(function () {
    'use strict';

    angular
        .module('jotApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ui.sortable',
            'ui.select',
            'xeditable',
            'ngSanitize',
            'ngAnimate',
            'ui.load',
            'ui.jq',
            'rzModule',
            'angular-loading-bar',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'schemaForm',
            'angular-scroll-complete',
            'localytics.directives',
            'chart.js',
            'chartjs-directive',
            'ngTable',
            'nk.touchspin',
            'ui.ace',
            'angular-advanced-searchbox',
            'vcRecaptcha',
            'ja.qr',
            'angularjs-dropdown-multiselect'
        ]).value('THROTTLE_MILLISECONDS', 300).run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$window', '$rootScope', '$location', 'Principal'];

    function run(stateHandler, translationHandler, $window, $rootScope, $location, Principal) {
        $window.ga('create', 'UA-176793938-1', 'auto');
        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', {'page': $location.path()});
        });
        stateHandler.initialize();
        translationHandler.initialize();

        Principal.identity().then(function (data) {
            if (data !== null && data.context !== null) {
                $rootScope.licence = data.context.licence;
                if (data.authorities.length === 4) {
                    $rootScope.licence.id = 4;
                }
            }
        });

        // Functions for dropdown menus in tables

        $(document).on('shown.bs.dropdown', '.table-scrollable', function (e) {
            // The .dropdown container
            var $container = $(e.target);

            // Find the actual .dropdown-menu
            var $dropdown = $container.find('.dropdown-menu');
            if ($dropdown.length) {
                // Save a reference to it, so we can find it after we've attached it to the body
                $container.data('dropdown-menu', $dropdown);

            } else {
                $dropdown = $container.data('dropdown-menu');
            }

            // Hide the dropdown menu if there is one
            $("body > .dropdown-menu").hide();

            // Create the dropdown menu in the DOM
            $dropdown.appendTo('body');

            // Position the dropdown menu relative to the button
            $dropdown.css('top', ($container.offset().top - $dropdown.height() - $container.outerHeight()) + 10 + 'px');
            $dropdown.css('left', ($container.offset().left - $container.width()) + 'px');
            $dropdown.css('display', 'block');
        });

        $(document).on('shown.bs.dropdown', '.table-scrollable-vertical', function (e) {
            // The .dropdown container
            var $container = $(e.target);

            // Find the actual .dropdown-menu
            var $dropdown = $container.find('.dropdown-menu');
            if ($dropdown.length) {
                // Save a reference to it, so we can find it after we've attached it to the body
                $container.data('dropdown-menu', $dropdown);

            } else {
                $dropdown = $container.data('dropdown-menu');
            }

            // Hide the dropdown menu if there is one
            $("body > .dropdown-menu").hide();

            // Create the dropdown menu in the DOM
            $dropdown.appendTo('body');

            // Position the dropdown menu relative to the button
            $dropdown.css('top', ($container.offset().top - $dropdown.height() - $container.outerHeight()) + 10 + 'px');
            $dropdown.css('left', ($container.offset().left - $container.width()) + 'px');
            $dropdown.css('display', 'block');
        });

        $(document).on('hide.bs.dropdown', '.table-scrollable', function (e) {
            // Hide the dropdown menu bound to this button
            $(e.target).data('dropdown-menu').css('display', 'none');
        });

        $(document).on('hide.bs.dropdown', '.table-scrollable-vertical', function (e) {
            // Hide the dropdown menu bound to this button
            $(e.target).data('dropdown-menu').css('display', 'none');
        });

        window.addEventListener('resize', function () {
            // Hide the dropdown menu on window resize
            $("body > .dropdown-menu").hide();
            // Remove class "open" from the button to prevent double click to re-open dropdown menu after window resize
            $(".table-scrollable .table-action-btn-group.open .dropdown-toggle ").dropdown("toggle");
        });

        // Hide the dropdown menu after clicking one of the elements in the list
        $("body").on("click", ".dropdown-menu li a", function () {
            $("body > .dropdown-menu").hide();
        });

        setTimeout(function (){
            // Hide dropdown on table vertical scroll
            $('.table-scrollable-vertical').on("scroll", function (){
                // Hide the dropdown menu on window resize
                $("body > .dropdown-menu").hide();
                // Remove class "open" from the button to prevent double click to re-open dropdown menu after window resize
                $(".table-scrollable-vertical .table-action-btn-group.open .dropdown-toggle ").dropdown("toggle");
                $(".table-scrollable-vertical .table-action-btn-group").removeClass("open");
            });
        }, 1000);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        })
        .state('update_management', {
            abstract: true,
            url: '/update-management',
            parent: 'app'
        })
        .state('alerting', {
            abstract: true,
            url: '/alerting',
            parent: 'app'
        })
        .state('dashboard', {
            abstract: true,
            url: '/dashboards',
            parent: 'app'
        })
        .state('kiosk', {
            abstract: true,
            url: '/kiosk',
            parent: 'app'
        })
        .state('testing', {
            abstract: true,
            url: '/testing',
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$state', '$stateParams', 'Auth', '$timeout'];

    function ActivationController($state, $stateParams, Auth, $timeout) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;

        vm.login = function () {
            $state.go('login');
        };

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(activateAccount).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function activateAccount() {
            Auth.activateAccount({key: $stateParams.key}).then(function () {
                vm.error = null;
                vm.success = 'OK';
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'site',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            templateUrl: 'app/account/activate/activate.html',
            controller: 'ActivationController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertingSettingOverviewController', AlertingSettingOverviewController);

    AlertingSettingOverviewController.$inject = ['$uibModalInstance', '$state', 'AlertingSettings', 'pagingParams'];

    function AlertingSettingOverviewController ($uibModalInstance, $state, AlertingSettings, pagingParams) {
        var vm = this;
        vm.alertsToDelete = [];
        if(pagingParams.alertsToDelete[0].alertSystemType.name === 'slack') {
            pagingParams.alertsToDelete.forEach(function (value) {
                vm.alertsToDelete.push(value.slackIntegration.channel);
            });
        } else {
            pagingParams.alertsToDelete.forEach(function (value) {
                vm.alertsToDelete.push(value.actionIdentifier);
            });
        }

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.confirm = function () {
            if(pagingParams.alertType) {
                AlertingSettings.alertingSettings({alertType: pagingParams.alertType}, pagingParams.alertingSettings);
            } else {
                AlertingSettings.delete({id:pagingParams.domainToDelete});
            }
            vm.clear();
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('GeneralSettingsController', GeneralSettingsController);

    GeneralSettingsController.$inject = ['$uibModal', '$scope', '$state', '$rootScope', 'TabDomains', 'domain', 'UserAlertService', 'AlertRules', '$timeout', 'AlertService', 'MaintenanceSettingsService', 'maintenanceSetting', 'DomainAlertService', 'Principal', 'Auth', 'User'];

    function GeneralSettingsController($uibModal, $scope, $state, $rootScope, TabDomains, domain, UserAlertService, AlertRules, $timeout, AlertService, MaintenanceSettingsService, maintenanceSetting, DomainAlertService, Principal, Auth, User) {
        var vm = this;
        // general settings variables
        vm.enableAlerting = false;
        vm.mailIntegration = false;
        vm.telegramIntegration = false;
        vm.webhookIntegration = false;
        vm.tabDomain = domain;
        vm.maintenanceSetting = undefined;
        vm.showMaintenanceForm = false;
        vm.domain = {};
        vm.newtrusted = {};
        vm.newtrusted.email = [];
        vm.newtrusted.telegram = [];
        vm.newtrusted.webhook = [];
        vm.throttleUnit = ["minutes", "hours", "days", "weeks"];
        vm.mailType = "none";
        vm.settingsAccount = null;
        vm.datePickerOptions = {
            minDate: new Date()
        };
        //my channel variables
        vm.promise = {};
        vm.licence = $rootScope.licence;
        vm.promise = {};
        vm.licence = $rootScope.licence;
        vm.authorities = [];

        // INIT SECTION get all the needed resources
        vm.init = function () {
            //init general settings resources
            maintenanceSetting.$promise.then(function (data) {
                if (angular.isDefined(data)) {
                    vm.maintenanceSetting = data;
                    vm.maintenanceSetting.releaseDate = new Date(data.releaseDate);
                    vm.showMaintenanceForm = true;
                    vm.maintenanceSetting.version !== "null" ? vm.mailType = "maintenance" : vm.mailType = "notice";
                }
            });
            Principal.identity(true).then(function (account) {
                vm.settingsAccount = vm.copyAccount(account);
                vm.settingsNotification = vm.copyNotification(account);
                vm.authorities = angular.copy(account.authorities);
                $timeout(function (){
                    if (vm.authorities.includes('ROLE_DOMAIN_USER') === true) {
                        if (vm.tabDomain.mailAlerting === false) {
                            vm.settingsNotification.warningEmail = angular.copy(vm.tabDomain.mailAlerting);
                        }
                        if (vm.tabDomain.telegramAlerting === false) {
                            vm.settingsNotification.warningTelegram = angular.copy(vm.tabDomain.telegramAlerting);
                        }
                        if (vm.tabDomain.webhookAlerting === false) {
                            vm.settingsNotification.webhook = angular.copy(vm.tabDomain.webhookAlerting);
                        }
                    }
                });
            });
            User.getTerms({}, onSuccessCheck, onErrorCheck);
            vm.loadAll()
            vm.trustedDomainGeneralSettings();
            vm.enableAlerting = vm.tabDomain.enableAlerting;
        }

        vm.loadAll = function () {
            DomainAlertService.getUserAlertSystem({user: 'logged'}, onSuccess);
            DomainAlertService.getAuthentications(function (result) {
                vm.authentications = result;
                vm.authentication = 'none';
            });
        }

        vm.trustedDomainGeneralSettings = function () {
            vm.trusted = {};
            vm.trusted.email = [];
            vm.trusted.telegram = [];
            vm.trusted.webhook = [];
            UserAlertService.getUserAlertingSettings({alertType: 'email'}, function (result) {
                vm.trusted.email = result;
                vm.trusted.email.forEach(function (value) {
                    value.saved = true;
                });
            });
            UserAlertService.getUserAlertingSettings({alertType: 'telegram'}, function (result) {
                vm.trusted.telegram = result;
                vm.trusted.telegram.forEach(function (value) {
                    value.saved = true;
                });
            });
            UserAlertService.getUserAlertingSettings({alertType: 'webhook'}, function (result) {
                vm.trusted.webhook = result;
                vm.trusted.webhook.forEach(function (value) {
                    value.saved = true;
                });
            });

        }

        vm.copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        vm.copyNotification = function (account) {
            return account.notification;
        };

        // SERVICE CALLBACK SECTION all the callback function are down here
        vm.setAlertConf = function () {
            vm.testEmail = false;
            vm.testTelegram = false;
            vm.testWebhook = false;
        };

        var onSaveSuccess = function (result) {
            AlertService.success("Notification channel successfully configured.");
            $timeout(function () {
                vm.isSaving = false;
                vm.loadAll();
            }, 1000);
        };

        var onSaveError = function (result) {
            vm.isSaving = false;
            AlertService.error("The code is invalid or expired");
        };

        var onSaveSuccessGeneral = function () {
            vm.isSaving = false;
        };

        var onSaveErrorGeneral = function () {
            vm.isSaving = false;
            TabDomains.current(function (result) {
                vm.tabDomain = result;
            });

        };

        function onSuccess(results) {
            vm.email = {};
            vm.telegram = {};
            vm.webhook = {};
            results.forEach(function (alert) {
                if (alert.alertSystemType.name == "email") {
                    vm.email = alert;
                } else if (alert.alertSystemType.name == "telegram") {
                    vm.telegram = alert;
                } else if (alert.alertSystemType.name == "webhook") {
                    vm.webhook = alert;
                    vm.authentication = alert.webhookIntegration.authType;
                }
            });
            vm.setAlertConf();
        }

        function onTestError(result) {
            if (result.status == 403) {
                AlertService.error("Channel domain is not trusted");
                vm.isSaving = false;
            } else {
                AlertService.error(result.data ? result.data.description : "Test fail");
                vm.isSaving = false;
            }
        }

        function onSuccessCheck(response) {
            vm.updateCheck = {};
            vm.updateCheck.check1 = response.check1;
            vm.updateCheck.check2 = response.check2;
            vm.updateCheck.check3 = response.check3;
        }

        function onErrorCheck(error) {
            console.log(error);
        }

        function onCheckSuccess(data) {
            $interval.cancel(vm.promise);
            vm.promise = undefined;
            vm.window.close();
        }

        function onCheckError(data) {
            if (data.status !== 404)
                $interval.cancel(vm.promise);
        }


        // SAVE SECTION all the function with service calls to save the page status
        vm.save = function (type, code) {
            vm.isSaving = true;
            if (type === 'Email') {
                DomainAlertService.checkMailCode({authorizationCode: code}, onSaveSuccess, onSaveError);
            } else if (type === "Telegram") {
                DomainAlertService.checkTelegramCode({authorizationCode: code}, onSaveSuccess, onSaveError);
            } else if (type === "Webhook") {
                DomainAlertService.saveWebhook(onSaveSuccess, onSaveError);
            }
        }

        vm.saveThrottle = function (type, allWarning, values) {
            vm[type] = values;
            if (vm[type].throttle === undefined) {
                AlertService.error("Throttle time must be between 1 and 59.");
            } else {
                vm.wac = {};
                vm.wac.alertSystemType = {};
                vm.wac.alertSystemType.name = type;
                if (vm[type].time === "minutes") {
                    vm.wac.throttlePeriod = vm[type].throttle;
                } else if (vm[type].time === "hours") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60;
                } else if (vm[type].time === "days") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60 * 24;
                } else if (vm[type].time === "weeks") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60 * 24 * 7;
                }
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm.wac,
                    warning: vm.warning,
                    allWarning: allWarning
                }, function (result) {
                    vm.warning = result;
                    AlertService.success("Throttle time saved for all alerts in this channel.");
                }, function (result) {
                    AlertService.error("Error saving throttle.");
                });
            }
        };
        // check if remove is needed
        vm.saveGeneral = function (channelSettings) {
            vm.isSaving = true;
            var body = {
                tabDomains: vm.tabDomain,
                enable: vm.tabDomain[channelSettings],
                channel: channelSettings
            }
            TabDomains.requestToUpdateSettings(body, onSaveSuccessGeneral, onSaveErrorGeneral);
        };

        vm.saveToggle = function (crossCheck, propName) {
            if (vm.tabDomain[crossCheck] === false){
                $timeout(function (){
                    vm.settingsNotification[propName] = false;
                });
                // open modal here
                $uibModal.open({
                    templateUrl: 'app/account/general-settings/modals/channel-disabled.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                });
            } else {
                Auth.updateAccount(vm.settingsAccount).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    Principal.identity(true).then(function (account) {
                        vm.settingsAccount = vm.copyAccount(account);
                    });
                    User.setTerms(vm.updateCheck);
                    User.updateNotifications({
                        login: vm.settingsAccount.login,
                        notification: vm.settingsNotification
                    }).$promise.then( function () {
                        vm.loadAll();
                    });
                    AlertService.success("Your notificiations settings have been updated");
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        vm.saveMaintenanceGeneral = function () {
            delete vm.maintenanceSetting.id;

            if (vm.maintenanceSetting.description === "" || vm.maintenanceSetting.description == null) {
                vm.maintenanceSetting.description =
                    "Version: \n" + vm.maintenanceSetting.version + "\n" +
                    "\nNew Features:\n" + vm.maintenanceSetting.features + "\n" +
                    "\nEnhancements:\n" + vm.maintenanceSetting.enhancements + "\n" +
                    "\nBugs Fixing:\n" + vm.maintenanceSetting.bugsFixing;
            } else {
                evaluate(vm.maintenanceSetting.version) ? vm.maintenanceSetting.version = "null" : vm.maintenanceSetting.version;
                evaluate(vm.maintenanceSetting.features) ? vm.maintenanceSetting.features = "null" : vm.maintenanceSetting.features;
                evaluate(vm.maintenanceSetting.enhancements) ? vm.maintenanceSetting.enhancements = "null" : vm.maintenanceSetting.enhancements;
                evaluate(vm.maintenanceSetting.bugsFixing) ? vm.maintenanceSetting.bugsFixing = "null" : vm.maintenanceSetting.bugsFixing;
            }

            MaintenanceSettingsService.save(vm.maintenanceSetting);
        };

        vm.updateTogglesOnAction = function (type) {
            if (type === 'email' || type === 'mailAlerting') {
                vm.settingsNotification.warningEmail = false;
            } else if (type === 'telegram' || type === 'telegramAlerting') {
                vm.settingsNotification.warningTelegram = false;
            } else {
                vm.settingsNotification.warningWebhook = false;
            }
            if (vm.tabDomain.enableAlerting === false) {
                vm.settingsNotification.warningEmail = false;
                vm.settingsNotification.warningTelegram = false;
                vm.settingsNotification.warningWebhook = false;
            }
            vm.saveToggle();
        //    build
        }

        //MODALS SECTION all modals function and controllers
        function configurationModalController($uibModalInstance, type, authentications) {
            var vm = this;
            if (authentications) {
                vm.authentications = authentications;
            }
            vm.type = type;
            vm.testAlert = testAlert;

            function testAlert() {
                $scope.isSaving = true;
                if (type === 'Email') {
                    DomainAlertService.sendMailCode({email: vm.email.actionIdentifier}, function () {
                        vm.testEmail = true;
                        vm.isSaving = false;
                    }, onTestError);
                } else if (type === "Webhook") {
                    if (vm.oauth) {
                        vm.webhook.oauthScheme = 1;
                    }
                    DomainAlertService.checkWebhook(vm.webhook, function () {
                        vm.testWebhook = true;
                        vm.isSaving = false;
                        AlertService.success("The url is valid and can be used as notification channel.");
                    }, onTestError);
                }
            }

            // set email
            vm.save = function (type, code) {
                $uibModalInstance.close({type: type, code: code});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function saveThrottleConfigurationController($uibModalInstance, data) {
            var vm = this;
            vm.type = data.type;
            vm.throttleUnit = data.throttleUnit;

            vm.save = function (type, values) {
                // route to save then outside of modal
                $uibModalInstance.close({type: vm.type, values: values});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function domainSettingConfigurationController($uibModalInstance, data) {
            var vm = this;
            vm.email = data.email;
            vm.webhook = data.webhook;
            vm.domain = data.domain;
            vm.trusted = data.trusted;
            vm.setting = data.settings;
            vm.newtrusted = data.newtrusted;
            vm.domainToDelete = [];
            vm.showWarningResult = false;
            vm.isConfirmOperation = false;

            vm.addDomainGeneral = function (type) {
                vm.newDomain = {};
                vm.newDomain.trustedDomain = vm.domain[type];
                vm.trusted[type].push(vm.newDomain);
                vm.newtrusted[type].push(vm.domain[type]);
                vm.domain[type] = "";
            };

            vm.saveSettingsGeneral = function (type) {
                vm.dataObject = {
                    domainsToAdd: null,
                    domainsToDelete: null
                };
                vm.alertingSettings = [];
                vm.newtrusted[type].forEach(function (element) {
                    vm.setting = {};
                    vm.setting.alertSystemType = {};
                    vm.setting.alertSystemType.name = type;
                    vm.setting.domain = vm.domain.id;
                    vm.setting.trustedDomain = element;
                    vm.alertingSettings.push(vm.setting);
                });
                if (vm.alertingSettings.length > 0) {
                    UserAlertService.checkUserAddAlertingSettings({alertType: type}, vm.alertingSettings, function (result) {
                        if (result.length > 0) {
                            // change view of modal and do additional steps
                            vm.isConfirmOperation = true;
                            vm.showWarningResult = true;
                            vm.alertsToDelete = [];
                            vm.newtrusted[type] = [];
                            vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                            vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                            vm.save(type, vm.dataObject);
                        } else {
                            vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                            vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                            vm.save(type, vm.dataObject);
                        }
                    });
                } else {
                    vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                    vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                    vm.save(type, vm.dataObject);
                }
            };

            vm.checkAndPrepareToDelete = function (trusted) {
                if (trusted.selected !== true) {
                    UserAlertService.checkUserDeleteAlertingSettings({id: trusted.id}, function (result) {
                        if (result.length > 0) {
                            if (!vm.domainToDelete.find(x => x.id === trusted.id)) {
                                vm.domainToDelete.push(trusted);
                            }
                            vm.isConfirmOperation = true;
                            trusted.toBeDeleted = true;
                            trusted.selected = true;
                        } else {
                            if (!vm.domainToDelete.find(x => x.id === trusted.id)) {
                                vm.domainToDelete.push(trusted);
                            }
                            trusted.greyout = true;
                            trusted.selected = true;
                        }
                    });
                } else {
                    vm.domainToDelete = vm.domainToDelete.filter(x => x.id !== trusted.id)
                    trusted.toBeDeleted = false;
                    trusted.greyout = false;
                    trusted.selected = false
                }
            }

            // set email
            vm.save = function (typeOfOperation, toSaveData) {
                if (vm.isConfirmOperation === true) {
                    typeOfOperation = 'confirmation';
                }
                // route to save then outside of modal
                $uibModalInstance.close({typeOfOperation: angular.copy(typeOfOperation), toSaveData: angular.copy(toSaveData)});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.deleteAlert = function (id, type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/delete-dialog.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;

                    function stop() {
                        DomainAlertService.delete({id: id}, function (result) {
                            $state.reload();
                        }, onSaveError);
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function () {
                vm.updateTogglesOnAction(type);
                AlertService.success("entity.delete.deleteChannel")
            });
        };

        vm.openToggleModal = function (notificationStatus, channelSettings) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/toggle-domain-notifications.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.channelSettings = channelSettings;
                    vm.notificationStatus = notificationStatus;
                    vm.clear = clear;
                    vm.stop = stop;

                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        notificationStatus = !notificationStatus;
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                }
            }).result.then(function (result) {
                vm.saveGeneral(channelSettings);
                vm.isSaving = false;
            }, function (){
                if (channelSettings === 'mailAlerting') {
                    vm.tabDomain.mailAlerting = !vm.tabDomain.mailAlerting;
                }
                else if (channelSettings === 'telegramAlerting') {
                    vm.tabDomain.telegramAlerting = !vm.tabDomain.telegramAlerting;
                }
                else if (channelSettings === 'webhookAlerting') {
                    vm.tabDomain.webhookAlerting = !vm.tabDomain.webhookAlerting;
                } else if (channelSettings === 'enableAlerting') {
                    vm.tabDomain.enableAlerting = !vm.tabDomain.enableAlerting;
                }
            });
        }


        vm.openMailModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/email-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return null
                    }
                }
            }).result.then(function (result) {
                vm.save(result.type, result.code);
                vm.isSaving = false;
            });
        };

        vm.openTelegramModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/telegram-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return null
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.save(result.type, result.code);
            });
        };

        vm.openWebhookModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/webhook-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return vm.authentications
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.save(result.type, result.code);
            });
        };

        vm.openDomainSetting = function () {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/domain-emails-setup.html',
                controller: domainSettingConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            domain: vm.domain,
                            email: vm.email,
                            webhook: vm.webhook,
                            trusted: vm.trusted,
                            settings: vm.setting,
                            newtrusted: vm.newtrusted
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                if (result.toSaveData.domainsToAdd.length > 0) {
                    UserAlertService.userAlertingSettings({alertType: 'email'}, result.toSaveData.domainsToAdd).$promise.then(function () {
                        vm.trustedDomainGeneralSettings();
                    });
                }
                if (result.toSaveData.domainsToDelete.length > 0) {
                    // needs massive delete accepting a list as parameter
                    var cleanedArray = result.toSaveData.domainsToDelete.map((domain) => {
                        return {
                            alertSystemType: domain.alertSystemType,
                            domain: domain.domain,
                            id: domain.id,
                            trustedDomain: domain.trustedDomain
                        }
                    });
                    UserAlertService.deleteProvidedRequest({toDelete: cleanedArray});
                    vm.trustedDomainGeneralSettings();
                }
            });
        }

        vm.openDomainSettingWebhook = function () {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/domain-webhook-setup.html',
                controller: domainSettingConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            domain: vm.domain,
                            email: vm.email,
                            webhook: vm.webhook,
                            trusted: vm.trusted,
                            settings: vm.setting,
                            newtrusted: vm.newtrusted
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                if (result.toSaveData.domainsToAdd.length > 0) {
                    UserAlertService.userAlertingSettings({alertType: 'webhook'}, result.toSaveData.domainsToAdd).$promise.then(function () {
                        vm.trustedDomainGeneralSettings();
                    });
                }
                if (result.toSaveData.domainsToDelete.length > 0) {
                    var cleanedArray = result.toSaveData.domainsToDelete.map((domain) => {
                        return {
                            alertSystemType: domain.alertSystemType,
                            domain: domain.domain,
                            id: domain.id,
                            trustedDomain: domain.trustedDomain
                        }
                    });
                    UserAlertService.deleteProvidedRequest({toDelete: cleanedArray});
                    vm.trustedDomainGeneralSettings();
                }
            });
        }

        vm.openThrottleSetting = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/throttle-configuration.html',
                controller: saveThrottleConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            type: type,
                            throttleUnit: vm.throttleUnit
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.saveThrottle(result.type, true, result.values);
            });
        }

        //Miscellaneous functions for specific page section (to check if used)
        vm.deleteTrusted = function (domain, type) {
            UserAlertService.checkUserDeleteAlertingSettings({id: domain.id}, function (result) {
                if (result.length > 0) {
                    $uibModal.open({
                        templateUrl: 'app/account/general-settings/alerting-settings-overview.html',
                        controller: 'AlertingSettingOverviewController',
                        backdrop: 'static',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            pagingParams: ['$stateParams', function () {
                                return {
                                    alertsToDelete: result,
                                    domainToDelete: domain.id
                                };
                            }]
                        }
                    }).result.then(function () {
                        vm.isSaving = false;
                        $timeout(function () {
                            vm.trustedDomainGeneralSettings();
                        }, 500);
                    });
                } else {
                    var found = Object.values(vm.newtrusted[type]).indexOf(domain.trustedDomain);
                    if (found > -1) {
                        var index = Object.values(vm.trusted[type]).indexOf(domain);
                        vm.trusted[type].splice(index, 1);
                        vm.newtrusted[type].splice(found, 1);
                    } else {
                        UserAlertService.delete({id: domain.id}, function () {
                            $timeout(function () {
                                vm.trustedDomainGeneralSettings();
                            }, 500);
                        });
                    }
                }
            });
        };

        function evaluate(field) {
            if (field === "" || field == null)
                return true;
        }

        vm.toggleMaintenance = function () {
            if (vm.showMaintenanceForm) {
                //turn off maintenance
                MaintenanceSettingsService.delete();
                vm.showMaintenanceForm = false;
            } else {
                vm.showMaintenanceForm = true;
            }
        };

        vm.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.maintenanceDatetime) {
                vm.maintenanceDatetime.isOpen = !vm.maintenanceDatetime.isOpen;
            } else {
                vm.maintenanceDatetime = {isOpen: true};
            }

        };

        vm.evaluateTypeMail = function (value, type) {
            if (value === "" || value == null) {
                if (type === "maintenance") {
                    if (evaluate(vm.maintenanceSetting.version)
                        && evaluate(vm.maintenanceSetting.features)
                        && evaluate(vm.maintenanceSetting.enhancements)
                        && evaluate(vm.maintenanceSetting.bugsFixing))
                        vm.mailType = "none";
                } else
                    vm.mailType = "none";
            } else {
                vm.mailType = type;
            }
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp').factory('UserAlertService', UserAlertService)
        .factory('MaintenanceSettingsService', MaintenanceSettingsService)
        .factory('DomainAlertService', DomainAlertService);


    UserAlertService.$inject = ['$resource'];
    MaintenanceSettingsService.$inject = ['$resource'];
    DomainAlertService.$inject = ['$resource'];

    function UserAlertService($resource) {
        var resourceUrl = 'api/alerting-settings/:id';

        return $resource(resourceUrl, {}, {
            'getUserAlertsList': {method: 'GET', isArray: true},
            'getUserAlerts': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'userAlertingSettings': {
                url: 'api/alerting-settings/:alertType',
                method: 'POST',
                isArray: true
            },
            'getUserAlertingSettings': {
                url: 'api/alerting-settings/:alertType',
                method: 'GET',
                isArray: true
            },
            'checkUserAddAlertingSettings': {
                url: 'api/alerting-settings/:alertType/checkAdd',
                method: 'POST',
                isArray: true
            },
            'checkUserDeleteAlertingSettings': {
                url: 'api/alerting-settings/:id/checkDelete',
                method: 'GET',
                isArray: true
            },
            'deleteProvidedRequest': {
                url: 'api/alerting-settings/deleteProvidedRequest',
                method: 'POST',
            }
        });
    }

    function MaintenanceSettingsService($resource) {
        var resourceUrl = 'api/maintenance-setting/';

        return $resource(resourceUrl, {}, {
            'getMaintenanceListSetting': {method: 'GET', isArray: true},
            'getMaintenanceDetailSetting': {
                method: 'GET',
                transformResponse: function (data, headers, statusCode) {
                    if (statusCode === 200) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function DomainAlertService ($resource) {
        var resourceUrl =  'api/my-channel/:id';

        return $resource(resourceUrl, {}, {
            'getDomainAlertsList': { method: 'GET', isArray: true},
            'getDomainAlerts': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'userAlertSystem' : {
                method:'PUT' ,
                url:'api/my-channel-user'
            },
            'getUserAlertSystem' : {
                method:'GET' ,
                url:'api/my-channel-user/:user',
                isArray: true
            },
            'getSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/state'
            },
            'checkSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/status'
            },
            'sendSlackWelcome' : {
                method:'GET' ,
                url:'api/slack/integration/test'
            },
            'sendMailCode' : {
                method:'GET' ,
                url:'api/mail/integration?email=:email'
            },
            'checkMailCode' : {
                method:'GET' ,
                url:'api/mail/authorize?authorizationCode=:authorizationCode'
            },
            'checkTelegramCode' : {
                method:'GET' ,
                url:'api/telegram/authorize?authorizationCode=:authorizationCode'
            },
            'getAuthentications' : {
                method:'GET' ,
                url:'api/webhook/integration/authenticationType',
                isArray : true
            },
            'checkWebhook' : {
                method:'POST' ,
                url:'api/webhook/integration/test'
            },
            'saveWebhook' : {
                method:'GET' ,
                url:'api/webhook/integration/save'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('general-settings', {
            parent: 'account',
            url: '/general-settings',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN', 'ROLE_DOMAIN_USER'],
                pageTitle: 'global.menu.account.generalSettings'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/general-settings/general-settings.html',
                    controller: 'GeneralSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('generalSettings');
                    $translatePartialLoader.addPart('tabDomains');
                    $translatePartialLoader.addPart('myChannel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                    var deferred = $q.defer();
                    Principal.identity().then(function (account) {
                        deferred.resolve(TabDomains.current());
                    });
                    return deferred.promise;
                }],
                maintenanceSetting: ['MaintenanceSettingsService', function (MaintenanceSettingsService) {
                    return MaintenanceSettingsService.get();
                }]
            }
        });
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]@]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch(
                function() {
                    return scope.passwordToCheck;
                },

                function (password) {

                    iElement.removeClass('ng-hide');

                    let c;
                    if (!password || password.length === 0) {
                        c = { idx: 0, col: '#DDD' };
                    } else {
                        c = strength.getColor(strength.mesureStrength(password));
                    }

                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' }) // reset
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.passwordmatch = "";
        vm.checkMinLngUser = true;

        // boolean variables to change password input box type
        vm.showPassword = false;
        vm.showConfirmPassword = false;

        Principal.identity().then(function(account) {
            vm.account = account;
        });
        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.password = "";
                    vm.confirmPassword = "";
                    //location.reload();
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
        vm.passwordmatch = function()
        {
            if(vm.password === vm.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser =  (vm.password !== vm.confirmPassword);
        }

        /*vm.reset = function (){
            var x = document.getElementById("password");
            var y = document.getElementById("confirmPassword");
            console.log(x,y);
        }*/
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', '$state'];

    function ResetFinishController($stateParams, $timeout, Auth, $state) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.checkMinLngUser = true;
        vm.passwordnotmatch = " ";

        vm.login = function () {
            $state.go('login');
        };

        $timeout(function () {
            angular.element('#password').focus();
        });

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
        vm.passwordmatch = function()
        {
            if(vm.resetAccount.password === vm.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser =  (vm.resetAccount.password !== vm.confirmPassword);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'site',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            templateUrl: 'app/account/reset/finish/reset.finish.html',
            controller: 'ResetFinishController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteTwoFactorController', DeleteTwoFactorController);

    DeleteTwoFactorController.$inject = ['$state', '$uibModalInstance', 'pagingParams', 'User'];

    function DeleteTwoFactorController($state, $uibModalInstance, pagingParams, User) {
        var vm = this;

        pagingParams.twoFactorEmail;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirm = function () {
            User.getTOTP({twoFactorEmail: pagingParams.twoFactorEmail}, onSuccess);
        };

        function onSuccess() {
            User.set2FEmail({twoFactorEmail: true});
            $uibModalInstance.close(true);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActiveIntegrationController', ActiveIntegrationController);

    ActiveIntegrationController.$inject = ['Integration', 'IntegrationScope', 'TabDomains', '$state', 'pagingParams', 'paginationConstants'];

    function ActiveIntegrationController (Integration, IntegrationScope, TabDomains, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.integrations = [];
        vm.selectedDomain = {};
        vm.selectedScope = {};

        vm.charToSearch = pagingParams.search;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.currentState = "active-integration";
        vm.filter = localStorage.getItem(vm.currentState);

        if(vm.filter != null && vm.filter !== "null" && vm.filter !== undefined){
            vm.filter = JSON.parse(vm.filter);
            if (Object.keys(vm.filter).length > 0) {
                if (vm.selectedDomain === vm.filter.selectedDomain || vm.selectedDomain === {}
                    || vm.selectedDomain == null || Object.keys(vm.selectedDomain).length === 0) {

                    vm.selectedDomain = vm.filter.selectedDomain;
                    vm.selectedScope = vm.filter.selectedScope;
                } else {
                    setLocalStorage();
                }
            }
        } else {
            vm.selectedDomain.id = -1;
            vm.selectedScope.scope = "All";
        }

        function setLocalStorage() {
            vm.filter = {};
            vm.filter.selectedDomain = vm.selectedDomain;
            vm.filter.selectedScope = vm.selectedScope;
            localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
        }

        vm.domains = TabDomains.query({size:1000}, function (result) {
            var all = {
                id: -1,
                domainName: "All",
            };
            vm.domains = result;
            vm.domains.unshift(all);
            vm.selectedDomain === {} ? vm.domains[0] : vm.selectedDomain;
        });

        vm.scopes = IntegrationScope.query(function (result) {
            var all = {
                id: -1,
                scope: "All",
            };
            vm.scopes = result;
            vm.scopes.unshift(all);
            vm.selectedScope === {} ? vm.scopes[0] : vm.selectedScope;
        });

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            setLocalStorage();

            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                scope: vm.selectedScope,
                search: vm.charToSearch,
                domain : vm.selectedDomain,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll = function(){
            var body = {
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                scope: vm.selectedScope.scope,
                domainId : vm.selectedDomain.id,
                query: vm.charToSearch
            };

            Integration.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.integrations = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.integrations = data;
            }

            function onError(error) {}
        };

        vm.reloadIntegration = function() {
            setLocalStorage();
            vm.loadAll();
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('EditIntegrationController', EditIntegrationController);

    EditIntegrationController.$inject = ['entity', '$state', 'Integration'];

    function EditIntegrationController (entity, $state, Integration) {
        var vm = this;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.client = entity;
            });
        }

        vm.clear = function() {
            $state.go('active-integration');
        }

        vm.save = function () {
            vm.isSaving = true;
            if (vm.client.clientId !== null) {
                Integration.update(vm.client, onSaveSuccess, onSaveError);
            } else {
                Integration.save(vm.client, onSaveSuccess, onSaveError);
            }
        };

        var onSaveSuccess = function () {
            vm.isSaving = false;
            $state.go('active-integration');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('IntegrationDeleteDialogController',IntegrationDeleteDialogController);

    IntegrationDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'Integration'];

    function IntegrationDeleteDialogController($uibModalInstance, entity, Integration) {
        var vm = this;
        vm.client = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Integration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('IntegrationController', IntegrationController);

    IntegrationController.$inject = ['Integration', 'IntegrationScope', 'TabDomains', '$state', '$uibModal'];

    function IntegrationController (Integration, IntegrationScope, TabDomains, $state, $uibModal) {
        var vm = this;

        vm.client = {};
        vm.selectedDomain = {};
        vm.selectedScopes = [];
        vm.domains = TabDomains.query({size:1000});
        vm.scopes = IntegrationScope.query();

        vm.generated = false;
        vm.disabled = true;
        vm.checkRequireFields = true;

        vm.generateClient = function () {
            var body = {
                scope: evaluateScope(),
                domain: vm.selectedDomain
            };

            Integration.save(body, onSuccessSave, onErrorSave);
        }

        function evaluateScope() {
            vm.selectedScopes.sort(function (a, b) {
                var scope1 = a.id, scope2 = b.id;
                return scope1-scope2;
            });

            var scope = "";
            angular.forEach(vm.selectedScopes, function(s){
                scope += s.scope + ",";
            });
            return scope.substring(0, scope.length -1);
        }

        function onSuccessSave(data) {
            vm.generated = true;
            vm.disabled = false;
            vm.client.id = data.clientId;
            vm.client.secret = data.clientSecret;
            showValues();
        }

        function onErrorSave() {}

        vm.clear = function() {
            $state.reload();
        }

        vm.refreshRequired = function() {
            vm.checkRequireFields = !(vm.selectedDomain !== {} && vm.selectedDomain !== null)
                || !(vm.selectedScopes !== [] && vm.selectedScopes !== null && vm.selectedScopes.length > 0);
        }

        function showValues() {
            $uibModal.open({
                templateUrl: 'app/account/settings/integration/show-integration.html',
                controller: 'ShowIntegrationController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.client
                }
            });
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Integration', Integration)
        .factory('IntegrationScope', IntegrationScope);

    Integration.$inject = ['$resource'];

    function Integration($resource) {
        var resourceUrl = 'api/integration/:id';

        return $resource(resourceUrl, {}, {
            'save': {method: 'POST'},
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }

    IntegrationScope.$inject = ['$resource'];

    function IntegrationScope($resource) {
        var resourceUrl = 'api/scope/:scope';

        return $resource(resourceUrl, {}, {
            'save': {method: 'POST'},
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('integration', {
            parent: 'settings',
            url: '/integration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/integration.html',
                    controller: 'IntegrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('active-integration', {
            parent: 'integration',
            url: '/active',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.active'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/active-integration.html',
                    controller: 'ActiveIntegrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                filter: null,
                search: {
                    value: '',
                    squash: true
                },
                domain: {
                    id: -1
                },
                scope: {
                    id: -1
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        filter: $stateParams.filter,
                        domain: $stateParams.domain.id,
                        scope: $stateParams.scope.id
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('integration-edit', {
            parent: 'integration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.settings.integration.edit'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/integration/edit-integration.html',
                    controller: 'EditIntegrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Integration', function ($stateParams, Integration) {
                    return Integration.get({id: $stateParams.id});
                }]
            }
        })
        .state('delete-integration', {
            parent: 'active-integration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/integration/integration-delete-dialog.html',
                    controller: 'IntegrationDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Integration', function (Integration) {
                            return Integration.get({id: $stateParams.id});
                        }]
                    }
                }).result.then(function () {
                    $state.go('active-integration', null, {reload: true});
                }, function () {
                    $state.go('active-integration');
                });
            }]
        })
        .state('scope-dialog', {
            parent: 'integration',
            url: '/scope',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/integration/scope-dialog.html',
                    controller: 'ScopeDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                }).result.then(function () {
                    $state.go('integration', null, {reload: true});
                }, function () {
                    $state.go('integration', null, {reload: true});
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScopeDeleteDialogController', ScopeDeleteDialogController);

    ScopeDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'IntegrationScope'];

    function ScopeDeleteDialogController($uibModalInstance, entity, IntegrationScope) {
        var vm = this;
        vm.scope = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (scope) {
            IntegrationScope.delete({scope: scope},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScopeDialogController',ScopeDialogController);

    ScopeDialogController.$inject = ['$state', '$uibModalInstance', 'IntegrationScope', '$uibModal'];

    function ScopeDialogController($state, $uibModalInstance, IntegrationScope, $uibModal) {
        var vm = this;

        vm.scopes = IntegrationScope.query();

        vm.saveNew = false;
        vm.editorEnabled = [];
        vm.updateScope = [];

        vm.enableEditor = function(index, edit) {
            if(edit === 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                }
            } else if(edit === 1) {
                vm.updateScope[index] = vm.scopes[index].scope;
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            } else {
                if (vm.scopes[index].scope === "") {
                    vm.scopes.splice(index, 1);
                    vm.editorEnabled.splice(index, 1);
                    vm.saveNew = false;
                } else {
                    vm.editorEnabled[index] = !vm.editorEnabled[index];
                    vm.updateScope[index] = vm.scopes[index].scope;
                }
            }
        };

        vm.save = function () {
            var scope = checkScopeToSave(vm.scopes.length -1);
            if (scope !== null)
                IntegrationScope.save(scope, onSuccess, onError);
        };

        vm.saveUpdate = function(index) {
            var scope = checkScopeToSave(index);
            if (scope !== null)
                IntegrationScope.update(scope, onSuccess, onError);
        };

        function checkScopeToSave(index) {
            if (vm.updateScope[index] !== "" && vm.updateScope[index] !== undefined) {
                vm.scopes[index].scope = vm.updateScope[index];
                return vm.scopes[index];
            }
            return null;
        }

        function onSuccess() {
            $uibModalInstance.close(true);
        }

        function onError(){}

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addNewScope = function() {
            vm.saveNew = true;

            var newScope = {
                id: vm.scopes[vm.scopes.length -1].id +1,
                scope: ""
            }
            vm.scopes.push(newScope);

            vm.editorEnabled[vm.scopes.length -1] = true;
        }

        vm.deleteScope = function (scope) {
            $uibModalInstance.dismiss('cancel');
            $uibModal.open({
                templateUrl: 'app/account/settings/integration/scope-delete-dialog.html',
                controller: 'ScopeDeleteDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: scope
                }
            }).result.then(function () {
                $state.transitionTo('integration', {}, {reload: true});
            }, function () {
                $state.go('scope-dialog', {}, {reload: true});
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ShowIntegrationController', ShowIntegrationController);

    ShowIntegrationController.$inject = ['entity', '$uibModalInstance'];

    function ShowIntegrationController (entity, $uibModalInstance) {
        var vm = this;

        vm.client = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TwoFactorController',TwoFactorController);

    TwoFactorController.$inject = ['$state', '$uibModalInstance', 'pagingParams', 'AlertService', 'User'];

    function TwoFactorController($state, $uibModalInstance, pagingParams, AlertService, User) {
        var vm = this;
        vm.qrCode2Factor = pagingParams.result.qrCode2Factor;
        vm.privateKey = pagingParams.result.privateKey;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.copyKey = function () {
            navigator.clipboard.writeText(vm.privateKey);
            AlertService.success("settings.twoFactor.copySuccess");
        }

        vm.confirm = function () {
            User.set2FEmail({twoFactorEmail: false});
            $uibModalInstance.close(true);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteController',DeleteController);

    DeleteController.$inject = ['$state', '$uibModalInstance', 'User', 'Auth'];

    function DeleteController($state, $uibModalInstance, User, Auth) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // this function send delete request to the user.service
        vm.confirm = function () {
            User.deleteRequest(
                function () {
                    Auth.logout();
                    $state.go('login');
                    $uibModalInstance.close(true);
                });
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', '$state', '$uibModal', 'Auth', 'JhiLanguageService', '$translate', 'User', 'AlertService'];

    function SettingsController(Principal, $state, $uibModal, Auth, JhiLanguageService, $translate, User, AlertService) {
        let vm = this;
        vm.error = null;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        vm.copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        vm.copyNotification = function (account) {
            return account.notification;
        };

        function onSuccessCheck(response) {
            vm.updateCheck = {};
            vm.updateCheck.check1 = response.check1;
            vm.updateCheck.check2 = response.check2;
            vm.updateCheck.check3 = response.check3;
        }

        function onErrorCheck(error) {
            console.log(error);
        }

        vm.init = function () {
            Principal.identity().then(function (account) {
                vm.settingsAccount = vm.copyAccount(account);
                vm.settingsNotification = vm.copyNotification(account);
            });
            User.getTerms({}, onSuccessCheck, onErrorCheck);
        }

        vm.save = function () {
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = vm.copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                User.setTerms(vm.updateCheck);
                User.updateNotifications({
                    login: vm.settingsAccount.login,
                    notification: vm.settingsNotification
                }, onSuccessNot, onErrorNot);
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        // new delete function to show confirmation popup
        vm.delete = function () {
            $uibModal.open({
                // new html file contain the popup message
                templateUrl: 'app/account/settings/settings-delete.html',
                controller: 'DeleteController',
                controllerAs: 'vm',
                size: 'md'
            });
        };
        // cancel function to exit the popup
        vm.cancel = function () {
            $state.go('settings', null, {reload: false});
        };

        function onSuccessNot() {
           return true;
        }

        function onErrorNot() {
            vm.success = null;
            vm.error = 'ERROR';
        }

        //open modal to confirm or dismiss change from TOTP to email
        vm.get2FOTP = function () {
            if (vm.settingsNotification.twoFactorEmail) {
                let modalPromise = $uibModal.open({
                    templateUrl: 'app/account/settings/delete-2F.html',
                    controller: 'DeleteTwoFactorController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        pagingParams: ['$stateParams', function () {
                            return {
                                twoFactorEmail: vm.settingsNotification.twoFactorEmail
                            };
                        }]
                    }
                });
                modalPromise.result
                    .then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                    vm.switchValues();
                });
            }
            User.getTerms({}, onSuccessCheck, onErrorCheck);
        }

        // invert values of email and OTP switches
        vm.switchValues = function () {
            vm.settingsNotification.twoFactorEmail = !vm.settingsNotification.twoFactorEmail;
        }

        //open one of the two modals, depending on current values
        vm.onChange2F = function () {
            vm.switchValues();
            if (vm.settingsNotification.twoFactorEmail) {
                vm.get2FOTP();
            } else {
                User.getTOTP({twoFactorEmail: vm.settingsNotification.twoFactorEmail}, onSuccess2F, onErrorNot);
            }
        }

        // open modal with QR code and auth key
         function onSuccess2F(response) {
            if (!vm.settingsNotification.twoFactorEmail) {
                let modalPromise2F = $uibModal.open({
                    templateUrl: 'app/account/settings/settings-2F-detail.html',
                    controller: 'TwoFactorController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        pagingParams: ['$stateParams', function () {
                            return {
                                result: response
                            };
                        }]
                    }
                });
                modalPromise2F.result
                    .then(function (result) {
                        console.log("Modal closed with result", result);
                    }).catch(function (reason) {
                    vm.switchValues();
                });
            }
        }

        vm.showQrCode = function () {
            User.getTOTP({twoFactorEmail: vm.settingsNotification.twoFactorEmail}, onSuccess2F, onErrorNot);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SignupController', SignupController);

    SignupController.$inject = ['$window', '$state', '$location', 'Signup', 'AlertService'];

    function SignupController ($window, $state, $location, Signup, AlertService) {
        var vm = this;

        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";
        vm.passwordnotmatch = " ";
        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;
        vm.disabled = true;

        vm.checkDisabled = "Please view both links";

        vm.user = {};
        vm.nextOptions = false;
        vm.success = false;

        vm.checkMinLngUser = true;

        vm.init = function () {
            var key = $location.search().invitationKey;
            Signup.getInvitation({invitationKey: key}, onGetSuccess, onGetError);

            function onGetSuccess(data) {
                vm.user.email = data.email;
                vm.user.authority = data.authority.name;
                vm.user.invitationKey = key;
                vm.user.createdBy = data.invitedBy;
            }

            function onGetError() {
                vm.user = null;
            }
        }

        vm.save = function () {
            Signup.registerNewUser(vm.user, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                AlertService.success("User Created.");
                vm.success = true;
            }

            function onSaveError(error) {
                console.log(error);
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.changeOptions = function() {
            vm.nextOptions = !vm.nextOptions;
        }

        vm.goToLogin = function() {
            $state.go('login');
        }
        vm.passwordmatch = function()
        {
            if(vm.user.password === vm.user.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser = checkMinLength(vm.user.login, 7) || checkMinLength(vm.user.firstName, 0)
                || checkMinLength(vm.user.lastName, 0) || checkMinLength(vm.user.password, 8)
                || checkMinLength(vm.user.confirmPassword, 8) || (vm.user.password !== vm.user.confirmPassword);
            if(vm.checkMinLngUser)
                    vm.passwordnotmatch = " ";
        }

        function checkMinLength(inputVar, minLng) {
            return inputVar === undefined || inputVar < minLng;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('signup', {
            parent: 'site',
            url: '/signup?invitationKey',
            data: {
                authorities: [],
            },
            templateUrl: 'app/account/signup/signup.html',
            controller: 'SignupController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditLogDetailController', AuditLogDetailController);

    AuditLogDetailController.$inject = ['$scope', '$rootScope', 'entity', 'AuditLogService' ];

    function AuditLogDetailController($scope, $rootScope, entity, AuditLogService) {
        var vm = this;
        vm.auditLog = entity;
        vm.differences = [];
        vm.deletedEntities = [];
        // vm.getDeletedList = getDeletedList;
        vm.dashedName = null;

        // vm.getDeletedList();

        vm.auditLog.$promise.then(function () {
            vm.differences = splitChangesString();
            vm.dashedName = vm.auditLog.entityName.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
        });

        function splitChangesString(){
            if (vm.auditLog.changes != null) {
                var splitString = vm.auditLog.changes.slice(0, -1).split("PROPERTY");
                splitString.splice(0, 1);
                return splitString;
            }
        }

        // function getDeletedList (){
        //     AuditLogService.loadByAction({action: 'DELETED'}, function (res) {
        //         var result = res.map(function (audit) {
        //             return {entityId: (audit.entityId), entityName: (audit.entityName)}
        //         });
        //         vm.deletedEntities = Array.from(new Set(result.map(JSON.stringify))).map(JSON.parse);
        //     });
        // }

        /**
         * disabilitato ui-sref su entity User dato che pagina user-management-detail non ha id come parametro
         * decidere se lasciare cosi o modificare User per recuperare login e fare funzione che costruisce ui-sref dal controller
         */
        // vm.checkIfAuditDeletedOrIsUser = function () {
        //     var found = false;
        //     vm.deletedEntities.forEach(function (entry) {
        //         if (!found) {
        //             found = ((entry.entityId === vm.auditLog.entityId && entry.entityName === vm.auditLog.entityName) || (vm.auditLog.entityName === 'User')) ;
        //         }
        //     });
        //     return found;
        // };

        var unsubscribe = $rootScope.$on('jotApp:AuditLogUpdate', function(event, result) {
            vm.auditLog = result;
        });

        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditLogController', AuditLogController);

    AuditLogController.$inject = ['$filter', 'AuditLogService', 'ParseLinks', '$state', 'pagingParams'];

    function AuditLogController($filter, AuditLogService, ParseLinks, $state, pagingParams) {
        var vm = this;

        vm.auditLog = null;
        vm.fromDate = pagingParams.fromDate;
        vm.toDate = pagingParams.toDate;
        vm.links = null;
        vm.filter = pagingParams.filter;
        vm.onChangeDate = onChangeDate;
        vm.predicates = pagingParams.predicates;
        vm.totalItems = null;
        vm.size = 20;
        vm.transition = transition;
        vm.applyFilter = applyFilter;
        vm.currentState = "audit-log";
        vm.searchText = pagingParams.search;
        vm.onChangeDate();

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        function onChangeDate() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditLogService.query({
                page: pagingParams.page - 1,
                sort: sort(),
                size: vm.size,
                fromDate: fromDate,
                toDate: toDate,
                action: vm.filter.activity,
                query: vm.searchText
            }, function (result, headers) {
                vm.auditLog = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.page = pagingParams.page;
            });
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }


        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                search: vm.searchText,
                predicates: vm.predicates,
                toDate: vm.toDate,
                fromDate: vm.fromDate,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.onChangeDate();
            vm.transition(false);
        };

        function applyFilter() {
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('AuditLogService', AuditLogService);

    AuditLogService.$inject = ['$resource'];

    function AuditLogService($resource) {
        var service = $resource('api/audit-log/:id', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            },
            'loadByAction': {
                url: 'api/audit-log/actions',
                method: 'GET',
                isArray: true,
                params: {action: null}
            }
        });
        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audit-log', {
            parent: 'admin',
            url: '/audit-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'auditLog.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audit-log/audit-log.html',
                    controller: 'AuditLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort:{
                    squash:true
                },
                toDate: {
                    value:
                        (function today(){
                            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                        }),
                    squash: true
                },
                fromDate: {
                    value:
                        (function previousMonth(){
                            var fromDate = new Date();
                            if (fromDate.getMonth() === 0) {
                                return new Date(fromDate.getFullYear()-1, 11, fromDate.getMonth());
                            } else {
                                return new Date(fromDate.getFullYear(), fromDate.getMonth()-1, fromDate.getDate());
                            }
                        }),
                    squash: true
                },
                filter: {
                    value: {activity: ''},
                    squash: true
                },
                predicates :{},
                search:{
                    value:'',
                    squash:true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return{
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        search: $stateParams.search,
                        predicates : $stateParams.predicates,
                        toDate: $stateParams.toDate,
                        fromDate: $stateParams.fromDate,
                        filter: $stateParams.filter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }]
            }
        }).state('audit-log-detail', {
            parent: 'audit-log',
            url: '/audit-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'auditLog.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audit-log/audit-log-detail.html',
                    controller: 'AuditLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AuditLogService', function ($stateParams, AuditLogService) {
                    return AuditLogService.get({id: $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
;


(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', '$state','AuditsService', 'ParseLinks', 'pagingParams', 'Context'];

    function AuditsController ($filter, $state, AuditsService, ParseLinks, pagingParams, Context) {
        var vm = this;

        vm.domains = [];
        vm.domain = [];
        vm.predicates = pagingParams.predicates;
        vm.charToSearch = pagingParams.search;
        vm.fromDate = pagingParams.fromDate;
        vm.toDate = pagingParams.toDate;
        vm.filter = pagingParams.filter;
        vm.loadAllToExport = loadAllToExport;
        vm.onChangeDate = onChangeDate;
        vm.exportTable = exportTable;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.loadAll = loadAll;
        vm.currentState = "audits";
        vm.totalItems = null;
        vm.audits = null;
        vm.links = null;
        vm.size = 20;
        vm.page = pagingParams.page;
        vm.onChangeDate();

        Context.query(function (result) {
            var all = {
                id: -1,
                domainName: "All"
            };
            vm.domains = result;
            vm.domains.unshift(all);
        });

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        function onChangeDate() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;

            AuditsService.query({
                page: vm.page - 1,
                size: vm.size,
                fromDate: fromDate,
                toDate: toDate,
                domain: domain,
                query: vm.charToSearch,
                sort: sort()
            }, function (result, headers) {
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }

        function loadAll () {
            vm.page = 1;
            vm.onChangeDate();
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.charToSearch,
                fromDate: fromDate,
                toDate: toDate,
                domain: domain
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.page = 1;
            vm.onChangeDate();
            vm.transition(false);
        };

        function loadAllToExport(){
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);
            var ch = vm.charToSearch;
            var domain = vm.domain.id == null || vm.domain.id == undefined ? -1 : vm.domain.id;

            var body = {
                page: 0,
                size: 1000,
                fromDate: fromDate,
                toDate: toDate,
                query: ch,
                domain : domain
            };
            AuditsService.query(body, onSuccess, onError);
            function onSuccess(result) {vm.audits = result;}
            function onError() {}
        }

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 100, 1: 80, 2: 150, 3: 100},
                    tableName: 'Audits'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Audits'});
            }
            vm.onChangeDate();
        }
    }
})();

;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('api/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            params:{
                page: {
                    value: '1',
                    squash: true
                },
                sort:{
                    squash:true
                },
                toDate: {
                    value:
                        (function today(){
                            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                        }),
                    squash: true
                },
                fromDate: {
                    value:
                        (function previousMonth(){
                            var fromDate = new Date();
                            if (fromDate.getMonth() === 0) {
                                return new Date(fromDate.getFullYear()-1, 11, fromDate.getMonth());
                            } else {
                                return new Date(fromDate.getFullYear(), fromDate.getMonth()-1, fromDate.getDate());
                            }
                        }),
                    squash: true
                },
                filter: {
                    value: {activity: ''},
                    squash: true
                },
                predicates :{},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        toDate: $stateParams.toDate,
                        fromDate: $stateParams.fromDate,
                        sort: $stateParams.sort,
                        filter: $stateParams.filter,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('jotApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$state', '$stateParams'];

    function HealthModalController ($state, $stateParams) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = $stateParams.currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function cancel() {
            // $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        }).state('jhi-health-detail', {
            parent: 'jhi-health',
            url: '/health-detail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/health/health.modal.html',
                    controller: 'HealthModalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            },
            params: {
                currentHealth: null
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InvitationListController', InvitationListController);

    InvitationListController.$inject = ['$state', 'Invitation', 'AlertService', 'pagingParams', 'paginationConstants' ];

    function InvitationListController ($state, Invitation, AlertService, pagingParams, paginationConstants) {

        var vm = this;

        vm.invitations = [];
        vm.predicates = pagingParams.predicates;
        vm.charToSearch = pagingParams.search;

        vm.page = 1;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.currentState = "invitation-list";
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

         function loadAll  (){
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                sort: sort()
            }
            Invitation.invitationList(body, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.invitations = data;
            }

        }

        vm.sendMail = function (invite){
            Invitation.sendMail(invite,function(){
            AlertService.success("Mail send successfully");
            }, onError)
        }

        vm.deleteInvitation = function (id){
            Invitation.delete({id: id},function(){
                vm.loadAll();
                AlertService.success("Delete mail successfully");
            }, onError)
        }


        function onError(){
            AlertService.error("Something wrong");
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});

        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
            transition();

        }

        vm.loadAll();

    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Invitation', Invitation)

    Invitation.$inject = ['$resource'];

    function Invitation($resource) {
        var resourceUrl = 'api/invitations/:id';

        return $resource(resourceUrl, {}, {
            'create': {method: 'POST'},
            'invitationList': {method: 'GET', url: "api/invitations-list", isArray: true},
            'sendMail': {method: 'PUT', url: "api/invitations-email"},
            'delete': {method: 'DELETE'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invitation', {
                parent: 'admin',
                url: '/invitation',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'jotApp.invitation.detail.title'
                },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/invitation/invite-user.html',
                    controller: 'InviteUserController',
                    controllerAs: 'vm'
                }
            },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invitationList', {
                parent: 'admin',
                url: '/invitation-list',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle:'jotApp.invitation.detail.titleList'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/invitation/invitation-list.html',
                        controller: 'InvitationListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InviteUserController', InviteUserController);

    InviteUserController.$inject = ['$stateParams', '$state', 'Invitation', 'TabDomains', 'AlertService', 'Authority'];

    function InviteUserController ($stateParams, $state, Invitation, TabDomains, AlertService, Authority) {
        var vm = this;
        vm.quantity = 1;
        vm.mailList = [];
        vm.domain = [];
        vm.authority = [];
        vm.oldURL = document.baseURI;

        vm.domains = TabDomains.listByUser();
        Authority.query().$promise.then(function (authorities) {
            vm.authorities = authorities;
        });

        vm.clear = function() {
            if(document.URL === vm.oldURL)
                window.history.back();
            else
                window.location.href=vm.oldURL;
        }

        vm.save = function() {
            vm.isSaving = true;
            var body = {
                email: vm.mailList,
                domains: vm.domain,
                authority: vm.authority
            };
            Invitation.create(body, onSuccess, onError);
        }

        function onSuccess() {
            vm.isSaving = false;
            AlertService.success("Invitations sent successfully");
            $state.reload();
        }

        function onError(error){
            var msg = "";
            if(error.status === 409) {
                angular.forEach(error.data, function (value){
                    msg += value + "; ";
                })
                AlertService.error("Mail already present in the database: " + msg.slice(0, -2));
                angular.forEach(vm.mailList, function (value){
                    if(error.data.indexOf(value) === -1) {
                        vm.deleteEmail(vm.mailList.indexOf(value));
                    }
                })
            }
            vm.isSaving = false;
        }

        vm.deleteEmail = function(index){
            vm.mailList.splice(index, 1);
            vm.domain.splice(index, 1);
            vm.authority.splice(index, 1);
            vm.quantity--;
        };

        vm.addQuantity = function(index){
            if(index === Object.keys(vm.mailList).length -1){
                vm.quantity++;
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ChangeObjectController', ChangeObjectController);

    ChangeObjectController.$inject = ['$state', '$uibModalInstance', 'LicenceCode', 'AlertService', 'entity'];

    function ChangeObjectController($state, $uibModalInstance, LicenceCode, AlertService, entity) {
        var vm = this;

        vm.licence = entity;
        vm.objectUniqueCode = "";

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {

            var body = {
                licence: vm.licence.licenceCode,
                objectUniqueCode: vm.objectUniqueCode,
            };

            LicenceCode.update(body, onSuccess, onError);

            function onSuccess(){
                $uibModalInstance.close();
                AlertService.success("Update licence");
            }

            function onError(error){
                AlertService.error("Licence cannot be update");
            }

        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesCodeDetailController', LicencesCodeDetailController);

    LicencesCodeDetailController.$inject = ['$q', '$state', '$uibModal', 'LicenceCode', 'Vendor', 'pagingParams', 'paginationConstants'];

    function LicencesCodeDetailController($q, $state, $uibModal, LicenceCode, Vendor, pagingParams, paginationConstants) {
        var vm = this;
        vm.licences = [];
        vm.vendors = [];
        vm.domains = [];

        vm.filter = {};
        vm.status = -1;
        vm.vendor = [];

        vm.domain = [];

        vm.charToSearch = pagingParams.search;
        vm.domainAble;

        var filter = localStorage.getItem("licence-code-detail");

        if(filter != null && filter != "null" && filter != undefined){
            vm.filter = JSON.parse(filter);
            if (Object.keys(vm.filter).length > 0) {
                vm.status = vm.filter.status ? vm.filter.status : "-1";
                vm.vendor = vm.filter.vendor;
                vm.domain = vm.filter.domain;

            }
        }

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.exportTable = exportTable;
        vm.loadAllToExport = loadAllToExport;

        Vendor.query(function (result) {
            var all = {
                id: -1,
                name: "All",
                link: null
            };
            vm.vendors = result;
            vm.vendors.unshift(all);
        });


        vm.loadAll = function(){

            var body = {
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                domainId : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
                query: vm.charToSearch
            };

            LicenceCode.getByVendor(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.licences = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.licences = data;
            }

            function onError() {}
        };

        vm.addDomains = function () {
            var body = {
                page: 0,
                size: 1000,
            };
            LicenceCode.getDomains(body, onSuccess, onError)
            function onSuccess(data) {
                const all = {
                    domainName: "All"
                };
                vm.domains = data.map(function(x) {return{domainName: x.domainName}})
                vm.domains.unshift(all);
            }
            function onError() {}
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            vm.filter.vendor = vm.vendor;
            vm.filter.status = vm.status;
            vm.filter.domain = vm.domain;
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.filter));
            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                search: vm.charToSearch,
                domain : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.reloadLicences = function() {
            vm.filter.vendor = vm.vendor;
            vm.filter.status = vm.status;
            vm.filter.domain = vm.status == 1 ? {domainName: "All"} :vm.domain;
            vm.domain = vm.status == 1 ? {domainName: "All"} :vm.domain;
            vm.charToSearch = '',
            vm.domainAble = vm.status == 1;
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.filter));
            vm.loadAll();
        };

        function loadAllToExport(){
            var body = {
                page: 0,
                size: 1000,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                domainId : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
            };

            LicenceCode.getByVendor(body, onSuccess, onError);

            function onSuccess(data) {vm.licences = data;}
            function onError() {}
        }

        function exportTable(type) {

            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 70, 1: 80, 2: 100, 3: 100, 4: 100, 5: 100},
                    tableName: 'Licences Code'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Licences Code'});
            }

            vm.loadAll();
        }

        vm.change = function(id){
            $uibModal.open({
                templateUrl: 'app/admin/licences/change-object.html',
                controller: 'ChangeObjectController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['LicenceCode', function (LicenceCode) {
                        return LicenceCode.get({id: id});
                    }]
                }
            }).result.then(function () {
                $state.go('licences-code-detail', null, {reload: true});
            });
        };

        vm.loadAll();
        vm.addDomains();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesCodeController', LicencesCodeController);

    LicencesCodeController.$inject = ['$state', '$uibModal', 'LicenceType', 'Vendor', 'LicenceCode', 'AlertService', 'pagingParams'];

    function LicencesCodeController($state, $uibModal, LicenceType, Vendor, LicenceCode, AlertService, pagingParams) {
        var vm = this;
        vm.licences = [];
        vm.checkTypes = [];
        vm.vendor = [];
        vm.viewLicence = [];
        vm.viewActiveLicence = [];

        var clearTable = {};
        localStorage.setItem("licence-code-detail", JSON.stringify(clearTable));

        vm.loadLicence = function(){
            var body = {
                page: 0,
                size: 20
            };

            LicenceCode.query(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(data) {
                vm.viewLicence = data;
            }

            function onLicenceError() {}
        };

        vm.loadActiveLicence = function(){
            var body = {
                id: -1,
                page: 0,
                size: 20,
            };

            LicenceCode.activeLicence(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(data) {
                vm.viewActiveLicence = data;
            }

            function onLicenceError() {}
        };

        vm.loadTypes = function () {
            LicenceType.query(onTypeSuccess, onTypeError);

            function onTypeSuccess(data) {
                vm.checkTypes = data;
            }

            function onTypeError() {}
        };

        vm.loadVendor = function () {
            Vendor.query(onVendorSuccess, onVendorError);

            function onVendorSuccess(data) {
                vm.vendor = data;
            }

            function onVendorError() {}
        };

        vm.newVendor = function () {
            $uibModal.open({
                templateUrl: 'app/admin/licences/new-vendor.html',
                controller: 'NewVendorController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('licences-code', null, {reload: true});
            });
        };

        vm.save = function () {
            vm.isSaving = true;

            var body = {
                licenceType: vm.licences.checkType,
                vendor: vm.licences.vendor,
                duration: vm.licences.duration,
                quantity: vm.licences.quantity
            };

            LicenceCode.save(body, onSuccess, onError);

            function onSuccess() {
                vm.isSaving = false;
                $state.reload();
            }

            function onError(){
                vm.isSaving = false;
            }
        };

        vm.clear = function () {
            $state.reload();
        };

        vm.loadTypes();
        vm.loadVendor();
        vm.loadLicence();
        vm.loadActiveLicence();

    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('LicenceCode', LicenceCode)
        .factory('LicenceType', LicenceType)
        .factory('Vendor', Vendor);

    LicenceCode.$inject = ['$resource', 'DateUtils'];

    function LicenceCode($resource, DateUtils) {
        var resourceUrl = 'api/licence-code/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'save': {method: 'POST', url:'api/licence-code/save-new'},
            'get': {method: 'GET', url:'api/licence-code/licence-id/:id'},
            'getByVendor': {
                method: 'GET',
                url: 'api/licence-code/by-vendor/:id/:status',
                isArray: true
            },
            'active': {method: 'PUT', url:'api/licence-code/active'},
            'activeLicence': {
                method: 'GET',
                url: 'api/licence-code/active-licence/:id',
                isArray: true
            },
            'update': {method: 'PUT', url:'api/licence-code/update'},
            'getDomains': {method: 'GET', url: 'api/licence-code/domains', isArray: true}
        });
    }

    LicenceType.$inject = ['$resource', 'DateUtils'];

    function LicenceType($resource, DateUtils) {
        var resourceUrl = 'api/licence-type/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    Vendor.$inject = ['$resource', 'DateUtils'];

    function Vendor($resource, DateUtils) {
        var resourceUrl = 'api/vendor/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'create': {method: 'PUT', url:'api/vendor/create-new'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('licences-code', {
            parent: 'admin',
            url: '/licences-code',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/licences-code.html',
                    controller: 'LicencesCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('licences-code-detail', {
            parent: 'licences-code',
            url: '/detail?page',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/licences-code-detail.html',
                    controller: 'LicencesCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                filter: null,
                search: {
                    value: '',
                    squash: true
                },
                vendor: {
                    id: -1
                },
                status: -1,
                domain: {
                    domainName: "All"
                },
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        id: $stateParams.vendor.id,
                        status: $stateParams.status,
                        domain: $stateParams.domain,
                        fiter: $stateParams.filter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('recap-objects', {
            parent: 'licences-code',
            url: '/active',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN'],
                pageTitle: 'jotApp.licencesCode.titlePage'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/licences/recap-objects.html',
                    controller: 'RecapObjectsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                search: {
                    value: '',
                    squash: true
                },
                vendor: {
                    id: -1
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        search: $stateParams.search,
                        id: $stateParams.vendor.id
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licencesCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NewVendorController', NewVendorController);

    NewVendorController.$inject = ['$state', '$uibModalInstance', 'Vendor', 'AlertService'];

    function NewVendorController($state, $uibModalInstance, Vendor, AlertService) {
        var vm = this;
        vm.vendor = [];

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {

            var body = {
                name: vm.vendor.name,
                link: vm.vendor.vendorLink != null ? vm.vendor.vendorLink : null
            };
            Vendor.create(body, onSuccess, onError);

            function onSuccess(data, headers) {
                $uibModalInstance.close();
            }

            function onError() {
                AlertService.error("Name already exist");
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('RecapObjectsController', RecapObjectsController);

    RecapObjectsController.$inject = ['$state', 'LicenceCode', 'Vendor', 'pagingParams', 'paginationConstants'];

    function RecapObjectsController($state, LicenceCode, Vendor, pagingParams, paginationConstants) {
        var vm = this;

        vm.charToSearch = pagingParams.search;

        vm.activeLicence = [];
        vm.vendors = [];

        vm.vendor = [];
        var vendor = localStorage.getItem("licence-code-detail");
        if(vendor != null && vendor != "null" && vendor != undefined){
            vm.vendor = JSON.parse(vendor);
        }

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        Vendor.query(function (result) {
            var all = {
                id: -1,
                name: "ALL",
                link: null
            };
            vm.vendors = result;
            vm.vendors.unshift(all);
        });

        vm.loadAll = function() {
            var body = {
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                query: vm.charToSearch
            };

            LicenceCode.activeLicence(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.activeLicence = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.activeLicence = data;
            }

            function onError() {}
        };

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.reloadLicences = function() {
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.vendor));
            vm.loadAll();
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['threadDump'];

    function JhiMetricsMonitoringModalController (threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            //TODO da fare tasto back
            // $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('metrics/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        })
        .state('jhi-metrics-detail', {
            parent: 'jhi-metrics',
            url: '/metrics-total-detail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }],
                threadDump: ['JhiMetricsService', function(JhiMetricsService) {
                    console.log(JhiMetricsService);
                    return JhiMetricsService.threadDump().then(function(data) {
                        console.log(data);
                        return data;
                    });
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementAlertSystemController', TeamManagementAlertSystemController);

    TeamManagementAlertSystemController.$inject = ['$state', 'entity', 'Team', 'domain', 'AlertRules', 'AlertService', 'AlertSystem', 'pagingParams', 'paginationConstants', 'ParseLinks', '$uibModal', '$rootScope'];

    function TeamManagementAlertSystemController($state, entity, Team, domain, AlertRules, AlertService, AlertSystem, pagingParams, paginationConstants, ParseLinks, $uibModal, $rootScope) {
        var vm = this;

        vm.user = entity;
        vm.domain = domain;
        vm.predicates = pagingParams.predicates;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.currentState = "team-alert-system";
        vm.systemWarningItemLimit = 4;
        vm.enableMail = [];
        vm.enableSlack = [];
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.wac = [];
        vm.licence = $rootScope.licence;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);
        retrievedOrder = localStorage.getItem(vm.currentState+"system");
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.systemPredicates = JSON.parse(retrievedOrder);

        }
        vm.transition = transition;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            AlertRules.getWarningByUser({
                login: $state.params.login,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(vm.predicates,"")
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warnings = data.warnings;
                vm.notifications = data.notification;
                vm.page = pagingParams.page;
                enableAlertSystem(vm.warnings);
                AlertSystem.getUserAlertSystem({user: $state.params.login}, onAlertSuccess);
            }

            AlertRules.getSystemWarningByUser({
                login: $state.params.login,
                page: pagingParams.systemPage - 1,
                size: vm.systemWarningItemLimit,
                sort: sort(vm.systemPredicates,"system")
            }, onSuccessSystem, onError);

            function onSuccessSystem(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.systemTotalItems = headers('X-Total-Count');
                vm.systemQueryCount = vm.systemTotalItems;
                vm.systemWarnings = data.warnings;
                vm.notifications = data.notification;
                vm.systemPage = pagingParams.systemPage;
                enableAlertSystem(vm.systemWarnings);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
            function onAlertSuccess(results) {
                vm.emailDisabled = false;
                vm.slackDisabled = false;
                vm.telegramDisabled = false;
                vm.webhookDisabled = false;
                results.forEach(function (alert) {
                    if(alert.alertSystemType.name == "email") {
                        vm.email = alert;
                        vm.userEmail = alert.actionIdentifier;
                        vm.emailDisabled = alert.adminDisabled;
                    } else if(alert.alertSystemType.name == "slack") {
                        vm.slack = alert;
                        vm.slackDisabled = alert.adminDisabled;
                        vm.userSlack = alert.actionIdentifier;
                    } else if(alert.alertSystemType.name == "telegram") {
                        vm.telegram = alert;
                        vm.telegramDisabled = alert.adminDisabled;
                        vm.userTelegram = alert.actionIdentifier;
                    } else if(alert.alertSystemType.name == "webhook") {
                        vm.webhook = alert;
                        vm.webhookDisabled = alert.adminDisabled;
                        vm.userWebhok = alert.actionIdentifier;
                    }
                });
            }

        }

        vm.deleteAlert = function (id) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/delete-dialog.html',
                controller:function($uibModalInstance){
                    var vm=this;
                    vm.clear = clear;
                    vm.stop = stop;
                    function stop() {
                        AlertSystem.delete({id: id}, function (result) {
                            $state.reload();
                        });
                        $uibModalInstance.close();
                    }
                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs:'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function () {
                transition(false);
            });
        };

        function enableAlertSystem(warnings){
            warnings.forEach(function (warning) {
                vm.wac[warning.id] = {};
                vm.wac[warning.id].email = false;
                vm.wac[warning.id].slack = false;
                vm.wac[warning.id].telegram = false;
                vm.wac[warning.id].webhook = false;
                warning.warningAlertConfigurations.forEach(function (wac) {
                    var name = wac.alertSystemType.name;
                    vm.wac[warning.id][name] = wac.active;
                });
                if(!(vm.domain.enableAlerting && vm.domain.mailAlerting))
                    warning.relatedAlertSystemType.Channelemail = vm.wac[warning.id].email = vm.domain.enableAlerting && vm.domain.mailAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.slackAlerting))
                    warning.relatedAlertSystemType.Channelslack = vm.wac[warning.id].slack = vm.domain.enableAlerting && vm.domain.slackAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.telegramAlerting))
                    warning.relatedAlertSystemType.Channeltelegram = vm.wac[warning.id].telegram = vm.domain.enableAlerting && vm.domain.telegramAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.webhookAlerting))
                    warning.relatedAlertSystemType.Channelwebhook = vm.wac[warning.id].webhook = vm.domain.enableAlerting && vm.domain.webhookAlerting;
                vm.enableMail[warning.id] =  warning.relatedAlertSystemType.email != null && warning.relatedAlertSystemType.email != undefined && warning.relatedAlertSystemType.Channelemail != undefined && warning.relatedAlertSystemType.Channelemail && vm.wac[warning.id].email;
                vm.enableSlack[warning.id] = warning.relatedAlertSystemType.slack != null && warning.relatedAlertSystemType.slack != undefined && warning.relatedAlertSystemType.Channelslack != undefined && warning.relatedAlertSystemType.Channelslack && vm.wac[warning.id].slack;
                vm.enableTelegram[warning.id] = warning.relatedAlertSystemType.telegram != null && warning.relatedAlertSystemType.telegram != undefined && warning.relatedAlertSystemType.Channeltelegram != undefined && warning.relatedAlertSystemType.Channeltelegram && vm.wac[warning.id].telegram;
                vm.enableWebhook[warning.id] = warning.relatedAlertSystemType.webhook != null && warning.relatedAlertSystemType.webhook != undefined && warning.relatedAlertSystemType.Channelwebhook != undefined && warning.relatedAlertSystemType.Channelwebhook && vm.wac[warning.id].webhook;
            });
        }

        vm.user.$promise.then(loadAll());


        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                systemPredicates: vm.systemPredicates,
                sort: sort(vm.predicates,""),
                systemPage: vm.systemPage,
                systemSort: sort(vm.systemPredicates,"system"),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                entity: vm.user,
                domain : vm.domain,
                login :  vm.user.login
            }, {notify: notify, location: "replace"});
        }



        vm.toggleStatus = function(type, status) {
            AlertRules.domainToggleChannel({login: vm.user.login, type: type, status: status}, function () {
                loadAll();
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDeleteController', TeamManagementDeleteController);

    TeamManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Team'];

    function TeamManagementDeleteController ($uibModalInstance, entity, Team) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            Team.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDetailController', TeamManagementDetailController);

    TeamManagementDetailController.$inject = ['$stateParams', 'Team'];

    function TeamManagementDetailController ($stateParams, Team) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            Team.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDialogController', TeamManagementDialogController);

    TeamManagementDialogController.$inject = ['$state', 'entity', 'Team', 'JhiLanguageService', 'UserProfile', 'domain'];

    function TeamManagementDialogController($state, entity, Team, JhiLanguageService, UserProfile, domain) {
        var vm = this;

        vm.authorities = null;
        vm.languages = null;
        vm.userProfiles = null;
        vm.save = save;
        vm.user = entity;
        vm.domain = domain;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        UserProfile.getTeamProfiles().$promise.then(function (userProfiles) {
            $('#login').prop('readonly', true);
            vm.userProfiles = userProfiles;
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('team-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.clear = function () {
            $state.go('team-management');
        };

        function save() {
            vm.isSaving = true;
            vm.user.authorities = [vm.user.authorities];
            Team.update(vm.user, onSaveSuccess, onSaveError);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementController', TeamManagementController);

    TeamManagementController.$inject = ['$state','Principal', 'Team', 'ParseLinks', 'paginationConstants', 'pagingParams', 'JhiLanguageService'];

    function TeamManagementController($state,Principal, Team, ParseLinks, paginationConstants, pagingParams, JhiLanguageService) {
        var vm = this;

        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.predicates = pagingParams.predicates;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = pagingParams.page;
        vm.setActive = setActive;
        vm.transition = transition;
        vm.totalItems = null;
        vm.users = [];
        vm.changePageSize = changePageSize;
        vm.currentState = "team-management";
        vm.charToSearch = pagingParams.search;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.userStatus = pagingParams.status !== null ? pagingParams.status : '';
        vm.active = vm.userStatus === '' ? true : vm.userStatus === 'inactive' ? false : null;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            Team.query(
                {
                    page: vm.page - 1,
                    size: vm.itemsPerPageChosen,
                    query: vm.charToSearch,
                    status: vm.active,
                    sort: sort()
                }, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                //vm.page = pagingParams.page;
                vm.users = result;
                    // transition();
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.showUserByStatus = function () {
            vm.page = 1;
            if(vm.userStatus == "all"){
                vm.active = null;
            }else if (vm.userStatus == "") {
                vm.active = true;
            } else if (vm.userStatus == "inactive") {
                vm.active = false;
            }
            loadAll();
        }


        function setActive(user, isActivated) {
            user.activated = isActivated;
            Team.update(user, function () {
                vm.loadAll();
                vm.clear();
            });

        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();

        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                status: vm.userStatus
            }, {notify: notify, location: "replace"});


        }

        vm.search = function () {
            pagingParams.page = 1;
            loadAll(false);
        };


        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.newInvitation = function () {
            $state.go('invitation', null, {reload: true});
        }

        vm.invitationList = function () {
            $state.go('invitationList',null,{reload: true})
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('team-management', {
                parent: 'admin',
                url: '/team',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management.html',
                        controller: 'TeamManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {},
                    status: ''
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            status: $stateParams.status

                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('team-management');
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-detail', {
                parent: 'admin',
                url: '/team/:login',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-detail.html',
                        controller: 'TeamManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('team-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-edit', {
                parent: 'team-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-dialog.html',
                        controller: 'TeamManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Team','$stateParams', function (Team, $stateParams) {
                        return Team.get({login: $stateParams.login});
                    }],
                    domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                        var domain = $q.defer();
                        Principal.identity().then(function (data) {
                            domain.resolve(TabDomains.get({id: data.context.id}));
                        });
                        return domain.promise;
                    }]
                }
            })
            .state('team-management-alerts', {
                parent: 'team-management',
                url: '/{login}/alerts',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'entity.action.alertSystem'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-alert-system.html',
                        controller: 'TeamManagementAlertSystemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        squash: true
                    },
                    systemPage: {
                        value: '1',
                        squash: true
                    },
                    systemSort: {
                        squash: true
                    },
                    search: null,
                    predicates : {},
                    systemPredicates : {},
                    itemsPerPageChosen: null
                },
                resolve: {
                    entity: ['Team','$stateParams', function (Team, $stateParams) {
                        return Team.get({login: $stateParams.login});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                            systemSort: $stateParams.systemSort,
                            predicates : $stateParams.predicates,
                            systemPredicates : $stateParams.systemPredicates,
                            search: $stateParams.search
                        };
                    }],
                    domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                        var domain = $q.defer();
                        Principal.identity().then(function (data) {
                            domain.resolve(TabDomains.current());
                        });
                        return domain.promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-delete', {
                parent: 'team-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/team-management/team-management-delete-dialog.html',
                        controller: 'TeamManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Team', function (Team) {
                                return Team.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('team-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();
;
(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('jotApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            if (stompClient === null) {
                var loc = $window.location;
                var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
                var socket = new SockJS(url);
                stompClient = Stomp.over(socket);
                var stateChangeStart;
                var headers = {};
                headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
                stompClient.connect(headers, function () {
                    connected.resolve('success');
                    sendActivity();
                    if (!alreadyConnectedOnce) {
                        stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                            sendActivity();
                        });
                        alreadyConnectedOnce = true;
                    }
                });
                $rootScope.$on('$destroy', function () {
                    if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                        stateChangeStart();
                    }
                });
            }
        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                        {},
                        angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe() {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/tracker', function (data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            },
            onExit: function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'UserProfile'];

    function UserManagementDetailController ($stateParams, User, UserProfile) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                vm.user.userProfile = UserProfile.getByUserId({"id":vm.user.id});
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$state', '$timeout', '$q', 'User', 'Authority', 'JhiLanguageService', 'TabDomains', 'entity', 'UserProfile'];

    function UserManagementDialogController($state, $timeout, $q, User, Authority, JhiLanguageService, TabDomains, entity, UserProfile) {
        var vm = this;

        vm.authorities = null;
        vm.clear = clear;
        vm.languages = null;
        vm.userProfiles = [];
        vm.save = save;
        vm.user = entity;
        vm.domains = TabDomains.list();
        vm.loadProfiles = loadProfiles;
        vm.edit = false;
        vm.profilesLoading = false;

        initController();

        function initController() {
            var entityPromise = entity.$promise ? entity.$promise : $q.when(entity);

            entityPromise.then(function(user) {
                vm.user = user;

                Authority.query().$promise.then(function (authorities) {
                    vm.authorities = authorities;

                    if(vm.user.id) {
                        vm.edit=true;
                        loadProfiles(function () {
                            loadProfile();
                        });
                    }

                });
            });
        }

        function assignDefaultProfile() {
            $timeout(function() {
                if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                    vm.user.userProfile = vm.userProfiles[0];
                    syncSelectedProfile();
                }
            }, 0);
        }

        function syncSelectedProfile() {

            if(!vm.user || !vm.user.userProfile || !vm.user.userProfile.id) {
                return;
            }

            if(!vm.userProfiles || !vm.userProfiles.length) {
                return;
            }

            angular.forEach(vm.userProfiles, function(p) {
                if(p && p.id === vm.user.userProfile.id) {
                    vm.user.userProfile = p;
                }
            });
        }

        function loadProfile() {

            UserProfile.getByUserId({"id": vm.user.id}, onSuccess, onError);

            function onSuccess(data){
                if (data && angular.isString(data)) {
                    data = angular.fromJson(data);
                }

                vm.user.userProfile = data;

                $timeout(function() {
                    if(!vm.user.userProfile || !vm.user.userProfile.id) {
                        assignDefaultProfile();
                        return;
                    }
                    syncSelectedProfile();
                }, 0);
            }
            function onError(){
                assignDefaultProfile();
            }
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $state.go('user-management');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('user-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getAuthorityName(authorities) {
            if (angular.isArray(authorities)) {
                return authorities.length > 0 ? (authorities[0] && authorities[0].name ? authorities[0].name : authorities[0]) : null;
            }
            if (authorities && authorities.name) {
                return authorities.name;
            }
            return authorities;
        }

        function normalizeAuthorities(authorities) {
            if (angular.isArray(authorities)) {
                return authorities.map(function(a) {
                    return a && a.name ? a.name : a;
                });
            }
            if (authorities && authorities.name) {
                return [authorities.name];
            }
            if (authorities) {
                return [authorities];
            }
            return [];
        }

        function loadProfiles(callback) {
            var authorityName = getAuthorityName(vm.user.authorities);

            if (!authorityName) {
                vm.userProfiles = [];
                vm.profilesLoading = false;
                if (callback) {
                    callback();
                }
                return;
            }

            vm.profilesLoading = true;
            var result = UserProfile.default({"authority":authorityName});

            if(result && result.$promise) {
                result.$promise.then(function (data) {
                    vm.userProfiles = data;
                    vm.profilesLoading = false;

                    $timeout(function() {
                        if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                            vm.user.userProfile = vm.userProfiles[0];
                        }
                        syncSelectedProfile();
                    }, 0);

                    if(callback) {
                        callback();
                    }
                }, function(error) {
                    vm.profilesLoading = false;
                    vm.userProfiles = [];
                    if(callback) {
                        callback();
                    }
                });
            } else {
                vm.userProfiles = result;
                vm.profilesLoading = false;

                $timeout(function() {
                    if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                        vm.user.userProfile = vm.userProfiles[0];
                    }
                    syncSelectedProfile();
                }, 0);

                if(callback) {
                    callback();
                }
            }
        }

        function save() {
            vm.isSaving = true;
            vm.user.authorities = normalizeAuthorities(vm.user.authorities);
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'TabDomains', 'TabFleets', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', '$state', 'AlertService', 'pagingParams'];

    function UserManagementController(Principal, TabDomains, TabFleets, User, ParseLinks, paginationConstants, JhiLanguageService, $state, AlertService, pagingParams) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.charToSearch = pagingParams.search;
        vm.setActive = setActive;
        vm.impersonate = impersonate;
        vm.changePageSize = changePageSize;
        vm.totalItems = null;
        vm.users = [];
        vm.domains = [];
        vm.fleets = [];
        vm.active = true;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        if(vm.filterDomain === undefined) {
            var allDomain = {}
            allDomain.id = -1;
            allDomain.domainName = "All";
            vm.domains.push(allDomain);
            vm.filterDomain = allDomain;
            var allFleets = {}
            allFleets.id = -1;
            allFleets.fleetName = "All";
            vm.filterFleet = allFleets;
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.loadAll();
        function loadAll () {
            TabDomains.query({
                page: 0,
                size: 1000 }, function (result) {
                vm.domains = [];
                allDomain = {}
                allDomain.id = -1;
                allDomain.domainName = "All";
                vm.domains.push(allDomain);
                result.forEach(function (val) {
                    vm.domains.push(val);
                })
            });
            User.query({
                query: vm.charToSearch,
                domain: vm.filterDomain.id,
                fleet: vm.filterFleet.id,
                status: vm.active,
                page: vm.page - 1,
                size: vm.itemsPerPageChosen
            }, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.showUserByStatus = function () {
            if(vm.userStatus == "all"){
                vm.active = null;
            }else if (vm.userStatus == "") {
                vm.active = true;
            } else if (vm.userStatus == "inactive") {
                vm.active = false;
            }
            loadAll();
        }

        vm.search = function () {
            vm.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        function changePageSize() {
            // if ((vm.queryCount / vm.itemsPerPageChosen) < vm.page)
            //    vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            // transition

            vm.page = 1;
            vm.loadAll();
        }


        function impersonate(user) {
            User.get({login: user.login}, function(result) {
                if(result.domains.length > 0) {
                    User.impersonate(user);
                    $state.go("context", null, {reload: true});
                } else {
                    AlertService.error("No domains found for this user");
                }
            });
        }

        vm.filterDomains = function () {
            TabFleets.domains({id:vm.filterDomain.id}, function (result) {
                if(vm.filterDomain.id == -1) {
                    loadAll();
                } else {
                    vm.fleets = [];
                    result.forEach(function (val) {
                        vm.fleets.push(val);
                    })
                    var allFleets = {}
                    allFleets.id = -1;
                    allFleets.fleetName = "All";
                    vm.fleets.push(allFleets);
                    vm.filterFleet = allFleets;
                    loadAll();
                }
            })
        }

        vm.newInvitation = function () {
            $state.go('invitation', null, {reload: true});
        }

        vm.invitationList = function () {
            $state.go('invitationList',null,{reload: true})
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('invitation');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.userManagement.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        id: null, login: null, firstName: null, lastName: null, email: null,
                        activated: true, langKey: null, createdBy: null, createdDate: null,
                        lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                        resetKey: null, authorities: null
                    };
                }
            }
        })
        .state('user-management-edit', {
            parent: 'user-management',
            url: '/user/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'User', function ($stateParams, User) {
                    return User.get({login : $stateParams.login});
                }]

            }
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("jotApp")

.constant("ENV", "prod")

.constant("VERSION", "1.39.0")

.constant("STOMP_DEBUG", false)

;
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('site', {
            abstract: true,
            template: '<ui-view/>',
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }

        }).state('main', {
            parent: 'site',
            data: {
                authorities: [],
                evaluateAuthorities: ''
            },
            templateUrl: 'app/layouts/content.html',
            controller: 'MainController',
            controllerAs: 'vm'
        }).state('app', {
            parent: 'main',
            views: {
                'navbar@main': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'aside@main': {
                    templateUrl: 'app/layouts/aside/aside.html',
                    controller: 'AsideController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'ENV'];

    function compileServiceConfig($compileProvider, ENV) {
        // disable debug data on prod profile to improve performance
        if(ENV === 'prod'){
            $compileProvider.debugInfoEnabled(false);
        }

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'ENV', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, ENV, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            //
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1 ) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout(to.name === 'login');
                if (to.name !== 'accessdenied') {
                    $sessionStorage.previousStateName = to.name;
                    $sessionStorage.previousStateParams = params;
                }
                // $injector.get('$state').go('login');
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))
                && !(response.status === 404 && (response.config.url.indexOf('api/maintenance-setting') === 0))) {
                $rootScope.$emit('jotApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-jotApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-jotApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" ng-if="!$ctrl.conflict">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('jotApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];
        vm.conflict = false;

        function addErrorAlert (message, key, data) {
            if(data === undefined || (data.fieldName !== "jotApp.invitationDTO.authority" && data.fieldName !== "jotApp.invitationDTO.domains")){
                key = key && key !== null ? key : message;
            } else {
                key = message.replace('jotApp.invitationDTO.', '');
            }
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('jotApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();

            function showCustomError(){
                var entityName;
                var entityKey = httpResponse.headers('X-jotApp-params');
                if(entityKey) {
                    entityName = $translate.instant(entityKey);
                }
                else{
                    entityName = httpResponse.headers('X-jotApp-value');
                }
                addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
            }
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                vm.conflict = false;
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                vm.conflict = false;
                var errorHeader = httpResponse.headers('X-jotApp-error');
                if (errorHeader) {
                    showCustomError();
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('jotApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.description, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 409:
                vm.conflict = true;
                break;

            default:
                vm.conflict = false;
                var errorHeader = httpResponse.headers('X-jotApp-error');
                if (errorHeader) {
                    showCustomError();
                }
                else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.description);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
                vm.conflict = false;
            }
        });
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" class="top right toast">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('jotApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function (){
    'use strict';

    var bgCanvas = {
        template: '<div class="bg-canvas-wrapper">' +
                        '<canvas id="canvas"></canvas>' +
                    '</div>',
        controller: bgCanvasController
    };

    angular
        .module('jotApp')
        .component ('bgCanvas', bgCanvas);

    function bgCanvasController() {
        // RequestAnimFrame: a browser API for getting smooth animations
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();

        // Initializing the canvas
        // I am using native JS here, but you can use jQuery,
        // Mootools or anything you want
        var canvas = document.getElementById("canvas");

        // Initialize the context of the canvas
        var ctx = canvas.getContext("2d");

        // Set the canvas width and height to occupy full window
        var W = window.innerWidth, H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;

        //manage window resize
        $(window).on('resize', function () {
            W = window.innerWidth;
            H = window.innerHeight;
            canvas.width = W;
            canvas.height = H;
        });

        // Some variables for later use
        var particleCount = 10 + Math.ceil(24 * (W * H) / (1920 * 1080));
        var twinParticleCount = 4;
        var particles = [];
        var minDist = 72;
        const attractiveness = 1 / 2000;
        const velocity = 1.07;      // 0.2+1.07^5=1.6
        const minVelocity = 0.2;    // initial velocity: [0.2, 1.6]
        const maxVelocity = 1.5;
        const autoVeloxDeceleration = 0.99996;

        // Function to paint the canvas black
        function paintCanvas() {
            // Set the fill color to black
            ctx.fillStyle = "rgba(0,0,0,1)";

            // This will create a rectangle of white color from the
            // top left (0,0) to the bottom right corner (W,H)
            ctx.fillRect(0, 0, W, H);
        }

        // Now the idea is to create some particles that will attract
        // each other when they come close. We will set a minimum
        // distance for it and also draw a line when they come
        // close to each other.

        // The attraction can be done by increasing their velocity as
        // they reach closer to each other

        // Let's make a function that will act as a class for
        // our particles.

        function Particle() {
            // Position them randomly on the canvas
            // Math.random() generates a random value between 0
            // and 1 so we will need to multiply that with the
            // canvas width and height.
            this.x = Math.random() * W;
            this.y = Math.random() * H;


            // We would also need some velocity for the particles
            // so that they can move freely across the space
            this.vx = (Math.random() - 0.5) * 2 * velocity;
            this.vy = (Math.random() - 0.5) * 2 * velocity;
            this.vx = Math.pow(this.vx, 5) + (Math.sign(this.vx) * minVelocity);
            this.vy = Math.pow(this.vy, 5) + (Math.sign(this.vy) * minVelocity);
            // = Math.sign(this.vx) * (Math.pow(this.vx, 4) + minVelocity)
            // = Math.sign(this.vy) * (Math.pow(this.vy, 4) + minVelocity)

            // Now the radius of the particles. I want all of
            // them to be equal in size so no Math.random() here..
            this.radius = 4;


            // This is the method that will draw the Particle on the
            // canvas. It is using the basic fillStyle, then we start
            // the path and after we use the `arc` function to
            // draw our circle. The `arc` function accepts four
            // parameters in which first two depicts the position
            // of the center point of our arc as x and y coordinates.
            // The third value is for radius, then start angle,
            // end angle and finally a boolean value which decides
            // whether the arc is to be drawn in counter clockwise or
            // in a clockwise direction. False for clockwise.
            this.draw = function () {
                ctx.fillStyle = 'rgb(246 246 246 / 50%)';
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);

                // Fill the color to the arc that we just created
                ctx.fill();
            }
        }

        // Time to push the particles into an array
        for (var i = 0; i < particleCount - twinParticleCount; i++) {
            particles.push(new Particle());
        }
        for (var i = 0; i < twinParticleCount; i++) {
            var twinParticle = new Particle();
            twinParticle.x = particles[i].x + around(minDist/3, minDist * 0.886);
            twinParticle.y = particles[i].y + around(minDist/3, minDist * 0.886);
            particles.push(twinParticle);
        }

        function around(min, max) {
            var a = Math.pow((Math.random() - 0.5) * 2, 2);
            return a * (max - min) + Math.sign(a) * min;
        }

        // Function to draw everything on the canvas that we'll use when
        // animating the whole scene.
        function draw() {

            // Call the paintCanvas function here so that our canvas
            // will get re-painted in each next frame
            paintCanvas();

            // Call the function that will draw the balls using a loop
            // particles.forEach(p => p.draw());
            particles.forEach(
                function (p){
                    p.draw();
                }
            );

            //Finally call the update function
            update();
        }

        // Give every particle some life
        function update() {

            // In this function, we are first going to update every
            // particle's position according to their velocities
            for (var i = 0; i < particles.length; i++) {
                var p = particles[i];

                p.interaction = 0;

                // Change the velocities
                p.x += p.vx;
                p.y += p.vy

                // We don't want to make the particles leave the
                // area, so just change their position when they
                // touch the walls of the window
                if (p.x + p.radius > W)
                    p.x = p.radius;

                else if (p.x - p.radius < 0) {
                    p.x = W - p.radius;
                }

                if (p.y + p.radius > H)
                    p.y = p.radius;

                else if (p.y - p.radius < 0) {
                    p.y = H - p.radius;
                }

                // Now we need to make them attract each other
                // so first, we'll check the distance between
                // them and compare it to the minDist we have
                // already set

                // We will need another loop so that each
                // particle can be compared to every other particle
                // except itself
                for (var j = i + 1; j < particles.length; j++) {
                    var p2 = particles[j];
                    distanceCalculator(p, p2);
                }

            }
            /*particles.forEach(p => {
                if (p.interaction < 4) {
                    p.vx = autoVelox(p.vx);
                    p.vy = autoVelox(p.vy);
                } else if(p.interaction > 8){
                    p.vx = autoDemolish(p.vx, p.interaction);
                    p.vy = autoDemolish(p.vy, p.interaction);
                }
            })*/
            particles.forEach(
                function (p){
                    if (p.interaction < 4) {
                        p.vx = autoVelox(p.vx);
                        p.vy = autoVelox(p.vy);
                    } else if(p.interaction > 8){
                        p.vx = autoDemolish(p.vx, p.interaction);
                        p.vy = autoDemolish(p.vy, p.interaction);
                    }
                }
            )
        }

        function autoDemolish(v, i) {
            return v * (1 + (0.0000001 * i));
        }

        function autoVelox(v) {
            if(Math.abs(v) > maxVelocity) {
                return v * autoVeloxDeceleration;
            }
            return v;
        }

        // Distance calculator between two particles
        function distanceCalculator(p1, p2) {
            var distance;
            var dx = p1.x - p2.x;
            var dy = p1.y - p2.y;

            distance = Math.sqrt(dx * dx + dy * dy);

            // Draw the line when distance is smaller
            // then the minimum distance
            if (distance <= minDist) {

                // Draw the line
                ctx.beginPath();
                ctx.strokeStyle = "rgba(255,255,255," + (1.2 - distance / minDist) + ")";
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p2.x, p2.y);
                ctx.stroke();
                ctx.closePath();

                // Some acceleration for the partcles
                // depending upon their distance
                var ax = dx * attractiveness,
                    ay = dy * attractiveness;

                p1.interaction++;
                // Apply the acceleration on the particles
                p1.vx -= ax;
                p1.vy -= ay;

                p2.vx += ax;
                p2.vy += ay;
            }
        }

        // Start the main animation loop using requestAnimFrame
        function animloop() {
            draw();
            requestAnimFrame(animloop);
        }

        animloop();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContextController', ContextController);

    ContextController.$inject = ['$state', 'Context', 'Principal'];

    function ContextController($state, Context, Principal) {
        var vm = this;
        vm.save = save;
        vm.searchText = '';
        vm.viewSearch = false;
        vm.contexts = [];

        vm.loadAll = function() {
            Context.query(
                {search: vm.searchText}
            ).$promise.then(
                function (resp) {
                    if(resp.length == 1 && vm.searchText=='') {
                        var element = document.getElementById("oneContext");
                        element.href = "/jot/api/context/" + resp[0].id;
                        element.click();
                    } else {
                        vm.viewSearch = true;
                        vm.contexts = resp.map(function (ct) {
                            var name = ct.domainName.split(" ");
                            ct.logo = '';
                            for (var i = 0, len = name.length > 3 ? 3 : name.length; i < len; i++) {
                                ct.logo += name[i].charAt(0).toUpperCase();
                            }
                            return ct;
                        });
                    }
                });
        }

        vm.loadAll();

        function save(context) {

            Context.save(context, onSuccess, onError);

            function onSuccess() {
                Principal.identity(true).then(function (account) {
                    if(account.authorities.length == 1)
                        $state.go('performance');
                    else
                        $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                });
            }

            function onError(error) {

            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('context', {
            parent: 'site',
            data: {
                authorities: []
            },
            templateUrl: 'app/components/context/context.html',
            controller: 'ContextController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20,
            'itemsPerPageChoose':[10,20,50,100]
        });
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(pagerConfig);

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(paginationConfig);

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$timeout', '$window', 'TabFleets', 'Team', 'Context', 'TabDomains', 'User', 'ListObjAndObjType', 'TabObjectsDashboard', 'TabObjectsMap', 'ObjectMap', '$uibModal'];

    function HomeController($scope, $timeout, $window, TabFleets, Team, Context, TabDomains, User, ListObjAndObjType, TabObjectsDashboard, TabObjectsMap, ObjectMap, $uibModal) {
        var vm = this;
        vm.addDomains = addDomains;
        vm.moveDomains=moveDomains;
        vm.domains = [];
        vm.selectDomains = [];
        vm.domainUser = [[]];
        vm.domainUserAdd = [[]];
        vm.domainUserMove = [[]];
        vm.userAddDomains = [[]];
        vm.domainsUser=[[]];
        vm.saveAddDomains = saveAddDomains;
        vm.saveMoveDomains = saveMoveDomains;
        vm.userAddFleets = [[]];
        vm.fleetDomain = [[]];
        vm.fleetAddDomains = [[]];
        vm.saveMoveFleetsDomain = saveMoveFleetsDomain;
        vm.moveFleetsDomain=moveFleetsDomain;
        vm.fleet = {};
        vm.objectType = {};
        vm.load = load;
        $scope.labelsFleets =[];
        $scope.labelsWarnings = [];
        $scope.seriesFleets =[];
        $scope.seriesWarnings = [];
        $scope.dataFleets =[];
        $scope.dataWarnings = [];
        vm.palette = {'AMT':'#26C281','Fan Issue':'#32C5D2','Screen Content':'#E43A45','Firmware Version':'#E87E04','Tamper':'#F3C200','Backlight':'#8E44AD','Temperature':'#3598DC','Temperature Sensor Failure':'#525E64','Humidity':'#C8D046'};
        $scope.colorsFleet = ['#26C281','#32C5D2','#E43A45','#E87E04', '#F3C200', '#8E44AD', '#3598DC', '#525E64', '#C8D046', '#e5e5e5'];

        vm.tabFleet = [];
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0
        };
        $scope.dataStatus = [];
        $scope.colorStatus = [];
        $scope.labelStatus = [];

        $scope.points = [];

        vm.onlineTrendPrecentage = 0;
        vm.offlineTrendPrecentage = 0;
        vm.untrackedTrendPrecentage = 0;
        vm.warningsTrendPercentage = 0;
        vm.trend = 0;

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        var resUntracked = [];

        User.checkTerms({}, onSuccessCheck, onErrorCheck);

        function onSuccessCheck() {}

        function onErrorCheck() {
            $uibModal.open({
                templateUrl: 'app/components/register-page/terms-conditions.html',
                controller: 'TermsConditionsController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                $state.reload();
            });
        }

        vm.mapStyle = {};
        var map = ObjectMap.build("object-map");
        var markersLayer = new L.LayerGroup();
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);
        resizeFrame();

        function resizeFrame() {
            var offsetY = 140;
            var mapHeight = $window.innerHeight -100;
            mapHeight = mapHeight > 600 ? mapHeight - offsetY : 600;
            vm.mapStyle.height = mapHeight;
            var sizeX = Math.round((mapHeight / 100));

            loadMap();
        }

        function loadMap(){
            TabObjectsMap.home({page:0, size: 100}, onSuccessMap, onErrorMap);
        }

        var boundsArray = [];

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if(!lat || !lng || lat === "null" || lng === "null"){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if(!lat || !lng || lat === "null" || lng === "null"){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccessMap(result, headers) {
            Array.prototype.push.apply(resUntracked, result);
            if (headers('Link') && headers('Link').includes("rel=\"next\"")) {
                var nextPage = resUntracked.length / 100;
                TabObjectsMap.home({page: nextPage, size: 100}, onSuccessMap, onErrorMap);
            } else {
                resUntracked.forEach(function (object) {
                    var coord = getCoordinate(object);
                    if(coord !== null) {
                        var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                        if(angular.isNumber(lati) && angular.isNumber(lngi)) {
                            vm.locations.push({lat: lati, lng: lngi});
                            vm.icons.push(ObjectMap.getMarkerIconHome(object.objectTracked));
                            vm.labels.push(object.objectName);
                        }
                    }
                });
                // solo quando ha finito tutti gli untracked, carica gli online
                TabObjectsMap.homeOnline(body, onSuccessMapOn, onErrorMapOn);
            }
        }

        function onErrorMap() {
        }

        var body = {
            page: 0,
            size: 100
        };
        var res = [];
        function onSuccessMapOn(result, headers) {
            Array.prototype.push.apply(res,result)
            if (headers('Link').includes("rel=\"next\"")) {
                body.page++;
                TabObjectsMap.homeOnline(body, onSuccessMapOn, onErrorMapOn);
            } else compileMap(res);
        }

        function compileMap(result) {
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if(coord !== null) {
                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIconHome(object.objectTracked));
                        vm.labels.push(object.objectName);
                    }
                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIconHome(object.objectTracked)})
                    //     .bindPopup("<span>Object: </span>" + object.objectName + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            // markersLayer.addTo(map);
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }

        function onErrorMapOn() {
        }

        load();

        function load() {
            Context.query(
                {
                    page: 0,
                    size: 100
                }, function (result, headers) {

                vm.domains = result;
                vm.selectDomains = result;
                vm.domains.forEach(function (d) {
                    d.users = Team.usersDomain({
                        id: d.id,
                        page: 0,
                        size: 100
                    });
                    d.fleets = TabFleets.domains({
                        id: d.id,
                        page: 0,
                        size: 100
                    });
                });
                vm.fleets = TabFleets.users(function (fl) {
                    fl.forEach(function (f) {
                        var page = {
                            id: f.id,
                            query: '',
                            onlyUpdate: false,
                            onlyOnline: false,
                            page: 0,
                            size: 1000
                        };
                        ListObjAndObjType.query(page, onSuccess, onError);

                        function onSuccess(data, headers){
                            $scope.labelsFleets.push(f.fleetName);
                            $scope.seriesFleets.push(f.fleetName);
                            $scope.dataFleets.push(data.tabObjectsList.length);
                        }

                        function onError(){

                        }


                    });
                });
                vm.selectFleet = vm.fleets;
                TabObjectsDashboard.stat(onSuccessDash);

                function onSuccessDash(count) {
                    vm.objectCounting.online = count[0];
                    vm.objectCounting.offline = count[1];
                    vm.objectCounting.warning = count[2];
                    renderChart();

                }

                TabObjectsDashboard.trend(onSuccessTrend);

                function onSuccessTrend(data) {
                    vm.trend = data;
                    vm.onlineTrendPrecentage = ((vm.objectCounting.online - vm.trend[0]) / (vm.trend[0] === 0 ? 1 : vm.trend[0]) * 100).toFixed(0);
                    vm.offlineTrendPrecentage = (((vm.trend[2] - vm.trend[3]) - vm.trend[1]) / ((vm.trend[1] + vm.trend[3]) === 0 ? 1 : (vm.trend[1] + vm.trend[3])) * 100).toFixed(0);
                    vm.warningsTrendPercentage = (((vm.trend[5] - vm.trend[6]) - vm.trend[4]) / ((vm.trend[4] + vm.trend[6]) === 0 ? 1 : (vm.trend[4] + vm.trend[6])) * 100).toFixed(0);
                }

                TabObjectsDashboard.graph(onSuccessGraph);

                function onSuccessGraph(data) {
                    var points = data;
                    points[points.length] = vm.objectCounting.online;

                    new Chart(document.getElementById("line-chart"), {
                        type: 'line',
                        data: {
                            labels: points,
                            datasets: [{
                                data: points,
                                backgroundColor: 'rgba(135, 206, 250, 0.2)',
                                pointRadius: 0,
                                lineTension: 0
                            }]
                        },
                        options: {
                            scales: {
                                xAxes: [{
                                    display: false
                                }],
                                yAxes: [{
                                    display: false,
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                            }
                        }

                    });
                }
            });
        }

        $scope.options = {
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        function addDomains(domain,user,val) {
            if(val) {
                if(!vm.domainsUser[domain])
                    vm.domainsUser[domain] = [];
                TabDomains.byUserLogin({login:user.login}, function (result, headers) {
                    vm.domainsUser[domain][user.id] = result;
                });

            }
            if(!vm.domainUser[domain])
                vm.domainUser[domain] = [];
            vm.domainUser[domain][user.id] = val;
            if(!vm.domainUserAdd[domain])
                vm.domainUserAdd[domain] = [];
            vm.domainUserAdd[domain][user.id] = val;
        }

        function saveAddDomains(domain,user) {
            user = User.get({login:user.login}, function(res){
                var user = res;
                user.domains = vm.domainsUser[domain][user.id];
                User.update(user, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    vm.domainUser[domain][user.id] = false;
                    vm.domainUserAdd[domain][user.id] = false;
                    load();
                }

                function onSaveError() {
                }
            });

        }

        function moveDomains(domain,index,val) {
            if(!vm.domainUser[domain.id])
                vm.domainUser[domain.id] = [];
            vm.domainUser[domain.id][index] = val;
            if(!vm.domainUserMove[domain.id])
                vm.domainUserMove[domain.id] = [];
            vm.domainUserMove[domain.id][index] = val;
            if(!vm.userAddDomains[domain.id])
                vm.userAddDomains[domain.id] = [];
            vm.userAddDomains[domain.id][index] = domain;
        }

        function saveMoveDomains(domain,user) {
            user = User.get({login:user.login}, function(res){
                var user = res;
                var i = 0;
                user.domains.forEach(function (d) {
                    if(d.id == domain.id) {
                        user.domains.splice(i, 1);
                    } else {
                        i++;
                    }
                });
                user.domains.push(vm.userAddDomains[domain.id][user.id]);
                User.update(user, onSaveSuccess, onSaveError);
                function onSaveSuccess(result) {
                    vm.domainUser[domain.id][user.id] = false;
                    vm.domainUserMove[domain.id][user.id] = false;
                    load();
                }

                function onSaveError() {
                }
            });

        }

        function moveFleetsDomain(fleet,domain,val) {
            if(!vm.fleetDomain[fleet.id])
                vm.fleetDomain[fleet.id] = [];
            vm.fleetDomain[fleet.id][domain.id] = val;
            if(!vm.fleetAddDomains[fleet.id])
                vm.fleetAddDomains[fleet.id] = [];
            vm.fleetAddDomains[fleet.id][domain.id] = domain;
        }

        function saveMoveFleetsDomain(fleet,domain) {
            TabFleets.get({id:fleet.id}, function (fl) {
                var fleetToUpdate = fl;
                fleetToUpdate.domains = vm.fleetAddDomains[fleet.id][domain.id];
                fleetToUpdate.users = [];
                TabFleets.update(fleetToUpdate, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    vm.fleetDomain[fleet.id][domain.id] = false;
                    load();
                }
                function onSaveError() {}
            });
        }

        function renderChart() {
            $scope.dataStatus[0]=(vm.objectCounting.online);
            $scope.labelStatus[0]=("online");
            $scope.colorStatus[0]=('#26C281');
            $scope.dataStatus[1]= (vm.objectCounting.offline);
            $scope.labelStatus[1]=("offline");
            $scope.colorStatus[1]=('#E43A45');
            $scope.dataStatus[2]=(vm.objectCounting.warning);
            $scope.labelStatus[2]=("warnings");
            $scope.colorStatus[2]=('#F3C200');
        }

        vm.trendFormatter = function (number) {
            (number > -0.5 && number <= 0) ? number = 0 : number;
            return number > 0 ? number.length > 3 ? (number/1000).toFixed(1) + "k" : number : number.length > 4 ? (number/1000).toFixed(1) + "k" : number;
        };

        function initMap() {
            var markers = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon}).bindPopup("<span>Object: </span>" + title + "</span>");
                marker.addTo(markers);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markers.addTo(map);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'global.menu.home'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/components/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('tabFleets');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$sessionStorage', '$timeout', 'Auth', 'Principal'];

    function LoginController($rootScope, $state, $sessionStorage, $timeout, Auth, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.view = 'login';

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function requestReset() {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
                vm.resetAccount.email = "";
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }

        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                // $uibModalInstance.close();

                // Principal.identity(true).then(function (account) {
                //     if (account.authorities.length == 1)
                //         $state.go('tab-objects-dashboard');
                //     else
                //         $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                // });

                Principal.identity(true).then(function (account) {
                    $state.go('tab-objects-dashboard');
                });

                // if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                //     $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                // }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                // if ($sessionStorage.previousStateName) {
                //     var previousStateName = $sessionStorage.previousStateName;
                //     var previousStateParams = $sessionStorage.previousStateParams;
                //     delete $sessionStorage.previousStateName;
                //     delete $sessionStorage.previousStateParams;
                //     $state.go(previousStateName, previousStateParams);
                // }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'site',
            data: {
                authorities: []
            },
            templateUrl: 'app/components/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$state', 'User'];

    function ContactUsController($state, User) {
        var vm = this;

        vm.form = true;
        vm.contact = [];

        vm.contactUs = function (){

            var body = {
                email: vm.contact.email,
                name: vm.contact.name,
                message: vm.contact.message
            };

            User.sendHelpMail(body, onSuccess, onError);

            function onSuccess(){
                vm.form = false;
            }

            function onError(){}
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('OTPCodeController', OTPCodeController);

    OTPCodeController.$inject = ['$http', 'User', '$state', 'AlertService', 'Principal','$localStorage'];

    function OTPCodeController($http, User, $state, AlertService, Principal,$localStorage) {
        var vm = this;

        vm.userOtp = null;
        vm.otpError = false;
        var rememberMe = $localStorage.rememberMe;

        Principal.identity().then(function (account) {
            vm.twoFactorEmail = copyNotification(account);
        });

        var copyNotification = function (account) {
            return account.notification.twoFactorEmail;
        };

        function createOtp() {
            User.createOTP();
        }

        vm.checkOtp = function () {

            var body = 'otp=' + encodeURIComponent(vm.userOtp) +
            '&remember-me=' + rememberMe;
            $http.post('api/check-otp', body, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function () {
                delete $localStorage.rememberMe;
                Principal.identity(true).then(function () {
                    $state.go('tab-objects-dashboard');
                });
            }).error(function () {
                vm.otpError = true;
            });

        };

        vm.sendNew = function () {
            createOtp();
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('otp-code', {
                parent: 'site',
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/otp-code.html',
                controller: 'OTPCodeController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            })
            .state('contact-us', {
                parent: 'site',
                cache:false,
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/contact.html',
                controller: 'ContactUsController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContactUsControllerPrivacy', ContactUsControllerPrivacy);

    ContactUsControllerPrivacy.$inject = ['$state', 'User'];

    function ContactUsControllerPrivacy($state, User) {
        var vm = this;

        vm.form = true;
        vm.contact = [];

        vm.contactUs = function (){

            var body = {
                email: vm.contact.email,
                name: vm.contact.name,
                message: vm.contact.message
            };

            User.sendPrivacyMail(body, onSuccess, onError);

            function onSuccess(){
                vm.form = false;
            }

            function onError(){}
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ModalTermsController', ModalTermsController);

    ModalTermsController.$inject = ['$uibModalInstance', 'privacy', 'terms', '$scope', '$window'];

    function ModalTermsController($uibModalInstance, privacy, terms, $scope, $window) {
        var vm = this;
        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";

        vm.dismissModal = function () {
            vm.result = {
                privacy: privacy,
                terms: terms
            }
            $uibModalInstance.close(vm.result);
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            terms = true;
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            privacy = true;
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('RegisterPageController', RegisterPageController);

    RegisterPageController.$inject = ['User', "$state", "AlertService", '$window', '$uibModal'];

    function RegisterPageController(User, $state, AlertService, $window, $uibModal) {
        var vm = this;
        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";
        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;

        vm.save = function () {
            User.create(vm.user, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                AlertService.success("Domain and User Created, check your email");
                $state.go("login")
            }

            function onSaveError(error) {
                console.log(error)
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
        };

        vm.openModal = function (){
            if (!vm.checkPrivacy || !vm.checkTerms) {
                document.getElementById("field_check1").checked = false;
                $uibModal.open({
                    templateUrl: 'app/components/register-page/privacy-terms-modal.html',
                    controller: 'ModalTermsController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                        privacy: function (){
                            return vm.checkPrivacy;
                        },
                        terms: function (){
                            return vm.checkTerms;
                        }
                    },
                }).result.then(function(result){
                    vm.checkPrivacy = result.privacy;
                    vm.checkTerms = result.terms;
                })
            }

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('register-page', {
                parent: 'site',
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/register-page/register-page.html',
                controller: 'RegisterPageController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('contact-us-privacy', {
                parent: 'site',
                cache:false,
                data: {
                    authorities: []
                },
                templateUrl: 'app/components/otp/contact.html',
                controller: 'ContactUsControllerPrivacy',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TermsConditionsController', TermsConditionsController);

    TermsConditionsController.$inject = ['$state', '$uibModalInstance', '$window', 'User', 'AlertService'];

    function TermsConditionsController($state, $uibModalInstance, $window, User, AlertService) {
        var vm = this;

        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";

        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;
        vm.disabled = true;
        vm.checkDisabled = "Please view both links";

        vm.save = function () {
            $uibModalInstance.close();

            User.setTerms(vm.updateCheck, onSuccess, onError);

            function onSuccess(data, headers) {
                $uibModalInstance.close();
            }

            function onError() {
                $state.reload();
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('jotApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .filter('beautifyCommand', beautifyCommand);

    function beautifyCommand() {
        return beautifyCommandFilter;

        function beautifyCommandFilter(input) {
            if (!input) {
                return '';
            }
            return input.replace(/_/g, " ");


        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('columnToHide', columnToHide);

    function columnToHide($compile) {
        var directive = {
            restrict: 'A',
            scope: false,
            compile : compileFunc
        };

        return directive;

        function compileFunc(scope, element, attrs, parentCtrl) {
            $('tr[column-to-hide]').each(function (index, vaue) {
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show',true);
            });
            $('th[column-to-hide]').each(function (index, vaue) {
                var name = $(this).attr('column-to-hide');
                var storageName = $('ul[hide-column-menu]').attr('hide-column-menu');
                var visibilityCondition = $(this).attr('ng-if') == null ? true : $(this).attr('ng-if');
                $('ul[hide-column-menu]').append('<li ng-if="' + visibilityCondition + '" hide-column-by="' + storageName + '.' + name + '"><input type="checkbox" id="' + name + '"><span class="fake-checkbox"><span class="glyphicon glyphicon-ok"></span></span><span>' + name + '</span></input></li>');
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show', '!vm.hide.' + name);
            });
            $('td[column-to-hide]').each(function (index, vaue) {
                var name = $(this).attr('column-to-hide');
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show', '!vm.hide.' + name);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('hideColumnBy', hideColumnBy);

    function hideColumnBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^hideColumn',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            $(element[0].firstChild).on('click', function(event) {
                var $target = $( event.currentTarget );
                parentCtrl.checkCheckbox($target);
            });
            $(element).on('click', function(event){
                var $target = $( event.currentTarget ),
                    $inp = $target.find( 'input' );
                var storage = event.currentTarget.attributes[0].value.split('.')[0];
                parentCtrl.checkCheckbox($inp);
                parentCtrl.changeVisibility(storage, event.currentTarget.innerText);
                event.stopPropagation();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('hideColumn', hideColumn);

    function hideColumn () {
        var directive = {
            restrict: 'A',
            scope: {
                hide: '=hideColumn',
                callback: '&'
            },
            controller: HideColumnController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    HideColumnController.$inject = ['$scope', '$element'];

    function HideColumnController ($scope, $element) {
        var vm = this;

        vm.checkCheckbox = checkCheckbox;
        vm.changeVisibility = changeVisibility;

        function checkCheckbox(inp) {

            if (  inp.prop( 'checked') ) {
                inp.prop( 'checked', false );
            } else {
                inp.prop( 'checked', true );
            }
        }

        function changeVisibility(storageName, field) {
            var hideFields = JSON.parse(localStorage.getItem(storageName));
            if(hideFields == null)
                hideFields = [];
            if(hideFields.indexOf(field) > -1)
                hideFields.splice(hideFields.indexOf(field), 1);
            else
                hideFields.push(field);
            localStorage.setItem(storageName, JSON.stringify(hideFields));
            vm.hide[field] = !vm.hide[field];
            $scope.$apply();
        }

    }
})();
;
(function () {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
        'Showing {{(($ctrl.page-1) * $ctrl.limit)==0 ? 1:(($ctrl.page-1) * $ctrl.limit)}} - ' +
        '{{($ctrl.page * $ctrl.limit) < $ctrl.queryCount ? ($ctrl.page * $ctrl.limit) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            limit: '<'
        }
    };

    angular
        .module('jotApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('multiSortBy', multiSortBy);

    function multiSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^multiSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.multiSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('multiSort', multiSort);

    function multiSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicates: '=multiSort',
                callback: '&'
            },
            controller: MultiSortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    MultiSortController.$inject = ['$scope', '$element'];

    function MultiSortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watch('vm.predicates', vm.triggerApply, true);
        vm.triggerApply();

        function applyClass (element, sortField) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = '',
                add = '';
            if(vm.predicates[sortField] == null){
                remove = sortAsc + ' ' + sortDesc;
                add = sortIcon;
                delete vm.predicates[sortField];
            }else if (!vm.predicates[sortField]) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            } else if(vm.predicates[sortField]) {
                remove = sortIcon + ' ' + sortDesc;
                add = sortAsc;
            }
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {

            if( vm.predicates && vm.predicates[field] != null){
                if(vm.predicates[field]) {
                    vm.predicates[field] = ! vm.predicates[field];
                } else{
                    vm.predicates[field] = null;
                }
            } else {
                vm.predicates[field] = true;
            }
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            var keys = Object.keys(vm.predicates);
            if (keys.length > 0 && values && values[0] !== '_score') {
                for(var key in keys) {
                    vm.applyClass($element.find('th[multi-sort-by=\'' + keys[key] + '\']'), keys[key]);
                }
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .filter('nullable', nullable);

    function nullable() {
        return nullableFilter;

        function nullableFilter(input, replace, empty) {
            if (replace === null || replace === undefined) {
                replace = '';
            }
            if (input === null || input === undefined || (empty && input === '')) {
                return replace;
            }
            return input;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('jotApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }

            return input;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$state', 'Principal' ];

    function MainController($state, Principal) {
        var vm = this;
        vm.licence = null;
        getDomainName();

        function getDomainName() {
            Principal.identity().then(function(data) {
                vm.licence = data.context.licence.name;
            }, function(reason) {
                console.log('Couldn\'t get License name');
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AppCtrl', AppCtrl);
    AppCtrl.$inject = ['$scope', '$translate', '$localStorage', '$window'];
    function AppCtrl($scope, $translate, $localStorage, $window) {

        // add 'ie' classes to html
        var isIE = !!navigator.userAgent.match(/MSIE/i);
        isIE && angular.element($window.document.body).addClass('ie');
        isSmartDevice($window) && angular.element($window.document.body).addClass('smart');

        // config
        $scope.app = {
            name: 'Angulr',
            version: '2.0.1',
            // for chart colors
            color: {
                primary: '#23b7e5',
                info: '#23b7e5',
                success: '#27c24c',
                warning: '#fad733',
                danger: '#f05050',
                light: '#e8eff0',
                dark: '#3a3f51',
                black: '#1c2b36'
            },
            settings: {
                themeID: 1,
                navbarHeaderColor: 'bg-black',
                navbarCollapseColor: 'bg-white-only',
                asideColor: 'bg-black',
                headerFixed: true,
                asideFixed: false,
                asideFolded: false,
                asideDock: false,
                container: false
            }
        };

        // save settings to local storage
        if (angular.isDefined($localStorage.settings)) {
            $scope.app.settings = $localStorage.settings;
        } else {
            $localStorage.settings = $scope.app.settings;
        }
        $scope.$watch('app.settings', function () {
            if ($scope.app.settings.asideDock && $scope.app.settings.asideFixed) {
                // aside dock and fixed must set the header fixed.
                $scope.app.settings.headerFixed = true;
            }
            // save to local storage
            $localStorage.settings = $scope.app.settings;
        }, true);

        // angular translate
        $scope.lang = {isopen: false};
        $scope.langs = {en: 'English', de_DE: 'German', it_IT: 'Italian'};
        $scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
        $scope.setLang = function (langKey, $event) {
            // set the current lang
            $scope.selectLang = $scope.langs[langKey];
            // You can change the language during runtime
            $translate.use(langKey);
            $scope.lang.isopen = !$scope.lang.isopen;
        };

        function isSmartDevice($window) {
            // Adapted from http://www.detectmobilebrowsers.com
            var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
            // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
            return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
        }

    }
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("jotApp")
        .constant("DASHBOARD_TYPE", {
            KIBANA: 0,
            GRAFANA: 1
        })
        .constant("DASHBOARD_PLACEHOLDER", {
            KIBANA: {
                fleet: "fleetId",
                domain: "domainId",
                objectType: "objectType",
                objectUniqueCode: "objectUniqueCode",
                detail: "detail",
                level: "level"

            },
            GRAFANA: {
                domainId: "domainId",
                fleetId: "fleetId",
                objectType: "objectType",
                objectUniqueCode: "objectUniqueCode",
                warningCategory: "warningCategory",
                warningName: "warningName",
                level: "level"
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = [];

    function DashboardController() {
        var vm = this;
        vm.applyFilter = applyFilter;

        vm.fleet = {};
        vm.objectType = {};

        function applyFilter(fleet, objectType) {
            vm.fleet = fleet;
            vm.objectType = objectType;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Geolocalization', Geolocalization);

    Geolocalization.$inject = ['$timeout'];

    var markers = [];

    function Geolocalization($timeout) {

        var map,
            latlng,
            geocoder,
            myOption,
            addressInput,
            marker;

        var service = {
            initializeGoogleMap: initializeGoogleMaps,
            geocodeFromAddress: geocodeFromAddress,
            reverseGeocode: reverseGeocode,
            addMarkerFromAddress: addMarkerFromAddress,
            clearMarkers: clearMarkers
        };


        return service;

        function initializeGoogleMaps(tabObjects, scope) {
            latlng = new google.maps.LatLng(45.4675, 9.18560);
            geocoder = new google.maps.Geocoder();
            myOption = {
                zoom: 15,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP

            };
            map = new google.maps.Map(document.getElementById("map_canvas"), myOption);
            // google.maps.event.addListener(map, "click", function (event) {
            //     if (!marker)
            //         marker = new google.maps.Marker({
            //             map: map,
            //             position: latlng,
            //             draggable: true,
            //             title: document.getElementById("field_objectName").value
            //         });
            //     else
            //         marker.setPosition(event.latLng);
            //     getAddressFromMarkerPosition(marker, tabObjects, scope);
            // });

            google.maps.event.addListener(map, "click", function (evt) {
                if (markers.length > 0) {
                    markers[0].setPosition(evt.latLng);
                    addMarkerFromAddress(evt.latLng, tabObjects, scope);
                } else {
                    addMarkerFromAddress(evt.latLng, tabObjects, scope);
                }
            });
            reverseGeocode(tabObjects, scope);

        }

        function geocodeFromAddress(tabObjects, scope) {
            addressInput = (tabObjects.objectLocation);
            if (addressInput != null || addressInput != "") {
                geocoder.geocode({'address': addressInput}, function (result, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var latlng = result[0].geometry.location;
                        tabObjects.objectLatitude = latlng.lat();
                        tabObjects.objectLongitude = latlng.lng();
                        addMarkerFromAddress(latlng, tabObjects, scope);
                    }
                });
            }

        }

        function reverseGeocode(tabObjects, scope) {
            var lat = tabObjects.objectLatitude;
            var lng = tabObjects.objectLongitude;

            if(lat === null && lng === null){
                lat = tabObjects.fieldLatitude;
                lng = tabObjects.fieldLongitude;
            }

            if (angular.isDefined(lat) && angular.isDefined(lng)) {
                var latlng = new google.maps.LatLng(lat, lng);
                geocoder.geocode({"latLng": latlng}, function (result, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (result[0]) {
                            tabObjects.objectLocation = (result[0].formatted_address);
                            addMarkerFromAddress(latlng, tabObjects, scope);
                        }
                    }
                });
            } else {
                geocodeFromAddress(tabObjects);
            }
        }

        function addMarkerFromAddress(latlng, tabObjects, scope) {
            clearMarkers();

            map.setCenter(latlng);
            marker = new google.maps.Marker({
                map: map,
                position: latlng,
                draggable: true,
                title: document.getElementById("field_objectName").value
            });

            var infoWindow = new google.maps.InfoWindow();
            google.maps.event.addListener(marker, "click", function (evt) {
                infoWindow.setContent(this.get("title"));
                infoWindow.open(map, this);
            });


            //marker listener for dragend event in the map
            marker.addListener("dragend", function (event) {
                getAddressFromMarkerPosition(marker, tabObjects, scope);
            });
            getAddressFromMarkerPosition(marker, tabObjects, scope);
            markers.push(marker);
        }

        function getAddressFromMarkerPosition(marker, tabObjects, scope) {
            tabObjects.objectLatitude = marker.position.lat();
            tabObjects.objectLongitude = marker.position.lng();

            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            geocoder.geocode({"latLng": latlng}, function (result, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (result[0]) {
                        tabObjects.objectLocation = (result[0].formatted_address);
                    }
                }
            });
            if (!scope.$$phase) scope.$apply();
        }

        function clearMarkers() {
            for (var i = markers.length - 1; i >= 0; i--) {
                markers[i].setMap(null);
                markers.splice(i, 1);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('ObjectMap', ObjectMap);

    ObjectMap.$inject = [];

    function ObjectMap() {


        var greenIcon = L.icon({
            iconUrl: 'content/images/green-marker.svg',
            iconSize: [38, 95]
        });
        var yellowIcon = L.icon({
            iconUrl: 'content/images/yellow-marker.svg',
            iconSize: [38, 95]
        });
        var orangeIcon = L.icon({
            iconUrl: 'content/images/orange-marker.svg',
            iconSize: [38, 95]
        });
        var redIcon = L.icon({
            iconUrl: 'content/images/red-marker.svg',
            iconSize: [38, 95]
        });
        var greyIcon = L.icon({
            iconUrl: 'content/images/grey-marker.svg',
            iconSize: [38, 95]
        });

        var service = {
            build:build,
            getMarkerIcon: getMarkerIcon,
            getMarkerIconHome: getMarkerIconHome
        };


        return service;

        function build(mapName){
            return L.map(mapName);
        }

        function getMarkerIcon(status, level) {
            if (!status)
                return greyIcon;
            if (level == 0)
                return greenIcon;
            if (level >= 1 && level < 4)
                return yellowIcon;
            if (level >= 4 && level < 10)
                return orangeIcon;
            else
                return redIcon;
        }

        function getMarkerIconHome(status) {
            if (!status)
                return redIcon;
            else
                return greenIcon;
        }

    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PerformancesController', PerformancesController);

    PerformancesController.$inject = ['$scope', 'Principal', '$sce', '$window'];

    function PerformancesController($scope, Principal, $sce, $window) {
        var vm = this;
        // vm.domain = domain;
        vm.grafanaUrl = "";
        vm.selectOne = selectOne;

        if (Principal.isAuthenticated()) {
            // selectOne(vm.domain);
        }

        function selectOne(domain) {
            var fleets = domain.fleets.map(function (f) {
                return f.id;
            });
            vm.grafanaUrl = domain.url.replace("-domainId-", domain.id).replace("-fleetsArray-", fleets.join("&var-fleets="));
            resizeFrame();
            angular.element($window).bind('resize', resizeFrame);
        }

        function resizeFrame() {
            var offsetY = 110;
            var pageHeight = $window.innerHeight;
            pageHeight = pageHeight > 600 ? pageHeight - offsetY : 600;
            var sizeX = Math.round((pageHeight / 100));
            vm.frameHeight = pageHeight; //(pageHeight - (pageHeight % 100));
            //var grafanaUrl = "http://192.169.0.1:3000/dashboard/db/jot_" + fleetId + "_" + objTypeId + "?var-object=" + objCode + "&kiosk"; //&panelId=3&fullscreen"
            vm.grafanaTrusted = $sce.trustAsResourceUrl(vm.grafanaUrl);
            if (!$scope.$$phase)
                $scope.$apply();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('old-performances', {
            parent: 'dashboard',
            url: '/performances',
            data: {
                authorities: []
            },
            views: {
                'content@main': {
                    templateUrl: 'app/performances/performances.html',
                    controller: 'PerformancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('performances');
                    return $translate.refresh();
                }]
                // domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                //     var deferred = $q.defer();
                //     Principal.identity().then(function (account) {
                //         deferred.resolve(TabDomains.get({id: account.context.id}));
                //     });
                //     return deferred.promise;
                //
                //
                // }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PerformanceController', PerformanceController);

    PerformanceController.$inject = ['pagingParams', '$state'];

    function PerformanceController(pagingParams, $state) {

        var vm = this;
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedFleets=[];
        vm.selectedCondition = {};
        vm.transition = transition;
        vm.applyFilter = applyFilter;

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            }
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            vm.transition();
        }

        function transition(notify) {
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id
            }, {notify: false, location: "replace"});
        }

    }
})();


;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('performance', {
                parent: 'dashboard',
                url: '/performance?fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.performance.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/performance/performance.html',
                        controller: 'PerformanceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        fleetName: true
                    },
                    objectType:{
                        value: '-1',
                        squash: true
                    }
                },

                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('performance');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardDetailController', TabObjectsDashboardDetailController);

    TabObjectsDashboardDetailController.$inject = ['$state', 'entity', 'fleetId', 'objTypeId', '$scope', 'warningDetail', '$rootScope'];

    function TabObjectsDashboardDetailController($state, entity, fleetId, objTypeId, $scope, warningDetail, $rootScope) {
        var vm = this;
        vm.tabObjects = entity;
        vm.grafanaUrl = "";
        vm.frameHeight = 0;
        vm.fleet = {};
        vm.tabObjects.$promise.then(function (res) {
            vm.dashboardType = "techObjectFrame" + res.objectType.objectTypeName.replace(".","");
        });
        vm.objectType = {};
        vm.fleet.id = fleetId;
        vm.objectType.id = objTypeId;
        vm.oldURL = document.baseURI;
        vm.columnChoose = { from: 'now-1h', to: 'now', display: 'Last 1 hour', setDate:function(){setHoursLess(1)}};
        vm.toDate = vm.columnChoose.to;
        vm.fromDate = vm.columnChoose.from;
        vm.toCalendarDate = null;
        vm.fromCalendarDate = null;
        vm.dashboardRange = vm.columnChoose.display;
        vm.warningDetail = warningDetail;
        vm.nextBtnDisabled = 0;
        vm.prevBtnDisabled = false;
        vm.isCustomTimeRange = false;
        vm.licence = $rootScope.licence;

        if (warningDetail.warningName !== '') {
            vm.fromDate = vm.warningDetail.warningDateFrom;
            vm.toDate = vm.warningDetail.warningDateTo;
            vm.dashboardRange = vm.fromDate + " to " + vm.toDate;
        }

        vm.rangeOptions = [
            {
                column1 : { from: 'now/d',    to: 'now/d',    display: 'Today', setDate: function () {setDayLess()}},
                column2 : { from: 'now-2d',   to: 'now',      display: 'Last 2 days', setDate: function () {setDaysLess(2)}},
                column3 : { from: 'now-1h',   to: 'now',      display: 'Last 1 hour', setDate:function(){setHoursLess(1)}},
                column4 : { from: 'now-5m',   to: 'now',      display: 'Last 5 minutes', setDate:function(){setMinutesLess(5)}}
            },
            {
                column1 : { from: 'now-7d/d', to: 'now-7d/d', display: 'This day last week', setDate: function () {setWeekDayLess()}},
                column2 : { from: 'now-7d',   to: 'now',      display: 'Last 7 days', setDate: function () {setDaysLess(7)}},
                column3 : { from: 'now-3h',   to: 'now',      display: 'Last 3 hours', setDate:function(){setHoursLess(3)}},
                column4 : { from: 'now-15m',  to: 'now',      display: 'Last 15 minutes', setDate:function(){setMinutesLess(15)}}
            },
            {
                column1 : { from: 'now/w',    to: 'now/w',    display: 'This week', setDate: function (){setWeekLess()}},
                column2 : { from: 'now-15d',   to: 'now',      display: 'Last 15 days', setDate: function () {setDaysLess(15)}},
                column3 : { from: 'now-6h',   to: 'now',      display: 'Last 6 hours', setDate:function(){setHoursLess(6)}},
                column4 : { from: 'now-30m',  to: 'now',      display: 'Last 30 minutes', setDate:function(){setMinutesLess(30)}}
            },
            {
                column1 : { from: 'now/M',    to: 'now/M',    display: 'This month', setDate: function () {setMonthLess()}},
                column2 : { from: 'now-30d',  to: 'now',      display: 'Last 30 days', setDate: function () {setDaysLess(30)}},
                column3 : { from: 'now-12h',  to: 'now',      display: 'Last 12 hours', setDate:function(){setHoursLess(12)}},
                column4 : { from: 'now-24h',  to: 'now',      display: 'Last 24 hours', setDate:function(){setHoursLess(24)}},
            },
            {
                column1: {from: '', to: '', display: ''},
                column2: {from: '', to: '', display: ''},
                column3: {from: '', to: '', display: ''},
                column4: {from: '', to: '', display: ''}
            }

        ];

        vm.isOpen = false;

        vm.fromDateOptions = {
            minDate: null,
            maxDate: new Date()
        };

        vm.toDateOptions = {
            minDate: new Date(),
            maxDate: getTwoWeeks(new Date(), false)
        };

        //Forces the max value of date-range to two weeks; ensures that fromDate is never bigger than toDate to keep date-range integrity
        vm.onChangeFromDate = function () {
            if (vm.fromCalendarDate) {
                vm.toDateOptions.minDate = vm.fromCalendarDate;
                vm.toDateOptions.maxDate = getTwoWeeks(vm.fromCalendarDate, false);

                if (getTwoWeeks(vm.fromCalendarDate, false) <= vm.toCalendarDate) {
                    vm.toCalendarDate = vm.toDateOptions.maxDate;
                }

                if (vm.toCalendarDate == null || vm.fromCalendarDate >= vm.toCalendarDate)
                    vm.toCalendarDate = new Date(vm.fromCalendarDate.getFullYear(), vm.fromCalendarDate.getMonth(), vm.fromCalendarDate.getDate() + 1);
            } else
                vm.fromCalendarDate = vm.today();

        };

        vm.applyFilterDate = function (e) {
            vm.isCustomTimeRange = true;
            vm.isOpen = !vm.isOpen;
            vm.rangeInMillis = 0;
            vm.fromDate = angular.copy(vm.fromCalendarDate);
            vm.toDate = angular.copy(vm.toCalendarDate);
            vm.fromDate.setMilliseconds(0);
            vm.fromDate.setSeconds(0);
            vm.toDate.setMilliseconds(0);
            vm.toDate.setSeconds(0);
            vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            vm.rangeInMillis = Math.abs(vm.fromDate - vm.toDate);
            checkNext();
        };

        function applyDate(from, to) {
            vm.fromDate = from;
            vm.toDate = to;
        }


        // quick range dashboard time, from anything to now
        vm.changeRange = function (column) {
            vm.nextBtnDisabled = 0;
            vm.columnChoose = column
            vm.fromDate = column.from;
            vm.toDate = column.to;
            vm.dashboardRange = column.display;
            vm.isOpen = !vm.isOpen;
            vm.prevBtnDisabled = false;
            vm.isCustomTimeRange = false;
        };

        // Get two weeks before (if "back" flag is set to true) or after the chosen date (if "back" flag is set to false);
        function getTwoWeeks(date, back) {
            if (back)
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 14);
            else
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 14);
        }

        vm.back = function () {
            $state.go('tab-objects-dashboard',{
                firstAccess: false
            }, {notify: true, location: "replace"});
        };

        function setDayLess() {
            var to = new Date();
            var from = new Date();
            to.setHours(23, 59, 59, 999);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 1 * vm.nextBtnDisabled);
            from.setDate(from.getDate() - 1 * vm.nextBtnDisabled);
            applyDate(from, to)
        };

        function setWeekDayLess() {
            var to = new Date();
            var from = new Date();
            to.setHours(23, 59, 59, 999);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 7 * (vm.nextBtnDisabled + 1));
            from.setDate(from.getDate() - 7 * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setDaysLess(date) {
            var to = new Date();
            var from = new Date();
            to.setDate(to.getDate() - date * vm.nextBtnDisabled);
            from.setDate(from.getDate() - date * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };


        function setHoursLess(hour) {
            var to = new Date();
            var from = new Date();
            to.setHours(to.getHours() - hour * vm.nextBtnDisabled);
            from.setHours(from.getHours() - hour * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setMinutesLess(minutes) {
            var to = new Date();
            var from = new Date();
            to.setTime(to.getTime() - 60000 * minutes * vm.nextBtnDisabled);
            from.setTime(from.getTime() - 60000 * minutes * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setWeekLess() {
            var to = new Date();
            var from = new Date();
            from.setDate(from.getDate() - 6 * vm.nextBtnDisabled - from.getDay() - vm.nextBtnDisabled + 1);
            to.setDate(to.getDate() - 6 * vm.nextBtnDisabled - to.getDay() - vm.nextBtnDisabled + 7);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);
            applyDate(from, to)
        }

        function setMonthLess() {
            var to = new Date();
            var from = new Date();
            from.setMonth(from.getMonth() - vm.nextBtnDisabled);
            from.setDate(1);
            to.setMonth(to.getMonth() - vm.nextBtnDisabled + 1);
            to.setDate(0);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);
            applyDate(from, to)
        }

        function customTimeRange(sumOrDiff) {
            var to = angular.copy(vm.toDate);
            var from = angular.copy(vm.fromDate);
            to.setTime(to.getTime() + vm.rangeInMillis * sumOrDiff);
            from.setTime(from.getTime() + vm.rangeInMillis * sumOrDiff);
            applyDate(from, to);
        }

        vm.prev = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.isCustomTimeRange) {
                vm.nextBtnDisabled = vm.nextBtnDisabled + 1;
                vm.columnChoose.setDate();
            } else {
                customTimeRange(-1);
                vm.nextBtnDisabled = 1;
            }
            vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            vm.isOpen = false;
        }

        vm.next = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.isCustomTimeRange) {
                vm.nextBtnDisabled = vm.nextBtnDisabled - 1;
                if (vm.nextBtnDisabled === 0) {
                    vm.changeRange(vm.columnChoose);
                } else {
                    vm.columnChoose.setDate();
                }
            } else {
                customTimeRange(1);
                checkNext();
            }
            if (vm.nextBtnDisabled !== 0 || vm.isCustomTimeRange) {
                vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            }
            vm.isOpen = false;
        }

        function checkNext() {
            var now = new Date();
            vm.nextBtnDisabled = vm.toDate > now ? 0 : 1;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardDialogController', TabObjectsDashboardDialogController);

    TabObjectsDashboardDialogController.$inject = [ '$scope', 'entity', 'TabObjects', '$state', 'Geolocalization', 'TabObjectsConditions'];

    function TabObjectsDashboardDialogController( $scope, entity, TabObjects, $state, Geolocalization, TabObjectsConditions) {

        var vm = this;
        vm.tabObjects = entity;
        vm.timeZone = [];

        //wait for tabObjects before loading gmap
        vm.tabObjects.$promise.then(function () {
            if(vm.tabObjects.condition.name === "in production") {
                vm.tabObjectsConditions = TabObjectsConditions.checkTest({id: vm.tabObjects.id});
            } else {
                vm.tabObjectsConditions = TabObjectsConditions.query();
            }
            Geolocalization.initializeGoogleMap(vm.tabObjects,$scope);
            var timeZoneSelected = {timeZone: vm.tabObjects.objectTimeZone};
            vm.tabObjects.timeZone = timeZoneSelected;
        });

        vm.onChangeCoordsFunction = function() {
            Geolocalization.reverseGeocode(vm.tabObjects,$scope);
        };

        vm.onChangeAddressFunction = function() {
            Geolocalization.geocodeFromAddress(vm.tabObjects,$scope);
        };

        vm.loadAllTimeZone = function() {
            TabObjects.timeZones(onZoneSuccess, onZoneError);

            function onZoneSuccess(data){
                vm.timeZone = [];
                for (var i = 0; i < data.length; i++) {
                    var timeZ = {timeZone: data[i]};
                    vm.timeZone.push(timeZ);
                }
            }

            function onZoneError(){}
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-objects-dashboard');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var timeZ = vm.tabObjects.timeZone;
            vm.tabObjects.objectTimeZone = timeZ.timeZone;
            if (vm.tabObjects.id !== null) {
                TabObjects.updateMetadata(vm.tabObjects, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-objects-dashboard',{
                firstAccess: false
            }, {notify: true, location: "replace"});
        };

        vm.onChangeCoordsFunction = function() {
            Geolocalization.reverseGeocode(vm.tabObjects, $scope);
        };

        vm.onChangeAddressFunction = function() {
            Geolocalization.geocodeFromAddress(vm.tabObjects, $scope);
        };

        vm.loadAllTimeZone();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsMapController', TabObjectsMapController);

    TabObjectsMapController.$inject = ['$state', '$window', 'TabObjectsMap', 'ObjectMap', 'pagingParams'];

    function TabObjectsMapController($state, $window, TabObjectsMap, ObjectMap, pagingParams) {
        var vm = this;
        vm.applyFilter = applyFilter;
        vm.object = [];
        vm.mapStyle = {};
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleets = [];
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedCondition = {};
        vm.oldURL = document.baseURI;
        vm.back = function () {
            window.location.href = vm.oldURL;
        };
        var map = ObjectMap.build("object-map");
        var markersLayer = new L.LayerGroup();
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);
        resizeFrame();

        vm.oldURL = document.baseURI;
        vm.back = function () {
            window.location.href = vm.oldURL;
        };

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        vm.consoleL = [];
        var boundsArray = [];
        var markersCluster = null;

        function loadAll() {
            vm.locations = [];
            vm.icons = [];
            vm.labels = [];
            vm.consoleL = [];
            boundsArray = [];
            var data = {
                fleet: vm.fleet.id,
                objectType: vm.objectType.id
            };
            TabObjectsMap.query(data, onSuccess, onError);
        }

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if(!lat || !lng || lat === "null" || lng === "null"){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if(!lat || !lng || lat === "null" || lng === "null"){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccess(result) {
            markersLayer.clearLayers();
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if (coord !== null) {
                    var consoleLink = '#/dashboards/tab-objects-dashboard/' + object.fleet.id + '/' + object.id + '/' + object.objectType.id;

                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIcon(object.objectTracked, object.level));
                        vm.labels.push({name: object.objectName, warning: object.warnings});
                        vm.consoleL.push(consoleLink);
                    }

                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIcon(object.objectTracked, object.level)})
                    //     .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + object.objectName + "</a><br\><span>Warning: " + object.warnings + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            // markersLayer.addTo(map);
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }

        function onError() {
        }

        function resizeFrame() {
            var offsetY = 140;
            var mapHeight = $window.innerHeight;
            mapHeight = mapHeight > 600 ? mapHeight - offsetY : 600;
            vm.mapStyle.height = mapHeight;
            var sizeX = Math.round((mapHeight / 100));
            // if (!$scope.$$phase)
            //     $scope.$apply();
        }

        function transition(notify) {

            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id
            }, {notify: notify, location: "replace"});
        }

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            }
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            loadAll();
            transition(false);
        }

        function initMap() {
            // rimuovi il cluster precedente dalla mappa se esiste
            if (markersCluster) {
                map.removeLayer(markersCluster);
            }

            markersCluster = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var consoleLink = vm.consoleL[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon})
                    .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + title.name + "</a><br\><span>Warning: " + title.warning + "</span>");
                marker.addTo(markersCluster);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markersCluster.addTo(map);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardController', TabObjectsDashboardController);

    TabObjectsDashboardController.$inject = ['$scope', '$state', '$window','$timeout','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjectsDashboard', 'TabObjects', '$uibModal', 'User', '$rootScope'];

    function TabObjectsDashboardController($scope, $state, $window,$timeout, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjectsDashboard, TabObjects, $uibModal, User, $rootScope) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.filterBy = filterBy;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.applyFilter = applyFilter;
        vm.exportTable = exportTable;
        vm.parseStatus = parseStatus;
        vm.changePageSize = changePageSize;
        vm.exportTableView = exportTableView;
        vm.loadAllToExport = loadAllToExport;
        vm.parseStatusClass = parseStatusClass;
        vm.parseWarningLevel = parseWarningLevel;
        vm.toggleMetricsCheckbox = toggleMetricsCheckbox;

        vm.currentState = "tab-objects-dashboard";
        vm.currentStateFilter = "tab-objects-dashboard-filter";
        vm.fleet = {};
        vm.condition = {};
        vm.objectType = {};
        vm.selectedFleet = {};
        vm.selectedCondition = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.selected = {};
        vm.selectedObjectType.selected = {};
        vm.tabObjects = [];
        vm.selectedFleets = [];
        vm.listFilter = pagingParams.filter;
        vm.charToSearch = pagingParams.search;
        vm.predicates = pagingParams.predicates;
        vm.selectedFleet.id = pagingParams.fleet;
        vm.firstAccess = pagingParams.firstAccess;
        vm.licence = $rootScope.licence;

        vm.filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        vm.filterStatus = "-1";
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);
        if (vm.filter !== null && vm.filter !== "null" && vm.filter !== undefined) {
            vm.filter = JSON.parse(vm.filter);
            if (Object.keys(vm.filter).length > 0) {
                vm.selectedFleet.id = vm.filter.fleet;
                vm.selectedObjectType.id = vm.filter.objectType;
                vm.selectedCondition.name = vm.filter.condition;
                vm.filterUntracked = vm.listFilter == -1 ? "-1" : vm.filter.filterUntracked;
                vm.filterStatus = vm.filter.filterStatus ? vm.filter.filterStatus : "-1";
                vm.filterWip = vm.listFilter == -1 ? "-1" : vm.filter.filterWip;
            }
        } else {
            vm.filter = {};
        }

        vm.hide = pagingParams.hide;
        vm.tabObjectsToExport = [];
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0,
            offlineTracked: 0
        };
        //boolean to set page ready
        vm.pageReady = false;

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        User.checkTerms({}, onSuccessCheck, onErrorCheck);

        function onSuccessCheck() {
        }

        function onErrorCheck() {
            $uibModal.open({
                templateUrl: 'app/components/register-page/terms-conditions.html',
                controller: 'TermsConditionsController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                $state.reload();
            });
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var data = {
                query: vm.charToSearch,
                filter: pagingParams.filter,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                condition: vm.selectedCondition.name,
                filterUntracked: vm.filterUntracked,
                filterStatus: vm.filterStatus,
                filterWip: vm.filterWip,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };


            TabObjectsDashboard.query(data, onSuccess, onError);
            TabObjectsDashboard.stat({
                query: vm.charToSearch,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                condition: vm.selectedCondition.name
            }, onSuccessDash, onError);

            function onSuccessDash(count) {
                vm.objectCounting.online = count[0];
                vm.objectCounting.offline = count[1];
                vm.objectCounting.warning = count[2];
                vm.objectCounting.offlineTracked = count[3];
            }


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabObjects = data;
                vm.page = pagingParams.page;
                vm.listFilter = pagingParams.filter;
                vm.pageReady = true;
                var retrievedHide = JSON.parse(localStorage.getItem('dashboardColumn'));
                vm.hideAndShow();
                if (retrievedHide !== null)
                    for (var hideColumn in retrievedHide) {
                        var id = retrievedHide[hideColumn];
                        if (id === "Metrics" || id === "Fleet" || id === "Type" || id === "Condition") {
                            vm.hide[id] = false;
                            $('#' + id).prop('checked', false);
                        } else {
                            vm.hide[id] = true;
                            $('#' + id).prop('checked', true);
                        }
                    }
                    if (data.length > 0)
                        vm.toggleMetricsCheckbox(vm.tabObjects[0].metricList.length);
                    else vm.toggleMetricsCheckbox(0);

                    if (vm.filter == 'null' || vm.filter == null || vm.filter == undefined)
                        vm.filter = {};
                    vm.filter.filterUntracked = vm.filterUntracked;
                    vm.filter.filterStatus = vm.filterStatus;
                    vm.filter.filterWip = vm.filterWip;
                    localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            data.query = vm.charToSearch;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                hide: vm.hide,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter,
                firstAccess: false
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function parseStatus(obj) {
            return obj.wipStatus > 0 ? "Maintenance" : obj.objectOnline && obj.objectTracked ? "Online" : "Offline";
        }

        function parseStatusClass(obj) {
            return obj.objectOnline && obj.objectTracked ? (obj.wipStatus > 0 ? "text-warning" : "text-online") : obj.objectOnline ? "text-untracked" : "text-danger";
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 0 ? "btn-lv-ok" : level < 3 ? "btn-lv-low" : level < 5 ? "btn-lv-medium" : "btn-lv-high");
        }

        function filterBy(filter) {
            vm.listFilter = filter == vm.listFilter ? -1 : filter;
            vm.transition();
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadAllToExport() {
            var dataExport = {
                page: 0,
                size: 200,
                ch: vm.charToSearch,
                filter: pagingParams.filter
            };

            function onSuccessExport(data, headers) {
                vm.totalItemsExport = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectsToExport.push(data[i]);
                }
                if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                    dataExport.page = dataExport.page + 1;
                    TabObjectsDashboard.query(dataExport, onSuccessExport, onErrorExport);
                }
            }

            function onErrorExport(error) {
                AlertService.error(error.data.message);
            }

            if (vm.tabObjectsToExport.length < 1)
                TabObjectsDashboard.query(dataExport, onSuccessExport, onErrorExport);
        }

        function exportTable(type) {
            if (vm.tabObjectsToExport.length == vm.totalItemsExport) {
                if (type == 'pdf') {
                    $('#tableToExport').tableExport({
                        type: 'pdf',
                        pdfFontSize: '7',
                        escape: 'false',
                        tableName: 'ObjectDashboard'
                    });
                } else if (type != null) {
                    $('#tableToExport').tableExport({
                        type: type,
                        escape: 'false',
                        tableName: 'ObjectDashboard',
                        size: {0: 40, 1: 50, 3: 100, 7: 60}
                    });
                }
                vm.tabObjectsToExport = [];
            } else {
                $timeout(function () {
                    exportTableView(type);
                }, 200)
            }
        }

        function exportTableView(type) {
            var additionalMetric = 10 + vm.tabObjects[0].metricList.length;
            if (type === "pdf")
                $('#tableView').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    ignoreColumn: [additionalMetric],
                    tableName: 'ObjectDashboard',
                    size: {0: 40, 1: 50, 3: 100, 7: 60}
                });
            else
                $('#tableView').tableExport({
                    type: type,
                    escape: 'false',
                    ignoreColumn: [additionalMetric],
                    tableName: 'ObjectDashboard'
                });
        }


        function applyFilter(fleet, objectType, condition) {
            if (fleet && fleet.id) {
                if (fleet.id > 0) {
                    vm.fleet = fleet;
                    vm.filter.fleet = fleet.id;
                } else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                    vm.filter.fleet = -1;
                }
            }
            if (objectType && objectType.id) {
                vm.objectType = objectType;
                vm.filter.objectType = objectType.id;
            } else {
                vm.objectType.id = -1;
            }

            if (vm.filter) {
                if (condition && condition.name) {
                    vm.filter.condition = condition.name;
                } else {
                    vm.filter.condition = "All Conditions";
                }
            }
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
            loadAll();
        }

        function toggleMetricsCheckbox(input) {
            if (input <= 0) {
                // $('li[hide-column-by]')[$('li[hide-column-by]').length-1].setAttribute("style", "display:none");
                $('li[hide-column-by="dashboardColumn.Metrics"]')[0].setAttribute("style", "display: none");
            } else {
                // $('li[hide-column-by]')[$('li[hide-column-by]').length-1].setAttribute("style", "display:block");
                $('li[hide-column-by="dashboardColumn.Metrics"]')[0].setAttribute("style", "display:block");
            }
        }

        var onSaveSuccess = function () {
            loadAll();
        }

        var onSaveError = function () {
        }

        vm.muteStatus = function (object) {
            object.objectMuted = !object.objectMuted;
            TabObjects.updateMute(object, onSaveSuccess, onSaveError);
        }

        vm.showStatus = function (status) {
            if (status)
                return "Mute off";
            else return "Mute on";
        }

        vm.showStatusWrench = function (status) {
            if (status)
                return "Unprocess";
            else return "Process";
        }

        vm.wipStatus = function (object, index) {
            $uibModal.open({
                templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-wip-dialog.html',
                controller: 'WipDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function () {
                        return object;
                    }]
                }
            }).result.then(function () {
                if (vm.filterWip != -1) {
                    vm.tabObjects.splice(index, 1);
                }
            });
        }

        vm.hideAndShow = function () {
            if (vm.firstAccess == true) {
                vm.hide['Metrics'] = true;
                $('#Metrics').prop('checked', true);
                vm.hide['Fleet'] = true;
                $('#Fleet').prop('checked', true);
                vm.hide['Type'] = true;
                $('#Type').prop('checked', true);
                vm.hide['Condition'] = true;
                $('#Condition').prop('checked', true);
                vm.hide['Warnings'] = false;
                $('#Warnings').prop('checked',  false);
                vm.hide['Code'] = false;
                $('#Code').prop('checked', false);
                vm.hide['Name'] = false;
                $('#Name').prop('checked',  false);
                vm.hide['Description'] = false;
                $('#Description').prop('checked', false);
                vm.hide['Notes'] = false;
                $('#Notes').prop('checked',  false);
                vm.hide['LastEvent'] = false;
                $('#LastEvent').prop('checked', false);
            } else {
                $('#Warnings').prop('checked',  vm.hide['Warnings']);
                $('#Code').prop('checked', vm.hide['Code']);
                $('#Name').prop('checked',  vm.hide['Name']);
                $('#Fleet').prop('checked', vm.hide['Fleet']);
                $('#Type').prop('checked',  vm.hide['Type']);
                $('#Condition').prop('checked', vm.hide['Condition']);
                $('#Description').prop('checked', vm.hide['Description']);
                $('#Notes').prop('checked',  vm.hide['Notes']);
                $('#LastEvent').prop('checked', vm.hide['LastEvent']);
                $('#Metrics').prop('checked',  vm.hide['Metrics']);
            }
        }

    }
})();
/*
* angular.element(document.body).injector().get('$translate')('jotApp.tabObjects.warningLevel').then(function(translation) {
    console.log('Traduzione:', translation);
});*/
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectsDashboard', TabObjectsDashboard)
        .factory('TabObjectsMap', TabObjectsMap);

    TabObjectsDashboard.$inject = ['$resource'];

    function TabObjectsDashboard($resource) {
        var resourceUrl = 'api/tab-objects-dashboard';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'stat': {method: 'GET', isArray: true,url:'api/tab-objects-dashboard-stat'},
            'trend' : {method: 'GET', isArray: true, url: 'api/tab-objects-dashboard-trend'},
            'graph' : {method: 'GET', isArray: true, url: 'api/tab-objects-dashboard-graph'}
        });
    }

    TabObjectsMap.$inject = ['$resource'];

    function TabObjectsMap($resource) {
        var resourceUrl = 'api/tab-objects-dashboard-map';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'home': {method: 'GET', isArray: true, url: 'api/home-map'},
            'homeOnline': {method: 'GET', isArray: true, url: 'api/home-map-on'}
        });
    }


})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-objects-dashboard', {
                parent: 'dashboard',
                url: '/tab-objects-dashboard?page&sort&search&fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard.html',
                        controller: 'TabObjectsDashboardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    firstAccess: true,
                    listFilter: '-1',
                    predicates: {},
                    hide: [],
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '',
                        squash: true
                    },
                    condition: {
                        value: '',
                        squash: true
                    },
                    filterUntracked: {
                        value: '-1',
                        squash: true
                    },
                    filterStatus: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            search: $stateParams.search,
                            filter: $stateParams.listFilter,
                            predicates: $stateParams.predicates,
                            hide: $stateParams.hide,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            condition: $stateParams.condition,
                            filterUntracked: $stateParams.filterUntracked,
                            firstAccess: $stateParams.firstAccess
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-dashboard-detail', {
                parent: 'dashboard',
                url: '/tab-objects-dashboard/{fleet}/{id}/{objType}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-detail.html',
                        controller: 'TabObjectsDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: null,
                    fleet: null,
                    objType: null,
                    warningDateFrom: {
                        value: '',
                        squash: true
                    },
                    warningDateTo: {
                        value: '',
                        squash: true
                    },
                    warningName: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    fleetId: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objTypeId: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    warningDetail: ['$stateParams', function ($stateParams) {
                        return {
                            warningDateFrom: $stateParams.warningDateFrom,
                            warningDateTo: $stateParams.warningDateTo,
                            warningName: $stateParams.warningName
                        }
                    }]
                }
            })
            .state('tab-objects-map', {
                parent: 'dashboard',
                url: '/tab-objects-map?fleet&objectType',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.tabObjects.dashboard.map'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-map.html',
                        controller: 'TabObjectsMapController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-dashboard-edit', {
                parent: 'dashboard',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-dialog.html',
                        controller: 'TabObjectsDashboardDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WipDialogController', WipDialogController);

    WipDialogController.$inject = ['$uibModalInstance', 'entity', 'AlertRules'];

    function WipDialogController ($uibModalInstance, entity, AlertRules) {
        var vm = this;

        vm.object = entity;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm () {
            AlertRules.wipAlerts({warning:"all", wip:vm.object.wipStatus, objectUniqueCode:vm.object.objectUniqueCode}, onSuccess, onError);

        }

        function onSuccess() {
            vm.object.wipStatus = vm.object.wipStatus == 0 ? 2 : 0;
            $uibModalInstance.close(true);
        }

        function onError() {

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDashboardDetailController', WarningDashboardDetailController);

    WarningDashboardDetailController.$inject = ['frame', 'titlePage', 'fleetId', 'objectType', 'objectUniqueCode', 'warningCategory', 'warningName', 'detail'];

    function WarningDashboardDetailController(frame, titlePage, fleetId, objectType, objectUniqueCode, warningCategory, warningName, detail) {
        var vm = this;
        vm.frame = frame;
        vm.titlePage = titlePage;
        vm.detail = detail;

        vm.fleetId = fleetId;
        vm.objectType = objectType;
        vm.objectUniqueCode = objectUniqueCode;
        vm.warningCategory = warningCategory;
        vm.warningName = warningName;

        vm.oldURL = document.baseURI;
        vm.back = function() {
            window.location.href=vm.oldURL;
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDashboardController', WarningDashboardController);

    WarningDashboardController.$inject = ['$state', 'TabObjectsDashboard', 'TabObjectsMap', 'pagingParams', 'ObjectMap', 'AlertService', 'WarningsDashboard', 'NgTableParams', 'ngTableEventsChannel', '$scope', '$interval'];

    function WarningDashboardController($state, TabObjectsDashboard, TabObjectsMap, pagingParams, ObjectMap, AlertService, WarningsDashboard, NgTableParams, ngTableEventsChannel, $scope, $interval) {
        var vm = this;
        vm.applyFilter = applyFilter;

        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.filterElastic = pagingParams.filterElastic;
        vm.selectedFleets = [];
        vm.selectedCondition = {};
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0
        };

        vm.object = [];
        vm.mapStyle = {};

        vm.topNamePage = 1;
        vm.topObjectsPage = 1;

        var map = ObjectMap.build("warning-map");
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        vm.consoleL = [];
        var boundsArray = [];

        function loadAll() {
            var data = {
                filter: pagingParams.filter,
                fleet: vm.fleet.id,
                objectType: vm.objectType.id
            };
            TabObjectsMap.query(data, onSuccess, onError);
            TabObjectsDashboard.stat({
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            }, onSuccessDash, onError);

            // Load data
            pollTopName();
            pollTopObjects();

            // Reload data every 20 secs
            vm.namePoll = $interval(pollTopName, 20000);
            vm.objectPoll = $interval(pollTopObjects, 20000);
        }

        function pollTopName() {
            WarningsDashboard.topName(vm.filterElastic, innerOnSuccess, onError);
        }

        function pollTopObjects() {
            WarningsDashboard.topObjects(vm.filterElastic, objectOnSuccess, onError);
        }

        function innerOnSuccess(result) {
            vm.tableNameParams = new NgTableParams({page: vm.topNamePage, count: 10}, {counts: [], dataset: result});
        }

        function objectOnSuccess(result) {
            vm.tableTopParams = new NgTableParams({page: vm.topObjectsPage, count: 10}, {counts: [], dataset: result});
        }

        $scope.$watch('vm.tableNameParams', function (params) {
            // ngTableEventsChannel.onDatasetChanged(function() {
            //         vm.tableNameParams.page(vm.topNamePage);
            // }, $scope, vm.tableNameParams );
            ngTableEventsChannel.onPagesChanged(function () {
                vm.topNamePage = vm.tableNameParams.page();
            }, $scope, vm.tableNameParams);
        });

        $scope.$watch('vm.tableTopParams', function (params) {
            // ngTableEventsChannel.onDatasetChanged(function() {
            //         vm.tableTopParams.page(vm.topObjectsPage);
            // }, $scope, vm.tableTopParams );
            ngTableEventsChannel.onPagesChanged(function () {
                vm.topObjectsPage = vm.tableTopParams.page();
            }, $scope, vm.tableTopParams);
        });

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if((lat === null && lng === null) || (lat === "null" && lng === "null")){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if((lat === "null" && lng === "null")){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccess(result) {
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if (coord !== null && object.level > 0) {
                    var consoleLink = '#/dashboards/tab-objects-dashboard/' + object.fleet.id + '/' + object.id + '/' + object.objectType.id;

                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIcon(object.objectTracked, object.level));
                        vm.labels.push({name: object.objectName, warning: object.warnings});
                        vm.consoleL.push(consoleLink);
                    }

                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIcon(object.objectTracked, object.level)})
                    //     .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + object.objectName + "</a><br\><span>Warning: " + object.warnings + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }


        function onSuccessDash(count) {
            vm.objectCounting.online = count[0];
            vm.objectCounting.offline = count[1];
            vm.objectCounting.warning = count[2];
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $scope.$on('$destroy', function () {
            if (vm.namePoll)
                $interval.cancel(vm.namePoll);
            if (vm.objectPoll)
                $interval.cancel(vm.objectPoll);
        });

        function applyFilter(fleet, objectType) {
            // Fleet
            if(fleet && fleet.id > 0) {
                vm.fleet = fleet;
                vm.filterElastic.fleets = [fleet];          // only selected fleet
            } else {
                vm.fleet = vm.selectedFleets || [];
                vm.filterElastic.fleets = vm.fleet;         // all fleets
            }

            // Object Type
            if (objectType && objectType.id > 0) {
                vm.objectType = objectType;
                vm.filterElastic.objectType = objectType;   // only selected object type
            } else {
                vm.objectType = { id: -1 };
                delete vm.filterElastic.objectType;          // no object type
            }

            loadAll();
            transition(false);
        }


        function transition(notify) {

            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id,
                filterElastic: vm.filterElastic
            }, {notify: notify, location: "replace"});
        }

        function initMap() {
            var markers = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var consoleLink = vm.consoleL[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon})
                    .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + title.name + "</a><br\><span>Warning: " + title.warning + "</span>");
                marker.addTo(markers);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markers.addTo(map);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warning-dashboard', {
                parent: 'dashboard',
                url: '/warning?fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.warning.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warning-dashboard/warning-dashboard.html',
                        controller: 'WarningDashboardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    filterElastic: {
                        value: {status: 'open'},
                        squash: true
                    }
                },

                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            filterElastic: $stateParams.filterElastic
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warning-dashboard-detail', {
                parent: 'entity',
                url: '/warning/{frame}?fleetId&objectType&objectUniqueCode&warningCategory&warningName&detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warning-dashboard/warning-dashboard-detail.html',
                        controller: 'WarningDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    frame: null,
                    titlePage: null,
                    detail: null,

                    fleetId: null,
                    objectType: null,
                    objectUniqueCode: null,
                    warningCategory: null,
                    warningName: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    detail: ['$stateParams', function ($stateParams) {
                        return $stateParams.detail;
                    }],
                    frame: ['$stateParams', function ($stateParams) {
                        return $stateParams.frame;
                    }],
                    titlePage: ['$stateParams', function ($stateParams) {
                        return $stateParams.titlePage;
                    }],
                    fleetId: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleetId;
                    }],
                    objectType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectType;
                    }],
                    objectUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }],
                    warningCategory: ['$stateParams', function ($stateParams) {
                        return $stateParams.warningCategory;
                    }],
                    warningName: ['$stateParams', function ($stateParams) {
                        return $stateParams.warningName;
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SingleWipDialogController', SingleWipDialogController);

    SingleWipDialogController.$inject = ['$uibModalInstance', 'entity', 'AlertRules'];

    function SingleWipDialogController ($uibModalInstance, entity, AlertRules) {
        var vm = this;

        vm.warning = entity;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm () {
            AlertRules.wipAlerts({warning: vm.warning.warningId, wip:vm.warning.wip ? 1 : 0, objectUniqueCode:vm.warning.objectUniqueCode}, onSuccess, onError);
        }

        function onSuccess() {
            vm.warning.wip = !vm.warning.wip;
            $uibModalInstance.close(true);
        }

        function onError() {

        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningsListDetailController', WarningsListDetailController);

    WarningsListDetailController.$inject = ['$q', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjects', 'AlertRules', 'WarningsDashboard', 'warName', 'objUniqueCode', 'fleetName'];

    function WarningsListDetailController($q, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjects, AlertRules, WarningsDashboard, warName, objUniqueCode, fleetName) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.parseWarningLevel = parseWarningLevel;

        vm.currentState = "warnings-list-detail";
        vm.currentStateFilter = "warnings-list-detail-filter";

        vm.filter = pagingParams.filter;
        vm.predicates = pagingParams.predicates;

        vm.filter.status = "all";
        vm.filter.sizeP = "page";
        vm.filter.warningGetAll = "all";
        vm.filter.warningName = warName;
        vm.filter.warningFleet = fleetName;
        vm.filter.warningObjectCode = objUniqueCode;

        vm.warning = [];
        vm.warningsGroup = [];
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        var filter = localStorage.getItem(vm.currentStateFilter);
        if (filter !== null && filter !== "null" && filter !== undefined && filter != "{}") {
            filter = JSON.parse(filter);
            if((filter.warningName != vm.filter.warningName || filter.warningObjectCode != vm.filter.warningObjectCode) && (vm.filter.warningName != "" && vm.filter.warningObjectCode != "")){
                localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
            } else {
                if (Object.keys(filter).length > 0) {
                    vm.filter = filter;
                }
            }
        } else {
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: null,
                search: vm.searchParams
            };

            WarningsDashboard.search(page, vm.filter, innerOnSuccess, onError);

            function innerOnSuccess(data, headers) {
                vm.showClose = vm.filter.status !== 'open';
                onSuccess(data, headers, notify);
            }
        }

        function onSuccess(data, headers, notify) {
            vm.warning = data;
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.listFilter = pagingParams.filter;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition(notify) {
            notify = notify == false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: null,
                predicates: vm.predicates,
                search: vm.searchParams,
                filter: vm.filter,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                name: vm.filter.warningName,
                objectUniqueCode: vm.filter.warningObjectCode,
                fleet: vm.filter.warningFleet
            }, {notify: notify, location: "replace"});
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 1 ? "lv-low" : level === 2 ? "lv-medium" : "lv-high");
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            vm.loadAll(false);
        }

        vm.showDetail = function (warning) {
            TabObjects.byUniqueCode({uniqueCode: warning.objectUniqueCode}).$promise.then(function (object) {
                AlertRules.get({id: warning.warningId}).$promise.then(function (rule) {
                    var date = new Date(warning.date);
                    var range = 1800;
                    if(rule.frequency > range) {
                        range = rule.frequency;
                    }
                    var dateTo;
                    if(warning.status === "close") {
                        dateTo = new Date(warning.dateClose).getTime() + 600000;
                    } else {
                        dateTo = date.getTime() + ((+range + 1800) * 1000);
                    }
                    $state.transitionTo('tab-objects-dashboard-detail', {
                        id: object.id,
                        fleet: warning.fleetId,
                        objType: object.objectType.id,
                        warningName: warning.name,
                        warningDateFrom: date.setTime(date.getTime() - (range * 1000)),
                        warningDateTo: date.setTime(dateTo)
                    }, {notify: true, location: "replace"});
                });
            });
        };

        vm.loadAll(false);
    }
})
();

;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningsListController', WarningsListController);

    WarningsListController.$inject = ['$q', 'entity', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'WarningsDashboard', '$scope', '$timeout', '$uibModal', 'TabObjects', 'AlertRules', 'TabFleets', 'WarningCategory'];

    function WarningsListController($q, entity, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, WarningsDashboard, $scope, $timeout, $uibModal, TabObjects, AlertRules, TabFleets, WarningCategory) {
        var vm = this;
        if (entity != null) {
            vm.myDomainNotification = entity;
        } else {
            vm.myDomainNotification = null;
        }
        vm.applySort = applySort;
        vm.transition = transition;
        vm.applySearch = applySearch;
        vm.exportTable = exportTable;
        vm.changePageSize = changePageSize;
        vm.loadAllToExport = loadAllToExport;
        vm.parseWarningLevel = parseWarningLevel;
        vm.applyWarningFilter = applyWarningFilter;

        vm.currentState = "warnings-dashboard";
        vm.currentStateFilter = "warnings-dashboard-filter";
        vm.picker = {
            start: false,
            end: false
        };

        vm.fleetOptions = [];
        vm.categoryOptions = [];
        vm.warningNameOptions = [];
        vm.tabObjectsToExport = [];
        vm.fleetSelectedAtStart = [];
        vm.warningSelectedAtStart = [];
        vm.categorySelectedAtStart = [];

        vm.seeMore = 5;
        vm.sorting = [];
        vm.warnings = [];
        vm.sortIcon = {};
        var sortingMap = {};
        vm.filterDetail = [];
        vm.warningsGroup = [];
        vm.showClose = false;
        vm.searchParams = pagingParams.search;
        vm.predicates = pagingParams.predicates;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        if (localStorage.getItem("is-from-see-more") == null) {
            localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: false}));
        }

        vm.tabFleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.categories = WarningCategory.query({
            page: 0,
            size: 100
        });
        vm.systemWarnings = AlertRules.querySystem({
            page: 0,
            size: 1000
        });
        vm.warningNames = AlertRules.query({
            page: 0,
            size: 1000
        });

        // Promises from $resource queries for fleets, categories, system warnings and warnings
        var fleetsPromise = vm.tabFleets.$promise;
        var categoriesPromise = vm.categories.$promise;
        var systemWarningsPromise = vm.systemWarnings.$promise;
        var warningsPromise = vm.warningNames.$promise;

        vm.tabFleets.$promise.then(function (fleets) {
            fleets.forEach(function (fleet) {
                vm.fleetOptions.push({id: fleet.id, label: fleet.fleetName});
            });
            vm.categories.$promise.then(function (categories) {
                categories.unshift({id: -1, warningName: 'Monitoring Warning'});
                vm.systemWarnings.$promise.then(function (systemWarnings) {
                    systemWarnings.warnings.forEach((systemWarning) => {
                        systemWarning.warningCategory = {id: -1, warningName: "Monitoring Warning"};
                    });
                    vm.systemWarnings = vm.systemWarnings.warnings;
                    vm.warningNames.$promise.then(function (warnings) {
                        vm.systemWarnings.forEach((systemWarning) => {
                            warnings.warnings.unshift(systemWarning);
                        });
                        vm.warningNames = vm.warningNames.warnings;
                        categories.forEach(category => {
                            if(warnings.warnings.some(w => w.warningCategory.warningName === category.warningName)) {
                                vm.categoryOptions.push({id: category.id, label: category.warningName})
                            }
                        });
                        warnings.warnings.forEach(warning => {
                            if (!vm.warningNameOptions.some(w => w.id === warning.id || w.label === warning.name))
                                vm.warningNameOptions.push({id: warning.id, label: warning.name});
                        });
                    });
                });
            });
        });

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        var v = JSON.parse(localStorage.getItem('is-from-see-more'));
        if (v.isFromSeeMore) {
            vm.isFromSeeMore = v.isFromSeeMore;
            var backToLastPage = JSON.parse(localStorage.getItem("warnings-page-back-detail"));
            vm.page = backToLastPage.pageBack;
            vm.itemsPerPageChosen = backToLastPage.sizeBack;
        }

        vm.filter = vm.isFromSeeMore ? JSON.parse(localStorage.getItem('save-filter')) : pagingParams.filter;
        localStorage.setItem("save-filter", JSON.stringify(vm.filter));

        vm.loadAll  = function (notify) {
            var page = {
                page: vm.isFromSeeMore ? vm.page - 1 : pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                search: vm.searchParams
            };
            if (vm.filter.hasOwnProperty('sizeP'))
                delete vm.filter.sizeP;
            if (vm.filter.hasOwnProperty('warningGetAll'))
                delete vm.filter.warningGetAll;
            if (vm.filter.hasOwnProperty('warningObjectCode'))
                delete vm.filter.warningObjectCode;
            if (vm.filter.hasOwnProperty('warningFleet'))
                delete vm.filter.warningFleet;
            if (vm.filter.hasOwnProperty('warningName'))
                delete vm.filter.warningName;

            WarningsDashboard.search(page, vm.filter, innerOnSuccess, onError);

            function innerOnSuccess(data, headers) {
                vm.showClose = vm.filter.status !== 'open';
                onSuccess(data, headers, notify);
            }
        }

        function onSuccess(data, headers, notify) {
            vm.warnings = data[0];
            vm.totalItems = data[0].count;
            vm.page =  vm.isFromSeeMore ? vm.page : pagingParams.page;
            vm.queryCount = vm.totalItems;
            vm.transition(notify);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            if (vm.isFromSeeMore) {
                var backToLastPage = JSON.parse(localStorage.getItem("warnings-page-back-detail"));
                vm.page = backToLastPage.pageBack;
                vm.itemsPerPageChosen = backToLastPage.sizeBack;
            }
            $state.transitionTo($state.$current, {
                sort: sort(),
                page: vm.page,
                filter: vm.filter,
                search: vm.searchParams,
                predicates: vm.predicates,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
            if (vm.isFromSeeMore) {
                localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: false}));
                vm.isFromSeeMore = false;
            }
        }

        vm.loadWarningsGroup = function () {
            for (var i = 0; i < Object.keys(vm.warnings.warningName).length; i++) {
                vm.warnings.warningName[i].expanded = false;
            }
        };

        vm.detail = function (warning) {
            if (!warning.expanded) {
                vm.loadWarningsGroup();
            }
            warning.expanded = !warning.expanded;
            vm.warningsGroup = [];
            if (warning.expanded) {
                var page = {
                    page: 0,
                    size: vm.itemsPerPageChosen,
                    sort: sort(),
                    search: vm.searchParams
                };

                vm.filterDetail = angular.copy(vm.filter);
                vm.filterDetail.warningFleet = warning.fleetName;
                vm.filterDetail.warningName = warning.name;
                vm.filterDetail.warningObjectCode = warning.objectUniqueCode;
                vm.filterDetail.warningGetAll = null
                WarningsDashboard.search(page, vm.filterDetail, onSuccessDetail, onErrorDetail);

                function onSuccessDetail(data) {
                    vm.warningsGroup = data[0].warningName[0];

                    if (warning.count > vm.seeMore) {
                        var name = {name: "See More"};
                        vm.warningsGroup.push(name);
                    }
                }

                function onErrorDetail() {
                }
            }
        };

        vm.openSeeMore = function (warning) {
            vm.savePage();
            localStorage.setItem("save-filter", JSON.stringify(vm.filter));
            localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: true}));
            $state.transitionTo("warnings-list-detail", {
                page: 1,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.searchParams,
                filter: vm.filter,
                itemsPerPageChosen: 10,
                name: warning.name,
                objectUniqueCode: warning.objectUniqueCode,
                fleet: warning.fleetName
            })
        };

        vm.saveIndex = function (index) {
            vm.indexColor = index;
            return vm.indexColor % 2 == 0;
        }

        function applySearch() {
            pagingParams.page = 1;
            resetTableToExport();
            vm.loadAll(false);
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 1 ? "lv-low" : level === 2 ? "lv-medium" : "lv-high");
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            vm.savePage();
           vm.transition();
        }

        vm.loadPage = function() {
            vm.savePage();
            localStorage.setItem("save-filter", JSON.stringify(vm.filter));
            pagingParams.page = vm.page;
            resetTableToExport();
            vm.loadAll(false);
        };

        function applySort(field) {
            if (!sortingMap[field]) {
                sortingMap[field] = "+";
                vm.sortIcon[field] = '-by-attributes';
            } else if (sortingMap[field] === '+') {
                sortingMap[field] = "-";
                vm.sortIcon[field] = "-by-attributes-alt";
            } else {
                delete sortingMap[field];
                delete vm.sortIcon[field];
            }
            vm.sorting = Object.keys(sortingMap).map(function (field) {
                return sortingMap[field] + field;
            });

        }

        function applyWarningFilter() {
            if (vm.filter.start < vm.filter.end || vm.filter.start == vm.filter.end) {
                collectFleets();
                collectCategories();
                collectWarnings();
                vm.filter.fleets = angular.copy(vm.selectedFleets);
                vm.filter.categories = angular.copy(vm.selectedCategories);
                vm.filter.warningNames = angular.copy(vm.selectedWarningNames);
                localStorage.setItem("save-filter", JSON.stringify(vm.filter));
                resetTableToExport();
                vm.loadAll(false);
            } else {
                AlertService.error("Error validation date.");
            }
        }

        function loadAllToExport() {
            var page = {
                page: 0,
                size: 2000,
                sort: sort(),
                search: vm.searchParams
            };
            var dataExport = {
                ch: vm.searchParams,
                filter: pagingParams.filter
            };

            function onSuccessExport(data, headers) {
                vm.totalItemsExport = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectsToExport.push(data[i]);
                }
                if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                    page.page = page.page + 1;
                    WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                } else {
                    vm.filter.warningGetAll = null;
                }
            }

            function onErrorExport(error) {
                AlertService.error(error.data.message);
                reject();
            }

            // Table to export is empty --> reload data from backend
            if (vm.tabObjectsToExport.length < 1) {
                vm.filter.warningGetAll = "all";
                WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
            }
        }

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 50, 1: 105, 2: 90, 3: 90, 4: 100, 5: 35, 6: 50, 8: 92, 9: 105},
                    tableName: 'Warnings'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Warnings'});
            }
        }

        vm.showStatus = function (status) {
            if (status)
                return "Unprocess";
            else return "Process";
        }

        vm.wipStatus = function (warning) {
            $uibModal.open({
                templateUrl: 'app/dashboards/warnings-list/warning-list-wip-dialog.html',
                controller: 'SingleWipDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function () {
                        return warning;
                    }]
                }
            });
        };

        vm.showDetail = function (warning) {
            TabObjects.byUniqueCode({uniqueCode: warning.objectUniqueCode}).$promise.then(function (object) {
                AlertRules.get({id: warning.warningId}).$promise.then(function (rule) {
                    var date = new Date(warning.date);
                    var range = 1800;
                    if (rule.frequency > range) {
                        range = rule.frequency;
                    }
                    var dateTo;
                    if (warning.status === "close") {
                        dateTo = new Date(warning.dateClose).getTime() + 600000;
                    } else {
                        dateTo = date.getTime() + ((+range + 1800) * 1000);
                    }
                    $state.transitionTo('tab-objects-dashboard-detail', {
                        id: object.id,
                        fleet: warning.fleetId,
                        objType: object.objectType.id,
                        warningName: warning.name,
                        warningDateFrom: date.setTime(date.getTime() - (range * 1000)),
                        warningDateTo: date.setTime(dateTo)
                    }, {notify: true, location: "replace"});
                });
            });
        };

        vm.categoryListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select categories",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
        vm.warningListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select warnings",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
        vm.fleetListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select fleet(s)",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };

        vm.fleetListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };
        vm.categoryListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };
        vm.warningListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };

        function collectFleets() {
            vm.selectedFleets = [];
            for (var x = 0; x < vm.tabFleets.length; x++) {
                for (var i = 0; i < vm.filter.fleets.length; i++) {
                    if (vm.tabFleets[x].id == vm.filter.fleets[i].id) {
                        vm.selectedFleets.push(vm.tabFleets[x]);
                    }
                }
            }
        }

        function collectCategories() {

            vm.selectedCategories = [];
            var systemExists = false;

            for (var i = 0; i < vm.filter.categories.length; i++) {
                if (vm.filter.categories[i].id === -1) {
                    systemExists = true;
                } else {
                    for (var j = 0; j < vm.categories.length; j++) {
                        if (vm.categories[j].id === vm.filter.categories[i].id) {
                            vm.selectedCategories.push(vm.categories[j]);
                            break;
                        }
                    }
                }
            }

            if (systemExists) {
                vm.selectedCategories.push({id: -1, warningName: "Monitoring Warning"})
            }

        }


        /**
         * vm.filter.warningNames:  array containing rules selected by the user                             { id:{}. warningName:{} } coming from Warning History, { id:{} } coming from My Domain Notification
         * vm.warningNameOptions:   array containing waring names selectable by the user in the UI model    { id:{}, label:{} }
         * vm.warningNames:         array containing rules read from database warning table                 { id: {}, warningName:{} }
         */
        function collectWarnings() {

            vm.selectedWarningNames = [];

            for (var i = 0; i < vm.filter.warningNames.length; i++) {
                for (var j = 0; j < vm.warningNameOptions.length; j++) {

                    // Need to filter by name/label (not only by id) because element must be selectable in UI (see how warningNameOptions is populated)
                    if (
                        vm.filter.warningNames[i].id === vm.warningNameOptions[j].id ||
                        vm.filter.warningNames[i].name === vm.warningNameOptions[j].label
                    ) {

                        // Need to select element from warningNames to query BE
                        for (var k = 0; k < vm.warningNames.length; k++) {

                            if(vm.warningNameOptions[j].id === vm.warningNames[k].id) {
                                vm.selectedWarningNames.push(vm.warningNames[k])
                            }
                        }
                    }
                }
            }
        }


        function resetTableToExport(){
            vm.tabObjectsToExport = [];
        }

        vm.precompile = function () {

            const noPageOrFirstPage = !$state.params.page || parseInt($state.params.page, 10) === 1;
            if (noPageOrFirstPage) {
                vm.restoreFilter();
            }

            vm.fleetSelectedAtStart = [];
            vm.categorySelectedAtStart = [];
            vm.warningSelectedAtStart = [];

            if (vm.myDomainNotification != null) {   // to fill filter in case this page is opened through mail link.
                vm.filter.fleets = [];
                vm.filter.categories = [];
                vm.filter.warningNames = [];
                vm.filter.fleets = angular.copy(vm.myDomainNotification.fleets);
                vm.filter.categories = angular.copy(vm.myDomainNotification.categories);
                vm.filter.warningNames = angular.copy(vm.myDomainNotification.warningNames);
                vm.filter.status = angular.copy(vm.myDomainNotification.status);
                vm.filter.objectsStatus = angular.copy(vm.myDomainNotification.objectsStatus);
                var executionTime = new Date(vm.myDomainNotification.nextExecutionDatetime);
                var end = new Date();
                var start = new Date();
                end.setHours(executionTime.getHours(), executionTime.getMinutes(), 0, 0);
                start.setHours(executionTime.getHours(), executionTime.getMinutes(), 0, 0);
                start.setDate(start.getDate() - vm.myDomainNotification.frequency);
                vm.filter.start = angular.copy(start);
                vm.filter.end = angular.copy(end);
                vm.myDomainNotification = null;

                vm.systemWarningExists = false;
                vm.filter.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                    vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.filter.fleets = angular.copy(vm.fleetSelectedAtStart);

                vm.filter.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                    vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                });
                vm.filter.categories = angular.copy(vm.categorySelectedAtStart);

                vm.filter.warningNames.forEach(function (warning) {   // getting all the warnings from entity and set it inside the dropdown list as (id, label).
                    if (warning.warningCategory == null || warning.warningCategory.id === -1) {
                        warning.warningCategory = {id: -1, warningName: "Monitoring Warning"}
                        vm.systemWarningExists = true;
                    }
                    warning.label = warning.name;
                    vm.warningSelectedAtStart.push(warning);
                });
                if (vm.systemWarningExists) {     // adding (system) to selected category in case systemWarning found
                    vm.filter.categories.push({id: -1, label: "Monitoring Warning"});
                }
                vm.filter.warningNames = angular.copy(vm.warningSelectedAtStart);
            } else {
                vm.systemWarningExists = false;
                vm.filter.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                    vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.filter.fleets = angular.copy(vm.fleetSelectedAtStart);

                var categoryIds = [];
                vm.filter.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                    vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                    categoryIds.push(category.id);
                });
                vm.filter.categories = angular.copy(vm.categorySelectedAtStart);

                vm.filter.warningNames.forEach(function (warning) {   // getting all the warnings from entity and set it inside the dropdown list as (id, label).
                    if (warning.warningCategory == null || warning.warningCategory.id === -1) {
                        warning.warningCategory = {id: -1, warningName: "Monitoring Warning"}
                        vm.systemWarningExists = true;
                    }
                    warning.label = warning.name;
                    vm.warningSelectedAtStart.push(warning);
                });
                if (vm.systemWarningExists && categoryIds.includes(-1)) {     // adding (system) to selected category in case systemWarning found
                    vm.filter.categories.push({id: -1, label: "Monitoring Warning"});
                }
                vm.filter.warningNames = angular.copy(vm.warningSelectedAtStart);
            }

        }

        vm.restoreFilter = function () {
         vm.filter = angular.copy(JSON.parse(localStorage.getItem('save-filter')));
         if (vm.filter.start !== undefined)
            vm.filter.start = angular.copy(new Date(vm.filter.start));
         if (vm.filter.end !== undefined)
             vm.filter.end = angular.copy(new Date(vm.filter.end));
        }

        vm.savePage = function () {
            var pageBackDetail = {
                pageBack: vm.page,
                sizeBack: vm.itemsPerPageChosen
            }
            localStorage.setItem("warnings-page-back-detail", JSON.stringify(pageBackDetail));
        }

        $q.all([
            fleetsPromise,
            categoriesPromise,
            systemWarningsPromise,
            warningsPromise
        ]).then(function () {

            vm.precompile();

            const noPageOrFirstPage =
                !$state.params.page || parseInt($state.params.page, 10) === 1;

            if (noPageOrFirstPage) {
                applyWarningFilter();
            }

        });
    }
})
();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('WarningsDashboard', WarningsDashboard);

    WarningsDashboard.$inject = ['$resource'];

    function WarningsDashboard($resource) {
        var resourceUrl = 'api/warnings-dashboard';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'search': {method: 'POST', isArray: true},
            'topName': {
                url: 'api/warnings-dashboard/topName',
                method: 'POST',
                isArray: true},
            'topObjects': {
                url: 'api/warnings-dashboard/topObject',
                method: 'POST',
                isArray: true}
        });
    }




})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warnings-list', {
                parent: 'dashboard',
                url: '/warnings-list?id&search&page&sort',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.warning.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warnings-list/warnings-list.html',
                        controller: 'WarningsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {

                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    filter: {
                        value: {
                            status: 'open',
                            objectsStatus: 'all',
                            wipStatus: 'all',
                            fleets: [],
                            categories: [],
                            warningNames: []
                        },
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            fleets: $stateParams.fleets,
                            warningName: $stateParams.warningName,
                            category: $stateParams.category
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myDomainNotification');
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function($stateParams, MyDomainNotification) {
                        if($stateParams.id != null || $stateParams.id != undefined) {
                            return MyDomainNotification.getOne({id: $stateParams.id});
                        }
                        return null;
                    }]
                }
            })
            .state('warnings-list-detail', {
                parent: 'warnings-list',
                url: '/detail/{name}/{objectUniqueCode}/{fleet}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warnings-list/warnings-list-detail.html',
                        controller: 'WarningsListDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    filter: {
                        value: {
                            status: 'open',
                            objectsStatus: 'all',
                            wipStatus: 'all',
                            fleets: [],
                            categories: [],
                            warningNames: [],
                            name: '',
                            objectUniqueCode: '',
                            fleet: ''
                        },
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            fleets: $stateParams.fleets,
                            warningName: $stateParams.warningName,
                            category: $stateParams.category,
                            name: $stateParams.name,
                            objectUniqueCode: $stateParams.objectUniqueCode,
                            fleet: $stateParams.fleet
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    warName: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    objUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }],
                    fleetName: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }]
                }
            });
    }
})();
;
// lazyload config

angular.module('jotApp')
    /**
     * jQuery plugin config use ui-jq directive , config the js and css files that required
     * key: function name of the jQuery plugin
     * value: array of the css js file located
     */
    .constant('JQ_CONFIG', {
        plot: ['./bower_components/Flot/jquery.flot.js',
                './bower_components/Flot/jquery.flot.pie.js',
                './bower_components/Flot/jquery.flot.resize.js',
                './bower_components/flot.tooltip/js/jquery.flot.tooltip.js',
                './bower_components/flot.orderbars/js/jquery.flot.orderBars.js'
                //'./bower_components/flot-spline/js/jquery.flot.spline.js'
            ]


    }
    )

;
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('copyToClipboard', copyToClipboard);

    function copyToClipboard(AlertService) {
        var directive = {
            restrict: 'A',
            require: ['?ngModel'],
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ctrls) {
            element.click(function () {
                var value = undefined;
                if (ctrls && ctrls.length > 0 && ctrls[0]) {
                    var ngModelCtrl = ctrls[0];
                    value = ngModelCtrl.$viewValue;
                } else {
                    value = attrs.copyToClipboard;
                }
                var
                    body = angular.element(window.document.body),
                    textarea = angular.element('<textarea/>');
                    textarea.css({ position: 'fixed', opacity: '0' });
                if(value.indexOf('path+') > -1 ) {
                    textarea.val(window.location.origin + window.location.pathname + value.substring(5));
                } else {
                    textarea.val(value);
                }
                body.append(textarea);
                textarea[0].select();
                document.execCommand('copy');
                textarea.remove();
                AlertService.success("Link copied");
                if(!scope.$$phase) {
                    scope.$apply();
                }
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular.module('jotApp')
        .directive('dashboardFilter', dashboardFilter);

    function dashboardFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                fleet: '=',
                objectType: '=',
                removeOptionAll: '=',
                showCondition: '=',
                fleets: '=',
                condition: '='
            },
            template: '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.fleet" theme="bootstrap" id="fleet_field" on-select="vm.onFleetSelect($item)">\n' +
            '                                        <ui-select-match\n' +
            '                                        placeholder="Select or search a fleet..">\n' +
            '                                        {{$select.selected.fleetName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.fleets | propsFilter: {fleetName: $select.search, fleetDescription: $select.search}">\n' +
            '                                            <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                            <small ng-bind-html="item.fleetDescription | highlight: $select.search"></small>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
            '                                            placeholder="Select or search an object type...">\n' +
            '                                            {{$select.selected.objectTypeName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                            <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div ng-if="vm.showCondition" class="col-xs-3">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.condition" id="condition_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
                '                                        placeholder="Select or search a condition...">\n' +
            '                                            {{$select.selected.name}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.conditions | filter: {name: $select.search}">\n' +
            '                                            <div ng-bind-html="item.name | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2" >\n' +
            '                                <div class="form-group">\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>',
            controller: DashboardFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DashboardFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabObjectsConditions'];

    function DashboardFilterController(TabFleets, TabObjectTypes, TabObjectsConditions) {
        var vm = this;
        var allFleet = {
            id: -1,
            fleetName: "All Fleet"
        };
        var allObjectType = {
            id: -1,
            objectTypeName: "All Object Type"
        };
        var allConditions = {
            id: -1,
            name: "All Conditions"
        };
        var mappedObjectType = {};

        vm.objectTypes = [];

        if(vm.showCondition) {
            vm.conditions = TabObjectsConditions.query();
            vm.conditions.$promise.then(function (data) {
                if (!vm.removeOptionAll)
                    data.unshift(allConditions);
                vm.submit();
            });

            if (!vm.condition.name) {
                vm.condition = allConditions;
            }
        } else  {
            vm.condition = allConditions;
        }

        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.fleets.$promise.then(function (data) {
            if(!vm.removeOptionAll)
                data.unshift(allFleet);
            // vm.fleets = data;
            if(!vm.showCondition)
                vm.submit();
        });

        TabObjectTypes.mapped().$promise.then(function (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectTypes();

            if(vm.fleets.$promise) {
                vm.fleets.$promise.then(function () {
                    if (vm.fleet.id > 0) {
                        vm.fleets.forEach(function (f) {
                            if (f.id == vm.fleet.id)
                                vm.fleet = f;
                        });
                        if (vm.fleet.fleetName == undefined || vm.fleet.fleetName == null) {
                            vm.fleet = allFleet;
                        }
                    } else  if (vm.removeOptionAll) {
                        vm.fleet = vm.fleets[0];
                        vm.objectTypes = mappedObjectType[vm.fleet.id];
                    } else {
                        vm.fleet = allFleet;
                    }
                });
            }

            vm.objectTypes = mappedObjectType[vm.fleet.id];
            if(vm.fleet.id == undefined || vm.fleet.id == null){
                if(vm.objectTypes == undefined){
                    vm.objectTypes = [];
                }
                vm.objectTypes.push(allObjectType);
            }

            if (vm.objectType.id > 0) {
                vm.objectTypes.forEach(function (o) {
                    if (o.id == vm.objectType.id)
                        vm.objectType = o;
                });
                if (vm.objectType.objectTypeName == undefined || vm.objectType.objectTypeName == null) {
                    vm.objectType=allObjectType;
                }
            } else if(vm.objectTypes != null && vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            } else
                vm.objectType = allObjectType;
        });

        vm.onFleetSelect = function (fleet) {
            vm.objectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.objectTypes.length > 0 && !vm.removeOptionAll) {
                vm.objectType = allObjectType;
            } else if(vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            }
        };

        vm.submit = function () {
            vm.filter({fleet: vm.fleet, objectType: vm.objectType, condition: vm.condition});
        };

        function mapObjectTypes() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0 && !vm.removeOptionAll) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }

        }



    }

    angular.module('jotApp').filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop]) {
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });
})();

;
(function () {
    'use strict';
    angular.module('jotApp')
        .directive('dashboard', dashboard);

    function dashboard() {
        var directive = {
            restrict: 'E',
            scope: {
                name: '@',
                fleet: '=',
                objectType: '=',
                objectUniqueCode: '=',
                warningCategory: '=',
                warningName: '=',
                detail: '=',
                frameHeight:"@",
                fromDate: '=',
                toDate: '=',
                fromDatel: '=',
                toDatel: '='
            },
            template: '<iframe ng-if="vm.parsedURL.length > 0" width="100%" height="{{vm.frameHeight}}" src="{{vm.parsedURL}}" class="dashboard" name="{{vm.name}}" style="border: 0"></iframe>',
            controller: DashboardDirectiveController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DashboardDirectiveController.$inject = ['$scope', '$element', 'Dashboard', 'Principal', 'DASHBOARD_TYPE', 'DASHBOARD_PLACEHOLDER'];

    function DashboardDirectiveController($scope, $element, Dashboard, Principal, DASHBOARD_TYPE, DASHBOARD_PLACEHOLDER) {
        var vm = this;
        var domainId = "";
        var dashboardLevel = "";
        var dashboard = "";
        var lastHeight = 996;
        var notMatchHit = 0;

        vm.parsedURL = "";
        vm.lastHeight = 996 + 'px';

        Principal.identity().then(function (account) {
            domainId = account.context.id;
            dashboardLevel = account.userProfile.warningLevel;
        });

        Dashboard.frame({frameReference: vm.name}).$promise.then(function (data) {
            dashboard = data;
            vm.parseURL(data.url);
        });


        vm.parseURL = function(url) {
            if(url && vm.name) {
                if (dashboard.dashboardType === DASHBOARD_TYPE.KIBANA) {
                    url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.domain), DASHBOARD_PLACEHOLDER.KIBANA.domain + ':' + domainId);
                    url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.level), DASHBOARD_PLACEHOLDER.KIBANA.level + ':>=' + dashboardLevel);
                    if (vm.fleet)
                        if (angular.isArray(vm.fleet)) {
                            var fleetIds = '( ' + vm.fleet.map(function (fleet) {
                                return DASHBOARD_PLACEHOLDER.KIBANA.fleet + ':' + fleet.id;
                            }
                            ).join(" OR ") + ' )';
                            fleetIds = fleetIds.replace("fleetId:-1 OR ", "");
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.fleet), fleetIds);
                        } else {
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.fleet), DASHBOARD_PLACEHOLDER.KIBANA.fleet + ':' + (vm.fleet.id == -1 ? '*' : vm.fleet.id));
                        }
                    if (vm.objectType)
                        if (angular.isArray(vm.objectType)) {
                            var objectTypeIds = '( ' + vm.objectType.map(function (objectType) {
                                return DASHBOARD_PLACEHOLDER.KIBANA.objectType + ':' + objectType.id;
                            }
                            ).join(" OR ") + ' )';
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectType), objectTypeIds);
                        } else {
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectType), DASHBOARD_PLACEHOLDER.KIBANA.objectType + ':' + (vm.objectType.id == -1 ? '*' : vm.objectType.objectTypeName));
                        }
                    if (vm.objectUniqueCode) {
                        url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectUniqueCode), DASHBOARD_PLACEHOLDER.KIBANA.objectUniqueCode + ':' + vm.objectUniqueCode);
                    }
                    if (vm.detail) {
                        url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.detail), "\"" + vm.detail + "\"");
                    }
                }
                else if (dashboard.dashboardType === DASHBOARD_TYPE.GRAFANA) {

                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.domainId, domainId);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.fleetId, vm.fleet);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.objectType, vm.objectType);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.objectUniqueCode, vm.objectUniqueCode);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.warningCategory, vm.warningCategory);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.warningName, vm.warningName);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.level, dashboardLevel);

                    if (vm.fromDate && vm.toDate) {
                        url = buildGrafanaTimeString(url, vm.fromDate, vm.toDate);
                    } else if (vm.fromDatel && vm.toDatel) {
                        url = buildGrafanaTimeString(url, vm.fromDatel, vm.toDatel);
                    }
                }

                vm.parsedURL = url;
            }
        };

        function replaceIfDefined(url, placeholder, value) {
            const finalValue = (value !== undefined && value !== null && value !== '') ? value : 'All';
            return url.replace(wrap(placeholder), finalValue);
        }

        function wrap(placeholder) {
            return '${{' + placeholder + '}}';
        }

        $scope.$watchGroup(['vm.fleet', 'vm.objectType', 'vm.fromDate', 'vm.toDate', 'vm.fromDatel', 'vm.toDatel'], function (newValues, oldValues) {
            if (oldValues[0] === undefined || oldValues[1] === undefined || (newValues[0] !== undefined && newValues[0].id !== oldValues[0].id) || (newValues[1] !== undefined && newValues[1].id !== oldValues[1].id)
                || (newValues[4] !== undefined && newValues[4] !== oldValues[4]) || (newValues[5] !== undefined && newValues[5] !== oldValues[5])) {
                vm.parseURL(dashboard.url);
            }
        });

        function getTimestamp(date) {
            return date/1;
        }

        function buildGrafanaTimeString(url, fromDate, toDate) {
            if(angular.isDate(fromDate))
                fromDate = getTimestamp(fromDate);

            if(angular.isDate(toDate))
                toDate = getTimestamp(toDate);

            return url + '&from=' + fromDate + '&to=' + toDate;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('deviceFilter', deviceFilter);

    function deviceFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                deviceType: '&',
                deviceTypeVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_type">Device Type</label>\n' +
            '                                       <ui-select ng-model="vm.deviceType" id="deviceType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a device type...">\n' +
            '                                           {{$select.selected.deviceTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabDevicesTypes | filter: {deviceTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.deviceTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: DeviceFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DeviceFilterController.$inject = ['TabDevicesTypes'];

    function DeviceFilterController(TabDevicesTypes) {
        var vm=this;
        TabDevicesTypes.query(onSuccess, onError);

        function onSuccess(data) {
            vm.tabDevicesTypes = data;
            vm.tabDevicesTypes.unshift(allDeviceTypes);
        }

        function onError(){}

        var allDeviceTypes = {
            id: -1,
            deviceTypeName: 'All'
        };

        vm.deviceType = +vm.deviceTypeVal() === -1 || vm.deviceTypeVal().id === -1 ? allDeviceTypes : vm.deviceTypeVal();

        vm.submit = function () {
            vm.filter({deviceType: vm.deviceType});
        };
    }
})();
;
(function () {
    'use strict';

    angular
            .module('jotApp')
            .directive('fileTypesFilter', fileTypesFilter);

    function fileTypesFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                tabFileType: '&',
                tabObjectType: '&',
                tabFileTypeVal: '&',
                tabObjectTypeVal: '&'
            },
            template:
            '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">' +
            '                                <div class="form-group">\n' +
            '                                   <label class="control-label ng-scope" for="objectType_field">Object Type</label>\n' +
            '                                   <ui-select ng-model="vm.tabObjectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match placeholder="Select or search an object type..."> {{$select.selected.objectTypeName}} </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_fileType">File Type</label>\n' +
            '                                    <ui-select ng-model="vm.tabFileType" id="fileType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a file type...">\n' +
            '                                           {{$select.selected.fileTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabFileTypes | filter: {fileTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.fileTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: FileTypesFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FileTypesFilterController.$inject = ['TabFileTypes', 'TabObjectTypes'];

    function FileTypesFilterController(TabFileTypes, TabObjectTypes){
        var vm=this;
        TabFileTypes.query({size: 1000}, onSuccess, onError);
        TabObjectTypes.query({size:1000}, onSuccessTypes, onErrorTypes);


        function onSuccessTypes(data) {
            vm.objectTypes = data;
            vm.objectTypes.unshift(allObjectTypes);
        }

        function onErrorTypes() {}

        function onSuccess(data) {
            vm.tabFileTypes = data;
            vm.tabFileTypes.unshift(allFileTypes);
        }

        function onError() {}

        var allFileTypes = {
            id: -1,
            fileTypeName: "All"
        };

        var allObjectTypes = {
            id: -1,
            objectTypeName: "All"
        };

        vm.tabFileType = +vm.tabFileTypeVal() === -1 || +vm.tabFileTypeVal().id === -1 ? allFileTypes : vm.tabFileTypeVal();
        vm.tabObjectType = +vm.tabObjectTypeVal() === -1 || +vm.tabFileTypeVal().id === -1 ? allObjectTypes : vm.tabObjectTypeVal();

        vm.submit = function () {
            if(vm.tabObjectType.id == -1){
                TabFileTypes.query({size: 1000}, onSuccess, onError);
                vm.filter({
                    tabFileType: vm.tabFileType,
                    tabObjectType: vm.tabObjectType
                });
            } else {
                TabObjectTypes.get({id: vm.tabObjectType.id}, onSuccessTypesId, onErrorTypesId);
            }

            function onSuccessTypesId(data) {
                vm.tabFileTypes = data.fileTypes;
                vm.tabFileTypes.unshift(allFileTypes);
                vm.filter({
                    tabFileType: vm.tabFileType,
                    tabObjectType: vm.tabObjectType
                });
            }

            function onErrorTypesId() {}
        };
    }


})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('firmwareFilter', firmwareFilter);

    function firmwareFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectType: '&',
                objectTypeVal: '&'
            },
            template:   '<div class="row">\n' +
                        '    <div class="col-xs-12">\n' +
                        '        <div class="portlet light filter-portlet bordered">\n' +
                        '            <div class="portlet-body form">\n' +
                        '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
                        '                    <div class="form-body">\n' +
                        '                       <div class="row">\n' +
                        '                            <div class="col-xs-5">\n' +
                        '                                <div class="form-group">\n' +
                        '                                    <label for="field_objectType">Object Type</label>\n' +
                        '                                    <ui-select ng-model="vm.objectType" id="field_objectType" theme="bootstrap" ng-keyup="vm.searchObjectType($select.search)" ng-click="vm.searchObjectType($select.search)">\n' +
                        '                                    <ui-select-match\n' +
                        '                                       placeholder="Select or search an object type...">\n' +
                        '                                       {{$select.selected.objectTypeName}}\n' +
                        '                                    </ui-select-match>\n' +
                        '                                    <ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" when-scrolled="vm.loadPageObjectType(vm.objectTypePage + 1)">\n' +
                        '                                       <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
                        '                                    </ui-select-choices>\n' +
                        '                                    </ui-select>\n' +
                        '                                </div>\n' +
                        '                            </div>\n' +
                        '                            <div class="col-xs-2 inline-filter-button">\n' +
                        '                                <div class="form-group">\n' +
                        '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
                        '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
                        '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
                        '                                    </button>\n' +
                        '                                </div>\n' +
                        '                            </div>\n' +
                        '                       </div>\n' +
                        '                    </div>\n' +
                        '                </form>\n' +
                        '            </div>\n' +
                        '        </div>\n' +
                        '    </div>\n' +
                        '</div>\n',
            controller: FirmwareController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FirmwareController.$inject = ['TabObjectTypes'];

    function FirmwareController (TabObjectTypes) {
        const vm = this;
        vm.objectTypePage = 0;
        vm.tabObjectTypes = [];

        const allObjectType = {
            id: -1,
            objectTypeName: 'All'
        };

        vm.objectType = +vm.objectTypeVal() === -1 || vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();

        vm.submit = function () {
            vm.filter({objectType: vm.objectType});
        };

        vm.loadAllObjectType = function () {
            TabObjectTypes.query({
                query: vm.charToSearch,
                page: vm.objectTypePage,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.charToSearch = "";
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
            }
        };

        vm.searchObjectType = function (search){
            vm.tabObjectTypes = [];
            vm.charToSearch = search;
            vm.loadAllObjectType();
            vm.tabObjectTypes.unshift(allObjectType);
        }


        vm.loadAllObjectType();
        vm.tabObjectTypes.unshift(allObjectType);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('fleetFilter', fleetFilter);

    function fleetFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectClazz: '&',
                objectClazzVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_class">Object Class</label>\n' +
            '                                       <ui-select ng-model="vm.objectClazz" id="objectClass_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search an object class...">\n' +
            '                                           {{$select.selected.className}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.objectClass | filter: {className: $select.search}">\n' +
            '                                           <div ng-bind-html="item.className | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: FleetFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FleetFilterController.$inject = ['ObjectClass'];

    function FleetFilterController(ObjectClass) {
        var vm=this;
        ObjectClass.query(onSuccess, onError);

        function onSuccess(data) {
            vm.objectClass = data;
            vm.objectClass.unshift(allObjectClass);
            // vm.objectClazz = allObjectClass;
        }

        function onError() {}

        var allObjectClass = {
            id: -1,
            className: "All"
        };

        vm.objectClazz = +vm.objectClazzVal() === -1 || vm.objectClazzVal().id === -1 ? allObjectClass : vm.objectClazzVal();

        vm.submit = function () {
            vm.filter({ objectClazz: vm.objectClazz });
        };
    }
})();
;
'use strict';

angular.module('jotApp')
    .directive('setminheight', function ($window) {
        return {
            link: function (scope, element, attrs) {
                // header height
                var topOffset = 50;
                // footer height
                var bottomOffset = 33;
                element.css('min-height', ($window.innerHeight - topOffset - bottomOffset  ) + 'px');
                $(window).on("resize", function(){
                    element.css('min-height', ($window.innerHeight - topOffset - bottomOffset  ) + 'px');
                });
            }
        };
    });

;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('maintenanceMessage', maintenanceMessage);

    function maintenanceMessage() {
        var directive = {
            restrict: 'E',
            template: '<a><span class="fa fa-warning"></span></a>',
            controller: MaintenanceMessageController
        };
        return directive;
    }

    MaintenanceMessageController.$inject = [];

    function MaintenanceMessageController() {
    }
})();
;
'use strict';

angular.module('jotApp')
    .directive('contentHeigthSync', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem) {
                elem.bind('click', function(e) {
                    $timeout(function(){
                        var sidebarHeight = $('.page-sidebar').innerHeight();
                        var pageContentHeight = $('.page-content').innerHeight();
                        if (sidebarHeight > pageContentHeight) {
                            $('.page-content').animate({
                                height: sidebarHeight
                            }, 200);
                        }
                        else {
                            $('.page-content').innerHeight('auto');
                        }
                    },300);
                });
            }
        };
    });
;
(function () {
    'use strict';

    angular.module('jotApp')
        .directive('multipleComFilter', multipleComFilter);

    function multipleComFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                fleet: '=',
                objectType: '=',
                removeOptionAll: '=',
                showCondition: '=',
                fleets: '=',
                condition: '=',
                showWarn: '='
            },
            template: '<div class="row">\n' +
                '    <div class="col-xs-12">\n' +
                '        <div class="portlet light filter-portlet bordered">\n' +
                '            <div class="portlet-body form">\n' +
                '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
                '                    <div class="form-body">\n' +
                '                        <div class="row">\n' +
                '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
                '                                <div class="form-group">\n' +
                '                                    <ui-select ng-model="vm.fleet" theme="bootstrap" id="fleet_field" on-select="vm.onFleetSelect($item)">\n' +
                '                                        <ui-select-match\n' +
                '                                        placeholder="Select or search a fleet..">\n' +
                '                                        {{$select.selected.fleetName}}\n' +
                '                                        </ui-select-match>\n' +
                '                                        <ui-select-choices repeat="item in vm.fleets | propsFilter: {fleetName: $select.search, fleetDescription: $select.search}">\n' +
                '                                            <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
                '                                            <small ng-bind-html="item.fleetDescription | highlight: $select.search"></small>\n' +
                '                                        </ui-select-choices>\n' +
                '                                    </ui-select>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
                '                                <div class="form-group">\n' +
                '                                    <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap" on-select="vm.updateShowWarning()">\n' +
                '                                        <ui-select-match\n' +
                '                                            placeholder="Select or search an object type...">\n' +
                '                                            {{$select.selected.objectTypeName}}\n' +
                '                                        </ui-select-match>\n' +
                '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
                '                                            <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
                '                                        </ui-select-choices>\n' +
                '                                    </ui-select>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div ng-if="vm.showCondition" class="col-xs-3">\n' +
                '                                <div class="form-group">\n' +
                '                                    <ui-select ng-model="vm.condition" id="condition_field" theme="bootstrap">\n' +
                '                                        <ui-select-match\n' +
                '                                        placeholder="Select or search a condition...">\n' +
                '                                            {{$select.selected.name}}\n' +
                '                                        </ui-select-match>\n' +
                '                                        <ui-select-choices repeat="item in vm.conditions | filter: {name: $select.search}">\n' +
                '                                            <div ng-bind-html="item.name | highlight: $select.search"></div>\n' +
                '                                        </ui-select-choices>\n' +
                '                                    </ui-select>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div class="col-xs-2 form-group-filter" >\n' +
                '                                <div class="form-group">\n' +
                '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
                '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
                '                                    </button>\n' +
                '                                </div>\n' +
                '                                <div class="form-group">\n' +
                '                                    <i class="fa fa-question-circle" uib-tooltip="Filter to apply/change your commands/macros selection" tooltip-placement="bottom"' +
                '                                       tooltip-is-open="vm.showWarn"></i></th>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                        </div>\n' +
                '                    </div>\n' +
                '                </form>\n' +
                '            </div>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>',
            controller: MultipleComFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    MultipleComFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabObjectsConditions'];

    function MultipleComFilterController(TabFleets, TabObjectTypes, TabObjectsConditions) {
        var vm = this;
        var allFleet = {
            id: -1,
            fleetName: "All Fleet"
        };
        var allObjectType = {
            id: -1,
            objectTypeName: "All Object Type"
        };
        var allConditions = {
            id: -1,
            name: "All Conditions"
        };
        var mappedObjectType = {};

        vm.objectTypes = [];
        vm.showWarn = false;

        if(vm.showCondition) {
            vm.conditions = TabObjectsConditions.query();
            vm.conditions.$promise.then(function (data) {
                if (!vm.removeOptionAll)
                    data.unshift(allConditions);
                vm.submit();
            });

            if (!vm.condition.name) {
                vm.condition = allConditions;
            }
        } else  {
            vm.condition = allConditions;
        }

        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.fleets.$promise.then(function (data) {
            if(!vm.removeOptionAll)
                data.unshift(allFleet);
            // vm.fleets = data;
            if(!vm.showCondition)
                vm.submit();
        });

        TabObjectTypes.mapped().$promise.then(function (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectTypes();

            if(vm.fleets.$promise) {
                vm.fleets.$promise.then(function () {
                    if (vm.fleet.id > 0) {
                        vm.fleets.forEach(function (f) {
                            if (f.id == vm.fleet.id)
                                vm.fleet = f;
                        });
                        if (vm.fleet.fleetName == undefined || vm.fleet.fleetName == null) {
                            vm.fleet = allFleet;
                        }
                    } else  if (vm.removeOptionAll) {
                        vm.fleet = vm.fleets[0];
                        vm.objectTypes = mappedObjectType[vm.fleet.id];
                    } else {
                        vm.fleet = allFleet;
                    }
                });
            }

            vm.objectTypes = mappedObjectType[vm.fleet.id];
            if(vm.fleet.id == undefined || vm.fleet.id == null){
                if(vm.objectTypes == undefined){
                    vm.objectTypes = [];
                }
                vm.objectTypes.push(allObjectType);
            }

            if (vm.objectType.id > 0) {
                vm.objectTypes.forEach(function (o) {
                    if (o.id == vm.objectType.id)
                        vm.objectType = o;
                });
                if (vm.objectType.objectTypeName == undefined || vm.objectType.objectTypeName == null) {
                    vm.objectType=allObjectType;
                }
            } else if(vm.objectTypes != null && vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            } else
                vm.objectType = allObjectType;
        });

        vm.updateShowWarning = function () {
            vm.showWarn = true;
        }

        vm.onFleetSelect = function (fleet) {
            vm.updateShowWarning();
            vm.objectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.objectTypes.length > 0 && !vm.removeOptionAll) {
                vm.objectType = allObjectType;
            } else if(vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            }
        };

        vm.submit = function () {
            vm.filter({fleet: vm.fleet, objectType: vm.objectType, condition: vm.condition, showWarn: vm.showWarn});
        };

        function mapObjectTypes() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0 && !vm.removeOptionAll) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }

        }

    }
})();

;
(function () {
    'use strict';

    angular.module('jotApp')
        .directive('objectFilter', dashboardFilter);

    function dashboardFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                fleetVal: '&',
                objectStateVal: '&',
                objectTypeVal: '&',
                networkVal: '&',
                releaseVal: '&',
                monitorVal: '&'
            },
            template: '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="fleet_field">Fleet</label>\n' +
            '                                    <ui-select ng-model="vm.fleet" theme="bootstrap" id="fleet_field" on-select="vm.onFleetSelect($item)">\n' +
            '                                        <ui-select-match placeholder="Select or search a fleet..">\n' +
            '                                            {{$select.selected.fleetName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.fleets | propsFilter: {fleetName: $select.search, fleetDescription: $select.search}">\n' +
            '                                            <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                            <small ng-bind-html="item.fleetDescription | highlight: $select.search"></small>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="objectType_field">Object Type</label>\n' +
            '                                    <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
            '                                            placeholder="Select or search an object type...">\n' +
            '                                            {{$select.selected.objectTypeName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                            <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                        <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_state">States</label>\n' +
            '                                    <select class="form-control" id="field_state" required name="states" ng-model="vm.objectState"\n chosen disable-search="true"' +
            '                                            ng-options="objectState as (objectState.objectStateName | uppercase) for objectState in vm.objectStates track by objectState.id "></select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                   <div class="form-group">\n' +
            '                                       <label for="field_release">Release Status</label>\n' +
            '                                       <select class="form-control" id="field_release"  name="release" ng-model="vm.release"\n chosen disable-search="true"' +
            '                                            ng-options="release as (release.value | uppercase) for release in vm.updateFilter track by release.id"></select>\n' +
            '                                   </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_network">Network Status</label>\n' +
            '                                    <select class="form-control" id="field_network" required name="network" ng-model="vm.network"\n chosen disable-search="true"' +
            '                                            ng-options="network as (network.value | uppercase) for network in vm.onlineFilter track by network.id "></select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                   <div class="form-group">\n' +
            '                                       <label for="field_monitor">Monitoring status</label>\n' +
            '                                       <select class="form-control" id="field_monitor"  name="monitor" ng-model="vm.monitor"\n chosen disable-search="true"' +
            '                                            ng-options="monitor as (monitor.value | uppercase) for monitor in vm.trackedFilter track by monitor.id"></select>\n' +
            '                                   </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: ObjectFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ObjectFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabObjectStates'];

    function ObjectFilterController(TabFleets, TabObjectTypes, TabObjectStates) {
        var vm = this;
        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.fleets.$promise.then(function (data) {
            data.unshift(allFleet);
        });

        TabObjectTypes.mapped().$promise.then(function (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectTypes();
            vm.objectTypes = mappedObjectType[vm.fleet.id];
        });

        var allFleet = {
            id: -1,
            fleetName: "All"
        };
        var allStates = {
            id: -1,
            objectStateName: "All"
        };
        var allObjectType = {
            id: -1,
            objectTypeName: "All"
        };
        var mappedObjectType = {};
        vm.onlineFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'ONLINE', query: true}, {
            id: 2,
            value: 'OFFLINE',
            query: false
        }];
        vm.updateFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'TO UPDATE', query: true}, {
            id: 2,
            value: 'UPDATED',
            query: false
        }];
        vm.trackedFilter = [{id: -1, value: 'ALL'}, {id: 1, value: 'TRACKED', query: true}, {
            id: 2,
            value: 'UNTRACKED',
            query: false
        }];
        vm.network = +vm.networkVal() === -1 || +vm.networkVal().id === -1 ? vm.onlineFilter[0] : vm.onlineFilter[+vm.networkVal().id];
        vm.release = +vm.releaseVal() === -1 || +vm.releaseVal().id === -1 ? vm.updateFilter[0] : vm.updateFilter[+vm.releaseVal().id];
        vm.monitor = +vm.monitorVal() === -1 || +vm.monitorVal().id === -1 ? vm.trackedFilter[0] : vm.trackedFilter[+vm.monitorVal().id];
        vm.objectState = +vm.objectStateVal() === -1 || +vm.objectStateVal().id === -1 ? allStates : vm.objectStateVal();
        vm.fleet = +vm.fleetVal() === -1 || +vm.fleetVal().id === -1 ? allFleet : vm.fleetVal();
        vm.objectType = +vm.objectTypeVal() === -1 || +vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();
        vm.objectTypes = [];

        vm.objectStates = TabObjectStates.query();
        vm.objectStates.$promise.then(function (data) {
            data.unshift(allStates);
        });


        vm.onFleetSelect = function (fleet) {
            vm.objectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.objectTypes.length > 0) {
                vm.objectType = allObjectType;
            }
        };

        vm.submit = function () {
            vm.filter({
                fleet: vm.fleet,
                objectType: vm.objectType,
                state: vm.objectState,
                update: vm.release,
                online: vm.network,
                tracked: vm.monitor
            });
        };

        function mapObjectTypes() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }

        }

    }
})();

;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('objectTypeFilter', objectTypeFilter);

    function objectTypeFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                device: '&',
                deviceVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_device">Device</label>\n' +
            '                                       <ui-select ng-model="vm.device" id="device_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a device...">\n' +
            '                                           {{$select.selected.deviceName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabDevices | filter: {deviceName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.deviceName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: ObjectTypeFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ObjectTypeFilterController.$inject = ['TabDevices'];

    function ObjectTypeFilterController(TabDevices) {
        var vm=this;
        TabDevices.query({size: 1000}, onSuccessDevice, onError);


        function onSuccessDevice(data) {
            vm.tabDevices = data;
            vm.tabDevices.unshift(allTabDevices);
        }

        function onError() {}

        var allTabDevices = {
            id: -1,
            deviceName: "All"
        };

        vm.device = +vm.deviceVal() === -1 || +vm.deviceVal().id === -1 ? allTabDevices : vm.deviceVal();

        vm.submit = function () {
            vm.filter({device: vm.device});
        };

    }
})();
;
(function () {

    'use-strict';

    angular
        .module('jotApp')
        .directive('recursiveRow', RecursiveRow);

    RecursiveRow.$inject = ['$timeout', '$state', '$uibModal'];

    function RecursiveRow($timeout, $state, $uibModal)
    {
        var directive = {
            restrict: 'A',
            templateUrl: 'app/entities/tab-object-types/recursive-row.html',
            scope: {
                model: '=',
                visibility: '='
            },
            link: function (scope, el, attrs)
            {
                scope.toggleChildren = function (model){
                    model.childrenVisible = !model.childrenVisible;
                    model.folderClass = model.childrenVisible ? "fa-minus-square":"fa-plus-square";
                };
                scope.clickHere = function(array){
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-object-types/insert-object.html',
                        controller: 'InsertObjectMappingType',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function () {
                        var newObject = localStorage.getItem("insert-new-object");
                        if(newObject != null && newObject != "null" && newObject != undefined){
                            newObject = JSON.parse(newObject);
                        }
                        localStorage.setItem("insert-new-object", JSON.stringify({}));
                        array.push(newObject);
                    });
                    $timeout(function ()
                    {
                        el.replaceWith(el.children());
                    });
                };
                $timeout(function ()
                {
                    el.replaceWith(el.children());
                });
            }
        };
        return directive;
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('scheduleFilter', scheduleFilter);

    function scheduleFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectType: '&',
                objectTypeVal: '&',
                fleet: '&',
                fleetVal: '&',
                fromVal: '&',
                toVal: '&',
                status: '&',
                statusVal: '&',
                tagVal: '&'
            },
            template:
            // '<div class="row">\n' +
            // '    <div class="col-xs-12 col-sm-12 col-md-8">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_fleet">Fleet</label>\n' +
            '                                    <ui-select ng-model="vm.fleet" id="fleet_field" theme="bootstrap" on-select="vm.onFleetSelect($item)" style="z-index: 1000;">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a fleet...">\n' +
            '                                           {{$select.selected.fleetName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_objectType">Object Type</label>\n' +
            '                                       <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search an object type...">\n' +
            '                                           {{$select.selected.objectTypeName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_status">Status</label>\n' +
            '                                    <ui-select ng-model="vm.status" id="field_status" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search a status...">\n' +
            '                                           {{$select.selected.scheduleStatusName}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.scheduleStatus | filter: {scheduleStatusName: $select.search}">\n' +
            '                                           <div ng-bind-html="item.scheduleStatusName | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_tag">Tag</label>\n' +
            '                                    <input type="text" class="form-control" name="tag" id="field_tag" ng_model="vm.tag"/>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                       <div class="row">\n' +
            '                           <div class="col-xs-10">\n' +
            '                               <div class="form-group">\n' +
            '                                   <label for="range">Range</label>\n' +
            '                                       <div class="input-group" id="range">\n' +
            '                                           <span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span>\n' +
            '                                           <input type="text" id="start" class="form-control" ng-click="vm.picker.start=true" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.from" is-open="vm.picker.start"/>\n' +
            '                                           <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span>\n' +
            '                                           <input type="text" id="end" class="form-control" ng-click="vm.picker.end=true" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.to" is-open="vm.picker.end"/>\n' +
            '                                       </div>\n' +
            '                                </div>\n' +
            '                           </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n',
            // '    </div>\n' ,
            // '</div>\n',
            controller: ScheduleFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    ScheduleFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabScheduleStatus'];

    function ScheduleFilterController(TabFleets, TabObjectTypes, TabScheduleStatus) {
        var vm = this;
        vm.tabFleets = TabFleets.query();

        vm.tabFleets.$promise.then(function (data) {
            data.unshift(allFleet);
        });
        var mappedObjectType = {};

        TabObjectTypes.mapped(onSuccess, onError);

        function onSuccess (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectType();
            vm.tabObjectTypes = mappedObjectType[vm.fleet.id];
        }

        function onError() {}

        var allFleet = {
            id: -1,
            fleetName: 'All'
        };

        var allObjectType = {
            id: -1,
            objectTypeName: 'All'
        };

        var allScheduleStatus = {
            id: -1,
            scheduleStatusName: 'All'
        };

        vm.onFleetSelect = function (fleet) {
            vm.tabObjectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.tabObjectTypes.length > 0) {
                vm.objectType = allObjectType;
            }
        };

        vm.scheduleStatus = TabScheduleStatus.query();
        vm.statusFiltered = [];
        vm.scheduleStatus.$promise.then(function (data) {
            data.unshift(allScheduleStatus);
        });

        var it = JSON.parse(localStorage.getItem("first-access"));
        if(!it.firstAccess) {
            vm.fleet = allFleet;
            vm.objectType = allObjectType;
            vm.status =allScheduleStatus;
            vm.from = previousYear();
            vm.to = today();
            vm.tag = "";
        } else {
            vm.fleet = +vm.fleetVal() === -1 || +vm.fleetVal().id === -1 ? allFleet : vm.fleetVal();
            vm.objectType = +vm.objectTypeVal() === -1 || +vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();
            vm.status = +vm.statusVal() === -1 || +vm.statusVal().id === -1 ? allScheduleStatus : vm.statusVal();
            var filter = JSON.parse(localStorage.getItem("save-filter"));
            vm.from = new Date(filter.from);
            vm.to = new Date(filter.to);
            vm.tag =  filter.tag;
        }

        function mapObjectType() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }
        }
        function previousYear() {
            return new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
        }

        function today(){
            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
        }

        vm.submit = function () {
            var filter = {};
            filter.from = angular.copy(vm.from);
            filter.to = angular.copy(vm.to);
            filter.tag = angular.copy(vm.tag);
            localStorage.setItem('save-filter', JSON.stringify(filter));
            vm.filter({
                fleet: vm.fleet,
                objectType: vm.objectType,
                from: vm.from,
                to: vm.to,
                status: vm.status,
                tag: vm.tag
            });
        };
    }
})();
;
angular.module('jotApp').directive('tableScrollDetection', function () {
    return function () {
       $('.table-scrollable-vertical').on('scroll', function (){
           $("body > .dropdown-menu").hide();
       })
    };
});
;
(function () {

    'use-strict';

    angular
        .module('jotApp')
        .directive('typesMapping', TypesMapping);

    TypesMapping.$inject = [];

    function TypesMapping()
    {
        var directive = {
            restrict: 'E',
            scope: {
                type: '='
            },
            template: '<div class="{{vm.styleSelect}}">' +
                      '<label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyDataType" for="field_data_type">Field Data Type</label>' +
                      '<ui-select ng-model="vm.selectedType" id="field_data_type" theme="bootstrap" ng-change="vm.changeFieldDataType()" ng-required="true">\n' +
                      '     <ui-select-match placeholder="Select a field data type...">\n' +
                      '          {{$select.selected.name}}\n' +
                      '     </ui-select-match>\n' +
                      '     <ui-select-choices group-by="vm.parent" repeat="item in vm.elasticTypes | propsFilter: {name: $select.search, description: $select.search}">\n' +
                      '          <div ng-bind-html="item.name | highlight: $select.search"></div>\n' +
                      '          <small ng-bind-html="item.description | highlight: $select.search"></small>\n' +
                      '     </ui-select-choices>\n' +
                      '</ui-select>\n' +
                      '</div>\n' +
                      '<div class="{{vm.styleSelect}}" ng-if="vm.showType">' +
                      '<label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyType" for="field_type">Type</label>' +
                      '<ui-select ng-model="vm.selectedValue" id="field_type" theme="bootstrap" ng-change="vm.changeType()" ng-required="true">\n' +
                      '     <ui-select-match placeholder="Select a type...">\n' +
                      '          {{$select.selected}}\n' +
                      '     </ui-select-match>\n' +
                      '     <ui-select-choices repeat="type in vm.value | filter: $select.search">\n' +
                      '          <div ng-bind-html="type | highlight: $select.search"></div>\n' +
                      '     </ui-select-choices>\n' +
                      '</ui-select>\n' +
                     '</div>' +
                     '<div class="{{vm.styleSelect}}" ng-if="vm.showDateFormat">\n' +
                     '      <label translate="jotApp.tabObjectTypes.mapping.formatDate" for="field_format">Format (Optional)</label>\n' +
                     '      <input type="text" class="form-control" id="field_format" ng-model="vm.format" placeholder="yyyy-MM-ddTHH:mm:ssZ" ng-change="vm.updateFormat()">' +
                     '</div>',
            controller: TypesMappingDirectiveController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    TypesMappingDirectiveController.$inject = [];

    function TypesMappingDirectiveController() {
        var vm = this;

        vm.type = "";
        vm.selectedType = [];
        vm.styleSelect = 'col-md-12 col-xs-12';
        vm.showType = false;
        vm.value = [];
        vm.selectedValue = "";

        vm.showDateFormat = false;
        vm.format = "";

        vm.elasticTypes = [];

        vm.elasticTypes.push({parent: "Core data types", name: "string", description: "text, keyword", value: ["text", "keyword"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Numeric", description: "long, integer, short, byte, double, float, half_float, scaled_float", value: ["long", "integer", "short", "byte", "double", "float", "half_float", "scaled_float"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Date", description: "date", value: ["date"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Date nanoseconds", description: "date_nanos", value: ["date_nanos"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Boolean", description: "boolean", value: ["boolean"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Binary", description: "binary", value: ["binary"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Range", description: "integer_range, float_range, long_range, double_range, date_range, ip_range", value: ["integer_range", "float_range", "long_range", "double_range", "date_range", "ip_range"]});

        vm.elasticTypes.push({parent: "Complex data types", name: "Object", description: "object for single JSON objects", value: ["object"]});
        vm.elasticTypes.push({parent: "Complex data types", name: "Nested", description: "nested for arrays of JSON objects", value: ["nested"]});

        vm.elasticTypes.push({parent: "Geo data types", name: "Geo-point", description: "geo_point for lat/lon points", value: ["geo_point"]});
        vm.elasticTypes.push({parent: "Geo data types", name: "Geo-shape", description: "geo_shape for complex shapes like polygons", value: ["geo_shape"]});

        vm.elasticTypes.push({parent: "Specialised data types", name: "IP", description: "ip for IPv4 and IPv6 addresses", value: ["ip"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Completion data type", description: "completion to provide auto-complete suggestions", value: ["completion"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Token count", description: "token_count to count the number of tokens in a string", value: ["token_count"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "mapper-murmur3", description: "murmur3 to compute hashes of values at index-time and store them in the index", value: ["murmur3"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "mapper-annotated-text", description: "annotated-text to index text containing special markup (typically used for identifying named entities)", value: ["annotated-text"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Percolator", description: "Accepts queries from the query-dsl", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Join", description: "Defines parent/child relation for documents within the same index", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Rank feature", description: "Record numeric feature to boost hits at query time.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Rank features", description: "Record numeric features to boost hits at query time.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Dense vector", description: "Record dense vectors of float values.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Sparse vector", description: "Record sparse vectors of float values.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Search-as-you-type", description: "A text-like field optimized for queries to implement as-you-type completion", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Alias", description: "Defines an alias to an existing field.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Flattened", description: "Allows an entire JSON object to be indexed as a single field.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Shape", description: "shape for arbitrary cartesian geometries.", value: ["shape"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Histogram", description: "histogram for pre-aggregated numerical values for percentiles aggregations.", value: ["histogram"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Constant keyword", description: "Specialization of keyword for the case when all documents have the same value.", value: ["keyword"]});

        vm.parent = function(item) {
            return item.parent;
        };

        vm.changeFieldDataType = function() {
            vm.value = [];
            vm.selectedValue = "";
            vm.showDateFormat = false;
            vm.format = "";
            vm.styleSelect = cssClassType();
            vm.value = vm.selectedType.value;
            if(vm.value.length == 1){
                vm.selectedValue = vm.value[0];
                vm.changeType();
            }
        };

        function cssClassType() {
            if(vm.selectedType != null && vm.selectedType != undefined){
                if(vm.selectedType.value.length > 1 && vm.selectedType.value != null){
                    vm.showType = true;
                    return 'col-md-6 col-xs-12'
                }
            }
            vm.showType = false;
            return 'col-md-12 col-xs-12'
        }

        vm.changeType = function() {
            vm.type = vm.selectedValue;
            if(vm.type === "date"){
                vm.showDateFormat = true;
                vm.styleSelect = 'col-md-6 col-xs-12';
            }
        };

        vm.updateFormat = function() {
            vm.type = vm.type.substring(0, 4);
            vm.type += " (" + vm.format + ")";
        };
    }

})();
;
'use strict';

/**
 * 0.1.1
 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
 *
 * It is possible to specify a default set of parameters for each jQuery plugin.
 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
 * Unfortunately, at this time you can only pre-define the first parameter.
 * @example { jq : { datepicker : { showOn:'click' } } }
 *
 * @param ui-jq {string} The $elm.[pluginName]() to call.
 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
 *     Multiple parameters can be separated by commas
 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
 *
 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
 */
angular.module('ui.jq', ['ui.load']).
  value('uiJqConfig', {}).
  directive('uiJq', ['uiJqConfig', 'JQ_CONFIG', 'uiLoad', '$timeout', function uiJqInjectingFunction(uiJqConfig, JQ_CONFIG, uiLoad, $timeout) {

      return {
          restrict: 'A',
          compile: function uiJqCompilingFunction(tElm, tAttrs) {

              if (!angular.isFunction(tElm[tAttrs.uiJq]) && !JQ_CONFIG[tAttrs.uiJq]) {
                  throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
              }
              var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];

              return function uiJqLinkingFunction(scope, elm, attrs) {

                  function getOptions(){
                      var linkOptions = [];

          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
                      if (attrs.uiOptions) {
                          linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
                          if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
                              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
                          }
                      } else if (options) {
                          linkOptions = [options];
                      }
                      return linkOptions;
                  }

        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
                  if (attrs.ngModel && elm.is('select,input,textarea')) {
                      elm.bind('change', function() {
                          elm.trigger('input');
                      });
                  }

        // Call jQuery method and pass relevant options
                  function callPlugin() {
                      $timeout(function() {
                          elm[attrs.uiJq].apply(elm, getOptions());
                      }, 0, false);
                  }

                  function refresh(){
          // If ui-refresh is used, re-fire the the method upon every change
                      if (attrs.uiRefresh) {
                          scope.$watch(attrs.uiRefresh, function() {
                              callPlugin();
                          });
                      }
                  }

                  if ( JQ_CONFIG[attrs.uiJq] ) {
                      uiLoad.load(JQ_CONFIG[attrs.uiJq]).then(function() {
                          callPlugin();
                          refresh();
                      }).catch(function() {
            
                      });
                  } else {
                      callPlugin();
                      refresh();
                  }
              };
          }
      };
  }]);
;
'use strict';

/**
 * 0.1.1
 * Deferred load js/css file, used for ui-jq.js and Lazy Loading.
 * 
 * @ flatfull.com All Rights Reserved.
 * Author url: http://themeforest.net/user/flatfull
 */

angular.module('ui.load', [])
	.service('uiLoad', ['$document', '$q', '$timeout', function ($document, $q, $timeout) {

		                                        var loaded = [];
		                                        var promise = false;
		                                        var deferred = $q.defer();

		/**
		 * Chain loads the given sources
		 * @param srcs array, script or css
		 * @returns {*} Promise that will be resolved once the sources has been loaded.
		 */
		                                        this.load = function (srcs) {
			                                        srcs = angular.isArray(srcs) ? srcs : srcs.split(/\s+/);
			                                        var self = this;
			                                        if(!promise){
				                                        promise = deferred.promise;
			}
    angular.forEach(srcs, function(src) {
      	                      promise = promise.then( function(){
      		                                        return src.indexOf('.css') >=0 ? self.loadCSS(src) : self.loadScript(src);
      	} );
    });
    deferred.resolve();
    return promise;
		};

		/**
		 * Dynamically loads the given script
		 * @param src The url of the script to load dynamically
		 * @returns {*} Promise that will be resolved once the script has been loaded.
		 */
		                                        this.loadScript = function (src) {
			                                        if(loaded[src]) return loaded[src].promise;

			                                        var deferred = $q.defer();
			                                        var script = $document[0].createElement('script');
			                                        script.src = src;
			                                        script.onload = function (e) {
				                                        $timeout(function () {
					                                        deferred.resolve(e);
				});
			};
			                                        script.onerror = function (e) {
				                                        $timeout(function () {
					                                        deferred.reject(e);
				});
			};
			                                        $document[0].body.appendChild(script);
			                                        loaded[src] = deferred;

			                                        return deferred.promise;
		};

		/**
		 * Dynamically loads the given CSS file
		 * @param href The url of the CSS to load dynamically
		 * @returns {*} Promise that will be resolved once the CSS file has been loaded.
		 */
		                                        this.loadCSS = function (href) {
			                                        if(loaded[href]) return loaded[href].promise;

			                                        var deferred = $q.defer();
			                                        var style = $document[0].createElement('link');
			                                        style.rel = 'stylesheet';
			                                        style.type = 'text/css';
			                                        style.href = href;
			                                        style.onload = function (e) {
				                                        $timeout(function () {
					                                        deferred.resolve(e);
				});
			};
			                                        style.onerror = function (e) {
				                                        $timeout(function () {
					                                        deferred.reject(e);
				});
			};
			                                        $document[0].head.appendChild(style);
			                                        loaded[href] = deferred;

			                                        return deferred.promise;
		};
}]);
;
angular.module('jotApp')
  .directive('uiNav', ['$timeout', function($timeout) {
      return {
          restrict: 'AC',
          link: function(scope, el, attr) {
              var _window = $(window),
                  _mb = 768,
                  wrap = $('.app-aside'),
                  next,
                  backdrop = '.dropdown-backdrop';
        // unfolded
              el.on('click', 'a', function(e) {
                  next && next.trigger('mouseleave.nav');
                  var _this = $(this);
                  _this.parent().siblings( ".active" ).toggleClass('active');
                  _this.next().is('ul') &&  _this.parent().toggleClass('active') &&  e.preventDefault();
          // mobile
                  _this.next().is('ul') || ( ( _window.width() < _mb ) && $('.app-aside').removeClass('show off-screen') );
              });

        // folded & fixed
              el.on('mouseenter', 'a', function(e){
                  next && next.trigger('mouseleave.nav');
                  $('> .nav', wrap).remove();
                  if ( !$('.app-aside-fixed.app-aside-folded').length || ( _window.width() < _mb ) || $('.app-aside-dock').length) return;
                  var _this = $(e.target)
          , top
          , w_h = $(window).height()
          , offset = 50
          , min = 150;

                  !_this.is('a') && (_this = _this.closest('a'));
                  if( _this.next().is('ul') ){
                      next = _this.next();
                  }else{
                      return;
                  }

                  _this.parent().addClass('active');
                  top = _this.parent().position().top + offset;
                  next.css('top', top);
                  if( top + next.height() > w_h ){
                      next.css('bottom', 0);
                  }
                  if(top + min > w_h){
                      next.css('bottom', w_h - top - offset).css('top', 'auto');
                  }
                  next.appendTo(wrap);

                  next.on('mouseleave.nav', function(e){
                      $(backdrop).remove();
                      next.appendTo(_this.parent());
                      next.off('mouseleave.nav').css('top', 'auto').css('bottom', 'auto');
                      _this.parent().removeClass('active');
                  });

                  $('.smart').length && $('<div class="dropdown-backdrop"/>').insertAfter('.app-aside').on('click', function(next){
                      next && next.trigger('mouseleave.nav');
                  });

              });

              wrap.on('mouseleave', function(e){
                  next && next.trigger('mouseleave.nav');
                  $('> .nav', wrap).remove();
              });
          }
      };
  }]);
;
angular.module('jotApp')
    .directive('uiToggleClass', ['$timeout', '$document', function ($timeout, $document) {
        return {
            restrict: 'AC',
            link: function (scope, el, attr) {
                el.on('click', function (e) {
                    e.preventDefault();
                    var classes = attr.uiToggleClass.split(','),
                        targets = (attr.target && attr.target.split(',')) || Array(el),
                        key = 0;
                    angular.forEach(classes, function (_class) {
                        var target = targets[(targets.length && key)];
                        ( _class.indexOf('*') !== -1 ) && magic(_class, target);
                        $(target).toggleClass(_class);
                        key++;
                    });
                    $(el).toggleClass('active');

                    function magic(_class, target) {
                        var patt = new RegExp('\\s' +
                            _class.
                            replace(/\*/g, '[A-Za-z0-9-_]+').
                            split(' ').
                            join('\\s|\\s') +
                            '\\s', 'g');
                        var cn = ' ' + $(target)[0].className + ' ';
                        while (patt.test(cn)) {
                            cn = cn.replace(patt, ' ');
                        }
                        $(target)[0].className = $.trim(cn);
                    }
                });
            }
        };
    }]);
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .filter('utcToLocal', Filter);

    function Filter($filter) {
        return function (utcDateString, format) {
            // return if input date is null or undefined
            if (!utcDateString) {
                return;
            }

            // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            // convert and format date using the built in angularjs date filter
            return $filter('date')(utcDateString, format);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertsConfigurationController', AlertsConfigurationController);

    AlertsConfigurationController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'AlertRules', '$state', '$uibModalInstance', 'AlertService', 'TabDomains', '$rootScope'];

    function AlertsConfigurationController($timeout, $scope, $stateParams, entity, AlertRules, $state, $uibModalInstance, AlertService, TabDomains, $rootScope) {
        var vm = this;
        vm.warning = entity;
        vm.throttleUnit = ["minutes", "hours", "days", "weeks"];
        vm.licence = $rootScope.licence;

        vm.warning.$promise.then(function () {
            vm.setAlertConf();
        });

        TabDomains.current(function (result) {
            vm.domain = result;
        });

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.setAlertConf = function() {
            vm.alertUsers = [];
            vm.email = {};
            vm.slack = {};
            vm.telegram = {};
            vm.webhook = {};
            vm.email.exist = false;
            vm.slack.exist = false;
            vm.telegram.exist = false;
            vm.webhook.exist = false;
            vm.warning.warningAlertConfigurations.forEach(function (wac) {
                vm[wac.alertSystemType.name].exist = true;
                vm[wac.alertSystemType.name].wac = wac;
                if(wac.throttlePeriod < 60) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod;
                    vm[wac.alertSystemType.name].time = "minutes";
                } else if(wac.throttlePeriod < (3600)) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / 60;
                    vm[wac.alertSystemType.name].time = "hours";
                } else if(wac.throttlePeriod < (3600 * 24 )) {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / (60 * 24);
                    vm[wac.alertSystemType.name].time = "days";
                } else {
                    vm[wac.alertSystemType.name].throttle = wac.throttlePeriod / (60 * 24 * 7);
                    vm[wac.alertSystemType.name].time = "weeks";
                }
                if(wac.active)
                    vm[wac.alertSystemType.name].active = true;
            });
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:warningUpdate', result);
            vm.isSaving = false;
            vm.warning = result;
            vm.setAlertConf();
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function (type) {
            vm.isSaving = true;
            vm.channel = {};
            vm.channel.alertSystemType = {};
            vm.channel.alertSystemType.name = type;
            vm.channel.active = true;
            vm.channel.warning = vm.warning;
            AlertRules.insertAlerts({warningAlertConfiguration : vm.channel, warning: vm.warning, users:vm.alertUsers}, onSaveSuccess, onSaveError);
        };

        vm.deleteAlert = function(type) {
            AlertRules.deleteAlerts({warningAlertConfiguration : vm[type].wac, warning: vm.warning}, onSaveSuccess, onSaveError);
        };

        vm.toggleStatus = function (type) {
            if(vm[type].exist) {
                vm[type].wac.active = !vm[type].wac.active;
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm[type].wac,
                    warning: vm.warning
                }, function (result) {
                    vm.warning = result;
                });
                vm[type].active = !vm[type].active;
            } else {
                vm.save(type);
            }
        };

        vm.saveThrottle = function (type, allWarning) {
            if(vm[type].throttle == undefined) {
                AlertService.error("Throttle time must be between 1 and 59");
            } else {
                if (vm[type].time == "minutes") {
                    vm[type].wac.throttlePeriod = vm[type].throttle;
                } else if (vm[type].time == "hours") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60;
                } else if (vm[type].time == "days") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60 * 24;
                } else if (vm[type].time == "weeks") {
                    vm[type].wac.throttlePeriod = vm[type].throttle * 60 * 24 * 7;
                }
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm[type].wac,
                    warning: vm.warning,
                    allWarning: allWarning
                }, function (result) {
                    vm.warning = allWarning ? result.warning : result;
                    AlertService.success(allWarning ? "Throttle time saved for all alert" : "Throttle time saved");
                }, function () {
                    AlertService.error("Error saving throttle");
                });
            }
        };

        vm.goToSettings = function () {
            $state.go('general-settings');
            vm.clear();
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningLevelController', WarningLevelController);

    WarningLevelController.$inject = ['entity','$uibModalInstance', 'Warning'];

    function WarningLevelController(entity, $uibModalInstance, Warning) {
        var vm = this;
        vm.warning = entity;

        vm.criticals = [
            {id: 1, name: "1 - LOW"},
            {id: 2, name: "2 - CRITICAL"}
            ];

        vm.critical = vm.criticals.find(function (value) {
            return value.id === vm.warning.critical;
        });

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.update = function () {
            vm.warning.critical  = vm.critical.id;
            vm.warning.active = !vm.warning.active;
            vm.warning.critical  = vm.critical.id;
            Warning.update(vm.warning);
            vm.clear();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningUserProfileController', WarningUserProfileController);

    WarningUserProfileController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'UserProfile', '$state', '$uibModalInstance', 'Warning'];

    function WarningUserProfileController($timeout, $scope, $stateParams, entity, UserProfile, $state, $uibModalInstance, Warning) {
        var vm = this;
        vm.warning = entity;
        vm.userProfiles = UserProfile.alertsProfile();
        vm.profile = vm.warning.userProfile;

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.update = function () {
            vm.warning.userProfile  = vm.profile;
            Warning.update(vm.warning);
            vm.clear();
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertRulesController', AlertRulesController);

    AlertRulesController.$inject = ['$uibModal', '$state', 'AlertRules', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'WarningConstant', 'domain', 'AlertSystem', '$rootScope', '$timeout'];

    function AlertRulesController($uibModal, $state, AlertRules, ParseLinks, AlertService, pagingParams, paginationConstants, WarningConstant, domain, AlertSystem, $rootScope, $timeout) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.loadSystemPage = loadSystemPage;
        vm.changePageSize = changePageSize;
        vm.tooggleStatus = tooggleStatus;
        vm.enableTooltip = enableTooltip;

        vm.predicates = pagingParams.predicates;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.currentState = "alert-rule";
        vm.systemWarningItemLimit = 4;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);

        }
        retrievedOrder = localStorage.getItem(vm.currentState + "system");
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.systemPredicates = JSON.parse(retrievedOrder);

        }
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedCondition = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedFleets = [];
        vm.applyFilter = applyFilter;
        vm.transition = transition;
        vm.loadAll();
        vm.enableMail = [];
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.wac = [];
        vm.licence = $rootScope.licence;
        vm.domain = domain;

        function enableTooltip(channel, id) {
            vm[channel][id].tooltip = true;
            $timeout(function () {
                vm[channel][id].tooltip = false;
            }, 2000);
        }

        function sort(predicates, type) {
            var sortFields = [];
            var keys = Object.keys(predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState + type, JSON.stringify(predicates));
            return sortFields;
        }

        function loadAll() {

            AlertRules.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                query: vm.charToSearch,
                sort: sort(vm.predicates, "")
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warnings = data.warnings;
                vm.notifications = data.notification;
                vm.page = pagingParams.page;
                enableAlertSystem(vm.warnings);
                AlertSystem.getUserAlertSystem({user: 'logged'}, onAlertSuccess);
            }

            AlertRules.querySystem({
                page: pagingParams.systemPage - 1,
                size: vm.systemWarningItemLimit,
                fleet: vm.selectedFleet.id,
                sort: sort(vm.systemPredicates, "system")
            }, onSuccessSystem, onError);

            function onSuccessSystem(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.systemTotalItems = headers('X-Total-Count');
                vm.systemQueryCount = vm.systemTotalItems;
                vm.systemWarnings = data.warnings;
                vm.notifications = data.notification;
                vm.systemPage = pagingParams.systemPage;
                enableAlertSystem(vm.systemWarnings);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function enableAlertSystem(warnings) {
            warnings.forEach(function (warning) {
                vm.wac[warning.id] = {};
                vm.wac[warning.id].email = false;
                vm.wac[warning.id].telegram = false;
                vm.wac[warning.id].webhook = false;
                warning.warningAlertConfigurations.forEach(function (wac) {
                    var name = wac.alertSystemType.name;
                    vm.wac[warning.id][name] = wac.active;
                });
                if (!(domain.enableAlerting && domain.mailAlerting))
                    warning.relatedAlertSystemType.Channelemail = vm.wac[warning.id].email = domain.enableAlerting && domain.mailAlerting;
                if (!(domain.enableAlerting && domain.telegramAlerting))
                    warning.relatedAlertSystemType.Channeltelegram = vm.wac[warning.id].telegram = domain.enableAlerting && domain.telegramAlerting;
                if (!(domain.enableAlerting && domain.webhookAlerting))
                    warning.relatedAlertSystemType.Channelwebhook = vm.wac[warning.id].webhook = domain.enableAlerting && domain.webhookAlerting;
                var enableMail = warning.relatedAlertSystemType.email != null && warning.relatedAlertSystemType.email != undefined && warning.relatedAlertSystemType.Channelemail != undefined && warning.relatedAlertSystemType.Channelemail && vm.wac[warning.id].email;
                var enableTelegram = warning.relatedAlertSystemType.telegram != null && warning.relatedAlertSystemType.telegram != undefined && warning.relatedAlertSystemType.Channeltelegram != undefined && warning.relatedAlertSystemType.Channeltelegram && vm.wac[warning.id].telegram;
                var enableWebhook = warning.relatedAlertSystemType.webhook != null && warning.relatedAlertSystemType.webhook != undefined && warning.relatedAlertSystemType.Channelwebhook != undefined && warning.relatedAlertSystemType.Channelwebhook && vm.wac[warning.id].webhook;
                vm.enableMail[warning.id] = vm.setWarningStatus(enableMail, domain.mailAlerting, vm.notifications.warningEmail, warning.relatedAlertSystemType.email, vm.wac[warning.id].email, warning.active);
                vm.enableTelegram[warning.id] = vm.setWarningStatus(enableTelegram, domain.telegramAlerting, vm.notifications.warningTelegram, warning.relatedAlertSystemType.telegram, vm.wac[warning.id].telegram, warning.active);
                vm.enableWebhook[warning.id] = vm.setWarningStatus(enableWebhook, domain.webhookAlerting, vm.notifications.warningWebhook, warning.relatedAlertSystemType.webhook, vm.wac[warning.id].webhook, warning.active);
            });
        }

        vm.setWarningStatus = function (enabled, domainNotification, userNotification, related, wac, warning) {
            var objToReturn = {status: false, config: {}, tooltip: false};
            if (enabled) {
                if (related && domainNotification === true && userNotification === true && warning === true) {
                    objToReturn.status = true;
                    objToReturn.config.color = 'color-green';
                } else {
                    objToReturn.status = true;
                    objToReturn.config.color = 'background-red';
                }
            } else objToReturn.config.color = 'color-grey';
            return objToReturn;
        }

        function onAlertSuccess(results) {
            vm.email = false;
            vm.telegram = false;
            vm.emailDisabled = false;
            vm.telegramDisabled = false;
            vm.webhookDisabled = false;
            results.forEach(function (alert) {
                if (alert.alertSystemType.name == "email") {
                    vm.email = true;
                    vm.userEmail = alert.actionIdentifier;
                    vm.emailDisabled = alert.adminDisabled;
                } else if (alert.alertSystemType.name == "telegram") {
                    vm.telegram = true;
                    vm.telegramDisabled = alert.adminDisabled;
                    vm.userTelegram = alert.actionIdentifier;
                } else if (alert.alertSystemType.name == "webhook") {
                    vm.webhook = true;
                    vm.webhookDisabled = alert.adminDisabled;
                    vm.userWebhok = alert.actionIdentifier;
                }
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function loadSystemPage(page) {
            vm.systemPage = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                systemPredicates: vm.systemPredicates,
                sort: sort(vm.predicates, ""),
                systemPage: vm.systemPage,
                systemSort: sort(vm.systemPredicates, "system"),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };


        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.changeProfile = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-user-profile-dialog.html',
                controller: 'WarningUserProfileController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            });
        };

        vm.changeLevel = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-level-dialog.html',
                controller: 'WarningLevelController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            }).result.then(function () {
                transition(false);
            });
        };

        function tooggleStatus(warning) {
            if (!!warning.active) {
                $uibModal.open({
                    templateUrl: 'app/entities/alert-rules/alert-rules-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/alert-rules/alert-rules-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            }
        }

        vm.openSettings = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-configuration.html',
                controller: 'AlertsConfigurationController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function ($stateParams, AlertRules) {
                        return AlertRules.get({id: id});
                    }]
                }
            }).result.then(function () {
                loadAll();
            });
        };

        vm.changeStatus = function (warning, type, notification, typeToCheck) {
            // check warning flags here to display proper modal
            if (typeToCheck.status && notification === true) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/modals/change-notification-channel.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;
                        vm.warning = warning;
                        vm.type = type;
                        vm.notification = notification;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                    AlertRules.notifications({id: warning.id, type: type}, onChangeSuccess, onChangeError);
                });
            } else {
                vm.rerouteToSettings(vm.notifications, vm.domain, type, typeToCheck);
            }
        };

        vm.rerouteToSettings = function (userNotifications, domain, type, typeToCheck) {
            console.log(userNotifications, domain, type, typeToCheck)
            $uibModal.open({
                templateUrl: 'app/entities/warning/modals/reroute-modal.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;
                    vm.notification = null;
                    vm.warningCondition = null;
                    vm.domain = domain;
                    vm.type = type;
                    vm.typeToCheck = typeToCheck;
                    if (vm.domain.enableAlerting === true) {
                        if (type === 'email') {
                            vm.notification = userNotifications.warningEmail;
                            vm.warningCondition = vm.domain.mailAlerting;
                        } else if (type === 'telegram') {
                            vm.notification = userNotifications.warningTelegram;
                            vm.warningCondition = vm.domain.telegramAlerting;
                        } else {
                            vm.notification = userNotifications.warningWebhook;
                            vm.warningCondition = vm.domain.webhookAlerting;
                        }
                    } else {
                        vm.warningCondition = vm.domain.enableAlerting;
                    }
                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result.then(function () {
                $state.go('general-settings');
            });
        };

        function onChangeSuccess(warning) {
            vm.warnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.warnings);
            vm.systemWarnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.systemWarnings);
        }

        function onChangeError() {

        }

        function applyFilter(fleet, objectType) {
            if (fleet.id) {
                if (fleet.id > 0)
                    vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                }
            } else
                vm.fleet.id = -1;
            if (objectType.id)
                vm.objectType = objectType;
            else
                vm.objectType.id = -1;
            vm.loadAll();
        }

        vm.notificationsHelp = function () {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/notifications-help.html',
                controller: 'NotificationsHelpController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('warning');
            });
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('AlertRules', AlertRules)
        .factory('WarningConstant', WarningConstant);

    AlertRules.$inject = ['$resource'];
    WarningConstant.$inject = ['$resource'];

    function AlertRules($resource) {
        var resourceUrl = 'api/warnings/:id';

        return $resource(resourceUrl, {}, {
            'query': {url: 'api/warnings-rules', method: 'GET'},
            'querySystem': {url: 'api/system-warnings', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getWarningByUser': {
                url: 'api/warnings-user/:login',
                method: 'GET'
            },
            'getSystemWarningByUser': {
                url: 'api/system-warnings-user/:login',
                method: 'GET'
            },
            'update': {method: 'PUT'},
            'insertAlerts': {
                method: 'PUT',
                url: 'api/warnings-alerts'
            },
            'deleteAlerts': {
                method: 'PUT',
                url: 'api/warnings-delete-alerts'
            },
            'notifications': {
                method: 'GET',
                url: 'api/warnings/notification-status/:id/:type'
            },
            'toggleChannel': {
                method: 'PUT',
                url: 'api/warnings-toggle-channel'
            },
            'domainToggleChannel': {
                method: 'GET',
                url: 'api/my-channel-user-toggle/:login/:type/:status'
            },
            'wipAlerts': {
                method: 'GET',
                url: 'api/warnings-wip/:warning/:wip/:objectUniqueCode'
            },
            'requestSendEmail': {url: 'api/warnings/sendEmail', method: 'POST'}
        });
    }

    function WarningConstant($resource) {
        var resourceUrl = 'api/warnings/status';

        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alert-rules', {
            parent: 'alerting',
            url: '/rules?page&sort',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.alertRules.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/alert-rules/alert-rules.html',
                    controller: 'AlertRulesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    squash: true
                },
                systemPage: {
                    value: '1',
                    squash: true
                },
                systemSort: {
                    squash: true
                },
                fleet: {
                    value: -1,
                    fleetName: true
                },
                objectType:{
                    value: -1,
                    squash: true
                },
                search: null,
                predicates : {},
                systemPredicates : {},
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                        systemSort: $stateParams.systemSort,
                        predicates : $stateParams.predicates,
                        systemPredicates : $stateParams.systemPredicates,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('alertRules');
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', function(TabDomains) {
                    return  TabDomains.current();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NotificationsHelpController', NotificationsHelpController);

    NotificationsHelpController.$inject = ['$state', '$uibModalInstance'];

    function NotificationsHelpController($state, $uibModalInstance) {
        var vm = this;

        vm.notifications = [
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-green', description: "Channel configured, active notifications"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'background-red', description: " Channel configured, inactive notification due to stopped rule or disabled notification (single rule or general setting)"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-gray', description: "Not configured or disabled by domain admin"}
        ]

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDeleteController',DashboardManagementDeleteController);

    DashboardManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dashboard'];

    function DashboardManagementDeleteController($uibModalInstance, entity, Dashboard) {
        var vm = this;
        vm.dashboard = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Dashboard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDetailController', DashboardManagementDetailController);

    DashboardManagementDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function DashboardManagementDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.dashboard = entity;

        var unsubscribe = $rootScope.$on('jotApp:dashboardUpdate', function(event, result) {
            vm.dashboard = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDialogController', DashboardManagementDialogController);

    DashboardManagementDialogController.$inject = ['$timeout', '$scope', '$state','entity', 'Dashboard', 'Licences'];

    function DashboardManagementDialogController ($timeout, $scope,$state, entity, Dashboard, Licences) {
        var vm = this;
        vm.dashboard = entity;
        vm.licences = Licences.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:dashboardUpdate', result);
            vm.isSaving = false;
            $state.go('dashboard-management');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.dashboard.id !== null) {
                Dashboard.update(vm.dashboard, onSaveSuccess, onSaveError);
            } else {
                Dashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('dashboard-management');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementController', DashboardManagementController);

    DashboardManagementController.$inject = ['$state', 'Dashboard', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DashboardManagementController($state, Dashboard, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.currentState = "dashboard-management";
        vm.transition = transition;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            Dashboard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource'];

    function Dashboard($resource) {
        var resourceUrl = 'api/dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'mapped': {
                url: 'api/dashboards/mapped',
                method: 'GET'
            },
            'frame': {
                url: 'api/dashboards/frame/:frameReference',
                method: 'GET'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dashboard-management', {
                parent: 'entity',
                url: '/dashboard?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management.html',
                        controller: 'DashboardManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('dashboard-detail', {
                parent: 'dashboard-management',
                url: '/dashboard/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-detail.html',
                        controller: 'DashboardManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Dashboard', function ($stateParams, Dashboard) {
                        return Dashboard.get({id: $stateParams.id});
                    }]
                }
            })
            .state('dashboard-new', {
                parent: 'dashboard-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-dialog.html',
                        controller: 'DashboardManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            name: null,
                            url: null,
                            description: null,
                            frameReference: null,
                            id: null
                        };
                    }
                }
            })
            .state('dashboard-edit', {
                parent: 'dashboard-management',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-dialog.html',
                        controller: 'DashboardManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Dashboard', function ($stateParams, Dashboard) {
                        return Dashboard.get({id: $stateParams.id});
                    }]
                }
            })
            .state('dashboard.delete', {
                parent: 'dashboard-management',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/dashboard/dashboard-management-delete-dialog.html',
                        controller: 'DashboardManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Dashboard', function (Dashboard) {
                                return Dashboard.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('dashboard-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KioskDashboardDeleteController',KioskDashboardDeleteController);

    KioskDashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'KiosksDashboards'];

    function KioskDashboardDeleteController($uibModalInstance, entity, KiosksDashboards) {
        var vm = this;
        vm.dashboard = entity.dashboard;
        vm.kioskId = entity.kioskId;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            KiosksDashboards.deleteFromKiosk({id: id, kioskId: vm.kioskId, order: vm.dashboard.order},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardDeleteController',KiosksDashboardDeleteController);

    KiosksDashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'KiosksDashboards'];

    function KiosksDashboardDeleteController($uibModalInstance, entity, KiosksDashboards) {
        var vm = this;
        vm.dashboard = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            KiosksDashboards.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardDialogController', KiosksDashboardDialogController);

    KiosksDashboardDialogController.$inject = ['$state', '$timeout', '$scope', 'KiosksDashboards', 'TabDomains', 'pagingParams', 'entity'];

    function KiosksDashboardDialogController($state, $timeout, $scope, KiosksDashboards, TabDomains, pagingParams, entity) {
        var vm = this;
        vm.kiosksDashboard = entity;
        vm.domains = TabDomains.query({size: 1000});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:kiosksDashboardUpdate', result);
            vm.isSaving = false;
            $state.go('kiosks-dashboard');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.kiosksDashboard.id) {
                KiosksDashboards.update(vm.kiosksDashboard, onSaveSuccess, onSaveError);
            } else {
                KiosksDashboards.save(vm.kiosksDashboard, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('kiosks-dashboard');
        };

        vm.setGrafanaId = function () {
            vm.kiosksDashboard.grafanaId = vm.dashboard.id;
            vm.kiosksDashboard.name = vm.dashboard.title;
        }

        if(pagingParams.registeredDashboard) {
            vm.enableSelect = true;
            KiosksDashboards.availableDashboard(function (result) {
                vm.grafanaDashboard = result;
                pagingParams.registeredDashboard.forEach(function (dash) {
                    vm.grafanaDashboard.splice(dash, 1);
                })
            });
        }  else {
            vm.enableSelect = false;
            vm.dashboard = vm.kiosksDashboard;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardKioskController', KiosksDashboardKioskController);

    KiosksDashboardKioskController.$inject = ['$state', '$timeout', '$scope', 'pagingParams', 'Kiosks', '$uibModal'];

    function KiosksDashboardKioskController($state, $timeout, $scope, pagingParams, Kiosks, $uibModal) {
        var vm = this;

        vm.dashboardList = pagingParams.selectedDashboards;
        vm.kiosksDashboardkiosk = pagingParams.kiosk;
        vm.currentState = "kiosk-dashboard-kiosk";
        vm.preselect = {};
        vm.kiosk = localStorage.getItem(vm.currentState);
        if (vm.kiosk !== null && vm.kiosk !== "null" && vm.kiosk !== undefined) {
            vm.kiosk = JSON.parse(vm.kiosk);
            if (Object.keys(vm.kiosk).length > 0) {
                if (vm.kiosksDashboardkiosk === vm.kiosk.kiosksDashboardkiosk || vm.kiosksDashboardkiosk === {}
                || vm.kiosksDashboardkiosk == null || Object.keys(vm.kiosksDashboardkiosk).length === 0) {
                    vm.dashboardList = vm.kiosk.dashboardList;
                    vm.kiosksDashboardkiosk = vm.kiosk.kiosksDashboardkiosk;
                } else {
                    setLocalStorage();
                }
            } else
                setLocalStorage();
        } else {
            setLocalStorage();
        }

        function setLocalStorage() {
            vm.kiosk = {};
            vm.kiosk.dashboardList = vm.dashboardList;
            vm.kiosk.kiosksDashboardkiosk = vm.kiosksDashboardkiosk;
            localStorage.setItem(vm.currentState, JSON.stringify(vm.kiosk));
        }

        vm.singleInterval = false;
        vm.time = [];
        if(vm.kiosksDashboardkiosk.id) {
            var times = vm.kiosksDashboardkiosk.interval.split(",");
            if(times.length == 1) {
                vm.dashboardInterval = times[0];
            } else {
                vm.singleInterval = true;
                var i = 0;
                vm.dashboardList.forEach(function (val) {
                    vm.time[val.name] = times[i];
                    i = i + 1;
                })
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:kiosksDashboardUpdate', result);
            vm.isSaving = false;
            $state.go('kiosks');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var composite = "";
            var i = 1;
            if(vm.singleInterval) {
                vm.dashboardList.forEach(function (val) {
                    val.order = i;
                    i = i + 1;
                    delete val.selected;
                    delete val.disabledCheck;
                    composite = composite + vm.time[val.name] + ","
                });
                vm.kiosksDashboardkiosk.interval = composite.substr(0, composite.length - 1);
            } else {
                vm.dashboardList.forEach(function (val) {
                    val.order = i;
                    i = i + 1;
                    delete val.selected;
                    delete val.disabledCheck;
                });
                vm.kiosksDashboardkiosk.interval = vm.dashboardInterval;
            }
            vm.kiosksDashboardkiosk.dashboards = vm.dashboardList;
            if(vm.kiosksDashboardkiosk.id) {
                Kiosks.update(vm.kiosksDashboardkiosk, onSaveSuccess, onSaveError);
            } else {
                Kiosks.save(vm.kiosksDashboardkiosk, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('kiosks');
        };

        vm.moveUp = function(index) {
            var dashboard = vm.dashboardList[index];
            vm.dashboardList.splice(index, 1);
            vm.dashboardList.splice(index - 1, 0, dashboard);
            setLocalStorage();
            // $scope.$apply();
        }

        vm.moveDown = function(index) {
            var dashboard = vm.dashboardList[index];
            vm.dashboardList.splice(index, 1);
            vm.dashboardList.splice(index + 1, 0, dashboard);
            setLocalStorage();
        }

        vm.deleteDashboard = function (id) {
            var entity = {};
            entity.kioskId = vm.kiosksDashboardkiosk.id;
            entity.dashboard = getDashboard(id);
            $uibModal.open({
                templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosk-dashboard-kiosk-delete.html',
                controller: 'KioskDashboardDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: entity
                }
            }).result.then(function () {
                removeDashboard(entity.dashboard.id);
                $state.transitionTo('kiosks-dashboard-kiosk', {}, {reload: true});
            }, function () {
                $state.go('kiosks-dashboard-kiosk');
            });
        }

        function removeDashboard(id) {
            removeFromArray(vm.kiosksDashboardkiosk.dashboards, id);
            removeFromArray(vm.dashboardList, id);
            setLocalStorage();
        }

        function removeFromArray(array, id) {
            var i = 0;
            while (i < array.length) {
                if (array[i].id === id)
                    break;
                i ++;
            }
            array.splice(i, 1);
        }

        function getDashboard(id) {
            for (var i = 0; i < vm.kiosksDashboardkiosk.dashboards.length; i++) {
                if (vm.kiosksDashboardkiosk.dashboards[i].id === id)
                    return vm.kiosksDashboardkiosk.dashboards[i];
            }
            return {};
        }

        vm.addDashboard = function() {
            $state.go('kiosks-dashboards');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardsController', KiosksDashboardsController);

    KiosksDashboardsController.$inject = ['$scope', '$state', 'KiosksDashboards', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$uibModal'];

    function KiosksDashboardsController ($scope, $state, KiosksDashboards, ParseLinks, AlertService, pagingParams, paginationConstants, $uibModal) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.selectedDashboards = [];
        vm.showCreation = pagingParams.showCreation;
        vm.time = [];
        vm.currentState = "kiosks";
        vm.currentStateFilter = "kiosks-filter";
        vm.currentStateDashboard = "kiosk-dashboard-kiosk";
        vm.updateKiosk = false;
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };

            KiosksDashboards.query(body, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.selectedDashboards = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.dashboards = data;
                checkDash(vm.dashboards, false);
                updateExistingKiosk();
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function checkDash(array, check) {
            angular.forEach(array, function (dash) {
                setSelected(dash, check);
                if (check)
                    vm.selectedDashboards.push(dash);
            });
        }

        function setSelected(dash, check) {
            for (var i = 0; i < vm.dashboards.length; i++) {
                if (vm.dashboards[i].id === dash.id) {
                    vm.dashboards[i].selected = check;
                    if (check)
                        vm.dashboards[i].disabledCheck = check;
                }
            }
        }

        function updateExistingKiosk() {
            vm.kiosk = localStorage.getItem(vm.currentStateDashboard);
            if (vm.kiosk !== null && vm.kiosk !== "null" && vm.kiosk !== undefined) {
                vm.kiosk = JSON.parse(vm.kiosk);
                if (Object.keys(vm.kiosk).length > 0) {
                    checkDash(vm.kiosk.dashboardList, true);
                    vm.updateKiosk = true;
                } else
                    vm.updateKiosk = false;
            }
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

        vm.clear = function () {
            $state.go('kiosks');
        };

        vm.toggleSelection = function(dashboard) {
            var idx = vm.selectedDashboards.indexOf(dashboard);
            if (idx > -1) {
                vm.selectedDashboards.splice(idx, 1);
            } else {
                vm.selectedDashboards.push(dashboard);
            }
        }

        vm.deleteDahboard = function (dashboard) {

        }

        vm.save = function () {
            if (vm.updateKiosk) {
                vm.kiosk.dashboardList = vm.selectedDashboards;
                localStorage.setItem(vm.currentStateDashboard, JSON.stringify(vm.kiosk));
            }

            $state.transitionTo("kiosks-dashboard-kiosk", {
                selectedDashboards : vm.selectedDashboards,
                kiosk: vm.kiosk.kiosksDashboardkiosk === undefined ? {} : vm.kiosk.kiosksDashboardkiosk,
            }, {location: "replace"});
        }

        // $("#table_sortable").sortable({
        //     placeholder: "ui-state-highlight"
        // });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('KiosksDashboards', KiosksDashboards);

    KiosksDashboards.$inject = ['$resource'];

    function KiosksDashboards($resource) {
        var resourceUrl = 'api/kiosk-dashboard/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'availableDashboard': {
                method: 'GET',
                url: 'api/kiosk-dashboard/available',
                isArray: true
            },
            'update': {method: 'PUT'},
            'deleteFromKiosk': {
                method: 'DELETE',
                url: 'api/kiosk-dashboard/delete-from-kiosk/:id/:kioskId'
            },
            'delete': {
                method: 'DELETE',
                url: 'api/kiosk-dashboard/:id'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('kiosks-dashboard', {
            parent: 'kiosk',
            url: '/kiosk-dashboard',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosksDashboard.home.title'
            },
            params : {
                showCreation: {
                    value: false,
                    squash: true
                },
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                itemsPerPageChosen: null,
                predicates: {}
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard.html',
                    controller: 'KiosksDashboardsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates: $stateParams.predicates,
                        search: $stateParams.search,
                        showCreation: $stateParams.showCreation
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }) .state('kiosks-dashboard-new', {
            parent: 'kiosks-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            params : {
                registeredDashboard: {
                    value: [],
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-dialog.html',
                    controller: 'KiosksDashboardDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        registeredDashboard: $stateParams.registeredDashboard
                    }
                }],
                entity: ['$stateParams', 'KiosksDashboards', function ($stateParams, KiosksDashboards) {
                    return {};
                }]
            }

        })
        .state('kiosks-dashboard-kiosk', {
            parent: 'kiosks-dashboard',
            url: '/kiosk',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            params : {
                selectedDashboards: {
                    value: [],
                    squash: true
                },
                kiosk: {
                    value: {},
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-kiosk.html',
                    controller: 'KiosksDashboardKioskController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        selectedDashboards: $stateParams.selectedDashboards,
                        kiosk: $stateParams.kiosk
                    }
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('kiosks');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }

        })
        .state('kiosks-dashboard-edit', {
            parent: 'kiosks-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-dialog.html',
                    controller: 'KiosksDashboardDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'KiosksDashboards', function ($stateParams, KiosksDashboards) {
                    return KiosksDashboards.get({id: $stateParams.id});
                }]}

        })
        .state('kiosks-dashboard.delete', {
            parent: 'kiosks-dashboard',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-delete-dialog.html',
                    controller: 'KiosksDashboardDeleteController',
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('kiosksDashboards');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['KiosksDashboards', function(KiosksDashboards) {
                            return KiosksDashboards.get({id: $stateParams.id});;
                        }]
                    }
                }).result.then(function() {
                    $state.go('kiosks-dashboard', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDeleteController',KiosksDeleteController);

    KiosksDeleteController.$inject = ['$uibModalInstance', 'entity', 'Kiosks'];

    function KiosksDeleteController($uibModalInstance, entity, Kiosks) {
        var vm = this;
        vm.kiosks = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Kiosks.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDetailController', KiosksDetailController);

    KiosksDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function KiosksDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.kiosk = entity;

        var unsubscribe = $rootScope.$on('jotApp:kiosksUpdate', function(event, result) {
            vm.kiosk = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksController', KiosksController);

    KiosksController.$inject = ['$scope', '$state', 'Kiosks', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function KiosksController ($scope, $state, Kiosks, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        // vm.applyFilter = applyFilter;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "kiosks";
        vm.currentStateFilter = "kiosks-filter";
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        vm.kiosk = {};
        localStorage.setItem("kiosk-dashboard-kiosk", JSON.stringify(vm.kiosk));

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };


            Kiosks.query(body, onSuccess, onError)
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.kiosks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }


        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

        vm.editKiosk = function(kiosk) {
            $state.transitionTo("kiosks-dashboard-kiosk", {
                selectedDashboards : kiosk.dashboards,
                kiosk : kiosk
            }, {location: "replace"});
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Kiosks', Kiosks)

    Kiosks.$inject = ['$resource'];

    function Kiosks($resource) {
        var resourceUrl = 'api/kiosk/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        })
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('kiosks', {
                parent: 'app',
                url: '/kiosks?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks.html',
                        controller: 'KiosksController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('kiosks-detail', {
                parent: 'kiosks',
                url: '/kiosks/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks-detail.html',
                        controller: 'KiosksDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Kiosks', function ($stateParams, Kiosks) {
                        return Kiosks.get({id: $stateParams.id});
                    }]
                }
            })
            .state('kiosks-new', {
                parent: 'kiosks',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.kiosk.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/kiosks/kiosks-dialog.html',
                        controller: 'KiosksDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('kiosks');
                        return $translate.refresh();
                    }],        entity: function () {
                        return {
                            id: null
                        };
                    },
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('kiosks.delete', {
                parent: 'kiosks',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/kiosks/kiosks-delete-dialog.html',
                        controller: 'KiosksDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('kiosks');
                                return $translate.refresh();
                            }],
                            entity: ['Kiosks', function (Kiosks) {
                                return Kiosks.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('kiosks', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            }).state('kiosks-dashboards', {
            parent: 'kiosks',
            url: '/kiosk-dashboard',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosk.detail.title'
            },
            params : {
                showCreation: {
                    value: true,
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard.html',
                    controller: 'KiosksDashboardsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates: $stateParams.predicates,
                        search: $stateParams.search,
                        showCreation : $stateParams.showCreation
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestManualController', LaunchObjectTestManualController);

    LaunchObjectTestManualController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', '$uibModal', '$filter'];

    function LaunchObjectTestManualController($scope, $state, ObjectTestResult, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;
        vm.filterTag = [];

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

       /* vm.obj = id !== null && id !== undefined ? { id } : {};
        vm.objectTestResults = [];
        loadTest();*/

        if (id !== null && id !== undefined) {
            vm.obj ={};
            vm.obj.id = id;
            vm.objectTestResults = [];
            loadTest();
        }

        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: vm.obj.id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;

                // all tags if none selected, otherwise use selected tags
                var tagList = vm.filterTag.length > 0 ? vm.filterTag : vm.testsTag;
                var tagIds = tagList.map(function(tag) {
                    return tag.id;
                });

                var promises = tagIds.map(function(tagId) {
                    return ObjectTestResult.byTags({
                        object: vm.obj.id,
                        testTagId: tagId,
                        isManual: true  // true
                    }).$promise;
                });

                Promise.all(promises).then(function (results) {
                    var tests = results.flat();
                    vm.objectTestResults = tests;
                    vm.objectTestResults.forEach(function (test) {
                        test.check = false;
                    });
                    vm.hasNotResults = tests.length === 0;
                });
            });
        }
        vm.applyTagsFilter = function ()  {
            loadTest()
        }

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.objNotSelected = id === null || id === undefined;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.manualResult = function (object, result) {
            object.status = result ? 1  : -1;
            object.executionCount = 1 + object.executionCount;
            ObjectTestResult.update(object, function () {
                object.lastExecution = new Date();
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestViewController', LaunchObjectTestViewController);

    LaunchObjectTestViewController.$inject = ['$scope', '$state', 'ObjectTestResult', 'TestSchedule', 'ParseLinks', 'AlertService', 'id', 'testResults', '$timeout', '$uibModal', '$filter'];

    function LaunchObjectTestViewController($scope, $state, ObjectTestResult, TestSchedule, ParseLinks, AlertService, id, testResults, $timeout, $uibModal, $filter) {

        var vm = this;
        vm.objectTestResults = testResults;
        vm.objId = id;
        vm.running = false;

        vm.loadAll = function () {
            if(vm.objectTestResults.length > 0 && id != null) {
                vm.objectTestResults.forEach(function (test) {
                    test.running = false;
                });
                vm.runAll();
            }
            else {
                $state.transitionTo('launch-object-test', {
                    id: vm.objId
                });
            }
        };

        vm.runAll = function () {
            for (var i = 0; i < vm.objectTestResults.length; i++) {
                if(!vm.objectTestResults[i].objectTestSetting.manual){
                    vm.running = true;
                    vm.objectTestResults[i].running = true;
                    vm.runTest(vm.objectTestResults[i], i);
                }
            }
            vm.running = false;
        };

        vm.runTest = function (test, i) {
            $timeout(function () {
                ObjectTestResult.execute(test).$promise.then(
                    function (result) {
                        vm.objectTestResults[i] = result;
                        vm.objectTestResults[i].running = false;
                    },
                    function () {
                        AlertService.error("Test Error");
                    });
            }, 1000);
        };

        vm.scheduleTest = function () {
            if (vm.showSchedule === undefined)
                vm.response = {
                    single: false,
                    afterLaunch: true
                };
            $uibModal.open({
                templateUrl: 'app/entities/test-schedule/schedule-object-test.html',
                controller: 'ScheduleObjectTestController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if (result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    vm.tabScheduleTest = {};
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.saveScheduleTest();
                } else
                    vm.showSchedule = undefined;
            })
        };

        function setData() {
            vm.tabScheduleTest.scheduleDateTime = vm.response.scheduleDateTime;
            vm.repeatNumber = vm.response.repeatNumber;
            convertDate();
        }

        function convertDate(){
            if(vm.repeatNumber) {
                var dateFormat = 'dd/MM/yyyy';
                var date = $filter('date')(new Date(vm.tabScheduleTest.scheduleDateTime), dateFormat);
                vm.showSchedule = "SCHEDULED: " + date + "\n" + " REPEAT EVERY " + vm.repeatNumber  + " " + "DAYS";
            } else {
                AlertService.error("Fill Repetition field");
                vm.showSchedule = undefined;
            }
        }

        function setMultipleData() {
            vm.tabScheduleTest.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.selectedTime) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");
            vm.tabScheduleTest.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));

            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        vm.saveScheduleTest = function () {
            vm.isSaving = true;
            vm.tabScheduleTest.name = vm.response.testName;
            vm.tabScheduleTest.single = vm.response.single;
            if(vm.tabScheduleTest.single && vm.repeatNumber){
                vm.tabScheduleTest.cronExpression = vm.repeatNumber;
            }
            vm.tabScheduleTest.testResults = vm.objectTestResults;
            vm.tabScheduleTest.multipleSchedule = false; //it's a single object schedule
            vm.tabScheduleTest.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            TestSchedule.create(vm.tabScheduleTest, onSuccess, onError);

            function onSuccess() {
                vm.response = {
                    single: false,
                    afterLaunch: true
                };
            }
            function onError(error) {}
        };

        vm.loadAll();

        function getCheckedTestListId() {
            var checkedTestResultsId = "";
            vm.objectTestResults.forEach(function (test) {
                checkedTestResultsId = checkedTestResultsId + (checkedTestResultsId === "" ? "" : ",") + test.id;
            });
            return checkedTestResultsId;
        }

        vm.downloadPdf = function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = "api/object-test-result-pdf/" + id + "?test=" + getCheckedTestListId() +"&timeZone=" + encodeURI(Intl.DateTimeFormat().resolvedOptions().timeZone);
            a.setAttribute("target", "_blank");
            a.download = name[name.length - 1];
            a.click();
        };
    }
})();

;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LaunchObjectTestController', LaunchObjectTestController);

    LaunchObjectTestController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', '$uibModal', '$filter'];

    function LaunchObjectTestController($scope, $state, ObjectTestResult, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;
        vm.running = false;
        vm.filterTag = [];
        vm.currentStateTag = "launch-object-test-tag";

        var tag = localStorage.getItem(vm.currentStateTag);

        if (id !== null && id !== undefined && vm.filterTag.length === 0) {
            var tag = localStorage.getItem(vm.currentStateTag);
            if (tag != null && tag != "null") {
                vm.filterTag = JSON.parse(tag);
            }
        }

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

        vm.obj = id !== null && id !== undefined ? { id } : {};
        vm.objectTestResults = [];
        loadTest();

       /* if (id !== null && id !== undefined) {
            vm.obj = {};
            vm.obj.id = id;
            vm.objectTestResults = [];
            loadTest();
        }
    */
        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: vm.obj.id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;
                var tagList = vm.filterTag.length > 0 ? vm.filterTag : vm.testsTag;
                var tagIds = tagList.map(function(tag) {
                    return tag.id;
                });

                localStorage.setItem(vm.currentStateTag, JSON.stringify(vm.filterTag));

                var promises = tagIds.map(function(tagId) {
                    return ObjectTestResult.byTags({
                        object: vm.obj.id,
                        testTagId: tagId,
                        isManual: false}).$promise;

                });
                Promise.all(promises).then(function (results) {
                    var tests = results.flat();
                    vm.objectTestResults = tests;
                    vm.objectTestResults.forEach(function (test) {
                        test.check = false;
                    });
                    vm.hasNotResults = tests.length === 0;
                });
            });
        }

        vm.applyTagsFilter = function ()  {
            loadTest()
        }

        vm.currentState = "launch-object-test";

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                //vm.objNotSelected = vm.obj === undefined || vm.obj === null || vm.obj.id === null || vm.obj.id === undefined;
                vm.objNotSelected = !vm.obj || vm.obj.id === null || vm.obj.id === undefined;
            }
0
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };


        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: vm.obj.id
            }, {notify: true, location: "replace"});
        };

        vm.checkAll = function (b) {
            vm.objectTestResults.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.objectTestResults.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.objectTestResults.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        vm.checkedTestList = function () {
            var checkedTestList = [];
            vm.objectTestResults.forEach(function (test) {
                if(test.check) checkedTestList.push(test);
            });
            $state.transitionTo('launch-object-test.view', {
                id: vm.obj.id,
                testResults: checkedTestList
            }, {location: "replace"});
        }

        vm.runAll = function () {
            vm.running = true;
            for (var i = 0; i < vm.objectTestResults.length; i++) {
                if(vm.objectTestResults[i].check && !vm.objectTestResults[i].objectTestSetting.manual){
                    vm.runTest(vm.objectTestResults[i], i);
                }
            }
        };

        vm.runTest = function (test, i) {
            $timeout(function () {
                ObjectTestResult.execute(test).$promise.then(
                    function (result) {
                        vm.objectTestResults[i] = result;
                        vm.areChk = false;
                        vm.running = false;
                    },
                    function () {
                        AlertService.error("Test Error");
                    });
            }, 1000);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('launch-object-test', {
                parent: 'testing',
                url: '/launch-object-test/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.automatic.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test.html',
                        controller: 'LaunchObjectTestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('launch-object-test.manual', {
                parent: 'testing',
                url: '/launch-object-test-manual/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.manual.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test-manual.html',
                        controller: 'LaunchObjectTestManualController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('objectTestResult');

                        return $translate.refresh();
                    }],
                }
            })
            .state('launch-object-test.view', {
                parent: 'launch-object-test',
                url: '/results',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.runResults.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test-view.html',
                        controller: 'LaunchObjectTestViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    },
                    testResults: {
                        value: []
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    testResults: ['$stateParams', function ($stateParams) {
                        return $stateParams.testResults;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                }
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDeleteController',LicencesDeleteController);

    LicencesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Licences'];

    function LicencesDeleteController($uibModalInstance, entity, Licences) {
        var vm = this;
        vm.licences = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Licences.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDetailController', LicencesDetailController);

    LicencesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Licences', 'TabDomains'];

    function LicencesDetailController($scope, $rootScope, $stateParams, entity, Licences, TabDomains) {
        var vm = this;
        vm.licences = entity;
        
        var unsubscribe = $rootScope.$on('jotApp:licencesUpdate', function(event, result) {
            vm.licences = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDialogController', LicencesDialogController);

    LicencesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Licences', 'TabDomains'];

    function LicencesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Licences, TabDomains) {
        var vm = this;
        vm.licences = entity;
        vm.tabdomains = TabDomains.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:licencesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.licences.id !== null) {
                Licences.update(vm.licences, onSaveSuccess, onSaveError);
            } else {
                Licences.save(vm.licences, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesController', LicencesController);

    LicencesController.$inject = ['$scope', '$state', 'Licences', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LicencesController ($scope, $state, Licences, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Licences.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.licences = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Licences', Licences);

    Licences.$inject = ['$resource'];

    function Licences ($resource) {
        var resourceUrl =  'api/licences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('licences', {
            parent: 'entity',
            url: '/licences?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jotApp.licences.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licences/licences.html',
                    controller: 'LicencesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licences');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('licences-detail', {
            parent: 'entity',
            url: '/licences/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jotApp.licences.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licences/licences-detail.html',
                    controller: 'LicencesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licences');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Licences', function($stateParams, Licences) {
                    return Licences.get({id : $stateParams.id});
                }]
            }
        })
        .state('licences.new', {
            parent: 'licences',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-dialog.html',
                    controller: 'LicencesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('licences');
                });
            }]
        })
        .state('licences.edit', {
            parent: 'licences',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-dialog.html',
                    controller: 'LicencesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Licences', function(Licences) {
                            return Licences.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('licences.delete', {
            parent: 'licences',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-delete-dialog.html',
                    controller: 'LicencesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Licences', function(Licences) {
                            return Licences.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroActionsDeleteController', MacroActionsDeleteController);

    MacroActionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'MacroActions', 'Macro'];

    function MacroActionsDeleteController($uibModalInstance, entity, MacroActions, Macro) {
        var vm = this;
        vm.command = null;

        // Handle both promise and direct entity
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.command = entity;
            });
        } else {
            vm.command = entity;
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            // Check if it's a Greengrass command
            if (vm.command.isGreengrass) {
                console.log('Deleting Greengrass command:', id, 'from macro:', vm.command.macroId);

                Macro.deleteGreengrassCommand({
                    commandId: id,
                    macroId: vm.command.macroId
                }, function(response) {
                    console.log('Greengrass command deleted successfully');
                    $uibModalInstance.close(true);
                }, function(error) {
                    console.error('Error deleting Greengrass command:', error);
                    $uibModalInstance.dismiss('error');
                });
            } else {
                // Traditional macro action delete
                MacroActions.delete({id: id}, function () {
                    $uibModalInstance.close(true);
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroDeleteController',MacroDeleteController);

    MacroDeleteController.$inject = ['$uibModalInstance', 'entity', 'Macro'];

    function MacroDeleteController($uibModalInstance, entity, Macro) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.macro = entity;
            });
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Macro.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroDetailController', MacroDetailController);

    MacroDetailController.$inject = ['$stateParams', '$state', 'entity', '$uibModal', 'Macro'];

    function MacroDetailController($stateParams, $state, entity, $uibModal, Macro) {
        var vm = this;
        vm.macro = [];
        vm.edit = false;
        vm.isGreengrassMacro = false;
        vm.greengrassCommands = [];

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.macro = entity;

                // Check if it's a Greengrass macro
                vm.isGreengrassMacro = !vm.macro.macroActions || vm.macro.macroActions.length === 0;

                if (vm.isGreengrassMacro) {
                    console.log('Loading Greengrass macro details for:', vm.macro.id);
                    loadGreengrassCommands();
                } else {
                    // Traditional macro
                    vm.macro.macroActions.sort(function (a, b) {
                        var commandA = a.order, commandB = b.order;
                        return commandA - commandB;
                    });
                }
            });
        }

        function loadGreengrassCommands() {
            Macro.getMacroDetails({macroId: vm.macro.id}, function(queueCommands) {
                console.log('Greengrass commands loaded:', queueCommands);

                vm.greengrassCommands = queueCommands.map(function(cmd) {
                    var parsedCmd = angular.copy(cmd);
                    try {
                        if (cmd.arguments && cmd.arguments !== '{}') {
                            parsedCmd.argumentMap = JSON.parse(cmd.arguments);
                        }
                    } catch (e) {
                        console.error('Error parsing arguments:', e);
                    }
                    return parsedCmd;
                });

                // Sort by order
                vm.greengrassCommands.sort(function(a, b) {
                    return a.order - b.order;
                });

                console.log('Processed Greengrass commands:', vm.greengrassCommands);
            }, function(error) {
                console.error('Error loading Greengrass commands:', error);
            });
        }

        vm.deleteMacroAction = function (actionId) {
            $uibModal.open({
                templateUrl: 'app/entities/macro/macro-actions-delete-dialog.html',
                controller: 'MacroActionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['MacroActions', function (MacroActions) {
                        return MacroActions.get({id: actionId});
                    }]
                }
            }).result.then(function () {
                if(vm.macro.macroActions.length == 1){
                    Macro.delete({id: vm.macro.id});
                    $state.go('macros');
                } else {
                    $state.go('macro-detail', null, {reload: true});
                }
            }, function () {
                $state.go('macro-detail');
            });
        }

        vm.deleteGreengrassCommand = function(index) {
            var command = vm.greengrassCommands[index];

            $uibModal.open({
                templateUrl: 'app/entities/macro/macro-actions-delete-dialog.html',
                controller: 'MacroActionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return {
                            id: command.id,
                            commandName: command.commandName,
                            macroId: vm.macro.id,
                            isLastCommand: vm.greengrassCommands.length === 1,
                            isGreengrass: true
                        };
                    }
                }
            }).result.then(function () {
                // Check if we need to navigate away (macro was deleted)
                if (vm.greengrassCommands.length === 1) {
                    $state.go('macros');
                } else {
                    $state.go('macro-detail', null, {reload: true});
                }
            }, function () {
                // User cancelled or error, stay on page
            });
        }

        vm.moveUp = function(index) {
            var command = vm.macro.macroActions[index];
            vm.macro.macroActions.splice(index, 1);
            vm.macro.macroActions.splice(index - 1, 0, command);
            vm.edit = true;
        }

        vm.moveDown = function(index) {
            var command = vm.macro.macroActions[index];
            vm.macro.macroActions.splice(index, 1);
            vm.macro.macroActions.splice(index + 1, 0, command);
            vm.edit = true;
        }

        vm.moveUpGreengrass = function(index) {
            var command = vm.greengrassCommands[index];
            vm.greengrassCommands.splice(index, 1);
            vm.greengrassCommands.splice(index - 1, 0, command);
            vm.edit = true;
        }

        vm.moveDownGreengrass = function(index) {
            var command = vm.greengrassCommands[index];
            vm.greengrassCommands.splice(index, 1);
            vm.greengrassCommands.splice(index + 1, 0, command);
            vm.edit = true;
        }

        vm.save = function () {
            if (vm.isGreengrassMacro) {
                console.log('Saving Greengrass macro order');
                console.log('Commands to update:', vm.greengrassCommands);

                // Send update request using the service
                Macro.updateGreengrassCommandsOrder({
                    macroId: vm.macro.id
                }, vm.greengrassCommands, function(response) {
                    console.log('Order updated successfully');
                    vm.edit = false;
                    $state.go('macro-detail', null, {reload: true});
                }, function(error) {
                    console.error('Error updating order:', error);
                    alert('Error saving changes: ' + (error.data.message || 'Unknown error'));
                });
            } else {
                // Traditional macro save
                for(var i = 0; i < vm.macro.macroActions.length; i++){
                    vm.macro.macroActions[i].order = i + 1;
                }

                Macro.update(vm.macro, onSuccess, onError);
            }

            function onSuccess() {
                vm.edit = false;
                $state.go('macro-detail', null, {reload: true});
            }

            function onError() {
                console.error('Error saving macro');
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroController', MacroController);

    MacroController.$inject = ['$stateParams', '$state', 'Macro', 'pagingParams', 'paginationConstants'];

    function MacroController($stateParams, $state, Macro, pagingParams, paginationConstants) {
        var vm = this;

        vm.macro = [];
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.loadAll = function() {
            var body = {
                id: -1,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen
            };

            Macro.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.macro = data;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;

                for(var i = 0; i < data.length; i++){
                    if(!data[i].macroActions || data[i].macroActions.length === 0){
                        loadCommandsForGreengrassMacro(data[i]);
                    }
                }

                if(vm.macro.length == 0){
                    $state.go('action-commands', null, {reload: true});
                }
            }

            function loadCommandsForGreengrassMacro(macro) {
                Macro.getMacroDetails({macroId: macro.id}, function(queueCommands) {
                    macro.greengrassCommands = queueCommands;
                }, function(error) {
                    console.error('Error loading commands for macro:', macro.id, error);
                });
            }

            function onError() {}
        };

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Macro', Macro)
        .factory('MacroActions', MacroActions);

    Macro.$inject = ['$resource', 'DateUtils'];

    function Macro($resource, DateUtils) {
        var resourceUrl = 'api/macro/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                url: 'api/macros/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'create' : {method: 'PUT'},
            'delete' : {method: 'DELETE'},
            'update': {method: 'POST'},
            'queryGreengrass': {
                method: 'GET',
                url: 'api/macro/greengrass/:id',
                isArray: true
            },
            'queryAllGreengrass': {
                method: 'GET',
                url: 'api/macro/greengrass/all',
                isArray: true
            },
            'queryGreengrassByObjectType': {
                url: 'api/macro/greengrass/objectType/:objectTypeId/:fleetId',
                method: 'GET',
                isArray: true
            },
            'getMacroDetails': {
                method: 'GET',
                url: 'api/macro/greengrass/details/:macroId',
                params: { macroId: '@macroId' },
                isArray: true
            },
            'byObjectType': {
                url: 'api/macro/objectType/:id/:fleet',
                method: 'GET',
                isArray: true
            },
            'updateGreengrassCommandsOrder': {
                method: 'POST',
                url: 'api/macro/greengrass/updateOrder/:macroId',
                params: {
                    macroId: '@macroId'
                }
            },
            'deleteGreengrassCommand': {
                method: 'DELETE',
                url: 'api/macro/greengrass/command/:commandId/:macroId',
                params: {
                    commandId: '@commandId',
                    macroId: '@macroId'
                }
            }
        });
    }

    MacroActions.$inject = ['$resource', 'DateUtils'];

    function MacroActions($resource, DateUtils) {
        var resourceUrl = 'api/macro-detail/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                url: 'api/macro-detail/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('macros', {
                parent: 'management',
                url: '/macros?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.macro.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/macro/macro.html',
                        controller: 'MacroController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('macro');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('queueCommand');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            repeatable: $stateParams.repeatable,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        }
                    }]
                }
            })
            .state('macro-detail', {
                parent: 'macros',
                url: '/{id}/macro-detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/macro/macro-detail.html',
                        controller: 'MacroDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('macro');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        $translatePartialLoader.addPart('queueCommand');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Macro', function ($stateParams, Macro) {
                        return Macro.get({id: $stateParams.id});
                    }]
                }
            })
            .state('macros.delete', {
                parent: 'macros',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/macro/macro-delete-dialog.html',
                        controller: 'MacroDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Macro', function (Macro) {
                                return Macro.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('macros', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationDeleteDialogController',MyDomainNotificationDeleteDialogController);

    MyDomainNotificationDeleteDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', '$state', '$uibModalInstance', 'MyDomainNotification'];

    function MyDomainNotificationDeleteDialogController($timeout, $scope, $stateParams, entity, $state, $uibModalInstance, MyDomainNotification) {
        var vm = this;
        vm.myDomainNotification = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MyDomainNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationDetailController', MyDomainNotificationDetailController);

    MyDomainNotificationDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function MyDomainNotificationDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.myDomainNotification = entity;

        var unsubscribe = $rootScope.$on('jotApp:myDomainNotification', function(event, result) {
            vm.myDomainNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('MyDomainNotificationDialogController', MyDomainNotificationDialogController);

        MyDomainNotificationDialogController.$inject = ['$uibModal', '$timeout', '$filter', '$scope', '$stateParams', 'entity', 'Warning', 'WarningCategory', 'TabFleets', 'UserProfile', '$state', 'ParseLinks', 'AlertService', 'MyDomainNotification', 'AlertRules'];

        function MyDomainNotificationDialogController($uibModal, $timeout, $filter, $scope, $stateParams, entity, Warning, WarningCategory, TabFleets, UserProfile, $state, ParseLinks, AlertService, MyDomainNotification, AlertRules) {
            var vm = this;
            vm.myDomainNotification = entity;
            vm.fleetOptions = [];
            vm.categoryOptions = [];
            vm.warningNameOptions = [];
            vm.fleetSelectedAtStart = [];
            vm.categorySelectedAtStart = [];
            vm.warningSelectedAtStart = [];

            vm.fleetEmpty = true;
            vm.categoryEmpty = true;

            vm.isEdit = false;
            vm.isClone = false;
            vm.isCreate = false;
            vm.notificationSystems = ['email', 'telegram'];

            if (vm.myDomainNotification.name != null) {
                vm.nameBeforeSave = vm.myDomainNotification.name;
            }

            vm.timepickerOptions = {showMeridian: false};
            vm.repeatStatus = false;
            vm.openTimeCalc = function () {
                $timeout(function () {
                    vm.repeatStatus = true;
                });
            };

            vm.userProfiles = UserProfile.alertsProfile({
                page: 0,
                size: 100
            });
           vm.currentUserProfile =MyDomainNotification.getCurrentUserProfile({
                page: 0,
                size: 100
            });
           vm.currentUserProfile.$promise.then(function (data) {
               vm.currentUserProfile = data;
           })

            vm.tabFleets = TabFleets.query({
                page: 0,
                size: 100
            });
            vm.categories = WarningCategory.query({
                page: 0,
                size: 100
            });
            vm.systemWarnings = AlertRules.querySystem({
                page: 0,
                size: 1000
            });
            vm.warningNames = AlertRules.query({
                page: 0,
                size: 1000
            });

            vm.tabFleets.$promise.then(function (fleets) {
                fleets.forEach(function (fleet) {
                    vm.fleetOptions.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.categories.$promise.then(function (categories) {
                    categories.unshift({id: -1, warningName: 'system'});
                    vm.systemWarnings.$promise.then(function (systemWarnings) {
                        systemWarnings.warnings.forEach((systemWarning) => {
                            systemWarning.warningCategory = {id: -1, warningName: "system"};
                        });
                        vm.systemWarnings = vm.systemWarnings.warnings;
                        vm.warningNames.$promise.then(function (warnings) {
                            vm.systemWarnings.forEach((systemWarning) => {
                                warnings.warnings.unshift(systemWarning);
                            });

                            vm.warningNames = vm.warningNames.warnings;

                            // Map name > rules[]
                            vm.warningNameMap = {};
                            vm.warningNames.forEach(function (warning) {
                                var name = warning.name;
                                if (!vm.warningNameMap[name]) {
                                    vm.warningNameMap[name] = [];
                                }
                                vm.warningNameMap[name].push(warning);
                            });

                            vm.precompile();
                        })
                    })
                });
            });

            $timeout(function () {
                angular.element('.form-group:eq(1)>input').focus();
            });

            // Dato l'array di rules in input, restituisce un array di rules con warning names univoci
            function dedupeByName(warnings) {
                const map = new Map();
                warnings.forEach(w => {
                    if (!map.has(w.name)) {
                        map.set(w.name, w);
                    }
                });
                return Array.from(map.values());
            }

            vm.save = function () {
                vm.myDomainNotification.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (vm.myDomainNotification.name === vm.nameBeforeSave && vm.isClone) {
                    $uibModal.open({
                        templateUrl: 'app/entities/my-domain-notification/modals/my-domain-notification-duplicate-name.html',
                        controller: function ($uibModalInstance) {
                            var vm = this;
                            vm.clear = clear;

                            function clear() {
                                $uibModalInstance.dismiss('cancel');
                            }
                        },
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', function ($translate) {
                                return $translate.refresh();
                            }],
                        }
                    })
                    return
                }

                collectFleets();
                collectCategories();
                collectWarnings();

                vm.myDomainNotification.fleets = angular.copy(vm.selectedFleets);
                vm.myDomainNotification.categories = angular.copy(vm.selectedCategories);
                vm.myDomainNotification.warningNames = angular.copy(vm.selectedWarnings);

                MyDomainNotification.update(vm.myDomainNotification, onSaveSuccess, onSaveError);
            };

            var onSaveSuccess = function (result) {
                if (vm.isClone || vm.isCreate) {
                    vm.notificationSystems.forEach(system => {
                        vm.saveToggle(system, result);
                    });
                } else {
                    $state.go('my-domain-notification', null, {reload: true});
                }
            };
            var onSaveError = function () {
                vm.isSaving = false;
            };

            vm.saveToggle = function (type, notification) {
                vm.channel = {};
                vm.channel.alertSystemType = {};
                vm.channel.alertSystemType.name = type;
                vm.channel.active = true;
                vm.channel.myDomainNotification = notification;
                MyDomainNotification.insertDomainAlerts({
                    myDomainNotificationAlertConfiguration: vm.channel,
                    myDomainNotification: notification,
                    users: vm.alertUsers
                }, function (result) {
                    notification = result;
                    vm.setAlertConf();
                });
            };

            vm.setAlertConf = function () {
                vm.alertUsers = [];
                vm.email = {};
                vm.telegram = {};
                vm.email.exist = false;
                vm.telegram.exist = false;
                vm.myDomainNotification.myDomainNotificationAlertConfigurations.forEach(function (mdnac) {
                    vm[mdnac.alertSystemType.name].exist = true;
                    vm[mdnac.alertSystemType.name].mdnac = mdnac;
                    if (mdnac.active)
                        vm[mdnac.alertSystemType.name].active = true;
                });
                $state.go('my-domain-notification', null, {reload: true});
            };

            vm.clear = function () {
                $state.go('my-domain-notification');
            };
            vm.refreshIndex = function () {
                vm.myDomainNotification.index = null;
                vm.tempMetric = [];
            };

            function onFleetSelect(fleets) {

                vm.categoryBeforeFleetselect = angular.copy(vm.myDomainNotification.categories);

                // vm.categoryOptionsBeforeFleetselect = angular.copy(vm.categoryOptions);

                vm.categoryOptions = [];
                vm.fleetEmpty = false;

                var categoryIds = [];
                fleets.forEach(fleet => {
                    vm.warningNames.forEach(warning => {
                        if (warning.tabFleets.id == fleet.id) {
                            vm.categoryOptions.forEach(function (option) {
                                categoryIds.push(option.id);
                            })
                            if (!categoryIds.includes(warning.warningCategory.id)) {
                                vm.categoryOptions.push({
                                    id: warning.warningCategory.id,
                                    label: warning.warningCategory.warningName
                                });
                            }
                        }
                    })
                })

                // Selected options that match by id remain selected, additional options are not selected automatically
                vm.myDomainNotification.categories = vm.categoryBeforeFleetselect.filter(prev =>
                    vm.categoryOptions.some(opt => opt.id === prev.id)
                );

                // if (vm.categoryBeforeFleetselect.length > 0) {
                //     vm.myDomainNotification.categories = angular.copy(vm.categoryBeforeFleetselect);
                //     var categoryIds2 = [];
                //     vm.categoryOptionsBeforeFleetselect.forEach(oldCategory => {
                //         categoryIds2.push(oldCategory.id);
                //     })
                //     vm.categoryOptions.forEach(categoryOption => {
                //         if (!categoryIds2.includes(categoryOption.id)) {
                //             vm.myDomainNotification.categories.push(categoryOption);
                //         }
                //     })
                // } else {
                //     vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                // }

                // onCategorySelect(vm.myDomainNotification.categories);
            }

            function onFleetDeselect(fleets) {

                if (fleets.length > 0) {

                    vm.categoryBeforeFleetDeselect = angular.copy(vm.myDomainNotification.categories);

                    vm.categoryOptions = [];
                    vm.fleetEmpty = false;

                    var categoryIds2 = [];
                    fleets.forEach(fleet => {
                        vm.warningNames.forEach(warning => {
                            if (warning.tabFleets.id == fleet.id) {
                                vm.categoryOptions.forEach(function (option) {
                                    categoryIds2.push(option.id);
                                })
                                if (!categoryIds2.includes(warning.warningCategory.id))
                                    vm.categoryOptions.push({
                                        id: warning.warningCategory.id,
                                        label: warning.warningCategory.warningName
                                    });
                            }
                        })
                    })

                    // Selected options that match by id remain selected, additional options are not selected automatically
                    vm.myDomainNotification.categories = vm.categoryBeforeFleetDeselect.filter(prev =>
                        vm.categoryOptions.some(opt => opt.id === prev.id)
                    );

                    // for (var x = 0; x < vm.categoryBeforeFleetDeselect.length; x++) {
                    //     if (!categoryIds2.includes(vm.categoryBeforeFleetDeselect[x].id)) {
                    //         vm.categoryBeforeFleetDeselect.splice(x, 1);
                    //     }
                    // }
                    // if (vm.categoryBeforeFleetDeselect.length > 0) {
                    //     vm.myDomainNotification.categories = angular.copy(vm.categoryBeforeFleetDeselect);
                    // } else {
                    //     vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                    // }


                    onCategoryDeselect(vm.myDomainNotification.categories);

                } else {

                    // vm.myDomainNotification.fleets = [];

                    vm.fleetEmpty = true;
                    vm.categoryEmpty = true;

                    // Nessuna flotta selezionata > nessuna categoria e warning name selezionati
                    vm.myDomainNotification.categories = [];
                    vm.myDomainNotification.warningNames = [];
                }
            }

            function onCategorySelect(categories) {

                // vm.warningBeforeCategorySelect = angular.copy(vm.myDomainNotification.warningNames);
                // vm.warningOptionsBeforeCategorySelect = angular.copy(vm.warningNameOptions);

                vm.warningNameOptions = [];
                vm.categoryEmpty = false;

                var fleetOptionsIds = [];

                vm.myDomainNotification.fleets.forEach(function (fleet) {
                    fleetOptionsIds.push(fleet.id)
                })

                // Set warning name options
                var warningNamesMap = new Map();
                categories.forEach(category => {
                    vm.warningNames.forEach(warning => {
                        if (warning.warningCategory.id === category.id && fleetOptionsIds.includes(warning.tabFleets.id)) {
                            warning.label = warning.name;
                            warningNamesMap.set(warning.name, warning);
                        }
                    })
                })
                vm.warningNameOptions = Array.from(warningNamesMap.values());

                // Selected options that match by name remain selected, additional options are not selected automatically
                var finalSelection = [];
                vm.myDomainNotification.warningNames.forEach(selected => {

                    // 1. Retrieves full object by id
                    var fullObj = vm.warningNames.find(w => w.id === selected.id);
                    if (!fullObj) return;

                    // 2. Find object with same name in options
                    var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                    if (!match) return;

                    // 3. Add object to final selection
                    finalSelection.push(match);
                });

                vm.myDomainNotification.warningNames = finalSelection;


                // if (vm.warningBeforeCategorySelect.length > 0) {
                //
                //     vm.myDomainNotification.warningNames = angular.copy(vm.warningBeforeCategorySelect);
                //
                //     var categoryIds3 = [];
                //     vm.warningOptionsBeforeCategorySelect.forEach(oldWarningCat => {
                //         categoryIds3.push(oldWarningCat.warningCategory.id);
                //     })
                //     var fleetIds2 = [];
                //     vm.warningOptionsBeforeCategorySelect.forEach(function (oldWarningFleet) {
                //         fleetIds2.push(oldWarningFleet.tabFleets.id)
                //     })
                //
                //     vm.warningNameOptions.forEach(warningOption => {
                //         if (!categoryIds3.includes(warningOption.warningCategory.id) || !fleetIds2.includes(warningOption.tabFleets.id)) {
                //             vm.myDomainNotification.warningNames.push(warningOption);
                //         }
                //     })
                //
                // } else {
                //     vm.myDomainNotification.warningNames = angular.copy(vm.warningNameOptions);
                // }

            }

            function onCategoryDeselect(categories) {

                if (categories.length > 0) {

                    // vm.warningBeforeCategoryDeselect = angular.copy(vm.myDomainNotification.warningNames);
                    // vm.warningOptionsBeforeCategoryDeselect = angular.copy(vm.warningNameOptions);

                    vm.warningNameOptions = [];
                    vm.categoryEmpty = false;

                    var fleetOptionsIds3 = [];

                    vm.myDomainNotification.fleets.forEach(function (fleet) {
                        fleetOptionsIds3.push(fleet.id)
                    })

                    // Set warning name options
                    var warningNamesMap = new Map();
                    categories.forEach(category => {
                        vm.warningNames.forEach(warning => {
                            if (warning.warningCategory.id === category.id && fleetOptionsIds3.includes(warning.tabFleets.id)) {
                                warning.label = warning.name;
                                warningNamesMap.set(warning.name, warning);
                            }
                        })
                    })
                    vm.warningNameOptions = Array.from(warningNamesMap.values());

                    // Selected options that match by name remain selected, additional options are not selected automatically
                    var finalSelection = [];
                    vm.myDomainNotification.warningNames.forEach(selected => {

                        // 1. Retrieves full object by id
                        var fullObj = vm.warningNames.find(w => w.id === selected.id);
                        if (!fullObj) return;

                        // 2. Find object with same name in options
                        var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                        if (!match) return;

                        // 3. Add object to final selection
                        finalSelection.push(match);
                    });

                    vm.myDomainNotification.warningNames = finalSelection;

                    // var fleetIds2 = [];
                    // vm.warningNameOptions.forEach(warningOption => {
                    //     fleetIds2.push(warningOption.tabFleets.id);
                    // })
                    // for (var x = 0; x < vm.myDomainNotification.fleets.length; x++) {
                    //     if (!fleetIds2.includes(vm.myDomainNotification.fleets[x].id)) {
                    //         vm.myDomainNotification.fleets.splice(x, 1);
                    //     }
                    // }
                    // var fleetsIds3 = [];
                    // for (var z1 = 0; z1 < vm.myDomainNotification.fleets.length; z1++) {
                    //     fleetsIds3.push(vm.myDomainNotification.fleets[z1].id);
                    // }
                    // var categoryIds4 = [];
                    // vm.warningNames.forEach(warning => {
                    //     if (fleetsIds3.includes(warning.tabFleets.id)) {
                    //         categoryIds4.push(warning.warningCategory.id);
                    //     }
                    // })
                    // for (var z = 0; z < vm.categoryOptions.length; z++) {
                    //     if (!categoryIds4.includes(vm.categoryOptions[z].id)) {
                    //         vm.categoryOptions.splice(z, 1);
                    //     }
                    // }

                } else {
                    // vm.myDomainNotification.fleets = [];
                    // vm.fleetEmpty = true;

                    vm.categoryEmpty = true;

                    // Nessuna categoria selezionata > nessun warning name selezionato
                    vm.myDomainNotification.warningNames = [];
                }
            }

            function onWarningSelect(warnings) {}
            function onWarningDeselect(warnings) {}

            vm.categoryListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select fleet first",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };
            vm.warningListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select category first",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };
            vm.fleetListSettings = {
                checkboxes: true,
                smartButtonMaxItems: 10,
                buttonDefaultText: "select fleet(s)",
                scrollable: true,
                enableSearch: true,
                clearSearchOnClose: true,
            };

            vm.fleetListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.fleets = angular.copy(vm.fleetOptions);
                    onFleetSelect(vm.myDomainNotification.fleets)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.fleets = [];
                    onFleetDeselect(vm.myDomainNotification.fleets)
                },
                onItemSelect: function () {
                    onFleetSelect(vm.myDomainNotification.fleets)
                },
                onItemDeselect: function () {
                    onFleetDeselect(vm.myDomainNotification.fleets)
                },
            };
            vm.categoryListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.categories = angular.copy(vm.categoryOptions);
                    onCategorySelect(vm.myDomainNotification.categories)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.categories = [];
                    onCategoryDeselect(vm.myDomainNotification.categories)
                },
                onItemSelect: function () {
                    onCategorySelect(vm.myDomainNotification.categories)
                },
                onItemDeselect: function () {
                    onCategoryDeselect(vm.myDomainNotification.categories)
                },
            };
            vm.warningListEvent = {
                onSelectAll: function () {
                    vm.myDomainNotification.warningNames = angular.copy(vm.warningNameOptions);
                    onWarningSelect(vm.myDomainNotification.warningNames)
                },
                onDeselectAll: function () {
                    vm.myDomainNotification.warningNames = [];
                    onWarningDeselect(vm.myDomainNotification.warningNames)
                },
                onItemSelect: function () {
                    onWarningSelect(vm.myDomainNotification.warningNames)
                },
                onItemDeselect: function () {
                    onWarningDeselect(vm.myDomainNotification.warningNames)
                },
            };

            function collectFleets() {
                vm.selectedFleets = [];
                for (var x = 0; x < vm.tabFleets.length; x++) {
                    for (var i = 0; i < vm.myDomainNotification.fleets.length; i++) {
                        if (vm.tabFleets[x].id == vm.myDomainNotification.fleets[i].id) {
                            vm.selectedFleets.push(vm.tabFleets[x]);
                        }
                    }
                }
            }

            function collectCategories() {
                vm.selectedCategories = [];
                for (var x = 0; x < vm.categories.length; x++) {
                    for (var i = 0; i < vm.myDomainNotification.categories.length; i++) {
                        if (vm.categories[x].id == vm.myDomainNotification.categories[i].id && vm.myDomainNotification.categories[i].id != -1) {
                            vm.selectedCategories.push(vm.categories[x]);
                        }
                    }
                }
            }

            function collectWarnings() {
                vm.selectedWarnings = [];

                var selectedFleetIds = vm.myDomainNotification.fleets.map(f => f.id);
                var selectedCategoryIds = vm.myDomainNotification.categories.map(c => c.id);

                vm.myDomainNotification.warningNames.forEach(selected => {

                    // 1. Retrieves full object by id
                    var fullObj = vm.warningNames.find(w => w.id === selected.id);
                    if (!fullObj) return;

                    // 2. Retrieves rules by name
                    var rulesForName = vm.warningNameMap[fullObj.name] || [];

                    rulesForName.forEach(rule => {
                        // Controllo se la rule appartiene a una flotta e categoria selezionata
                        if (selectedFleetIds.includes(rule.tabFleets.id) &&
                            selectedCategoryIds.includes(rule.warningCategory.id)) {

                            // Creo una copia pulita (senza label)
                            var ruleCopy= Object.assign({}, rule);
                            delete ruleCopy.label;

                            vm.selectedWarnings.push(ruleCopy);
                        }
                    });
                });
            }


            vm.precompile = function () {

                vm.nameForTitle = angular.copy(vm.myDomainNotification.name);
                vm.systemWarningExists = false;

                if (vm.myDomainNotification.fleets.length > 0) {    // in case is edit or clone
                    if (vm.myDomainNotification.id != null) {
                        vm.isEdit = true;
                    }
                    if (vm.myDomainNotification.id == null) {
                        vm.isClone = true;
                    }
                    vm.myDomainNotification.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                        vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                    });
                    vm.myDomainNotification.fleets = angular.copy(vm.fleetSelectedAtStart);

                    // Check for system warnings
                    vm.systemWarningExists = vm.myDomainNotification.warningNames.some(selected =>
                        selected.warningCategory == null
                    );

                    vm.myDomainNotification.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                        vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                    });
                    vm.myDomainNotification.categories = angular.copy(vm.categorySelectedAtStart);

                    // Se c'è almeno un system warning, aggiungo la categoria {-1, 'system'}
                    if (vm.systemWarningExists) {
                        vm.myDomainNotification.categories.push({id: -1, warningName: "system"});
                    }

                    // --

                    var fleetIds4 = [];
                    vm.myDomainNotification.fleets.forEach(function (fleet) {
                        fleetIds4.push(fleet.id)
                    })

                    // Set warning name options
                    var warningNamesMap = new Map();
                    vm.myDomainNotification.categories.forEach(category => {
                        vm.warningNames.forEach(warning => {
                            if (warning.warningCategory.id === category.id && fleetIds4.includes(warning.tabFleets.id)) {
                                warning.label = warning.name;
                                warningNamesMap.set(warning.name, warning);
                            }
                        })
                    })
                    vm.warningNameOptions = Array.from(warningNamesMap.values());

                    // Dedupe rules by name before selection
                    vm.myDomainNotification.warningNames = dedupeByName(vm.myDomainNotification.warningNames);

                    // Selected options that match by name remain selected, additional options are not selected automatically
                    var finalSelection = [];
                    vm.myDomainNotification.warningNames.forEach(selected => {

                        if (selected.warningCategory == null) {
                            vm.systemWarningExists = true;
                        }

                        // 1. Retrieves full object by id
                        var fullObj = vm.warningNames.find(w => w.id === selected.id);
                        if (!fullObj) return;

                        // 2. Find object with same name in option list
                        var match = vm.warningNameOptions.find(opt => opt.name === fullObj.name);
                        if (!match) return;

                        // 3. Add object to final selection
                        finalSelection.push(match);
                    });

                    // Imposto la selezione iniziale senza duplicati
                    vm.warningSelectedAtStart = angular.copy(finalSelection);
                    vm.myDomainNotification.warningNames = angular.copy(vm.warningSelectedAtStart);

                    // --

                    var categoryIds8 = [];

                    vm.warningNames.forEach(warningOption => {
                        if (fleetIds4.includes(warningOption.tabFleets.id)) {
                            vm.categoryOptions.forEach(function (option) {
                                categoryIds8.push(option.id);
                            })
                            if (!categoryIds8.includes(warningOption.warningCategory.id))
                                vm.categoryOptions.push({
                                    id: warningOption.warningCategory.id,
                                    label: warningOption.warningCategory.warningName
                                });
                        }
                    })
                    vm.fleetEmpty = false;
                    vm.categoryEmpty = false;

                    var date = new Date(vm.myDomainNotification.nextExecutionDatetime);
                    vm.myDomainNotification.nextExecutionDatetime = angular.copy(date);

                } else {
                    vm.isCreate = true;
                    vm.myDomainNotification.userProfile = vm.currentUserProfile;
                }
            }

        }
    }

)
();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationController', MyDomainNotificationController);

    MyDomainNotificationController.$inject = ['$rootScope', '$q', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'MyDomainNotification', '$scope', '$timeout', '$uibModal', 'TabObjects', 'AlertRules', 'TabFleets', 'WarningCategory', 'domain', 'AlertSystem'];

    function MyDomainNotificationController($rootScope, $q, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, MyDomainNotification, $scope, $timeout, $uibModal, TabObjects, AlertRules, TabFleets, WarningCategory, domain, AlertSystem) {
        var vm = this;
        vm.myDomainNotification = [];
        vm.requestBody = {};
        vm.loadPage = loadPage;
        vm.tooggleStatus = tooggleStatus;
        vm.changePageSize = changePageSize;
        vm.applySearch = applySearch;
        vm.applyFilter = applyFilter;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.enableTooltip = enableTooltip;

        vm.currentStateFilter = "my-domain-notification-filter";
        vm.currentState = "my-domain-notification";
        vm.predicates = pagingParams.predicates;
        vm.searchParams = pagingParams.search;
        vm.licence = $rootScope.licence;
        vm.filter = pagingParams.filter;
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.enableSlack = [];
        vm.enableMail = [];
        vm.mdnac = [];
        vm.showClose = false;
        vm.picker = {
            start: false,
            end: false
        };
        vm.notificationSystems = ['email', 'telegram'];
        vm.notification;
        vm.domain = domain;

        function enableTooltip(channel, id) {
            vm[channel][id].tooltip = true;
            $timeout(function () {
                vm[channel][id].tooltip = false;
            }, 2000);
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll();

        function loadAll() {
            MyDomainNotification.get({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                search: vm.searchParams
            }, onSuccess, onError);

            function onSuccess(data, headers, notify) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.myDomainNotification = data.myDomainNotifications;
                vm.notification = data.notification;
                vm.page = pagingParams.page;
                $timeout(function () {
                    enableAlertSystem(vm.myDomainNotification); // to fix bug : notification channel symbol not loading
                }, 50);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.searchParams,
                itemsPerPageChosen: vm.itemsPerPageChosen,
            }, {notify: notify, location: "replace"});
        }

        function enableAlertSystem(myDomainNotifications) {
            myDomainNotifications.forEach(function (myDomainNotification) {
                vm.mdnac[myDomainNotification.id] = {};
                vm.mdnac[myDomainNotification.id].email = false;
                vm.mdnac[myDomainNotification.id].telegram = false;
                myDomainNotification.myDomainNotificationAlertConfigurations.forEach(function (mdnac) {
                    var name = mdnac.alertSystemType.name;
                    vm.mdnac[myDomainNotification.id][name] = mdnac.active;
                });
                if (!(domain.enableAlerting && domain.mailAlerting))
                    myDomainNotification.relatedAlertSystemType.Channelemail = vm.mdnac[myDomainNotification.id].email = domain.enableAlerting && domain.mailAlerting;
                if (!(domain.enableAlerting && domain.telegramAlerting))
                    myDomainNotification.relatedAlertSystemType.Channeltelegram = vm.mdnac[myDomainNotification.id].telegram = domain.enableAlerting && domain.telegramAlerting;
                vm.isEnableMail = myDomainNotification.relatedAlertSystemType.email != null && myDomainNotification.relatedAlertSystemType.email != undefined && myDomainNotification.relatedAlertSystemType.Channelemail != undefined && myDomainNotification.relatedAlertSystemType.Channelemail && vm.mdnac[myDomainNotification.id].email;
                vm.isEnableTelegram = myDomainNotification.relatedAlertSystemType.telegram != null && myDomainNotification.relatedAlertSystemType.telegram != undefined && myDomainNotification.relatedAlertSystemType.Channeltelegram != undefined && myDomainNotification.relatedAlertSystemType.Channeltelegram && vm.mdnac[myDomainNotification.id].telegram;
                vm.enableMail[myDomainNotification.id] = vm.setWarningStatus(vm.isEnableMail, domain.mailAlerting, vm.notification.warningEmail, myDomainNotification.relatedAlertSystemType.email, vm.mdnac[myDomainNotification.id].email, myDomainNotification.active);
                vm.enableTelegram[myDomainNotification.id] = vm.setWarningStatus(vm.isEnableTelegram, domain.telegramAlerting, vm.notification.warningTelegram, myDomainNotification.relatedAlertSystemType.telegram, vm.mdnac[myDomainNotification.id].telegram, myDomainNotification.active);
            });
        }

        vm.setWarningStatus = function (enabled, domainNotification, userNotification, related, wac, myDomainNotification) {
            var objToReturn = {status: false, config: {}};
            if (enabled) {
                if (related && domainNotification === true && userNotification === true && myDomainNotification === true) {
                    objToReturn.status = true;
                    objToReturn.config.color = 'color-green';
                } else {
                    objToReturn.status = true;
                    objToReturn.config.color = 'background-red';
                }
            } else objToReturn.config.color = 'color-grey';
            return objToReturn;
        }

        function tooggleStatus(myDomainNotification) {
            if (!!myDomainNotification.active) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-my-domain-notification-status.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.myDomainNotification = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return myDomainNotification;
                        }
                    }
                }).result.then(function () {
                    myDomainNotification.active = !myDomainNotification.active;
                    MyDomainNotification.update(myDomainNotification, function () {
                        loadAll();
                    });
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-my-domain-notification-status.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.myDomainNotification = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return myDomainNotification;
                        }
                    }
                }).result.then(function () {
                    myDomainNotification.active = !myDomainNotification.active;
                    MyDomainNotification.update(myDomainNotification, function () {
                        loadAll();
                    });
                });
            }
        }

        vm.changeStatus = function (myDomainNotification, type, notification, typeToCheck) {
            if (typeToCheck.status && notification === true) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-domain-notification/modals/change-notification-channel.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;
                        vm.myDomainNotification = myDomainNotification;
                        vm.type = type;
                        vm.notification = notification;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                    MyDomainNotification.myDomainNotifications({
                        id: myDomainNotification.id,
                        type: type
                    }, onChangeSuccess, onChangeError);
                });
            } else {
                vm.rerouteToSettings(vm.notification, vm.domain, type, typeToCheck);
            }
        };

        function onChangeSuccess(myDomainNotification) {
            vm.myDomainNotification.forEach(function (warn) {
                if (warn.id == myDomainNotification.id)
                    warn.relatedAlertSystemType = myDomainNotification.relatedAlertSystemType;
            });
            loadAll()
        }

        function onChangeError() {
        }

        vm.rerouteToSettings = function (userNotifications, domain, type, typeToCheck) {
            $uibModal.open({
                templateUrl: 'app/entities/my-domain-notification/modals/reroute-modal.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;
                    vm.notification = null;
                    vm.myDomainNotificationCondition = null;
                    vm.domain = domain;
                    vm.type = type;
                    vm.typeToCheck = typeToCheck;
                    if (type === 'email') {
                        vm.notification = userNotifications.warningEmail;
                        vm.myDomainNotificationCondition = vm.domain.mailAlerting;
                    } else if (type === 'telegram') {
                        vm.notification = userNotifications.warningEmail;
                        vm.myDomainNotificationCondition = vm.domain.telegramAlerting;
                    }

                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result.then(function () {
                $state.go('general-settings');
            });
        };

        function applyFilter() {
            if (vm.filter.start < vm.filter.end || vm.filter.start == vm.filter.end) {
                localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
                loadAll();
            } else {
                AlertService.error("Error validation date.");
            }
        }

        vm.notificationsHelp = function () {
            $uibModal.open({
                templateUrl: 'app/entities/warning/notifications-help.html',
                controller: 'NotificationsHelpController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('my-domain-notification');
            });
        };

        vm.deleteRule = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/my-domain-notification/my-domain-notification-delete-dialog.html',
                controller: 'MyDomainNotificationDeleteDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: id});
                    }]
                }
            }).result.then(function () {
                loadAll();
            });
        };

        function applySearch() {
            pagingParams.page = 1;
            loadAll(false);
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            //vm.savePage();
            vm.transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

    }
})
();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('MyDomainNotification', MyDomainNotification)

    MyDomainNotification.$inject = ['$resource'];

    function MyDomainNotification($resource) {
        var resourceUrl = 'api/my-domain-notification';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                url: 'api/my-domain-notification/',
                method: 'GET',
            },
            'getOne': {
                url: 'api/my-domain-notification/find-one/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getClone': {
                url: 'api/my-domain-notification/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': {
                method: 'POST',
                isArray: true
            },
            'myDomainNotifications': {
                method: 'GET',
                url: 'api/my-domain-notification/notification-status/:id/:type'
            },
            'insertDomainAlerts': {
                method: 'PUT',
                url: 'api/my-domain-notification/alert-configuration'
            },
            'update': {
                url: 'api/my-domain-notification',
                method: 'PUT'
            },
            'delete': {
                url: 'api/my-domain-notification/:id',
                method: 'DELETE'
            },
            'getCurrentUserProfile': {
                url: 'api/my-domain-notification/userProfile',
                method: 'GET'
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('AlertSystem', AlertSystem);

    AlertSystem.$inject = ['$resource'];

    function AlertSystem ($resource) {
        var resourceUrl =  'api/my-channel/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'userAlertSystem' : {
                method:'PUT' ,
                url:'api/my-channel-user'
            },
            'getUserAlertSystem' : {
                method:'GET' ,
                url:'api/my-channel-user/:user',
                isArray: true
            },
            'getSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/state'
            },
            'checkSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/status'
            },
            'sendSlackWelcome' : {
                method:'GET' ,
                url:'api/slack/integration/test'
            },
            'sendMailCode' : {
                method:'GET' ,
                url:'api/mail/integration?email=:email'
            },
            'checkMailCode' : {
                method:'GET' ,
                url:'api/mail/authorize?authorizationCode=:authorizationCode'
            },
            'checkTelegramCode' : {
                method:'GET' ,
                url:'api/telegram/authorize?authorizationCode=:authorizationCode'
            },
            'getAuthentications' : {
                method:'GET' ,
                url:'api/webhook/integration/authenticationType',
                isArray : true
            },
            'checkWebhook' : {
                method:'POST' ,
                url:'api/webhook/integration/test'
            },
            'saveWebhook' : {
                method:'GET' ,
                url:'api/webhook/integration/save'
            }
        });
    }
})();

;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('my-domain-notification', {
                parent: 'alerting',
                url: '/my-domain-notification?search&page&sort',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification.html',
                        controller: 'MyDomainNotificationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            name: $stateParams.name,
                            fleet: $stateParams.fleet,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myDomainNotification');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    domain: ['TabDomains', function (TabDomains) {
                        return TabDomains.current();
                    }]
                }
            })
            .state('my-domain-notification-view', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-detail.html',
                        controller: 'MyDomainNotificationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: $stateParams.id});
                    }]
                }
            })
            .state('my-domain-notification-new', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            name: null,
                            active: true,
                            frequency: null,
                            userProfile: null,
                            wipStatus: "all",
                            objectsStatus: "all",
                            status: "all",
                            fleets: [],
                            categories: [],
                            warningNames: [],
                            cron: "0 0 * * *",
                            nextExecutionDatetime: null,
                            myDomainNotificationAlertConfigurations : []
                        };
                    }
                }
            })
            .state('my-domain-notification-edit', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}/edit',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getOne({id: $stateParams.id});
                    }]
                }
            })
            .state('my-domain-notification-clone', {
                parent: 'my-domain-notification',
                url: '/my-domain-notification/{id}/clone',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.myDomainNotification.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/my-domain-notification/my-domain-notification-dialog.html',
                        controller: 'MyDomainNotificationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function ($stateParams, MyDomainNotification) {
                        return MyDomainNotification.getClone({id: $stateParams.id}).$promise
                    }]
                }
            })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultDeleteController', ObjectTestResultDeleteController);

    ObjectTestResultDeleteController.$inject = ['$uibModalInstance', 'name', 'ObjectTestResult', 'type'];

    function ObjectTestResultDeleteController($uibModalInstance, name, ObjectTestResult, type) {
        var vm = this;
        vm.name = name;
        vm.type = type;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function () {
            ObjectTestResult.deletePdf({name: name, type: type}).$promise.then(function () {
                $uibModalInstance.close();
            });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultHistoryController', ObjectTestResultHistoryController);

    ObjectTestResultHistoryController.$inject = ['$scope', '$state', '$http', '$sce', 'ObjectTestResult', '$uibModal', 'ParseLinks', 'AlertService', 'pagingParams'];

    function ObjectTestResultHistoryController($scope, $state, $http, $sce, ObjectTestResult, $uibModal, ParseLinks, AlertService, pagingParams) {
        var vm = this;
        vm.tabObjects = [];
        vm.checkestensione = false;
        vm.objectTestHistory = [];
        vm.objectInTest = [];
        vm.page = 0;
        vm.pdf = "pdf";
        vm.csv = "csv";
        vm.obj = {
            objectTypeName: pagingParams.object,
            id: pagingParams.id
        };

        if (vm.obj.objectTypeName !== null && vm.obj.objectTypeName !== undefined) {
            ObjectTestResult.historyObjectTest({object: vm.obj.objectTypeName}).$promise.then(function (tests) {
                if (tests.length > 0) {
                    vm.objectTestHistory = [];
                    if(vm.obj.id != -1)
                    {
                        tests.forEach(function (test) {
                            vm.objectTestHistory.push(test.split("\.")[0]);
                        })
                    }
                    else{
                        tests.forEach(function (test) {
                            vm.objectTestHistory.push(test);
                        })
                    }

                }
            });
        }

        vm.openFilePdf = function (name) {
            var body = {fileName: name, type: "inline"};

            $http.post("api/object-test-pdf", body, {responseType: 'blob'}
            ).then(function (data) {
                vm.showPdfFile = $sce.trustAsResourceUrl(
                    URL.createObjectURL(
                        new Blob([data.data], {type: data.headers("Content-Type")})));
                $uibModal.open({
                    templateUrl: 'app/management/commands/showPdf.html',
                    controller: 'ShowPdfController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    windowClass: 'app-modal-window',
                    resolve: {
                        content: function () {
                            return vm.showPdfFile;
                        }
                    }
                }).result.then(function () {
                    vm.showPdfFile = "";
                });
            });
        }

        vm.downloadFilePdf = function (name) {
            var body = {fileName: name, type: "attachment", estensione: ".pdf"};

            $http.post('api/object-test-pdf', body, { responseType: 'blob' }
            ).then(function(data) {
                var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                var contentDisposition = data.headers("Content-Disposition");
                anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                anchor.href = url;
                anchor.click();
            });
        }
        vm.downloadFilePdf1 = function (name) {
            var body = {fileName: name, type: "attachment", estensione: ".csv"};

            $http.post('api/object-test-pdf', body, { responseType: 'blob' }
            ).then(function(data) {
                var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                var contentDisposition = data.headers("Content-Disposition");
                anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                anchor.href = url;
                anchor.click();
            });
        }
        vm.checkFiletype = function (name){
            var estensione = name.split('.');
            estensione = estensione[estensione.length -1];
            console.log(estensione);
            if(estensione === "csv")
            {
                vm.checkestensione = true;
            }
            else
                vm.checkestensione = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultController', ObjectTestResultController);

    ObjectTestResultController.$inject = ['$scope', '$state', 'ObjectTestResult', 'TestSchedule', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', 'scheduleId', 'fromManualTests'];

    function ObjectTestResultController($scope, $state, ObjectTestResult, TestSchedule, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag, scheduleId, fromManualTests) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.filterTag = {};
            vm.filterTag.id = -1;
            vm.filterTag.testTag = "All";
            vm.testsTag.unshift(vm.filterTag);
        })

        if (id !== null && id !== undefined) {
            vm.objectTestResults = [];
            loadTest();
        }

        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function checkAndOrderByManualTests() {
            vm.objectTestResults.forEach(function (test) {
                test.check = test.objectTestSetting.manual;
                vm.objectTestResults.sort((a, b) => b.check - a.check);
            });
        }

        function defaultCheckAndOrder() {
            vm.objectTestResults.forEach(function (test) {
                test.check = false;
            });
            vm.objectTestResults.sort((a, b) => new Date(b.lastExecution) - new Date(a.lastExecution));
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;
                ObjectTestResult.retrieveObjectTest({object: id, testTagId: vm.filterTag === undefined ? -1 : vm.filterTag.id})
                    .$promise.then(function (tests) {
                        vm.objectTestResults = tests;
                        if(scheduleId != null) {
                            ObjectTestResult.bySchedule({id: scheduleId}).$promise.then(function (testsBySchedule) {
                                checkSelectedTests(testsBySchedule);
                            });
                        } else if(fromManualTests === true) {
                            checkAndOrderByManualTests();
                        } else {
                            defaultCheckAndOrder();
                        }

                        vm.hasNotResults = !tests.length > 0;
                    });
            });
        }

        function checkSelectedTests(scheduleTests) {
            vm.objectTestResults.forEach(function (test) {
                test.check = false;
                scheduleTests.forEach(function (scheduleTest) {
                    if (test.id === scheduleTest.id) {
                        test.check = true;
                        test.isUpdatedByOther = test.lastExecutionByTestScheduleId !== scheduleId;
                    }
                });
            });
            vm.objectTestResults.sort((a,b) => b.check - a.check);
        }

        vm.currentState = "object-test-result";

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.objNotSelected = id === null || id === undefined;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.checkAll = function (b) {
            vm.objectTestResults.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.objectTestResults.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.objectTestResults.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        function getCheckedTestListId() {
            var checkedTestResultsId = "";
            vm.objectTestResults.forEach(function (test) {
                if(test.check)
                    checkedTestResultsId = checkedTestResultsId + (checkedTestResultsId === "" ? "" : ",") + test.id;
            });
            return checkedTestResultsId;
        }

        vm.downloadPdf = function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            var tagId = vm.filterTag === undefined ? -1 : vm.filterTag.id;
            a.href = "api/object-test-result-pdf/" + id + "?test=" + getCheckedTestListId() +"&timeZone=" + encodeURI(Intl.DateTimeFormat().resolvedOptions().timeZone);
            a.setAttribute("target", "_blank");
            a.download = name[name.length - 1];
            a.click();
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ObjectTestResult', ObjectTestResult);

    ObjectTestResult.$inject = ['$resource', 'DateUtils'];

    function ObjectTestResult ($resource, DateUtils) {
        var resourceUrl =  'api/object-test-result/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'execute': { url: 'api/object-test-result-execute', method:'PUT'},
            'retrieveObjectTest': {
                url: 'api/object-test-result-object/:object',
                method: 'GET',
                isArray: true
            },
            'retrieveAutoOrManualObjectTest': { //per avere solo test automatici o solo test manuali
                url: 'api/object-test-result-object/automatic-or-manual/:object',
                method: 'GET',
                isArray: true
            },
            // 'testsForScheduling': { url:'api/object-test-result/tests-for-scheduling', method: 'GET', isArray: true},
            'bySchedule': {
                url: "api/object-test-result/by-test-schedule/:id",
                method: 'GET',
                isArray: true
            },
            'numberOfTestsBySchedule': {
                url: "api/number-of-tests/by-test-schedule/:id",
                method: 'GET',
                isArray: true
            },
            'historyObjectTest': {
                url: 'api/object-test-result-history/:object',
                method: 'GET',
                isArray: true
            },
            'deletePdf': {
                url: 'api/object-test-remove-pdf/:name/:type',
                method: 'GET'
            },
            'byTags' : {
                method: 'GET',
                url: 'api/object-test-result-object/automatic-or-manual-tag/:object',
                isArray:true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('object-test-result', {
                parent: 'testing',
                url: '/object-test-result/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.objectTestResult.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/object-test-result/object-test-result.html',
                        controller: 'ObjectTestResultController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    },
                    scheduleId: {value: null},
                    fromManualTests: {value: false}
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    scheduleId: ['$stateParams', function ($stateParams) {
                        return $stateParams.scheduleId;
                    }],
                    fromManualTests: ['$stateParams', function ($stateParams) {
                        return $stateParams.fromManualTests;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('objectTestResult');
                        $translatePartialLoader.addPart('objectTestSetting');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('object-test-result.history', {
                parent: 'testing',
                url: '/object-test-result-history?object&id',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.objectTestResult.history.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/object-test-result/object-test-result-history.html',
                        controller: 'ObjectTestResultHistoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    object: {
                        value: null,
                        squash: true
                    },
                    id: {
                        value: null
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            object: $stateParams.object,
                            id: $stateParams.id
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('objectTestResult');
                        $translatePartialLoader.addPart('objectTestSetting');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('object-test-result.history-delete', {
            parent: 'object-test-result.history',
                url: '/delete/{name}/{type}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/object-test-result/object-test-result-history-delete-dialog.html',
                        controller: 'ObjectTestResultDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            name: [function () {
                                return $stateParams.name;
                            }],
                            type: [function () {
                                return $stateParams.type;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('object-test-result.history', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NewTagController', NewTagController);

    NewTagController.$inject = ['$state', '$uibModalInstance', 'TestSettingTag', 'AlertService'];

    function NewTagController($state, $uibModalInstance, TestSettingTag, AlertService) {
        var vm = this;
        vm.tag = {isCrossDomain: false};

        vm.clear = function () {
            // $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close();
        };

        vm.save = function () {

            var body = {
                testTag: vm.tag.name,
                crossDomain: vm.tag.isCrossDomain
            };
            TestSettingTag.create(body, onSuccess, onError);

            function onSuccess() {
                $uibModalInstance.close();
            }

            function onError() {
                AlertService.error("Tag already exist");
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingDeleteController',ObjectTestSettingDeleteController);

    ObjectTestSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'ObjectTestSetting'];

    function ObjectTestSettingDeleteController($uibModalInstance, entity, ObjectTestSetting) {
        var vm = this;

        vm.objectTestSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ObjectTestSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingDialogController', ObjectTestSettingDialogController);

    ObjectTestSettingDialogController.$inject = ['Profile_User','$timeout', '$scope', '$state', 'entity', 'ObjectTestSetting', 'TabObjectTypes', 'AlertService', 'ParseLinks', 'TabFleets', 'TestSettingTag', '$uibModal'];

    function ObjectTestSettingDialogController(Profile_User, $timeout, $scope, $state, entity, ObjectTestSetting, TabObjectTypes, AlertService, ParseLinks, TabFleets, TestSettingTag, $uibModal) {
        var vm = this;

        vm.objectTestSetting = entity;
        vm.tabObjectTypes = [];
        vm.tabFleets = [];
        vm.testsTag = [];
        vm.testsTag2 = [];
        vm.userProfiles = ["Tech","test","ADMIN","OPERATOR","TECH","test"];
        vm.metric = [];
        vm.valueToCheck=null;
        vm.tempMetric = null;
        vm.tempSecondaryMetric = null;
        vm.hasInteractedWithSecondaryMetric = false;
        vm.timeSpan = {};
        vm.periodUnit = ["Seconds","Minutes", "Hours"];
        vm.page = 0;
        vm.save = save;
        vm.clear = clear;
        vm.checkAggregationAllowed = checkAggregationAllowed;

        if (vm.objectTestSetting.checkType && vm.objectTestSetting.checkType === 'Between') {
            var values = vm.objectTestSetting.expectedValue.split(',');
            vm.expectedA = parseInt(values[0]);
            vm.expectedB = parseInt(values[1]);
        } else if (vm.objectTestSetting.checkType && (vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals')) {
            vm.expected = vm.objectTestSetting.expectedValue;
        } else {
            vm.expectedNumber = parseInt(vm.objectTestSetting.expectedValue);
        }

        if(vm.objectTestSetting.valueToCheck) {
            vm.valueToCheck = vm.objectTestSetting.valueToCheck;
        }

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
        })

        if(vm.objectTestSetting.timeSpan) {
            if(vm.objectTestSetting.timeSpan === 'Last value') {
                vm.timeSpan.time = vm.objectTestSetting.timeSpan;
            } else {
                if (vm.objectTestSetting.timeSpan.endsWith('s')) {
                    vm.timeSpan.time = "Seconds";
                } else if (vm.objectTestSetting.timeSpan.endsWith('m')) {
                    vm.timeSpan.time = "Minutes";
                } else {
                    vm.timeSpan.time = "Hours";
                }
                vm.timeSpan.period = parseInt(vm.objectTestSetting.timeSpan.substring(0, vm.objectTestSetting.timeSpan.length - 1));
            }
            checkAggregationAllowed();
        }
        vm.checkTypes = ObjectTestSetting.checkType();

        vm.aggregations = ObjectTestSetting.aggregations();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('object-test-setting');
        }

        function save() {
            vm.isSaving = true;

            // clearance secondary metric
            if(!vm.hasInteractedWithSecondaryMetric) {
                vm.objectTestSetting.secondaryMetric = null;
                vm.objectTestSetting.secondaryMetricExpectedValue = null;
            }

            // if(!vm.objectTestSetting.manual && vm.objectTestSetting.metric.indexOf("properties") > -1 && vm.objectTestSetting.metric.indexOf("keyword") < 0) {
            //     vm.objectTestSetting.metric = vm.objectTestSetting.metric + ".keyword";
            // }
            if (!vm.objectTestSetting.manual && ((vm.objectTestSetting.checkType !== 'Between' && vm.objectTestSetting.checkType !== 'Exists' && vm.objectTestSetting.checkType !== 'Not Exists' &&
                    (((vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') && (vm.expected.length === 0 || angular.isUndefined(vm.expected))) ||
                        ((vm.objectTestSetting.checkType !== 'Equals' && vm.objectTestSetting.checkType !== 'Not Equals') && (vm.expectedNumber === null || angular.isUndefined(vm.expectedNumber )))))
                || (vm.objectTestSetting.checkType === 'Between' && (angular.isUndefined(vm.expectedA) || angular.isUndefined(vm.expectedB))))) {
                AlertService.error("Insert expected value");
                vm.isSaving = false; // reset saving state
            } else {
                if(!vm.objectTestSetting.manual) {
                    if (vm.objectTestSetting.checkType === 'Between') {
                        vm.objectTestSetting.expectedValue = vm.expectedA + "," + vm.expectedB;
                    } else if (vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') {
                        vm.objectTestSetting.expectedValue = vm.expected;
                    } else {
                        vm.objectTestSetting.expectedValue = vm.expectedNumber;
                    }
                    if(vm.valueToCheck !== null) {
                        vm.objectTestSetting.valueToCheck = vm.valueToCheck;
                    }
                    if(vm.timeSpan.time === 'Last value') {
                        vm.objectTestSetting.timeSpan = vm.timeSpan.time;
                    } else {
                        if(vm.timeSpan.period === undefined || vm.timeSpan.period === null || vm.timeSpan.period === "") {
                            AlertService.error("Insert Period");
                            vm.isSaving = false;
                            return;
                        } else if (vm.timeSpan.time === "Seconds") {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "s";
                        } else if (vm.timeSpan.time === "Minutes") {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "m";
                        } else {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "h";
                        }
                    }
                } else {
                    vm.objectTestSetting.checkType = "Manual";
                    vm.objectTestSetting.aggregation = "None";
                    vm.objectTestSetting.metric = "";
                    vm.objectTestSetting.timeSpan="";
                    vm.objectTestSetting.expectedValue = "";
                }
                if(vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists') {
                    vm.objectTestSetting.expectedValue = null;
                }
                if (vm.objectTestSetting.id !== null) {
                    ObjectTestSetting.update(vm.objectTestSetting, onSaveSuccess, onSaveError);
                } else {
                    ObjectTestSetting.save(vm.objectTestSetting, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('jotApp:objectTestSettingUpdate', result);
            vm.isSaving = false;
            $state.go('object-test-setting');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function checkAggregationAllowed() {
            if (vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists') {
                vm.objectTestSetting.aggregation = 'None';
                vm.aggregationDisabled = true;
            } else {
                vm.aggregationDisabled = false;
            }

            if (vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists' ||
                vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') {
                if(vm.periodUnit.indexOf("Last value") < 0) {
                    vm.periodUnit.push("Last value");
                }
            } else {
                if(vm.periodUnit.indexOf("Last value") > -1) {
                    vm.periodUnit.splice(3, 1);
                }
            }
        }

        vm.loadAllTypes = function () {
            TabObjectTypes.mapped().$promise.then(function (data) {
                var mappedObjectType = JSON.parse(angular.toJson(data));
                vm.tabObjectTypes = mappedObjectType[-1];
            });

            if(vm.objectTestSetting.id != null) {
                var tempM = vm.objectTestSetting.metric;
                var tempSecondaryM = vm.objectTestSetting.secondaryMetric;

                metricLoad();
                vm.tempMetric = {name: tempM};

                if(tempSecondaryM) {
                    vm.tempSecondaryMetric = {name: tempSecondaryM};
                    vm.hasInteractedWithSecondaryMetric = true; // user has not interacted
                }
            }
        };

        vm.loadAllFleets = function () {
            TabFleets.query(onSuccess, onError);

            function onSuccess(data) {
                for (var i = 0; i < data.length; i++) {
                    vm.tabFleets.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadUserProfile = function (){
            Profile_User.getUserProfile({ size: 145 }, function (results) {
                vm.testsTag2 = results;
            })
        };

        vm.loadAllTypes();
        vm.loadAllFleets();
        vm.loadUserProfile();

        vm.checkTimePeriod = function () {
            if(vm.timeSpan.time === "Last value"){
                vm.timeSpan.period = "";
            }
        };

        vm.loadMetric = function () {
            metricLoad();
        }

        function metricLoad() {
            vm.metric = [];
            vm.tempMetric = null;
            vm.tempSecondaryMetric = null;
            var body = {id: vm.objectTestSetting.tabObjectTypes.id};

            TabObjectTypes.getMapping(body, onSuccess, onError);

            function onSuccess(data) {
                var obj = data.properties;
                angular.forEach(obj, function (value, key) {
                    var metric = "", app = "";
                    metric += key.toString();
                    if(value.type == undefined){
                        angular.forEach(value.properties, function (value, key) {
                            getProperties(value,key, metric);
                        })
                    } else {
                        vm.metric.push({name: metric});
                    }
                });
            }

            function getProperties(value, key, metric) {
                var subMetric = "";
                subMetric += "." + key.toString();
                if(value.type == undefined){
                    metric += subMetric;
                    angular.forEach(value.properties, function (value, key) {
                        getProperties(value,key,metric);
                    })
                } else {
                    vm.metric.push({name: metric+subMetric});
                }
            }

            function onError(){
                AlertService.error("Mapping not Available");
            }
        }

        vm.loadUserProfilePage = function (page) {
            if (page <= vm.userProfileLinks['last']) {
                vm.userProfilePage = page;
                vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);
            }
        };

        vm.updateMetric = function () {
            vm.objectTestSetting.metric = vm.tempMetric.name;
        }

        vm.updateSecondaryMetric = function () {
            vm.hasInteractedWithSecondaryMetric = true; // user interacted
            if (vm.tempSecondaryMetric && vm.tempSecondaryMetric.name) {
                vm.objectTestSetting.secondaryMetric = vm.tempSecondaryMetric.name;
            } else {
                vm.objectTestSetting.secondaryMetric = null;
                vm.objectTestSetting.secondaryMetricExpectedValue = null;
            }
        }

        vm.newTag = function () {
            $uibModal.open({
                templateUrl: 'app/entities/object-test-setting/new-tag.html',
                controller: 'NewTagController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.reload();
            });
        };
        /*vm.loadUserProfile = function (){
            UserProfile.getUserProfile({ size: 1000 }, function (results) {
                vm.testsTag2 = results;
            });
        };*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('EditTagController', EditTagController);

    EditTagController.$inject = ['$state', 'TestSettingTag', 'AlertService', '$uibModal', 'Principal'];

    function EditTagController($state, TestSettingTag, AlertService, $uibModal, Principal) {
        var vm = this;

        vm.tags = [];
        vm.editorEnabled = [];
        vm.updateDescription = [];

        vm.loadAll = function () {
            Principal.hasAuthority("ROLE_ADMIN").then(function (isAdmin){
                if(isAdmin) {
                    TestSettingTag.byDomain({size: 1000}, function (result) {
                        vm.tags = result;
                    })
                } else {
                    TestSettingTag.customByDomain({size: 1000}, function (result) {
                        vm.tags = result;
                    })
                }
            });
        }

        vm.enableEditor = function(index, edit) {
            if(edit === 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                    if(vm.updateDescription[index] === undefined)
                        vm.updateDescription[index] = vm.tags[index].testTag;
                }
            } else if(edit === 1) {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.tags[index].testTag;
            } else {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.tags[index].testTag;
            }
        };

        vm.saveUpdate = function(index) {
            vm.tags[index].testTag = vm.updateDescription[index].toUpperCase();

            TestSettingTag.update(vm.tags[index], onSuccess, onError);

            function onSuccess() {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            }

            function onError(){
                AlertService.error("Cannot edit this tag");
            }
        };

        vm.loadAll();

        vm.newTag = function () {
            $uibModal.open({
                templateUrl: 'app/entities/object-test-setting/new-tag.html',
                controller: 'NewTagController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.reload();
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteTagController', DeleteTagController);

    DeleteTagController.$inject = ['$state', '$uibModalInstance', 'TestSettingTag', 'AlertService', 'entity'];

    function DeleteTagController($state, $uibModalInstance, TestSettingTag, AlertService, entity) {
        var vm = this;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tag = entity;
            });
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            TestSettingTag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingController', ObjectTestSettingController);

    ObjectTestSettingController.$inject = ['$scope', '$state', 'ObjectTestSetting', 'TabObjectTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabFleets', 'TestSettingTag'];

    function ObjectTestSettingController ($scope, $state, ObjectTestSetting, TabObjectTypes, ParseLinks, AlertService, pagingParams, paginationConstants, TabFleets, TestSettingTag) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.filterType = pagingParams.objectTypes;
        vm.filterFleet = pagingParams.fleets;
        vm.filterTag = pagingParams.testSettingTag;
        vm.filterTagSelected = [];

        vm.charToSearch = pagingParams.search;

        if(vm.filterTag[0] !== -1) {
            vm.filterTag.forEach( tag => {vm.filterTagSelected.push({id: tag})});

        }
        vm.transition = transition;
        vm.applyTagsFilter = applyTagsFilter;
        vm.currentState = "object-test-setting";

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        var mappedObjectType = {};
        var allFleet = {id: -1, fleetName: "All"};
        var allObjectType = {id: -1, objectTypeName: "All"};

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadObjectType = function () {
            vm.filterType = {
                id: -1,
                objectTypeName: "All"
            };
            mapObjectType();
        }

        function mapObjectType() {
            TabObjectTypes.mapped().$promise.then(function (data) {
                mappedObjectType = JSON.parse(angular.toJson(data));
                mapObjectTypes();
                vm.objectTypes = mappedObjectType[vm.filterFleet.id];
            });

            function mapObjectTypes() {
                for (var fleet in mappedObjectType) {
                    if (mappedObjectType[fleet].length > 0) {
                        mappedObjectType[fleet].unshift(allObjectType);
                    }
                }
            }
        }


        TabFleets.query({size: 1000}, function (result) {
            vm.fleets = result;
            vm.fleets.unshift(allFleet);
        })

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.testsTag.forEach((tag)=>{
                tag.label = tag.testTag;
            })
        })

        function applyTagsFilter() {
            console.log(vm.filterFleet.id, vm.filterTag.id, vm.filterTagSelected);

            vm.filterTag = vm.filterTagSelected.length > 0 ? vm.filterTagSelected.map(tag => tag.id) : [-1];
            transition(true);
        }

        vm.loadAll = function () {
            console.log(vm.filterFleet.id, vm.filterTag)
            ObjectTestSetting.searchTag({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                objectTypeId: vm.filterType.id,
                fleetId: vm.filterFleet.id ,
                testTagId: vm.filterTag,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers,notify) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.objectTestSettings = data;
                vm.page = pagingParams.page;
                vm.transition(notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition(false);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition(true);
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                objectTypes: vm.filterType,
                fleets: vm.filterFleet,
                testSettingTag: vm.filterTag
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };
        mapObjectType();
        vm.loadAll();
        vm.tagListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "Select tags",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
    }
})();


;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Profile_User', UserProfiles)
        .factory('ObjectTestSetting', ObjectTestSetting)
        .factory('TestSettingTag', TestSettingTag);


    ObjectTestSetting.$inject = ['$resource'];

    function ObjectTestSetting ($resource) {
        var resourceUrl =  'api/object-test-setting/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;

                }
            },
            'getClone': {
                url:'api/object-test-setting/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'checkType': { url:'api/object-test-setting/checkType', method: 'GET', isArray: true},
            'aggregations': { url:'api/object-test-setting/aggregations', method: 'GET', isArray: true},
            'notManualTests': { url:'api/object-test-setting/not-manual', method: 'GET', isArray: true},
            'update': { method:'PUT' },
            'searchTag':{ url:'api/object-test-setting/search-tag', method: 'GET', isArray: true}
        });
    }

    TestSettingTag.$inject = ['$resource'];

    function TestSettingTag($resource) {
        var resourceUrl = 'api/test-setting-tag/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'byDomain': {method: 'GET', url:'api/test-setting-tag/by-domain', isArray: true},
            'customByDomain': {method: 'GET', url:'api/test-setting-tag/custom-by-domain', isArray: true},
            'getUserProfile': {method: 'GET', url:'api/user-profiles', isArray: true},
            'create': {method: 'POST', url:'api/test-setting-tag/create-new'},
            'update': {method: 'PUT', url:'api/test-setting-tag/update-tag'}
        });
    }
    UserProfiles.$inject = ['$resource'];

    function UserProfiles($resource){
        var resourceUrl = 'api/user-profiles';
        return $resource(resourceUrl, {},{
            'getUserProfile': {method: 'GET', url:'api/user-profiles', isArray: true}
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('object-test-setting', {
            parent: 'testing',
            url: '/object-test-setting?page&sort&search',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting.html',
                    controller: 'ObjectTestSettingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                search: null,
                predicates: {},
                objectTypes: {
                    id: -1,
                    objectTypeName: "All"
                },
                fleets: {
                    id: -1,
                    fleetName: "All"
                },
                testSettingTag: {
                    value : [-1]
                },
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        objectTypes: $stateParams.objectTypes,
                        fleets: $stateParams.fleets,
                        testSettingTag: $stateParams.testSettingTag
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('object-test-setting-new', {
            parent: 'object-test-setting',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        name: null,
                        metric: null,
                        expectedValue: null,
                        checkType: null,
                        aggregation: null,
                        timeSpan: null,
                        description: null,
                        id: null
                    };
                }
            }
        })
        .state('object-test-setting-edit', {
            parent: 'object-test-setting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObjectTestSetting', function($stateParams, ObjectTestSetting) {
                    return ObjectTestSetting.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('object-test-setting-clone', {
            parent: 'object-test-setting',
            url: '/{id}/clone',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObjectTestSetting', function($stateParams, ObjectTestSetting) {
                    return ObjectTestSetting.getClone({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('object-test-setting.delete', {
            parent: 'object-test-setting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-delete-dialog.html',
                    controller: 'ObjectTestSettingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ObjectTestSetting', function(ObjectTestSetting) {
                            return ObjectTestSetting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('object-test-setting', null, { reload: 'object-test-setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('object-test-setting-edit-tag', {
            parent: 'object-test-setting',
            url: '/edit-tag',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.home.edit'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-edit-tag.html',
                    controller: 'EditTagController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }]
            }
        })
        .state('object-test-setting-edit-tag.delete', {
            parent: 'object-test-setting-edit-tag',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-tag-delete-dialog.html',
                    controller: 'DeleteTagController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TestSettingTag', function (TestSettingTag) {
                            return TestSettingTag.get({id: $stateParams.id});
                        }],
                    }
                }).result.then(function () {
                    $state.go('object-test-setting-edit-tag', null, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('PublishMessageController', PublishMessageController);

    PublishMessageController.$inject = ['PublishMessage', 'AlertService'];

    function PublishMessageController(PublishMessage, AlertService) {
        var vm = this;

        vm.save = function () {
            PublishMessage.publishMessage({topic:vm.topic, message: vm.message}, onSuccess, onError);

            function onSuccess() {
                vm.message="";
            }

            function onError() {
                AlertService.error("Message not sent");
            }
        }

    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('PublishMessage', PublishMessage);

    PublishMessage.$inject = ['$resource'];

    function PublishMessage($resource) {
        var resourceUrl = 'api/publishMessage';

        return $resource(resourceUrl, {}, {
            'publishMessage' : {method: 'POST'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('publish-message', {
                parent: 'management',
                url: '/publishMessage',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.publishMessage.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/publishMessage/publishMessage.html',
                        controller: 'PublishMessageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('publishMessage');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueForcedDialog',QueueForcedDialog);

    QueueForcedDialog.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueForcedDialog($uibModalInstance, entity, Queue) {
        var vm = this;
        vm.queue;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
            });
        }


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmForced = function (id) {
            Queue.forceComplet({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueStopDialog',QueueStopDialog);

    QueueStopDialog.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueStopDialog($uibModalInstance, entity, Queue) {
        var vm = this;
        vm.queue;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
            });
        }


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmStop = function (id) {
            Queue.stopCron({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueuesDeleteController',QueuesDeleteController);

    QueuesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueuesDeleteController($uibModalInstance, entity, Queue) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queues = entity;
                if (vm.queues.licenseExpirationDate != null) {
                    vm.queues.licenseExpirationDate = new Date(vm.queues.licenseExpirationDate);
                }
            });
        }

        vm.queues;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Queue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueDetailController', QueueDetailController);

    QueueDetailController.$inject = ['$stateParams', '$state', 'Queue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', 'entity'];

    function QueueDetailController($stateParams, $state, Queue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, entity) {
        var vm = this;
        vm.queue = [];
        vm.timeline = [];
        vm.timelines = [];
        vm.showCommand = {};

        // Add the new function
        vm.getActionDisplayName = getActionDisplayName;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
                if (vm.queue.licenseExpirationDate != null) {
                    vm.queue.licenseExpirationDate = new Date(vm.queue.licenseExpirationDate);
                }
                vm.queue.queueCommands.sort(function (a, b) {
                    var commandA = a.order, commandB = b.order;
                    return commandA-commandB;
                });
                vm.queue.queueCommands.sort(function (a, b) {
                    var dateA = new Date(a.executionDatetime), dateB = new Date(b.executionDatetime);
                    return dateA-dateB;
                });
                var c = 0;
                for(var i = 0; i < vm.queue.queueCommands.length; i++){
                    if(vm.queue.queueCommands[i].executionDatetime == null){
                        var temp = vm.queue.queueCommands[i];
                        vm.queue.queueCommands.splice(i, 1);
                        vm.queue.queueCommands.push(temp);
                        i--;
                    } else {
                        break;
                    }
                    if(c == vm.queue.queueCommands.length -1){
                        break;
                    }
                    c++;
                }
                c = 0;
                for(var i = 0; i < vm.queue.queueCommands.length; i++){
                    if(c < 10 && c < vm.queue.queueCommands.length){
                        vm.timeline.push(vm.queue.queueCommands[i]);
                    } else {
                        vm.timelines.push(vm.timeline);
                        vm.timeline = [];
                        c = 0;
                        vm.timeline.push(vm.queue.queueCommands[i]);
                    }
                    c++;
                }
                vm.timelines.push(vm.timeline);
            });
        }

        vm.findIndexCommand = function (command, timeline){
            for(var i = 0; i < timeline.length; i++){
                if(timeline[i].id == command.id){
                    return (i*10)+4;
                }
            }
        };

        vm.printCommand = function(command, index){
            Object.keys(vm.showCommand).forEach(function (key) {
                vm.showCommand[key] = false;
            })
            vm.showCommand[index] = true;
            vm.command = command;
        }

        vm.isEmpty = function (argumentMap) {
            return Object.keys(argumentMap).length > 0;
        }

        /**
         * Get the display name for the command action.
         * For non-Greengrass: returns actions.actionCommand
         * For Greengrass: extracts action from response field
         */
        function getActionDisplayName(command) {
            // If actions exists (non-Greengrass), use it
            if (command.actions && command.actions.actionCommand) {
                return command.actions.actionCommand;
            }

            //// For Greengrass commands, extract from response
            //if (command.response) {
            //    return extractActionFromResponse(command.response);
            //}

            return command.commandName;
        }

        /**
         * Extract action name from response field
         * Handles both plain string "RESET_VIDEO_BOARD_A" and JSON {"action":"RESET_VIDEO_BOARD_A",...}
         */
        function extractActionFromResponse(response) {
            if (!response || response.trim() === '') {
                return 'Unknown Action';
            }

            var trimmedResponse = response.trim();

            // Check if it's JSON (starts with '{')
            if (trimmedResponse.charAt(0) === '{') {
                try {
                    var jsonObj = JSON.parse(trimmedResponse);
                    if (jsonObj.action) {
                        return jsonObj.action;
                    }
                    return 'Unknown Action';
                } catch (e) {
                    console.warn('Failed to parse response as JSON:', trimmedResponse);
                    return 'Unknown Action';
                }
            } else {
                // Plain string - return as is
                return trimmedResponse;
            }
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueController', QueueController);

    QueueController.$inject = ['$stateParams', '$state', '$scope', 'Queue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', 'TabObjects', '$uibModal'];

    function QueueController($stateParams, $state, $scope, Queue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, TabObjects, $uibModal) {
        var vm = this;

        //Aggiunta per Queue
        vm.transition = transition;
        vm.queue = [];
        vm.checkQueueEmpty = true;
        vm.now = [];
        vm.systemItemLimit = 10;
        vm.once = [];
        vm.scheduled = [];
        vm.completed = [];
        vm.filter = {};

        //vm.predicates = {'insertDateTime': false};
        vm.page = 0;
        vm.applyFilterPage = false;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;

        vm.picker = {
            start: false,
            end: false
        };

        vm.objects = [];
        vm.currentState = "queues";
        vm.filter.objectId = "-1";
        vm.filter.status = "all";
        vm.filter.start = null;
        vm.filter.stop = null;
        vm.obj = null;

        var filter = localStorage.getItem(vm.currentState);
        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.filter.objectId = filter.objectId;
                vm.filter.status = filter.status;
                vm.filter.start = filter.start;
                vm.filter.stop = filter.stop;
            }
        }

        vm.repeatable = pagingParams.repeatable;
        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.objectPage = 0;

        function sort() {
            return ['lastModifiedDate,desc'];
        }

        vm.loadAll = function () {

            var dataNow = {
                type: "now",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemNowPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataNow, onSuccessNow, onErrorNow);

            function onSuccessNow(data, headers) {

                vm.now = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemNowTotalItems = headers('X-Total-Count');
                vm.systemNowQueryCount = vm.systemNowTotalItems;
                vm.systemNowPage = pagingParams.systemNowPage;

                for (var i = 0; i < data.length; i++) {
                    vm.now.push(data[i]);
                }
                if(vm.now.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemNowPage === 0 && vm.systemNowPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorNow(error) {
                AlertService.error(error.data.message);
            }

            var dataOnce = {
                type: "once",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemOncePage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataOnce, onSuccessOnce, onErrorOnce);

            function onSuccessOnce(data, headers) {

                vm.once = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemOnceTotalItems = headers('X-Total-Count');
                vm.systemOnceQueryCount = vm.systemOnceTotalItems;
                vm.systemOncePage = pagingParams.systemOncePage;

                for (var i = 0; i < data.length; i++) {
                    vm.once.push(data[i]);
                }
                if(vm.once.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemOncePage === 0 && vm.systemOncePage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnce(error) {
                AlertService.error(error.data.message);
            }

            var dataScheduled = {
                type: "scheduled",
                completed: false,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemScheduledPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataScheduled, onSuccessScheduled, onErrorOnceScheduled);

            function onSuccessScheduled(data, headers) {

                vm.scheduled = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemScheduledTotalItems = headers('X-Total-Count');
                vm.systemScheduledQueryCount = vm.systemScheduledTotalItems;
                vm.systemScheduledPage = pagingParams.systemScheduledPage;

                for (var i = 0; i < data.length; i++) {
                    vm.scheduled.push(data[i]);
                }
                if(vm.scheduled.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if (vm.systemScheduledPage === 0 && vm.systemScheduledPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnceScheduled(error) {
                AlertService.error(error.data.message);
            }

            var dataCompleted = {
                type: "completed",
                completed: true,
                page: vm.applyFilterPage ? vm.page : pagingParams.systemCompletedPage - 1,
                size: vm.systemItemLimit,
                sort: sort(),
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop,
                search: vm.charToSearch
            };

            Queue.query(dataCompleted, onSuccessCompleted, onErrorOnceCompleted);

            function onSuccessCompleted(data, headers) {

                vm.completed = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.systemCompletedTotalItems = headers('X-Total-Count');
                vm.systemCompletedQueryCount = vm.systemCompletedTotalItems;
                vm.systemCompletedPage = pagingParams.systemCompletedPage;

                for (var i = 0; i < data.length; i++) {
                    vm.completed.push(data[i]);
                }
                if ($state.params.filter) {
                    vm.searchText = $state.params.filter;
                }
                if(vm.completed.length > 0) {
                    vm.checkQueueEmpty = false;
                }
                if (vm.systemCompletedPage === 0 && vm.systemCompletedPage < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onErrorOnceCompleted(error) {
                AlertService.error(error.data.message);
            }

            vm.objects = [];
            vm.objectPage = 0;

            // Restore the selected object after loading objects
            var savedObjectId = vm.filter.objectId;
            vm.loadAllObject("", function() {
                if (savedObjectId && savedObjectId !== "-1") {
                    // Find the object in the loaded list
                    var selectedObj = vm.objects.find(function(obj) {
                        return obj.id == savedObjectId;
                    });
                    if (selectedObj) {
                        vm.obj = selectedObj;
                    }
                }
            });
        };

        vm.loadAllObject = function (stringToSearch, callback) {

            TabObjects.byQueue({
                page: vm.objectPage,
                size: 20,
                searchObj: stringToSearch
            }, onSuccessObject, onErrorObject);

            function onSuccessObject (data, headers){
                vm.objectLinks = ParseLinks.parse(headers('link'));
                vm.objectTotalItems = headers('X-Total-Count');

                if(vm.objectPage === 0){
                    var all = {
                        id: -1,
                        objectUniqueCode: "ALL",
                        objectName: "ALL"
                    };
                    vm.objects.push(all);
                }

                for (var i = 1; i < data.length+1; i++) {
                    if(vm.objects.indexOf(data[i-1]) === -1)
                        vm.objects.push(data[i-1]);
                }

                // Callback
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }

            function onErrorObject() {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        };

        vm.searchObj = function(stringToSearch, paste) {
            vm.objects = [];
            vm.objectPage = 0;
            if(paste) {
                var pasted = event.clipboardData.items[0];
                pasted.getAsString(function (data) {
                    vm.pstObj = data;
                    $scope.$apply();
                    vm.loadAllObject(vm.pstObj);
                });
            } else {
                vm.loadAllObject(stringToSearch);
            }
        };

        vm.loadPageObject = function (page) {
            if (page <= vm.objectLinks['last']) {
                vm.objectPage = page;
                vm.loadAllObject("");
            }
        };

        vm.selectObject = function (obj) {
            vm.filter.objectId = obj.id;
        };

        vm.applyFilter = function(){
            if(vm.filter.start < vm.filter.stop || vm.filter.start === vm.filter.stop){
                // Save the current object selection
                if (vm.obj && vm.obj.id) {
                    vm.filter.objectId = vm.obj.id;
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
                vm.page = 0;
                vm.applyFilterPage = true;
                vm.loadAll();
            } else {
                AlertService.error("Error validation date.");
            }
        };

        vm.clear = function(){
            vm.filter = {};
            vm.filter.objectId = "-1";
            vm.filter.status = "all";
            vm.filter.start = null;
            vm.filter.stop = null;
            vm.obj = null; // Clear the object selection
            localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
            vm.applyFilterPage = false;
            $state.go('queues', {}, { reload: true });
        };

        vm.findIndexDate = function (array){
            for(var i = 0; i < array.length; i++){
                if(array[i].executionDatetime !== null){
                    return i;
                }
            }
        };

        vm.forceCompletion = function (queue){
            $uibModal.open({
                templateUrl: 'app/entities/queue/queues-forced-dialog.html',
                controller: 'QueueForcedDialog',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Queue', function (Queue) {
                        return Queue.get({id: queue.id});
                    }]
                }
            }).result.then(function () {
                $state.go('queues', null, {reload: true});
            }, function () {
                $state.go('queues');
            });
        };

        vm.showCron = function(stopped){
            if(stopped)
                return "Start Execution";
            else return "Stop Execution";
        };

        vm.muteCron = function(scheduled){
            if(!scheduled.stopped){
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queues-stop-dialog.html',
                    controller: 'QueueStopDialog',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function (Queue) {
                            return Queue.get({id: scheduled.id});
                        }]
                    }
                }).result.then(function () {
                    $state.go('queues', null, {reload: true});
                }, function () {
                    $state.go('queues');
                });
            } else {
                Queue.stopCron({id: scheduled.id}, onSuccessFc, onErrorFc);

                function onSuccessFc(data) {
                    vm.loadAll();
                }

                function onErrorFc() {}
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.queue = [];
            var orderCall = vm.loadAll();
        };

        vm.loadAll();

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.systemNowPage = page;
            vm.systemOncePage = page;
            vm.systemScheduledPage = page;
            vm.systemCompletedPage = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                systemNowPage: vm.systemNowPage,
                systemOncePage: vm.systemOncePage,
                systemScheduledPage: vm.systemScheduledPage,
                systemCompletedPage: vm.systemCompletedPage,
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                status: vm.filter.status,
                objectId: vm.filter.objectId,
                startDate: vm.filter.start,
                stopDate: vm.filter.stop
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();


            //broke when you go to fast
            //for now, it shows the result then return without filter
            // try to put vm.loadPage instead of vm.transition


            // idea : cancel the search bar and try with the filter in the header if they have the same issue


        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Queue', Queue);

    Queue.$inject = ['$resource', 'DateUtils'];

    function Queue($resource, DateUtils) {
        var resourceUrl = 'api/queues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'forceComplet' : {
                url: 'api/queues/forceComplet',
                method: 'GET'
            },
            'stopCron' : {
                url: 'api/queues/stopCron',
                method: 'GET'
            },
            'create' : {method: 'PUT'},
            'checkExpired' : {method: 'GET'},
            'getByAlias' : {
                url: 'api/queues/alias',
                method: 'GET',
                isArray: true
            },
            'countByAlias' : {
                url: 'api/queues/countAlias',
                method: 'GET',
                isArray: true
            },
            'getGroups' : {
                url: 'api/queues/groupList',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('queues', {
                parent: 'management',
                url: '/queues?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.Queue.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    status: 'all',
                    objectId: '-1',
                    start: null,
                    stop: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    systemNowPage: {
                        value: '1',
                        squash: true
                    },
                    systemOncePage: {
                        value: '1',
                        squash: true
                    },
                    systemScheduledPage: {
                        value: '1',
                        squash: true
                    },
                    systemCompletedPage: {
                        value: '1',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/queue/queues.html',
                        controller: 'QueueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            systemNowPage: PaginationUtil.parsePage($stateParams.systemNowPage),
                            systemOncePage: PaginationUtil.parsePage($stateParams.systemOncePage),
                            systemScheduledPage: PaginationUtil.parsePage($stateParams.systemScheduledPage),
                            systemCompletedPage: PaginationUtil.parsePage($stateParams.systemCompletedPage),
                            repeatable: $stateParams.repeatable,
                            search: $stateParams.search,
                            status: $stateParams.status,
                            objectId: $stateParams.objectId,
                            start: $stateParams.start,
                            stop: $stateParams.stop
                        }
                    }]
                }
            })
            .state('queues-detail', {
                parent: 'queues',
                url: '/queues/{id}/queue-detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/queue/queues-detail.html',
                        controller: 'QueueDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Queue', function ($stateParams, Queue) {
                        return Queue.get({id: $stateParams.id});
                    }]
                }
            })
            .state('queues.delete', {
                parent: 'queues',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/queue/queues-delete-dialog.html',
                        controller: 'QueuesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Queue', function (Queue) {
                                return Queue.get({id: $stateParams.id});
                            }],
                        }
                    }).result.then(function () {
                        $state.go('queues', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });


    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDeleteController',ScriptsReleasesDeleteController);

    ScriptsReleasesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScriptsReleases'];

    function ScriptsReleasesDeleteController($uibModalInstance, entity, ScriptsReleases) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ScriptsReleases.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDetailController', ScriptsReleasesDetailController);

    ScriptsReleasesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function ScriptsReleasesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.scriptsReleases = entity;

        var unsubscribe = $rootScope.$on('jotApp:scriptsReleasesUpdate', function(event, result) {
            vm.scriptsReleases = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDialogController', ScriptsReleasesDialogController);

    ScriptsReleasesDialogController.$inject = ['$state','$timeout', '$scope', 'entity', 'ScriptsReleases', 'ScriptsTypes','ParseLinks','AlertService', 'DataUtils', '$window'];

    function ScriptsReleasesDialogController($state,$timeout, $scope, entity, ScriptsReleases, ScriptsTypes, ParseLinks, AlertService, DataUtils, $window) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.scriptsTypes = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:scriptsReleasesUpdate', result);
            vm.isSaving = false;
            $state.go('scripts-releases');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(!vm.fileContentRaw || vm.fileContentRaw == 0) {
                AlertService.error('Empty File');
                return;
            }
            if (vm.scriptsReleases.id !== null) {
                ScriptsReleases.update(vm.scriptsReleases, onSaveSuccess, onSaveError);
            } else {
                ScriptsReleases.save(vm.scriptsReleases, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('scripts-releases');
        };

        vm.loadAll = function () {

            ScriptsTypes.query({
                filter: 'tabdevicereleases-is-null',
                page: vm.page,
                size: 200
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsTypes.push(data[i]);
                }
                if(vm.scriptsReleases && vm.scriptsReleases.fileContent.length > 0) {
                    vm.fileContentRaw = $window.atob(vm.scriptsReleases.fileContent);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.setFileFromEditor = function () {
            vm.scriptsReleases.fileContent = $window.btoa(vm.fileContentRaw);
        };

        vm.byteSize = DataUtils.byteSize;

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesEnableController',ScriptsReleasesEnableController);

    ScriptsReleasesEnableController.$inject = ['$uibModalInstance', 'entity', 'ScriptsReleases'];

    function ScriptsReleasesEnableController($uibModalInstance, entity, ScriptsReleases) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.scriptsReleases.isActive = true;
            ScriptsReleases.update(vm.scriptsReleases,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesController', ScriptsReleasesController);

    ScriptsReleasesController.$inject = ['$state', 'ScriptsReleases', 'TabObjectTypes','ParseLinks', 'AlertService', 'pagingParams', 'ScriptsTypes'];

    function ScriptsReleasesController ($state, ScriptsReleases, TabObjectTypes, ParseLinks, AlertService, pagingParams, ScriptsTypes) {
        var vm = this;
        vm.scriptsReleases = [];
        vm.scriptsReleasesInactive = [];
        vm.predicates = {};
        vm.page = 0;
        vm.currentState = "tab-device-releases";
        vm.charToSearch = pagingParams.search;
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        vm.scriptTypes = {};
        vm.scriptTypes.id = pagingParams.scriptsTypes;
        vm.loadFilters = loadFilters;
        vm.loadFilters();

        function loadFilters() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            ScriptsTypes.query({
                page: 0,
                size: 1000
            }, onSuccessDevice, onError);

            function onSuccessDevice(data) {
                vm.scriptsTypes = data;
                vm.scriptsTypes.unshift({
                    id: -1,
                    scriptsTypeName: 'All'
                });
                vm.scriptsTypes.forEach(function (value) {
                    if (value.id == pagingParams.scriptsTypes) {
                        vm.scriptTypes = value;
                    }
                });
            }

            function onError() {
            }
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function(notify) {
            var page = {
                page: vm.page,
                size: 20,
                sort: sort()
            };
            var ch = {ch: vm.charToSearch, objectType: vm.objectType.id, scriptsTypes: vm.scriptTypes.id};

            ScriptsReleases.search(page, ch, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsReleases.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);
                // transition (notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function() {
            vm.page = 0;
            vm.scriptsReleases = [];
            vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

        vm.loadInactive = function(scriptsRelease) {
            ScriptsReleases.load({name: scriptsRelease.scriptsReleaseName, idShowed : scriptsRelease.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.scriptsReleasesInactive[scriptsRelease.scriptsReleaseName] = [];
                vm.scriptsReleasesInactive[scriptsRelease.scriptsReleaseName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                objectType: vm.objectType.id,
                scriptsTypes: vm.scriptsTypes.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.scriptsReleases = [];
            vm.page = 0;
            vm.loadAll();
            transition(false);
        };

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ScriptsReleases', ScriptsReleases);

    ScriptsReleases.$inject = ['$resource'];

    function ScriptsReleases ($resource) {
        var resourceUrl =  'api/scripts-releases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'load': {
                url:'api/scripts-releases/inactive',
                method: 'GET',
                isArray: true
            },
            'search': {
                url:'api/scripts-releases/search',
                method: 'POST',
                isArray: true
            },
            'filterType': {
                url:'api/scripts-releases/scripts-type/:scriptsTypeId',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scripts-releases', {
                parent: 'update_management',
                url: '/scripts-releases?sort&search&objectType',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases.html',
                        controller: 'ScriptsReleasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    scriptsTypes: {
                        value: '-1',
                        squash: true
                    },
                    predicates: {}
                }, resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectType: $stateParams.objectType,
                            scriptsTypes: $stateParams.scriptsTypes
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scripts-releases-detail', {
                parent: 'scripts-releases',
                url: '/scripts-releases/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-detail.html',
                        controller: 'ScriptsReleasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScriptsReleases', function ($stateParams, ScriptsReleases) {
                        return ScriptsReleases.get({id: $stateParams.id});
                    }]
                }
            })
            .state('scripts-releases-new', {
                parent: 'scripts-releases',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-dialog.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }], entity: function () {
                        return {
                            scriptsReleaseName: null,
                            scriptsReleaseDescription: null,
                            isActive: false,
                            scriptsReleaseVersion: null,
                            id: null
                        };
                    }
                }
            })
            .state('scripts-releases-edit', {
                parent: 'scripts-releases',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-dialog.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'ScriptsReleases', function ($stateParams, ScriptsReleases) {
                        return ScriptsReleases.get({id: $stateParams.id});

                    }]
                }
            })
            .state('scripts-releases-upgrade', {
                parent: 'scripts-releases',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.scriptsReleases.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-upgrade.html',
                        controller: 'ScriptsReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scriptsReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScriptsReleases', '$q', function ($stateParams, ScriptsReleases, $q) {
                        var scriptsRelease = $q.defer();
                        ScriptsReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            scriptsRelease.resolve(data);
                        });
                        return scriptsRelease.promise;
                    }]
                }
            })
            .state('scripts-releases.delete', {
                parent: 'scripts-releases',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-delete-dialog.html',
                        controller: 'ScriptsReleasesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScriptsReleases', function (ScriptsReleases) {
                                return ScriptsReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('scripts-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('scripts-releases.enable', {
                parent: 'scripts-releases',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scripts-releases/scripts-releases-enable-dialog.html',
                        controller: 'ScriptsReleasesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScriptsReleases', function (ScriptsReleases) {
                                return ScriptsReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('scripts-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDeleteController',ScriptsTypesDeleteController);

    ScriptsTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScriptsTypes'];

    function ScriptsTypesDeleteController($uibModalInstance, entity, ScriptsTypes) {
        var vm = this;
        vm.scriptsTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ScriptsTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDetailController', ScriptsTypesDetailController);

    ScriptsTypesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function ScriptsTypesDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.scriptsTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:scriptsTypesUpdate', function(event, result) {
            vm.scriptsTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDialogController', ScriptsTypesDialogController);

    ScriptsTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ScriptsTypes', '$state'];

    function ScriptsTypesDialogController ($timeout, $scope, $stateParams, entity, ScriptsTypes, $state) {
        var vm = this;
        vm.scriptsTypes = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:scriptsTypesUpdate', result);
            vm.isSaving = false;
            $state.go('scripts-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.scriptsTypes.id !== null) {
                ScriptsTypes.update(vm.scriptsTypes, onSaveSuccess, onSaveError);
            } else {
                ScriptsTypes.save(vm.scriptsTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('scripts-types');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesController', ScriptsTypesController);

    ScriptsTypesController.$inject = ['$scope', '$state', 'ScriptsTypes', 'ParseLinks', 'AlertService'];

    function ScriptsTypesController ($scope, $state, ScriptsTypes, ParseLinks, AlertService) {
        var vm = this;
        vm.scriptsTypes = [];
        vm.predicates = {};
        vm.page = 0;
        vm.currentState = "scripts-type";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {
            ScriptsTypes.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsTypes.push(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.scriptsTypes = [];
            var orderCall = vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ScriptsTypes', ScriptsTypes);

    ScriptsTypes.$inject = ['$resource'];

    function ScriptsTypes ($resource) {
        var resourceUrl =  'api/scripts-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('scripts-types', {
            parent: 'entity',
            url: '/scripts-types',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types.html',
                    controller: 'ScriptsTypesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('scripts-types-detail', {
            parent: 'scripts-types',
            url: '/scripts-types/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-detail.html',
                    controller: 'ScriptsTypesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ScriptsTypes', function($stateParams, ScriptsTypes) {
                    return ScriptsTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('scripts-types-new', {
            parent: 'scripts-types',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-dialog.html',
                    controller: 'ScriptsTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceTypeName: null,
                        deviceTypeDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('scripts-types-edit', {
            parent: 'scripts-types',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-dialog.html',
                    controller: 'ScriptsTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ScriptsTypes', function($stateParams, ScriptsTypes) {
                    return ScriptsTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('scripts-types.delete', {
            parent: 'scripts-types',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scripts-types/scripts-types-delete-dialog.html',
                    controller: 'ScriptsTypesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ScriptsTypes', function(ScriptsTypes) {
                            return ScriptsTypes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('scripts-types', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueDeleteController',TabActionsQueueDeleteController);

    TabActionsQueueDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabActionsQueue'];

    function TabActionsQueueDeleteController($uibModalInstance, entity, TabActionsQueue) {
        var vm = this;
        vm.tabActionsQueue = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabActionsQueue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueDetailController', TabActionsQueueDetailController);

    TabActionsQueueDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function TabActionsQueueDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.group = $stateParams.group;
        vm.tabActionsQueue = entity;
        var unsubscribe = $rootScope.$on('jotApp:tabActionsQueueUpdate', function(event, result) {
            vm.tabActionsQueue = result;

        });
        $scope.$on('$destroy', unsubscribe);



    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueController', TabActionsQueueController);

    TabActionsQueueController.$inject = ['$stateParams', '$state', 'TabActionsQueue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', '$rootScope'];

    function TabActionsQueueController($stateParams, $state, TabActionsQueue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, $rootScope) {
        var vm = this;
        vm.tabActionsQueues = [];
        //vm.predicates = {'insertDateTime': false};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.charToSearch = pagingParams.search;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.tabActionQueueGroups = [];
        vm.repeatable = pagingParams.repeatable;
        vm.currentState = "tab-action-queue";
        vm.licence = $rootScope.licence;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {

            var data = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                repeatable: vm.repeatable,
                query: vm.charToSearch,
                sort: sort()
            };

            TabActionsQueue.query(data, onSuccess, onError);

            function onSuccess(data, headers) {

                vm.tabActionsQueues = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;

                if(data.length > 0) {
                    if (vm.tabActionQueueGroups.length === 0) {
                        TabActionsQueue.getGroups({}, succ, err);
                    }
                    if ($stateParams.group !== null) {
                        vm.obj = $stateParams.group;
                        vm.selectObject($stateParams.group);
                    } else {
                        for (var i = 0; i < data.length; i++) {
                            vm.tabActionsQueues.push(data[i]);
                        }
                        if ($state.params.filter) {
                            vm.searchText = $state.params.filter;
                        }
                        if (vm.page === 0 && vm.page < vm.links['last']) {
                            vm.loadPage();
                        }
                    }
                }
                function succ(data, headers) {
                    vm.tabActionQueueGroups = data;
                    vm.tabActionQueueGroups.push("All");
                }
                function err(error) {
                    AlertService.error(error.data.message);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            data.query = vm.charToSearch;
        };
        vm.reset = function () {
            vm.page = 0;
            vm.tabActionsQueues = [];
            var orderCall = vm.loadAll();
        };

        vm.loadAll();

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

        vm.retry = function (tabActionsQueue) {
            TabActionsQueueRetry.update({}, tabActionsQueue, onSuccess, onError);

            function onSuccess(data, headers) {
                tabActionsQueue = data;
                var i = vm.tabActionsQueues.findIndex(function (el) {
                    return el.id === tabActionsQueue.id;
                });
                if (i !== -1) {
                    vm.tabActionsQueues[i] = tabActionsQueue;
                }

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.selectObject = function (obj) {
            vm.tabActionsQueues = [];
            if (obj === "All" || obj === null || obj === undefined) {
                $stateParams.group = null;
                vm.reset();
            } else {
                TabActionsQueue.getByAlias({group: obj,  repeatable: vm.repeatable, sort: sort()}, onSuccess, onError);
            }


            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    vm.tabActionsQueues.push(data[i]);
                }
                    $stateParams.group = obj;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabActionsQueue', TabActionsQueue)
        .factory('TabActionsQueueRetry', TabActionsQueueRetry);

    TabActionsQueue.$inject = ['$resource', 'DateUtils'];

    function TabActionsQueue($resource, DateUtils) {
        var resourceUrl = 'api/tab-actions-queues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.insertDateTime = DateUtils.convertDateTimeFromServer(data.insertDateTime);
                    data.executionDateTime = DateUtils.convertDateTimeFromServer(data.executionDateTime);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'checkExpired' : {method: 'GET'},
            'getByAlias' : {
                url: 'api/tab-actions-queues/alias',
                method: 'GET',
                isArray: true
            },
            'getGroups' : {
                url: 'api/tab-actions-queues/groupList',
                method: 'GET',
                isArray: true
            }
        });
    }

    function TabActionsQueueRetry($resource, DateUtils) {
        var resourceUrl = 'api/tab-actions-queues/retry:id';

        return $resource(resourceUrl, {}, {
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-actions-queue', {
                parent: 'management',
                url: '/tab-actions-queue?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabActionsQueue.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queues.html',
                        controller: 'TabActionsQueueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            repeatable: $stateParams.repeatable,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        }
                    }]
                }
            })
            .state('tab-actions-queue-detail', {
                parent: 'tab-actions-queue',
                url: '/tab-actions-queue/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabActionsQueue.detail.title'
                },
                params: {
                    filter: null,
                    group : null
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queue-detail.html',
                        controller: 'TabActionsQueueDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabActionsQueue', function ($stateParams, TabActionsQueue) {
                        return TabActionsQueue.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-actions-queue.delete', {
                parent: 'tab-actions-queue',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-actions-queue/tab-actions-queue-delete-dialog.html',
                        controller: 'TabActionsQueueDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabActionsQueue', function (TabActionsQueue) {
                                return TabActionsQueue.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-actions-queue', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });


    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsDeleteController',TabActionsDeleteController);

    TabActionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabActions'];

    function TabActionsDeleteController($uibModalInstance, entity, TabActions) {
        var vm = this;
        vm.tabActions = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabActions.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsDetailController', TabActionsDetailController);

    TabActionsDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabActionsDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabActions = entity;

        vm.tabActions.$promise.then(function () {
            vm.arguments = JSON.parse(vm.tabActions.argumentsSchema);
            if(vm.arguments)
                vm.arguments = vm.arguments.properties;
        });

        var unsubscribe = $rootScope.$on('jotApp:tabActionsUpdate', function(event, result) {
            vm.tabActions = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function(){
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsController', TabActionsController);

    TabActionsController.$inject = ['pagingParams', '$state', 'TabActions', 'ParseLinks', 'AlertService'];

    function TabActionsController (pagingParams, $state, TabActions, ParseLinks, AlertService) {
        var vm = this;
        vm.tabActions = [];
        vm.predicates = {};
        vm.page = 0;
        vm.charToSearch = pagingParams.search;
        vm.currentState = "tab-actions";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {

            var page = {
                page: vm.page,
                size: 20,
                sort: sort()
            };
            var ch = {ch: vm.charToSearch};
            TabActions.search(page,ch, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabActions.push(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);

                transition ();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch
            }, {notify: false, location: "replace"});
        }

        vm.search = function () {
            vm.tabActions = [];
            vm.page = 0;
            vm.loadAll();
        };

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabActions', TabActions);

    TabActions.$inject = ['$resource'];

    function TabActions($resource) {
        var resourceUrl = 'api/tab-actions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'search': {url: 'api/tab-actions/search', method: 'POST', isArray: true},
            'command': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/object/:id'
            },
            'allCommand': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/type/:typeId/fleet/:fleetId'
            },
            'allDownload': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/type/fleet'
            },
            'download': {
                method: 'GET',
                url: 'api/tab-actions/type/:typeId/fleet/:fleetId/download'
            },
            'multiple': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/multiple'
            },
            'commandsByObjects': {
                method: 'POST',
                isArray: true,
                url: 'api/tab-actions/commands-by-objects'
            },
            'actionsByObjectType': {
                method: 'GET',
                isArray: true,
                url: 'api/tab-actions/objectType/:id'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-actions', {
            parent: 'management',
            url: '/tab-actions?sort&search',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabActions.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-actions/tab-actions.html',
                    controller: 'TabActionsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: [],
                    squash: true
                },
                search: {
                    value: '',
                    squash: true
                },
                predicates : {}
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabActions');
                    $translatePartialLoader.addPart('tabDeviceReleases');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-actions-detail', {
            parent: 'tab-actions',
            url: '/tab-actions/{id}',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabActions.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-actions/tab-actions-detail.html',
                    controller: 'TabActionsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabActions');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabActions', function($stateParams, TabActions) {
                    return TabActions.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-actions.delete', {
            parent: 'tab-actions',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-actions/tab-actions-delete-dialog.html',
                    controller: 'TabActionsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabActions', function(TabActions) {
                            return TabActions.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-actions', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDeleteController',TabDeviceReleasesDeleteController);

    TabDeviceReleasesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDeviceReleases'];

    function TabDeviceReleasesDeleteController($uibModalInstance, entity, TabDeviceReleases) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDeviceReleases.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDetailController', TabDeviceReleasesDetailController);

    TabDeviceReleasesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabDeviceReleasesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabDeviceReleases = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDeviceReleasesUpdate', function(event, result) {
            vm.tabDeviceReleases = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDialogController', TabDeviceReleasesDialogController);

    TabDeviceReleasesDialogController.$inject = ['$state','$timeout', '$scope', 'entity', 'TabDeviceReleases', 'TabDevices','ParseLinks','AlertService'];

    function TabDeviceReleasesDialogController($state,$timeout, $scope, entity, TabDeviceReleases, TabDevices,ParseLinks,AlertService) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.devices = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDeviceReleasesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-device-releases');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDeviceReleases.id !== null) {
                TabDeviceReleases.update(vm.tabDeviceReleases, onSaveSuccess, onSaveError);
            } else {
                TabDeviceReleases.save(vm.tabDeviceReleases, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-device-releases');
        };

        vm.loadAll = function () {

            TabDevices.query({
                filter: 'tabdevicereleases-is-null',
                page: vm.page,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.devices.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesEnableController',TabDeviceReleasesEnableController);

    TabDeviceReleasesEnableController.$inject = ['$uibModalInstance', 'entity', 'TabDeviceReleases'];

    function TabDeviceReleasesEnableController($uibModalInstance, entity, TabDeviceReleases) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabDeviceReleases.isActive = true;
            TabDeviceReleases.update(vm.tabDeviceReleases,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesController', TabDeviceReleasesController);

    TabDeviceReleasesController.$inject = ['$state', 'TabDeviceReleases', 'TabObjectTypes','ParseLinks', 'AlertService', 'pagingParams', 'TabDevices', 'paginationConstants'];

    function TabDeviceReleasesController ($state, TabDeviceReleases, TabObjectTypes, ParseLinks, AlertService, pagingParams, TabDevices, paginationConstants) {
        var vm = this;
        vm.tabDeviceReleases = [];
        vm.tabDeviceReleasesInactive = [];
        vm.predicates = pagingParams.predicates;
        //vm.page = 0;
        vm.loadPage = loadPage;
        vm.currentState = "tab-device-releases";
        vm.charToSearch = pagingParams.search;
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        vm.device = {};
        vm.device.id = pagingParams.device;
        vm.loadFilters = loadFilters;
        vm.loadFilters();
        vm.transition = transition;
        vm.selectFilter = false;

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;     //Pagination da aggiungere sopra ['']
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function loadFilters() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            TabDevices.query({
                page: 0,
                size: 1000
            }, onSuccessDevice, onError);

            function onSuccessDevice(data) {
                vm.devices = data;
                vm.devices.unshift({
                    id: -1,
                    deviceName: 'All'
                });
                vm.devices.forEach(function (value) {
                    if (value.id == pagingParams.device) {
                        vm.device = value;
                    }
                });
            }

            function onError() {
            }
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function(notify) {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            var ch = {ch: vm.charToSearch, objectType: vm.objectType.id, device: vm.device.id};

            if(vm.selectFilter && vm.objectType.id != -1){
                TabDeviceReleases.search(page, ch, onSuccess, onError);
            } else {
                if(vm.device.id == -1){
                    TabDeviceReleases.getPage(page, ch, onSuccess, onError);
                } else {
                    TabDeviceReleases.filterTypePage({id: vm.device.id, query: vm.charToSearch}, onSuccess, onError);
                }
            }

            function onSuccess(data, headers) {
                vm.selectFilter = false;
                vm.tabDeviceReleases = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabDeviceReleases.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage();
                // transition (notify);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function() {
            vm.page = 0;
            vm.tabDeviceReleases = [];
            vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        vm.loadAll();

        vm.loadInactive = function(tabDevice) {
            TabDeviceReleases.load({name: tabDevice.deviceReleaseName, idShowed : tabDevice.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabDeviceReleasesInactive[tabDevice.deviceReleaseName] = [];
                vm.tabDeviceReleasesInactive[tabDevice.deviceReleaseName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.charToSearch,
                objectType: vm.objectType.id,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                device: vm.device.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            vm.tabDeviceReleases = [];
            pagingParams.page = 1;
            vm.selectFilter = true;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDeviceReleases', TabDeviceReleases);

    TabDeviceReleases.$inject = ['$resource'];

    function TabDeviceReleases ($resource) {
        var resourceUrl =  'api/tab-device-releases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPage': {
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' },
            'load': {
                url:'api/tab-device-releases/inactive',
                method: 'GET',
                isArray: true
            },
            'search': {
                url:'api/tab-device-releases/search',
                method: 'POST',
                isArray: true
            },
            'filterType': {
                url:'api/tab-device-releases/tab-devices/:deviceId',
                method: 'GET',
                isArray: true
            },
            'filterTypePage': {
                url:'api/tab-device-releases/tab-devices-page/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-device-releases', {
                parent: 'update_management',
                url: '/tab-device-releases?sort&search&objectType',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases.html',
                        controller: 'TabDeviceReleasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    device: {
                        value: '-1',
                        squash: true
                    },
                    predicates: {}
                }, resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectType: $stateParams.objectType,
                            device: $stateParams.device
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-device-releases-detail', {
                parent: 'tab-device-releases',
                url: '/tab-device-releases/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-detail.html',
                        controller: 'TabDeviceReleasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDeviceReleases', function ($stateParams, TabDeviceReleases) {
                        return TabDeviceReleases.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-device-releases-new', {
                parent: 'tab-device-releases',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-dialog.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }], entity: function () {
                        return {
                            deviceReleaseName: null,
                            deviceReleaseDescription: null,
                            isActive: false,
                            deviceReleaseVersion: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-device-releases-edit', {
                parent: 'tab-device-releases',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-dialog.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'TabDeviceReleases', function ($stateParams, TabDeviceReleases) {
                        return TabDeviceReleases.get({id: $stateParams.id});

                    }]
                }
            })
            .state('tab-device-releases-upgrade', {
                parent: 'tab-device-releases',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-upgrade.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDeviceReleases', '$q', function ($stateParams, TabDeviceReleases, $q) {
                        var deviceRelease = $q.defer();
                        TabDeviceReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            deviceRelease.resolve(data);
                        });
                        return deviceRelease.promise;
                    }]
                }
            })
            .state('tab-device-releases.delete', {
                parent: 'tab-device-releases',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-delete-dialog.html',
                        controller: 'TabDeviceReleasesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDeviceReleases', function (TabDeviceReleases) {
                                return TabDeviceReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-device-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-device-releases.enable', {
                parent: 'tab-device-releases',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-enable-dialog.html',
                        controller: 'TabDeviceReleasesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDeviceReleases', function (TabDeviceReleases) {
                                return TabDeviceReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-device-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDeleteController',TabDevicesTypesDeleteController);

    TabDevicesTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDevicesTypes'];

    function TabDevicesTypesDeleteController($uibModalInstance, entity, TabDevicesTypes) {
        var vm = this;
        vm.tabDevicesTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDevicesTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDetailController', TabDevicesTypesDetailController);

    TabDevicesTypesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabDevicesTypes', 'TabDevices'];

    function TabDevicesTypesDetailController($scope, $rootScope, $stateParams, entity, TabDevicesTypes, TabDevices) {
        var vm = this;
        vm.tabDevicesTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDevicesTypesUpdate', function(event, result) {
            vm.tabDevicesTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDialogController', TabDevicesTypesDialogController);

    TabDevicesTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabDevicesTypes', 'TabDevices', '$state'];

    function TabDevicesTypesDialogController ($timeout, $scope, $stateParams, entity, TabDevicesTypes, TabDevices, $state) {
        var vm = this;
        vm.tabDevicesTypes = entity;
        vm.tabdevices = TabDevices.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDevicesTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-devices-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDevicesTypes.id !== null) {
                TabDevicesTypes.update(vm.tabDevicesTypes, onSaveSuccess, onSaveError);
            } else {
                TabDevicesTypes.save(vm.tabDevicesTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-devices-types');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesController', TabDevicesTypesController);

    TabDevicesTypesController.$inject = ['$scope', '$state', 'TabDevicesTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabDevicesTypesController ($scope, $state, TabDevicesTypes, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabDevicesTypes = [];
        //vm.predicates = {};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.currentState = "tab-devices-type";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {

            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
            }

            TabDevicesTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabDevicesTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabDevicesTypes.push(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.tabDevicesTypes = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDevicesTypes', TabDevicesTypes);

    TabDevicesTypes.$inject = ['$resource'];

    function TabDevicesTypes ($resource) {
        var resourceUrl =  'api/tab-devices-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-devices-types', {
            parent: 'entity',
            url: '/tab-devices-types',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types.html',
                    controller: 'TabDevicesTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                sort: {
                    value: [],
                    squash: true
                },
                predicates: {},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates: $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-devices-types-detail', {
            parent: 'tab-devices-types',
            url: '/tab-devices-types/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-detail.html',
                    controller: 'TabDevicesTypesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevicesTypes', function($stateParams, TabDevicesTypes) {
                    return TabDevicesTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-types-new', {
            parent: 'tab-devices-types',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-dialog.html',
                    controller: 'TabDevicesTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceTypeName: null,
                        deviceTypeDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('tab-devices-types-edit', {
            parent: 'tab-devices-types',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevicesTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-dialog.html',
                    controller: 'TabDevicesTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevicesTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevicesTypes', function($stateParams, TabDevicesTypes) {
                    return TabDevicesTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-types.delete', {
            parent: 'tab-devices-types',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-devices-types/tab-devices-types-delete-dialog.html',
                    controller: 'TabDevicesTypesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabDevicesTypes', function(TabDevicesTypes) {
                            return TabDevicesTypes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-devices-types', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDeleteController',TabDevicesDeleteController);

    TabDevicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDevices'];

    function TabDevicesDeleteController($uibModalInstance, entity, TabDevices) {
        var vm = this;
        vm.tabDevices = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDevices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDetailController', TabDevicesDetailController);

    TabDevicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabDevices', 'TabDevicesTypes', 'TabObjectTypes', 'TabSchedule'];

    function TabDevicesDetailController($scope, $rootScope, $stateParams, entity, TabDevices, TabDevicesTypes, TabObjectTypes, TabSchedule) {
        var vm = this;
        vm.tabDevices = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDevicesUpdate', function(event, result) {
            vm.tabDevices = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDialogController', TabDevicesDialogController);

    TabDevicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabDevices', 'TabDevicesTypes', 'TabObjectTypes', 'TabSchedule', '$state'];

    function TabDevicesDialogController ($timeout, $scope, $stateParams, entity, TabDevices, TabDevicesTypes, TabObjectTypes, TabSchedule, $state) {
        var vm = this;
        vm.tabDevices = entity;
        vm.tabdevicestypes = TabDevicesTypes.query({size: 1000});
        vm.tabobjecttypes = TabObjectTypes.query();
        vm.tabschedules = TabSchedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDevicesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-devices');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDevices.id !== null) {
                TabDevices.update(vm.tabDevices, onSaveSuccess, onSaveError);
            } else {
                TabDevices.save(vm.tabDevices, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-devices');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesController', TabDevicesController);

    TabDevicesController.$inject = ['$state', 'TabDevices', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabDevicesController ($state, TabDevices, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-devices";
        vm.currentStateFilter = "tab-devices-filter";
        vm.applyFilter = applyFilter;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        vm.deviceType = pagingParams.deviceType;
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.deviceType = filter.deviceType;
            }
        }

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.searchText = pagingParams.search;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            // vm.transition(false);
        };

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                query: vm.searchText,
                sort: sort()
            };
            addFilter(body);
            TabDevices.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabDevices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter,
                search: vm.searchText
            }, {notify: notify, location: "replace"});
        }

        function applyFilter(deviceType) {
            var filter={};
            filter.deviceType = vm.deviceType = deviceType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.deviceType.id !== -1)
                body.deviceTypeId = vm.deviceType.id;
        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDevices', TabDevices);

    TabDevices.$inject = ['$resource'];

    function TabDevices ($resource) {
        var resourceUrl =  'api/tab-devices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-devices', {
            parent: 'entity',
            url: '/tab-devices?page&sort&search',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices.html',
                    controller: 'TabDevicesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: {
                    value: '',
                    squash: true
                },
                itemsPerPageChosen: null,
                predicates : {},
                deviceType: {
                    value: '-1'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        deviceType: $stateParams.deviceType
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-devices-detail', {
            parent: 'tab-devices',
            url: '/tab-devices/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-detail.html',
                    controller: 'TabDevicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevices', function($stateParams, TabDevices) {
                    return TabDevices.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-new', {
            parent: 'tab-devices',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-dialog.html',
                    controller: 'TabDevicesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceName: null,
                        deviceDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('tab-devices-edit', {
            parent: 'tab-devices',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-dialog.html',
                    controller: 'TabDevicesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevices', function($stateParams, TabDevices) {
                    return TabDevices.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices.delete', {
            parent: 'tab-devices',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-devices/tab-devices-delete-dialog.html',
                    controller: 'TabDevicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabDevices', function(TabDevices) {
                            return TabDevices.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-devices', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDeleteController',TabDomainsDeleteController);

    TabDomainsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDomains'];

    function TabDomainsDeleteController($uibModalInstance, entity, TabDomains) {
        var vm = this;
        vm.tabDomains = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDomains.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDetailController', TabDomainsDetailController);

    TabDomainsDetailController.$inject = ['$scope', '$rootScope', 'entity', 'DataUtils'];

    function TabDomainsDetailController($scope, $rootScope, entity, DataUtils) {
        var vm = this;
        vm.tabDomains = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDomainsUpdate', function (event, result) {
            vm.tabDomains = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDialogController', TabDomainsDialogController);

    TabDomainsDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabDomains', 'User', 'DataUtils', 'Licences'];

    function TabDomainsDialogController($state, $timeout, $scope, entity, TabDomains, User, DataUtils, Licences) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabDomains = entity;
                if (vm.tabDomains.licenseExpirationDate != null) {
                    vm.tabDomains.licenseExpirationDate = new Date(vm.tabDomains.licenseExpirationDate);
                }
            });
        }
        vm.users = User.list({size: 1000});
        vm.licences = Licences.query();
        vm.datepickerOptions = {
            minDate: new Date()
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }

        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDomainsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-domains');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDomains.id !== null) {
                TabDomains.update(vm.tabDomains, onSaveSuccess, onSaveError);
            } else {
                TabDomains.save(vm.tabDomains, onSaveSuccess, onSaveError);
            }
        };

        vm.setDomainCertificate = function ($file, tabDomains, col) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabDomains[col] = base64Data;

                    });
                });
            }
        };

        vm.clear = function () {
            $state.go('tab-domains');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsController', TabDomainsController);

    TabDomainsController.$inject = ['$state', 'TabDomains', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DataUtils'];

    function TabDomainsController($state, TabDomains, ParseLinks, AlertService, pagingParams, paginationConstants, DataUtils) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.setActive = setActive;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-domains";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.searchText = pagingParams.search;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            TabDomains.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.searchText,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabDomains = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.searchText,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        function setActive(domains, isActivated) {
            domains.isActive = isActivated;
            TabDomains.update(domains, function () {
                vm.loadAll();
                vm.clear();
            });

        }

        function clear() {
            vm.domains = {
                domainName: null,
                domainDescription: null,
                domainCaCrt: null,
                domainClientCrt: null,
                domainClientKey: null,
                isActive: false,
                isVisibile: false,
                id: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        vm.loadAll();

        vm.checkLastLog = function (timestamp) {
            var date = new Date();
            var log = new Date(timestamp);
            return log.setDate(log.getDate() + 30) > date;
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
        };
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabDomains', TabDomains);

    TabDomains.$inject = ['$resource'];

    function TabDomains($resource) {
        var resourceUrl = 'api/tab-domains/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'list': {
                url:'api/tab-domains/list',
                method: 'GET',
                isArray: true},
            'listByUser': {
                url:'api/tab-domains/list-by-user',
                method: 'GET',
                isArray: true},
            'update': {method: 'PUT'},
            'requestToUpdateSettings': {
                url: 'api/tab-domains/update-settings',
                method: 'POST'
            },
            'byFleet': {
                url: 'api/tab-domains/fleets/:id',
                method: 'GET'
            },
            'byUser': {
                url: 'api/tab-domains/fleets',
                method: 'GET',
                isArray: true
            },
            'byUserLogin': {
                url: 'api/tab-domains/user/:login',
                method: 'GET',
                isArray: true
            },
            'myDomains': {
                url: 'api/my-domains',
                method: 'GET',
                isArray: true
            },
            'current' : {
                url: 'api/tab-domains/current-domain',
                method: 'GET'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-domains', {
                parent: 'entity',
                url: '/tab-domains?page&sort&search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains.html',
                        controller: 'TabDomainsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    predicates: {},
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-domains-detail', {
                parent: 'tab-domains',
                url: '/tab-domains/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-detail.html',
                        controller: 'TabDomainsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDomains', function ($stateParams, TabDomains) {
                        return TabDomains.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-domains-new', {
                parent: 'tab-domains',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-dialog.html',
                        controller: 'TabDomainsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            domainName: null,
                            domainDescription: null,
                            domainCaCrt: null,
                            domainClientCrt: null,
                            domainClientKey: null,
                            isActive: false,
                            isVisibile: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-domains-edit', {
                parent: 'tab-domains',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-dialog.html',
                        controller: 'TabDomainsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDomains', function ($stateParams, TabDomains) {
                        return TabDomains.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-domains.delete', {
                parent: 'tab-domains',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-domains/tab-domains-delete-dialog.html',
                        controller: 'TabDomainsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDomains', function (TabDomains) {
                                return TabDomains.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-domains', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesDeleteController',TabFileTypesDeleteController);

    TabFileTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFileTypes'];

    function TabFileTypesDeleteController($uibModalInstance, entity, TabFileTypes) {
        var vm = this;
        vm.tabFileTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFileTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesDialogController', TabFileTypesDialogController);

    TabFileTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabFileTypes', '$state'];

    function TabFileTypesDialogController ($timeout, $scope, $stateParams, entity, TabFileTypes, $state) {
        var vm = this;
        vm.tabFileTypes = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFileTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-file-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFileTypes.id !== null) {
                TabFileTypes.update(vm.tabFileTypes, onSaveSuccess, onSaveError);
            } else {
                TabFileTypes.save(vm.tabFileTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-file-types');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesController', TabFileTypesController);

    TabFileTypesController.$inject = ['$scope', '$state', 'TabFileTypes', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFileTypesController($scope, $state, TabFileTypes, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        //vm.predicates = {};
        vm.tabFileTypes = [];
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.currentState = "tab-file-types";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }


        vm.loadAll = function () {
            // new variable search, which have the filtering string
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                sort: sort()
            };

            TabFileTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFileTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabFileTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function () {
            vm.page = 0;
            vm.tabFileTypes = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        // added the function search , to reload the page after a filter has been detected (string in the search bar)
        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };


        vm.loadAll();

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabFileTypes', TabFileTypes);

    TabFileTypes.$inject = ['$resource'];

    function TabFileTypes ($resource) {
        var resourceUrl =  'api/tab-file-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-file-types', {
            parent: 'entity',
            url: '/tab-file-types',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.tabFileTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-file-types/tab-file-types.html',
                    controller: 'TabFileTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                itemsPerPageChosen: null,
                sort: {
                    value: [],
                    squash: true
                },
                predicates: {},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates: $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabFileTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-file-types-new', {
            parent: 'tab-file-types',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.tabFileTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-file-types/tab-file-types-dialog.html',
                    controller: 'TabFileTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabFileTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        id: null
                    };
                }
            }
        })
            .state('tab-file-types-edit', {
                parent: 'tab-file-types',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFileTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-file-types/tab-file-types-dialog.html',
                        controller: 'TabFileTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFileTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFileTypes', function($stateParams, TabFileTypes) {
                        return TabFileTypes.get({id : $stateParams.id});
                    }]
                }
            })
            .state('tab-file-types.delete', {
                parent: 'tab-file-types',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-file-types/tab-file-types-delete-dialog.html',
                        controller: 'TabFileTypesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFileTypes', function(TabFileTypes) {
                                return TabFileTypes.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('tab-file-types', null, { reload: true });
                    }, function() {
                        $state.go('tab-file-types');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDeleteController', TabFilesDeleteController);

    TabFilesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFiles'];

    function TabFilesDeleteController($uibModalInstance, entity, TabFiles) {
        var vm = this;
        vm.tabFiles = entity;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFiles.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDetailController', TabFilesDetailController);

    TabFilesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabFiles', 'DataUtils'];

    function TabFilesDetailController($scope, $rootScope, $stateParams, entity, TabFiles, DataUtils) {
        var vm = this;
        vm.tabFiles = entity;
        vm.openFile = false;
        vm.fileContent = '';
        vm.tabFiles.$promise.then(function(test){
            vm.fileContent = window.atob(vm.tabFiles.fileContent);
        });



        var unsubscribe = $rootScope.$on('jotApp:tabFilesUpdate', function (event, result) {
            vm.tabFiles = result;
        });
        $scope.$on('$destroy', unsubscribe);
        vm.byteSize = DataUtils.byteSize;
        //vm.openFile = DataUtils.openFile;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDialogController', TabFilesDialogController);

    TabFilesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabFiles', 'DataUtils', 'TabFileTypes', '$state', '$window'];

    function TabFilesDialogController($timeout, $scope, $stateParams, $q, entity, TabFiles, DataUtils, TabFileTypes, $state, $window) {
        var vm = this;

        // vm.tabFiles = entity;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabFiles = entity;
                if(vm.tabFiles.id !== null){
                    getPermsFromString(vm.tabFiles.perms);
                }
            });
        }
        vm.tabfiletypes = TabFileTypes.query({size: 1000});
        vm.showInlineEditor = false;
        vm.isCustomPermission = false;
        vm.permissions = {};

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFilesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-files');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

            var permsString = getPerms();
            if (permsString === "---------" || permsString === "")
                permsString = null;

            vm.tabFiles.permissions = vm.permissions.permission;
            vm.tabFiles.categories = vm.permissions.category;
            vm.tabFiles.perms = permsString;
            if(vm.tabFiles.isActive == null){
                vm.tabFiles.isActive = false;
            }

            if (vm.tabFiles.id !== null) {
                TabFiles.update(vm.tabFiles, onSaveSuccess, onSaveError);
            } else {
                TabFiles.save(vm.tabFiles, onSaveSuccess, onSaveError);
            }
        };

        vm.clearPermission = function() {
            if(vm.permissions.permission === "-1"){
                if(vm.permissions.user !== undefined) {
                    vm.permissions.user.permis.r = false;
                    vm.permissions.user.permis.w = false;
                    vm.permissions.user.permis.x = false;
                }
                if(vm.permissions.group !== undefined) {
                    vm.permissions.group.permis.r = false;
                    vm.permissions.group.permis.w = false;
                    vm.permissions.group.permis.x = false;
                }
                if(vm.permissions.other !== undefined) {
                    vm.permissions.other.permis.r = false;
                    vm.permissions.other.permis.w = false;
                    vm.permissions.other.permis.x = false;
                }
            } else {
                vm.permissions.permission = "-1";
                vm.permissions.category = "-1";
            }
        }

        function getPerms() {
            var perms = "";
            if(vm.permissions.user !== undefined) {
                perms += getValuePermsString(vm.permissions.user.permis.r, "r");
                perms += getValuePermsString(vm.permissions.user.permis.w, "w");
                perms += getValuePermsString(vm.permissions.user.permis.x, "x");
            }
            if(vm.permissions.group !== undefined) {
                perms += getValuePermsString(vm.permissions.group.permis.r, "r");
                perms += getValuePermsString(vm.permissions.group.permis.w, "w");
                perms += getValuePermsString(vm.permissions.group.permis.x, "x");
            }
            if(vm.permissions.other !== undefined) {
                perms += getValuePermsString(vm.permissions.other.permis.r, "r");
                perms += getValuePermsString(vm.permissions.other.permis.w, "w");
                perms += getValuePermsString(vm.permissions.other.permis.x, "x");
            }
            return perms;
        }

        function getPermsFromString(perms) {
            if(perms !== undefined && perms !== "---------" && perms !== null) {
                vm.isCustomPermission = true;
                vm.permissions.user = {};
                vm.permissions.group = {};
                vm.permissions.other = {};
                vm.permissions.user.permis = {};
                vm.permissions.group.permis = {};
                vm.permissions.other.permis = {};
                vm.permissions.user.permis.r = perms.charAt(0) !== "-";
                vm.permissions.user.permis.w = perms.charAt(1) !== "-";
                vm.permissions.user.permis.x = perms.charAt(2) !== "-";
                vm.permissions.group.permis.r = perms.charAt(3) !== "-";
                vm.permissions.group.permis.w = perms.charAt(4) !== "-";
                vm.permissions.group.permis.x = perms.charAt(5) !== "-";
                vm.permissions.other.permis.r = perms.charAt(6) !== "-";
                vm.permissions.other.permis.w = perms.charAt(7) !== "-";
                vm.permissions.other.permis.x = perms.charAt(8) !== "-";
            }
        }

        function getValuePermsString(condition, index) {
            if(condition)
                return index;
            return "-";
        }

        vm.clear = function () {
            $state.go('tab-files');
        };

        vm.setFileContent = function ($file, tabFiles) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.fileContentRaw = $window.atob(base64Data);
                        tabFiles.fileContent = base64Data;
                        tabFiles.fileContentType = $file.type;
                    });
                });
            }
        };

        vm.toggleInlineEditor = function () {
            vm.showInlineEditor = !vm.showInlineEditor;
            if (vm.showInlineEditor)
                vm.fileContentRaw = $window.atob(vm.tabFiles.fileContent ? vm.tabFiles.fileContent : "");
        };

        vm.setFileFromEditor = function () {
            vm.tabFiles.fileContent = $window.btoa(vm.fileContentRaw);
        };

        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesEnableController',TabFilesEnableController);

    TabFilesEnableController.$inject = ['$uibModalInstance', 'entity', 'TabFiles'];

    function TabFilesEnableController($uibModalInstance, entity, TabFiles) {
        var vm = this;
        vm.tabFile = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabFile.isActive = true;
            TabFiles.enable(vm.tabFile,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesController', TabFilesController);

    TabFilesController.$inject = ['$scope', '$state', 'TabFiles', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFilesController($scope, $state, TabFiles, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabFiles = [];
        vm.tabFilesInactive = [];
        vm.predicates = pagingParams.predicates;
        //vm.page = 0;      Modifica per impaginazione
        vm.loadPage = loadPage;
        vm.applyFilter = applyFilter;
        vm.charToSearch = pagingParams.search;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-files";
        vm.currentStateFilter = "tab-files-filter";
        vm.tabFileType = pagingParams.tabFileType;
        vm.tabObjectType = pagingParams.tabObjectType;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        var filter = localStorage.getItem(vm.currentStateFilter);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;     //Pagination da aggiungere sopra ['']
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.tabFileType = filter.tabFileType;
                vm.tabObjectType = filter.tabObjectType;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,        //Modifica per impaginazione
                size: vm.itemsPerPageChosen,        //Modifica per impaginazione
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabFiles.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFiles = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;      //Aggiunta per impaginazione
                vm.page = pagingParams.page;
                //vm.systemPage = pagingParams.systemPage;
                for (var i=0; i < data.length; ++i) {
                    vm.tabFiles.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.loadInactive = function(tabFiles) {
            TabFiles.load({name: tabFiles.fileAlias, idShowed : tabFiles.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabFilesInactive[tabFiles.fileAlias] = [];
                vm.tabFilesInactive[tabFiles.fileAlias] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(type, objectType) {
            var filter = {};
            filter.tabFileType = vm.tabFileType = type;
            filter.tabObjectType = vm.tabObjectType = objectType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.tabFiles = [];
            vm.page = pagingParams.page;
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.tabFileType.id !== -1) {
                body.tabFileTypeId = vm.tabFileType.id;
            }
            if (vm.tabObjectType.id !== -1) {
                body.tabObjectTypeId = vm.tabObjectType.id;
            }
        }

        vm.reset = function () {
            vm.page = 0;
            vm.tabFiles = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {           //Modifica per impaginazione
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFiles', TabFiles);

    TabFiles.$inject = ['$resource'];

    function TabFiles ($resource) {
        var resourceUrl =  'api/tab-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'load': {
                url:'api/tab-files/inactive',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' },
            'enable': {
                url:'api/tab-files/enable',
                method:'PUT'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-files', {
                parent: 'update_management',
                url: '/tab-files?search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files.html',
                        controller: 'TabFilesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    tabFileType: {
                        value: '-1'
                    },
                    tabObjectType: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            tabFileType: $stateParams.tabFileType,
                            tabObjectType: $stateParams.tabObjectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-files-upgrade', {
                parent: 'tab-files',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-upgrade.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', '$q', function ($stateParams, ScriptsReleases, $q) {
                        var scriptsRelease = $q.defer();
                        ScriptsReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            scriptsRelease.resolve(data);
                        });
                        return scriptsRelease.promise;
                    }]
                }
            })
            .state('tab-files-detail', {
                parent: 'tab-files',
                url: '/tab-files/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-detail.html',
                        controller: 'TabFilesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', function ($stateParams, TabFiles) {
                        return TabFiles.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-files-new', {
                parent: 'tab-files',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-dialog.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            fileAlias: null,
                            fileDescription: null,
                            fileName: null,
                            fileContent: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-files-edit', {
                parent: 'tab-files',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-dialog.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', function ($stateParams, TabFiles) {
                        return TabFiles.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-files.enable', {
                parent: 'tab-files',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-files/tab-files-enable-dialog.html',
                        controller: 'TabFilesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFiles', function (TabFiles) {
                                return TabFiles.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-files', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-files.delete', {
                parent: 'tab-files',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-files/tab-files-delete-dialog.html',
                        controller: 'TabFilesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFiles', function (TabFiles) {
                                return TabFiles.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-files', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDeleteController', TabFirmwareDeleteController);

    TabFirmwareDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFirmware'];

    function TabFirmwareDeleteController($uibModalInstance, entity, TabFirmware) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFirmware.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDetailController', TabFirmwareDetailController);

    TabFirmwareDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabFirmware', 'DataUtils'];

    function TabFirmwareDetailController($scope, $rootScope, $stateParams, entity, TabFirmware, DataUtils) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.openFile = false;
        vm.fileContent = '';
        vm.tabFirmware.$promise.then(function(test){
            vm.firmwareBody = window.atob(vm.tabFirmware.firmwareBody);
        });

        var unsubscribe = $rootScope.$on('jotApp:tabFirmwareUpdate', function (event, result) {
            vm.tabFirmware = result;
        });
        
        $scope.$on('$destroy', unsubscribe);
        vm.byteSize = DataUtils.byteSize;
        // vm.openFile = DataUtils.openFile;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDialogController', TabFirmwareDialogController);

    TabFirmwareDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabFirmware', 'DataUtils', 'TabObjectTypes', '$state', 'AlertService','ParseLinks'];

    function TabFirmwareDialogController($timeout, $scope, $stateParams, $q, entity, TabFirmware, DataUtils, TabObjectTypes, $state, AlertService,ParseLinks) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.tabFirmwareInactive = [];
        vm.tabObjectTypes = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFirmwareUpdate', result);
            vm.isSaving = false;
            $state.go('tab-firmware');
        };

        var onSaveError = function () {
            vm.isSaving = false;
            AlertService.error("Error saving firmware file");
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFirmware.id !== null) {
                TabFirmware.update(vm.tabFirmware, onSaveSuccess, onSaveError);
            } else {
                TabFirmware.save(vm.tabFirmware, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-firmware');
        };

        vm.setFileContent = function ($file, tabFirmware) {
            if ($file) {
                if($file.type === "srec" || $file.name.indexOf(".srec") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "SREC";
                        });
                    });
                    vm.tabFirmware.extension = ".srec";
                } else if($file.type === "hex" || $file.name.indexOf(".hex") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "HEX";
                        });
                    });
                    vm.tabFirmware.extension = ".hex";
                } else if($file.type === "bin" || $file.name.indexOf(".bin") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "BIN";
                        });
                    });
                    vm.tabFirmware.extension = ".bin";
                } else {
                    AlertService.error("The file type is not 'srec', 'hex' or 'bin', are you sure is a firmware file");
                }
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.isSameVersion = function () {
            return vm.tabFirmware.version === document.getElementById("field_currentVersion").value || vm.checkVersionOverride();
        };

        vm.loadInactive = function(tabFirmwareActive) {
            TabFirmware.load({address: tabFirmwareActive.address, objectTypeId: tabFirmwareActive.objectType.id, idShowed : tabFirmwareActive.id}, null, onSuccess, onError);
            function onSuccess(data) {
                data.forEach(function (fw) {
                    vm.tabFirmwareInactive.push(fw);
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        TabFirmware.query().$promise.then(function (res) {
            res.forEach(function (fw) {
                vm.loadInactive(fw);
            });
        });

        vm.checkVersionOverride = function () {
            var found = false;
            if (vm.tabFirmwareInactive.length > 0) {
                vm.tabFirmwareInactive.forEach(function (entry) {
                    if (!found) {
                        found = entry.address === vm.tabFirmware.address && entry.version === vm.tabFirmware.version && entry.objectType.id === vm.tabFirmware.objectType.id;
                    }
                });
            }
            return found;
        };

        vm.loadAll = function () {
            TabObjectTypes.query({
                page: vm.page,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareEnableController',TabFirmwareEnableController);

    TabFirmwareEnableController.$inject = ['$uibModalInstance', 'entity', 'TabFirmware'];

    function TabFirmwareEnableController($uibModalInstance, entity, TabFirmware) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabFirmware.isActive = true;
            TabFirmware.update(vm.tabFirmware,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareController', TabFirmwareController);

    TabFirmwareController.$inject = ['$scope', '$state', 'TabFirmware', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFirmwareController($scope, $state, TabFirmware, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabFirmware = [];
        vm.tabFirmwareInactive = [];
        vm.transition = transition;
        //vm.predicates = {};
        //vm.page = 0;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-firmware";
        vm.currentStateFilter = "tab-firmware-filter";
        vm.objectType = pagingParams.objectType;
        vm.applyFilter = applyFilter;
        var filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectType = filter.objectType;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabFirmware.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFirmware = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    vm.tabFirmware.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.loadInactive = function(tabFirmwareActive) {
            TabFirmware.load({address: tabFirmwareActive.address, objectTypeId: tabFirmwareActive.objectType.id, idShowed : tabFirmwareActive.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabFirmwareInactive[tabFirmwareActive.address + tabFirmwareActive.objectType.objectTypeName] = [];
                vm.tabFirmwareInactive[tabFirmwareActive.address + tabFirmwareActive.objectType.objectTypeName] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabFirmware = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(objectType) {
            var filter={};
            filter.objectType = vm.objectType = objectType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.page = pagingParams.page;
            vm.tabFirmware = [];
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.objectType.id !== -1)
                body.objectTypeId = vm.objectType.id;
        }

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFirmware', TabFirmware);

    TabFirmware.$inject = ['$resource'];

    function TabFirmware ($resource) {
        var resourceUrl =  'api/tab-firmware/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'load': {
                url:'api/tab-firmware/inactive',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-firmware', {
                parent: 'entity',
                url: '/tab-firmware?search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware.html',
                        controller: 'TabFirmwareController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    objectType: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            objectType: $stateParams.objectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-firmware-new', {
                parent: 'tab-firmware',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-dialog.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            address: null,
                            version: null,
                            description: null,
                            firmwareBody: null,
                            boardReference: null,
                            isActive: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-firmware-edit', {
                parent: 'tab-firmware',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-dialog.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', function ($stateParams, TabFirmware) {
                        return TabFirmware.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-firmware-upgrade', {
                parent: 'tab-firmware',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-upgrade.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', '$q', function ($stateParams, TabFirmware, $q) {
                        var firmware = $q.defer();
                        TabFirmware.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            data.firmwareBody = null;
                            firmware.resolve(data);
                        });
                        return firmware.promise;
                    }]
                }
            })
            .state('tab-firmware.delete', {
                parent: 'tab-firmware',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-delete-dialog.html',
                        controller: 'TabFirmwareDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFirmware', function (TabFirmware) {
                                return TabFirmware.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-firmware', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-firmware.enable', {
                parent: 'tab-firmware',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-enable-dialog.html',
                        controller: 'TabFirmwareEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFirmware', function (TabFirmware) {
                                return TabFirmware.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-firmware', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-firmware-detail', {
                parent: 'tab-firmware',
                url: '/tab-firmware/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-detail.html',
                        controller: 'TabFirmwareDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', function ($stateParams, TabFirmware) {
                        return TabFirmware.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
;
(function() {

    'use strict'

    angular
        .module('jotApp')
        .filter('fleetFilter', fleetFilter);

    function fleetFilter() {
        return fleetFilterFunction;

        function fleetFilterFunction (objList, expression) {
            var filteredList = [];
            // no filter specified
            if(expression != undefined){
                if (expression.name === "" && expression.category === "") {
                    filteredList = objList;
                } else {
                    angular.forEach(objList, function (value) {
                        var toPush = true;
                        // filter for name
                        if (value.objectName !== "" && !value.objectName.toLowerCase().includes(expression.name)) {
                            toPush = false;
                        }
                        // filter for objectUniqueCode && name
                        if ((value.objectUniqueCode !== "" && !value.objectUniqueCode.toLowerCase().includes(expression.objectUniqueCode.toLowerCase())) &&
                            (value.objectName !== "" && !value.objectName.toLowerCase().includes(expression.objectUniqueCode.toLowerCase()))) {
                            toPush = false;
                        }
                        //filter for type
                        if (expression.type !== 'ALL' && (value.objectType.objectTypeName+'') !== expression.type) {
                            toPush = false;
                        }
                        //filter for category
                        // if (expression.category !== 'all' && (value.cat+'') !== expression.category) {
                        //     toPush = false;
                        // }
                        if (toPush)
                            filteredList.push(value);
                    });
                }
            }
            return filteredList;
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDeleteController',TabFleetsDeleteController);

    TabFleetsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFleets'];

    function TabFleetsDeleteController($uibModalInstance, entity, TabFleets) {
        var vm = this;
        vm.tabFleets = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFleets.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDetailController', TabFleetsDetailController);

    TabFleetsDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabFleetsDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabFleets = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabFleetsUpdate', function(event, result) {
            vm.tabFleets = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsDialogController', TabFleetsDialogController);

    TabFleetsDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabFleets', 'TabDomains', 'domain', 'TabFiles', 'Principal'];

    function TabFleetsDialogController($state, $timeout, $scope, entity, TabFleets, TabDomains, domain, TabFiles, Principal) {
        var vm = this;
        vm.tabFleets = entity;
        vm.domain = domain;

        Principal.identity().then(function (data) {
            if(data.authorities.indexOf('ROLE_TECH') > -1) {
                vm.domains = TabDomains.query({size: 1000});
                vm.tabfiles = TabFiles.query({size: 1000});
            }
        });



        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFleetsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-fleets');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFleets.id !== null) {
                if (vm.tabFleets.notVisibleUsers != null){
                    vm.tabFleets.users = vm.tabFleets.users.concat(vm.tabFleets.notVisibleUsers);
                }
                TabFleets.update(vm.tabFleets, onSaveSuccess, onSaveError);
            } else {
                TabFleets.save(vm.tabFleets, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-fleets');
        };

        vm.reloadUsers = function () {
            vm.tabFleets.users = [];
            vm.domain = TabDomains.get({id: vm.tabFleets.domains.id});
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsManageObjectController', TabFleetsManageObjectController);

    TabFleetsManageObjectController.$inject = ['$state', '$scope', 'entity', 'TabFleets', 'TabObjects', 'AlertService'];

    function TabFleetsManageObjectController($state, $scope, entity, TabFleets, TabObjects, AlertService) {
        var vm = this;

        vm.fleets = [];

        vm.fleet1 = [];
        vm.type1 = [];
        vm.fleet2 = [];
        vm.type2 = [];
        vm.fleetFilters = {
            name:     '',
            category: 'all',
            objectUniqueCode: '',
            type: 'ALL'
        };
        vm.fleet2Filters = {
            name:     '',
            category: 'all',
            objectUniqueCode: '',
            type: 'ALL'
        };

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.fleet1 = entity;

                TabFleets.query(onSuccess, onError);

                function onSuccess(data){
                    for(var i = 0; i < data.length; i++){
                        vm.fleets.push(data[i]);
                        if(vm.fleet1.id == vm.fleets[i].id){
                            vm.fleets[i].selected = true;
                        } else {
                            vm.fleets[i].selected = false;
                        }
                    }
                }

                function onError(){}

                getObject(vm.fleet1, vm.type1);
            });
        }

        vm.getIndex = function (fleet) {
            for(var i = 0; i < vm.fleets.length; i++){
                if(fleet.id == vm.fleets[i].id)
                    return i;
            }
        };

        vm.change = function (fleet, type){
            for(var i = 0; i < vm.fleets.length; i++){
                if(vm.fleet1.id == vm.fleets[i].id || vm.fleet2.id == vm.fleets[i].id){
                    vm.fleets[i].selected = true;
                } else {
                    vm.fleets[i].selected = false;
                }
            }
            getObject(fleet, type);
        };

        vm.moveObj = function(obj,origin,destination) {
            //check if selected fleet are not the same
            if(destination != undefined){
                if (origin.id != destination.id) {
                    var index = origin.fleetList.findIndex(function(elem){
                        return (elem.id == obj.id);
                    });
                    origin.fleetList.splice(index,1);
                    destination.fleetList.unshift(obj);

                    obj.fleet.domains = destination.domains;
                    obj.fleet.entityId = destination.entityId;
                    obj.fleet.files = destination.files;
                    obj.fleet.fleetDescription = destination.fleetDescription;
                    obj.fleet.fleetName = destination.fleetName;
                    obj.fleet.id = destination.id;
                    obj.fleet.objectClass = destination.objectClass;
                    obj.fleet.otherMetrics = destination.otherMetrics;
                    obj.fleet.users = destination.users;
                    TabObjects.update(obj, onSuccessUpdate, onErrorUpdate);

                    function onSuccessUpdate() {}

                    function onErrorUpdate() {}
                }
            } else AlertService.error("No destination fleet has been selected")
        };

        function getObject(fleet, type) {
            var body = {
                id: fleet.id,
                onlyUpdate: false,
                onlyOnline: false,
                page: vm.page,
                size: 1000
            };
            TabObjects.byFleet(body, onSuccessObj, onErrorObj);

            function onSuccessObj(data) {
                vm.fleets[vm.getIndex(fleet)].fleetList = data.tabObjectsList;
                getType(vm.fleets[vm.getIndex(fleet)].fleetList, type);
            }

            function onErrorObj() {}
        }

        function getType(listObj, type){
            type.length = 0;
            for(var i = 0; i < listObj.length; i++){
                type.push(listObj[i].objectType.objectTypeName);
            }
            type.sort();
            for(var i = 1; i < type.length;){
                if(type[i-1] ===  type[i]){
                    type.splice(i, 1);
                } else {
                    i++;
                }
            }
            type.push("ALL");
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsController', TabFleetsController);

    TabFleetsController.$inject = ['$scope', '$state', 'TabFleets', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabFleetsController ($scope, $state, TabFleets, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.applyFilter = applyFilter;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-fleets";
        vm.currentStateFilter = "tab-fleets-filter";
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

       vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };

            TabFleets.query(body, onSuccess, onError);
            // addFilter(body);
            // TabFleets.filterClass(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabFleets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(objClass) {
            var filter = {};
            filter.objectClazz = vm.objectClazz = objClass;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.objectClazz.id !== -1) {
                body.objectClazzId = vm.objectClazz.id;
            }
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabFleets', TabFleets)
        .factory('UserForSelect', UserForSelect);

    TabFleets.$inject = ['$resource'];

    function TabFleets($resource) {
        var resourceUrl = 'api/tab-fleets/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'domains': {
                url:'api/tab-fleets/domains/:id',
                method: 'GET',
                isArray: true
            },
            'all': {
                url:'api/tab-fleets/all-domains',
                method: 'GET',
                isArray: true
            },
            'domainsEager': {
                url:'api/tab-fleets/domainsEager/:id',
                method: 'GET',
                isArray: true
            },
            'users': {
                url:'api/tab-fleets/users',
                method: 'GET',
                isArray: true
            },
            'filterType': {
                url:'api/tab-fleets/filterClass/:className',
                method: 'GET',
                isArray: true
            },
            'warnings': {
                url:'api/tab-fleets/warnings',
                method: 'GET'
            },
            'filterClass': {
                url: 'api/tab-fleets/filterByClassId',
                method: 'GET',
                isArray: true
            }
        });
    }

    UserForSelect.$inject = ['$resource'];

    function UserForSelect($resource) {
        var resourceUrl = 'api/users-select/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-fleets', {
                parent: 'entity',
                url: '/tab-fleets?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets.html',
                        controller: 'TabFleetsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    predicates: {},
                    objectClazz: {
                        value: '-1'
                    },
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectClazz: $stateParams.objectClazz
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-fleets-detail', {
                parent: 'tab-fleets',
                url: '/tab-fleets/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-detail.html',
                        controller: 'TabFleetsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFleets', function ($stateParams, TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-fleets-new', {
                parent: 'tab-fleets',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-dialog.html',
                        controller: 'TabFleetsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],        entity: function () {
                        return {
                            fleetName: null,
                            fleetDescription: null,
                            isActive: false,
                            isVisibile: false,
                            id: null
                        };
                    },
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('tab-fleets-edit', {
                parent: 'tab-fleets',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-dialog.html',
                        controller: 'TabFleetsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFleets', function ($stateParams,TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }],
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('tab-fleets.delete', {
                parent: 'tab-fleets',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-delete-dialog.html',
                        controller: 'TabFleetsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFleets', function (TabFleets) {
                                return TabFleets.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-fleets', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-fleets-object', {
                parent: 'tab-fleets',
                url: '/{id}/manage-objects',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-manage-object.html',
                        controller: 'TabFleetsManageObjectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'TabFleets', function ($stateParams, TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectStates', TabObjectStates);

    TabObjectStates.$inject = ['$resource'];

    function TabObjectStates ($resource) {
        var resourceUrl =  'api/tab-object-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('InsertObjectMappingType', InsertObjectMappingType);

    InsertObjectMappingType.$inject = ['$state', '$uibModalInstance'];

    function InsertObjectMappingType($state, $uibModalInstance) {
        var vm = this;
        vm.property = "";

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            localStorage.setItem("insert-new-object", JSON.stringify(vm.property));
            $uibModalInstance.close();
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTypesDeviceReleasesController', ObjectTypesDeviceReleasesController);

    ObjectTypesDeviceReleasesController.$inject = ['$scope', '$state', '$stateParams', 'TabDeviceReleases', 'TabObjectTypes', 'TabDevices','entity'];

    function ObjectTypesDeviceReleasesController($scope, $state, $stateParams, TabDeviceReleases, TabObjectTypes, TabDevices ,entity) {
        var vm = this;
        vm.tabObjectTypes = entity;
        vm.deviceReleasesForced = {};
        vm.tabDeviceReleases = [];
        vm.loadReleases = loadReleases;
        vm.clearDependency = clearDependency;

        vm.tabObjectTypes.$promise.then(function (data) {
            vm.tabDevices = data.devices;
            vm.loadReleases(vm.tabDevices);
            vm.tabObjectTypes.deviceReleases.forEach(function (release) {
                vm.deviceReleasesForced[release.deviceReleaseName] = release;
            });
            console.log(vm.deviceReleasesForced);
        });

        function loadReleases(tabDevice) {
            for (var i = 0; i < tabDevice.length; ++i) {
                vm.tabDeviceReleases.push(TabDeviceReleases.filterType({deviceId: tabDevice[i].id}));
            }

        }

        function clearDependency(release){
            delete vm.deviceReleasesForced[release];
        }

        var formatReleases = function () {
            vm.tabObjectTypes.deviceReleases = Object.keys(vm.deviceReleasesForced).map(function (value) {
                if (value)
                    return vm.deviceReleasesForced[value];
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            formatReleases();
            vm.isSaving = true;
            if (vm.tabObjectTypes.id !== null) {
                TabObjectTypes.update(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            } else {
                TabObjectTypes.save(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-object-types');
        };


    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDeleteController', TabObjectTypesDeleteController);

    TabObjectTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabObjectTypes'];

    function TabObjectTypesDeleteController($uibModalInstance, entity, TabObjectTypes) {
        var vm = this;
        vm.tabObjectTypes = entity;
        vm.hasIndices = false;
        vm.clear = function () {
            vm.hasIndices = false;
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id, decision) {
            vm.hasIndices = false;
            TabObjectTypes.delete({id: id, decision: decision},
                function () {
                    $uibModalInstance.close(true);
                },
                function (response) {
                    if (response.status === 449) {
                        vm.hasIndices = true;
                    }
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDetailController', TabObjectTypesDetailController);

    TabObjectTypesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabObjectTypesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabObjectTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabObjectTypesUpdate', function(event, result) {
            vm.tabObjectTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesDialogController', TabObjectTypesDialogController);

    TabObjectTypesDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabDevices', 'TabFiles', 'TabObjectTypes', 'TabFileTypes'];

    function TabObjectTypesDialogController($state, $timeout, $scope, entity, TabDevices, TabFiles, TabObjectTypes, TabFileTypes) {

        var vm = this;
        vm.tabObjectTypes = entity;
        vm.tabdevices = TabDevices.query({size: 1000});
        vm.tabfiles = TabFiles.query({size: 1000});
        vm.tabFileTypes = TabFileTypes.query({size: 1000});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabObjectTypes.id !== null) {
                TabObjectTypes.update(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            } else {
                checkControl();
                TabObjectTypes.save(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            }
        };

        function checkControl() {
            if (vm.tabObjectTypes.skipBurnin === undefined || vm.tabObjectTypes.skipBurnin == null) {
                vm.tabObjectTypes.skipBurnin = false;
            }
            if (vm.tabObjectTypes.multipleDocs === undefined || vm.tabObjectTypes.multipleDocs == null) {
                vm.tabObjectTypes.multipleDocs = false;
            }
            if (vm.tabObjectTypes.greengrassType === undefined || vm.tabObjectTypes.greengrassType == null) {
                vm.tabObjectTypes.greengrassType = false;
            }
        }


        vm.saveAndContinue = function () {

            vm.isSaving = true;
            if (vm.tabObjectTypes.id == null) {
                checkControl();
                TabObjectTypes.save(vm.tabObjectTypes, andContinue, onSaveError);
            }


        };

        function andContinue(result) {
            $state.go("object-types-device-releases", {
                id: result.id
            });
        }

        vm.clear = function () {
            localStorage.removeItem('tabObjectTypes');
            $state.go('tab-object-types');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesMappingDialogController', TabObjectTypesMappingDialogController);

    TabObjectTypesMappingDialogController.$inject = ['$state', '$scope', '$rootScope', 'entity', 'TabObjectTypes'];

    function TabObjectTypesMappingDialogController($state, $scope, $rootScope, entity, TabObjectTypes) {

        var vm = this;

        vm.template = entity;
        vm.property = [];
        vm.createObj = false;
        vm.quantity = 0;
        vm.properties = [];

        vm.clear = function () {
            $state.go('^');
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types-mapping');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            if(!vm.createObj){
                var properties = {};
                properties[vm.property.name] = {type: vm.property.type};
                var body = {
                    id: vm.template.id,
                    index: "jot_"+vm.template.objectTypeName.toLowerCase()+"_template",
                    properties: properties
                };
                TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
            } else {
                var app = {};
                for(var i = 0; i < vm.properties.length; i++){
                    if(vm.properties[i].type != "object") {
                        app[vm.properties[i].name] = {type: vm.properties[i].type};
                    } else {
                        app[vm.properties[i].name] = angular.fromJson(vm.properties[i].objectJson);
                    }
                }
                var body = {
                    id: vm.template.id,
                    index: "jot_"+vm.template.objectTypeName.toLowerCase()+"_template",
                    properties: app
                };
                TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesMappingController', TabObjectTypesMappingController);

    TabObjectTypesMappingController.$inject = ['$scope', '$state', '$rootScope', 'entity', 'TabObjectTypes', 'pagingParams', 'AlertService'];

    function TabObjectTypesMappingController($scope, $state, $rootScope, entity, TabObjectTypes, pagingParams, AlertService) {

        var vm = this;

        vm.tabObjectTypes = [];
        vm.templateMetric = [];
        vm.espandMetric = {};
        vm.templateMetricString = [];

        vm.charToSearch = pagingParams.search;

        vm.isValid = false;
        vm.errorJson = "";

        vm.updateJsonObject = function() {
            try {
                JSON.parse(vm.script);
            } catch (e) {
                vm.isValid = false;
                vm.errorJson = "Invalid JSON Format";
            }
            vm.message = JSON.parse(vm.script);
            if(Object.keys(vm.message)[0].toString() === "properties"){
                vm.isValid = true;
            } else {
                vm.isValid = false;
                vm.errorJson = "First key must be properties";
            }
        };

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabObjectTypes = entity;
                var body = {id: vm.tabObjectTypes.id};

                TabObjectTypes.getTemplate(body, onSuccess, onError);

                function onSuccess(data) {
                    var obj = data.properties;
                    angular.forEach(obj, function (value, key) {
                        var template = {};
                        template.name=key;
                        if(value.type != undefined){
                            template.type = value.type;
                            template.visibility = true;
                        } else {
                            template.type = "object";
                            template.visibility = true;
                            template.folderClass = "fa-plus-square";
                            template.addMetric = "fa-pencil";
                            var level = 0;
                            template.subProperties = [];
                            angular.forEach(value.properties, function (value, key) {
                                template.subProperties.push(getProperties(value,key, level));
                            })
                        }
                        vm.templateMetric.push(template);
                    });
                    for(var i = 0; i < Object.keys(vm.templateMetric).length; i++){
                        vm.templateMetricString.push(JSON.stringify(vm.templateMetric[i]));
                    }
                }

                function getProperties(value, key, level) {
                    var subTemplate = {};
                    level++;
                    subTemplate.name = key;
                    if(value.type != undefined){
                        subTemplate.type = value.type;
                        subTemplate.level = (level*20)+6;
                        subTemplate.level = subTemplate.level.toString() + "px";
                    } else {
                        subTemplate.type = "object";
                        subTemplate.folderClass = "fa-plus-square";
                        subTemplate.addMetric = "fa-pencil";
                        subTemplate.level = (level*20)+6;
                        subTemplate.level = subTemplate.level.toString() + "px";
                        subTemplate.subProperties = [];
                        angular.forEach(value.properties, function (value, key) {
                            subTemplate.subProperties.push(getProperties(value,key, level));
                        })
                    }
                    return subTemplate;
                }

                function onError() {
                    AlertService.error("Template not Available");
                }
            });
        }

        vm.search = function(){
            searchIn();
        };

        function searchIn() {
            for(var i = 0; i < vm.templateMetricString.length; i++){
                if(vm.templateMetricString[i].includes(vm.searchText)){
                    vm.templateMetric[i].visibility = true;
                } else {
                    vm.templateMetric[i].visibility = false;
                }
            }
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.reload();
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            var body = {
                id: vm.tabObjectTypes.id,
                index: "jot_"+vm.tabObjectTypes.objectTypeName.toLowerCase()+"_template",
                properties: vm.message
            };
            TabObjectTypes.putTemplate(body, onSaveSuccess, onSaveError);
        };

        vm.clear = function () {
            vm.script = "";
            vm.isValid = false;
            vm.errorJson = "";
        };

        vm.updateNewObject = function () {
            deleteProperties(vm.templateMetric);
            var obj = getObject(vm.templateMetric);
            var mapping = JSON.stringify(obj);
            var body = {
                id: vm.tabObjectTypes.id,
                index: "jot_"+vm.tabObjectTypes.objectTypeName.toLowerCase()+"_template",
                mapping: mapping
            };
            TabObjectTypes.newInObject(body, onSuccessObjectMap, onErrorObjectMap);

            function onSuccessObjectMap() {
                $state.reload();
            }

            function onErrorObjectMap() {}
        };

        function getObject(array) {
            var obj = {};
            array.forEach(function (a) {
                if(a.type != "object"){
                    obj[a.name] = {type: a.type};
                } else {
                    obj[a.name] = getObject(a.subProperties);
                }
            });
            return {properties: obj};
        }

        function deleteProperties (metrics) {
            metrics.forEach(function (a) {
                delete a.level;
                delete a.visibility;
                delete a.folderClass;
                delete a.addMetric;
                if(a.subProperties != undefined){
                    deleteProperties(a.subProperties);
                }
            })
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesController', TabObjectTypesController);

    TabObjectTypesController.$inject = ['$scope', '$state', 'TabObjectTypes', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabObjectTypesController ($scope, $state, TabObjectTypes, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabObjectTypes = [];
        vm.applyFilter = applyFilter;
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.currentState = "tab-object-types";
        vm.currentStateFilter = "tab-object-types-filter";
        vm.device = pagingParams.device;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.device = filter.device;
            }
        }

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabObjectTypes.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabObjectTypes = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i=0; i < data.length; ++i) {
                    vm.tabObjectTypes.push(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(device) {
            var filter = {};
            filter.device = vm.device = device;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.tabObjectTypes = [];
            vm.page = pagingParams.page;
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.device.id !== -1)
                body.deviceId = vm.device.id;
        }

        vm.reset = function() {
            vm.page = 0;
            vm.tabObjectTypes = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();


    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectTypes', TabObjectTypes);

    TabObjectTypes.$inject = ['$resource'];

    function TabObjectTypes($resource) {
        var resourceUrl = 'api/tab-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'filterType': {
                url: 'api/tab-object-types/filterClass/:className',
                method: 'GET',
                isArray: true
            },
            'byFleet': {
                url: 'api/tab-object-types/by-fleet/:id',
                method: 'GET',
                isArray: true
            },
            'mapped': {
                url: 'api/tab-object-types/mapped',
                method: 'GET'
            },
            'getTemplate': {
                url: 'api/tab-object-types/mapping/:id',
                method: 'GET'
            },
            'putTemplate': {
                url: 'api/tab-object-types/mapping/new',
                method: 'PUT'
            },
            'getMapping': {
                url: 'api/tab-object-types/template-mapping/:id',
                method: 'GET'
            },
            'getMappingByIndex': {
                url: 'api/tab-object-types/template-mapping-index/:id',
                method: 'GET'
            },
            'newInObject': {
                url: 'api/tab-object-types/mapping/new-in-object',
                method: 'PUT'
            },
            'delete': {
                url: 'api/tab-object-types/:id/:decision',
                method: 'DELETE'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-object-types', {
                parent: 'entity',
                url: '/tab-object-types?search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjectTypes.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types.html',
                        controller: 'TabObjectTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    device: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            device: $stateParams.device,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-object-types-detail', {
                parent: 'tab-object-types',
                url: '/tab-object-types/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-detail.html',
                        controller: 'TabObjectTypesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-new', {
                parent: 'tab-object-types',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-dialog.html',
                        controller: 'TabObjectTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            objectTypeName: null,
                            objectTypeDescription: null,
                            objectTypeNotes: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-object-types-edit', {
                parent: 'tab-object-types',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-dialog.html',
                        controller: 'TabObjectTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types.delete', {
                parent: 'tab-object-types',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-delete-dialog.html',
                        controller: 'TabObjectTypesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjectTypes', function (TabObjectTypes) {
                                return TabObjectTypes.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-object-types', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('object-types-device-releases', {
                parent: 'tab-object-types',
                url: '/{id}/object-types-device-releases',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/object-types-device-releases.html',
                        controller: 'ObjectTypesDeviceReleasesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-mapping', {
                parent: 'tab-object-types',
                url: '/{id}/mapping',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-mapping.html',
                        controller: 'TabObjectTypesMappingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-mapping-new', {
                parent: 'tab-object-types-mapping',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-mapping-dialog.html',
                        controller: 'TabObjectTypesMappingDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjectsConditions', TabObjectsConditions);

    TabObjectsConditions.$inject = ['$resource'];

    function TabObjectsConditions($resource) {
        var resourceUrl = 'api/tab-objects-conditions/:name';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'default': {url: 'api/tab-objects-conditions-default', method: 'GET'},
            'checkTest': {url: 'api/tab-objects-conditions-check/:id', method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MassivePropertiesController', MassivePropertiesController);

    MassivePropertiesController.$inject = ['$state', 'paginationConstants', 'ListObjByObjTypeAndFleet', 'AlertService', 'TabFleets', 'ListObjAndObjType', '$uibModal'];

    function MassivePropertiesController($state, paginationConstants, ListObjByObjTypeAndFleet, AlertService, TabFleets, ListObjAndObjType, $uibModal) {
        var vm = this;
        vm.init = init;
        vm.selectObjectType = selectObjectType;
        vm.toggleSelection = toggleSelection;
        vm.chkUnChkAll = chkUnChkAll;
        vm.selectedFleet = selectedFleet;
        vm.checkOverwrittenProperties = checkOverwrittenProperties;
        vm.allChecked = false;
        vm.tabObjectTypes = [];
        vm.fleets = [];
        vm.fleet = null;
        vm.currentPage = 1;
        vm.itemsPerPageChosen = paginationConstants.itemsPerPage;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;

        function initializeVariable() {
            vm.tabObjects = [];
            vm.objectChecked = {};
            vm.selectionValue = [];
            vm.objectWithOldProps = {};
            vm.objType = {};
        }

        function init() {
            initializeVariable();
            TabFleets.query({}, function (data) {
                vm.fleets = data;
            }, onError);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function selectObjectType(item) {
            ListObjByObjTypeAndFleet.filtered({
                typeId: item.id,
                fleetId: vm.fleet.id,
                props: true
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.tabObjects = data;
                vm.tabObjects.forEach(function (o) {
                    if (o.hasOverrideProperties === true)
                        vm.objectWithOldProps[o.objectUniqueCode] = true;
                });
            }
        }

        function selectedFleet(fleet) {
            ListObjAndObjType.query({
                id: fleet.id
            }, function (data) {
                initializeVariable();
                vm.tabObjectTypes = data.tabObjectTypesList;
                vm.fleet = fleet;
            }, onError);

        }

        function toggleSelection(object, index, all) {
            var isCheck = vm.objectChecked[index];
            if (isCheck == undefined || isCheck == null || isCheck === false) {
                vm.selectionValue.push(object.objectUniqueCode);
                vm.objectChecked[index] = true;
            }
            else if (!all) {
                vm.selectionValue.splice(vm.selectionValue.indexOf(object.objectUniqueCode), 1);
                delete vm.objectChecked[index];
            }

        }

        function chkUnChkAll() {
            vm.allChecked = !vm.allChecked;
            vm.tabObjects.forEach(function (obj, i, arr) {
                toggleSelection(obj, i, vm.allChecked);
            });
        }

        function checkOverwrittenProperties() {
            var warningObject = [];
            vm.selectionValue.forEach(function (sel) {
                if (vm.objectWithOldProps[sel]) {
                    warningObject.push(sel);
                }
            });
            if (warningObject.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objectstype-properties-dialog.html',
                    controller: 'TabObjectsTypesPropertiesDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        warnings: [function () {
                            return warningObject;
                        }]
                    }
                }).result.then(function () {
                    $state.go("massive-properties.update", {id: vm.objType.id, objects: vm.selectionValue});
                });
            } else {
                $state.go("massive-properties.update", {id: vm.objType.id, objects: vm.selectionValue});
            }
        }

        vm.init();

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('massive-properties', {
                parent: 'entity',
                url: '/tab-objects-properties',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/massive-properties-update.html',
                        controller: 'MassivePropertiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabProperties');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }]
                }
            }).state('massive-properties.update', {
                parent: 'massive-properties',
                url: '/update/:id',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objectstype-properties.html',
                        controller: 'TabObjectTypesPropertiesController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    id:null,
                    objects: []
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        return $translate.refresh();
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.queryByType({id: $stateParams.id});
                    }],
                    occurrence: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.occurrence({objectUniqueCodes: $stateParams.objects});
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('jotApp')
        .factory('ObjectStatusService', ObjectStatusService);

    ObjectStatusService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'STOMP_DEBUG'];

    function ObjectStatusService($rootScope, $window, $cookies, $http, $q, STOMP_DEBUG) {
        var stompClient = null;
        var subscriber = [];
        var listener = $q.defer();
        var connected = $q.defer();
        var connectionId;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            init: init,
            sendChangePage: sendChangePage,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/object/status';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            if (STOMP_DEBUG === false)
                stompClient.debug = null;
            connectionId = guid();
            var headers = {};
            headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
            stompClient.connect(headers, function () {
                connected.resolve('success');
            });

        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                connected = $q.defer();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function init() {
            return listener = $q.defer();
        }

        function sendChangePage(page) {
            if (stompClient !== null && stompClient.connected) {
                stompClient.send('/topic/object/page/' + connectionId, {}, angular.toJson(page));
            }
        }

        function subscribe(callback) {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/network/status/' + connectionId, function (data) {
                    listener.notify(angular.fromJson(data.body));
                }, {'id': connectionId});
                callback.call();
            }, null, null);

        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }

            return s4() + s4() + s4();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDeleteController',TabObjectsDeleteController);

    TabObjectsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabObjects'];

    function TabObjectsDeleteController($uibModalInstance, entity, TabObjects) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabObjects.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDetailController', TabObjectsDetailController);

    TabObjectsDetailController.$inject = ['$scope', '$rootScope', 'DataUtils','entity'];

    function TabObjectsDetailController($scope, $rootScope, DataUtils, entity) {
        var vm = this;
        vm.tabObjects = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabObjectsUpdate', function(event, result) {
            vm.tabObjects = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;


        vm.print = function(){
            var printContents = document.getElementById("toPrint").innerHTML;
            var popupWin = window.open('', '_blank', 'width=1024,height=900');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" href="content/css/vendor.css"><style>.col-lg-4{width: 33%; display: inline-block;}</style></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDialogController', TabObjectsDialogController);

    TabObjectsDialogController.$inject = ['$timeout', '$state', '$scope', 'DataUtils', 'entity', 'TabObjects', 'TabObjectTypes', 'TabFleets', 'ParseLinks', 'AlertService', 'Geolocalization', 'TabObjectsConditions'];

    function TabObjectsDialogController($timeout, $state, $scope, DataUtils, entity, TabObjects, TabObjectTypes, TabFleets, ParseLinks, AlertService, Geolocalization, TabObjectsConditions) {
        var vm = this;
        vm.tabObjects = entity;
        vm.tabObjectTypes = [];
        vm.tabFleets = [];
        vm.timeZone = [];
        vm.objectTypePage = 0;
        vm.fleetPage = 0;
        vm.tabObjects.multipleCreation = false;
        vm.tabObjects.sequence = false;
        vm.tabObjects.pair = false;
        vm.defaultCondition;
        vm.charToSearch;
        vm.fleetToSearch;

        var isLoadingObjectTypes = false;
        var isLoadingFleets = false;
        var originalValue = {
            id: null
        };

        $scope.$watch(function() {
            return vm.tabObjects.multipleCreation;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                //recall map
                $timeout(function () {
                    Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
                });
            }
        });

        if ($state.current.name === 'tab-objects-edit') {
            vm.tabObjects.$promise.then(function (to) {
                originalValue = to.objectType;
                vm.filterFleets();
                $timeout(function () {
                    Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
                });
                var timeZoneSelected = {timeZone: vm.tabObjects.objectTimeZone};
                vm.tabObjects.timeZone = timeZoneSelected;
            });
            vm.tabObjectsConditions = TabObjectsConditions.query();
        } else {
            vm.defaultCondition = TabObjectsConditions.default();
            $timeout(function () {
                Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        //wait for tabObjects before loading gmap


        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-objects');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var timeZ;
            if (vm.tabObjects.id !== null) {
                timeZ = vm.tabObjects.timeZone;
                vm.tabObjects.objectTimeZone = timeZ.timeZone;
                vm.tabObjects.objectAddata = angular.toJson(vm.tabObjects.objectAddata);
                TabObjects.update(vm.tabObjects, onSaveSuccess, onSaveError);
            } else {
                vm.tabObjects.condition = vm.defaultCondition;
                timeZ = vm.tabObjects.timeZone;
                vm.tabObjects.objectTimeZone = timeZ.timeZone;
                TabObjects.save(vm.tabObjects, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-objects');
        };

        vm.setObjectCertificate = function ($file, tabObjects, col) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabObjects[col] = base64Data;

                    });
                });
            }
        };

        vm.isOriginalValue = function () {
            if (vm.tabObjects.objectType && originalValue.id === vm.tabObjects.objectType.id)
                vm.editForm.objectType.$setPristine();
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.filterFleets = function () {
            vm.loadAllFleet();
        };

        vm.onChangeCoordsFunction = function () {
            Geolocalization.reverseGeocode(vm.tabObjects, $scope);
        };

        vm.onChangeAddressFunction = function () {
            Geolocalization.geocodeFromAddress(vm.tabObjects, $scope);
        };

        vm.loadAllTimeZone = function() {
            TabObjects.timeZones(onZoneSuccess, onZoneError);

            function onZoneSuccess(data){
                vm.timeZone = [];
                for (var i = 0; i < data.length; i++) {
                    var timeZ = {timeZone: data[i]};
                    vm.timeZone.push(timeZ);
                }
            }

            function onZoneError(){}
        };

        vm.loadAllFleet = function () {
            isLoadingFleets = true;

            TabFleets.query({
                page: vm.fleetPage,
                size: 20,
                query: vm.fleetToSearch,
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                isLoadingFleets = false;
                vm.fleetToSearch = "";
                vm.fleetLinks = ParseLinks.parse(headers('link'));
                vm.fleetTotalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    var exists = vm.tabFleets.some(function(item) {
                        return item.id === data[i].id;
                    });

                    if (!exists) {
                        vm.tabFleets.push(data[i]);
                    }
                }
            }

            function onError(error) {
                isLoadingFleets = false;
                AlertService.error(error.data.message);
            }
        };

        vm.loadPageFleet = function (page) {
            if (page <= vm.fleetLinks['last']) {
                vm.fleetPage = page;
                vm.loadAllFleet();
            }
        };

        vm.loadAllObjectType = function () {
            isLoadingObjectTypes = true;

            TabObjectTypes.query({
                query: vm.charToSearch,
                page: vm.objectTypePage,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                isLoadingObjectTypes = false;
                vm.charToSearch = "";
                vm.objectTypeLinks = ParseLinks.parse(headers('link'));
                vm.objectTypeTotalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    var exists = vm.tabObjectTypes.some(function(item) {
                        return item.id === data[i].id;
                    });

                    if (!exists) {
                        vm.tabObjectTypes.push(data[i]);
                    }
                }
            }

            function onError(error) {
                isLoadingObjectTypes = false;
                AlertService.error(error.data.message);
            }
        };

        vm.loadPageObjectType = function (page) {
            if (page <= vm.objectTypeLinks['last']) {
                vm.objectTypePage = page;
                vm.loadAllObjectType();
            }
        };

        vm.convertToBoolean = function () {
            vm.tabObjects.sequence = vm.mode === "1";
        };

        vm.populateName = function () {
            vm.tabObjects.objectName = vm.tabObjects.objectUniqueCode;
        };

        vm.serachObjectType = function (search){
            if (isLoadingObjectTypes) return;
            vm.tabObjectTypes = [];
            vm.charToSearch = search;
            vm.objectTypePage = 0;
            vm.loadAllObjectType();
        }

        vm.searchFieldFleet = function (search){
            if (isLoadingFleets) return;
            vm.tabFleets = [];
            vm.fleetToSearch = search;
            vm.loadAllFleet();
        }

        // vm.loadAllObjectType();
        vm.loadAllTimeZone();

    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsElasticPropertiesController', TabObjectsElasticPropertiesController);

    TabObjectsElasticPropertiesController.$inject = ['$state', '$stateParams', 'entity', 'properties', '$uibModal', 'editableOptions', 'TabObjectProperties', 'AlertService'];

    function TabObjectsElasticPropertiesController($state, $stateParams, entity, properties, $uibModal, editableOptions, TabObjectProperties, AlertService) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.searchText = "";
        vm.properties = [];
        vm.app = [];
        vm.tabObject = entity;
        // vm.properties = properties;

        if(properties.$promise) {
            properties.$promise.then(function () {
                vm.properties = properties;
                vm.app = angular.copy(vm.properties);
            });
        }

        function saveReference(key, value) {
            save(key, value);
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }


        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save(key, value) {
                TabObjectProperties.elasticUpdate({
                    key: key,
                    value: value,
                    objectUniqueCode: vm.tabObject.objectUniqueCode
                }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            AlertService.success("Property updated")
        }

        function onSaveError() {
            reloadState();
            AlertService.error("Error update property")

        }

        vm.search = function () {
            vm.app = angular.copy(vm.properties);
            angular.forEach(vm.app, function (value, key) {
                if(!key.toString().includes(vm.searchText)){
                    delete vm.app[key];
                }
            });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsMaintenanceController', TabObjectsMaintenanceController);

    TabObjectsMaintenanceController.$inject = ['$uibModalInstance', 'entity', 'TabObjectsMaint'];

    function TabObjectsMaintenanceController($uibModalInstance, entity, TabObjectsMaint) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setMaintenance = function (tabObjects) {
            TabObjectsMaint.update({}, tabObjects, onSuccess, onError);
            function onSuccess(data) {
                tabObjects = data;
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsManageDomainController',TabObjectsManageDomainController);

    TabObjectsManageDomainController.$inject = ['$uibModalInstance', '$state', '$scope', 'entity', 'TabObjects', 'TabDomains', 'TabFleets'];

    function TabObjectsManageDomainController($uibModalInstance, $state, $scope, entity, TabObjects, TabDomains, TabFleets) {
        var vm = this;

        vm.tabObjects = entity;
        vm.domains = TabDomains.query({
            page: 0,
            size: 100
        });

        vm.domain = null;
        vm.fleet = null;
        vm.styleDomain = "col-md-11 col-xs-12";
        vm.disabledFleet = false;

        vm.selectDomain = function() {
            vm.styleDomain = vm.domain == null ? "col-md-11 col-xs-12" : "col-md-6 col-xs-12";
            TabFleets.domains({id: vm.domain.id}, onSuccessFleet, onErrorFleet);
        }

        function onSuccessFleet(data) {
            if(data.length === 0) {
                vm.disabledFleet = true;
            } else {
                vm.fleets = data;
                vm.disabledFleet = false;
            }
        }

        function onErrorFleet() {}

        vm.manangeDomain = function (){
            vm.isSaving = true;
            vm.tabObjects.fleet = vm.fleet;
            TabObjects.update(vm.tabObjects, onSaveSuccess, onSaveError);
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $uibModalInstance.close(true);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsPropertiesHistoryController', TabObjectsPropertiesHistoryController);

    TabObjectsPropertiesHistoryController.$inject = ['ParseLinks', '$stateParams', 'entity', 'property', 'paginationConstants', 'TabOverrideProperties', 'AlertService'];

    function TabObjectsPropertiesHistoryController(ParseLinks, $stateParams, entity, property, paginationConstants, TabOverrideProperties, AlertService) {
        var vm = this;
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.updates = [];
        vm.loadAll = loadAll;

        entity.$promise.then(function () {
            vm.tabObject = entity;
            property.$promise.then(function () {
                vm.property = property;
                loadAll();
            });
        });

        function loadAll() {
            TabOverrideProperties.query({
                propertyId: property.id,
                objectUniqueCode: entity.objectUniqueCode,
                page: vm.page,
                sort: "createdDate,desc",
                size: 20
            }, onSuccess, onError);

            function onSuccess(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.updates = result;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsPropertiesController', TabObjectsPropertiesController);

    TabObjectsPropertiesController.$inject = ['$state', '$stateParams', 'pagingParams', 'entity', 'properties', '$uibModal', 'paginationConstants', 'editableOptions', 'TabObjectProperties'];

    function TabObjectsPropertiesController($state, $stateParams, pagingParams, entity, properties, $uibModal, paginationConstants, editableOptions, TabObjectProperties) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.search = "";
        editableOptions.theme = 'bs3';
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.tabObject = entity;
        vm.properties = properties;
        vm.predicates = pagingParams.predicates;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            return sortFields;
        }

        vm.reloadPage = function () {
            $state.go('tab-objects-properties', {id: vm.tabObject.id, sort: sort(), predicates: vm.predicates});
        }

        function saveReference(data) {
            editedProperty[data.id] = data;
            save();
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }

        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save() {
            if (!checkNoPendingEdit()) {
                var sendingProperties = [];
                for (var key in editedProperty) {
                    sendingProperties.push(editedProperty[key]);
                }

                TabObjectProperties.update({
                    properties: sendingProperties,
                    objectUniqueCode: vm.tabObject.objectUniqueCode
                }, onSaveSuccess);
            }
        }

        function onSaveSuccess(result) {
            editedProperty = {};
            //$state.transitionTo($state.current, $stateParams, {
            //    reload: true
            //});
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsProvisionController', TabObjectsProvisionController);

    TabObjectsProvisionController.$inject = ['$uibModalInstance', '$interval', 'entityId', 'TabObjectsRedeploy'];

    function TabObjectsProvisionController($uibModalInstance, $interval, entityId, TabObjectsRedeploy) {

        var vm = this;
        vm.entityId = entityId;
        vm.formData = {
            'operations': {'restore': false, 'restart': true}
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // *********************************** //
        // ** Single TabObject confirmation ** //
        // *********************************** //
        vm.confirmRedeployment = function (id) {
            TabObjectsRedeploy.provision({'id': id}, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRedeploymentController', TabObjectsRedeploymentController);

    TabObjectsRedeploymentController.$inject = ['$uibModalInstance', '$interval', 'entityId', 'TabObjectsRedeploy', 'TabObjectsRedeployablesCounter'];

    function TabObjectsRedeploymentController($uibModalInstance, $interval, entityId, TabObjectsRedeploy, TabObjectsRedeployablesCounter) {

        var vm = this;
        vm.entityId = entityId;
        vm.formData = {
            'operations': {'restore': false, 'restart': true}
        };
        vm.redeployObjCounter = TabObjectsRedeployablesCounter;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // *********************************** //
        // ** Single TabObject confirmation ** //
        // *********************************** //
        vm.confirmRedeployment = function (id) {
            TabObjectsRedeploy.redeploy({'id': id}, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        // ************************************ //
        // *** Mass TabObjects confirmation *** //
        // ************************************ //
        vm.confirmRedeploymentAll = function () {
            TabObjectsRedeploy.redeployAll({
                'restore': vm.formData.operations.restore,
                'restart': vm.formData.operations.restart
            }, {}, onSuccess, onError);

            function onSuccess(data) {
                $uibModalInstance.close(true);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRegisterController',TabObjectsRegisterController);

    TabObjectsRegisterController.$inject = ['$uibModalInstance', 'TabObjects', 'AlertService', 'TabFleets', 'LicenceCode'];

    function TabObjectsRegisterController($uibModalInstance, TabObjects, AlertService, TabFleets, LicenceCode) {
        var vm = this;
        vm.fleet = null;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });

        vm.register = function () {
            var body = {
                licence: vm.registrationCode,
                objectUniqueCode: vm.objectUniqueCode,
                fleet: vm.fleet
            };

            LicenceCode.active(body, onLicenceSuccess, onLicenceError);

            function onLicenceSuccess(){
                $uibModalInstance.close(true);
            }

            function onLicenceError(error) {
                if(error.status === 400) {
                    AlertService.error("Licence cannot be activated");
                }
            }

        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRerunningController',TabObjectsRerunningController);

    TabObjectsRerunningController.$inject = ['$uibModalInstance', 'entity', 'TabObjects'];

    function TabObjectsRerunningController($uibModalInstance, entity, TabObjects) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmRerunning = function (objectUniqueCode) {
            TabObjects.rerunning(objectUniqueCode,
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectViewLastDataController', TabObjectViewLastDataController)
        .filter('Find', function() {
            return function(input, str) {
                var tmp = {};
                angular.forEach(input, function(val, key) {
                    if (key.toLowerCase().match(str.toLowerCase())) {
                        tmp[key] = val;
                    }
                });
                return tmp;
            };
        });

    TabObjectViewLastDataController.$inject = ['$state', '$stateParams', '$scope', 'entity', 'uniqueCode'];

    function TabObjectViewLastDataController($state, $stateParams, $scope, entity, uniqueCode) {
        var vm = this;
        vm.tabObjectMetrics = entity;
        vm.objectUniqueCode = uniqueCode;

        vm.tabObjectMetrics.$promise.then(function (data) {
            vm.tabObjectMetrics = data;
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsController', TabObjectsController);

    TabObjectsController.$inject = ['$scope', '$state', 'DataUtils', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjectsRedeployablesCounter', 'TabObjects'];

    function TabObjectsController($scope, $state, DataUtils, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjectsRedeployablesCounter, TabObjects) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.applyFilter = applyFilter;
        vm.predicates = pagingParams.predicates;
        vm.fleet = pagingParams.fleet;
        vm.objectType = pagingParams.objectType;
        vm.objectState = pagingParams.objectState;
        vm.toUpdate = pagingParams.toUpdate;
        vm.online = pagingParams.online;
        vm.tracked = pagingParams.tracked;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-objects";
        vm.currentStateFilter = "tab-objects-filter";
        vm.charToSearch = pagingParams.search;
        vm.tabObjects = [];
        //boolean to set page ready
        vm.pageReady = false;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.fleet = filter.fleet;
                vm.objectType = filter.objectType;
                vm.objectState = filter.objectState;
                vm.toUpdate = filter.toUpdate;
                vm.online = filter.online;
                vm.tracked = filter.tracked;
            }
        }

        vm.redeployObjCounter = TabObjectsRedeployablesCounter;

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (fromState.name === vm.currentState &&
                toState.name !== fromState.name &&
                (toState.name !== 'tab-objects-detail' &&
                    toState.name !== 'tab-objects-new' &&
                    toState.name !== 'tab-objects-edit' &&
                    toState.name !== 'tab-objects.delete' &&
                    toState.name !== 'tab-objects.rerunning' &&
                    toState.name !== 'tab-objects.redeployment' &&
                    toState.name !== 'tab-objects.maintenance' &&
                    toState.name !== 'tab-objects-properties')) {
                localStorage.removeItem(vm.currentStateFilter);
            }
        });
        vm.loadAll();

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                query: vm.charToSearch,
                sort: sort()
            };
            addFilter(body);
            TabObjects.query(body, onSuccess, onError);


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabObjects = data;
                vm.page = pagingParams.page;
                vm.pageReady = true;
                // transition(false);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                fleet: vm.fleet,
                objectType: vm.objectType,
                objectState: vm.objectState,
                toUpdate: vm.toUpdate,
                online: vm.online,
                tracked: vm.tracked
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function applyFilter(fleet, objectType, state, update, online, tracked) {
            var filter = {};
            filter.fleet = vm.fleet = fleet;
            filter.objectType = vm.objectType = objectType;
            filter.objectState = vm.objectState = state;
            filter.toUpdate = vm.toUpdate = update;
            filter.online = vm.online = online;
            filter.tracked = vm.tracked = tracked;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            loadAll();
        }

        function addFilter(body) {
            if (+vm.fleet.id !== -1) {
                body.fleetId = vm.fleet.id;
            }
            if (+vm.objectType.id !== -1) {
                body.typeId = vm.objectType.id;
            }
            if (+vm.objectState.id !== -1) {
                body.stateId = vm.objectState.id;
            }
            if (+vm.toUpdate.id !== -1) {
                body.toUpdate = vm.toUpdate.query;
            }
            if (+vm.online.id !== -1) {
                body.online = vm.online.query;
            }
            if (+vm.tracked.id !== -1) {
                body.tracked = vm.tracked.query;
            }
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.changeSimStatus = function(object, status) {
            object.simActive = status;
            TabObjects.simStatus(object, onSimSuccess, onSimError);

            function onSimSuccess() {
                AlertService.success(status ? "Activated" : "Blocked" + " Sim for object " + object.objectUniqueCode);
            }

            function onSimError() {
                AlertService.error("Error " + status ? "Activating" : "Blocking" + " Sim for object " + object.objectUniqueCode);
            }
        };
    }
})
();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabObjects', TabObjects)
        .factory('TabObjectsRedeploy', TabObjectsRedeploy)
        .factory('TabObjectsRedeployablesCounter', TabObjectsRedeployablesCounter)
        .factory('TabObjectsMaint', TabObjectsMaint)
        .factory('TabObjectProperties', TabObjectProperties)
        .factory('TabOverrideProperties', TabOverrideProperties);

    TabObjects.$inject = ['$resource'];

    function TabObjects($resource) {
        var resourceUrl = 'api/tab-objects/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.objectAddata = angular.fromJson(data.objectAddata);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'updateMetadata': {method: 'PUT', url: 'api/tab-objects-metadata'},
            'updateMute': {method: 'PUT', url: 'api/tab-objects-mute'},
            'byActions': {
                method: 'POST',
                isArray: true,
                url: 'api/tab-objects/by-actions'
            },
            'byUniqueCode': {
                method: 'GET',
                url: 'api/tab-objects-unique-code/:uniqueCode'
            },
            'viewLastData': {
                method: 'GET',
                url: 'api/view-last-data/:id'
            },
            'timeZones': {
                method: 'GET',
                url: 'api/tab-objects-timezones',
                isArray: true
            },
            'byFleet': {
                method: 'GET',
                url: 'api/tab-objects/by-fleet/:id'
            },
            'simStatus': {method: 'PUT', url: 'api/tab-objects-sim'},
            'byQueue': {
                method: 'GET',
                url: 'api/tab-objects/by-queue',
                isArray: true
            },
            'rerunning':{
                method: 'PUT',
                url: 'api/tab-objects/rerun'
            }
        });
    }

    TabObjectsRedeployablesCounter.$inject = ['$interval', 'TabObjectsRedeploy'];

    function TabObjectsRedeployablesCounter($interval, TabObjectsRedeploy) {
        var stopCalculation = null;
        var numObjs = 2;
        var calc = function calculate() {

            stopCalculation = $interval(function () {
                TabObjectsRedeploy.numOfOnlineAndUntrackedTabObjs({}, {},
                    function (data) {
                        numObjs = data.num;
                    }, function onError(error) {
                        AlertService.error(error.data.message);
                    }
                );
            }, 5000);
        };

        return {
            start: calc,
            stop: function () {
                $interval.cancel(stopCalculation);
            },
            getNumObjs: function () {
                return numObjs;
            }
        };
    }

    TabObjectsRedeploy.$inject = ['$resource'];

    function TabObjectsRedeploy($resource) {
        var resourceUrl = 'api/tab-objects/redeploy/:id';

        return $resource(resourceUrl, {}, {
            'redeploy': {method: 'PUT'},
            'provision': {
                url: 'api/tab-objects/provision/:id',
                method: 'PUT'},
            'redeployAll': {url: 'api/tab-objects/redeploy-all/', method: 'PUT'},
            'numOfOnlineAndUntrackedTabObjs': {
                url: 'api/tab-objects/num-online-untracked-tab-objs',
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    return {'num': data};
                }
            }
        });
    }


    TabObjectsMaint.$inject = ['$resource'];

    function TabObjectsMaint($resource) {
        var resourceUrl = 'api/tab-objects/maint/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    TabObjectProperties.$inject = ['$resource'];

    function TabObjectProperties($resource) {
        var resourceUrl = 'api/tab-devices-releases-properties/:id';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryByType': {url: "api/tab-devices-releases-properties/object-type/:id", method: 'GET', isArray: true},
            'queryById': {url: "api/tab-devices-releases-properties-by-id/:id", method: 'GET'},
            'occurrence': {url: "api/tab-devices-releases-properties/occurrence", method: 'POST'},
            'elastic': {url: 'api/tab-elastic-properties/:id', method: 'GET'},
            'elasticUpdate': {url: 'api/tab-elastic-update-properties', method: 'PUT'},
            'update': {method: 'PUT', isArray: true}
        });
    }

    TabOverrideProperties.$inject = ['$resource'];

    function TabOverrideProperties($resource) {
        var resourceUrl = 'api/tab-override-properties-by-property/:id';
        return $resource(resourceUrl, {}, {
            'query': {url: 'api/tab-override-properties-by-object', method: 'GET', isArray: true}
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-objects', {
                parent: 'entity',
                url: '/tab-objects?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects.html',
                        controller: 'TabObjectsController',
                        controllerAs: 'vm'
                    }
                },
                onEnter: ['TabObjectsRedeployablesCounter', function (TabObjectsRedeployablesCounter) {
                    TabObjectsRedeployablesCounter.start();
                }],
                onExit: ['TabObjectsRedeployablesCounter', function (TabObjectsRedeployablesCounter) {
                    TabObjectsRedeployablesCounter.stop();
                }],
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {

                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    fleet: {
                        value: '-1'
                    },
                    objectType: {
                        value: '-1'
                    },
                    objectState: {
                        value: '-1'
                    },
                    toUpdate: {
                        value: '-1'
                    },
                    online: {
                        value: '-1'
                    },
                    tracked: {
                        value: '-1'
                    },
                    itemsPerPageChosen: null,
                    predicates : {}

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            search: $stateParams.search,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            objectState: $stateParams.objectState,
                            toUpdate: $stateParams.toUpdate,
                            online: $stateParams.online,
                            tracked: $stateParams.tracked
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-detail', {
                parent: 'tab-objects',
                url: '/tab-objects/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-detail.html',
                        controller: 'TabObjectsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects-new', {
                parent: 'tab-objects',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-dialog.html',
                        controller: 'TabObjectsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            objectUniqueCode: null,
                            objectCaCrt: null,
                            objectClientCrt: null,
                            objectClientKey: null,
                            objectName: null,
                            objectDescription: null,
                            objectNotes: null,
                            objectLongitude: null,
                            objectLatitude: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-objects-edit', {
                parent: 'tab-objects',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-dialog.html',
                        controller: 'TabObjectsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects.delete', {
                parent: 'tab-objects',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-delete-dialog.html',
                        controller: 'TabObjectsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.register', {
                parent: 'tab-objects',
                url: '/register',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-register-dialog.html',
                        controller: 'TabObjectsRegisterController',
                        controllerAs: 'vm',
                        size: 'md',
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.redeployment', {
                parent: 'tab-objects',
                url: '/redeploy/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'TabObjectsRedeployablesCounter', function ($stateParams, $state, $uibModal, TabObjectsRedeployablesCounter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-redeploy-dialog.html',
                        controller: 'TabObjectsRedeploymentController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entityId: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }],
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                }
            })
            .state('tab-objects.provision', {
                parent: 'tab-objects',
                url: '/provision/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-provision-dialog.html',
                        controller: 'TabObjectsProvisionController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entityId: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }],
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                }
            })
            .state('tab-objects.maintenance', {
                parent: 'tab-objects',
                url: '/{id}/maint',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-maint-dialog.html',
                        controller: 'TabObjectsMaintenanceController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects-properties', {
                parent: 'entity',
                url: '/{id}/tab-object-properties/',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-properties.html',
                        controller: 'TabObjectsPropertiesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    sort: {
                        squash: true
                    },
                    predicates : {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            predicates : $stateParams.predicates
                        }}],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.query({id: $stateParams.id, sort: $stateParams.sort});
                    }]
                }
            })
            .state('tab-objects-elastic-properties', {
                parent: 'entity',
                url: '/{id}/tab-object-elastic-properties/',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-elastic-properties.html',
                        controller: 'TabObjectsElasticPropertiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.elastic({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects-properties-history', {
                parent: 'entity',
                url: '/{id}/tab-object-properties-history/{property}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-properties-history.html',
                        controller: 'TabObjectsPropertiesHistoryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    property: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.queryById({id:$stateParams.property});
                    }]
                }
            })
            .state('tab-objects-manage-domain', {
                parent: 'tab-objects',
                url: '/{id}/manage-domain',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-manage-domain.html',
                        controller: 'TabObjectsManageDomainController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.rerunning', {
                parent: 'tab-objects',
                url: '/{id}/rerunning',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-rerunning-dialog.html',
                        controller: 'TabObjectsRerunningController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects-view-last-data', {
                parent: 'tab-objects',
                url: '/view-last-data/{id}&{name}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-view-last-data.html',
                        controller: 'TabObjectViewLastDataController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    uniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.viewLastData({id: $stateParams.id});
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsTypesPropertiesDialogController', TabObjectsTypesPropertiesDialogController);

    TabObjectsTypesPropertiesDialogController.$inject = ['$uibModalInstance','warnings'];

    function TabObjectsTypesPropertiesDialogController($uibModalInstance, warnings) {
        var vm = this;
        vm.warnings = warnings;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.go = function () {
            $uibModalInstance.close(true);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectTypesPropertiesController', TabObjectTypesPropertiesController);

    TabObjectTypesPropertiesController.$inject = ['$state', '$stateParams', '$scope', 'properties', 'occurrence', '$uibModal', 'paginationConstants', 'editableOptions', 'TabObjectProperties'];

    function TabObjectTypesPropertiesController($state, $stateParams, $scope, properties, occurrence, $uibModal, paginationConstants, editableOptions, TabObjectProperties) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.init = init;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.showOldValue = showOldValue;
        vm.openModal = openModal;
        editableOptions.theme = 'bs3';
        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.objects = $stateParams.objects;
        vm.properties = properties;
        vm.occurrence = occurrence;

        function init() {
            if (vm.objects == undefined || vm.objects == null || !vm.objects.length > 0) {
                $state.go("massive-properties");
            }
        }


        function saveReference(data) {
            editedProperty[data.id] = data;
            save();
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }

        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save() {
            if (!checkNoPendingEdit()) {
                var sendingProperties = [];
                for (var key in editedProperty) {
                    sendingProperties.push(editedProperty[key]);
                }
                vm.objects.forEach(function (id) {
                    TabObjectProperties.update({
                        properties: sendingProperties,
                        objectUniqueCode: id
                    }, onSaveSuccess);
                });
            }
        }

        function onSaveSuccess() {
            editedProperty = {};
        }


        function showOldValue(propertyName) {
            return vm.occurrence.hasOwnProperty(propertyName);
        }

        function openModal(propertyName) {
            var subScope = $scope.$new(true);
            subScope.values = vm.occurrence[propertyName];
            subScope.propertyName = propertyName;
            $uibModal.open({
                templateUrl: 'app/entities/tab-objects/tab-objectstype-properties-old-value-dialog.html',
                controller: 'TabObjectsTypesPropertiesDialogController',
                controllerAs: 'vm',
                scope: subScope,
                resolve:{
                    warnings:[function(){
                        return {};
                    }]
                }
            });
        }

        vm.init();

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabOnEventScriptsDeleteController', TabOnEventScriptsDeleteController);

    TabOnEventScriptsDeleteController.$inject = ['$uibModalInstance', 'scriptName'];

    function TabOnEventScriptsDeleteController($uibModalInstance, scriptName) {
        var vm = this;
        vm.getFileName = scriptName;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (scriptName) {
            $uibModalInstance.close(scriptName);
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabOnEventScriptsController', TabOnEventScriptsController);

    TabOnEventScriptsController.$inject = ['$scope', '$state', 'TabOnEventScripts', 'AlertService', '$uibModal'];

    function TabOnEventScriptsController($scope, $state, TabOnEventScripts, AlertService, $uibModal) {
        var vm = this;
        vm.tabOnEventScripts = [];
        vm.currentState = "tab-onEvent-scripts";
        vm.transition = transition;

        vm.loadAll = function () {

            TabOnEventScripts.query(onSuccess, onError);

            function onSuccess(data) {
                vm.tabOnEventScripts = [];
                vm.tabOnEventScripts = data;
                vm.transition();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
            }, {notify: notify, location: "replace"});
        }

        vm.openDeleteDialog = function(name) {
            $uibModal.open({
                templateUrl: 'app/entities/tab-onEvent-scripts/tab-onEvent-scripts-delete-dialog.html',
                controller: 'TabOnEventScriptsDeleteController',
                controllerAs: 'vm',
                resolve: {
                    scriptName: function(){
                        return name;
                    }
                }
            }).result.then(function (scriptName) {
                TabOnEventScripts.delete({scriptName: scriptName},
                    function () {
                        vm.loadAll();
                    });
            }, function () {
            });
        };

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabOnEventScripts', TabOnEventScripts);

    TabOnEventScripts.$inject = ['$resource'];

    function TabOnEventScripts ($resource) {
        var resourceUrl = 'api/tab-onEvent-scripts/';

        return $resource(resourceUrl, {}, {
            'query': {method : 'GET', isArray : true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'delete':{
                method: 'DELETE',
                url: 'api/tab-onEvent-scripts/delete'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-onEvent-scripts', {
                parent: 'update_management',
                url: '/tab-onEvent-scripts',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.entities.tabOnEventScripts'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-onEvent-scripts/tab-onEvent-scripts.html',
                        controller: 'TabOnEventScriptsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabOnEventScripts');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDeleteController',TabPropertiesDeleteController);

    TabPropertiesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabProperties'];

    function TabPropertiesDeleteController($uibModalInstance, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabProperties.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDetailController', TabPropertiesDetailController);

    TabPropertiesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabProperties'];

    function TabPropertiesDetailController($scope, $rootScope, $stateParams, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabPropertiesUpdate', function(event, result) {
            vm.tabProperties = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDialogController', TabPropertiesDialogController);

    TabPropertiesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TabProperties'];

    function TabPropertiesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabPropertiesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabProperties.id !== null) {
                TabProperties.update(vm.tabProperties, onSaveSuccess, onSaveError);
            } else {
                TabProperties.save(vm.tabProperties, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesController', TabPropertiesController);

    TabPropertiesController.$inject = ['$scope', '$state', 'TabProperties', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabPropertiesController ($scope, $state, TabProperties, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-properties";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        vm.loadAll();
        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll () {
            TabProperties.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabProperties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.currentSearch
            }, {location: "replace"});
        }

    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabProperties', TabProperties);

    TabProperties.$inject = ['$resource'];

    function TabProperties ($resource) {
        var resourceUrl =  'api/tab-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-properties', {
            parent: 'entity',
            url: '/tab-properties?page&sort&search',
            data: {
                authorities: ['ROLE_PROPERTY'],
                pageTitle: 'jotApp.tabProperties.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-properties/tab-properties.html',
                    controller: 'TabPropertiesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                predicates : {}
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabProperties');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-properties-detail', {
            parent: 'entity',
            url: '/tab-properties/{id}',
            data: {
                authorities: ['ROLE_PROPERTY'],
                pageTitle: 'jotApp.tabProperties.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-properties/tab-properties-detail.html',
                    controller: 'TabPropertiesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabProperties');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabProperties', function($stateParams, TabProperties) {
                    return TabProperties.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-properties.new', {
            parent: 'tab-properties',
            url: '/new',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-dialog.html',
                    controller: 'TabPropertiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                propertyDescription: null,
                                properyValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('tab-properties');
                });
            }]
        })
        .state('tab-properties.edit', {
            parent: 'tab-properties',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-dialog.html',
                    controller: 'TabPropertiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TabProperties', function(TabProperties) {
                            return TabProperties.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tab-properties.delete', {
            parent: 'tab-properties',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-delete-dialog.html',
                    controller: 'TabPropertiesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabProperties', function(TabProperties) {
                            return TabProperties.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabScheduleStatus', TabScheduleStatus);

    TabScheduleStatus.$inject = ['$resource'];

    function TabScheduleStatus ($resource) {
        var resourceUrl =  'api/tab-schedule-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleDeleteController',TabScheduleDeleteController);

    TabScheduleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabSchedule'];

    function TabScheduleDeleteController($uibModalInstance, entity, TabSchedule) {
        var vm = this;
        vm.tabSchedule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabSchedule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleDetailController', TabScheduleDetailController);

    TabScheduleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function TabScheduleDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.tabSchedule = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabScheduleUpdate', function(event, result) {
            vm.tabSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleController', TabScheduleController);

    TabScheduleController.$inject = ['$state', 'TabSchedule', 'ParseLinks', 'AlertService', 'pagingParams', '$scope', '$filter', 'paginationConstants'];

    function TabScheduleController($state, TabSchedule, ParseLinks, AlertService, pagingParams, $scope, $filter, paginationConstants) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = {scheduleDatetime: false};
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.currentState = "tab-schedule";
        vm.currentStateFilter = "tab-schedule-filter";
        vm.fleet = pagingParams.fleet;
        vm.objectType = pagingParams.objectType;
        vm.from = pagingParams.from;
        vm.to = pagingParams.to;
        vm.status = pagingParams.status;
        vm.tag = pagingParams.tag;
        vm.searchText = pagingParams.ch;
        vm.firstAccess = pagingParams.firstAccess;
        vm.applyFilter = applyFilter;
        vm.picker = {
            start: false,
            end: false
        };

        var filter = localStorage.getItem(vm.currentStateFilter);
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.fleet = filter.fleet;
                vm.objectType = filter.objectType;
                vm.from = filter.from;
                vm.to = filter.to;
                vm.status = filter.status;
            }
        }

        if (vm.firstAccess == true) {
            localStorage.setItem("first-access", JSON.stringify({firstAccess: false}));
        } else {
            localStorage.setItem("first-access", JSON.stringify({firstAccess: true}));
        }

        Chart.plugins.register({
            beforeRender: function (chart) {
                if (chart.config.options.showAllTooltips) {
                    // create an array of tooltips
                    // we can't use the chart tooltip because there is only one tooltip per chart
                    chart.pluginTooltips = [];
                    chart.config.data.datasets.forEach(function (dataset, i) {
                        chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                            chart.pluginTooltips.push(new Chart.Tooltip({
                                _chart: chart.chart,
                                _chartInstance: chart,
                                _data: chart.data,
                                _options: chart.options.tooltips,
                                _active: [sector]
                            }, chart));
                        });
                    });
                    // turn off normal tooltips
                    chart.options.tooltips.enabled = false;
                }
            },
            afterDraw: function (chart, easing) {
                if (chart.config.options.showAllTooltips) {
                    // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
                    if (!chart.allTooltipsOnce) {
                        if (easing !== 1)
                            return;
                        chart.allTooltipsOnce = true;
                    }
                    chart.getDatasetMeta(0).data.forEach(function (data) {
                        for (var i = 0; i < data._chart.config.data.datasets[0].data.length; ++i) {
                            chart.getDatasetMeta(0).data[i].hidden = data._chart.config.data.datasets[0].data[i] === 0;
                        }
                    });
                    // turn on tooltips
                    chart.options.tooltips.enabled = true;
                    Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                        // This line checks if the item is visible to display the tooltip
                        if(!tooltip._active[0].hidden){
                            tooltip.initialize();
                            tooltip.update();
                            tooltip.transition(easing).draw();
                        }
                    });
                    chart.options.tooltips.enabled = false;
                }
                chart.update();
            }
        });

        $scope.options = {
            legend: {display: true, position: 'right'},
            title: {display: true, fontSize: 12, text: "Updates Schedules Status", position: "left"},
            showAllTooltips: true,
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    }
                }
            }
        };

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                ch: vm.searchText
            };
            addFilter(page);
            TabSchedule.query(page,  onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabSchedules = data;
                vm.page = pagingParams.page;
                // transition();
                $scope.dataSchedules = [];
                $scope.labelsSchedules = [];
                $scope.colorsSchedules = [];
                vm.done = [];
                vm.error = [];
                vm.duplicated = [];
                vm.other = [];
                data.forEach( function (d) {
                    if (d.scheduleStatus.scheduleStatusName === "done")
                        vm.done.push(d);
                    else if (d.scheduleStatus.scheduleStatusName === "error")
                        vm.error.push(d);
                    else if (d.scheduleStatus.scheduleStatusName === "duplicated")
                        vm.duplicated.push(d);
                    else vm.other.push(d);
                });

                $scope.dataSchedules.push(vm.done.length);
                $scope.labelsSchedules.push("done");
                $scope.colorsSchedules.push('#26C281');

                $scope.dataSchedules.push(vm.error.length);
                $scope.labelsSchedules.push("error");
                $scope.colorsSchedules.push('#E43A45');

                $scope.dataSchedules.push(vm.duplicated.length);
                $scope.labelsSchedules.push("duplicated");
                $scope.colorsSchedules.push('#F3C200');

                $scope.dataSchedules.push(vm.other.length);
                $scope.labelsSchedules.push("other");
                $scope.colorsSchedules.push('#C3C3C3');

                vm.emptyData = $scope.dataSchedules.filter(function (value) {
                    return value > 0;
                });

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            localStorage.setItem("save-filter", JSON.stringify({from: vm.from, to: vm.to,fleet: vm.fleet,objectType: vm.objectType, status: vm.status, tag: vm.tag }));
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                search: vm.charToSearch,
                fleet: vm.fleet,
                objectType: vm.objectType,
                from: vm.from,
                to: vm.to,
                status: vm.status,
                tag: vm.tag,
                ch: vm.searchText,
                firstAccess: false
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function applyFilter(fleet, objectType, from, to, status, tag) {
            var filter = {};
            filter.fleet = vm.fleet = fleet;
            filter.objectType = vm.objectType = objectType;
            filter.from = vm.from = from;
            filter.to = vm.to = to;
            filter.status = vm.status = status;
            filter.tag = vm.tag = tag;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        var dateFormat = 'yyyy-MM-dd HH:mm';
        function addFilter(body) {
            if (+vm.fleet.id !== -1)
                body.fleetId = vm.fleet.id;
            if (+vm.objectType.id !== -1)
                body.objectTypeId = vm.objectType.id;
            if (vm.from !== null)
                body.from = $filter('date')(vm.from, dateFormat);
            if (vm.to !== null)
                body.to = $filter('date')(vm.to, dateFormat);
            if (+vm.status.id !== -1)
                body.statusId = vm.status.id;
            if (vm.tag !== null) {
                body.tag = vm.tag;
            }

        }

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabSchedule', TabSchedule);

    TabSchedule.$inject = ['$resource', 'DateUtils'];

    function TabSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/tab-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': { url: 'api/tab-schedules/search', method: 'POST', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-schedule', {
            parent: 'update_management',
            url: '/tab-schedule?page&sort&search',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabSchedule.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-schedule/tab-schedules.html',
                    controller: 'TabScheduleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: [],
                    squash:true
                },
                itemsPerPageChosen: null,
                ch: {
                    value: '',
                    squash: true
                },
                firstAccess: {
                    value: true
                },
                predicates : {},
                fleet: {
                    value: '-1'
                },
                objectType: {
                    value: '-1'
                },
                status: {
                    value: '-1'
                },
                from: {
                    value: (function previousYear() {
                        return new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
                    }),
                    squash: true
                },
                to: {
                    value: (function today(){
                        return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                    }),
                    squash: true
                },
                tag : {
                    value: null
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        ch: $stateParams.ch,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        status: $stateParams.status,
                        tag: $stateParams.tag,
                        firstAccess: $stateParams.firstAccess
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabSchedule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-schedule-detail', {
            parent: 'tab-schedule',
            url: '/tab-schedule/{id}',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabSchedule.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-schedule/tab-schedule-detail.html',
                    controller: 'TabScheduleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabSchedule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabSchedule', function($stateParams, TabSchedule) {
                    return TabSchedule.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-schedule.delete', {
            parent: 'tab-schedule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DOMAIN_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-schedule/tab-schedule-delete-dialog.html',
                    controller: 'TabScheduleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabSchedule', function(TabSchedule) {
                            return TabSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDeleteController', TabUpdateScriptsDeleteController);

    TabUpdateScriptsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabUpdateScripts'];

    function TabUpdateScriptsDeleteController($uibModalInstance, entity, TabUpdateScripts) {
        var vm = this;
        vm.tabUpdateScripts = entity;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            TabUpdateScripts.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDetailController', TabUpdateScriptsDetailController);

    TabUpdateScriptsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabUpdateScripts', 'DataUtils'];

    function TabUpdateScriptsDetailController($scope, $rootScope, $stateParams, entity, TabUpdateScripts, DataUtils) {
        var vm = this;
        vm.tabUpdateScripts = entity;

        var unsubscribe = $rootScope.$on('jotApp.tabUpdateScriptsUpdate', function (event, result) {
            vm.tabUpdateScripts = result;
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDialogController', TabUpdateScriptsDialogController);

    TabUpdateScriptsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabUpdateScripts', 'DataUtils', 'TabObjectTypes', '$state','ParseLinks', 'AlertService'];

    function TabUpdateScriptsDialogController($timeout, $scope, $stateParams, $q, entity, TabUpdateScripts, DataUtils, TabObjectTypes, $state,ParseLinks, AlertService) {
        var vm = this;
        vm.tabUpdateScripts = entity;
        vm.tabObjectTypes = [];
        vm.page = 0;
        vm.typeToSearch= '';

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabUpdateScripts', result);
            vm.isSaving = false;
            $state.go('tab-update-scripts');
        };

        var onSaveError = function (result) {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabUpdateScripts.id !== null) {
                TabUpdateScripts.update(vm.tabUpdateScripts, onSaveSuccess, onSaveError);
            } else {
                TabUpdateScripts.save(vm.tabUpdateScripts, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-update-scripts');
        };

        vm.setScriptContent = function ($file, tabUpdateScripts) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabUpdateScripts.scriptContent = base64Data;
                    });
                });
            }
        };

        vm.search = function(searchText){
            if(vm.typeToSearch != undefined && vm.typeToSearch != ""){
                vm.typeToSearch = searchText;
                vm.loadAll();
            }
        }

        vm.loadAll = function () {
            TabObjectTypes.query({
                page: vm.page,
                query: vm.typeToSearch,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsController', TabUpdateScriptsController);

    TabUpdateScriptsController.$inject = ['$scope', '$state', 'TabUpdateScripts', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'TabObjectTypes', 'paginationConstants'];

    function TabUpdateScriptsController($scope, $state, TabUpdateScripts, ParseLinks, AlertService, DataUtils, pagingParams, TabObjectTypes, paginationConstants) {
        var vm = this;
        vm.tabUpdateScripts = [];
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.loadFilter = loadFilter;
        vm.currentState = "tab-update-scripts";
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        vm.loadFilter();

        //Aggiunta per impaginazione
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadFilter() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            function onError() {}
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch,
                objectType: vm.objectType.id == -1 ? null : vm.objectType.id
            };

            TabUpdateScripts.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabUpdateScripts = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.tabUpdateScripts = data;
                if (vm.page == 0 && (vm.page < vm.links['last']))
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabUpdateScripts = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabUpdateScripts', TabUpdateScripts);

    TabUpdateScripts.$inject = ['$resource'];

    function TabUpdateScripts ($resource) {
        var resourceUrl = 'api/tab-update-scripts/:id';

        return $resource(resourceUrl, {}, {
            'query': {method : 'GET', isArray : true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-update-scripts', {
                parent: 'update_management',
                url: '/tab-update-scripts?search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts.html',
                        controller: 'TabUpdateScriptsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            objectType: $stateParams.objectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-update-scripts-detail', {
                parent: 'tab-update-scripts',
                url: '/tab-update-scripts/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-detail.html',
                        controller: 'TabUpdateScriptsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabUpdateScripts', function ($stateParams, TabUpdateScripts) {
                        return TabUpdateScripts.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-update-scripts-new', {
                parent: 'tab-update-scripts',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-dialog.html',
                        controller: 'TabUpdateScriptsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    transaltePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            scriptName: null,
                            scriptDescription: null,
                            scriptContent: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-update-scripts-edit', {
                parent: 'tab-update-scripts',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-dialog.html',
                        controller: 'TabUpdateScriptsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabUpdateScripts', function ($stateParams, TabUpdateScripts) {
                        return TabUpdateScripts.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-update-scripts.delete', {
                parent: 'tab-update-scripts',
                url: '{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-delete-dialog.html',
                        controller: 'TabUpdateScriptsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabUpdateScripts', function (TabUpdateScripts) {
                                return TabUpdateScripts.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-update-scripts', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScheduleObjectTestController', ScheduleObjectTestController);

    ScheduleObjectTestController.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity'];

    function ScheduleObjectTestController($state, $uibModalInstance, AlertService, $timeout, entity) {
        var vm = this;

        vm.scheduleDate = entity;
        vm.testScheduleName = vm.scheduleDate.scheduleName;
        if(!entity.single)
            vm.multipleSchedule = entity.selectedDay;

        vm.afterLaunch = entity.afterLaunch;

        vm.multipleSchedule = [
            {day: "MON"},
            {day: "TUE"},
            {day: "WED"},
            {day: "THU"},
            {day: "FRI"},
            {day: "SAT"},
            {day: "SUN"}
        ];

        vm.repeatStatus = [false, false, false, false, false, false, false];

        vm.checkEmptyWeeklyForm = function () {
            var isEmpty = true;
            angular.forEach(vm.multipleSchedule, function(check){
                if(check.selectedTime){
                    isEmpty = false;
                }
            })
            return isEmpty;
        }

        vm.openTimeCal = function(index) {
            $timeout(function() {
                vm.repeatStatus[index] = true;
            });
        };

        vm.datepickerOptions = {
            minDate: null
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            vm.scheduleDate.testName = vm.testName;
            if(!vm.scheduleDate.single) {
                vm.scheduleDate.selectedDay = vm.multipleSchedule;
                checkAtLeastOneValue();
            }
            $uibModalInstance.close(vm.scheduleDate);
        };

        function checkAtLeastOneValue() {
            var res = false;
            angular.forEach(vm.scheduleDate.selectedDay, function(check) {
                if(check.selectedTime != null) {
                    res = true;
                }
            });
            if(!res)
                vm.scheduleDate.selectedDay = undefined;
        }

        vm.check = function (check) {
            vm.scheduleDate = {};
            vm.scheduleDate.single = check;
            if(!vm.scheduleDate.single) {
                vm.multipleSchedule = [
                    {day: "MON"},
                    {day: "TUE"},
                    {day: "WED"},
                    {day: "THU"},
                    {day: "FRI"},
                    {day: "SAT"},
                    {day: "SUN"}
                ];
                vm.datepickerOptions = {
                    minDate: null
                };
            } else {
                vm.multipleSchedule = [];
                vm.datepickerOptions = {
                    minDate: new Date()
                };
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDeleteController',TestScheduleDeleteController);

    TestScheduleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TestSchedule'];

    function TestScheduleDeleteController($uibModalInstance, entity, TestSchedule) {
        var vm = this;

        vm.testSchedule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TestSchedule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDetailController', TestScheduleDetailController);

    TestScheduleDetailController.$inject = ['$scope', '$rootScope', 'entity', 'DataUtils'];

    function TestScheduleDetailController($scope, $rootScope, entity, DataUtils) {
        var vm = this;
        vm.testSchedule = entity;

        var unsubscribe = $rootScope.$on('jotApp:testScheduleUpdate', function (event, result) {
            vm.testSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDialogNextController', TestScheduleDialogNextController);

    TestScheduleDialogNextController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'TabObjects', '$timeout', 'name', 'fleet', 'objType', 'tests', 'objects', 'testSchedule', '$uibModal', '$filter', 'TestSchedule', 'include'];

    function TestScheduleDialogNextController($scope, $state, ParseLinks, AlertService, TabObjects, $timeout, name, fleet, objType, tests, objects, testSchedule, $uibModal, $filter, TestSchedule,include) {
        var vm = this;

        vm.testSchedule = testSchedule;
        vm.fleet = fleet;
        vm.objType = objType;
        vm.tests = tests;
        vm.tabObjects = objects;
        vm.scheduleName = name;
        vm.isActive = include;
        vm.loadAll = loadAll;

        function loadAll() {
            if (!(fleet && objType && tests && objects)) {
                $state.transitionTo('test-schedule', {});
            }
            if(vm.testSchedule != null) {
                checkSelectedObjects(vm.testSchedule.objects);
            }
            function checkSelectedObjects(selectedObjects) {
                vm.tabObjects.forEach(function (object) {
                    object.check = false;
                    selectedObjects.forEach(function (selectedObject) {
                        if (object.id === selectedObject.id)
                            object.check = true;
                    });
                });
                vm.tabObjects.sort((a,b) => b.check - a.check);
            }
        }

        vm.checkAll = function () {
            vm.tabObjects.forEach(function (object) {
                object.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.tabObjects.forEach(function (object) {
                allChecked = object.check && allChecked;
                notChecked = !object.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneObject = function () {
            var isChecked = false;
            vm.tabObjects.forEach(function (object) {
                isChecked = isChecked || object.check
            });
            return isChecked;
        }

        function selectedObjects() {
            var selectedObjects = [];
            vm.tabObjects.forEach(function (object) {
                if(object.check)
                    selectedObjects.push(object);
            });
            return selectedObjects;
        }

        loadAll();

        vm.back = function () {
            if(vm.testSchedule == null) {
                $state.transitionTo('test-schedule.new', {
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    objType: vm.objType,
                    tests: vm.tests,
                    include: vm.isActive
                }, {location: "replace"});
            }
            else {
                $state.transitionTo('test-schedule.edit', {
                    id: vm.testSchedule.id,
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    objType: vm.objType,
                    tests: vm.tests,
                    include: vm.isActive
                }, {location: "replace"});
            }
        }

        vm.scheduleTest = function () {
            if (vm.showSchedule === undefined)
                vm.response = {
                    single: false,
                    afterLaunch: false,
                    scheduleName: vm.scheduleName
                };
            $uibModal.open({
                templateUrl: 'app/entities/test-schedule/schedule-object-test.html',
                controller: 'ScheduleObjectTestController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if (result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    vm.tabScheduleTest = {};
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.saveScheduleTest();
                } else
                    vm.showSchedule = undefined;
            })
        };

        function setData() {
            vm.tabScheduleTest.scheduleDateTime = vm.response.scheduleDateTime;
            vm.repeatNumber = vm.response.repeatNumber;
            convertDate();
        }

        function convertDate(){
            if(vm.repeatNumber) {
                var dateFormat = 'dd/MM/yyyy';
                var date = $filter('date')(new Date(vm.tabScheduleTest.scheduleDateTime), dateFormat);
                vm.showSchedule = "SCHEDULED: " + date + "\n" + " REPEAT EVERY " + vm.repeatNumber  + " " + "DAYS";
            } else {
                AlertService.error("Fill Repetition field");
                vm.showSchedule = undefined;
            }
        }

        function setMultipleData() {
            vm.tabScheduleTest.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.selectedTime) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");
            vm.tabScheduleTest.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));

            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        vm.saveScheduleTest = function () {
            vm.isSaving = true;
            vm.tabScheduleTest.name = vm.scheduleName;
            vm.tabScheduleTest.single = vm.response.single;
            if(vm.tabScheduleTest.single && vm.repeatNumber){
                vm.tabScheduleTest.cronExpression = vm.repeatNumber;
            }
            vm.tabScheduleTest.multipleSchedule = true; //it's a multiple object schedule
            vm.tabScheduleTest.testSettings = vm.tests;
            vm.tabScheduleTest.tabObjects = selectedObjects();
            vm.tabScheduleTest.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            vm.tabScheduleTest.includeOffline = vm.isActive;

            TestSchedule.create(vm.tabScheduleTest, onSuccess, onError);
        };

        function onSuccess() {
            $state.transitionTo('test-schedule', {}, {notify: true, location: "replace", reload: true});
        }

        function onError(error) {}

        vm.update = function () {
            TestSchedule.update({
                id: vm.testSchedule.id,
                name: vm.scheduleName,
                tests: vm.tests,
                includeOffline : vm.isActive,
                objects: selectedObjects()
            }, onSuccess, onError);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleDialogController', TestScheduleDialogController);

    TestScheduleDialogController.$inject = ['$scope', '$state', 'ObjectTestResult', 'ParseLinks', 'AlertService', 'TabObjects', '$timeout', 'name', 'tabFleets', 'fleet', 'objType', 'tests', 'TabObjectTypes', 'ObjectTestSetting', 'testSchedule'];

    function TestScheduleDialogController($scope, $state, ObjectTestResult, ParseLinks, AlertService, TabObjects, $timeout, name, tabFleets, fleet, objType, tests, TabObjectTypes, ObjectTestSetting, testSchedule) {
        var vm = this;

        vm.testSchedule = testSchedule;
        vm.tabFleets = tabFleets;
        vm.tabObjectTypes = [];
        vm.tests = [];
        vm.selection = {fleet: -1, objectType: -1};

        vm.loadAll = function () {
            if(vm.testSchedule == null) { //create schedule
                if(fleet && objType && tests && name) { // se sono tornato indietro dalla pagina dialog-next
                    vm.selectedTests = tests;
                    vm.fleet = fleet;
                    vm.objType = objType;
                    vm.scheduleName = name;
                    vm.selection = {fleet: fleet.id, objectType: objType.id};
                    loadTests();
                    TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
                }
            }
            else { //edit schedule
                vm.selectedTests = tests ? tests : testSchedule.tests; //Se faccio back in fase di edit, mi prendo i tests dello stateparams altrimenti prendo quelli della schedulazione
                vm.scheduleName = name ? name : testSchedule.name;
                vm.fleet = testSchedule.tests[0].tabFleets; //tutti i test associati alla schedule hanno stessa flotta e type, quindi prendo il primo test.
                vm.objType = testSchedule.tests[0].tabObjectTypes;
                loadTests();
            }
            function onSuccess(data) {
                vm.tabObjectTypes = data;
            }
        }

        function loadTests() {
                if (vm.fleet && vm.objType) {
                    ObjectTestSetting.notManualTests({
                        objectTypeId: vm.objType.id,
                        fleetId: vm.fleet.id,
                    }, onSuccess, onError);
                }
                //tirare su i test associati alla schedule passsando l'id schedule (il parametro tests li dovrà avere)
                //tirare su i test associabili (avrò flotta e objType grazie ai test associati)

            function onSuccess(data) {
                vm.tests = data;
                if(vm.selectedTests) { //se ho fatto una back dalla pagina dialog-next o se sto facendo una edit, mi porto i test che avevo selezionato prima e setto check a true;
                    checkSelectedTests(vm.selectedTests);
                }

                function checkSelectedTests(selectedTests) {
                    vm.tests.forEach(function (test) {
                        test.check = false;
                        selectedTests.forEach(function (selectedTest) {
                            if (test.id === selectedTest.id)
                                test.check = true;
                        });
                    });
                    vm.tests.sort((a,b) => b.check - a.check);
                }
            }
        }


        /* selezionata la flotta popolo la select degli object type */
        vm.selectedFleet = function (fleet) {
            if (vm.selection.fleet.id !== fleet.id) {
                vm.selection.fleet = fleet.id;
                vm.fleet = fleet;
                vm.objType = null;
                TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
            }

            function onSuccess(data) {
                vm.tabObjectTypes = [];
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
                if(data.length === 1) {
                    vm.selectedObjectType(vm.tabObjectTypes[0]);
                }
            }
        };

        vm.selectedObjectType = function (objType) {
            if (vm.selection.objectType !== objType.id) {
                vm.selection.objectType = objType.id;
                vm.objType = objType;
                loadTests();
            }

        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.checkAll = function (b) {
            vm.tests.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.tests.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.tests.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        vm.loadAll();

        vm.next = function () {
            var selectedTests = [];
            vm.tests.forEach(function (test) {
                if(test.check)
                    selectedTests.push(test);
            });
            if(vm.testSchedule == null) {
                $state.go('test-schedule.new-next', {
                    name: vm.scheduleName,
                    fleet: vm.fleet,
                    include: vm.isActive,
                    objType: vm.objType,
                    tests: selectedTests
                }, {location: "replace"});
            }
            else {
                $state.transitionTo('test-schedule.edit-next', {
                    id: vm.testSchedule.id,
                    name: vm.scheduleName,
                    testSchedule: vm.testSchedule,
                    fleet: vm.fleet,
                    include: vm.isActive,
                    objType: vm.objType,
                    tests: selectedTests
                }, {location: "replace"});
            }
        }
    }
})();
;
(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('TestScheduleFailedTestsController', TestScheduleFailedTestsController);

        TestScheduleFailedTestsController.$inject = ['$stateParams', '$state', 'pagingParams', 'paginationConstants', 'entity', 'testSchedule'];

        function TestScheduleFailedTestsController($stateParams, $state, pagingParams, paginationConstants, entity, testSchedule) {
            var vm = this;
            vm.testSchedule = testSchedule;
            vm.scheduleResults = entity;
            vm.tabObjectsToExport = [];
            vm.exportTable = exportTable;
            vm.loadAllToExport = loadAllToExport;
            function loadAllToExport() {
                var page = {
                    page: 0,
                    size: 2000,
                    sort: sort(),
                    /*search: vm.charToSearch*/
                };
                var dataExport = {
                    /*ch: vm.charToSearch,*/
                    filter: pagingParams.filter
                };

                function onSuccessExport(data, headers) {
                    vm.totalItemsExport = headers('X-Total-Count');
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjectsToExport.push(data[i]);
                    }
                    if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                        page.page = page.page + 1;
                        WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                    } else {
                        vm.filter.warningGetAll = null;
                    }
                }

                function onErrorExport(error) {
                    AlertService.error(error.data.message);
                    reject();
                }

                if (vm.tabObjectsToExport.length < 1) {
                    vm.filter.warningGetAll = "all";
                    WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                }
            }
            function exportTable(type) {
                if (type == 'pdf') {
                    $('#tableToExport').tableExport({
                        type: 'pdf',
                        pdfFontSize: '7',
                        escape: 'false',
                        ignoreColumn: [0,4],
                        size: {1: 100, 2: 400, 3: 120},
                        tableName: vm.testSchedule.name
                    });
                } else if (type != null) {
                    $('#tableToExport').tableExport({ignoreColumn: [0,4],type: type, escape: 'false', tableName: vm.testSchedule.name});
                }
            }
            vm.downloadPdf = function (detailed) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = "api/result-pdf/pdf/" + vm.testSchedule.id + "/" + detailed;
                a.setAttribute("target", "_blank");
                a.download = name[name.length - 1];
                a.click();
            };
            vm.downloadCsv = function (detailed) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = "api/result-csv/csv/" + vm.testSchedule.id + "/" + detailed;
                a.setAttribute("target", "_blank");
                a.download = name[name.length - 1];
                a.click();
            };
        }
    }
)
();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleResumeController',TestScheduleResumeController);

    TestScheduleResumeController.$inject = ['$uibModalInstance', 'entity', 'TestSchedule'];

    function TestScheduleResumeController($uibModalInstance, entity, TestSchedule) {
        var vm = this;

        vm.testSchedule = entity;
        vm.clear = clear;
        vm.confirmResume = confirmResume;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmResume (id) {
            TestSchedule.manage(vm.testSchedule, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleController', TestScheduleController);

        TestScheduleController.$inject = ['$timeout', '$scope', '$state', 'pagingParams', 'TabFleets', 'TabObjectTypes', 'paginationConstants', 'ParseLinks',
            'AlertService', 'TabActions', 'TestSchedule', 'ListObjByObjTypeAndFleet'];

        function TestScheduleController($timeout, $scope, $state, pagingParams, TabFleets, TabObjectTypes, paginationConstants, ParseLinks,
                                                AlertService, TabActions, TestSchedule, ListObjByObjTypeAndFleet) {
            var vm = this;
            vm.loadPage = loadPage;
            vm.transition = transition;
            vm.changePageSize = changePageSize;
            vm.loadTestSchedule = loadTestSchedule;
            vm.tabFleets = [];
            vm.tabObjectTypes = [];
            vm.tabObjects = [];

            vm.objPage = 0;
            vm.now = null;
            var data = new Date();
            var hours = data.getHours();
            vm.now = hours;
            vm.datelastexcution = false;

            vm.predicates = {};

            vm.currentState = "test-schedule";
            var retrievedOrder = localStorage.getItem(vm.currentState);
            if (retrievedOrder != null && retrievedOrder != "null")
                vm.predicates = JSON.parse(retrievedOrder);

            vm.selection = {fleet: -1, objectType: -1};
            vm.objParsed = 0;
            vm.testSchedule = [];

            vm.table = [];
            vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
            vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

            var allFleet = {id: -1, fleetName: "All"};
            var allObjectType = {id: -1, objectTypeName: "All"};
            vm.tabObjectTypes.push(allObjectType);

            function loadAll() {
                vm.fleet = allFleet;
                vm.objType = allObjectType;
                vm.objects = [];
                vm.page = pagingParams.page;
                loadTestSchedule();
                TabFleets.query({}, onTabFleetsSuccess, onError);
            }

            function onTabFleetsSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                if(data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        vm.tabFleets.push(data[i]);
                    }
                    if(data.length > 1){
                        vm.tabFleets.unshift(allFleet);
                    }
                    vm.fleet = vm.tabFleets[0];
                }
            }

            /* selezionata la flotta popolo la select degli object type */
            vm.selectedFleet = function (fleet) {
                if (vm.selection.fleet !== fleet.id) {
                    vm.selection.fleet = fleet.id;
                    vm.forms = [];
                    vm.currentPage = 1;
                    TabObjectTypes.byFleet({id: fleet.id}, onSuccess, onError);
                }

                function onSuccess(data) {
                    vm.fleet = fleet;
                    vm.tabObjectTypes = [];
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjectTypes.push(data[i]);
                    }
                    if(data.length !== 1){
                        vm.tabObjectTypes.unshift(allObjectType);
                    }
                    vm.objType = vm.tabObjectTypes[0];
                    vm.objects = [];
                    //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                    transition(false);
                }
            };

            vm.selectedObjectType = function (objType) {
                if (vm.selection.objectType !== objType.id) {
                    vm.selection.objectType = objType.id;
                    vm.objType = objType;
                    vm.objects = [];
                    vm.pagesChecked = [];
                    vm.checkNextPages = false;
                    vm.forms = [];
                    vm.currentPage = 1;
                }

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            loadAll();

            vm.manageSchedule = function (testSchedule) {
                TestSchedule.manage(testSchedule, onSuccess, onError);
                function onSuccess(data) {
                    loadTestSchedule();
                }
            }
            vm.runSchedule = function (testSchedule) {
                TestSchedule.runSchedule(testSchedule, onSuccess, onError);
                function onSuccess(data) {
                    loadTestSchedule();
                }
            }


            function onTestScheduleSuccess(data, headers) {
                vm.testSchedule = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                transition(false);
            }

            function transition(recall) {
                //eseguo la chiamata in base alle opzioni già selezionate
                if (recall) {
                    loadTestSchedule();
                }
                $state.transitionTo($state.$current, {
                    page: vm.currentPage,
                    predicates: vm.predicates,
                    sort: sort(),
                    search: vm.charToSearch,
                    itemsPerPageChosen: vm.itemsPerPageChosen
                }, {notify: false, reload: false, location: "replace"});
            }

            function sort() {
                var sortFields = [];
                var keys = Object.keys(vm.predicates);
                for (var key in keys) {
                    var predicate = keys[key];
                    sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
                return sortFields.length === 0 ? ['createdDate,desc'] : sortFields;
            }

            function loadPage (page) {
                vm.page = page;
                vm.transition();
            }

            function changePageSize() {
                if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                    vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
                vm.forms = [];
                transition(true);
            }

            function loadTestSchedule() {
                var query = {
                    query: vm.charToSearch,
                    page: vm.page -1,
                    size: vm.itemsPerPageChosen,
                    sort: sort()};

                if (vm.objects.length === 0) {
                    if (vm.fleet.id === -1 && vm.objType.id === -1) {
                        TestSchedule.query(query, onTestScheduleSuccess, onError);
                    } else {
                        query.typeId = vm.objType.id;
                        query.fleetId = vm.fleet.id;
                        TestSchedule.byObjTypeAndFleet(query, onTestScheduleSuccess, onError);
                    }
                } else {
                    TestSchedule.byObjects(query, vm.objects, onTestScheduleSuccess, onError);
                }
            }



            vm.loadObjSelect = function (objPage) {
                if (objPage < vm.linksObj['last'] || objPage === vm.linksObj['next']) {
                    vm.objPage = objPage;
                    vm.loadObjects();
                }
            }

            vm.loadObjects = function () {
                ListObjByObjTypeAndFleet.query({
                    typeId: vm.objType.id,
                    fleetId: vm.fleet.id,
                    page: vm.objPage,
                    size: 20,
                    query: vm.charToSearch
                }, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.linksObj = ParseLinks.parse(headers('link'));
                    vm.totalItemsObj = headers('X-Total-Count');
                    for (var i = 0; i < data.length; i++) {
                        vm.tabObjects.push(data[i]);
                    }
                }
            };

            vm.selectSearch = function (searchText) {
                vm.charToSearch = searchText;
                vm.objPage = 0;
                vm.tabObjects = [];
                vm.loadObjects();
            };

            vm.search = function () {
                pagingParams.page = 1;
                loadTestSchedule();
            }
            vm.changevisibilty = function (testSchedule){
                var currDate = new Date();
                var lastexecdate = new Date(testSchedule.lastExecution)
                var millisecondscurr = currDate.getTime();
                var millisecondlastexec = lastexecdate.getTime();
                if(Math.abs(millisecondscurr - millisecondlastexec) >= 3600000){
                    vm.datelastexcution = true;
                }
                else{
                    vm.datelastexcution = false;
                }
            }


        }
    }
)
();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TestSchedule', TestSchedule);

    TestSchedule.$inject = ['$resource', 'DateUtils'];

    function TestSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/test-schedule/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byObjTypeAndFleet': {url:"api/test-schedule/by-obj-type/:typeId/fleet/:fleetId", method: 'GET', isArray: true},
            'byObjects': {url:"api/test-schedule/by-objects", method: 'POST', isArray: true},
            'create': {method:'POST'},
            'update': {method: 'PUT'},
            'manage': {method: 'PUT', url:"api/test-schedule/manage-schedule"},
            'runSchedule': {method: 'PUT', url:"api/test-schedule/run-schedule"},
            'delete': {method: 'DELETE'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('test-schedule', {
                parent: 'testing',
                url: '/test-schedule',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule.html',
                        controller: 'TestScheduleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-schedule.detail', {
                parent: 'test-schedule',
                url: '/test-schedule/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-detail.html',
                        controller: 'TestScheduleDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id});
                    }]
                }
            })
            .state('test-schedule.delete', {
                parent: 'test-schedule',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/test-schedule/test-schedule-delete-dialog.html',
                        controller: 'TestScheduleDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TestSchedule', function (TestSchedule) {
                                return TestSchedule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('test-schedule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('test-schedule.resume', {
                parent: 'test-schedule',
                url: '/{id}/resume',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/test-schedule/test-schedule-resume-dialog.html',
                        controller: 'TestScheduleResumeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TestSchedule', function (TestSchedule) {
                                return TestSchedule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('test-schedule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('test-schedule.failed-tests', {
                parent: 'test-schedule',
                url: '/{id}/failed-tests',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-failed-tests.html',
                        controller: 'TestScheduleFailedTestsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                            objects: $stateParams.objects
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ObjectTestResult', function ($stateParams, ObjectTestResult) {
                        return ObjectTestResult.numberOfTestsBySchedule({id: $stateParams.id}).$promise;
                    }],
                    testSchedule: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id});
                    }]
                }
            })
            .state('test-schedule.new', {
                parent: 'test-schedule',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog.html',
                        controller: 'TestScheduleDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    testSchedule: {value: null},
                    name: {value: null}
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('objectTestSetting');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    tabFleets: ['TabFleets', function (TabFleets) {
                        return TabFleets.query().$promise;
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            })
            .state('test-schedule.new-next', {
                parent: 'test-schedule',
                url: '/new/next',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog-next.html',
                        controller: 'TestScheduleDialogNextController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: null,
                    objType: null,
                    tests: null,
                    include: false,
                    name: null,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    objects: ['$stateParams', 'ListObjByObjTypeAndFleet', function ($stateParams, ListObjByObjTypeAndFleet) {
                        return ListObjByObjTypeAndFleet.query({
                            typeId: $stateParams.objType.id,
                            fleetId: $stateParams.fleet.id,
                            size: 2000
                        });
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            })
            .state('test-schedule.edit', {
                parent: 'test-schedule',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog.html',
                        controller: 'TestScheduleDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    name: {value:null},
                    include: false,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('objectTestSetting');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    tabFleets: ['$stateParams', function ($stateParams) {
                        return $stateParams.tabFleets;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    testSchedule: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('test-schedule.edit-next', {
                parent: 'test-schedule',
                url: '/{id}/edit/next',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog-next.html',
                        controller: 'TestScheduleDialogNextController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    testSchedule: {value: null},
                    name: {value: null},
                    include: false,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    id: ['$stateParams', function ($stateParams) {
                       return $stateParams.id;
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    objects: ['$stateParams', 'ListObjByObjTypeAndFleet', function ($stateParams, ListObjByObjTypeAndFleet) {
                        return ListObjByObjTypeAndFleet.query({
                            typeId: $stateParams.objType.id,
                            fleetId: $stateParams.fleet.id,
                            size: 2000
                        }).$promise;
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserProfileDeleteController',UserProfileDeleteController);

    UserProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserProfile'];

    function UserProfileDeleteController($uibModalInstance, entity, UserProfile) {
        var vm = this;

        vm.userProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserProfileDetailController', UserProfileDetailController);

    UserProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function UserProfileDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.userProfile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('jotApp:userProfileUpdate', function(event, result) {
            vm.userProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserProfileDialogController', UserProfileDialogController);

    UserProfileDialogController.$inject = ['$state', '$scope', 'entity', 'UserProfile', 'Authority','TabDomains', 'Principal'];

    function UserProfileDialogController ($state, $scope, entity, UserProfile, Authority, TabDomains, Principal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.userProfile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.slider;
        vm.floor = 5;
        vm.gap = 4;
        vm.customizable=false;

        function loadAll(){
            if(vm.userProfile.id == null || vm.userProfile.id == "null") {
                vm.userProfile.authority = {};
                vm.userProfile.authority.name = "ROLE_DOMAIN_USER";
                vm.userProfile.customProfile = true;
            }
            Principal.hasAuthority("ROLE_ADMIN").then(function (isAdmin){
                if(isAdmin){
                    TabDomains.query().$promise.then(function (domains) {
                        vm.domains = domains;
                    });
                }
            });
            vm.limitLevel();
        }

        function clear () {
            $state.go('user-profile');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userProfile.id !== null) {
                UserProfile.update(vm.userProfile, onSaveSuccess, onSaveError);
            } else {
                UserProfile.save(vm.userProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('jotApp:userProfileUpdate', result);
            vm.isSaving = false;
            $state.go('user-profile');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.limitLevel = function() {
            vm.slider = {};
            if(vm.userProfile.authority.name == 'ROLE_ADMIN') {
                vm.slider = {
                    options: {
                        floor: 1,
                        ceil: 10,
                        step: 1,
                        minLimit: 0,
                        maxLimit: 0,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 1, legend: 'High'}, {value: 2}, {value: 3}, {value: 4}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_TECH') {
                vm.slider = {
                    options: {
                        floor: 1,
                        ceil: 10,
                        step: 1,
                        minLimit: 1,
                        maxLimit: 2,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 1, legend: 'High'}, {value: 2}, {value: 3}, {value: 4}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_DOMAIN_ADMIN') {
                vm.slider = {
                    options: {
                        floor: vm.floor,
                        ceil: 10,
                        step: 1,
                        minLimit: 3 - vm.gap,
                        maxLimit: 3 - vm.gap,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 4, legend: 'High'}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            else if(vm.userProfile.authority.name == 'ROLE_DOMAIN_USER') {
                vm.customizable=true;
                vm.slider = {
                    options: {
                        floor: vm.floor,
                        ceil: 10,
                        step: 1,
                        minLimit: 4 - vm.gap,
                        maxLimit: 9 - vm.gap,
                        rightToLeft: true
                    }
                };
                vm.slider.options.stepsArray = [{value: 5, legend: 'High'}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10, legend: 'Low'}];
            }
            vm.slider.options.showTicksValues = true;
            $scope.$broadcast('rzSliderForceRender');
        };

        vm.loadAll();

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserProfileController', UserProfileController);

    UserProfileController.$inject = ['$scope', '$state', 'UserProfile', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Principal'];

    function UserProfileController ($scope, $state, UserProfile, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.loadAll = loadAll;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = pagingParams.page;

        vm.currentState = "user-profile";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        loadAll();

        function loadAll () {
            UserProfile.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.userProfiles = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort : sort(),
                search: vm.currentSearch
            }, {location: "replace"});
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('UserProfile', UserProfile);

    UserProfile.$inject = ['$resource'];

    function UserProfile($resource) {
        var resourceUrl = 'api/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByUserId': {
                url: "api/user-profiles/user/:id",
                method: 'GET',
            },
            'update': {method: 'PUT'},
            'default': {
                url: "api/user-profiles/default/:authority",
                method: 'GET',
                isArray: true
            },
            'getTeamProfiles': {
                url: "api/user-profiles/team",
                method: 'GET',
                isArray: true
            },
            'alertsProfile': {
                url: "api/alert-user-profiles",
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-profile', {
            parent: 'admin',
            url: '/user-profile?page&sort&search',
            data: {
                evaluateAuthorities: 'ROLE_DOMAIN_ADMIN && !ROLE_TECH || ROLE_ADMIN',
                pageTitle: 'jotApp.userProfile.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/user-profile/user-profiles.html',
                    controller: 'UserProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                predicates : {}
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-profile-detail', {
            parent: 'user-profile',
            url: '/user-profile/{id}',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN'],
                pageTitle: 'jotApp.userProfile.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/user-profile/user-profile-detail.html',
                    controller: 'UserProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserProfile', function($stateParams, UserProfile) {
                    return UserProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-profile-detail.edit', {
            parent: 'user-profile',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserProfile', function(UserProfile) {
                            return UserProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-profile.new', {
            parent: 'user-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN'],
                pageTitle: 'jotApp.userProfile.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        warningLevel: 10,
                        commandLevel: 10,
                        id: null
                    };
                }
            }
        })
        .state('user-profile-edit', {
            parent: 'user-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN'],
                pageTitle: 'jotApp.userProfile.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'UserProfile', function($stateParams, UserProfile) {
                    return UserProfile.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-profile-delete', {
            parent: 'user-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DOMAIN_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-delete-dialog.html',
                    controller: 'UserProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserProfile', function(UserProfile) {
                            return UserProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-profile', null, { reload: 'user-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDeleteController',WarningCategoryDeleteController);

    WarningCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'WarningCategory'];

    function WarningCategoryDeleteController($uibModalInstance, entity, WarningCategory) {
        var vm = this;
        vm.warningCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WarningCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDetailController', WarningCategoryDetailController);

    WarningCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WarningCategory'];

    function WarningCategoryDetailController($scope, $rootScope, $stateParams, entity, WarningCategory) {
        var vm = this;
        vm.warningCategory = entity;
        
        var unsubscribe = $rootScope.$on('jotApp:warningCategoryUpdate', function(event, result) {
            vm.warningCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDialogController', WarningCategoryDialogController);

    WarningCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'WarningCategory', '$state'];

    function WarningCategoryDialogController ($timeout, $scope, $stateParams, entity, WarningCategory, $state) {
        var vm = this;
        vm.warningCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:warningCategoryUpdate', result);
            vm.isSaving = false;
            $state.go('warning-category');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.warningCategory.id !== null) {
                WarningCategory.update(vm.warningCategory, onSaveSuccess, onSaveError);
            } else {
                WarningCategory.save(vm.warningCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('warning-category');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryController', WarningCategoryController);

    WarningCategoryController.$inject = ['$scope', '$state', 'WarningCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WarningCategoryController($scope, $state, WarningCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.predicates = pagingParams.predicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.currentState = "warning-category";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.loadAll();

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            WarningCategory.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            }, onSuccess, onError);


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warningCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                search: vm.currentSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('WarningCategory', WarningCategory);

    WarningCategory.$inject = ['$resource'];

    function WarningCategory ($resource) {
        var resourceUrl =  'api/warning-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warning-category', {
                parent: 'alerting',
                url: '/warning-category?page&sort&search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-categories.html',
                        controller: 'WarningCategoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    predicates:{},
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates:  $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warning-category-detail', {
                parent: 'entity',
                url: '/warning-category/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-category-detail.html',
                        controller: 'WarningCategoryDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WarningCategory', function ($stateParams, WarningCategory) {
                        return WarningCategory.get({id: $stateParams.id});
                    }]
                }
            })
            .state('warning-category-new', {
                parent: 'warning-category',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.warningCategory.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/warning-category/warning-category-dialog.html',
                        controller: 'WarningCategoryDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warningCategory');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            warningName: null,
                            id: null
                        };
                    }
                }
            })
            .state('warning-category.edit', {
                parent: 'warning-category',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warning-category/warning-category-dialog.html',
                        controller: 'WarningCategoryDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarningCategory', function (WarningCategory) {
                                return WarningCategory.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warning-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warning-category.delete', {
                parent: 'warning-category',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warning-category/warning-category-delete-dialog.html',
                        controller: 'WarningCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WarningCategory', function (WarningCategory) {
                                return WarningCategory.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warning-category', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('CheckSaveEditController', CheckSaveEditController);

    CheckSaveEditController.$inject = ['$state', '$scope', '$uibModalInstance', 'query'];

    function CheckSaveEditController($state, $scope, $uibModalInstance, query) {
        var vm = this;

        vm.lastQuery = query.lastQuery;
        vm.newQuery = query.newQuery;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            $uibModalInstance.close();
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SelectedRulesEmailController', SelectedRulesEmailController);

    SelectedRulesEmailController.$inject = ['$state', '$uibModalInstance', 'Authority'];

    function SelectedRulesEmailController($state, $uibModalInstance, Authority) {
        var vm = this;

        vm.selectedAut = {};
        vm.authorities = [];
        Authority.query().$promise.then(function (authorities) {
            vm.selectedAut = {id: -1, name: authorities[authorities.length -1]};
            authorities.sort();

            var i = 0;
            authorities.forEach(a => {
                vm.authorities.push({id: i, name: a});
                i++;
            });
        });

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            $uibModalInstance.close(vm.selectedAut.name);
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NotificationsHelpController', NotificationsHelpController);

    NotificationsHelpController.$inject = ['$state', '$uibModalInstance'];

    function NotificationsHelpController($state, $uibModalInstance) {
        var vm = this;

        vm.notifications = [
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-green', description: "Channel configured, active notifications"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'background-red', description: " Channel configured, inactive notification due to stopped rule or disabled notification (single rule or general setting)"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-gray', description: "Not configured or disabled by domain admin"}
        ]

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDeleteController',WarningDeleteController);

    WarningDeleteController.$inject = ['$uibModalInstance', 'entity', 'Warning'];

    function WarningDeleteController($uibModalInstance, entity, Warning) {
        var vm = this;
        vm.warning = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Warning.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDetailController', WarningDetailController);

    WarningDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$http'];

    function WarningDetailController($scope, $rootScope, $stateParams, entity, $http) {
        var vm = this;
        vm.warning = entity;
        vm.isGreengrassObjectType = false;

        if (vm.warning.$promise) {
            vm.warning.$promise.then(function() {
                normalizeWarningResponse(vm.warning);
                resolveGreengrassType(vm.warning);
            });
        } else {
            normalizeWarningResponse(vm.warning);
            resolveGreengrassType(vm.warning);
        }

        var unsubscribe = $rootScope.$on('jotApp:warningUpdate', function(event, result) {
            vm.warning = result;
            normalizeWarningResponse(vm.warning);
            resolveGreengrassType(vm.warning);
        });
        $scope.$on('$destroy', unsubscribe);

        function resolveGreengrassType(warning) {
            if (warning.tabObjectTypes == null || warning.tabObjectTypes.id == null) {
                vm.isGreengrassObjectType = false;
                return;
            }

            if (warning.tabObjectTypes.greengrassType === true ||
                warning.tabObjectTypes.greengrassType === false) {
                vm.isGreengrassObjectType = warning.tabObjectTypes.greengrassType === true;
                return;
            }

            // fallback
            $http.get('api/tab-object-types/' + warning.tabObjectTypes.id)
                .then(function(response) {
                    warning.tabObjectTypes.greengrassType = response.data.greengrassType;
                    vm.isGreengrassObjectType = response.data.greengrassType === true;
                })
                .catch(function() {
                    vm.isGreengrassObjectType = false;
                });
        }

        vm.hasAutoRepairResponse = function() {
            return vm.warning != null && (
                vm.warning.macro != null ||
                vm.warning.action != null ||
                vm.warning.greengrassCommandName != null
            );
        };

        vm.getResponseType = function() {
            if (vm.warning == null) return null;
            if (vm.warning.macro != null) return 'Macro';
            if (vm.warning.action != null || vm.warning.greengrassCommandName != null) return 'Single Command';
            return null;
        };

        vm.getResponseBadgeLabel = function() {
            return vm.isGreengrassObjectType ? 'Greengrass' : 'Kura';
        };

        vm.prettyLabel = function(value) {
            if (!value) return '';
            return value.replace(/_/g, ' ').toLowerCase()
                .replace(/\b\w/g, function(letter) { return letter.toUpperCase(); });
        };

        function normalizeWarningResponse(warning) {
            if (warning == null) return;

            if (warning.greengrassArguments != null && angular.isString(warning.greengrassArguments)) {
                try {
                    warning.greengrassArguments = angular.fromJson(warning.greengrassArguments);
                } catch (e) {
                    warning.greengrassArguments = {};
                }
            }

            if (warning.actionArguments != null && angular.isString(warning.actionArguments)) {
                try {
                    warning.actionArguments = angular.fromJson(warning.actionArguments);
                } catch (e) {
                    warning.actionArguments = {};
                }
            }

            if (warning.greengrassArguments == null &&
                warning.actionArguments != null) {

                var actionArguments = angular.copy(warning.actionArguments);

                if (actionArguments.__greengrassCommand != null) {

                    warning.greengrassCommandName = actionArguments.__greengrassCommand;
                    warning.greengrassTarget      = actionArguments.__greengrassTarget;

                    delete actionArguments.__greengrassCommand;
                    delete actionArguments.__greengrassTarget;

                    warning.greengrassArguments = actionArguments;
                }
            }
        }

        vm.hasKeys = function(obj) {
            return obj && Object.keys(obj).length > 0;
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDialogQueryController', WarningDialogQueryController);

    WarningDialogQueryController.$inject = ['$scope', '$stateParams', '$state', 'AlertService', 'Warning'];

    function WarningDialogQueryController($scope, $stateParams, $state, AlertService, Warning) {
        var vm = this;

        vm.showQuery = "";
        vm.query = [];
        vm.notQuery = false;
        vm.lastIndex = null;
        vm.hasTotalNegation= false;
        vm.memory = [];
        vm.originalQuery = localStorage.getItem("originalQuery");

        var warning = localStorage.getItem("edit-automatic-rule");
        var query = "";
        if(warning != null && warning != "null" && warning != undefined){
            vm.warning = JSON.parse(warning);
            query = vm.warning.query;
        }
        if(query != null){
            vm.showQuery = query.replace(/\s\s+/g, ' ');
            //  aggiorno showQuery basata su originalQuery
            updateShowQuery();
            query = vm.showQuery.split(" ");
            query = checkQuery(query);
            var limit = query.length;
            for(var i = 0; i < limit; i++){
                if(query[i+1] === "TO"){
                    query[i] = query[i]+" "+query[i+1]+" "+query[i+2];
                    query.splice(i+1, 2);
                }
            }
            for(var i = 0; i < query.length; i++){
                var app = {};
                app.value = query[i];
                app.level = 0;
                vm.query.push(app);
            }
            app = {};
            app.query = vm.showQuery;
            app.components = JSON.stringify(vm.query);
            app.negative = false;
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length-1;
        }


        function updateShowQuery() {
            var storedValue = localStorage.getItem("originalQuery");
            if (!storedValue) return;

            var originalQuery = JSON.parse(storedValue).trim().replace(/^\\\\*"\\s*|\\s*"\\\\*$/g, '');
            var hasTotalNegation = /^!\(.*\)$/.test(originalQuery);

            if (hasTotalNegation && !vm.showQuery.startsWith("!(") && !vm.showQuery.endsWith(")")) {
                vm.showQuery = "!(" + vm.showQuery + ")";
            }
            vm.hasTotalNegation = hasTotalNegation;
        }
        function checkQuery(query) {
            for(var i = 0;  i < query.length; i++){
                if(query[i].length == 0) {
                    query.splice(i, 1);
                }
            }
            return query;
        }

        vm.moveInside = function(index) {
            if(index%2==0){
                if(vm.lastIndex == null || vm.lastIndex != index){
                    if(vm.lastIndex != index-1 && vm.lastIndex != index+1){
                        moveIndex(index);
                        vm.lastIndex = index;
                    } else {
                        AlertService.error("Error Edit Group");
                    }
                } else {
                    AlertService.error("Error Edit Group");
                }
            } else {
                if(vm.lastIndex == null || vm.lastIndex != index){
                    moveIndex(index);
                    vm.lastIndex = index;
                } else {
                    AlertService.error("Error Edit Group");
                }
            }
            app = {};
            app.query = vm.showQuery;
            app.components = JSON.stringify(vm.query);
            app.neagative = false;
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length-1;
        };

        function moveIndex(index){
            if(index%2 == 0){
                move(index);
            } else {
                if(vm.query[index-1].level-1 == vm.query[index].level){
                    if(vm.query[index].level == vm.query[index+1].level){
                        move(index);
                        move(index+1);
                    } else {
                        AlertService.error("Cannot move this operator");
                    }
                } else {
                    if(vm.query[index-1].level == vm.query[index+1].level){
                        if(vm.query[index].level == vm.query[index+1].level){
                            move(index-1);
                            move(index);
                            move(index+1);
                        } else {
                            AlertService.error("Error Edit");
                        }
                    }
                }
            }
        }

        function move(index) {
            vm.query[index].level++;
            if(index != 0){
                if(vm.query[index-1].level == vm.query[index].level){
                    if(index != vm.query.length-1){
                        if (vm.query[index+1].level == vm.query[index].level) {
                            vm.query[index+1].value = vm.query[index-1].value.substring(1, vm.query[index-1].value.length);
                            vm.query[index].value = "(" + vm.query[index].value;
                        } else {
                            vm.query[index-1].value = vm.query[index-1].value.substring(0, vm.query[index-1].value.length-1);
                            vm.query[index].value = vm.query[index].value + ")";
                        }
                    } else {
                        vm.query[index-1].value = vm.query[index-1].value.substring(0, vm.query[index-1].value.length-1);
                        vm.query[index].value = vm.query[index].value + ")";
                    }
                } else {
                    vm.query[index].value = "(" + vm.query[index].value + ")";
                }
            } else {
                vm.query[index].value = "(" + vm.query[index].value + ")";
            }
            vm.showQuery = "";
            for(var i = 0; i < vm.query.length; i++){
                if(i == vm.query.length-1){
                    vm.showQuery += vm.query[i].value;
                } else {
                    vm.showQuery += vm.query[i].value+" ";
                }
            }
        }

     /*   vm.negQuery = function() {
            vm.notQuery = !vm.notQuery;
            if(vm.showQuery[vm.showQuery.length-1] === " "){
                vm.showQuery = vm.showQuery.substring(0, vm.showQuery.length-1);
            }
            if(vm.notQuery){
                vm.showQuery = "!(" + vm.showQuery + ")";
                app = {};
                app.query = vm.showQuery;
                app.components = JSON.stringify(vm.query);
                app.negative = vm.notQuery;

                vm.memory.push(app);
                vm.viewIndex = vm.memory.length-1;
            } else {
                /!*vm.showQuery = vm.showQuery.substring(2, vm.showQuery.length-1);*!/
                app = {};
                app.query = vm.showQuery;
                app.components = JSON.stringify(vm.query);
                app.negative = vm.notQuery;
                vm.memory.push(app);
                vm.viewIndex = vm.memory.length-1;
            }
        };*/

        vm.negQuery = function() {
            if (!vm.hasTotalNegation) {
                vm.showQuery = "!(" + vm.showQuery + ")";
                vm.hasTotalNegation = true;
            } else {
                vm.showQuery = vm.showQuery.substring(2, vm.showQuery.length - 1);
                vm.hasTotalNegation = false;
            }
            var app = {
                query: vm.showQuery,
                components: JSON.stringify(vm.query),
                negative: vm.hasTotalNegation
            };
            vm.memory.push(app);
            vm.viewIndex = vm.memory.length - 1;
        };

        vm.addNegQuery = function() {
            vm.showQuery = vm.showQuery.startsWith("!(") && vm.showQuery.endsWith(")")
                ? vm.showQuery.slice(2, -1)
                : "!(" + vm.showQuery + ")";
            vm.hasTotalNegation = !vm.hasTotalNegation;
            vm.memory.push({
                query: vm.showQuery,
                components: JSON.stringify(vm.query),
                negative: vm.hasTotalNegation
            });
            vm.viewIndex = vm.memory.length - 1;
        };



        vm.save = function () {
            vm.isSaving = true;
            vm.warning.query = vm.showQuery;
            vm.warning.composed = true;
            vm.warning.active = false;
            if(vm.warning.action != null && vm.warning.action.id == -1 ) {
                vm.warning.action = null;
            }
            if(vm.warning.macro != null && vm.warning.macro.id == -1 ) {
                vm.warning.macro = null;
            }

            if (vm.warning.id !== null) {
                Warning.update(vm.warning, onSaveSuccess, onSaveError);
            } else {
                vm.fleetsTosave = vm.warning.tabFleets;
                vm.isSaving = true;
                vm.saveByFleet();
            }
        };

        vm.saveByFleet = function() {
            vm.warning.tabFleets = vm.fleetsTosave[0];
            vm.fleetsTosave.splice(0, 1);
            Warning.save(vm.warning, onSaveSuccess, onSaveError);
        };

        var onSaveSuccess = function (result) {
            if(vm.fleetsTosave != null || vm.fleetsTosave != undefined){
                if (vm.fleetsTosave.length > 0) {
                    vm.saveByFleet();
                } else {
                    $scope.$emit('jotApp:warningUpdate', result);
                    vm.isSaving = false;
                    $state.go('warning');
                }
            } else {
                $scope.$emit('jotApp:warningUpdate', result);
                vm.isSaving = false;
                $state.go('warning');
            }
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $state.reload();
        };

        vm.useMemory = function (goBack) {
            if(goBack){
                vm.viewIndex--;
            } else {
                vm.viewIndex++;
            }
            vm.showQuery = vm.memory[vm.viewIndex].query;
            vm.query = JSON.parse(vm.memory[vm.viewIndex].components);
            vm.notQuery = vm.memory[vm.viewIndex].negative;
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDialogController', WarningDialogController);

    WarningDialogController.$inject = ['$timeout', '$filter', '$scope', '$stateParams', 'entity', 'Warning', 'WarningCategory', 'TabObjectTypes', 'TabFleets', 'UserProfile', '$state', 'ParseLinks', 'AlertService', 'TabActions', 'Macro', '$uibModal', '$http', 'CommandManifest'];

    function WarningDialogController($timeout, $filter, $scope, $stateParams, entity, Warning, WarningCategory, TabObjectTypes, TabFleets, UserProfile, $state, ParseLinks, AlertService, TabActions, Macro, $uibModal, $http, CommandManifest) {
        var vm = this;
        vm.warning = entity;
        vm.tabFleets = [];
        vm.macro = [];
        vm.fleetPage = 0;
        vm.fleetLinks = {};
        vm.tabObjectTypes = [];
        vm.objectTypePage = 0;
        vm.objectTypeLinks = {};
        vm.userProfiles = [];
        vm.userProfilePage = 0;
        vm.userProfileLinks = {};
        vm.warningCategories = [];
        vm.warningCategoryPage = 0;
        vm.warningCategoryLinks = {};
        vm.commandKeys = ["actionId", "command", "deviceReleases", "form", "schema", "weight"];
        vm.fleetsTosave = [];
        vm.metric = [];
        vm.operator = [];
        vm.addMetric = [];
        vm.tempMetric = null;
        vm.quantity = 1;
        vm.expected = [];
        vm.expectedNumber = [];
        vm.checkType = [];
        vm.expectedA = [];
        vm.expectedB = [];
        vm.expectedDate = [];
        vm.expectedDateA = [];
        vm.expectedDateB = [];
        vm.metricDate = [];
        vm.metricDateDown = [];
        vm.datepickerOptions = {
            minDate: new Date()
        };
        vm.formDate = [];
        vm.typeDateForm = [];
        vm.relativeDateNumber = [];
        vm.relativeDate = [];
        vm.relativeDateSimbol = [];
        vm.relativeDateNumberB = [];
        vm.relativeDateB = [];
        vm.relativeDateSimbolB = [];
        vm.lastQuery = "";
        vm.compose = true;
        vm.isGreengrassObjectType = false;
        vm.commandList = [];
        vm.objectTypeCache = {};
        vm.GREENGRASS_COMMAND_KEY = "__greengrassCommand";
        vm.GREENGRASS_TARGET_KEY = "__greengrassTarget";

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            if (vm.fleetsTosave.length > 0) {
                vm.saveByFleet();
            } else {
                $scope.$emit('jotApp:warningUpdate', result);
                vm.isSaving = false;
                $state.go('warning');
            }
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        function getDate(date){
            var formatDate = $filter('date')(date, "yyyy-MM-dd HH:mm");
            var d = formatDate.toString().split(" ");
            return d[0]+"T"+d[1];
        }

        function createQuery(){
            console.log("Inizio costruzione query. Metriche selezionate:", vm.tempMetric);
            if(vm.compose){
                var error = "";
                var query = [];
                for(var i = 0; i < Object.keys(vm.tempMetric).length; i++){
                    var app = {};
                    var errorField = true;
                    var errorDate = true;
                    app.metric = vm.tempMetric[i].name;
                    if(vm.checkType[i] != null){
                        app.type = vm.checkType[i];
                        switch (app.type) {
                            case "Exists":
                            case "Not Exists":
                                if(vm.operator[i] != null){
                                    app.operator = vm.operator[i].name;
                                }
                                query.push(app);
                                errorDate = false;
                                errorField = false;
                                break;
                            case "Equals":
                            case "Not Equals":
                                if(vm.expected[i] != null && vm.expected[i].length > 0){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = vm.expected[i];
                                    query.push(app);
                                    errorField = false;
                                }
                                if(vm.expectedNumber[i] != null){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = vm.expectedNumber[i];
                                    query.push(app);
                                    errorField = false;
                                }
                                if(vm.expectedDate[i] != null){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = getDate(vm.expectedDate[i]);
                                    app.date = true;
                                    query.push(app);
                                    errorField = false;
                                }
                                errorDate = false;
                                break;
                            case "Lower":
                            case "Lower equals":
                            case "Greater":
                            case "Greater equals":
                                if (vm.tempMetric[i].type !== "date") {
                                    if (vm.expectedNumber[i] != null) {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = "" + vm.expectedNumber[i];
                                        app.date = false;
                                        query.push(app);
                                        errorField = false;
                                    }
                                } else {
                                    if (vm.expectedDate[i] != null && vm.typeDateForm[i] === "absolute") {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = getDate(vm.expectedDate[i]);
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    } else {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = vm.expected[i] == null ? "now" : vm.expected[i];
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    }
                                }
                                errorDate = false;
                                break;
                            case "Between":
                                if (vm.tempMetric[i].type !== "date") {
                                    if (vm.expectedA[i] != null && vm.expectedB[i] != null) {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = "" + vm.expectedA[i];
                                        app.valueB = "" + vm.expectedB[i];
                                        app.date = false;
                                        query.push(app);
                                        errorField = false;
                                    }
                                    errorDate = false;
                                } else {
                                    if (vm.typeDateForm[i] === "absolute") {
                                        if (vm.expectedDateA[i] != null && vm.expectedDateB[i] != null) {
                                            if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                            if (vm.expectedDateA[i] > vm.expectedDateB[i]) {
                                                errorDate = true;
                                            } else {
                                                app.value = getDate(vm.expectedDateA[i]);
                                                app.valueB = getDate(vm.expectedDateB[i]);
                                                app.date = true;
                                                query.push(app);
                                                errorField = false;
                                            }
                                        } else {
                                            errorDate = false;
                                        }
                                    } else {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = vm.expected[i] == null ? "now" : vm.expected[i];
                                        app.valueB = vm.expectedB[i] == null ? "now" : vm.expectedB[i];
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    }
                                }
                                break;
                        }
                    } else {
                        error = "Field cannot be empty";
                        break;
                    }
                    if (errorField) {
                        error = errorDate ? "Error set date in metric" : "Field cannot be empty";
                        break;
                    }
                }
                if (error === "") {
                    vm.warning.query = "";
                    for (var i = 0; i < Object.keys(query).length; i++) {
                        switch (query[i].type) {
                            case "Exists":
                                vm.warning.query += "_exists_:" + query[i].metric;
                                break;
                            case "Not Exists":
                                vm.warning.query += "!_exists_:" + query[i].metric;
                                break;
                            case "Equals":
                                if (!query[i].date) {
                                    vm.warning.query += /^-?[\d.]+(?:e-?\d+)?$/.test(query[i].value) ?
                                        query[i].metric + ":" + query[i].value :
                                        query[i].metric + ":\"" + query[i].value + "\"";
                                } else {
                                    vm.warning.query += query[i].metric + ":\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"";
                                }
                                break;
                            case "Not Equals":
                                if (!query[i].date) {
                                    vm.warning.query += /^-?[\d.]+(?:e-?\d+)?$/.test(query[i].value) ?
                                        "!" + query[i].metric.replace(/\s/g, '') + ":" + query[i].value :
                                        "!" + query[i].metric.replace(/\s/g, '') + ":\"" + query[i].value + "\"";
                                } else {
                                    vm.warning.query += "!" + query[i].metric.replace(/\s/g, '') + ":\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"";
                                }
                                break;
                            case "Lower":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":<\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":<" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":<" + query[i].value;
                                }
                                break;
                            case "Lower equals":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":<=\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":<=" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":<=" + query[i].value;
                                }
                                break;
                            case "Greater":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":>\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":>" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":>" + query[i].value;
                                }
                                break;
                            case "Greater equals":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":>=\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":>=" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":>=" + query[i].value;
                                }
                                break;
                            case "Between":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":[\"" + query[i].value.substring(0, query[i].value.length - 6) + " TO " + query[i].valueB.substring(0, query[i].valueB.length - 6) + "\"]" :
                                        query[i].metric + ":[" + query[i].value + " TO " + query[i].valueB + "]";
                                } else {
                                    vm.warning.query += query[i].metric + ":[" + query[i].value + " TO " + query[i].valueB + "]";
                                }
                                break;
                        }
                        if (query[i].operator != null) {
                            vm.warning.query += " " + query[i].operator.toUpperCase() + " ";
                        }
                    }
                    return true;
                } else {
                    AlertService.error(error);
                    return false;
                }
            } else {
                return true;
            }
        }

        function getSavedActionArguments() {
            if (vm.warning != null && vm.warning.greengrassArguments != null) {
                return angular.copy(vm.warning.greengrassArguments) || {};
            }

            if (vm.warning == null || vm.warning.actionArguments == null || vm.warning.actionArguments === '') {
                return {};
            }

            try {
                return angular.fromJson(vm.warning.actionArguments) || {};
            } catch (e) {
                return {};
            }
        }
        function hasStoredGreengrassCommand() {
            if (vm.warning == null) {
                return false;
            }

            if (vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                return true;
            }

            if (vm.warning.actionArguments == null || vm.warning.actionArguments === '') {
                return false;
            }

            try {
                var args = angular.fromJson(vm.warning.actionArguments);
                return args != null && args[vm.GREENGRASS_COMMAND_KEY] != null && args[vm.GREENGRASS_COMMAND_KEY] !== '';
            } catch (e) {
                return false;
            }
        }

        function parseArgumentSchema(argumentsSchema) {
            if (argumentsSchema == null || argumentsSchema === '') return null;
            if (angular.isObject(argumentsSchema)) return argumentsSchema;
            try {
                return angular.fromJson(argumentsSchema);
            } catch (e) {
                return null;
            }
        }

        function getManifestArgumentType(argument) {
            var type = argument != null && argument.type != null ? ('' + argument.type).toLowerCase() : '';
            if (type === 'toggle') return 'boolean';
            if (type === 'slider') return 'number';
            if (type === 'input') {
                if (argument.defaultValue != null && typeof argument.defaultValue === 'number') return 'number';
                if (argument.props != null && (argument.props.min != null || argument.props.max != null)) return 'number';
                return 'string';
            }
            if (type === 'select') return argument.defaultValue != null && typeof argument.defaultValue === 'number' ? 'number' : 'string';
            if (type === 'timepicker' || type === 'datepicker') return 'string';
            return type || 'string';
        }

        function buildArgumentsSchemaFromManifestArguments(argumentsList) {
            if (!angular.isArray(argumentsList) || argumentsList.length === 0) return null;

            var schema = { type: 'object', properties: {} };

            argumentsList.forEach(function (argument, index) {
                if (argument == null || argument.key == null || argument.key === '') return;

                var props = argument.props || {};
                var property = {};

                property.type = getManifestArgumentType(argument);
                property.component = argument.type;
                property.defaultValue = argument.defaultValue;
                property.description = props.description || props.label || '';
                property.title = props.label || props.title || argument.key;
                property.order = index + 1;

                if (argument.defaultValue !== undefined && argument.defaultValue !== null) {
                    property.default = argument.defaultValue;
                }

                // timepicker
                if (argument.type === 'timepicker') {
                    property.format = 'time';
                }

                // slider/range
                if (argument.type === 'slider') {
                    property.component = 'range';
                    property.options = {
                        step: 1,
                        floor: props.min !== undefined ? props.min : 0,
                        ceil: props.max !== undefined ? props.max : 100
                    };
                    property.minimum = props.min;
                    property.maximum = props.max;
                    if (props.thumbLabel !== undefined) property.thumbLabel = props.thumbLabel;
                }

                // select — converti label → name come fa ActionCommandsController
                if (argument.type === 'select' && props.options && props.options.length > 0) {
                    property.titleMap = props.options.map(function (option) {
                        return {
                            name: option.label || option.name || String(option.value),
                            value: String(option.value)
                        };
                    });
                    property.enum = props.options.map(function (option) {
                        return String(option.value);
                    });
                    if (property.default !== undefined && property.default !== null) {
                        property.default = String(property.default);
                    }
                }

                if (props.required) {
                    if (!schema.required) schema.required = [];
                    schema.required.push(argument.key);
                }

                if (props.min != null) property.minimum = props.min;
                if (props.max != null) property.maximum = props.max;

                schema.properties[argument.key] = property;
            });

            return Object.keys(schema.properties).length > 0 ? schema : null;
        }

        function isInvalidArgumentValue(value) {
            return value === null || value === undefined || value === '' || value !== value || value === 'NaN';
        }

        function isNumericArgument(property) {
            return property != null && (
                property.type === 'number' ||
                property.type === 'integer' ||
                property.component === 'slider' ||
                property.component === 'range' ||
                property.component === 'number'
            );
        }

        function isBooleanArgument(property) {
            return property != null && (
                property.type === 'boolean' ||
                property.component === 'checkbox' ||
                property.component === 'toggle'
            );
        }

        function getDefaultArgumentValue(property) {
            if (property == null) return '';
            if (property.hasOwnProperty('default')) return property.default;
            if (property.hasOwnProperty('defaultValue')) return property.defaultValue;
            if (isNumericArgument(property)) return 0;
            if (isBooleanArgument(property)) return false;
            if (property.type === 'array') return [];
            if (property.type === 'object') return {};
            return '';
        }

        function normalizeArgumentValue(value, property) {
            if (isInvalidArgumentValue(value)) {
                value = getDefaultArgumentValue(property);
            }
            if (isNumericArgument(property)) {
                var numericValue = Number(value);
                return isNaN(numericValue) ? Number(getDefaultArgumentValue(property)) : numericValue;
            }
            // Converti stringa "HH:mm" → Date per timepicker
            if (property != null && property.component === 'timepicker' && typeof value === 'string' && value.indexOf(':') !== -1) {
                var timeParts = value.split(':');
                var timeDate = new Date();
                timeDate.setHours(parseInt(timeParts[0]) || 0);
                timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                timeDate.setSeconds(0);
                timeDate.setMilliseconds(0);
                return timeDate;
            }
            return value;
        }

        // Restituisce un oggetto contenente gli argomenti e relativi valori per il comando selezionato
        function buildCompleteActionArguments() {
            var args = {};
            var previousArgs = getSavedActionArguments();
            var action = vm.warning != null ? vm.warning.action : null;
            var schema = action != null ? parseArgumentSchema(action.argumentsSchema) : null;

            if(schema == null && vm.formSchemas != null && vm.formSchemas.schema != null) {
                schema = vm.formSchemas.schema;
            }

            // Nessuno schema > nessun argomento
            if(schema == null || schema.properties == null) {
                return {};
            }

            Object.keys(schema.properties).forEach(function (arg) {
                var value = vm.formSchemas != null ? vm.formSchemas[arg] : null;

                if(isInvalidArgumentValue(value) && previousArgs.hasOwnProperty(arg)) {
                    value = previousArgs[arg];
                }

                value = normalizeArgumentValue(value, schema.properties[arg]);

                // Converti Date → "HH:mm" per timepicker prima del salvataggio
                if (schema.properties[arg] != null &&
                    schema.properties[arg].component === 'timepicker' &&
                    value instanceof Date) {
                    value = padTime(value.getHours()) + ":" + padTime(value.getMinutes());
                }

                args[arg] = value;
            });

            return args;
        }

        vm.save = function (createQ) {
            if(createQ){
                vm.isSaving = true;
                vm.warning.active = false;
                vm.warning.composed = vm.compose;

                var selectedNoAction = vm.warning.action != null && vm.warning.action.id == -1;
                var selectedNoMacro = vm.warning.macro != null && vm.warning.macro.id == -1;

                if (selectedNoAction) {
                    vm.warning.action = null;
                }

                if (selectedNoMacro) {
                    vm.warning.macro = null;
                }

                var hasSelectedAction = vm.warning.action != null;
                var hasSelectedMacro = vm.warning.macro != null;

                if (vm.isGreengrassObjectType && hasSelectedAction && vm.warning.action.manifestCommand === true) {
                    var greengrassArgs = buildCompleteActionArguments();

                    greengrassArgs[vm.GREENGRASS_COMMAND_KEY] = vm.warning.action.actionCommand;
                    greengrassArgs[vm.GREENGRASS_TARGET_KEY] = vm.warning.action.componentName;

                    vm.warning.actionArguments = angular.toJson(greengrassArgs);
                    vm.warning.action = null;
                    vm.warning.macro = null;
                } else if (hasSelectedAction) {
                    vm.warning.actionArguments = angular.toJson(buildCompleteActionArguments());
                } else if (hasSelectedMacro) {
                    vm.formSchemas = null;
                    vm.warning.actionArguments = null;
                    vm.warning.action = null;
                } else if (vm.isGreengrassObjectType && hasStoredGreengrassCommand()) {
                    var storedGreengrassArgs = getSavedActionArguments();

                    if (vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                        storedGreengrassArgs[vm.GREENGRASS_COMMAND_KEY] = vm.warning.greengrassCommandName;
                    }

                    if (vm.warning.greengrassTarget != null && vm.warning.greengrassTarget !== '') {
                        storedGreengrassArgs[vm.GREENGRASS_TARGET_KEY] = vm.warning.greengrassTarget;
                    }

                    vm.warning.actionArguments = angular.toJson(storedGreengrassArgs);
                    vm.warning.action = null;
                    vm.warning.macro = null;
                } else {
                    vm.formSchemas = null;
                    vm.warning.actionArguments = null;
                    vm.warning.action = null;
                    vm.warning.macro = null;
                }

                if (vm.warning.id !== null) {
                    Warning.update(vm.warning, onSaveSuccess, onSaveError);
                } else {
                    if (angular.isArray(vm.warning.tabFleets)) {
                        vm.fleetsTosave = angular.copy(vm.warning.tabFleets);
                    } else if (vm.warning.tabFleets != null && vm.warning.tabFleets.id != null) {
                        vm.fleetsTosave = [angular.copy(vm.warning.tabFleets)];
                    } else {
                        vm.fleetsTosave = [];
                    }

                    if (vm.fleetsTosave.length === 0) {
                        AlertService.error("Fleet is required");
                        vm.isSaving = false;
                        return;
                    }

                    vm.warning.composed = vm.compose;
                    vm.isSaving = true;
                    vm.saveByFleet();
                }
            }
        };

        function padTime(value) {
            value = parseInt(value, 10);
            if (isNaN(value)) {
                value = 0;
            }
            return value < 10 ? '0' + value : '' + value;
        }

        vm.saveByFleet = function () {
            if (vm.fleetsTosave == null || vm.fleetsTosave.length === 0) {
                AlertService.error("Fleet is required");
                vm.isSaving = false;
                return;
            }

            vm.warning.tabFleets = angular.copy(vm.fleetsTosave[0]);
            vm.fleetsTosave.splice(0, 1);

            Warning.save(vm.warning, onSaveSuccess, onSaveError);
        };


        vm.loadAll = function (resourceService, resource, resourcePage, headerLink) {
            var query = {
                page: resourcePage,
                query: vm.typeToSearch != undefined && vm.typeToSearch != "" ? vm.typeToSearch : "",
                size: 20
            };

            resourceService.query(query, onSuccess, onError);

            function onSuccess(data, headers) {
                var links = ParseLinks.parse(headers('link'));
                for (var key in links) headerLink[key] = links[key];
                for (var i = 0; i < data.length; i++) resource.push(data[i]);
            }

            function onError(error) {

                AlertService.error(error.data.message);
            }
        };

        vm.loadObjectTypePage = function (page) {
            if (page <= vm.objectTypeLinks['last']) {
                vm.objectTypePage = page;
                vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
            }
        };

        vm.loadFleetPage = function (page) {
            if (page <= vm.fleetLinks['last']) {
                vm.fleetPage = page;
                vm.loadAll(TabFleets, vm.tabFleets, vm.fleetPage, vm.fleetLinks);
            }
        };

        vm.loadWarningCategoryPage = function (page) {
            if (page <= vm.warningCategoryLinks['last']) {
                vm.warningCategoryPage = page;
                vm.loadAll(WarningCategory, vm.warningCategories, vm.warningCategoryPage, vm.warningCategoryLinks);
            }
        };

        vm.loadUserProfilePage = function (page) {
            if (page <= vm.userProfileLinks['last']) {
                vm.userProfilePage = page;
                vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);
            }
        };

        vm.search = function (searchText) {
            vm.typeToSearch = searchText;
            vm.tabObjectTypes = [];
            vm.objectTypePage = 0;
            vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
        };
        vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
        vm.loadAll(TabFleets, vm.tabFleets, vm.fleetPage, vm.fleetLinks);
        vm.loadAll(WarningCategory, vm.warningCategories, vm.warningCategoryPage, vm.warningCategoryLinks);
        vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);

        function clearRuleResponses(clearSelectedResponse) {
            vm.commandList = [];
            vm.macro = [];
            vm.formSchemas = null;

            if(clearSelectedResponse === true) {
                vm.warning.action = null;
                vm.warning.macro = null;
            }
        }

        function hasSelectedObjectType() {
            return vm.warning != null && vm.warning.tabObjectTypes != null && vm.warning.tabObjectTypes.id != null;
        }

        vm.canLoadRuleResponses = function () {
            return hasSelectedObjectType() && vm.getSelectedFleetId() != null;
        };

        vm.onObjectTypeChange = function () {
            vm.refreshIndex();
            clearRuleResponses(true);
            vm.getActions();
        };

        vm.onFleetChange = function () {
            clearRuleResponses(true);
            vm.getActions();
        };

        vm.loadRuleResponsesIfAvailable = function () {
            if (vm.canLoadRuleResponses()) {
                vm.getActions();
            } else {
                clearRuleResponses(false);
            }
        };

        vm.getActions = function () {
            if (!vm.canLoadRuleResponses()) {
                clearRuleResponses(false);
                return;
            }

            var noAction = { id: -1, actionCommand: "No Command" };
            var noMacro = { id: -1, alias: "No Macro" };

            vm.commandList = [];
            vm.macro = [];

            var fleetId = vm.getSelectedFleetId();

            vm.checkIfObjectTypeIsGreengrass(function () {
                if (vm.isGreengrassObjectType) {
                    vm.loadGreengrassActions(noAction, noMacro);
                } else {
                    Macro.byObjectType({ id: vm.warning.tabObjectTypes.id, fleet: fleetId, page: 0, size: 1000 }, onSuccessMacro);
                    TabActions.actionsByObjectType({ id: vm.warning.tabObjectTypes.id }, onSuccess);
                }
            });

            function onSuccess(actions) {
                vm.commandList = actions || [];
                if (vm.warning.action != null) vm.checkArguments();
                vm.commandList.push(noAction);
            }

            function onSuccessMacro(data) {
                vm.macro.length = 0;
                for (var i = 0; i < data.length; i++) vm.macro.push(data[i]);
                vm.macro.push(noMacro);
            }
        };

        vm.checkIfObjectTypeIsGreengrass = function (callback) {
            if (!vm.warning.tabObjectTypes || !vm.warning.tabObjectTypes.id) {
                vm.isGreengrassObjectType = false;
                if (callback) callback();
                return;
            }
            if (vm.warning.tabObjectTypes.greengrassType === true || vm.warning.tabObjectTypes.greengrassType === false) {
                vm.isGreengrassObjectType = vm.warning.tabObjectTypes.greengrassType === true;
                if (callback) callback();
                return;
            }
            if (vm.objectTypeCache[vm.warning.tabObjectTypes.id]) {
                vm.isGreengrassObjectType = vm.objectTypeCache[vm.warning.tabObjectTypes.id].greengrassType === true;
                if (callback) callback();
                return;
            }
            $http.get('api/tab-object-types/' + vm.warning.tabObjectTypes.id)
                .then(function (response) {
                    vm.objectTypeCache[vm.warning.tabObjectTypes.id] = response.data;
                    vm.warning.tabObjectTypes.greengrassType = response.data.greengrassType;
                    vm.isGreengrassObjectType = response.data.greengrassType === true;
                    if (callback) callback();
                })
                .catch(function () {
                    vm.isGreengrassObjectType = false;
                    if (callback) callback();
                });
        };

        vm.getSelectedFleetId = function () {
            if (vm.warning == null || vm.warning.tabFleets == null) return null;
            var fleetId = angular.isArray(vm.warning.tabFleets) ?
                (vm.warning.tabFleets.length > 0 && vm.warning.tabFleets[0] != null ? vm.warning.tabFleets[0].id : null) :
                (vm.warning.tabFleets.id != null ? vm.warning.tabFleets.id : null);
            return (fleetId == null || Number(fleetId) < 1) ? null : fleetId;
        };

        vm.filterResponseCommand = function (search) {
            return function (item) {
                if (item == null) {
                    return false;
                }

                if (search == null || search === '') {
                    return true;
                }

                var text = search.toLowerCase();

                var commandName = item.actionCommand != null ? item.actionCommand.toLowerCase() : '';
                var componentName = item.componentName != null ? item.componentName.toLowerCase() : '';
                var description = item.description != null ? item.description.toLowerCase() : '';

                return commandName.indexOf(text) !== -1 ||
                    componentName.indexOf(text) !== -1 ||
                    description.indexOf(text) !== -1;
            };
        };

        vm.loadGreengrassActions = function (noAction, noMacro) {
            var fleetId = vm.getSelectedFleetId();

            vm.commandList = [noAction];
            vm.macro.length = 0;
            vm.macro.push(noMacro);

            if (vm.warning.tabObjectTypes == null || vm.warning.tabObjectTypes.id == null || fleetId == null) return;

            Macro.queryGreengrassByObjectType({
                objectTypeId: vm.warning.tabObjectTypes.id,
                fleetId: fleetId,
                page: 0,
                size: 1000
            }, function (data) {
                vm.macro.length = 0;
                for (var i = 0; i < data.length; i++) vm.macro.push(data[i]);
                vm.macro.push(noMacro);
            }, function () {
                vm.macro.length = 0;
                vm.macro.push(noMacro);
            });

            $http.get('api/tab-objects/with-manifest', { params: { fleetId: fleetId, typeId: vm.warning.tabObjectTypes.id } })
                .then(function (response) {
                    return CommandManifest.get({ objectUniqueCode: response.data.objectUniqueCode }).$promise;
                })
                .then(function (manifestData) {
                    vm.processManifestTemplate(manifestData, noAction);
                })
                .catch(function (error) {
                    vm.commandList = [noAction];
                    // if (error.status === 404) {
                    //    AlertService.error('No Greengrass manifest available for the selected object type and fleet.');
                    // } else {
                    //    AlertService.error('Error loading commands from manifest');
                    // }
                });
        };

        vm.processManifestTemplate = function (manifestData, noAction) {
            vm.commandList = [];

            if (!manifestData || !manifestData.manifest) {
                vm.commandList.push(noAction);
                return;
            }

            var manifest = manifestData.manifest.manifest ? manifestData.manifest.manifest : manifestData.manifest;
            var commandIndex = 0;

            angular.forEach(manifest, function (commands, componentName) {
                angular.forEach(commands, function (command) {
                    if (command.command_name) {
                        vm.commandList.push({
                            id: 'manifest_' + commandIndex,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            componentName: command.component || componentName,
                            manifestCommand: true,
                            argumentsSchema: command.argumentsSchema || command.arguments_schema || command.schema || buildArgumentsSchemaFromManifestArguments(command.arguments),
                            weight: command.weight || 1,
                            permissionLevel: command.permission_level || command.permissionLevel || 0
                        });
                        commandIndex++;
                    }
                });
            });

            vm.restoreGreengrassCommandSelection();
            vm.commandList.push(noAction);
        };

        vm.restoreGreengrassCommandSelection = function () {
            var commandName = vm.getGreengrassCommandName();
            var target = vm.getGreengrassTarget();
            if (commandName == null) return;
            for (var i = 0; i < vm.commandList.length; i++) {
                if (vm.commandList[i].actionCommand === commandName && (target == null || vm.commandList[i].componentName === target)) {
                    vm.warning.action = vm.commandList[i];
                    vm.checkArguments();
                    return;
                }
            }
        };

        vm.getGreengrassCommandName = function () {
            if (vm.warning != null && vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                return vm.warning.greengrassCommandName;
            }

            if (vm.warning == null || vm.warning.actionArguments == null) {
                return null;
            }

            try {
                return angular.fromJson(vm.warning.actionArguments)[vm.GREENGRASS_COMMAND_KEY];
            } catch (e) {
                return null;
            }
        };

        vm.getGreengrassTarget = function () {
            if (vm.warning != null && vm.warning.greengrassTarget != null && vm.warning.greengrassTarget !== '') {
                return vm.warning.greengrassTarget;
            }

            if (vm.warning == null || vm.warning.actionArguments == null) {
                return null;
            }

            try {
                return angular.fromJson(vm.warning.actionArguments)[vm.GREENGRASS_TARGET_KEY];
            } catch (e) {
                return null;
            }
        };

        vm.onMacroChange = function () {
            if (vm.warning.macro != null && vm.warning.macro.id != null && vm.warning.macro.id != -1) {
                vm.warning.action = null;
                vm.formSchemas = null;
            }
        };

        if (vm.warning.$promise) {
            vm.warning.$promise.then(function () {
                if (vm.warning.id === null && vm.warning.cloned !== true) {
                    vm.compose = true;
                    vm.isGreengrassObjectType = false;
                    clearRuleResponses(false);
                } else {
                    vm.compose = vm.warning.composed;
                }

                vm.loadMetric();
            });
        }

        function findType(name) {
            name = name.replace(/\s/g, '');
            var obj = $filter('filter')(vm.metric, { name: name });
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].name === name) return obj[i].type;
            }
        }

        function getEditQuery() {
            vm.originalQuery = vm.warning.query;
            localStorage.setItem("originalQuery", JSON.stringify(vm.originalQuery));
            if (vm.warning.composed) {
                vm.lastQuery = vm.warning.query;
                var modifiedQuery = vm.warning.query.replace(/"/g, '');
                modifiedQuery = modifiedQuery.replace(/\!\(!/g, "!");
                if (modifiedQuery.endsWith(")")) modifiedQuery = modifiedQuery.slice(0, -1);
                vm.modifiedQuery = modifiedQuery;
                var op = modifiedQuery.split(" ");
                vm.operator = [];
                for (var i = 0; i < op.length; i++) {
                    if (op[i] === "AND") vm.operator.push({ name: "AND" });
                    if (op[i] === "OR") vm.operator.push({ name: "OR" });
                }
                var query = modifiedQuery.split("AND");
                var subQuery = [];
                for (var i = 0; i < query.length; i++) {
                    var app = query[i].split("OR");
                    for (var j = 0; j < app.length; j++) subQuery.push(app[j]);
                }
                query = subQuery;
                subQuery = [];
                for (var i = 0; i < query.length; i++) {
                    var app = query[i].split(":");
                    for (var j = 0; j < app.length; j++) subQuery.push(app[j]);
                }
                vm.quantity = vm.operator.length + 1;
                vm.tempMetric = [];
                for (var i = 0; i < query.length; i++) {
                    var app = {};
                    if (subQuery[i * 2] === "_exists_" || subQuery[i * 2] === "!_exists_" ||
                        subQuery[i * 2] === " _exists_" || subQuery[i * 2] === " !_exists_") {
                        if (subQuery[i * 2] === "_exists_" || subQuery[i * 2] === " _exists_") {
                            app.name = subQuery[(i * 2) + 1];
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            vm.checkType.push("Exists");
                        } else {
                            app.name = subQuery[(i * 2) + 1];
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            vm.checkType.push("Not Exists");
                        }
                        pushExistsNullMetric();
                    } else {
                        var equals = true;
                        switch (subQuery[(i * 2) + 1].charAt(0)) {
                            case "<":
                                if (subQuery[(i * 2) + 1].charAt(1) === "=") {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('<', '').replace('=', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower equals");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('<', true, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower equals");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var value = subQuery[(i * 2) + 1].replace(/\s/g, '').replace('<', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('<', false, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                }
                                break;
                            case ">":
                                if (subQuery[(i * 2) + 1].charAt(1) === "=") {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('>', '').replace('=', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater equals");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('>', true, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater equals");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('>', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('>', false, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                }
                                break;
                            case "[":
                                var subQueryD = query[i].split(":");
                                var subQueryDate = "";
                                for (var j = 1; j < subQueryD.length; j++) subQueryDate += subQueryD[j];
                                app.name = subQueryD[0];
                                app.type = findType(app.name);
                                if (app.type === "date") {
                                    vm.tempMetric.push(app);
                                    vm.checkType.push("Between");
                                    subQueryD = subQueryDate.split("TO");
                                    if (subQueryD[0].charAt(1) === "n") {
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.relativeDate.length != (vm.tempMetric.length - 1)) {
                                                vm.relativeDate.push(null); vm.relativeDateB.push(null);
                                                vm.relativeDateNumber.push(null); vm.relativeDateNumberB.push(null);
                                                vm.relativeDateSimbol.push(null); vm.relativeDateSimbolB.push(null);
                                            }
                                            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                                                vm.formDate.push(null); vm.typeDateForm.push(null);
                                            }
                                        }
                                        var relativeA = subQueryD[0].replace(/\s/g, '').replace('[', '');
                                        var relativeB = subQueryD[1].replace(/\s/g, '').replace(']', '');
                                        relativeA.length == 3 ? pushRelativeDateValue(null, null, null, null) :
                                            pushRelativeDateValue(relativeA.charAt(relativeA.length - 1), parseInt(relativeA.substring(4, relativeA.length - 1)), relativeA.charAt(3), relativeA);
                                        relativeB.length == 3 ? pushRelativeDateValueB(null, null, null, null) :
                                            pushRelativeDateValueB(relativeB.charAt(relativeB.length - 1), parseInt(relativeB.substring(4, relativeB.length - 1)), relativeB.charAt(3), relativeB);
                                        vm.formDate.push(false);
                                        vm.typeDateForm.push("relative");
                                    } else {
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedDateA.length != (vm.tempMetric.length - 1)) {
                                                vm.expectedDateA.push(null); vm.expectedDateB.push(null);
                                            }
                                            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                                                vm.formDate.push(null); vm.typeDateForm.push(null);
                                            }
                                        }
                                        var dateA = subQueryD[0].replace('"', '').replace(/\s/g, '').replace('[', '');
                                        var dateB = subQueryD[1].replace('"', '').replace(/\s/g, '').replace(']', '');
                                        vm.expectedDateA.push(new Date(dateA));
                                        vm.expectedDateB.push(new Date(dateB));
                                        vm.expected.push(null); vm.expectedB.push(null);
                                        vm.formDate.push(false); vm.typeDateForm.push("absolute");
                                    }
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    vm.tempMetric.push(app);
                                    vm.checkType.push("Between");
                                    var v = subQuery[(i * 2) + 1].split("TO");
                                    v[0] = v[0].replace(/\s/g, '').replace('[', '');
                                    v[1] = v[1].replace(/\s/g, '').replace(']', '');
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expectedA.length != (vm.tempMetric.length - 1)) vm.expectedA.push(null);
                                    }
                                    if (app.type === "float") {
                                        vm.expectedA.push(parseFloat(v[0]));
                                        vm.expectedB.splice(vm.expectedA.length - 1, 1, parseFloat(v[1]));
                                    } else {
                                        vm.expectedA.push(parseInt(v[0]));
                                        vm.expectedB.splice(vm.expectedA.length - 1, 1, parseInt(v[1]));
                                    }
                                }
                                equals = false;
                                break;
                        }
                        if (equals) {
                            app.name = subQuery[(i * 2)].replace(/\s/g, '');
                            vm.checkType.push(app.name.charAt(0) === "!" ? "Not Equals" : "Equals");
                            app.name = subQuery[(i * 2)].replace('!', '');
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            if (findType(app.name) === "date") {
                                var date = subQuery[(i * 2) + 1].replace(/\s/g, '').replace('>', '');
                                date = date.substring(1, date.length - 1);
                                for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                    if (vm.expectedDate.length != (vm.tempMetric.length - 1)) vm.expectedDate.push(null);
                                }
                                vm.expectedDate.push(new Date(date));
                                vm.formDate.push(false); vm.typeDateForm.push("absolute");
                            } else {
                                var value = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                if (/^-?[\d.]+(?:e-?\d+)?$/.test(value)) {
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                    }
                                    vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                } else {
                                    var str = subQuery[(i * 2) + 1].replace(/\"/g, '').replace(/\s/g, '');
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expected.length != (vm.tempMetric.length - 1)) {
                                            vm.expected.push(null); vm.expectedB.push(null);
                                        }
                                    }
                                    vm.expected.push(str);
                                }
                            }
                            vm.expectedB.push(null);
                        }
                    }
                }
            }
        }

        function pushRelativeDateValueB(valueD, ValueDN, ValueDS, exp) {
            vm.relativeDateB.push(valueD); vm.relativeDateNumberB.push(ValueDN);
            vm.relativeDateSimbolB.push(ValueDS); vm.expectedB.push(exp);
        }

        function pushRelativeDateValue(valueD, ValueDN, ValueDS, exp) {
            vm.relativeDate.push(valueD); vm.relativeDateNumber.push(ValueDN);
            vm.relativeDateSimbol.push(ValueDS); vm.expected.push(exp);
        }

        function removeChar(charComp, isEquals, date) {
            date = date.replace(/\s/g, '');
            date = charComp === '>' ? date.replace('>', '') : date.replace('<', '');
            if (isEquals) date = date.replace('=', '');
            date = date.substring(1, date.length - 1);
            for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                if (vm.expectedDate.length != (vm.tempMetric.length - 1)) vm.expectedDate.push(null);
            }
            vm.expectedDate.push(new Date(date));
            vm.formDate.push(false); vm.typeDateForm.push("absolute");
        }

        function pushRelativeDate() {
            if (vm.relativeDate.length != (vm.tempMetric.length - 1)) {
                vm.relativeDate.push(null); vm.relativeDateNumber.push(null); vm.relativeDateSimbol.push(null);
                vm.relativeDateB.push(null); vm.relativeDateNumberB.push(null); vm.relativeDateSimbolB.push(null);
            }
            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                vm.formDate.push(null); vm.typeDateForm.push(null);
            }
        }

        function relativeDate(value) {
            if (value.length == 3) {
                pushDateFromRelative(null, null, null, null, null, null, null, null);
            } else {
                pushDateFromRelative(value.charAt(value.length - 1), parseInt(value.substring(4, value.length - 1)), value.charAt(3), null, null, null, value, null);
            }
            vm.formDate.push(false); vm.typeDateForm.push("relative");
        }

        function pushDateFromRelative(relD, relDN, relDS, relDB, relDNB, relDSB, exp, expB) {
            vm.relativeDate.push(relD); vm.relativeDateNumber.push(relDN); vm.relativeDateSimbol.push(relDS);
            vm.relativeDateB.push(relDB); vm.relativeDateNumberB.push(relDNB); vm.relativeDateSimbolB.push(relDSB);
            vm.expected.push(exp); vm.expectedB.push(expB);
        }

        function pushExistsNullMetric() {
            vm.expected.push(null); vm.expectedNumber.push(null); vm.expectedA.push(null); vm.expectedB.push(null);
            vm.expectedDate.push(null); vm.expectedDateA.push(null); vm.expectedDateB.push(null);
            vm.relativeDate.push(null); vm.relativeDateB.push(null); vm.relativeDateSimbol.push(null);
            vm.relativeDateSimbolB.push(null); vm.relativeDateNumber.push(null); vm.relativeDateNumberB.push(null);
        }

        vm.checkArguments = function () {
            if (vm.warning.action == null || vm.warning.action.id == null || vm.warning.action.id == -1) {
                $scope.formSchema = [];
                vm.formSchemas = null;
                return;
            }

            if (vm.warning.action != null && vm.warning.action.id != null && vm.warning.action.argumentsSchema != null) {
                $scope.formSchema = [];
                var data = vm.warning.action;
                var jArg = parseArgumentSchema(data.argumentsSchema);

                if (jArg == null || jArg.properties == null || Object.keys(jArg.properties).length === 0) {
                    vm.formSchemas = null;
                    return;
                }

                var first = Object.keys(jArg.properties)[0];
                if (jArg.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties).length;
                    Object.keys(jArg.properties).forEach(function (val) {
                        orderProps.splice(Number(jArg.properties[val].order) - 1, 1, vm.getEntry(jArg, val, null));
                    });
                    orderProps.forEach(function (val) { $scope.formSchema.push(val); });
                } else {
                    Object.keys(jArg.properties).forEach(function (val) {
                        $scope.formSchema.push(vm.getEntry(jArg, val, null));
                    });
                }

                vm.formSchemas = {
                    command: data.actionCommand,
                    form: $scope.formSchema,
                    schema: jArg,
                    deviceReleases: data.deviceReleases,
                    actionId: data.id,
                    weight: data.weight
                };

                var savedArgs = getSavedActionArguments();
                Object.keys(jArg.properties).forEach(function (arg) {
                    vm.formSchemas[arg] = normalizeArgumentValue(savedArgs[arg], jArg.properties[arg]);
                });
            }
        };

        vm.onMacroChange = function () {
            if (vm.warning.macro != null && vm.warning.macro.id != null && vm.warning.macro.id != -1) {
                vm.warning.action = null;
                vm.formSchemas = null;
                $scope.formSchema = [];
            }
        };

        vm.onCommandChange = function () {

            // Reset arguments
            vm.warning.actionArguments = null;
            vm.warning.greengrassArguments = null;
            vm.formSchemas = null;
            $scope.formSchema = [];

            if (vm.warning.action != null && vm.warning.action.id != null) {

                // Reset macro
                vm.warning.macro = null;

                // "No command" option selected
                if (vm.warning.action.id === -1) {

                    // Reset action
                    vm.warning.action = null;

                    // Reset greengrass command
                    vm.warning.greengrassCommandName = null;
                    vm.warning.greengrassTarget = null;

                    return;
                }
            }

            vm.checkArguments();
        };

        vm.getEntry = function (jArg, val, arrayName) {
            var entry = {};
            entry.key = arrayName != null ? arrayName + "[]." + val : val;

            var prop = jArg.properties[val];
            var hasTitleMap = prop.hasOwnProperty('titleMap') && Array.isArray(prop.titleMap) && prop.titleMap.length > 0;

            if (hasTitleMap) {
                entry.titleMap = prop.titleMap;
                entry.type = 'select';
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
                if (prop.hasOwnProperty("pending")) {
                    prop.titleMap.forEach(function (title) {
                        if (title.value === prop.pending) prop.pending = title.name;
                    });
                }
            }

            if (prop.type === 'string' && !hasTitleMap) {
                entry.type = prop.format === 'time' ? 'timepicker' : 'text';
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
            }

            if (prop.type === 'boolean') {
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
            }

            if (prop.hasOwnProperty('component') && !hasTitleMap) {
                entry.type = prop.component === 'toggle' ? 'checkbox' : prop.component;
            }

            if (prop.hasOwnProperty('options')) entry.options = prop.options;
            if (prop.hasOwnProperty('style')) entry.style = prop.style;
            if (prop.hasOwnProperty('maxDate')) entry.maxDate = prop.maxDate;
            if (prop.hasOwnProperty('minDate')) entry.minDate = prop.minDate;

            if (prop.hasOwnProperty('format') && prop.format === 'time') {
                if (prop.default && typeof prop.default === 'string') {
                    var timeParts = prop.default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    prop.default = timeDate;
                }
            }

            if (prop.hasOwnProperty('default')) {
                prop.defaultRestore = angular.copy(prop.default);
            }

            var savedDefaults = getSavedActionArguments();

            if (savedDefaults != null && savedDefaults.hasOwnProperty(val)) {
                prop.default = normalizeArgumentValue(savedDefaults[val], prop);
            } else if (!prop.hasOwnProperty('default')) {
                prop.default = getDefaultArgumentValue(prop);
            }

            if (prop.hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(prop.items.properties)[0];
                if (prop.items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(prop.items.properties).length;
                    Object.keys(prop.items.properties).forEach(function (item) {
                        orderProps.splice(Number(prop.items.properties[item].order) - 1, 1, vm.getEntry(prop.items, item, val));
                    });
                    orderProps.forEach(function (val) { entry.items.push(val); });
                } else {
                    Object.keys(prop.items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(prop.items, item, val));
                    });
                }
            }

            return entry;
        };

        vm.refreshIndex = function () {
            vm.warning.index = null;
            vm.tempMetric = [];
        };

        vm.loadMetric = function () {
            vm.addMetric = [{ name: "AND" }, { name: "OR" }];
            vm.checkTypes = ["Exists", "Not Exists", "Equals", "Not Equals"];
            vm.checkTypesNumeric = ["Exists", "Not Exists", "Equals", "Not Equals", "Lower", "Lower equals", "Greater", "Greater equals", "Between"];
            vm.metric = [];
            vm.tempMetric = [];

            if (vm.warning.index === "JoT") {
                TabObjectTypes.getMapping({ id: vm.warning.tabObjectTypes.id }, function (data) {
                    getPropMapping(data.properties);
                    retrieveQuery();
                }, function () {
                    // handled globally by interceptor
                });
            } else {
                var index = vm.warning.index === "TheTailKeepalive" ? { id: 0 } : { id: 1 };
                TabObjectTypes.getMappingByIndex(index, function (data) {
                    getPropMapping(data.properties);
                    retrieveQuery();
                }, function () {
                    // handled globally by interceptor
                });
            }

            function getPropMapping(obj) {
                angular.forEach(obj, function (value, key) {
                    if (value.type == undefined) {
                        angular.forEach(value.properties, function (value, key2) {
                            getProperties(value, key2, key);
                        });
                    } else {
                        vm.metric.push({ name: key, type: value.type });
                    }
                });
                for (var i = 0; i < vm.metric.length; i++) {
                    if (vm.metric[i].name === "date") { vm.metric.splice(i, 1); break; }
                }
            }

            function getProperties(value, key, metric) {
                var subMetric = "." + key.toString();
                if (value.type == undefined) {
                    angular.forEach(value.properties, function (value, key) {
                        getProperties(value, key, metric + subMetric);
                    });
                } else {
                    vm.metric.push({ name: metric + subMetric, type: value.type });
                }
            }

            vm.checkMetricType = function (index) {
                if (vm.tempMetric[index].type === "keyword" || vm.tempMetric[index].type === "boolean" || vm.tempMetric[index].type === "text") return true;
                vm.formDate[index] = vm.tempMetric[index].type === "date" && (vm.typeDateForm[index] === "" || vm.typeDateForm[index] == null);
                return false;
            };

            vm.changeDate = function (index) { vm.formDate[index] = false; };

            vm.changeDateRelative = function (index) {
                if (vm.relativeDateSimbol[index] == null) vm.relativeDateSimbol[index] = "+";
                if (vm.relativeDateNumber[index] == null) vm.relativeDateNumber[index] = 1;
                vm.expected[index] = "now" + vm.relativeDateSimbol[index] + vm.relativeDateNumber[index] + vm.relativeDate[index];
            };

            vm.changeDateRelativeB = function (index) {
                if (vm.relativeDateSimbolB[index] == null) vm.relativeDateSimbolB[index] = "+";
                if (vm.relativeDateNumberB[index] == null) vm.relativeDateNumberB[index] = 1;
                vm.expectedB[index] = "now" + vm.relativeDateSimbolB[index] + vm.relativeDateNumberB[index] + vm.relativeDateB[index];
            };

            vm.checkMetricDate = function (index) { return vm.tempMetric[index].type === "date"; };

            vm.openCalendar = function (e, index) {
                e.preventDefault(); e.stopPropagation();
                vm.metricDate[index] = vm.metricDate[index] ? { isOpen: !vm.metricDate[index].isOpen } : { isOpen: true };
            };

            vm.openDownCalendar = function (e, index) {
                e.preventDefault(); e.stopPropagation();
                vm.metricDateDown[index] = vm.metricDateDown[index] ? { isOpen: !vm.metricDateDown[index].isOpen } : { isOpen: true };
            };

            vm.clearOperator = function (index) {
                vm.operator[index] = null; vm.checkType[index] = null;
                vm.expected[index] = null; vm.expectedNumber[index] = null;
                vm.expectedA[index] = null; vm.expectedB[index] = null;
                vm.expectedDate[index] = null; vm.expectedDateA[index] = null; vm.expectedDateB[index] = null;
                vm.typeDateForm[index] = null; vm.formDate[index] = true;
                vm.relativeDateNumber[index] = null; vm.relativeDate[index] = null; vm.relativeDateSimbol[index] = null;
                vm.relativeDateNumberB[index] = null; vm.relativeDateB[index] = null; vm.relativeDateSimbolB[index] = null;
            };

            vm.addQuantity = function (index) {
                if (index == Object.keys(vm.tempMetric).length - 1) vm.quantity++;
            };
        };

        function retrieveQuery() {
            if (vm.warning.id != null || vm.warning.cloned === true) {
                getEditQuery();
                vm.loadRuleResponsesIfAvailable();
            }
        }

        vm.deleteMetric = function (index) {
            vm.expected.splice(index, 1); vm.expectedNumber.splice(index, 1);
            vm.expectedA.splice(index, 1); vm.expectedB.splice(index, 1);
            vm.expectedDate.splice(index, 1); vm.expectedDateA.splice(index, 1); vm.expectedDateB.splice(index, 1);
            vm.relativeDate.splice(index, 1); vm.relativeDateB.splice(index, 1);
            vm.relativeDateSimbol.splice(index, 1); vm.relativeDateSimbolB.splice(index, 1);
            vm.relativeDateNumber.splice(index, 1); vm.relativeDateNumberB.splice(index, 1);
            vm.checkType.splice(index, 1); vm.tempMetric.splice(index, 1);
            if (vm.tempMetric.length == 1) {
                vm.operator.splice(index - 1, 1);
            } else if (index == vm.tempMetric.length) {
                vm.operator.splice(index - 1, 2);
            } else {
                vm.operator.splice(index, 1);
            }
            vm.quantity--;
        };

        vm.editQuery = function () {
            if (createQuery()) {
                localStorage.setItem("edit-automatic-rule", JSON.stringify(vm.warning));
                $state.go('warning-edit-query');
            }
        };

        function updateNewQuery() {
            var lastQuery = JSON.parse(localStorage.getItem("originalQuery") || "null");
            var newQuery = vm.warning.query;
            if (lastQuery && newQuery && !newQuery.startsWith("!(") && !newQuery.endsWith(")") && /^!\(.*\)$/.test(lastQuery)) {
                vm.warning.query = "!(" + newQuery + ")";
            }
        }

        vm.checkSaveEdit = function () {
            var createQ = createQuery();
            if (createQ) {
                updateNewQuery();
                $uibModal.open({
                    templateUrl: 'app/entities/warning/check-save-edit.html',
                    controller: 'CheckSaveEditController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        query: function () {
                            return {
                                lastQuery: localStorage.getItem("originalQuery"),
                                newQuery: vm.warning.query
                            };
                        }
                    }
                }).result.then(function () {
                    vm.save(createQ);
                    localStorage.removeItem("originalQuery");
                });
            }
        };
        vm.clear = function () {
            $state.go('warning');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningController', WarningController);

    WarningController.$inject = ['$scope', '$uibModal', '$state', 'Warning', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'WarningConstant', 'AlertRules', 'domain', '$timeout'];

    function WarningController($scope, $uibModal, $state, Warning, ParseLinks, AlertService, pagingParams, paginationConstants, WarningConstant, AlertRules, domain, $timeout) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.toggleStatus = toggleStatus;
        vm.transition = transition;
        vm.enableTooltip = enableTooltip;

        vm.predicates = pagingParams.predicates;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.currentState = "warning";
        vm.currentStateFilter = "warning-filter";
        vm.systemWarningItemLimit = 4;
        // retrievedOrder = localStorage.getItem(vm.currentState+"system");
        // if (retrievedOrder != null && retrievedOrder !== "null") {
        //     vm.systemPredicates = JSON.parse(retrievedOrder);
        // }
        vm.charToSearch = pagingParams.search;
        vm.enableMail = [];
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.selectedCondition = {};
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.fleet = {};
        vm.objectType = {};
        vm.selectedFleets = [];
        vm.wac = [];
        vm.domain = domain;

        function enableTooltip(channel, id) {
            vm[channel][id].tooltip = true;
            $timeout(function () {
                vm[channel][id].tooltip = false;
            }, 2000);
        }

        vm.applyFilter = applyFilter;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }

        var filter = localStorage.getItem(vm.currentStateFilter);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.selectedFleet.id = filter.fleet.id;
                vm.selectedObjectType.id = filter.objectType.id;
            }
        }

        vm.loadAll();


        function sort(predicates, type) {
            var sortFields = [];
            var keys = Object.keys(predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState + type, JSON.stringify(predicates));
            return sortFields;
        }

        function loadAll() {
            AlertRules.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id,
                query: vm.charToSearch,
                sort: sort(vm.predicates, "")
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warnings = data.warnings;
                vm.notifications = data.notification;
                vm.page = pagingParams.page;
                enableAlertSystem(vm.warnings);
            }

            AlertRules.querySystem({
                page: pagingParams.systemPage - 1,
                size: vm.systemWarningItemLimit,
                fleet: vm.selectedFleet.id,
                sort: sort(vm.systemPredicates, "system")
            }, onSuccessSystem, onError);

            function onSuccessSystem(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.systemTotalItems = headers('X-Total-Count');
                vm.systemQueryCount = vm.systemTotalItems;
                vm.systemWarnings = data.warnings;
                vm.notifications = data.notification;
                vm.systemPage = pagingParams.systemPage;
                enableAlertSystem(vm.systemWarnings);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function enableAlertSystem(warnings) {
            warnings.forEach(function (warning) {
                if (warning.greengrassArguments == null && warning.actionArguments != null) {
                    try {
                        var args = angular.fromJson(warning.actionArguments);
                        if (args != null && args.__greengrassCommand != null) {
                            warning.greengrassCommandName = args.__greengrassCommand;
                        }
                    } catch (e) {}
                }
                vm.wac[warning.id] = {};
                vm.wac[warning.id].email = false;
                vm.wac[warning.id].telegram = false;
                vm.wac[warning.id].webhook = false;
                warning.warningAlertConfigurations.forEach(function (wac) {
                    var name = wac.alertSystemType.name;
                    vm.wac[warning.id][name] = wac.active;
                });
                if(!(domain.enableAlerting && domain.mailAlerting))
                    warning.relatedAlertSystemType.Channelemail = vm.wac[warning.id].email = domain.enableAlerting && domain.mailAlerting;
                if(!(domain.enableAlerting && domain.telegramAlerting))
                    warning.relatedAlertSystemType.Channeltelegram = vm.wac[warning.id].telegram = domain.enableAlerting && domain.telegramAlerting;
                if(!(domain.enableAlerting && domain.webhookAlerting))
                    warning.relatedAlertSystemType.Channelwebhook = vm.wac[warning.id].webhook = domain.enableAlerting && domain.webhookAlerting;
                var enableMail =  warning.relatedAlertSystemType.email != null && warning.relatedAlertSystemType.email != undefined && warning.relatedAlertSystemType.Channelemail != undefined && warning.relatedAlertSystemType.Channelemail && vm.wac[warning.id].email;
                var enableTelegram = warning.relatedAlertSystemType.telegram != null && warning.relatedAlertSystemType.telegram != undefined && warning.relatedAlertSystemType.Channeltelegram != undefined && warning.relatedAlertSystemType.Channeltelegram && vm.wac[warning.id].telegram;
                var enableWebhook = warning.relatedAlertSystemType.webhook != null && warning.relatedAlertSystemType.webhook != undefined && warning.relatedAlertSystemType.Channelwebhook != undefined && warning.relatedAlertSystemType.Channelwebhook && vm.wac[warning.id].webhook;
                vm.enableMail[warning.id] = vm.setWarningStatus(enableMail, domain.mailAlerting, vm.notifications.warningEmail, warning.relatedAlertSystemType.email, vm.wac[warning.id].email, warning.active);
                vm.enableTelegram[warning.id] = vm.setWarningStatus(enableTelegram, domain.telegramAlerting, vm.notifications.warningTelegram, warning.relatedAlertSystemType.telegram, vm.wac[warning.id].telegram, warning.active);
                vm.enableWebhook[warning.id] = vm.setWarningStatus(enableWebhook, domain.webhookAlerting, vm.notifications.warningWebhook, warning.relatedAlertSystemType.webhook, vm.wac[warning.id].webhook, warning.active);
            });
        }

        vm.setWarningStatus = function (enabled, domainNotification, userNotification, related, wac, warning) {
            var objToReturn = {status: false, config: {}, tooltip: false};
            if (enabled) {
                if (related && domainNotification === true && userNotification === true && warning === true) {
                    objToReturn.status = true;
                    objToReturn.config.color = 'color-green';
                } else {
                    objToReturn.status = true;
                    objToReturn.config.color = 'background-red';
                }
            } else objToReturn.config.color = 'color-grey';
            return objToReturn;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                systemPredicates: vm.systemPredicates,
                sort: sort(vm.predicates, ""),
                systemPage: vm.systemPage,
                systemSort: sort(vm.systemPredicates, "system"),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                fleet: vm.selectedFleet.id,
                objectType: vm.objectType.id
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.changeProfile = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-user-profile-dialog.html',
                controller: 'WarningUserProfileController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            });
        };
        vm.changeLevel = function (warning) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-level-dialog.html',
                controller: 'WarningLevelController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function () {
                        return warning;
                    }]
                }
            }).result.then(function () {
                transition(false);
            });
        };
        vm.openSettings = function (id) {
            $uibModal.open({
                templateUrl: 'app/entities/alert-rules/alert-rules-configuration.html',
                controller: 'AlertsConfigurationController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AlertRules', function ($stateParams, AlertRules) {
                        return AlertRules.get({id: id});
                    }]
                }
            }).result.then(function () {
                loadAll();
            });
        };

        function toggleStatus(warning) {
            if (!!warning.active) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/warning-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/warning-turnoff-dialog.html',
                    controller: function ($uibModalInstance, entity) {
                        var vm = this;
                        vm.warning = entity;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return warning;
                        }
                    }
                }).result.then(function () {
                    warning.active = !warning.active;
                    WarningConstant.update(warning, function () {
                        vm.loadAll();
                    });
                });
            }
        }

        vm.changeStatus = function (warning, type, notification, typeToCheck) {
            // check warning flags here to display proper modal
            if (typeToCheck.status && notification === true) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/modals/change-notification-channel.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;
                        vm.warning = warning;
                        vm.type = type;
                        vm.notification = notification;
                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                    AlertRules.notifications({id: warning.id, type: type}, onChangeSuccess, onChangeError);
                });
            } else {
                vm.rerouteToSettings(vm.notifications, vm.domain, type, typeToCheck);
            }
        };

        vm.rerouteToSettings = function (userNotifications, domain, type, typeToCheck) {
            $uibModal.open({
                templateUrl: 'app/entities/warning/modals/reroute-modal.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;
                    vm.notification = null;
                    vm.warningCondition = null;
                    vm.domain = domain;
                    vm.type = type
                    vm.typeToCheck = typeToCheck;
                    if (vm.domain.enableAlerting === true) {
                        if (type === 'email') {
                            vm.notification = userNotifications.warningEmail;
                            vm.warningCondition = vm.domain.mailAlerting;
                        } else if (type === 'telegram') {
                            vm.notification = userNotifications.warningTelegram;
                            vm.warningCondition = vm.domain.telegramAlerting;
                        } else {
                            vm.notification = userNotifications.warningWebhook;
                            vm.warningCondition = vm.domain.webhookAlerting;
                        }
                    } else {
                        vm.warningCondition = vm.domain.enableAlerting;
                    }

                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result.then(function () {
                $state.go('general-settings');
            });
        };

        function onChangeSuccess(warning) {
            vm.warnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.warnings);
            vm.systemWarnings.forEach(function (warn) {
                if (warn.id == warning.id)
                    warn.relatedAlertSystemType = warning.relatedAlertSystemType;
            });
            enableAlertSystem(vm.systemWarnings);
        }

        function onChangeError() {

        }

        function applyFilter(fleet, objectType) {
            var filter = {};
            if (fleet.id) {
                if (fleet.id > 0)
                    filter.fleet = vm.fleet = fleet;
                else {
                    vm.fleet = [];
                    filter.fleet = vm.fleet = vm.selectedFleets;
                }
            } else
                filter.fleet = vm.fleet.id = -1;
            if (objectType.id)
                filter.objectType = vm.objectType = objectType;
            else
                filter.objectType = vm.objectType.id = -1;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        vm.notificationsHelp = function () {
            $uibModal.open({
                templateUrl: 'app/entities/warning/notifications-help.html',
                controller: 'NotificationsHelpController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.go('warning');
            });
        };

        vm.toggleRuleListComposition = function (toggle) {
            vm.selectingRules = !toggle;
            vm.selectedRules = [];
        }

        vm.sendRuleEmail = function () {
            $uibModal.open({
                templateUrl: 'app/entities/warning/email/selected-rules-email.html',
                controller: 'SelectedRulesEmailController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static'
            }).result.then(function (result) {
                sendRulesEmail(result)
            });
        }

        function sendRulesEmail(auth) {
            AlertRules.requestSendEmail(auth, onSuccessEmail, onErrorEmail);

            function onSuccessEmail() {
                AlertService.success("JoT will send the rules to user inbox.");
            }

            function onErrorEmail() {
                AlertService.error("Generic Error");
            }
        }
    }

})();
;
(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Warning', Warning)
        .factory('WarningConstant', WarningConstant);

    Warning.$inject = ['$resource'];
    WarningConstant.$inject = ['$resource'];

    function Warning ($resource) {
        var resourceUrl =  'api/warnings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getClone': {
                url: 'api/warnings/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function WarningConstant ($resource) {
        var resourceUrl =  'api/warnings/status';

        return $resource(resourceUrl, {}, {
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('warning', {
            parent: 'alerting',
            url: '/admin/rules?page&sort&search&systemPage&systemSort',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warnings.html',
                    controller: 'WarningController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    squash: true
                },
                systemPage: {
                    value: '1',
                    squash: true
                },
                systemSort: {
                    squash: true
                },
                fleet: {
                    value: -1,
                    fleetName: true
                },
                objectType:{
                    value: -1,
                    squash: true
                },
                search: null,
                predicates : {},
                systemPredicates : {},
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                        systemSort: $stateParams.systemSort,
                        predicates : $stateParams.predicates,
                        systemPredicates : $stateParams.systemPredicates,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', function(TabDomains) {
                    return  TabDomains.current();
                }]
            }
        })
        .state('warning-detail', {
            parent: 'warning',
            url: '/admin/rule/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-detail.html',
                    controller: 'WarningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.get({id : $stateParams.id});
                }]
            }
        })
        .state('warning-new', {
            parent: 'warning',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        type: $stateParams.type
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        query: null,
                        description: null,
                        active: false,
                        channel: null,
                        message: null,
                        level: null,
                        frequency: null,
                        id: null
                    };
                }
            }
        })
        .state('warning-edit', {
            parent: 'warning',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.get({id : $stateParams.id});
                }]
            }
        })
        .state('warning-clone', {
            parent: 'warning',
            url: '/{id}/clone',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog.html',
                    controller: 'WarningDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Warning', function($stateParams, Warning) {
                    return Warning.getClone({id : $stateParams.id}).$promise.then(function (data) {
                        data.cloned = true;
                        return data;
                    });
                }]
            }
        })
        .state('warning.delete', {
            parent: 'warning',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/warning/warning-delete-dialog.html',
                    controller: 'WarningDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warning');
                            $translatePartialLoader.addPart('alertRules');
                            return $translate.refresh();
                        }],
                        entity: ['Warning', function(Warning) {
                            return Warning.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('warning', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('warning-edit-query', {
            parent: 'warning',
            url: '/edit-query',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.alertRules.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/warning/warning-dialog-query.html',
                    controller: 'WarningDialogQueryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('alertRules');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('AsideController', AsideController);

    AsideController.$inject = ['$state', 'Principal', 'ENV', 'Macro', 'Queue', 'LicenceCode', '$rootScope'];

    function AsideController($state, Principal, ENV, Macro, Queue, LicenceCode, $rootScope) {
        var vm = this;

        // vm.isAsideCollapse = false;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        // vm.toggleAside = toggleAside;
        // vm.collapseAside = collapseAside;
        vm.$state = $state;

        vm.homeTemplate = 'app/layouts/aside/templates/home.html';
        vm.monitoringTemplate = 'app/layouts/aside/templates/monitoring.html';
        vm.controlTemplate = 'app/layouts/aside/templates/control.html';
        vm.systemTemplate = 'app/layouts/aside/templates/system.html';
        vm.alertingTemplate = 'app/layouts/aside/templates/alerting.html';
        vm.updatesTemplate = 'app/layouts/aside/templates/updates.html';
        vm.kioskTemplate = 'app/layouts/aside/templates/kiosk.html';
        vm.kioskTemplateAdmin = 'app/layouts/aside/templates/kioskAdmin.html';
        vm.testingTemplate = 'app/layouts/aside/templates/testing.html';
        vm.administrationTemplate = 'app/layouts/aside/templates/administration.html';


        vm.set

        vm.toggleAside = function() {
            if (window.screen.width <= 990) {
                $('.navbar-collapse').collapse('hide');
            }
        }

        // function collapseAside() {
        //     vm.isAsideCollapse = true;
        // }

        Macro.query({id: -1, page: vm.page}, onSuccessMacro, onErrorMacro);

        LicenceCode.activeLicence({id: -1, page: vm.page}, onSuccess, onError);

        function onSuccessMacro(data) {
            vm.macro = [];
            for (var i = 0; i < data.length; i++) {
                vm.macro.push(data[i]);
            }
            if (vm.macro.length != 0) {
                vm.showMacro = true;
            }

        }

        function onErrorMacro() {

        }

        function onSuccess(data) {
            if (data.length > 0) {
                vm.showLicences = true;
            }
        }

        function onError() {
        }

        //close open tab on click on other menu element
        var $myGroup = $('.page-sidebar-menu');
        $myGroup.on('show.bs.collapse', '.collapse', function () {
            $myGroup.find('.collapse.in').collapse('hide');
        });
        $('.page-sidebar-menu > li > a.nav-link:not(.nav-toggle)').on('click', function () {
            $myGroup.find('.collapse.in').collapse('hide');
        });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ENV', 'Context', 'User', 'MaintenanceSettingsService', '$cookies', '$filter', '$rootScope'];

    function NavbarController($state, Auth, Principal, ENV, Context, User, MaintenanceSettingsService, $cookies, $filter, $rootScope) {
        var vm = this;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.restoreUser = restoreUser;
        vm.closeMaintenanceMessage = closeMaintenanceMessage;
        vm.togglePopup = togglePopup;
        vm.$state = $state;
        vm.domainName = '';
        vm.domainId = 0;
        vm.maintenance = {};
        vm.isMaintenance = false;
        vm.popupToggled = false;
        getDomainName();
        vm.licence = $rootScope.licence;

        vm.maintUserCheck = angular.isDefined($cookies.get("maintenance"));

        MaintenanceSettingsService.getMaintenanceDetailSetting().$promise.then(function (data) {
            vm.maintenance = data;
            vm.isMaintenance = new Date(data.releaseDate).getTime() > new Date().getTime();
        });

        Context.query().$promise.then(
            function (resp) {
                vm.domains = resp;
            });

        function getDomainName() {
            Principal.identity().then(function (data) {
                vm.username = data.login;
                vm.impersonated = data.impersonatedUser;
                vm.domainName = data.context.domainName;
                if(data.context.licenseExpirationDate != null) {
                    var today = new Date();
                    var expiration = new Date(data.context.licenseExpirationDate);
                    var distance = parseInt((expiration - today) / (1000 * 60 * 60 * 24)) + 1;
                    if (distance < 30) {
                        vm.expirationDate = data.context.licenseExpirationDate;
                        if (distance > 1) {
                            vm.expireDays = 'in ' + distance + " days";
                        } else {
                            vm.expireDays = 'tomorrow';
                        }
                    }
                }
                vm.domainId = data.context.id;
            }, function () {
                vm.domainName = 'N/D';
            });
        }

        function login() {
            $state.go('login');
        }

        Principal.identity().then(function (account) {
            vm.domainContext = account.context.domainName;
        });

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function restoreUser() {
            User.restore();
            $state.go("context", null, {reload: true});
        }

        function closeMaintenanceMessage() {
            vm.maintUserCheck = true;
            $cookies.put("maintenance", "close", {expires: vm.maintenance.releaseDate});
            if (vm.popupToggled){
                togglePopup();
            }
        }

        function togglePopup() {
            vm.popupToggled = !vm.popupToggled;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActionCommandsController', ActionCommandsController);

    ActionCommandsController.$inject = ['$rootScope', '$scope', '$state', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'id', 'Queue', 'Macro', '$uibModal', '$filter','$timeout', '$window', '$interval', 'CommandManifest'];

    function ActionCommandsController($rootScope, $scope, $state, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, id, Queue, Macro, $uibModal, $filter, $timeout, $window, $interval, CommandManifest) {
        var vm = this;
        var commandStash = {};

        vm.commandToSend = false;
        vm.tabObjects = [];
        vm.predicates = {};
        vm.page = 0;
        vm.tabActionsQueue = {commands: [], object: {}};
        vm.tabActionsQueue.isCron = false;
        vm.tabActionsQueue.alias = "";
        vm.charToSearch = "";
        vm.currentState = "action-commands";
        vm.actionDeviceReleaseMap = {};
        vm.clickMacro = false;
        vm.commandStash = [];
        vm.originalTable = [];
        vm.isQueue = true;
        vm.commAside = false;
        vm.redrawInterval = null;
        vm.isGreengrassObject = false; // Track if current object is Greengrass type
        //boolean to set page ready
        vm.pageReady = false;

        vm.init = function (){
            vm.licence = $rootScope.licence;
            vm.setAsideTop();
            $scope.$on("sf-render-finished", function(){
                $interval.cancel(vm.redrawInterval);
                vm.redrawInterval = $interval(function (){
                    vm.resizeTrigger();
                    $interval.cancel(vm.redrawInterval);
                }, 10);
            })
        };

        window.addEventListener('resize', function (){
            vm.setAsideTop();
        });

        vm.resizeTrigger = function (){
            $window.dispatchEvent(new Event("resize"));
        };

        vm.setAsideTop = function (){
            var headerHeight = $(".navbar-fixed-top").height();
            $(".command-sidebar-aside").css('top', headerHeight + 25);
            $(".aside-open-button").css('top',headerHeight + 35);
        }

        vm.toggleQueue = function() {
            vm.isQueue = !vm.isQueue;
            vm.showSchedule = undefined;
        };

        if (id !== null && id !== undefined) {
            TabObjects.get({id: id}).$promise.then(function (data) {
                vm.obj = data;
                vm.fetchActions(data);
            });
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.selectObject = function (obj) {
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.loadAll = function () {
            var requestedQuery = vm.charToSearch;

            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                // scarta risposte obsolete
                if (requestedQuery !== vm.charToSearch) {
                    console.log('Ignoring obsolete response for: ' + requestedQuery + " current search is: " + vm.charToSearch);
                    return;
                }
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.pageReady = true;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.commandStash = [];
            vm.commAside = false;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        // Helper to recompute vm.clickMacro based on actual stash contents
        function updateClickMacroFlag() {
            vm.clickMacro = vm.commandStash.some(function(cmd) {
                return cmd.macro === true;
            });
        }

        vm.fetchActions = function (obj) {
            vm.tabActionsQueue.commands = [];
            vm.tabActionsQueue.object = obj;

            // Track if current object is Greengrass type
            vm.isGreengrassObject = obj.objectType && obj.objectType.greengrassType === true;

            // Check if Greengrass object is offline
            function onSuccessMacro(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }
            }

            function onErrorMacro(error) {
                console.error('Error fetching  macros:', error);
                AlertService.error('Failed to fetch macros for object');
            }
            // Check if greengrassType is true
            if (obj.objectType && obj.objectType.greengrassType === true) {

                // Call CommandManifest service for greengrass objects
                if (typeof CommandManifest !== 'undefined' && CommandManifest !== null) {
                    CommandManifest.get({objectUniqueCode: obj.objectUniqueCode}, onSuccessManifest, onErrorManifest);

                    function onSuccessManifest(manifestData) {
                        // Fetch Greengrass macros
                        Macro.queryGreengrass({id: obj.id, page: vm.page}, onSuccessMacro, onErrorMacro);
                        var transformedData = transformManifestToTabActions(manifestData, obj);
                        onSuccess(transformedData);
                    }

                    function onErrorManifest(error) {
                        AlertService.error(error.data.message);
                    }
                } else {
                    console.error('CommandManifest service is not defined!');
                    AlertService.error('CommandManifest service is not available');
                }
            } else {
                // Original flow for non-greengrass objects
                Macro.query({id: obj.id, page: vm.page}, onSuccessMacro, onErrorMacro);

                TabActions.command({id: obj.id}, onSuccess, onError);
            }

            function transformManifestToTabActions(manifestData, obj) {
                var result = [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data:', manifestData);
                    return result;
                }

                console.log('%c=== GREENGRASS MANIFEST TRANSFORMATION ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Original Greengrass manifest data:', manifestData);

                Object.keys(manifestData.manifest).forEach(function(componentName) {
                    var commands = manifestData.manifest[componentName];

                    console.log('%cProcessing component: ' + componentName, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in component:', commands);

                    commands.forEach(function(command, index) {
                        var argumentsSchema = null;

                        if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                            (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {

                            argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                        }

                        var tabAction = {
                            id: 1000 + result.length,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            permissionLevel: command.permission_level || 1,
                            weight: command.weight || 1,
                            argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                            deviceReleases: {
                                id: 500 + result.length,
                                deviceReleaseName: componentName,
                                deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                isActive: true,
                                deviceReleaseVersion: '1.0.0',
                                device: {
                                    id: 200 + result.length,
                                    deviceName: componentName.split('.').pop(),
                                    deviceDescription: 'Greengrass device for ' + componentName,
                                    isActive: true,
                                    isVisibile: true,
                                    deviceType: {
                                        id: 100,
                                        deviceTypeName: 'Greengrass Component Type',
                                        deviceTypeDescription: 'AWS IoT Greengrass Component',
                                        isActive: true,
                                        isVisibile: true,
                                        entityId: 100
                                    },
                                    entityId: 200 + result.length
                                },
                                entityId: 500 + result.length
                            }
                        };

                        console.log('%cCommand #' + (index + 1) + ': ' + command.command_name, 'color: #FF9800;');
                        console.log('  - Arguments Schema:', argumentsSchema);
                        console.log('  - Transformed TabAction:', tabAction);

                        result.push(tabAction);
                    });
                });

                console.log('%c=== TRANSFORMATION COMPLETE ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Total commands transformed:', result.length);
                console.log('Final result:', result);

                return result;
            }

            function convertGreengrassArgumentsToJsonSchema(greengrassArgs) {
                var properties = {};
                var required = [];
                var order = 1;

                console.log('  Converting arguments:', greengrassArgs);

                var argsArray = Array.isArray(greengrassArgs) ? greengrassArgs :
                    (typeof greengrassArgs === 'object' ? [] : []);

                if (argsArray.length === 0 && typeof greengrassArgs === 'object' && !Array.isArray(greengrassArgs)) {
                    console.log('  No arguments to convert');
                    return null;
                }

                argsArray.forEach(function(arg) {
                    var key = arg.key;
                    var props = arg.props || {};

                    var property = {
                        description: props.description || props.label || '',
                        title: key,
                        type: mapGreengrassTypeToJsonSchemaType(arg.type)
                    };

                    if (arg.defaultValue !== undefined && arg.defaultValue !== null) {
                        property.default = arg.defaultValue;
                    }

                    property.order = order++;

                    if (arg.type === 'timepicker') {
                        property.format = 'time';
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                        property.options = {
                            step: 1,
                            floor: props.min !== undefined ? props.min : 0,
                            ceil: props.max !== undefined ? props.max : 100
                        };
                        property.minimum = props.min;
                        property.maximum = props.max;
                        if (props.thumbLabel !== undefined) {
                            property.thumbLabel = props.thumbLabel;
                        }
                    }

                    if (arg.type === 'select' && props.options && props.options.length > 0) {
                        property.titleMap = props.options.map(function(option) {
                            return {
                                name: option.label,
                                value: String(option.value)
                            };
                        });

                        property.enum = props.options.map(function(option) {
                            return String(option.value);
                        });

                        if (property.default !== undefined && property.default !== null) {
                            property.default = String(property.default);
                        }
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                    }

                    if (props.required) {
                        required.push(key);
                    }

                    properties[key] = property;

                    console.log('  - Property "' + key + '":', property);
                });

                var schema = {
                    metricReference: {},
                    type: 'object',
                    properties: properties
                };

                if (required.length > 0) {
                    schema.required = required;
                }

                console.log('  Final schema:', schema);

                return schema;
            }

            function mapGreengrassTypeToJsonSchemaType(greengrassType) {
                switch(greengrassType) {
                    case 'slider':
                        return 'number';
                    case 'toggle':
                        return 'boolean';
                    case 'text':
                    case 'input':
                    case 'timepicker':
                        return 'string';
                    case 'select':
                        return 'string';
                    default:
                        return 'string';
                }
            }



            function onSuccess(data) {
                console.log('%c=== FORM CREATION FROM DATA ===', 'color: #9C27B0; font-weight: bold; font-size: 14px;');
                console.log('Data received in onSuccess:', data);

                vm.tabActions = [];
                vm.formSchemas = {
                    forms: [],
                    buttons: []
                };
                for (var i = 0; i < data.length; i++) {
                    $scope.formSchema = [];
                    vm.tabActions.push(data[i]);
                    vm.actionDeviceReleaseMap[data[i].actionCommand] = {
                        idAction: data[i].id,
                        deviceReleases: {
                            deviceReleaseName: data[i].deviceReleases.deviceReleaseName
                        },
                        permissionLevel: data[i].permissionLevel
                    };

                    console.log('%cProcessing command: ' + data[i].actionCommand, 'color: #9C27B0; font-weight: bold;');

                    if (data[i].argumentsSchema != null) {
                        var jArg = angular.fromJson(data[i].argumentsSchema);
                        console.log('  Parsed argumentsSchema:', jArg);

                        var first = Object.keys(jArg.properties)[0];
                        if (jArg.properties[first].hasOwnProperty('order')) {
                            console.log('  Using ORDER-based sorting');
                            var orderProps = [];
                            orderProps.length = Object.keys(jArg.properties).length;
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                orderProps.splice(Number(jArg.properties[val].order) - 1, 1, entry);
                            });
                            orderProps.forEach(function (val) {
                                $scope.formSchema.push(val);
                            });
                        } else {
                            console.log('  Using NATURAL ordering');
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                $scope.formSchema.push(entry);
                            });
                        }

                        var formToAdd = {
                            command: data[i].actionCommand,
                            description: data[i].description,
                            form: $scope.formSchema,
                            schema: jArg,
                            weight: data[i].weight,
                            showPending: false
                        };

                        Object.keys(jArg.properties).forEach(function(propKey) {
                            if (jArg.properties[propKey].hasOwnProperty('default')) {
                                formToAdd[propKey] = jArg.properties[propKey].default;
                            }
                        });

                        console.log('  Form to add:', formToAdd);
                        vm.formSchemas.forms.push(formToAdd);
                    } else {
                        console.log('  No arguments - adding as BUTTON');
                        vm.formSchemas.buttons.push({
                            command: data[i].actionCommand
                        });
                    }
                }

                console.log('%cFinal formSchemas:', 'color: #9C27B0; font-weight: bold;');
                console.log('  Forms:', vm.formSchemas.forms);
                console.log('  Buttons:', vm.formSchemas.buttons);

                var tempFormBig = [];
                var tempFormMedium = [];
                var tempFormSmall = [];
                var tempLineArray = [];
                angular.forEach(vm.formSchemas.forms, function (value, i) {
                    if (value.weight == 1) {
                        tempFormSmall.push(value);
                    }
                    else if (value.weight == 2) {
                        tempFormMedium.push(value);
                    }
                    else if (value.weight == 3) {
                        tempFormBig.push(value);
                    }
                });

                while (tempFormSmall.length != 0 || tempFormMedium.length != 0 || tempFormBig.length != 0) {
                    if (tempFormBig.length > 0) {
                        tempLineArray.push({form: [tempFormBig.shift()], type: '3'});
                    }
                    else if (tempFormSmall.length > 0 && tempFormMedium.length > 0) {
                        tempLineArray.push({form: [tempFormSmall.shift(), tempFormMedium.shift()], type: '2-1-1'});
                    }
                    else if (tempFormSmall.length > 0) {
                        while (tempFormSmall.length > 0) {
                            if (tempFormSmall.length > 1) {
                                tempLineArray.push({
                                    form: [tempFormSmall.shift(), tempFormSmall.shift(), tempFormSmall.shift(), tempFormSmall.shift()],
                                    type: '1-1-1-1'
                                });
                            }
                            else {
                                tempLineArray.push({form: [tempFormSmall.shift()], type: '1'});
                            }
                        }
                    }
                    else if (tempFormMedium.length > 0) {
                        tempLineArray.push({form: [tempFormMedium.shift()], type: '2'});
                    }
                }


                vm.formSchemas.forms = [];
                angular.forEach(tempLineArray, function (value, i) {
                    angular.forEach(value.form, function (form, index) {
                        if (form !== undefined) {
                            vm.formSchemas.forms.push(form);
                        }
                    });
                });

                angular.forEach(vm.formSchemas.forms,  function(cmd){
                    if(!isCommandValued(cmd)){
                        var command = {name: cmd.command, rowSpan: cmd.form.length}
                        var pos = 0;
                        while(!isCommandValue(cmd.form[pos], command)){
                            pos ++;
                        }
                        vm.originalTable.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                        for(var i = pos+1; i < cmd.form.length; i++){
                            if(!isCommandValue(cmd.form[i],cmd)){
                                vm.originalTable.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd), command: {name:null}});
                            }
                        }
                    }
                });

                function getValue(form, command){
                    return isCommandValue (form, command) ? form.schema.default : command[form.title];
                }

                function isCommandValue(form, command){
                    return command[form.title] === undefined || command[form.title] === null || isNaN(command[form.title]);
                }

                function isCommandValued(command){
                    var check = false;
                    var forms = command.form;
                    for(var i = 0;  i < forms.length; i++){
                        check = check || isCommandValue(forms[i],command)
                    }
                    return check;
                }

                var tempCommands;

                tempCommands = vm.tabActions.filter( function(command){
                    return vm.originalTable.findIndex(function (commandInQueue){
                        return command.actionCommand === commandInQueue.command.name
                    }) < 0
                });

                var notValuedCommands = tempCommands.map(function (oldCommand){
                    return {
                        metricName: null,
                        metricValue: null,
                        description: oldCommand.description,
                        command: {
                            name: oldCommand.actionCommand
                        }
                    }
                });


                vm.originalTable = vm.originalTable.concat(notValuedCommands);

            }


            function onError(error) {
                AlertService.error(error.data.message);
            }

        };

        vm.getEntry = function (jArg, val, arrayName) {
            var entry = {};
            if (arrayName != null)
                entry.key = arrayName + "[]." + val;
            else
                entry.key = val;
            if (jArg.properties[val].hasOwnProperty('titleMap')) {
                entry.titleMap = jArg.properties[val].titleMap;
                entry.type = 'select';
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
                if (jArg.properties[val].hasOwnProperty("pending")) {
                    jArg.properties[val].titleMap.forEach(function (title) {
                        if (title.value === jArg.properties[val].pending)
                            jArg.properties[val].pending = title.name;
                    });
                }
            }
            if (jArg.properties[val].type === 'string' && !jArg.properties[val].hasOwnProperty('titleMap')) {
                if (jArg.properties[val].format === 'time') {
                    entry.type = 'timepicker';
                } else {
                    entry.type = 'text';
                }
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].hasOwnProperty('component') && !jArg.properties[val].hasOwnProperty('titleMap'))
                entry.type = jArg.properties[val].component;
            if (jArg.properties[val].hasOwnProperty('options'))
                entry.options = jArg.properties[val].options;
            if (jArg.properties[val].hasOwnProperty('style'))
                entry.style = jArg.properties[val].style;
            if (jArg.properties[val].hasOwnProperty('maxDate'))
                entry.maxDate = jArg.properties[val].maxDate;
            if (jArg.properties[val].hasOwnProperty('minDate'))
                entry.minDate = jArg.properties[val].minDate;
            if (jArg.properties[val].hasOwnProperty('format') && jArg.properties[val].format == 'time') {
                if (jArg.properties[val].default && typeof jArg.properties[val].default === 'string') {
                    var timeParts = jArg.properties[val].default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    jArg.properties[val].default = timeDate;
                }
            }
            if (jArg.properties[val].hasOwnProperty('default')) {
                jArg.properties[val].defaultRestore = angular.copy(jArg.properties[val].default);
            }
            if (jArg.properties[val].hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(jArg.properties[val].items.properties)[0];
                if (jArg.properties[val].items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties[val].items.properties).length;
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        orderProps.splice(Number(jArg.properties[val].items.properties[item].order) - 1, 1, vm.getEntry(jArg.properties[val].items, item, val));
                    });
                    orderProps.forEach(function (val) {
                        entry.items.push(val);
                    });
                } else {
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(jArg.properties[val].items, item, val));
                    });
                }
            }
            return entry;
        };

        vm.saveQueueOrMacro = function (actionExec) {
            vm.isSaving = true;

            // block saving a macro that contains another macro
            if (actionExec === 'saveMacro' && vm.isGreengrassObject && vm.clickMacro) {
                AlertService.error("Cannot save a macro that contains another macro.");
                vm.isSaving = false;
                return;
            }

            if(vm.tabActionsQueue.single){
                if(vm.tabActionsQueue.cron === true && vm.repeatNumber && vm.repeatTime) {
                    vm.tabActionsQueue.cronExpression = vm.repeatNumber  + " " + vm.repeatTime;
                } else if(vm.tabActionsQueue.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                    AlertService.error("Fill Repetition fields");
                    return;
                }
            }

            vm.tabActionsQueue.commands = vm.commandStash;
            if(actionExec == "saveQueue"){
                for(var i = 0; i < vm.tabActionsQueue.commands.length; i++){
                    var commandName = vm.tabActionsQueue.commands[i].actionCommand.split(' - ');
                    var command = commandName[0];
                    vm.tabActionsQueue.commands[i].actionCommand = command;
                }
                Queue.create(vm.tabActionsQueue, onSuccess, onError);
            } else {
                vm.macroNameCheck = true;
                vm.nameErrorMsg = "";
                angular.forEach(vm.macro, function (macro){
                    if (macro.alias === vm.tabActionsQueue.alias){
                        vm.macroNameCheck = false;
                    }
                });
                if (vm.macroNameCheck) {
                    Macro.create(vm.tabActionsQueue, onSuccess, onError);
                } else {
                    vm.nameErrorMsg = "Macro name already exists, choose a new name"
                    AlertService.error(vm.nameErrorMsg);
                };
            }

            function onSuccess() {
                $state.transitionTo($state.$current, {
                    id: id
                }, {notify: true, location: "replace", reload: true});
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.clear();
            }
        };

        vm.deleteCommand = function (commandId) {
            TabActionsQueue.delete({id: commandId}, onSuccess, onError);

            function onSuccess() {
                $state.transitionTo($state.$current, {
                    id: id
                }, {notify: true, location: "replace", reload: true});
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.clear = function () {

            $timeout(function() {
                $window.dispatchEvent(new Event("resize"));
            }, 300);

            commandStash = {};
            vm.commandStash = [];
            vm.commAside = false;
            vm.commandToSend = false;
            vm.clickMacro = false; // reset macro flag on clear
            vm.fetchActions(vm.obj);
            vm.tabActionsQueue.alias = "";
            vm.macroNameCheck = true;
        };

        vm.fillEntity = function (entity, commandName, withArgs) {
            vm.cleanEntity(entity, commandName, withArgs);
            vm.commandToSend = true;
        };

        vm.remove = function(index) {
            vm.commandStash.splice(index, 1);
            updateClickMacroFlag();
            if(Object.keys(vm.commandStash).length == 0){
                vm.clear();
            }
        }

        vm.moveUp = function(index) {
            var obj = vm.commandStash[index];
            vm.commandStash.splice(index, 1);
            vm.commandStash.splice(index - 1, 0, obj);
        }

        vm.moveDown = function(index) {
            var obj = vm.commandStash[index];
            vm.commandStash.splice(index, 1);
            vm.commandStash.splice(index + 1, 0, obj);
        }

        vm.cleanEntity = function (entity, commandName, withArgs) {
            if (withArgs) {
                var args = {};
                for (var key in entity.schema.properties) {
                    if (entity[key] instanceof Date) {
                        var hours = entity[key].getHours();
                        var minutes = entity[key].getMinutes();
                        args[key] = String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
                    } else {
                        args[key] = entity[key];
                    }
                }
            }
            vm.commandStash.push({
                id: vm.actionDeviceReleaseMap[commandName].idAction,
                actionCommand: commandName,
                deviceReleases: vm.actionDeviceReleaseMap[commandName].deviceReleases,
                arguments: args,
                permissionLevel: vm.actionDeviceReleaseMap[commandName].permissionLevel
            });
        };

        $scope.storeChanges = function (action) {

            $timeout(function() {
                $window.dispatchEvent(new Event("resize"));
            }, 300);

            if (typeof action === "string") {
                sendZeroArgumentAction(action);
            } else {
                sendMultiArgumentAction.call(this, action);
            }
        };

        $scope.storeChangesMacro = function (macro) {
            vm.tabActionsQueue.alias = macro.alias;

            if (vm.isGreengrassObject) {
                // For Greengrass: get queue commands and merge with manifest data
                Macro.getMacroDetails({macroId: macro.id}, onSuccessGreengrassMacro, onErrorGreengrassMacro);

                function onSuccessGreengrassMacro(queueCommands) {
                    console.log('Greengrass macro queue commands:', queueCommands);

                    queueCommands.forEach(function(qc) {
                        var parsedArguments = {};
                        try {
                            parsedArguments = qc.arguments ? JSON.parse(qc.arguments) : {};
                        } catch (e) {
                            console.error('Failed to parse arguments:', e);
                        }

                        // Find matching command in manifest
                        var matchingCommand = vm.tabActions.find(function(action) {
                            return action.actionCommand === qc.commandName;
                        });

                        if (matchingCommand) {
                            vm.commandStash.push({
                                id: matchingCommand.id,
                                actionCommand: qc.commandName + " - " + macro.alias,
                                deviceReleases: matchingCommand.deviceReleases,
                                arguments: parsedArguments,
                                permissionLevel: matchingCommand.permissionLevel,
                                macro: true
                            });
                        } else {
                            console.warn('Command not in manifest:', qc.commandName);
                            AlertService.error('Failed to load macro detail');
                        }
                    });

                    vm.commandToSend = true;
                    vm.commAside = true;
                    updateClickMacroFlag();
                }

                function onErrorGreengrassMacro(error) {
                    console.error('Error loading macro:', error);
                    AlertService.error('Failed to load macro details');
                }

            } else {
                // Original non-Greengrass flow
                macro.macroActions.sort(function (a, b) {
                    return a.order - b.order;
                });

                for(var i = 0; i < macro.macroActions.length; i++){
                    var commandName = macro.macroActions[i].tabActions.actionCommand + " - " + macro.alias;
                    vm.commandStash.push({
                        id: macro.macroActions[i].tabActions.id,
                        actionCommand: commandName,
                        deviceReleases: macro.macroActions[i].tabActions.deviceReleases,
                        arguments: macro.macroActions[i].arguments == "{}" ? {} : macro.macroActions[i].argumentMap,
                        macro: true
                    });
                }

                vm.commandToSend = true;
                vm.commAside = true;
                updateClickMacroFlag();
            }
        };

        function sendZeroArgumentAction(action) {
            if (commandStash[action] !== null && commandStash[action] !== undefined) {
                delete commandStash[action];
                vm.commandToSend = !(Object.keys(commandStash).length === 0);
            } else
                vm.fillEntity({}, action, false);
            vm.commAside = true;
        }

        function sendMultiArgumentAction(action) {
            var commandName = action.command;
            if (this[commandName] !== undefined)
                $scope.$broadcast('schemaFormValidate', this[commandName].$name);
            if (this[commandName] === undefined || this[commandName].$valid) {
                vm.fillEntity(action, commandName, true);
            }
            vm.commAside = true;
        };

        vm.removeChanges = function (formSchema) {
            delete commandStash[formSchema.command];
            for (var value in formSchema) {
                if (value != "command" && value != "form" && value != "schema" && value != "$$hashKey" && value != "weight" && value != "showPending" && value != "description") {
                    if (formSchema.schema.properties[value].type == 'array' && formSchema.schema.properties[value].defaultRestore === undefined) {
                        formSchema[value] = [{}];
                    }
                    else {
                        formSchema[value] = angular.copy(formSchema.schema.properties[value].defaultRestore);
                    }
                }
            }
            $('#' + formSchema.command).removeAttr("disabled");
            vm.commandToSend = !(Object.keys(commandStash).length === 0);
        };

        vm.commAside = false;
        vm.toggleCommAside = function() {
            if(vm.commandStash.length != 0)
                vm.commAside = !vm.commAside;

            $timeout(function() {
                vm.resizeTrigger();
            }, 300);
        };

        vm.scheduleCommands = function () {
            if(vm.showSchedule === undefined)
                vm.response = {
                    single: false
                };
            $uibModal.open({
                templateUrl: 'app/management/action-commands/schedule-commands.html',
                controller: 'ScheduleCommandsController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if(result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.tabActionsQueue.single = vm.response.single;
                } else
                    vm.showSchedule = undefined;
            });
        };

        function setMultipleData() {
            vm.tabActionsQueue.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.includeDay) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");

            vm.tabActionsQueue.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));
            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        function setData() {
            vm.tabActionsQueue.scheduleDateTime = vm.response.scheduleDateTime;
            vm.tabActionsQueue.cron = vm.response.cron;
            vm.repeatNumber = vm.response.repeatNumber;
            vm.repeatTime = vm.response.repeatTime;
            convertDate();
        }

        function convertDate(){
            var dateFormat = 'dd/MM/yyyy';
            var date = $filter('date')(new Date(vm.tabActionsQueue.scheduleDateTime), dateFormat);
            vm.showSchedule = "SCHEDULED: " + date + "\n";
            if(vm.tabActionsQueue.cron === true && vm.repeatNumber && vm.repeatTime) {
                vm.showSchedule += " REPEAT EVERY " + vm.repeatNumber  + " " + vm.repeatTime;
            } else if(vm.tabActionsQueue.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                AlertService.error("Fill Ripetition fields");
                vm.showSchedule = undefined;
            }
        }

        vm.commandsView = function () {
            if(vm.showSchedule === undefined)
                vm.response = {
                    single: false
                };
            $uibModal.open({
                templateUrl: 'app/management/action-commands/commands-view.html',
                controller: 'CommandsView',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return vm.formSchemas.forms;
                    },
                    commandsArray: function () {
                        return vm.tabActions;
                    }
                }
            });
        };


    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabCommand', TabCommand);

    TabCommand.$inject = ['$resource'];



    function TabCommand($resource) {
        var resourceUrl = 'api/tab-objects/action-by-id/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                cache: false
            },
            'get': {
                method: 'GET',
                cache: false
                // transformResponse: function (data) {
                //     data = angular.fromJson(data);
                //     return data;
                // }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('action-commands', {
                parent: 'management',
                url: '/action-commands/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.home.title'
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/action-commands/action-commands.html',
                        controller: 'ActionCommandsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('commands-detail', {
                parent: 'action-commands',
                url: '/commands-detail',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.actionCommands.commandsDetail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/action-commands/commands-detail.html',
                        controller: 'CommandsDetailController',
                        controllerAs: 'vm'
                    }
                },
                params:{
                    objectUniqueCode: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('tabActionsQueue');
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabActions', function ($stateParams, TabActions) {
                        return TabActions.command({id: $stateParams.id});
                    }],
                    objectUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }]
                }
            });
    }

})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('CommandManifest', CommandManifest);

    CommandManifest.$inject = ['$resource'];

    function CommandManifest($resource) {
        return $resource('api/command-manifest/:objectUniqueCode', {}, {
            'get': {
                method: 'GET',
                cache: false
            }

        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CommandsDetailController', CommandsDetailController);

    CommandsDetailController.$inject = ['$rootScope', '$scope', '$state', 'TabActions', 'entity', 'objectUniqueCode'];

    function CommandsDetailController($rootScope, $scope, $state, TabActions, entity, objectUniqueCode) {
        var vm = this;

        vm.commands = [];
        vm.editorEnabled = [];
        vm.updateDescription = [];
        vm.objectUniqueCode = objectUniqueCode;

        if(vm.objectUniqueCode != null){
            localStorage.setItem("commands-detail-edit", JSON.stringify(vm.objectUniqueCode));
        } else {
            var uniqueCode = localStorage.getItem("commands-detail-edit");
            if(uniqueCode != null && uniqueCode != "null" && uniqueCode != undefined){
                vm.objectUniqueCode = JSON.parse(uniqueCode);
            }
        }

        vm.exportTable = exportTable;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.commands = entity;
                vm.commands.forEach(function (c) {
                    vm.editorEnabled.push(false);
                    vm.updateDescription.push("");
                });
            });
        }

        vm.enableEditor = function(index, edit) {
            if(edit == 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                }
            } else if(edit == 1) {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            } else {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.commands[index].description;
            }
        };

        vm.saveUpdate = function(index) {
            vm.commands[index].description = vm.updateDescription[index];

            TabActions.update(vm.commands[index], onSuccess, onError);

            function onSuccess() {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            }

            function onError(){}
        };

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 200, 1: 600},
                    tableName: vm.objectUniqueCode + ' - Commands'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: vm.objectUniqueCode + ' - Commands'});
            }
        }
    }
})();
;
(function (obj, type) {
    'use strict';

    angular
        .module('jotApp')
        .controller('CommandsView', CommandsView);

    CommandsView.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity', 'commandsArray', '$rootScope', '$scope', 'TabActions'/*, 'originalTable'*/];

    function CommandsView($state, $uibModalInstance, AlertService, $timeout, entity, commandsArray, $rootScope, $scope, TabActions/*, originalTable*/) {
        var vm = this;

        vm.commandsArray = commandsArray; // contains all the commands (tabActions)
        vm.commands = entity; // contains all the commands that can be assigned a value (formSchemas.forms)
        vm.table = []; // contains all the commands with a value assigned
        vm.tableToExport = []; // contains all the commands with a value assigned

        var isEdit = false;

            /*Pushes every command with an assigned value in the array vm.table*/
            angular.forEach(vm.commands,  function(cmd){
                if(!isCommandValued(cmd)){
                    var command = {name: cmd.command, rowSpan: cmd.form.length}
                    var pos = 0;
                    while(!isCommandValue(cmd.form[pos], command)){
                        pos ++;
                    }
                    vm.table.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                    vm.tableToExport.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                    for(var i = pos+1; i < cmd.form.length; i++){
                        if(!isCommandValue(cmd.form[i],cmd)){
                            vm.table.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd),command: {name:null}});
                            vm.tableToExport.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd),command: {name:null}});
                        }
                    }
                }
            });

            /*Array with every command without an assigned value*/
            var tempCommands;

            tempCommands = vm.commandsArray.filter(function(command){
                return vm.table.findIndex(function (commandInQueue){
                    return command.actionCommand === commandInQueue.command.name
                }) < 0
            });

            /*Array with every command without value, but the objects are structured like in vm.table*/

            vm.notValuedCommands = tempCommands.map(function (oldCommand){
                return {
                    metricName: null,
                    metricValue: null,
                    description: oldCommand.description,
                    command: {
                        name: oldCommand.actionCommand
                    }
                }
            });

            /*vm.table now contains all the commands, with and without assigned values*/
            vm.table = vm.table.concat(vm.notValuedCommands);

        /*Returns the value of a command if it has one*/
        function getValue(form, command){
            return isCommandValue (form, command) ? form.schema.default : command[form.title];
        }

        /*Returns the value of a command */
        function isCommandValue(form, command){
            return command[form.title] === undefined || command[form.title] === null || isNaN(command[form.title]);
        }

        /*Checks if a command has any value assigned, returns a boolean*/
        function isCommandValued(command){
            var check = false;
            var forms = command.form;
            for(var i = 0;  i < forms.length; i++){
                check = check || isCommandValue(forms[i],command)
            }
            return check;
        }

        vm.exportTable = function (type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    tableName: 'Commands Detail',
                    ignoreColumn: [3,4],
                    size: {0: 200, 1: 100, 3: 100}
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({
                    type: type,
                    escape: 'false',
                    tableName: 'Commands Detail',
                    size: {0: 50, 1: 50, 3: 50},
                    ignoreColumn: [3,4],
                });
            }
            vm.tabObjectsToExport = [];
        };

        /*Closes the modal*/
        vm.clear = function () {
            if(isEdit){
                $state.reload();
            }
            $uibModalInstance.dismiss('cancel');
        };

        /*Opens the description editor*/
        vm.enableEditor = function(command) {
            command.isEdit = true;
        };

        /*Closes the description editor and reassigns the value to the one before the modifications*/
        vm.disableEditor = function (command){
            command.isEdit = false;

            var originalCommand;

            originalCommand = vm.commandsArray.find(function (originalCommand){
                return originalCommand.actionCommand === command.command.name;
            })

            command.description = originalCommand.description;
        };

        /*Saves the modified description*/
        vm.saveUpdate = function(command) {
            var originalCommand;

            originalCommand = vm.commandsArray.find(function (originalCommand){
                return originalCommand.actionCommand === command.command.name;
            })

            // assign the new description to the command
            originalCommand.description = command.description;

            TabActions.update(originalCommand, onSuccess, onError);

            function onSuccess() {
                command.isEdit = false;
                isEdit = true;
            }

            function onError(error){
                AlertService.error(error.data.message);
            }
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScheduleCommandsController', ScheduleCommandsController);

    ScheduleCommandsController.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity'];

    function ScheduleCommandsController($state, $uibModalInstance, AlertService, $timeout, entity) {
        var vm = this;

        vm.scheduleDate = entity;
        if(!entity.single)
            vm.multipleSchedule = entity.selectedDay;

        if(Object.keys(entity).length === 1)
            vm.multipleSchedule = [
                {day: "MON", selectedTime: ""},
                {day: "TUE", selectedTime: ""},
                {day: "WED", selectedTime: ""},
                {day: "THU", selectedTime: ""},
                {day: "FRI", selectedTime: ""},
                {day: "SAT", selectedTime: ""},
                {day: "SUN", selectedTime: ""}
            ];

        vm.repeatStatus = [false, false, false, false, false, false, false];

        vm.openTimeCal = function(index) {
            $timeout(function() {
                vm.repeatStatus[index] = true;
            });
        };

        vm.datepickerOptions = {
            minDate: null
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            if(!vm.scheduleDate.single) {
                vm.scheduleDate.selectedDay = vm.multipleSchedule;
                checkAtLeastOneValue();
            }
            $uibModalInstance.close(vm.scheduleDate);
        };

        function checkAtLeastOneValue() {
            var res = false;
            angular.forEach(vm.scheduleDate.selectedDay, function(check){
                if(check.includeDay && check.selectedTime != null) {
                    res = true;
                } else
                    check.includeDay = false;
            });
            if(!res)
                vm.scheduleDate.selectedDay = undefined;
        }

        vm.check = function (check){
            vm.scheduleDate = {};
            vm.scheduleDate.single = check;
            if(!vm.scheduleDate.single){
                vm.multipleSchedule = [
                    {day: "MON"},
                    {day: "TUE"},
                    {day: "WED"},
                    {day: "THU"},
                    {day: "FRI"},
                    {day: "SAT"},
                    {day: "SUN"}
                ];
                vm.datepickerOptions = {
                    minDate: null
                };
            } else {
                vm.multipleSchedule = [];
                vm.datepickerOptions = {
                    minDate: new Date()
                };
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('view-all-command-value', {
                parent: 'management',
                url: '/view-all-command-value',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: ''
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/commands/view-all-commands-value.html',
                        controller: 'viewAllCommandsValueController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SelectedEmailController', SelectedEmailController);

    SelectedEmailController.$inject = ['$state', '$uibModalInstance', 'User', 'AlertService'];

    function SelectedEmailController($state, $uibModalInstance, User, AlertService) {
        var vm = this;

        vm.email = {};

        User.getLoggedUserEmail({}, onSuccess, onError);

        function onSuccess(result) {
            vm.email.principal = result.email;
        }

        function onError() {}

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            User.checkReportCommandsEmail({principal: vm.email.principal, cc: vm.email.cc}, onSuccessCheck, onErrorCheck);

            function onSuccessCheck() {
                $uibModalInstance.close(vm.email);
            }

            function onErrorCheck() {}
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ShowPdfController', ShowPdfController);

    ShowPdfController.$inject = ['$state', '$uibModalInstance', 'content'];

    function ShowPdfController($state, $uibModalInstance, content) {
        var vm = this;

        vm.content = content;

        vm.clear = function () {
            $uibModalInstance.close();
        };
    }
})();
;
(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('viewAllCommandsValueController', viewAllCommandsValueController);

        viewAllCommandsValueController.$inject = ['$timeout', '$scope', '$state', '$http','$sce', 'pagingParams', 'TabFleets', 'ListObjAndObjType', 'paginationConstants', 'ParseLinks',
            'AlertService', 'ListObjByObjTypeAndFleet', 'SetScheduleForAll', '$uibModal', 'ObjectStatusService', 'TabActions'];

        function viewAllCommandsValueController($timeout, $scope, $state, $http, $sce, pagingParams, TabFleets, ListObjAndObjType, paginationConstants, ParseLinks,
                                                AlertService, ListObjByObjTypeAndFleet, SetScheduleForAll, $uibModal, ObjectStatusService, TabActions) {
            var vm = this;
            vm.transition = transition;
            vm.changePageSize = changePageSize;
            vm.exportTable = exportTable;
            // vm.loadAllToExport = loadAllToExport;
            vm.tabFleets = [];
            vm.predicates = {};
            vm.selection = {};
            vm.selection.fleet = -1;
            vm.selection.objectType = -1;
            ObjectStatusService.init();
            vm.objParsed = 0;
            vm.tableIsLoading = false;

            vm.table = [];
            vm.tableToExport = [];

            vm.allDownloadReport = [];

            vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
            vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

            vm.showPdfFile = "";

            vm.message = {
                show: true,
                text: "Choose fleet and object type before selecting your report settings (PDF/XLSX) to download it or access history if available"
            }

            //caricamento delle flotte all'atterraggio in pagina
            TabFleets.query({}, onTabFleetsSuccess, onError);

            function onError(error) {
                AlertService.error(error.data.message);
                $timeout(function (){
                    vm.tableIsLoading =  false;
                },300)
            }

            function onTabFleetsSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabFleets.push(data[i]);
                }
                if (data.length === 1) {
                    vm.selectedFleet(data[0]);
                }
            }
            vm.resetFilter = function () {
                if (vm.tableIsLoading !== true) {
                    vm.fleet=null;
                    vm.charToSearch = '';
                    vm.onlyToUpdate = false;
                    vm.onlyOnline = false;
                }
            };
            /* selezionata la flotta popolo la select degli object type e la lista degli object in pagina
          annullando l'eventuale selezione di questi ultimi */
            vm.selectedFleet = function (fleet) {
                vm.allDownloadReport = [];
                vm.message.show = true;
                vm.message.text = "Choose object type before selecting your report settings (PDF/XLSX) to download it or access history if available";
                if (vm.tableIsLoading !== true) {
                    if (vm.selection.fleet != fleet.id) {
                        vm.selection.fleet = fleet.id;
                        vm.forms = [];
                        vm.table = [];
                        vm.tableToExport = [];
                        vm.currentPage = 1;
                    }
                    var query = {
                        id: fleet.id,
                        fleetId: fleet.id
                    };
                    ListObjAndObjType.query(query, onSuccess, onError);

                    function onSuccess(data) {
                        vm.tabObjectType = (data.tabObjectTypesList);
                        vm.fleet = fleet;
                        //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                        vm.objType = null;
                        ObjectStatusService.sendChangePage(query);
                        transition(false);
                        if (data.tabObjectTypesList.length === 1) {
                            vm.objType = data.tabObjectTypesList[0]
                            vm.selectObjectType(vm.objType)
                        }
                        if (vm.tabObjectType.length === 0) {
                            vm.message.show = true;
                            vm.message.text = "Report not available: selected fleet has no associated object type";
                        }
                    }
                }
            };

            /* selezionato l'object type popolo la select e lista degli object in pagina
             annullando l'eventuale selezione di quest' ultimo */
            vm.selectObjectType = function (objType) {
                if (vm.tableIsLoading !== true) {
                    vm.tableIsLoading = true;
                    if (vm.selection.objectType != objType.id) {
                        vm.pagesChecked = [];
                        vm.checkNextPages = false;
                        vm.selection.objectType = objType.id;
                        vm.forms = [];
                        vm.table = [];
                        vm.tableToExport = [];
                        vm.currentPage = 1;
                    }
                    var query = {
                        typeName: objType.objectTypeName,
                        fleetName: vm.fleet.fleetName,
                        page: vm.currentPage -1,
                        size: vm.itemsPerPageChosen,
                        sort: null
                    }
                    // TabActions.allCommand(query, onSuccess, onError);

                    TabActions.allDownload(query, onSuccessDownload, onErrorDownload);

                    function onSuccessDownload(data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.page = vm.currentPage;
                        vm.allDownloadReport = data;
                        $timeout(function (){
                            vm.tableIsLoading = false;
                        },300);
                        if (vm.allDownloadReport.length === 0) {
                            vm.message.show = true;
                            vm.message.text = "History not available. Generate the first report for these objects to create it.";
                        } else {
                            vm.message.show = false;
                            vm.message.text = "";
                        }
                    }

                    function onErrorDownload() {}

                    // loadAllToExport();

                    function onSuccess(data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.page = vm.currentPage;
                        vm.table = [];
                        angular.forEach(data, function (d) {
                                vm.table.push({obj: d.object});
                                angular.forEach(d.commands, function (a) {
                                    vm.table.push({
                                        command: a.command,
                                        metricName: a.metric[0].metricName,
                                        metricValue: a.metric[0].metricValue
                                    });
                                    for (var i = 1; i < a.metric.length; i++) {
                                        vm.table.push({
                                            metricName: a.metric[i].metricName,
                                            metricValue: a.metric[i].metricValue
                                        });
                                    }

                                });
                            }
                        );
                        $timeout(function (){
                            vm.tableIsLoading =  false;
                        },300)
                        transition(false);
                    }
                }
            }

            function transition(recall, reset) {
                //eseguo la chiamata in base alle opzioni già selezionate
                if (recall) {
                    if (vm.objType) {
                        vm.selectObjectType(vm.objType, vm.currentPage, reset);
                    } else {
                        vm.selectedFleet(vm.fleet, vm.currentPage, reset);
                    }
                }
                $state.transitionTo($state.$current, {
                    page: vm.currentPage,
                    predicates: vm.predicates,
                    sort: null,
                    search: vm.charToSearch,
                    itemsPerPageChosen: vm.itemsPerPageChosen
                }, {notify: false, reload: false, location: "replace"});
            }

            function changePageSize() {
                if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                    vm.currentPage = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
                vm.forms = [];
                vm.table = [];
                transition(true);
            }

            vm.openFilePdf = function (file) {
                var body = {
                    fileName: file.fileName,
                    fleetName: file.fleetName,
                    typeName: file.typeName
                }

                if (file.fileName.substr(file.fileName.length - 4) === '.pdf') {
                    $http.post('api/tab-actions/downloadReportFilePdf/', body, {responseType: 'blob'}
                    ).then(function (data) {
                        vm.showPdfFile = $sce.trustAsResourceUrl(
                            URL.createObjectURL(
                                new Blob([data.data], {type: data.headers("Content-Type")})));
                        $uibModal.open({
                            templateUrl: 'app/management/commands/showPdf.html',
                            controller: 'ShowPdfController',
                            controllerAs: 'vm',
                            size: 'md',
                            backdrop: 'static',
                            windowClass: 'app-modal-window',
                            resolve: {
                                content: function () {
                                    return vm.showPdfFile;
                                }
                            }
                        }).result.then(function () {
                            vm.showPdfFile = "";
                        });
                    });
                }
            }

            vm.downloadCommandsReport = function (file) {

                var body = {
                    fileName: file.fileName,
                    fleetName: file.fleetName,
                    typeName: file.typeName};

                if (file.fileName.substr(file.fileName.length - 4) === '.pdf') {
                    $http.post('api/tab-actions/downloadReportFilePdf/', body, { responseType: 'blob' }
                    ).then(function(data) {
                        downloadReportFile(data);
                    });
                } else {
                    $http.post('api/tab-actions/downloadReportFileXlsx/', body, { responseType: 'blob' }
                    ).then(function(data) {
                        downloadReportFile(data);
                    });
                }

                function downloadReportFile(data) {
                    var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                    var url = window.URL.createObjectURL(blob);
                    var anchor = document.createElement("a");
                    var contentDisposition = data.headers("Content-Disposition");
                    anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                    anchor.href = url;
                    anchor.click();
                }

                function onErrorLink() {}
            }

            function exportTable(type) {

                $uibModal.open({
                    templateUrl: 'app/management/commands/selected-email.html',
                    controller: 'SelectedEmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static'
                }).result.then(function (result) {
                    downloadReport(type, result);
                });
            }

            function downloadReport(type, email) {
                var query = {
                    typeId: vm.objType.id,
                    fleetId: vm.fleet.id,
                    objTypeName: vm.objType.objectTypeName,
                    fleetName: vm.fleet.fleetName,
                    fileType: type,
                    principal: email.principal,
                    cc: email.cc,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
                TabActions.download(query, onSuccessDownload, onErrorDownload);

                function onSuccessDownload() {
                    AlertService.success("JoT will send the report to your inbox. This process may take few hours.");
                }

                function onErrorDownload() {
                    AlertService.error("Generic Error");
                }
            }
        }
    }
)
();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdatesDialogController', CustomUpdatesDialogController);

    CustomUpdatesDialogController.$inject = ['$timeout', 'TabObjects', 'TabActionsQueue', '$state', '$uibModalInstance', 'scripts'];

    function CustomUpdatesDialogController($timeout, TabObjects, TabActionsQueue, $state, $uibModalInstance, scripts) {
        var vm = this;

        vm.newCommand = $state.params.oldCommands;
        vm.tabobjects = TabObjects.query();
        vm.tabactionsqueues = TabActionsQueue.query();
        vm.scripts = scripts;

        vm.writeCommandInTextbox = function() {
            if (vm.script)
                vm.newCommand = writeScriptName(vm.script.scriptName);
            else
                vm.newCommand = null;
        };

        vm.resetScriptBox = function() {
            vm.script = null;
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.save = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.newCommand);
            vm.isSaving = false;
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function writeScriptName (scriptName) {
            return '#' + scriptName + '#';
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdateTagsDialogController', CustomUpdateTagsDialogController);

    CustomUpdateTagsDialogController.$inject = ['$timeout', 'TabObjects', 'TabActionsQueue', '$state', '$uibModalInstance', 'numObjects'];

    function CustomUpdateTagsDialogController($timeout, TabObjects, TabActionsQueue, $state, $uibModalInstance, numObjects) {
        var vm = this;

        vm.picker = false;
        vm.tabobjects = TabObjects.query();
        vm.tabactionsqueues = TabActionsQueue.query();
        vm.numObjects = numObjects;
        vm.tag = new Date().toDateString();
        vm.firmware = false;
        vm.forced = false;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.save = function () {
            vm.isSaving = true;
            $uibModalInstance.close({tag: vm.tag, date: vm.date, updFirmware: vm.firmware, forced: vm.forced});
            vm.isSaving = false;
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdatesController', CustomUpdatesController);

    CustomUpdatesController.$inject = ['$scope', '$state', 'TabFleets', 'ListObjAndObjType', 'paginationConstants', 'ParseLinks',
        'AlertService', 'ListObjByObjTypeAndFleet', 'SetScheduleForAll', '$uibModal', 'ObjectStatusService', 'TabUpdateScripts'];

    function CustomUpdatesController($scope, $state, TabFleets, ListObjAndObjType, paginationConstants, ParseLinks,
                                     AlertService, ListObjByObjTypeAndFleet, SetScheduleForAll, $uibModal, ObjectStatusService, TabUpdateScripts) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.transition = transition;
        vm.predicates = {};
        vm.tabObjectsRow = [];
        vm.areChk = false;
        vm.tabFleets = [];
        vm.isOpen = false;
        vm.objectToUdp = [];
        vm.currentPage = 1;
        vm.date = new Date();
        vm.charToSearch = '';
        vm.onlyToUpdate = false;
        vm.onlyOnline = false;
        vm.checkNextPages = false;
        vm.pagesChecked = [];
        vm.selection = {};
        vm.selection.fleet = -1;
        vm.selection.objectType = -1;
        vm.currentState = "custom-update";
        vm.tabUpdateScripts = [];
        vm.numberObjects = 0;
        vm.forced = false;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        vm.commands = $state.params.commands;
        vm.tag = null;
        vm.timepickerOptions = {showMeridian: false};

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        ObjectStatusService.init();

        var query = {};

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            if (toState.name == vm.currentState && toState.name != fromState.name) {
                ObjectStatusService.connect();
                ObjectStatusService.subscribe(function () {
                    ObjectStatusService.sendChangePage({
                        page: vm.currentPage - 1,
                        size: vm.itemsPerPageChosen,
                        sort: sort(),
                        query: vm.charToSearch
                    });
                });


            } else if (fromState.name == vm.currentState && toState.name != fromState.name) {
                ObjectStatusService.unsubscribe();
                ObjectStatusService.disconnect();
            }
        });

        //caricamento delle flotte all'atterraggio in pagina
        TabFleets.query({}, onTabFleetsSuccess, onError);

        function onTabFleetsSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            for (var i = 0; i < data.length; i++) {
                vm.tabFleets.push(data[i]);
            }
            if (data.length === 1) {
                vm.selectedFleet(data[0], 1, true);
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        //check e uncheck di tutti gli elementi in pagina
        vm.chkUnChkAll = function () {
            if (vm.areChk) {
                resetParams();
            } else {
                vm.areChk = true;
                vm.objectToUdp = [];
                // pushAllObject();
                addAllToUpdate(false).then(function () {
                    $state.go('custom-update', null, {reload: false});
                });
            }
        };


        function pushAllObject() {
            vm.checkNextPages = true;
            if (vm.pagesChecked.indexOf(vm.currentPage - 1) < 0 || vm.areChk) {
                $.each(vm.tabObjectsRow, function (key, el) {
                    if (findIndex(el) < 0) {
                        vm.objectToUdp.push(el);
                    }
                });
                vm.pagesChecked.push(vm.currentPage - 1);
            }
        }

        function resetParams() {
            vm.areChk = false;
            vm.checkNextPages = false;
            vm.pagesChecked = [];
            if (vm.objectToUdp.length > vm.numberObjects) {
                addAllToUpdate(true).then(function () {
                    $state.go('custom-update', null, {reload: false});
                });
            } else {
                vm.objectToUdp = [];
            }
        }

        /* selezionata la flotta popolo la select degli object type e la lista degli object in pagina
         annullando l'eventuale selezione di questi ultimi */
        vm.selectedFleet = function (fleet, currentPage, uncheckAll) {
            if (vm.selection.fleet != fleet.id) {
                resetParams();
                vm.tabObjectsRow = [];
                vm.totalItems = 0;
                vm.queryCount = 0;
                vm.selection.fleet = fleet.id;
                vm.numberObjects = 0;
            }
            query = {
                id: fleet.id,
                fleetId: fleet.id,
                query: vm.charToSearch,
                onlyUpdate: vm.onlyToUpdate,
                onlyOnline: vm.onlyOnline,
                page: currentPage - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };
            ListObjAndObjType.query(query, onSuccess, onError);

            function sort() {
                var sortFields = [];
                var keys = Object.keys(vm.predicates);
                for (var key in keys) {
                    var predicate = keys[key];
                    sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
                }
                localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
                return sortFields;
            }

            function onSuccess(data, headers) {
                vm.tabObjectType = (data.tabObjectTypesList);
                vm.fleet = fleet;
                //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                vm.objType = null;
                vm.currentPage = currentPage;
                ObjectStatusService.sendChangePage(query);
                transition(false);
                if (data.tabObjectTypesList.length === 1) {
                    vm.objType = data.tabObjectTypesList[0]
                    vm.selectObjectType(vm.objType, 1, true)
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        /* selezionato l'object type popolo la select e lista degli object in pagina
         annullando l'eventuale selezione di quest' ultimo */
        vm.selectObjectType = function (objType, currentPage, uncheckAll, script) {
            if (vm.selection.objectType != objType.id) {
                vm.pagesChecked = [];
                vm.checkNextPages = false;
                vm.selection.objectType = objType.id;
                vm.numberObjects = 0;
            }
            query = {
                typeId: objType.id,
                fleetId: vm.fleet.id,
                query: vm.charToSearch,
                onlyUpdate: vm.onlyToUpdate,
                onlyOnline: vm.onlyOnline,
                page: currentPage - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };
            ListObjByObjTypeAndFleet.query(query, onSuccess, onError);

            TabUpdateScripts.query({
                page: 0,
                size: 1000,
                objectType: vm.objType.id
            }, onSuccessScript);


            function onSuccessScript(data) {
                vm.tabUpdateScripts = data;
            }

            function onSuccess(data, headers) {
                vm.tabObjectsRow = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                // if (vm.numberObjects === 0)
                vm.numberObjects = parseInt(vm.totalItems);

                areAllObjectChecked();
                //popolamento tabella
                if (uncheckAll) {
                    vm.objectToUdp = [];
                }
                if (vm.areChk || vm.checkNextPages)
                    pushAllObject();
                // forzo la prima pagina della tabella
                vm.currentPage = currentPage;
                ObjectStatusService.sendChangePage(query);
                transition(false);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.deselectObjTy = function (obj) {
            var reload = vm.objType;
            vm.objType = null;
            if (reload != null)
                loadPage(vm.currentPage);
        };

        function findIndex(obj) {
            return vm.objectToUdp.findIndex(function (el) {
                return el.objectUniqueCode === obj.objectUniqueCode;
            });
        }

        vm.toggleSelection = function (data) {
            var idx = findIndex(data);
            if (idx > -1) {
                vm.objectToUdp.splice(idx, 1);
                vm.areChk = false;
            } else {
                vm.objectToUdp.push(data);
                areAllObjectChecked();
            }
        };

        function areAllObjectChecked() {
            if (vm.objectToUdp.length >= vm.numberObjects) {
                vm.areChk = true;
            } else {
                vm.areChk = false;
            }
        }

        function addAllToUpdate(isToRemove) {
            return new Promise(function (resolve, reject) {
                // if (vm.areChk) {
                    query = {
                        typeId: vm.selection.objectType,
                        fleetId: vm.fleet.id,
                        query: vm.charToSearch,
                        onlyUpdate: vm.onlyToUpdate,
                        onlyOnline: vm.onlyOnline,
                        page: 0,
                        size: vm.totalItems,
                        sort: sort()
                    };
                    ListObjByObjTypeAndFleet.query(query, onSuccess, onError);

                    function onSuccess(d, h) {
                        if (!isToRemove) {
                            vm.objectToUdp = d;
                        } else {
                            $.each(d, function (key, object) {
                                vm.objectToUdp.splice(findIndex(object), 1);
                            })
                        }
                        resolve();
                    }

                    function onError() {
                        console.log("Error all update");
                    }
                // } else {
                //     resolve();
                // }
            })
        }

        vm.openCalendar = function (e, prop, el) {
            e.preventDefault();
            e.stopPropagation();
            if (vm[el]) {
                vm[el].isOpen = !vm[el].isOpen;
            } else {
                vm[el] = {isOpen: true};
            }

        };

        vm.configureUpdates = function () {
            query.all = vm.areChk;
            query.updateFirmware = vm.updFirmware
            SetScheduleForAll.update(query, {
                scheduleDatetime: vm.date,
                tabObjects: vm.areChk ? [] : vm.objectToUdp,
                command: vm.commands,
                tag: vm.tag,
                forced: vm.forced
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabObjectsRow = [];
                vm.fleet = null;
                vm.objType = null;
                vm.obj = null;
                vm.areChk = false;
                vm.commands = null;
                vm.tag = null;
                vm.forced = false;
            }


            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.openModalCommand = function () {
            $uibModal.open({

                templateUrl: 'app/management/custom-update/custom-update-dialog.html',
                controller: 'CustomUpdatesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    scripts: function () {
                        return vm.tabUpdateScripts;
                    }
                }
            }).result.then(function (newCommands) {
                vm.commands = newCommands;
            });
        };

        // modal for tag on updates processes
        vm.openModalForTag = function () {
            $uibModal.open({
                templateUrl: 'app/management/custom-update/custom-update-tags-dialog.html',
                controller: 'CustomUpdateTagsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    numObjects: function () {
                        return vm.areChk ? vm.totalItems : vm.objectToUdp.length;
                    },
                    schedule: false
                }
            }).result.then(function (data) {
                vm.tag = data.tag;
                vm.updFirmware = data.updFirmware;
                if (data.date) {
                    vm.date = data.date;
                }
                vm.forced = data.forced;
                vm.configureUpdates();
            });
        };

        function loadPage(page) {
            vm.currentPage = page;
            transition(true, false);
        }

        vm.search = function () {
            // resetParams();
            vm.currentPage = 1;
            var reset = false;
            // if(!vm.areChk)
            //     reset = true;
            transition(true, reset);
        };

        function transition(recall, reset) {
            //eseguo la chiamata in base alle opzioni già selezionate
            if (recall) {
                if (vm.objType) {
                    vm.selectObjectType(vm.objType, vm.currentPage, reset);
                } else {
                    vm.selectedFleet(vm.fleet, vm.currentPage, reset);
                }
            }
            $state.transitionTo($state.$current, {
                page: vm.currentPage,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: false, reload: false, location: "replace"});
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                vm.currentPage = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition(true);
        }

        vm.checkChecked = function (obj) {
            var idx = findIndex(obj);
            return idx > -1;
        };
    }

})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('ListObjAndObjType', ListObjAndObjType)
        .factory('ListObjByObjTypeAndFleet', ListObjByObjTypeAndFleet)
        .factory('SetScheduleForAll', SetScheduleForAll);

    SetScheduleForAll.$inject = ['$resource', 'DateUtils'];

    function SetScheduleForAll($resource, DateUtils) {
        var resourceUrl = 'api/tab-schedules/add-more';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.scheduleDatetime = DateUtils.convertLocalDateFromServer(data.scheduleDatetime);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                   // data.scheduleDatetime = DateUtils.convertLocalDateToServer(data.scheduleDatetime);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.scheduleDatetime = DateUtils.convertLocalDateToServer(data.scheduleDatetime);
                    return angular.toJson(data);
                }
            }
        });
    }

    ListObjAndObjType.$inject = ['$resource'];


    function ListObjAndObjType($resource) {
        var resourceUrl = 'api/tab-objects/by-fleet/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                cache: false
            },
            'get': {
                method: 'GET',
                cache: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }

    ListObjByObjTypeAndFleet.$inject = ['$resource'];


    function ListObjByObjTypeAndFleet($resource) {
        var resourceUrl = 'api/tab-objects/by-obj-type/:typeId/fleet/:fleetId';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                cache: false
            },
            'filtered': {
                url:'api/tab-objects/by-obj-type/:typeId/fleet/:fleetId/filtered',
                method: 'GET',
                isArray: true
            },
            'update': {method: 'PUT'}
        }, {stripTrailingSlashes: false});
    }

    //TabActionsQueue.$inject = ['$resource'];
    //
    //function TabActionsQueue($resource) {
    //    var resourceUrl = 'api/tab-actions-queues/:id';
    //
    //    return $resource(resourceUrl, {}, {
    //        'query': {
    //            method: 'POST',
    //            isArray: true,
    //            cache: false
    //        }
    //
    //    });
    //}
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('custom-update', {
                parent: 'update_management',
                url: '/custom-update',
                params: {
                    commands: null,
                    tag: '',
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null
                },
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.customUpdate.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/custom-update/custom-update.html',
                        controller: 'CustomUpdatesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customUpdate');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('management', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('CheckSaveController', CheckSaveController);

    CheckSaveController.$inject = ['$state', '$uibModalInstance', 'AlertService'];

    function CheckSaveController($state, $uibModalInstance, AlertService) {
        var vm = this;
        vm.check = [];

        vm.totalObjects = [];
        vm.objects = [];
        var objects = localStorage.getItem("check-multiple-save");
        if(objects != null && objects != "null" && objects != undefined){
            vm.totalObjects = JSON.parse(objects);
            vm.page = 1;
            vm.systemQueryCount = Object.keys(vm.totalObjects).length;
            vm.systemItemLimit = 10;
            vm.systemNowTotalItems = Object.keys(vm.totalObjects).length;

            vm.objects = vm.totalObjects.slice(0, vm.systemItemLimit);
        }

        vm.changePage = function () {
            vm.objects = vm.totalObjects.slice((vm.page -1) * vm.systemItemLimit,
                ((vm.page -1) * vm.systemItemLimit) + vm.systemItemLimit);
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
            localStorage.setItem("check-multiple-save", JSON.stringify(vm.check));
        };

        vm.save = function () {
            $uibModalInstance.close();
            localStorage.setItem("check-multiple-save", JSON.stringify(vm.check));
        };

    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MultipleCommandsArgumentsController', MultipleCommandsArgumentsController);

    MultipleCommandsArgumentsController.$inject = ['$uibModal', '$scope', '$stateParams', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'Macro', 'Queue', '$rootScope', 'CommandManifest', '$filter'];

    function MultipleCommandsArgumentsController($uibModal, $scope, $stateParams, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, Macro, Queue, $rootScope, CommandManifest, $filter) {
        var vm = this;
        var commandStash = {};
        vm.tabCommands = [];
        vm.currentPage = 0;
        vm.tabActionsQueues = [];
        vm.actionDeviceReleaseMap = [];
        vm.datepickerOptions = {
            minDate: new Date()
        };
        vm.objectList = $stateParams.objects;
        vm.commandList = $stateParams.commands;
        vm.macro = $stateParams.macros;
        vm.licence = $rootScope.licence;
        vm.isGreengrassObject = false;

        vm.loadAll = function () {
            vm.tabObjectsActions = [];

            vm.isGreengrassObject = vm.objectList.some(function(obj) {
                return obj.objectType && obj.objectType.greengrassType === true;
            });

            if (vm.isGreengrassObject) {
                console.log('=== GREENGRASS OBJECTS DETECTED ===');
                console.log('Selected objects:', vm.objectList.length);

                // Recupera l'ObjectType dal primo oggetto
                var objectTypeId = vm.objectList[0].objectType.id;
                var fleetId = vm.objectList[0].fleet ? vm.objectList[0].fleet.id : null;

                // Cerca il manifest template salvato
                var cacheKey = 'manifestTemplate_' + objectTypeId + '_' + fleetId;
                var cachedManifestStr = localStorage.getItem(cacheKey);

                if (cachedManifestStr) {
                    try {
                        var cachedData = JSON.parse(cachedManifestStr);

                        console.log('✓ Using cached manifest template');
                        console.log('  Loaded from object:', cachedData.sourceObject);
                        console.log('  Object status:', cachedData.objectStatus);
                        console.log('  Cached at:', cachedData.timestamp);
                        console.log('  Will be applied to', vm.objectList.length, 'selected objects');

                        // Usa il manifest cached
                        var manifestData = cachedData.manifest;

                        // Trasforma il manifest in tabActions
                        var transformedData = transformManifestToTabActions(manifestData, vm.objectList[0]);

                        if (vm.macro && vm.macro.length > 0) {
                            loadGreengrassMacroCommands(manifestData, vm.objectList[0], transformedData);
                        } else {
                            onSuccess(transformedData);
                        }

                    } catch (e) {
                        console.error('Error parsing cached manifest:', e);
                        AlertService.error('Error loading cached manifest. Please go back and reload commands.');
                    }

                } else {
                    console.error('No cached manifest template found!');
                    console.error('Cache key:', cacheKey);
                    AlertService.error('Manifest template not found. Please go back and reload commands.');
                }
            } else {
                if(vm.commandList.length > 0){
                    TabActions.commandsByObjects({}, {objects: vm.objectList , commands: vm.commandList}, onSuccess, onError);
                }
            }

            function loadGreengrassMacroCommands(manifestData, greengrassObject, existingTransformedData) {
                console.log('%c=== LOADING GREENGRASS MACRO COMMANDS ===', 'color: #E91E63; font-weight: bold;');
                console.log('Number of macros to load:', vm.macro.length);
                console.log('Macros:', vm.macro);

                if (!vm.macro || vm.macro.length === 0) {
                    console.warn('No macros to load, calling onSuccess with existing data');
                    onSuccess(existingTransformedData);
                    return;
                }

                var macroCommandsToLoad = [];
                var macroCommandsLoaded = 0;

                vm.macro.forEach(function(macro, macroIndex) {
                    console.log('%c[Macro ' + (macroIndex + 1) + '/' + vm.macro.length + '] Loading commands for macro:', 'color: #E91E63; font-weight: bold;', macro.alias, 'ID:', macro.id);

                    Macro.getMacroDetails({macroId: macro.id}, function(queueCommands) {
                        console.log('%c[Macro ' + macro.alias + '] QueueCommands received:', 'color: #4CAF50;', queueCommands.length, 'commands');
                        console.log('QueueCommands:', queueCommands);

                        queueCommands.forEach(function(qc, qcIndex) {
                            console.log('  [Command ' + (qcIndex + 1) + '] Name:', qc.commandName, 'Arguments:', qc.arguments);

                            var parsedArguments = {};
                            try {
                                parsedArguments = qc.arguments ? JSON.parse(qc.arguments) : {};
                                console.log('  Parsed arguments:', parsedArguments);
                            } catch (e) {
                                console.error('  Failed to parse arguments:', e);
                            }

                            macroCommandsToLoad.push({
                                commandName: qc.commandName,
                                arguments: parsedArguments,
                                macroAlias: macro.alias,
                                order: qc.order
                            });
                        });

                        macroCommandsLoaded++;
                        console.log('%cMacros loaded so far: ' + macroCommandsLoaded + '/' + vm.macro.length, 'color: #2196F3;');

                        if (macroCommandsLoaded === vm.macro.length) {
                            console.log('%c=== ALL MACROS LOADED ===', 'color: #4CAF50; font-weight: bold;');
                            console.log('Total macro commands to transform:', macroCommandsToLoad.length);
                            console.log('Macro commands:', macroCommandsToLoad);

                            var allTransformedData = transformMacroCommandsFromManifest(
                                manifestData,
                                greengrassObject,
                                macroCommandsToLoad,
                                existingTransformedData
                            );

                            console.log('Calling onSuccess with', allTransformedData.length, 'total commands');
                            onSuccess(allTransformedData);
                        }
                    }, function(error) {
                        console.error('%c[Macro ' + macro.alias + '] ERROR loading macro details:', 'color: #F44336; font-weight: bold;', error);
                        console.error('Error status:', error.status);
                        console.error('Error data:', error.data);

                        macroCommandsLoaded++;
                        console.log('Macros loaded (with error) so far: ' + macroCommandsLoaded + '/' + vm.macro.length);

                        if (macroCommandsLoaded === vm.macro.length) {
                            console.warn('All macros processed (some with errors), calling onSuccess');
                            onSuccess(existingTransformedData);
                        }
                    });
                });
            }

            function transformMacroCommandsFromManifest(manifestData, obj, macroCommands, existingData) {
                console.log('%c=== TRANSFORMING MACRO COMMANDS FROM MANIFEST ===', 'color: #9C27B0; font-weight: bold;');

                var result = existingData || [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data');
                    return result;
                }

                macroCommands.forEach(function(macroCmd) {
                    console.log('Processing macro command:', macroCmd.commandName, 'from macro:', macroCmd.macroAlias);

                    var commandFound = false;

                    Object.keys(manifestData.manifest).forEach(function(componentName) {
                        var commands = manifestData.manifest[componentName];

                        commands.forEach(function(command) {
                            if (command.command_name === macroCmd.commandName) {
                                console.log('Found matching command in manifest:', command.command_name);
                                commandFound = true;

                                var argumentsSchema = null;
                                if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                                    (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {
                                    argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                                }

                                var tabAction = {
                                    id: 2000 + result.length,
                                    actionCommand: command.command_name,
                                    description: command.description || command.command_name,
                                    permissionLevel: command.permission_level || 1,
                                    weight: command.weight || 1,
                                    argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                                    isMacroCommand: true,
                                    macroAlias: macroCmd.macroAlias,
                                    macroArguments: macroCmd.arguments,
                                    macroOrder: macroCmd.order,
                                    deviceReleases: {
                                        id: 600 + result.length,
                                        deviceReleaseName: componentName,
                                        deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                        isActive: true,
                                        deviceReleaseVersion: '',
                                        device: {
                                            id: 300 + result.length,
                                            deviceName: componentName.split('.').pop(),
                                            deviceDescription: 'Greengrass device for ' + componentName,
                                            isActive: true,
                                            isVisibile: true,
                                            deviceType: {
                                                id: 100,
                                                deviceTypeName: 'Greengrass Component Type',
                                                deviceTypeDescription: 'AWS IoT Greengrass Component',
                                                isActive: true,
                                                isVisibile: true,
                                                entityId: 100
                                            },
                                            entityId: 300 + result.length
                                        },
                                        entityId: 600 + result.length
                                    }
                                };

                                console.log('Transformed macro command:', tabAction);
                                result.push(tabAction);
                            }
                        });
                    });

                    if (!commandFound) {
                        console.warn('Command not found in manifest:', macroCmd.commandName);
                    }
                });

                console.log('Total commands after macro transformation:', result.length);
                return result;
            }

            function transformManifestToTabActions(manifestData, obj) {
                var result = [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data:', manifestData);
                    return result;
                }

                console.log('%c=== GREENGRASS MANIFEST TRANSFORMATION ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Original Greengrass manifest data:', manifestData);

                var selectedCommandNames = new Set();
                vm.commandList.forEach(function(cmd) {
                    selectedCommandNames.add(cmd.actionCommand);
                });

                console.log('Selected command names:', Array.from(selectedCommandNames));

                Object.keys(manifestData.manifest).forEach(function(componentName) {
                    var commands = manifestData.manifest[componentName];

                    console.log('%cProcessing component: ' + componentName, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in component:', commands);

                    commands.forEach(function(command, index) {
                        if (!selectedCommandNames.has(command.command_name)) {
                            console.log('%cSkipping command: ' + command.command_name + ' (not selected)', 'color: #FF5722;');
                            return;
                        }

                        console.log('%cIncluding command: ' + command.command_name + ' (selected)', 'color: #4CAF50;');

                        var argumentsSchema = null;

                        if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                            (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {

                            argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                        }

                        var tabAction = {
                            id: 1000 + result.length,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            permissionLevel: command.permission_level || 1,
                            weight: command.weight || 1,
                            argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                            deviceReleases: {
                                id: 500 + result.length,
                                deviceReleaseName: componentName,
                                deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                isActive: true,
                                deviceReleaseVersion: '',
                                device: {
                                    id: 200 + result.length,
                                    deviceName: componentName.split('.').pop(),
                                    deviceDescription: 'Greengrass device for ' + componentName,
                                    isActive: true,
                                    isVisibile: true,
                                    deviceType: {
                                        id: 100,
                                        deviceTypeName: 'Greengrass Component Type',
                                        deviceTypeDescription: 'AWS IoT Greengrass Component',
                                        isActive: true,
                                        isVisibile: true,
                                        entityId: 100
                                    },
                                    entityId: 200 + result.length
                                },
                                entityId: 500 + result.length
                            }
                        };

                        console.log('%cCommand #' + (result.length + 1) + ': ' + command.command_name, 'color: #FF9800;');
                        console.log('  - Component Name (deviceReleaseName):', componentName);
                        console.log('  - Arguments Schema:', argumentsSchema);
                        console.log('  - Transformed TabAction:', tabAction);

                        result.push(tabAction);
                    });
                });

                console.log('%c=== TRANSFORMATION COMPLETE ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Total commands transformed:', result.length);
                console.log('Final result:', result);

                return result;
            }

            // Convert Greengrass arguments format to JSON Schema format
            function convertGreengrassArgumentsToJsonSchema(greengrassArgs) {
                var properties = {};
                var required = [];
                var order = 1;

                console.log('  Converting arguments:', greengrassArgs);

                var argsArray = Array.isArray(greengrassArgs) ? greengrassArgs :
                    (typeof greengrassArgs === 'object' ? [] : []);

                if (argsArray.length === 0 && typeof greengrassArgs === 'object' && !Array.isArray(greengrassArgs)) {
                    console.log('  No arguments to convert');
                    return null;
                }

                argsArray.forEach(function(arg) {
                    var key = arg.key;
                    var props = arg.props || {};

                    var property = {
                        description: props.description || props.label || '',
                        title: key,
                        type: mapGreengrassTypeToJsonSchemaType(arg.type)
                    };

                    if (arg.defaultValue !== undefined && arg.defaultValue !== null) {
                        property.default = arg.defaultValue;
                    }

                    property.order = order++;

                    if (arg.type === 'timepicker') {
                        property.format = 'time';
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                        property.options = {
                            step: 1,
                            floor: props.min !== undefined ? props.min : 0,
                            ceil: props.max !== undefined ? props.max : 100
                        };
                        property.minimum = props.min;
                        property.maximum = props.max;
                        if (props.thumbLabel !== undefined) {
                            property.thumbLabel = props.thumbLabel;
                        }
                    }

                    if (arg.type === 'select' && props.options && props.options.length > 0) {
                        property.titleMap = props.options.map(function(option) {
                            return {
                                name: option.label,
                                value: String(option.value)
                            };
                        });

                        property.enum = props.options.map(function(option) {
                            return String(option.value);
                        });

                        if (property.default !== undefined && property.default !== null) {
                            property.default = String(property.default);
                        }
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                    }

                    if (props.required) {
                        required.push(key);
                    }

                    properties[key] = property;

                    console.log('  - Property "' + key + '":', property);
                });

                var schema = {
                    metricReference: {},
                    type: 'object',
                    properties: properties
                };

                if (required.length > 0) {
                    schema.required = required;
                }

                console.log('  Final schema:', schema);

                return schema;
            }

            function mapGreengrassTypeToJsonSchemaType(greengrassType) {
                switch(greengrassType) {
                    case 'slider':
                        return 'number';
                    case 'toggle':
                        return 'boolean';
                    case 'text':
                    case 'input':
                    case 'timepicker':
                        return 'string';
                    case 'select':
                        return 'string';
                    default:
                        return 'string';
                }
            }

            function onSuccess(data) {
                console.log('%c=== FORM CREATION FROM DATA ===', 'color: #9C27B0; font-weight: bold; font-size: 14px;');
                console.log('Data received in onSuccess:', data);

                vm.formSchemas = {
                    forms: [],
                    buttons: []
                };

                // Aggiungi una struttura per memorizzare i comandi delle macro raggruppati
                vm.macroCommands = {};

                for (var i = 0; i < data.length; i++) {
                    $scope.formSchema = [];
                    vm.tabObjectsActions.push(data[i]);

                    if(!vm.actionDeviceReleaseMap[data[i].id])
                        vm.actionDeviceReleaseMap[data[i].id] = [];
                    vm.actionDeviceReleaseMap[data[i].id].push({
                        idAction: data[i].id,
                        deviceReleases: {
                            deviceReleaseName: data[i].deviceReleases.deviceReleaseName
                        }
                    });

                    console.log('%cProcessing command: ' + data[i].actionCommand, 'color: #9C27B0; font-weight: bold;');
                    console.log('  Device Release Name:', data[i].deviceReleases.deviceReleaseName);
                    console.log('  Is Macro Command:', data[i].isMacroCommand);

                    // Se è un comando di una macro, memorizzalo separatamente
                    if (data[i].isMacroCommand) {
                        if (!vm.macroCommands[data[i].macroAlias]) {
                            vm.macroCommands[data[i].macroAlias] = [];
                        }
                        vm.macroCommands[data[i].macroAlias].push({
                            actionId: data[i].id,
                            actionCommand: data[i].actionCommand,
                            deviceReleases: data[i].deviceReleases,
                            arguments: data[i].macroArguments,
                            order: data[i].macroOrder
                        });
                        console.log('  Added to macro commands for:', data[i].macroAlias);
                        continue; // Non aggiungere ai form/buttons
                    }

                    if (data[i].argumentsSchema != null) {
                        var jArg = angular.fromJson(data[i].argumentsSchema);
                        console.log('  Parsed argumentsSchema:', jArg);

                        var first = Object.keys(jArg.properties)[0];
                        if (jArg.properties[first].hasOwnProperty('order')) {
                            console.log('  Using ORDER-based sorting');
                            var orderProps = [];
                            orderProps.length = Object.keys(jArg.properties).length;
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                orderProps.splice(Number(jArg.properties[val].order) - 1, 1, entry);
                            });
                            orderProps.forEach(function (val) {
                                $scope.formSchema.push(val);
                            });
                        } else {
                            console.log('  Using NATURAL ordering');
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                $scope.formSchema.push(entry);
                            });
                        }

                        var formToAdd = {
                            command: data[i].actionCommand,
                            form: $scope.formSchema,
                            schema: jArg,
                            deviceReleases: data[i].deviceReleases,
                            actionId: data[i].id,
                            weight: data[i].weight
                        };

                        // Initialize default values
                        Object.keys(jArg.properties).forEach(function(propKey) {
                            if (jArg.properties[propKey].hasOwnProperty('default')) {
                                formToAdd[propKey] = jArg.properties[propKey].default;
                            }
                        });

                        console.log('  Form to add:', formToAdd);
                        vm.formSchemas.forms.push(formToAdd);
                    } else {
                        console.log('  No arguments - adding as BUTTON');
                        vm.formSchemas.buttons.push({
                            command: data[i].actionCommand,
                            deviceReleases: data[i].deviceReleases,
                            actionId: data[i].id
                        });
                    }
                }

                console.log('%cFinal formSchemas:', 'color: #9C27B0; font-weight: bold;');
                console.log('  Forms:', vm.formSchemas.forms);
                console.log('  Buttons:', vm.formSchemas.buttons);
                console.log('  Macro Commands:', vm.macroCommands);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.getEntry = function(jArg, val, arrayName) {
            var entry = {};
            if(arrayName != null)
                entry.key = arrayName + "[]." + val;
            else
                entry.key = val;
            if (jArg.properties[val].hasOwnProperty('titleMap')) {
                entry.titleMap = jArg.properties[val].titleMap;
                entry.type = 'select';
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].type === 'string' && !jArg.properties[val].hasOwnProperty('titleMap')) {
                if (jArg.properties[val].format === 'time') {
                    entry.type = 'timepicker';
                } else {
                    entry.type = 'text';
                }
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].hasOwnProperty('component') && !jArg.properties[val].hasOwnProperty('titleMap'))
                entry.type = jArg.properties[val].component;
            if (jArg.properties[val].hasOwnProperty('options'))
                entry.options = jArg.properties[val].options;
            if (jArg.properties[val].hasOwnProperty('style'))
                entry.style = jArg.properties[val].style;
            if (jArg.properties[val].hasOwnProperty('maxDate'))
                entry.maxDate = jArg.properties[val].maxDate;
            if (jArg.properties[val].hasOwnProperty('minDate'))
                entry.minDate = jArg.properties[val].minDate;
            if (jArg.properties[val].hasOwnProperty('format') && jArg.properties[val].format == 'time') {
                if (jArg.properties[val].default && typeof jArg.properties[val].default === 'string') {
                    var timeParts = jArg.properties[val].default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    jArg.properties[val].default = timeDate;
                }
            }
            if (jArg.properties[val].hasOwnProperty('default')) {
                jArg.properties[val].defaultRestore = angular.copy(jArg.properties[val].default);
            }
            if (jArg.properties[val].hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(jArg.properties[val].items.properties)[0];
                if (jArg.properties[val].items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties[val].items.properties).length;
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        orderProps.splice(Number(jArg.properties[val].items.properties[item].order) - 1, 1, vm.getEntry(jArg.properties[val].items, item, val));
                    });
                    orderProps.forEach(function (val) {
                        entry.items.push(val);
                    });
                } else {
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(jArg.properties[val].items, item, val));
                    });
                }
            }
            return entry;
        };

        vm.checkSave = function(){

            var objects = [];
            for(var i = 0; i < vm.objectList.length; i++){
                objects.push(vm.objectList[i].objectUniqueCode);
            }
            localStorage.setItem("check-multiple-save", JSON.stringify(objects));
            $uibModal.open({
                templateUrl: 'app/management/multiple-commands/check-save.html',
                controller: 'CheckSaveController',
                controllerAs: 'vm',
                size: 'md'
            }).result.then(function () {
                save();
            });
        };

        function save() {
            $scope.$broadcast('schemaFormValidate');
            if($('form.ng-invalid').length == 0 && $('form.ng-invalid-add').length == 0) {
                vm.isSaving = true;

                console.log('%c=== SAVING COMMANDS ===', 'color: #FF5722; font-weight: bold;');
                console.log('Is Greengrass Object:', vm.isGreengrassObject);
                console.log('Form Schemas:', vm.formSchemas);
                console.log('Macro Commands:', vm.macroCommands);

                if(vm.commandList.length > 0){
                    vm.formSchemas.buttons.forEach(function (value) {
                        console.log('Sending button command:', value);
                        sendAction(value, false);
                    });
                    vm.formSchemas.forms.forEach(function (value) {
                        console.log('Sending form command:', value);
                        sendAction(value, true);
                    });
                }

                // Gestione macro per oggetti Greengrass
                if (vm.isGreengrassObject && vm.macroCommands && Object.keys(vm.macroCommands).length > 0) {
                    console.log('%c=== SENDING GREENGRASS MACRO COMMANDS ===', 'color: #E91E63; font-weight: bold;');

                    Object.keys(vm.macroCommands).forEach(function(macroAlias) {
                        var macroCommandsList = vm.macroCommands[macroAlias];

                        // Ordina i comandi per order
                        macroCommandsList.sort(function(a, b) {
                            return a.order - b.order;
                        });

                        console.log('Sending macro:', macroAlias, 'with', macroCommandsList.length, 'commands');

                        macroCommandsList.forEach(function(cmd) {
                            console.log('  Command:', cmd.actionCommand, 'Arguments:', cmd.arguments);
                            sendGreengrassMacroCommand(cmd);
                        });
                    });
                }

                // Gestione macro per oggetti non-Greengrass (logica originale)
                if (!vm.isGreengrassObject && vm.macro) {
                    vm.macro.forEach(function (value) {
                        value.macroActions.sort(function (a, b) {
                            var commandA = a.order, commandB = b.order;
                            return commandA - commandB;
                        });
                        for(var i = 0; i < value.macroActions.length; i++){
                            if(value.macroActions[i].arguments == "{}") {
                                sendMacro(value.macroActions[i], false);
                            } else {
                                sendMacro(value.macroActions[i], true);
                            }
                        }
                    });
                }

                vm.objectList.forEach(function (commandQueue) {
                    // Initialize tabActionsQueues for this object if it doesn't exist
                    if(!vm.tabActionsQueues[commandQueue.objectUniqueCode]) {
                        vm.tabActionsQueues[commandQueue.objectUniqueCode] = {commands: [], object: commandQueue};
                    }

                    console.log('%cQueue for object: ' + commandQueue.objectUniqueCode, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in queue:', vm.tabActionsQueues[commandQueue.objectUniqueCode].commands);

                    vm.tabActionsQueues[commandQueue.objectUniqueCode].scheduleDateTime = vm.scheduleDateTime;
                    vm.tabActionsQueues[commandQueue.objectUniqueCode].cron = vm.cron;
                    if(vm.cron === true && vm.repeatNumber && vm.repeatTime) {
                        vm.tabActionsQueues[commandQueue.objectUniqueCode].cronExpression = vm.repeatNumber  + " " + vm.repeatTime;
                    } else if(vm.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                        AlertService.error("Fill Repetition fields");
                        return;
                    }

                    vm.commands = {};
                    vm.commands.commands = vm.tabActionsQueues[commandQueue.objectUniqueCode].commands;
                    vm.commands.object = commandQueue;

                    vm.commands.scheduleDateTime = vm.tabActionsQueues[commandQueue.objectUniqueCode].scheduleDateTime;
                    vm.commands.cronExpression = vm.tabActionsQueues[commandQueue.objectUniqueCode].cronExpression;

                    var d = new Date();
                    var dd = d.getDate();
                    var MM = d.getMonth();
                    MM++;
                    var yyyy = d.getFullYear();
                    vm.commands.alias = "Queue_"+commandQueue.objectUniqueCode+"_"+dd+"/"+MM+"/"+yyyy;

                    console.log('%cFinal commands object to send:', 'color: #4CAF50; font-weight: bold;');
                    console.log(vm.commands);

                    Queue.create(vm.commands, onSuccess, onError);
                });

            }
            function onSuccess() {
                //reset tab actions queues
                vm.tabActionsQueues = [];
                console.log('%cCommands sent successfully!', 'color: #4CAF50; font-weight: bold;');
            }

            function onError(error) {
                //reset tab actions queues
                vm.tabActionsQueues = [];
                console.error('%cError sending commands:', 'color: #F44336; font-weight: bold;', error);
                AlertService.error(error.data.message);
            }
        }

        vm.cleanEntity = function (entity, commandName, withArgs, isMacro) {
            if(!isMacro){
                if (withArgs) {
                    var args = {};
                    for (var key in entity.schema.properties) {
                        if(entity[key] instanceof Date) {
                            args[key] = String(entity[key].getHours()).padStart(2, '0') + ":" + String(entity[key].getMinutes()).padStart(2, '0');
                        } else {
                            args[key] = entity[key];
                        }
                    }
                }
                if(args == undefined){
                    args = {};
                }

                console.log('%cCleaning entity for command: ' + commandName, 'color: #9C27B0;');
                console.log('  Entity:', entity);
                console.log('  Action ID:', entity.actionId);
                console.log('  Device Release Map:', vm.actionDeviceReleaseMap[entity.actionId]);

                // Get deviceReleases from actionDeviceReleaseMap
                var deviceReleasesInfo = vm.actionDeviceReleaseMap[entity.actionId][0].deviceReleases;

                var cleanedEntity = {
                    id: entity.actionId,
                    actionCommand: commandName,
                    deviceReleases: deviceReleasesInfo,
                    arguments: args
                };

                console.log('  Cleaned entity:', cleanedEntity);

                return cleanedEntity;
            } else {
                return {
                    id: entity.tabActions.id,
                    arguments: entity.argumentMap,
                    actionCommand: entity.tabActions.actionCommand,
                    deviceReleases: entity.tabActions.deviceReleases,
                    argumentMap: entity.argumentMap
                };
            }
        };

        function sendAction(action, withArgument) {
            console.log('%cSendAction called', 'color: #FF9800;');
            console.log('  Action:', action);
            console.log('  With Argument:', withArgument);
            console.log('  Is Greengrass:', vm.isGreengrassObject);

            vm.objectList.forEach(function (commandObject) {
                console.log('  Processing object:', commandObject.objectUniqueCode);

                // For Greengrass objects, send to all objects regardless of deviceReleases match
                if (vm.isGreengrassObject) {
                    console.log('    Adding to queue (Greengrass)');
                    vm.addCommandInQueue(commandObject, action, withArgument, false);
                } else {
                    // Original logic for non-Greengrass objects
                    commandObject.deviceReleases.forEach(function (dr) {
                        console.log('    Checking device release:', dr.id, 'vs', action.deviceReleases.id);
                        if(dr.id == action.deviceReleases.id) {
                            console.log('    Match! Adding to queue');
                            vm.addCommandInQueue(commandObject, action, withArgument, false);
                        }
                    });
                }
            });
        }

        function sendMacro(action, withArgument) {
            vm.objectList.forEach(function (commandObject) {
                vm.addCommandInQueue(commandObject, action, withArgument, true);
            });
        }

        function sendGreengrassMacroCommand(command) {
            console.log('%cSendGreengrassMacroCommand called', 'color: #E91E63;');
            console.log('  Command:', command);

            vm.objectList.forEach(function (commandObject) {
                console.log('  Processing object:', commandObject.objectUniqueCode);

                if(!vm.tabActionsQueues[commandObject.objectUniqueCode]) {
                    vm.tabActionsQueues[commandObject.objectUniqueCode] = {commands: [], object: {}};
                    vm.tabActionsQueues[commandObject.objectUniqueCode].object = commandObject;
                }

                var cleanedCommand = {
                    id: command.actionId,
                    actionCommand: command.actionCommand,
                    deviceReleases: command.deviceReleases,
                    arguments: command.arguments || {}
                };

                console.log('  Adding macro command to queue:', cleanedCommand);
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(cleanedCommand);
            });
        }

        vm.addCommandInQueue = function(commandObject, action, withArgument, isMacro) {
            console.log('%cAddCommandInQueue called', 'color: #00BCD4;');
            console.log('  Object:', commandObject.objectUniqueCode);
            console.log('  Action:', action);
            console.log('  With Argument:', withArgument);
            console.log('  Is Macro:', isMacro);

            if(!vm.tabActionsQueues[commandObject.objectUniqueCode]) {
                vm.tabActionsQueues[commandObject.objectUniqueCode] = {commands: [], object: {}};
                vm.tabActionsQueues[commandObject.objectUniqueCode].object = commandObject;
            }
            if(isMacro) {
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(vm.cleanEntity(action, action.tabActions.actionCommand, withArgument, true));
            } else {
                var cleanedCommand = vm.cleanEntity(action, action.command, withArgument, false);
                console.log('  Cleaned command to add:', cleanedCommand);
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(cleanedCommand);
            }

            console.log('  Updated queue:', vm.tabActionsQueues[commandObject.objectUniqueCode].commands);
        }

        vm.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleDatetime) {
                vm.scheduleDatetime.isOpen = !vm.scheduleDatetime.isOpen;
            } else {
                vm.scheduleDatetime = {isOpen: true};
            }
        };

        vm.loadAll();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MultipleCommandsController', MultipleCommandsController);

    MultipleCommandsController.$inject = ['$scope', '$state', '$http', '$timeout', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'Macro', 'CommandManifest', 'pagingParams'];

    function MultipleCommandsController($scope, $state, $http, $timeout, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, Macro, CommandManifest, pagingParams) {
        var vm = this;

        vm.total = 0;
        vm.onlyOnline = false;
        vm.commandToSend = false;
        vm.tabActions = [];
        vm.macro = [];
        vm.tabCommands = [];
        vm.tabMacro = [];
        vm.objectToUdp = [];
        vm.selectionValue = [];
        vm.pagesChecked = [];
        vm.predicates = {};
        vm.currentPage = 0;
        vm.tabActionsQueue = {commands: [], object: []};
        vm.charToSearch = pagingParams.search;
        vm.currentState = "multiple-commands";
        vm.currentStateFilter = "multiple-commands-filter";
        vm.showTable = false;
        vm.applyFilter = applyFilter;
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleets = [];
        vm.selectedCondition = {};
        vm.selectedObjectTypes = [];
        vm.fleet = {};
        vm.objectType = {};
        vm.showWarning = false;
        vm.filter = localStorage.getItem(vm.currentStateFilter);
        vm.hasGreengrassSelected = false;
        vm.greengrassCount = 0;
        vm.isGreengrassObjectType = false;
        vm.objectTypeCache = {};
        vm.filterApplied = false;
        vm.isInitializing = true;

        // Initialize filter and check Greengrass state
        function initializeController() {
            if (vm.filter !== null && vm.filter !== "null" && vm.filter !== undefined) {
                try {
                    vm.filter = JSON.parse(vm.filter);
                    if (Object.keys(vm.filter).length > 0) {
                        vm.selectedFleet.id = vm.filter.fleet;
                        vm.selectedObjectType.id = vm.filter.objectType;

                        // Check if it's Greengrass synchronously if possible
                        if (vm.selectedObjectType.id) {
                            checkAndSetGreengrassState().then(function() {
                                vm.isInitializing = false;
                            });
                        } else {
                            vm.isInitializing = false;
                        }
                    } else {
                        vm.isInitializing = false;
                    }
                } catch (e) {
                    console.error('Error parsing filter:', e);
                    vm.filter = {};
                    vm.isInitializing = false;
                }
            } else {
                vm.filter = {};
                vm.isInitializing = false;
            }
        }

        // Initialize on controller load
        initializeController();

        // Watch for ObjectType changes and reset state
        $scope.$watch('vm.selectedObjectType', function(newValue, oldValue) {
            if (newValue !== oldValue && newValue && newValue.id) {
                console.log('ObjectType changed:', newValue);

                // Reset state when ObjectType changes
                if (oldValue && oldValue.id && oldValue.id !== newValue.id) {
                    resetStateOnObjectTypeChange();
                }

                vm.checkIfObjectTypeIsGreengrass(newValue);
            }
        }, true);

        // Watch for filter changes and update filterApplied flag
        $scope.$watch('[vm.selectedFleet.id, vm.selectedObjectType.id]', function(newValues, oldValues) {
            if (newValues[0] !== oldValues[0] || newValues[1] !== oldValues[1]) {
                if (vm.filterApplied && (newValues[0] !== vm.filter.fleet || newValues[1] !== vm.filter.objectType)) {
                    console.log('Filter parameters changed - marking as not applied');
                    vm.filterApplied = false;
                    // Clear selections when filter changes
                    vm.clearObjectList();
                }
            }
        }, true);

        function checkAndSetGreengrassState() {
            var deferred = $http.get('api/tab-object-types/' + vm.selectedObjectType.id);

            return deferred.then(function(response) {
                var fullObjectType = response.data;
                vm.objectTypeCache[vm.selectedObjectType.id] = fullObjectType;

                if (fullObjectType && fullObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    vm.filterApplied = true; // Mark as applied if coming from saved state
                    console.log('Greengrass ObjectType restored from saved state');
                } else {
                    vm.isGreengrassObjectType = false;
                    // Check if filter was applied for non-Greengrass
                    if (vm.filter && vm.filter.fleet && vm.filter.objectType) {
                        vm.filterApplied = true;
                    }
                }
                return fullObjectType;
            }).catch(function(error) {
                console.error('Error loading ObjectType:', error);
                vm.isGreengrassObjectType = false;
                return null;
            });
        }

        function resetStateOnObjectTypeChange() {
            console.log('Resetting state due to ObjectType change');
            vm.tabCommands = [];
            vm.tabMacro = [];
            vm.objectList = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.showTable = false;
            vm.filterApplied = false;
            vm.hasGreengrassSelected = false;
            vm.greengrassCount = 0;
            vm.areChk = false;
            vm.pagesChecked = [];
            vm.tabActions = [];
            vm.macro = [];
            vm.isGreengrassObjectType = false;

            // Update chosen selects
            $timeout(function() {
                $('#field_action').trigger('chosen:updated');
                $('#field_action_macro').trigger('chosen:updated');
            }, 100);
        }

        vm.loadAll = function () {
            var queryString = {
                page: 0,
                size: 2000,
                query: vm.charToSearch,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            };

            if (vm.isGreengrassObjectType) {
                console.log('Greengrass ObjectType - loading commands from manifest');
                vm.loadCommandsFromManifest();

/*                Macro.queryGreengrassByObjectType({
                    objectTypeId: vm.selectedObjectType.id,
                    fleetId: vm.selectedFleet.id,
                    page: 0
                }, onSuccessMacro, onErrorMacro);*/
            } else {
                TabActions.multiple(queryString, onSuccess, onError);

                Macro.byObjectType({
                    id: vm.selectedObjectType.id,
                    fleet: vm.selectedFleet.id,
                    page: 0
                }, onSuccessMacro, onErrorMacro);
            }

            function onSuccess(data, headers) {
                if(!queryString.fleet) {
                    vm.applyFilter(vm.selectedFleet.id, vm.selectedObjectType.id);
                } else {
                    vm.tabActions = data;
                    console.log('TabActions loaded (non-Greengrass):', vm.tabActions.length);

                    if (vm.filter == 'null' || vm.filter == null || vm.filter == undefined)
                        vm.filter = {};
                    localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

                    $timeout(function() {
                        $('#field_action').trigger('chosen:updated');
                    }, 100);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            function onSuccessMacro(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }

                console.log('Macros loaded:', vm.macro.length, 'isGreengrass:', vm.isGreengrassObjectType);

                $timeout(function() {
                    $('#field_action_macro').trigger('chosen:updated');
                }, 100);
            }

            function onErrorMacro() {
                vm.macro = [];
            }
        };

        vm.search = function () {
            vm.fetchObjects(1);
        };

        vm.fetchObjects = function(page) {
            vm.currentPage = page;

            // For Greengrass, verify filter has been applied
            if (vm.isGreengrassObjectType && !vm.filterApplied) {
                AlertService.error("Please apply filter before checking objects for Greengrass ObjectType");
                return;
            }

            if(vm.selectedFleet.id != vm.filter.fleet || vm.selectedObjectType.id != vm.filter.objectType) {
                AlertService.error("Apply filter before check objects");
                return;
            }

            // For Greengrass use a different API with online parameter from checkbox
            if (vm.isGreengrassObjectType) {
                console.log('Fetching objects for Greengrass with online=' + vm.onlyOnline);
                var queryString = {
                    page: page - 1,
                    size: 20,
                    query: vm.charToSearch,
                    //online: vm.onlyOnline,  // Use checkbox value instead of hardcoded true
                    fleetId: vm.selectedFleet.id,
                    typeId: vm.selectedObjectType.id,
                    cacheBuster: new Date().getTime()
                };

                if (vm.onlyOnline) {
                    queryString.online = true;
                }

                $http.get('api/tab-objects', {params: queryString}).then(function(response) {
                    var data = response.data;
                    var headers = response.headers;

                    vm.showTable = true;
                    vm.objectList = data;
                    vm.greengrassCount = 0;

                    if (data && data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].objectType && data[i].objectType.greengrassType === true) {
                                vm.greengrassCount++;
                            }
                        }
                        if (vm.greengrassCount > 0) {
                            console.info('Found ' + vm.greengrassCount + ' Greengrass objects');
                        }
                    }

                    if(data.length > 0) {
                        var linkHeader = headers('link');
                        if (linkHeader) {
                            vm.links = ParseLinks.parse(linkHeader);
                        }
                        var totalCountHeader = headers('X-Total-Count');
                        vm.totalItems = totalCountHeader ? parseInt(totalCountHeader) : data.length;
                        if(vm.totalItems > vm.total){
                            vm.total = vm.totalItems;
                        }
                        if (vm.areChk || vm.checkNextPages)
                            pushAllObject();
                    } else {
                        vm.totalItems = 0;
                    }
                    vm.queryCount = vm.totalItems;
                }).catch(function(error) {
                    console.error('Error fetchObjects for Greengrass:', error);
                    AlertService.error('Error loading objects');
                });
            } else {
                // For non-Greengrass use normal byActions call
                var queryString = {
                    page: page - 1,
                    size: 20,
                    query: vm.charToSearch,
                    onlyOnline: vm.onlyOnline,
                    fleet: vm.selectedFleet.id,
                    objectType: vm.selectedObjectType.id
                };
                TabObjects.byActions(queryString, {commands: vm.tabCommands, macros: vm.tabMacro}, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.showTable = true;
                vm.objectList = data;
                vm.greengrassCount = 0;

                if (data && data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].objectType && data[i].objectType.greengrassType === true) {
                            vm.greengrassCount++;
                        }
                    }
                    if (vm.greengrassCount > 0) {
                        console.info('Found ' + vm.greengrassCount + ' Greengrass objects');
                    }
                }

                if(data.length > 0) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    if(vm.totalItems > vm.total){
                        vm.total = vm.totalItems;
                    }
                    if (vm.areChk || vm.checkNextPages)
                        pushAllObject();
                } else {
                    vm.totalItems = 0;
                }
                vm.queryCount = vm.totalItems;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function applyFilter(fleet, objectType) {
            vm.showWarning = false;
            vm.tabCommands = [];
            vm.tabMacro = [];
            vm.macro = [];
            vm.objectList = [];
            vm.tabActions = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.showTable = false;
            vm.filterApplied = false;
            vm.areChk = false;
            vm.pagesChecked = [];

            if(fleet && fleet.id) {
                if(fleet.id > 0) {
                    vm.fleet = fleet;
                    vm.filter.fleet = fleet.id;
                } else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                    vm.filter.fleet = -1;
                }
            }
            if(objectType && objectType.id && objectType.id > -1) {
                vm.objectType = objectType;
                vm.filter.objectType = objectType.id;

                // Re-check if it's Greengrass when applying filter
                if (vm.selectedObjectType && vm.selectedObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    console.warn('Greengrass ObjectType detected in applyFilter');
                } else {
                    // Check from cache or API
                    vm.checkIfObjectTypeIsGreengrass(vm.selectedObjectType);
                }
            } else {
                vm.objectType.id = -1;
                vm.isGreengrassObjectType = false;
            }

            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            // Wait a bit for Greengrass check to complete before loading
            $timeout(function() {
                vm.loadAll();
                vm.filterApplied = true;
                console.log('Filter applied - filterApplied:', vm.filterApplied, 'isGreengrassObjectType:', vm.isGreengrassObjectType);
            }, 100);
        }

        vm.checkIfObjectTypeIsGreengrass = function(objectType) {
            console.log('Checking ObjectType:', objectType);

            if (!objectType || !objectType.id) {
                vm.isGreengrassObjectType = false;
                return;
            }

            if (objectType.greengrassType === true) {
                vm.isGreengrassObjectType = true;
                console.warn('Greengrass ObjectType detected:', objectType);
                return;
            }

            if (objectType.greengrassType === false) {
                vm.isGreengrassObjectType = false;
                console.log('Non-Greengrass ObjectType confirmed:', objectType);
                return;
            }

            // Check cache first
            if (vm.objectTypeCache[objectType.id]) {
                console.log('ObjectType found in cache');
                var cachedObjectType = vm.objectTypeCache[objectType.id];
                if (cachedObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    console.warn('Greengrass ObjectType detected (from cache):', cachedObjectType);
                } else {
                    vm.isGreengrassObjectType = false;
                }
                return;
            }

            // Load from API if not in cache and greengrassType property is missing
            console.log('Loading ObjectType details ID:', objectType.id);
            $http.get('api/tab-object-types/' + objectType.id)
                .then(function(response) {
                    var fullObjectType = response.data;
                    console.log('Full ObjectType received:', fullObjectType);
                    vm.objectTypeCache[objectType.id] = fullObjectType;

                    if (fullObjectType && fullObjectType.greengrassType === true) {
                        vm.isGreengrassObjectType = true;
                        console.warn('Greengrass ObjectType detected (after loading):', fullObjectType);
                    } else {
                        vm.isGreengrassObjectType = false;
                    }

                    // Update UI after async load
                    $timeout(function() {
                        $('#field_action').trigger('chosen:updated');
                    }, 50);
                })
                .catch(function(error) {
                    console.error('Error loading ObjectType:', error);
                    vm.isGreengrassObjectType = false;
                });
        };

        vm.loadCommandsFromManifest = function() {
            if (!vm.selectedObjectType || !vm.selectedObjectType.id) {
                console.warn('No ObjectType selected to load commands');
                return;
            }

            if (!vm.isGreengrassObjectType) {
                console.log('Non-Greengrass ObjectType, skip manifest loading');
                return;
            }

            console.log('Loading manifest for Greengrass ObjectType...');
            console.log('Fleet ID:', vm.selectedFleet.id);
            console.log('ObjectType ID:', vm.selectedObjectType.id);

            $http.get('api/tab-objects/with-manifest', {
                params: {
                    fleetId: vm.selectedFleet.id,
                    typeId: vm.selectedObjectType.id
                }
            })
                .then(function(response) {
                    var objectWithManifest = response.data;

                    console.log('Object with manifest found:', objectWithManifest.objectUniqueCode);
                    console.log('  Status:', objectWithManifest.objectOnline ? 'ONLINE' : 'OFFLINE');
                    console.log('  Last tick:', objectWithManifest.lastTick);

                    return CommandManifest.get({
                        objectUniqueCode: objectWithManifest.objectUniqueCode
                    }).$promise.then(function(manifestData) {
                        return {
                            manifest: manifestData,
                            sourceObject: objectWithManifest.objectUniqueCode,
                            objectStatus: objectWithManifest.objectOnline ? 'ONLINE' : 'OFFLINE',
                            lastTick: objectWithManifest.lastTick
                        };
                    });
                })
                .then(function(result) {
                    console.log('Manifest loaded successfully!');


                    AlertService.success(
                        'Commands loaded successfully'
                    );

                    // Processa il manifest
                    processManifestTemplate(
                        result.manifest,
                        result.sourceObject,
                        result.objectStatus,
                        result.lastTick
                    );
                })
                .catch(function(error) {
                    console.error('Error loading manifest:', error);

                    if (error.status === 404) {
                        AlertService.error(
                            'No commands available for this fleet and object type. '
                        );
                    } else {
                        AlertService.error('Error loading commands from manifest');
                    }

                    vm.tabActions = [];
                    vm.tabCommands = [];
                });
        };

        /**
         * Processa il manifest e lo salva in cache
         */
        function processManifestTemplate(manifestData, sourceObject, objectStatus, lastTick) {
            vm.tabActions = [];
            vm.tabCommands = [];

            if (!manifestData || !manifestData.manifest) {
                console.warn('Invalid manifest data');
                return;
            }

            console.log('Processing manifest template...');
            console.log('  Source object:', sourceObject);
            console.log('  Object status:', objectStatus);

            var commandIndex = 0;

            angular.forEach(manifestData.manifest, function(commands, componentName) {
                angular.forEach(commands, function(command) {
                    if (command.command_name) {
                        vm.tabActions.push({
                            id: 'manifest_' + commandIndex,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            componentName: componentName
                        });
                        commandIndex++;
                    }
                });
            });

            console.log('Total commands loaded:', vm.tabActions.length);

            if (vm.tabActions.length === 0) {
                AlertService.warning('No commands available in manifest');
                return;
            }

            // Salva in cache
            var manifestCache = {
                manifest: manifestData,
                sourceObject: sourceObject,
                objectStatus: objectStatus,
                lastTick: lastTick,
                timestamp: new Date().toISOString(),
                objectTypeId: vm.selectedObjectType.id,
                fleetId: vm.selectedFleet.id,
                commandCount: vm.tabActions.length
            };

            var cacheKey = 'manifestTemplate_' + vm.selectedObjectType.id + '_' + vm.selectedFleet.id;
            localStorage.setItem(cacheKey, JSON.stringify(manifestCache));

            console.log('Manifest cached successfully');
            console.log('Loading Greengrass macros after manifest success...');
            Macro.queryGreengrassByObjectType({
                objectTypeId: vm.selectedObjectType.id,
                fleetId: vm.selectedFleet.id,
                page: 0
            }, function(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }
                console.log('Greengrass macros loaded:', vm.macro.length);

                $timeout(function() {
                    $('#field_action_macro').trigger('chosen:updated');
                }, 100);
            }, function() {
                console.warn('Error loading Greengrass macros');
                vm.macro = [];
            });



            // Aggiorno filtro
            if (!vm.filter) vm.filter = {};
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            // Aggiorno UI
            $timeout(function() {
                var selectElement = $('#field_action');
                if (selectElement.data('chosen')) {
                    selectElement.trigger('chosen:updated');
                }
            }, 100);
        }





        function pushAllObject() {
            vm.checkNextPages = true;
            if(vm.pagesChecked.indexOf(vm.currentPage - 1) < 0 || vm.areChk) {
                $.each(vm.objectList, function (key, el) {
                    // Allow Greengrass objects to be selected - they'll be handled on the next page
                    if(vm.selectionValue.indexOf(el.objectUniqueCode) < 0) {
                        vm.selectionValue.push(el.objectUniqueCode);
                        vm.objectToUdp.push(el);
                    }
                });
                vm.pagesChecked.push(vm.currentPage - 1);
            }
        }

        vm.chkUnChkAll = function () {
            if (vm.areChk) {
                vm.objectToUdp = [];
                vm.selectionValue = [];
                vm.checkNextPages = false;
                vm.pagesChecked = [];
            } else {
                vm.objectToUdp = [];
                vm.selectionValue = [];

                if (vm.isGreengrassObjectType) {
                    var queryString = {
                        page: 0,
                        size: 2000,
                        query: vm.charToSearch,
                        //online: vm.onlyOnline,  // Use checkbox value instead of hardcoded true
                        fleetId: vm.selectedFleet.id,
                        typeId: vm.selectedObjectType.id,
                        cacheBuster: new Date().getTime()
                    };

                    if (vm.onlyOnline) {
                        queryString.online = true;
                    }

                    $http.get('api/tab-objects', {params: queryString}).then(function(response) {
                        onAllSuccess(response.data);
                        pushAllObject();
                    }).catch(function(error) {
                        onAllError(error);
                    });
                } else {
                    var queryString = {
                        page: 0,
                        size: 2000,
                        query: vm.charToSearch,
                        onlyOnline: vm.onlyOnline,
                        fleet: vm.selectedFleet.id,
                        objectType: vm.selectedObjectType.id
                    };
                    TabObjects.byActions(queryString, {commands: vm.tabCommands, macros: vm.macro}, onAllSuccess, onAllError);
                    pushAllObject();
                }
            }
            vm.areChk = !vm.areChk;
            vm.updateGreengrassSelectedFlag();
        };

        function onAllSuccess(data) {
            $.each(data, function (key, el) {
                // Allow all objects to be added, including Greengrass
                if(vm.selectionValue.indexOf(el.objectUniqueCode) < 0) {
                    vm.selectionValue.push(el.objectUniqueCode);
                    vm.objectToUdp.push(el);
                }
            });
        }

        function onAllError(error) {
            AlertService.error("Error retrieving objects");
        }

        vm.toggleSelection = function (data) {
            var idx = vm.selectionValue.indexOf(data.objectUniqueCode);
            if (idx > -1) {
                vm.selectionValue.splice(idx, 1);
                vm.objectToUdp.splice(idx, 1);
                if (vm.selectionValue.length < vm.total) {
                    vm.areChk = false;
                }
            } else {
                vm.selectionValue.push(data.objectUniqueCode);
                vm.objectToUdp.push(data);
                if (vm.selectionValue.length == vm.total){
                    vm.areChk = true;
                }
            }
            vm.updateGreengrassSelectedFlag();
        };

        vm.clearObjectList = function() {
            vm.objectList = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.areChk = false;
            vm.showTable = false;
            vm.hasGreengrassSelected = false;
            vm.greengrassCount = 0;
            vm.pagesChecked = [];
        };

        vm.updateGreengrassSelectedFlag = function() {
            vm.hasGreengrassSelected = false;
            for (var i = 0; i < vm.objectToUdp.length; i++) {
                if (vm.objectToUdp[i].objectType && vm.objectToUdp[i].objectType.greengrassType === true) {
                    vm.hasGreengrassSelected = true;
                    console.info('Greengrass objects selected - will be handled on next page');
                    break;
                }
            }
        };

        $scope.$watch('vm.objectToUdp', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.updateGreengrassSelectedFlag();
            }
        }, true);

        // Listen for state changes to reset state when leaving/returning
        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if (fromState.name === 'multiple-commands') {
                console.log('Leaving multiple-commands state');
            }
        });

        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'multiple-commands' && fromState.name !== '') {
                console.log('Returning to multiple-commands state');
                // Reinitialize to check Greengrass state
                if (vm.selectedObjectType && vm.selectedObjectType.id) {
                    vm.checkIfObjectTypeIsGreengrass(vm.selectedObjectType);
                }
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabCommand', TabCommand);

    TabCommand.$inject = ['$resource'];



    function TabCommand($resource) {
        var resourceUrl = 'api/tab-objects/action-by-id/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                cache: false
            },
            'get': {
                method: 'GET',
                cache: false
                // transformResponse: function (data) {
                //     data = angular.fromJson(data);
                //     return data;
                // }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('multiple-commands', {
                parent: 'management',
                url: '/multiple-commands/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.multiple.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/multiple-commands/multiple-commands.html',
                        controller: 'MultipleCommandsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            search: $stateParams.search,
                            filter: $stateParams.listFilter,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('multiple-commands-arguments', {
                parent: 'management',
                url: '/multiple-commands-arguments',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.multiple.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/multiple-commands/multiple-commands-arguments.html',
                        controller: 'MultipleCommandsArgumentsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    objects: {
                        value: [],
                        squash: true
                    },
                    commands: {
                        value: [],
                        squash: true
                    },
                    macros: {
                        value: [],
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
;
angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        //Creates an default titleMap list from an enum, i.e. a list of strings.
        var enumToTitleMap = function(enm) {
            var titleMap = []; //canonical titleMap format is a list.
            enm.forEach(function(name) {
                titleMap.push({name: name, value: name});
            });
            return titleMap;
        };

        var stripNullType = function(type) {
            if (Array.isArray(type) && type.length == 2) {
                if (type[0] === 'null')
                    return type[1];
                if (type[1] === 'null')
                    return type[0];
            }
            return type;
        };

        var array = function(name, schema, options) {
            if (stripNullType(schema.type) === 'array') {
                var f   = schemaFormProvider.stdFormObj(name, schema, options);
                f.type  = 'array';
                f.key   = options.path;
                options.lookup[sfPathProvider.stringify(options.path)] = f;

                var required = schema.required &&
                    schema.required.indexOf(options.path[options.path.length - 1]) !== -1;
                // The default is to always just create one child. This works since if the
                // schemas items declaration is of type: "object" then we get a fieldset.
                // We also follow json form notatation, adding empty brackets "[]" to
                // signify arrays.

                var arrPath = options.path.slice();
                arrPath.push('');

                f.items = [schemaFormProvider.defaultFormDefinition(name, schema.items, {
                    path: arrPath,
                    required: required || false,
                    lookup: options.lookup,
                    ignore: options.ignore,
                    global: options.global
                })];
                return f;
            }
        };

        // Add our default to the defaults array
        angular.forEach(schemaFormProvider.defaults.array, function(value, i){
            if (value.name == 'array') {
                schemaFormProvider.defaults.array[i] = array;
            }
        });

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'array',
            'app/schema-form-component/angular-schema-form-array/angular-schema-form-array.html');

    }]);
;
angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        //Creates an default titleMap list from an enum, i.e. a list of strings.
        var enumToTitleMap = function(enm) {
            var titleMap = []; //canonical titleMap format is a list.
            enm.forEach(function(name) {
                titleMap.push({name: name, value: name});
            });
            return titleMap;
        };

        var stripNullType = function(type) {
            if (Array.isArray(type) && type.length == 2) {
                if (type[0] === 'null')
                    return type[1];
                if (type[1] === 'null')
                    return type[0];
            }
            return type;
        };

        var checkbox = function(name, schema, options) {
            if (stripNullType(schema.type) === 'boolean') {
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'checkbox';
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        // Add our default to the defaults array
        angular.forEach(schemaFormProvider.defaults.boolean, function(value, i){
            if (value.name == 'checkbox') {
                schemaFormProvider.defaults.boolean[i] = checkbox;
            }
        });

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'checkbox',
            'app/schema-form-component/angular-schema-form-checkbox/angular-schema-form-checkbox.html');

    }]);
;
angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        //Creates an default titleMap list from an enum, i.e. a list of strings.
        var enumToTitleMap = function(enm) {
            var titleMap = []; //canonical titleMap format is a list.
            enm.forEach(function(name) {
                titleMap.push({name: name, value: name});
            });
            return titleMap;
        };

        var stripNullType = function(type) {
            if (Array.isArray(type) && type.length == 2) {
                if (type[0] === 'null')
                    return type[1];
                if (type[1] === 'null')
                    return type[0];
            }
            return type;
        };

        var checkboxes = function(name, schema, options) {
            if (stripNullType(schema.type) === 'array' && schema.items && schema.items['enum']) {
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'checkboxes';
                if (!f.titleMap) {
                    f.titleMap = enumToTitleMap(schema.items['enum']);
                }
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        // Add our default to the defaults array
        angular.forEach(schemaFormProvider.defaults.array, function(value, i){
            if (value.name == 'checkboxes') {
                schemaFormProvider.defaults.array[i] = checkboxes;
            }
        });

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'checkboxes',
            'app/schema-form-component/angular-schema-form-checkboxes/angular-schema-form-checkboxes.html');

    }]);
;
angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        // First, we want this to be the default for a combination of schema parameters
        var spinner = function (name, schema, options) {
            if ((schema.type === 'integer' || schema.type === 'number') && schema.format == 'spinner') {
                // Initiate a form provider
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key = options.path;
                f.type = 'spinner';
                // Add it to the lookup dict (for internal use)
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };
        // Add our default to the defaults array
        schemaFormProvider.defaults.integer.unshift(spinner);
        schemaFormProvider.defaults.number.unshift(spinner);

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'spinner',
            'app/schema-form-component/angular-schema-form-spinner/angular-schema-form-spinner.html');
    }]);
;
angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        // First, we want this to be the default for a combination of schema parameters
        var timepicker = function (name, schema, options) {
            if (schema.type === 'string' && schema.format == 'time') {
                // Initiate a form provider
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key = options.path;
                f.type = 'timepicker';
                // Add it to the lookup dict (for internal use)
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;

            }
        };
        // Add our default to the defaults array
        schemaFormProvider.defaults.string.unshift(timepicker);

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'timepicker',
            'app/schema-form-component/angular-schema-form-timepicker/angular-schema-form-timepicker.html');
    }]);
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService', '$cookies'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService, $cookies) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            updateAccount: updateAccount
        };

        var checkState = location.hash.split("/");
        $sessionStorage.previousStateName = checkState[checkState.length -1];
        if ($sessionStorage.previousStateName !== "general-settings" && $sessionStorage.previousStateName !== "settings")
            delete $sessionStorage.previousStateName;
        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen(account) {
                var isAuthenticated = Principal.isAuthenticated();
                // an authenticated user with JOT_2FA cookie will be redirect to OTP page
                if (isAuthenticated && mustBeRedirectToOTP()) {
                    if ($rootScope.toState.name !== 'otp-code' && $rootScope.toState.name !== 'contact-us')
                        $state.go('otp-code');
                    return;
                }
                // an authenticated user without a selected context must be redirect to/ context page
                if (isAuthenticated && !Principal.hasContext() && $rootScope.toState.name !== 'context') {
                    $state.go('context');
                }
                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register') ||
                    $rootScope.toState.parent === 'app' && $rootScope.toState.name === 'home' && account.authorities[0] == "ROLE_DOMAIN_USER")) {
                    if (account.authorities[0] == "ROLE_DOMAIN_USER" && account.context.licence.id != 4)
                        $state.go('tab-objects-dashboard');
                    else if ($rootScope.toState.name !== 'home')
                        $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                }


                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if($rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority($rootScope.toState.data.authorities))
                {
                    notAuthorizedRedirect();
                } else if($rootScope.toState.data.evaluateAuthorities){
                    Principal.evaluate($rootScope.toState.data.evaluateAuthorities.replace(/\s+/g, ''))
                        .then(function (result) {
                            if(!eval(result)) {
                                notAuthorizedRedirect();
                            }
                    });
                }
            }
        }

        function notAuthorizedRedirect() {
            if (Principal.isAuthenticated()) {
                // user is signed in but not authorized for desired state
                $state.go('accessdenied');
            } else {
                // // user is not authenticated. stow the state they wanted before you
                // // send them to the login service, so you can return them when you're done
                // $sessionStorage.previousStateName = $rootScope.toState.name;
                // $sessionStorage.previousStateParams = $rootScope.toStateParams;
                //
                $state.go('login');
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout(true);
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout(skipRedirect) {
            AuthServerProvider.logout(skipRedirect);
            Principal.authenticate(null);

            // Reset state memory
            delete $sessionStorage.previousStateName;
            delete $sessionStorage.previousStateParams;
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function mustBeRedirectToOTP() {
            var OTPCookie = $cookies.get("JOT_2FA");
            return OTPCookie !== null && angular.isDefined(OTPCookie);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'JhiTrackerService', '$window'];

    function AuthServerProvider($http, $localStorage, JhiTrackerService, $window) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken() {
            var token = this.getToken();
            return !!token;
        }

        function login(credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                $localStorage.rememberMe = credentials.rememberMe;
                return response;
            });
        }

        function logout(skipRedirect) {
            localStorage.clear();
            JhiTrackerService.disconnect();
            // logout from the server
            $http.post('logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                // $http.get('api/account');
                if (!skipRedirect)
                    $window.location.href = "/jot/";
                return response;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('evaluateAuthorities', evaluateAuthorities);

    function evaluateAuthorities(Principal, $q) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            evaluate: evaluate
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.evaluateAuthorities.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.remove();
                },
                defineVisibility = function (reset) {
                    if (reset) {
                        setVisible();
                    }

                    evaluate(authorities).then(function (resultString) {
                        var result = eval(resultString);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }

        function evaluate(expression) {
            var deferred = $q.defer();
            var indexAnd = expression.indexOf("&&");
            var indexOr = expression.indexOf("||");
            if (indexAnd > 0 && (indexAnd < indexOr || indexOr < 0)) {
                var condition = expression.substr(0, indexAnd);
                var exp = expression.substr(indexAnd + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else if (indexOr > 0 && (indexAnd > indexOr || indexAnd < 0)) {
                var condition = expression.substr(0, indexOr);
                var exp = expression.substr(indexOr + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else {
                if (expression.indexOf("!") != -1) {
                    expression = expression.substr(1);
                    Principal.hasAuthority(expression)
                        .then(function (result) {
                            deferred.resolve("!" + result.toString());
                            return deferred.promise;
                        });
                } else {
                    Principal.hasAuthority(expression)
                        .then(function (result) {
                            deferred.resolve(result.toString());
                            return deferred.promise;
                        });
                }
            }

            return deferred.promise;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.remove();
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.remove();
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            hasContext: hasContext,
            evaluate: evaluate
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;

                if (_identity.context != null) {
                    var storedDomainName = localStorage.getItem("domainName");
                    var thisDomainName = _identity.context.domainName;

                    if (storedDomainName == null || storedDomainName != thisDomainName) {
                        localStorage.clear();
                        localStorage.setItem("domainName", thisDomainName);
                    }
                }

                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function hasContext() {
            if (!_authenticated || !_identity)
                return false;
            return _identity.context !== null && _identity.context !== undefined;
        }

        function checkAuthority(authority) {
            var deferred = $q.defer();
            deferred.resolve(_identity.authorities && _identity.authorities.indexOf(authority) !== -1);
            return deferred.promise;
        }

        function evaluate(expression) {
            var deferred = $q.defer();
            var indexAnd = expression.indexOf("&&");
            var indexOr = expression.indexOf("||");
            if (indexAnd > 0 && (indexAnd < indexOr || indexOr < 0)) {
                var condition = expression.substr(0, indexAnd);
                var exp = expression.substr(indexAnd + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else if (indexOr > 0 && (indexAnd > indexOr || indexAnd < 0)) {
                var condition = expression.substr(0, indexOr);
                var exp = expression.substr(indexOr + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else {
                if (expression.indexOf("!") != -1) {
                    expression = expression.substr(1);
                    checkAuthority(expression)
                        .then(function (result) {
                            deferred.resolve("!" + result.toString());
                            return deferred.promise;
                        });
                } else {
                    checkAuthority(expression)
                        .then(function (result) {
                            deferred.resolve(result.toString());
                            return deferred.promise;
                        });
                }
            }
            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('jotApp')
        .factory('Signup', Signup);

    Signup.$inject = ['$resource'];

    function Signup($resource) {
        var resourceUrl = 'api/invitations';

        return $resource(resourceUrl, {}, {
            'getInvitation': {method : 'GET'},
            'registerNewUser' : {
                method : 'POST',
                url : 'api/invitations/signup'
            }
        });
    }
})();
;
/**
 * Created by Lorenzo on 27/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Authority', Authority);

    Authority.$inject = ['$resource'];

    function Authority ($resource) {
        var service = $resource('api/authorities', {}, {});

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Context', Context);

    Context.$inject = ['$resource'];

    function Context($resource) {
        var context = $resource('api/context', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'delete': {method: 'DELETE'}
        });

        return context;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Team', Team);

    Team.$inject = ['$resource'];

    function Team($resource) {
        var service = $resource('api/team/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'usersDomain': {
                url:'api/team/usersByDomain/:id',
                method: 'GET',
                isArray: true
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {
        return $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'list': {
                url: 'api/users/list',
                method: 'GET',
                isArray: true
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},

            // call the deleteUserRequest in UserResource with method post
            'deleteRequest': {
                url: 'api/users/deleteUserRequest',
                method: 'post'},
            'queryByDomain': {
                url: 'api/domain/:id/users',
                method: 'GET',
                isArray: true
            },
            'impersonate': {
                url: 'api/usersImpersonate',
                method: 'POST'
            },
            'restore': {
                url: 'api/restoreUsersImpersonate',
                method: 'GET'
            },
            'create': {
                url: 'api/createUser',
                method: 'POST'
            },
            'createOTP': {
                url: 'api/createOtp',
                method: 'GET'
            },
            'checkCode': {
                url: 'api/checkOtp',
                method: 'GET'
            },
            'sendHelpMail': {
                url: 'api/sendHelpMail',
                method: 'POST'
            },
            'sendPrivacyMail': {
                url: 'api/sendPrivacyMail',
                method: 'POST'
            },
            'checkTerms' : {
                url: 'api/checkTermsConditions',
                method: 'GET'
            },
            'setTerms' : {
                url: 'api/setTermsConditions',
                method: 'POST'
            },
            'getTerms' : {
                url: 'api/getTermsConditions',
                method: 'GET'
            },
            'updateNotifications': {
                url: 'api/updateNotifications',
                method: 'PUT'
            },
            'getTOTP': {
                url: 'api/getTOTP',
                method: 'GET'
            },
            'set2FEmail': {
                url: 'api/set2FEmail',
                method: 'GET'
            },
            'getLoggedUserEmail': {
                url: 'api/getLoggedUserEmail',
                method: 'GET'
            },
            'checkReportCommandsEmail': {
                url: 'api/checkReportCommandsEmail',
                method: 'GET'
            }
        });
    }
})();
;(function(){'use strict';angular.module('jotApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/layouts/content.html','<div class="page-header navbar navbar-fixed-top"><div class="page-header-inner"><div class="page-logo"><a has-authority="ROLE_DOMAIN_ADMIN" href="javascript:;" ui-sref="home"><img src="./content/images/jot-logo-white.png" class="logo-default"><!--<span class="navtext-mobile">Carbon</span>--> </a><a evaluate-authorities="!ROLE_DOMAIN_ADMIN" href="javascript:;" ui-sref="performance"><img src="./content/images/jot-logo-white.png" class="logo-default"><!--<span class="navtext-mobile">Carbon</span>--></a></div><a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse"><span></span></a><div ui-view="navbar" class="top-menu" role="menu " ng-cloak></div><!--<div ui-butterbar="" class="butterbar"><span class="bar"></span></div>--></div></div><div class="clearfix"></div><div class="page-container"><div ui-view="aside" class="page-sidebar-wrapper"></div><div class="page-content-wrapper"><div class="page-content" style="min-height: 1100px;" setminheight ui-view="content"></div></div></div><div class="page-footer"><div class="page-footer-inner pull-right"><div id="footer" class="app-footer"><div class="wrapper b-t bg-light"><span>JoT v{{VERSION}}</span></div></div></div></div><!--<div ui-view="aside-right" id="aside-right" class="settings panel panel-default ng-scope"></div>-->');
$templateCache.put('app/account/activate/activate.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><div class="login-wrapper-inner"><div class="content"><div class="form"><div class="logo"><img src="./content/images/jot-logo.png" alt=""><!--<span class="login-page-title">JoT</span>--></div><div ng-hide="vm.keyMissing"><form autocomplete="off" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><h3 translate="activate.title">Set a new password</h3><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="activate.messages.error">Your password couldn\'t be set. Remember a activation link is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch && !vm.success" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group" ng-show="!vm.success"><label class="control-label visible-ie8 visible-ie9" for="password" translate="global.form.newpassword">New password</label> <input type="password" class="form-control form-control-solid placeholder-no-fix" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-pattern=\'/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$-/:-?{-~!"^_`\\[\\]])(?=\\S+$).{8,}$/\' ng-model="vm.resetAccount.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.pattern">Your password must contain at least one digit, one lower letter, one upper case letter and a special character</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group" ng-show="!vm.success"><label class="control-label visible-ie8 visible-ie9" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control form-control-solid placeholder-no-fix" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><div class="actions" ng-show="!vm.success"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-lg uppercase login-button" translate="activate.request.form.button">Set password</button></div></form></div></div></div><div class="contact-us"><a ui-sref="contact-us" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/account/general-settings/alerting-settings-overview.html','<form><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">This alert systems will be deleted</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><span ng-repeat="alert in vm.alertsToDelete">{{alert}}</span></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Confirm</span></button></div></form>');
$templateCache.put('app/account/general-settings/general-settings.html','<div class="app-content-body detail-page warning-detail-page general-settings-page" ng-init="vm.init()"><div class="settings-wrapper"><h1 class="page-title"><span translate="jotApp.generalSettings.home.title">General Settings</span></h1><div class="section-infos" translate="entity.infos.userAlertingInfos"></div><jhi-alert></jhi-alert><!-- email   --><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-envelope-regular"></i> Email <span ng-show="vm.email.id != null">: {{vm.email.actionIdentifier}}</span> <label class="switch aside-right" ng-if="vm.tabDomain.mailAlerting === true && vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.settingsNotification.warningEmail = !vm.settingsNotification.warningEmail; vm.saveToggle(\'mailAlerting\', \'warningEmail\')" ng-disabled="vm.tabDomain.enableAlerting === false" ng-checked="vm.settingsNotification.warningEmail"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label> <i class="fa fa-question-circle aside-right" ng-if="vm.tabDomain.mailAlerting === false || vm.tabDomain.enableAlerting === false" uib-tooltip="Channel has been disabled by admin" tooltip-placement="top"></i></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span ng-show="!vm.testEmail && vm.email.id == null"><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big gray" ng-click="vm.openMailModal(\'Email\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.configure">Configure</span></button></span><div class="btn btn-primary btn-inline-big no-hover" ng-show="vm.email.id != null"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.configured">Configured</span></div><button type="button" class="btn btn-round" ng-show="vm.email.id != null" ng-click="vm.deleteAlert(vm.email.id, \'email\')"><span class="fa fa-trash"></span></button></div></div><!-- telegram   --><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-telegram"></i> Telegram <span ng-show="vm.telegram.id != null">Identifier: <span>{{vm.telegram.actionIdentifier}}</span></span> <label class="switch aside-right" ng-if="vm.tabDomain.telegramAlerting === true && vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.settingsNotification.warningTelegram = !vm.settingsNotification.warningTelegram; vm.saveToggle(\'telegramAlerting\', \'warningTelegram\')" ng-disabled="vm.tabDomain.enableAlerting === false" ng-checked="vm.settingsNotification.warningTelegram"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label> <i class="fa fa-question-circle aside-right" ng-if="vm.tabDomain.telegramAlerting === false || vm.tabDomain.enableAlerting === false" uib-tooltip="Channel has been disabled by admin" tooltip-placement="top"></i></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span ng-show="vm.telegram.id == null"><button type="button" class="btn btn-primary btn-inline-big gray" ng-click="vm.openTelegramModal(\'Telegram\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.configure">Configure</span></button> </span><span ng-show="vm.telegram.id != null"><div class="btn btn-primary btn-inline-big no-hover"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.configured">Configured</span></div></span><button type="button" class="btn btn-round" ng-show="vm.telegram.id != null" ng-click="vm.deleteAlert(vm.telegram.id, \'telegram\')"><span class="fa fa-trash"></span></button></div></div><!-- webhook   --><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-webhook"></i> <span>Webhook </span><span ng-show="vm.webhook.actionIdentifier != null"><div class="too-long">{{vm.webhook.actionIdentifier}}</div></span><label class="switch aside-right" ng-if="vm.tabDomain.webhookAlerting === true && vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.settingsNotification.warningWebhook = !vm.settingsNotification.warningWebhook; vm.saveToggle(\'webhookAlerting\', \'warningWebhook\')" ng-disabled="vm.tabDomain.enableAlerting === false" ng-checked="vm.settingsNotification.warningWebhook"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label> <i class="fa fa-question-circle aside-right" ng-if="vm.tabDomain.webhookAlerting === false || vm.tabDomain.enableAlerting === false" uib-tooltip="Channel has been disabled by admin" tooltip-placement="top"></i></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span ng-show="!vm.webhook.actionIdentifier"><button type="button" class="btn btn-primary btn-inline-big gray" ng-click="vm.openWebhookModal(\'Webhook\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.configure">Test</span></button> </span><span ng-show="vm.webhook.actionIdentifier != null"><div class="btn btn-primary btn-inline-big no-hover"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.configured">Configured</span></div></span><button type="button" class="btn btn-round" ng-show="vm.webhook.actionIdentifier != null" ng-click="vm.deleteAlert(vm.webhook.id, \'webhook\')"><span class="fa fa-trash"></span></button></div></div></div><!--    domain alerting settings--><div class="settings-wrapper" has-authority="ROLE_DOMAIN_ADMIN"><h1 class="page-title"><span translate="jotApp.generalSettings.home.domainTitle">General Settings</span> <label class="switch" style="vertical-align: middle;"><input type="checkbox" ng-click="vm.tabDomain.enableAlerting = !vm.tabDomain.enableAlerting; vm.openToggleModal(vm.tabDomain.enableAlerting, \'enableAlerting\')" ng-checked="vm.tabDomain.enableAlerting"> <span class="alert-toggle round"></span></label></h1><div class="section-infos" translate="entity.infos.domainAlertingInfos"></div><!--    email domain settings--><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-envelope-regular"></i> Email <label class="switch aside-right" ng-if="vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.tabDomain.mailAlerting = !vm.tabDomain.mailAlerting; vm.openToggleModal(vm.tabDomain.mailAlerting, \'mailAlerting\')" ng-checked="vm.tabDomain.mailAlerting"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="vm.tabDomain.enableAlerting === true"><div class="form-group inline-form-group"><span><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big gray" ng-click="vm.openDomainSetting(\'Email\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.advancedSettings">advanced settings</span></button> </span><span><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big" ng-click="vm.openThrottleSetting(\'email\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.setThrottle">Set Throttle</span></button></span></div></div></div><!--    telegram domain settings--><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-telegram"></i> Telegram <label class="switch aside-right" ng-if="vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.tabDomain.telegramAlerting = !vm.tabDomain.telegramAlerting; vm.openToggleModal(vm.tabDomain.telegramAlerting, \'telegramAlerting\')" ng-checked="vm.tabDomain.telegramAlerting"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="vm.tabDomain.enableAlerting === true"><div class="form-group inline-form-group"><span><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big" ng-click="vm.openThrottleSetting(\'telegram\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.setThrottle">Set Throttle</span></button></span></div></div></div><!--    webhook domain settings--><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group switch-container"><i class="iconAlert icon-webhook"></i> Webhook <label class="switch aside-right" ng-if="vm.tabDomain.enableAlerting === true"><input type="checkbox" ng-click="vm.tabDomain.webhookAlerting = !vm.tabDomain.webhookAlerting; vm.openToggleModal(vm.tabDomain.webhookAlerting, \'webhookAlerting\')" ng-checked="vm.tabDomain.webhookAlerting"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="vm.tabDomain.enableAlerting === true"><div class="form-group inline-form-group"><span><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big gray" ng-click="vm.openDomainSettingWebhook(\'webhook\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.advancedSettings">advanced settings</span></button> </span><span><button type="button" ng-disabled=" vm.isSaving" class="btn btn-primary btn-inline-big" ng-click="vm.openThrottleSetting(\'webhook\')"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.setThrottle">Set Throttle</span></button></span></div></div></div></div><div class="settings-wrapper" has-authority="ROLE_ADMIN" ng-if="licence.id === 4"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="maintenanceForm" role="form" novalidate ng-submit="vm.saveMaintenanceGeneral()" show-validation><div class="form-body"><div class="row"><div class="col-xs-12 col-md-12 col-lg-12"><div class="form-group"><span style="margin-right: 10px; font-size: large">Maintenance</span> <label class="switch" id="maintenance-toggle"><input type="checkbox" ng-click="vm.toggleMaintenance()" ng-checked="vm.showMaintenanceForm"> <span class="alert-toggle round"></span></label></div></div></div><div class="row" ng-if="vm.showMaintenanceForm"><div class="col-xs-12 col-md-3 col-lg-3"><div class="form-group"><label translate="jotApp.generalSettings.maintenanceSetting.maintenanceStartDate" for="field_maintenanceStartDate">Maintenance Start Date</label><div class="input-group"><input id="field_maintenanceStartDate" type="text" class="form-control" required datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.maintenanceSetting.releaseDate" datepicker-options="vm.datePickerOptions" name="maintenanceStartDate" ng-click="vm.openCalendar($event)" is-open="vm.maintenanceDatetime.isOpen" popup-placement="top-left"> <span class="input-group-btn" ng-click="vm.openCalendar($event)" is-open="vm.maintenanceDatetime.isOpen" role="button" tabindex="0"><button type="button" class="btn btn-default"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row" ng-if="vm.showMaintenanceForm && (vm.mailType === \'none\' || vm.mailType === \'maintenance\')"><div class="row"><div class="col-xs-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" translate="jotApp.generalSettings.maintenanceSetting.version" for="field_maintenanceVersion">Version</label> <textarea type="text" class="form-control" name="maintenanceVersion" required id="field_maintenanceVersion" placeholder="1.0.0" ng-change="vm.evaluateTypeMail(vm.maintenanceSetting.version, \'maintenance\')" ng-model="vm.maintenanceSetting.version" ng-maxlength="1000" rows="5"> </textarea><div ng-show="maintenanceForm.deviceDescription.$invalid"><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 1000 characters.</p></div></div></div><div class="col-xs-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" translate="jotApp.generalSettings.maintenanceSetting.features" for="field_maintenanceFeatures">Features</label> <textarea type="text" class="form-control" name="maintenanceFeatures" required id="field_maintenanceFeatures" placeholder="Title - Description;" ng-change="vm.evaluateTypeMail(vm.maintenanceSetting.features, \'maintenance\')" ng-model="vm.maintenanceSetting.features" ng-maxlength="1000" rows="5"> </textarea><div ng-show="maintenanceForm.deviceDescription.$invalid"><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 1000 characters.</p></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" translate="jotApp.generalSettings.maintenanceSetting.enhancements" for="field_maintenanceEnhancements">Enhancements</label> <textarea type="text" class="form-control" name="maintenanceEnhancements" required id="field_maintenanceEnhancements" placeholder="Title - Description;" ng-change="vm.evaluateTypeMail(vm.maintenanceSetting.enhancements, \'maintenance\')" ng-model="vm.maintenanceSetting.enhancements" ng-maxlength="1000" rows="5"> </textarea><div ng-show="maintenanceForm.deviceDescription.$invalid"><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 1000 characters.</p></div></div></div><div class="col-xs-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" translate="jotApp.generalSettings.maintenanceSetting.bugFixing" for="field_maintenanceBugFixing">Bugs Fixing</label> <textarea type="text" class="form-control" name="maintenanceBugFixing" required id="field_maintenanceBugFixing" placeholder="Title - Description;" ng-change="vm.evaluateTypeMail(vm.maintenanceSetting.bugsFixing, \'maintenance\')" ng-model="vm.maintenanceSetting.bugsFixing" ng-maxlength="1000" rows="5"> </textarea><div ng-show="maintenanceForm.deviceDescription.$invalid"><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 1000 characters.</p></div></div></div></div></div><div class="row" ng-if="vm.showMaintenanceForm && (vm.mailType === \'none\' || vm.mailType === \'notice\')"><div class="row"><div class="col-xs-12 col-md-12 col-lg-12"><div class="form-group"><label class="control-label" translate="jotApp.generalSettings.maintenanceSetting.maintenanceMessage" for="field_maintenanceDescription">Message</label> <textarea type="text" class="form-control" name="maintenanceDescription" required id="field_maintenanceDescription" placeholder="New notice for active users" ng-change="vm.evaluateTypeMail(vm.maintenanceSetting.description, \'notice\')" ng-model="vm.maintenanceSetting.description" ng-maxlength="1000" rows="5"> </textarea><div ng-show="maintenanceForm.deviceDescription.$invalid"><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="maintenanceForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 1000 characters.</p></div></div></div></div></div></div><div class="form-actions" ng-if="vm.showMaintenanceForm"><button type="submit" ng-disabled="maintenanceForm.$invalid" class="btn btn-primary"><span class="fa fa-cog"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div class="app-content-body container"><div class="wrapped-md"><div class="row"><div class="col-md-4 col-md-offset-4"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form autocomplete="off" name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><!-- div campo password + pulsante occhio --><div style="display: flex;"><input type="{{vm.showPassword ? \'text\' : \'password\'}}" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-model-options="{ allowInvalid: true }" ng-pattern=\'/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$-/:-?{-~!"^_`\\[\\]])(?=\\S+$).{8,}$/\' ng-minlength="8" ng-maxlength="100" required autocomplete="false"> <button type="button" ng-click="vm.showPassword = !vm.showPassword"><i class="fa" ng-class="{\'fa-eye\': !vm.showPassword, \'fa-eye-slash\': vm.showPassword}"></i></button></div><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.pattern">Your password must contain at least one digit, one lower letter, one upper case letter and a special character</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><!-- div campo password + pulsante occhio --><div style="display: flex;"><input ng-hover="vm.passwordmatch()" ng-change="vm.passwordmatch()" ng-click="vm.passwordmatch()" type="{{vm.showConfirmPassword ? \'text\' : \'password\'}}" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" required> <button type="button" ng-click="vm.showConfirmPassword = !vm.showConfirmPassword"><i class="fa" ng-class="{\'fa-eye\': !vm.showConfirmPassword, \'fa-eye-slash\': vm.showConfirmPassword}"></i></button></div><!--\n                        <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">\n                                Your confirmation password is required.\n                            </p>\n\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">\n                                Your confirmation password is required to be at least 8 characters.\n                            </p>\n\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">\n                                Your confirmation password cannot be longer than 50 characters.\n                            </p>\n                        </div>--><p class="help-block" style="color: #a94442;">{{vm.passwordnotmatch}}</p></div><div ng-mouseover="vm.checkUserLng()"><button type="submit" class="btn btn-primary" translate="password.form.button" ng-disabled="vm.checkMinLngUser">Save</button></div></form></div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div class="app-content-body container"><div class="wrapped-md"><h2 translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="sessions.table.ipaddress">IP Address</th><th translate="sessions.table.useragent">User agent</th><th translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/account/settings/delete-2F.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h3 class="modal-title" translate="entity.delete.title">Confirm delete operation</h3></div><div class="modal-body"><p><span translate="settings.twoFactor.confirm">The two-factor key will be deleted upon confirmation. Restoration will require reconfiguration.</span></p></div><div class="modal-footer"><button class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div>');
$templateCache.put('app/account/settings/settings-2F-detail.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h3 class="modal-title">2 Factor authentication</h3></div><div class="modal-body"><!--        <p translate="settings.twoFactor.qr" translate-values="{qrCode2Factor: \'{{vm.qrCode2Factor}}\'}">Qr: ?</p>--><div><span translate="settings.twoFactor.scanQR">Scan this QR code to authenticate yourself:</span></div><qr text="vm.qrCode2Factor" size="200" class="text-center"></qr><div><span translate="settings.twoFactor.privateKey">Use this private key on your Authenticator:</span></div><br><div class="text-center">{{vm.privateKey}} <button class="btn btn-default" type="button" translate="entity.action.copy" ng-click="vm.copyKey()" id="copy-key-btn">Copy</button></div></div><div class="modal-footer"><div class="confirmation-description"><h6 class="text-left" translate="settings.twoFactor.confirmConfiguration">The confirmation must be done only after scanning the QR code or copying the link; otherwise the TOTP must be deleted and the configuration process will need to be repeated.</h6><button class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></div>');
$templateCache.put('app/account/settings/settings-delete.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h3 class="modal-title">Account deletion</h3></div><div class="modal-body"><p><b>Are you sure you want to DELETE your account ?</b></p><p>By pressing delete, your account will be suspended.<br>Our Helpdesk will send you an email within 24 hours to confirm that the operation has succeeded.<br>If you change your mind, please reply to that email and restore your account.</p></div><div class="modal-footer"><button class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">confirm</span></button></div>');
$templateCache.put('app/account/settings/settings.html','<div class="container-margin-fix settings-page" ng-init="vm.init()"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="settings.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.error" translate="settings.messages.error.fail"><strong>An error has occurred!</strong> Settings could not be saved.</div></div></div><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label> <input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label> <input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label> <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" chosen disable-search="true" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label class="mt-checkbox mt-checkbox-outline" for="field_check2"><input type="checkbox" class="form-control" name="check2" id="field_check2" ng-model="vm.updateCheck.check2"> <span></span><p class="help-block" translate="settings.consent.marketing">I confirm my consent to the processing of my personal data for marketing purposes, consisting in commercial offers sent via email.</p></label></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 spacer"><div class="form-group"><label class="mt-checkbox mt-checkbox-outline" for="field_check3"><input type="checkbox" class="form-control" name="check3" id="field_check3" ng-model="vm.updateCheck.check3"> <span></span><p class="help-block" translate="settings.consent.commercial">I confirm my consent to automated processing of my personal data, by means of profiling, in order to receive commercial offers customized on the basic of my browsing and purchasing behavior</p></label></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h4 class="settings-sub-title" translate="settings.twoFactor.title">Two-Factor Authentication</h4></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group switch-container"><label class="label-text-large">TOTP</label> <label class="switch aside-right"><input type="checkbox" ng-click="vm.onChange2F()" ng-checked="!vm.settingsNotification.twoFactorEmail"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-8"><div class="toggle-explanation" translate="settings.twoFactor.totpInfo"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h4 class="settings-sub-title" translate="settings.systemNotifications">System notification</h4></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group switch-container"><label class="label-text-large">Changelog</label> <label class="switch aside-right"><input type="checkbox" ng-click="vm.settingsNotification.emailChangelog = !vm.settingsNotification.emailChangelog" ng-checked="vm.settingsNotification.emailChangelog"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-8"><div class="toggle-explanation" translate="settings.notifications.changelogInfo"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group switch-container"><label class="label-text-large">Newsletter</label> <label class="switch aside-right"><input type="checkbox" ng-click="vm.settingsNotification.emailNewsletter = !vm.settingsNotification.emailNewsletter" ng-checked="vm.settingsNotification.emailNewsletter"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-8"><div class="toggle-explanation" translate="settings.notifications.newsletter"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 spacer"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button> <button type="button" class="btn btn-primary" ui-sref="integration" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-list"></span>&nbsp; <span translate="settings.integration.title">Integration</span></button><!-- new delete account button , which send mail to helpDesk --> <button type="button" class="btn btn-primary" translate="settings.form.delete" ng-click="vm.delete()">Delete My Account</button></div></div></form></div>');
$templateCache.put('app/account/signup/signup.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="login-wrapper-inner-register invitation" ng-init="vm.init()"><div class="content"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="logo"><img src="./content/images/jot-logo.png" alt=""><!--<span class="login-page-title">JoT</span>--></div><div ng-if="!vm.success"><div class="portlet-body form" ng-if="vm.user == null"><h3 class="form-title" translate="login.registration.expired">Expired</h3></div><div class="portlet-body form" ng-if="vm.user != null"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="form-body"><h3 class="form-title">Register new Account</h3><div ng-if="!vm.nextOptions"><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label> <input type="text" id="login" class="form-control" name="login" ng-pattern="/^(([a-z0-9]+)(\\.)?([a-z0-9]+))*$/" ng-model="vm.user.login" required ng-maxlength="50" ng-minlength="7"><div ng-show="editForm.login.$dirty && editForm.login.$invalid"><p class="help-block" style="color: red" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" style="color: red" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" style="color: red" ng-show="editForm.login.$error.minlength" translate="entity.validation.minlength" translate-value-min="7">This field is required to be at least 7 characters.</p><p class="help-block" style="color: red" ng-show="editForm.login.$error.pattern">Your username can only contain lower-case letters and digits and dots.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" required ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.login.$dirty && editForm.firstName.$invalid"><p class="help-block" style="color: red" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" style="color: red" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" required ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.login.$dirty && editForm.lastName.$invalid"><p class="help-block" style="color: red" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" style="color: red" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><label class="control-label visible-ie8 visible-ie9" for="password" translate="global.form.newpassword">New password</label> <input type="password" class="form-control form-control-solid placeholder-no-fix" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.user.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="editForm.password.$dirty && editForm.password.$invalid"><p class="help-block" style="color: red" ng-show="editForm.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" style="color: red" ng-show="editForm.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" style="color: red" ng-show="editForm.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.user.password"></password-strength-bar></div></div><div class="col-md-12 col-xs-12"><div class="form-group"><label class="control-label visible-ie8 visible-ie9" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input ng-hover="vm.passwordmatch()" ng-change="vm.passwordmatch()" ng-click="vm.passwordmatch()" type="password" class="form-control form-control-solid placeholder-no-fix" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.user.confirmPassword" ng-minlength="8" ng-maxlength="50" required><p class="help-block" style="color: red">{{vm.passwordnotmatch}}</p><!-- <script>\n                                                                //var pwd = document.getElementById("password");\n                                                                var cpwd = document.getElementById("confirmPassword");\n                                                                var error = document.getElementById("errore");\n                                                                confirmPasswordField.addEventListener("input", validate);\n                                                                function validate() {\n                                                                    var pass = document.getElementById("password");\n                                                                    var cpass = confirmPasswordField.value;\n                                                                    if( pass === cpass)\n                                                                    {\n                                                                        error.textContent = "";\n                                                                    }\n                                                                    else\n                                                                    {\n                                                                        error.textContent = "Your password must match.";\n                                                                    }\n                                                                }\n                                                            </script>--><!--                                                            --><!--                                                            <p class="help-block" style="color: red"--><!--                                                               ng-show="editForm.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">--><!--                                                                Your password confirmation is required.--><!--                                                            </p>--><!--                                                            <p class="help-block" style="color: red"--><!--                                                               ng-show="editForm.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">--><!--                                                                Your password confirmation is required to be at least 4 characters.--><!--                                                            </p>--><!--                                                            <p class="help-block" style="color: red"--><!--                                                               ng-show="editForm.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">--><!--                                                                Your password confirmation cannot be longer than 50 characters.--><!--                                                            </p>--></div></div></div></div><div ng-if="vm.nextOptions"><div class="row"><div class="col-md-12 col-xs-12" uib-tooltip="{{vm.checkDisabled}}" tooltip-placement="top"><div class="form-group"><input class="col-md-1 col-xs-12" type="checkbox" name="check1" id="field_check1" value="true" required ng-model="vm.user.check1" ng-disabled="vm.disabled"> <label class="col-md-11 col-xs-12" for="field_check1" style="font-size:12px">I confirm to have read the <span class="fake-link-text" ng-click="vm.privacyAgree()">Privacy Policy* </span>and to accept the <span class="fake-link-text" ng-click="vm.termsAgree()">Terms & conditions*</span></label></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><input class="col-md-1 col-xs-12" type="checkbox" name="check2" id="field_check2" value="true" ng-model="vm.user.check2"> <label class="col-md-11 col-xs-12" for="field_check2" style="font-size:12px">I confirm my consent to the processing of my personal data for marketing purposes, consisting in commercial offers sent via email</label></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><input class="col-md-1 col-xs-12" type="checkbox" name="check3" id="field_check3" value="true" ng-model="vm.user.check3"> <label class="col-md-11 col-xs-12" for="field_check3" style="font-size:12px">I confirm my consent to automated processing of my personal data, by means of profiling, in order to receive commercial offers customized on the basic of my browsing and purchasing behavior</label></div></div></div></div><br><div ng-if="!vm.nextOptions" ng-mouseover="vm.checkUserLng()"><button type="button" class="btn btn-default" ng-click="vm.changeOptions()" ng-disabled="vm.checkMinLngUser"><span class="fa fa-arrow-circle-o-right"></span>&nbsp;<span>next</span></button></div><div ng-if="vm.nextOptions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Save</span></button> <button type="button" class="btn btn-default" ui-sref="login"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-default" ng-click="vm.changeOptions()"><span class="fa fa-arrow-circle-o-left"></span>&nbsp;<span>Back</span></button></div></div></form></div></div><div ng-if="vm.success"><div class="portlet-body form"><h3 class="form-title">Registration was successful. Please, <a class="alert-link" href="" ng-click="vm.goToLogin()">sign in</a>.</h3></div></div></div></div></div></div><div class="contact-us"><a ui-sref="contact-us" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/admin/audit-log/audit-log-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="auditLog.detail.title">Audit Log Detail</span> <span>{{vm.auditLog.action}}</span> <span>{{vm.auditLog.entityName}}</span> <span>{{vm.auditLog.entityId}}</span></h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="auditLog.detail.action">Activity</span></dt><dd>{{vm.auditLog.action}}</dd><dt><span translate="auditLog.detail.entityName">Entity Name</span></dt><!--<dd><a ng-if="!vm.checkIfAuditDeletedOrIsUser()" ui-sref="{{vm.dashedName}}-detail({id: {{vm.auditLog.entityId}}})">{{vm.auditLog.entityName}}</a>--><!--<span ng-if="vm.checkIfAuditDeletedOrIsUser()">{{vm.auditLog.entityName}}</span>--><!--</dd>--><dd><span>{{vm.auditLog.entityName}}</span></dd><dt><span translate="auditLog.detail.entityId">Entity ID</span></dt><dd>{{vm.auditLog.entityId}}</dd><dt><span translate="auditLog.detail.createdBy">Created By</span></dt><dd>{{vm.auditLog.createdBy}}</dd><dt><span translate="auditLog.detail.createdDate">Created Date</span></dt><dd>{{vm.auditLog.createdDate | date: \'medium\'}}</dd><dt ng-if="vm.auditLog.action != \'INSERTED\'"><span translate="auditLog.detail.changes">Changes</span></dt><dd ng-if="vm.auditLog.action != \'DELETED\'" ng-repeat="difference in vm.differences">{{difference}}</dd><dd ng-if="vm.auditLog.action == \'DELETED\'">{{vm.auditLog.detail}}</dd></dl></div></div></div></div></div>');
$templateCache.put('app/admin/audit-log/audit-log.html','<div class="app-content-body"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label translate="auditLog.filter.title">Filter by date</label><div class="input-group" id="range"><span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span> <input type="text" id="start" class="form-control" name="start" ng-click="vm.picker.start=true" datetime-picker="dd/MM/yyyy" ng-model="vm.fromDate" is-open="vm.picker.start" enable-time="false" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span> <input type="text" id="end" class="form-control" name="end" ng-click="vm.picker.end=true" datetime-picker="dd/MM/yyyy" ng-model="vm.toDate" is-open="vm.picker.end" enable-time="false" ng-change="vm.onChangeDate()" required></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="activity">Filter per activity</label> <select class="form-control" id="activity" name="activity" ng-model="vm.filter.activity" ng-change="vm.applyFilter()" chosen disable-search="true"><option label="ALL" value="">ALL</option><option label="INSERTED" value="inserted">INSERTED</option><option label="UPDATED" value="updated">UPDATED</option><option label="DELETED" value="deleted">DELETED</option></select></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed table-hover no-footer"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="action"><span translate="auditLog.table.header.action">Activity</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="entityId"><span translate="auditLog.table.header.entityId">Entity Id</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="entityName"><span translate="auditLog.table.header.entityName">Entity Name</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="createdBy"><span translate="auditLog.table.header.createdBy">Created By</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="createdDate"><span translate="auditLog.table.header.createdDate">Created Date</span><span class="glyphicon glyphicon-sort"></span></th><th><span translate="auditLog.table.header.view"></span></th></tr></thead><tbody><tr ng-repeat="auditLog in vm.auditLog track by auditLog.id"><td>{{auditLog.action}}</td><td ng-bind-html="auditLog.entityId | highlight:vm.searchText"></td><td ng-bind-html="auditLog.entityName | highlight:vm.searchText"></td><td ng-bind-html="auditLog.createdBy | highlight:vm.searchText"></td><td>{{auditLog.createdDate | date: \'medium\'}}</td><td class="text-center"><button class="btn btn-primary" ui-sref="audit-log-detail({id:auditLog.id})"><i class="fa fa-eye"></i> <span translate="entity.action.view"></span></button></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.page" total="vm.totalItems" limit="vm.size"></jhi-item-count></div></div><div class="col-xs-12"><div class="dataTables_paginate"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div class="app-content-body"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label translate="audits.filter.title">Filter by date</label><div class="input-group" id="range"><span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span> <input type="text" id="start" class="form-control" name="start" ng-click="vm.picker.start=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.fromDate" is-open="vm.picker.start" ng-change="vm.loadAll()" required> <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span> <input type="text" id="end" class="form-control" name="end" ng-click="vm.picker.end=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.toDate" is-open="vm.picker.end" ng-change="vm.loadAll()" required></div></div></div><div class="col-md-6"><label translate="audits.filter.titleDomain" for="field_domain">Filter by Domain</label><ui-select id="field_domain" name="activity" ng-model="vm.domain" ng-change="vm.loadAll()" theme="bootstrap"><ui-select-match placeholder="Select or search per domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" refresh-delay="1"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><div class="btn-group"><div class="dropdown-toggle object-icon-action no-outline no-bg btn btn-primary" data-toggle="dropdown" ng-click="vm.loadAllToExport()"><i class="glyphicon glyphicon-save-file">&nbsp;</i> <span translate="audits.viewAudits.export">Export Table</span></div><ul class="dropdown-menu" role="menu"><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'csv\')"><i class="fa fa-file-zip-o"></i> CSV</a></li></ul></div></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed no-footer" id="tableToExport"><thead><tr multi-sort="vm.predicates" callback="vm.loadAll()"><th multi-sort-by="auditEventDate"><span translate="audits.table.header.date">Date</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="principal"><span translate="audits.table.header.principal">User</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="auditEventType"><span translate="audits.table.header.status">State</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="domain"><span translate="audits.table.header.domain">Domain</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tr ng-repeat="audit in vm.audits"><td><span>{{audit.timestamp | date:\'medium\'}}</span></td><td ng-bind-html="audit.principal | highlight:vm.charToSearch"></td><td ng-bind-html="audit.type | highlight:vm.charToSearch"></td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.domain.domainName">{{audit.data.domain.domainName}}</span></td></tr></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.page" total="vm.totalItems" limit="vm.size"></jhi-item-count></div></div><div class="col-xs-12"><div class="dataTables_paginate"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div class="app-content-body admin-configuration-page"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" translate="configuration.filter">Filter (by prefix)</label> <input type="text" ng-model="filter" class="form-control"></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-list-alt"></i> <span translate="configuration.table.portletTitle">Spring Configuration</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed no-footer" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span ng-bind-html="entry.prefix | highlight:filter"></span></td><td><div class="row internal-row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><button class="btn btn-primary btn-sm pull-right" popover-placement="left" uib-popover="{{value}}" popover-trigger="outsideClick"><i class="fa fa-eye"></i> <span translate="entity.action.view" class="ng-scope">View</span></button></div></div></td></tr></table></div></div></div></div></div></div><div class="row" ng-repeat="(key, value) in vm.allConfiguration" ng-hide="filtered.length == 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-list-alt"></i> {{key}}</div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed no-footer"><thead><tr><th>Property</th><th class="value-column">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break" ng-bind-html="item.key | highlight:filter"></td><td class="break"><!--<span class="pull-right label label-default break">{{item.val}}</span>--> <button class="btn btn-primary btn-sm pull-right" popover-placement="left" uib-popover="{{item.val}}" popover-trigger="outsideClick"><i class="fa fa-eye"></i> <span translate="entity.action.view" class="ng-scope">View</span></button></td></tr></tbody></table></div></div></div></div></div></div><!--<div ng-repeat="(key, value) in vm.allConfiguration">--><!--<label ng-hide="filtered.length == 0"><span>{{key}}</span></label>--><!--<table class="table table-condensed table-striped table-bordered table-responsive"--><!--style="table-layout:fixed" ng-hide="filtered.length == 0">--><!--<thead>--><!--<tr>--><!--<th class="col-sm-4">Property</th>--><!--<th class="col-sm-8">Value</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="item in filtered = (value | filter:filter)">--><!--<td class="break">{{item.key}}</td>--><!--<td class="break">--><!--<span class="pull-right label label-default break">{{item.val}}</span>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div class="app-content-body"><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="health.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table id="healthCheck" class="table table-striped table-bordered table-fixed no-footer action-column"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center status-table-header" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><!--<button class="hand btn btn-primary btn-sm" ng-click="vm.showHealth(health)" ng-show="health.details || health.error">--><!--<i class="fa fa-eye"></i>--><!--<span translate="entity.action.view">View</span>--><!--</button>--> <button class="hand btn btn-primary btn-sm" ui-sref="jhi-health-detail({currentHealth:health})" ng-show="health.details || health.error"><i class="fa fa-eye"></i> <span translate="entity.action.view">View</span></button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="app-content-body detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h1></div></div><div class="row content-row" ng-show="vm.currentHealth.details"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-heart"></i> <span translate="health.details.properties">Properties</span></div><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left" ng-bind-html="v"></td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div></div></div><!--<div class="modal-header">--><!--<button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span>--><!--</button>--><!--<h4 class="modal-title" id="showHealthLabel">--><!--{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}}--><!--{{vm.subSystemName(vm.currentHealth.name)}}--><!--</h4>--><!--</div>--><!--<div class="modal-body pad">--><!--<div ng-show="vm.currentHealth.details">--><!--<h4 translate="health.details.properties">Properties</h4>--><!--<table class="table table-striped">--><!--<thead>--><!--<tr>--><!--<th class="col-md-6 text-left" translate="health.details.name">Name</th>--><!--<th class="col-md-6 text-left" translate="health.details.value">Value</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="(k,v) in vm.currentHealth.details">--><!--<td class="col-md-6 text-left">{{k}}</td>--><!--<td class="col-md-6 text-left" ng-bind-html="v"></td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div ng-show="vm.currentHealth.error">--><!--<h4 translate="health.details.error">Error</h4>--><!--<pre>{{vm.currentHealth.error}}</pre>--><!--</div>--><!--</div>--><!--<div class="modal-footer">--><!--<button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button>--><!--</div>-->');
$templateCache.put('app/admin/invitation/invitation-list.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span>Invitation List</span></h1><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.loadAll()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="email"><span translate="invitation.email">Email</span></th><th multi-sort-by="consumed"><span translate="invitation.status">Status</span></th><th multi-sort-by="authority.name"><span translate="invitation.role">Role</span></th><th multi-sort-by="invitationDate"><span translate="invitation.invitationDate">Invitation Date</span></th><th translate="entity.action.actionLabel">Action</th></tr></thead><tbody><tr ng-repeat="invite in vm.invitations"><td>{{invite.email}}</td><td><span class="label label-danger" ng-show="!invite.consumed" translate="invitation.deactivated">Desactivated</span> <span class="label label-success" ng-show="invite.consumed" translate="invitation.activated">Activated</span></td><td>{{invite.authority.name}}</td><td>{{invite.invitationDate | date:\'dd/MM/yy HH:mm\'}}</td><td><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" ng-show="!invite.consumed"><span translate="entity.action.actionLabel">Actions</span> <i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a><i class="fa fa-envelope"></i><span translate="invitation.sendMail" ng-click="vm.sendMail(invite)">Send email</span></a></li><li><a><i class="fa fa-times"></i><span translate="entity.action.delete" ng-click="vm.deleteInvitation(invite.id)"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/invitation/invite-user.html','<div class="app-content-body"><h1 class="page-title" translate="invitation.home.inviteLabel">Invite a new User</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row" ng-repeat="quantity in [].constructor(vm.quantity) track by $index"><div class="col-md-3 col-xs-12"><div class="form-group"><label class="control-label" translate="invitation.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.mailList[$index]" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="col-md-3 col-xs-12"><div class="form-group"><label translate="invitation.domains" for="field_domains">Domains</label> <select class="form-control" chosen multiple="multiple" name="domains" id="field_domains" ng-model="vm.domain[$index]" ng-options="domain.domainName for domain in vm.domains track by domain.id" data-placeholder-text-multiple="\' \'"><option value=""></option></select></div></div><div class="col-md-3 col-xs-12"><div class="form-group"><label translate="invitation.role">Role</label> <select class="form-control" name="authority" ng-model="vm.authority[$index]" ng-options="authority for authority in vm.authorities track by authority"></select></div></div><div class="col-md-1 col-xs-2" ng-if="vm.quantity > 1 || $index != 0"><button id="field_deleteMetric" type="button" class="btn btn-primary form-rules-metric-delete-button" ng-click="vm.deleteEmail($index)"><span class="glyphicon glyphicon-remove-circle"></span></button></div><div class="col-lg-1 col-xs-2"><button type="button" class="btn btn-default form-rules-metric-delete-button" ng-click="vm.addQuantity($index)"><span>+</span></button></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="app-content-body"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" translate="logs.filter">Filter</label> <input type="text" ng-model="filter" class="form-control"> <span translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</span></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed no-footer"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small ng-bind-html="logger.name | characters:140 | highlight:filter"></small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs"><span ng-bind-html="(logger.level==\'TRACE\') ? (\'TRACE\' | highlight:filter) : \'TRACE\'"></span></button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs"><span ng-bind-html="(logger.level==\'DEBUG\') ? (\'DEBUG\' | highlight:filter) : \'DEBUG\'"></span></button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs"><span ng-bind-html="(logger.level==\'INFO\') ? (\'INFO\' | highlight:filter) : \'INFO\'"></span></button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs"><span ng-bind-html="(logger.level==\'WARN\') ? (\'WARN\' | highlight:filter) : \'WARN\'"></span></button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs"><span ng-bind-html="(logger.level==\'ERROR\') ? (\'ERROR\' | highlight:filter) : \'ERROR\'"></span></button></td></tr></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/licences/change-object.html','<form name="changeObjectForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Change Object - Licence: {{vm.licence.licenceCode}}</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-xs-12"><input type="text" class="form-control" ng-model="vm.objectUniqueCode" placeholder="Insert Unique Code.." required></div></div><!--        <div class="row">--><!--            <div class="col-md-12 col-xs-12">--><!--                <p>Licence can be update only 30 days after activation.</p>--><!--            </div>--><!--        </div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" ng-disabled="changeObjectForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/admin/licences/licences-code-detail.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title"><button type="submit" ui-sref="licences-code" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.licencesCode.viewLicences.title">Licences</span></h1><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Licences</span></div><div class="actions"><div class="btn-group"><div class="dropdown-toggle object-icon-action no-outline no-bg btn btn-primary" data-toggle="dropdown" ng-click="vm.loadAllToExport()"><i class="glyphicon glyphicon-save-file">&nbsp;</i> <span translate="jotApp.licencesCode.viewLicences.export">Export Table</span></div><ul class="dropdown-menu" role="menu"><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS</a></li></ul></div></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-md-3 col-xs-6"><label translate="jotApp.licencesCode.vendor" for="field_vendor">Vendor</label><ui-select id="field_vendor" ng-model="vm.vendor" on-select="vm.reloadLicences()" theme="bootstrap"><ui-select-match placeholder="Select or search a vendor..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.vendors | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-3 col-xs-6"><label translate="jotApp.licencesCode.status" for="field_status">Status</label> <select id="field_status" class="form-control" ng-model="vm.status" ng-change="vm.reloadLicences()"><option value="-1">All</option><option value="0">Active</option><option value="1">Inactive</option><option value="2">Expired</option></select></div><div class="col-md-3 col-xs-6"><label translate="jotApp.licencesCode.domain" for="field_domain">Vendor</label><ui-select id="field_domain" ng-model="vm.domain" on-select="vm.reloadLicences()" theme="bootstrap" ng-disabled="vm.domainAble"><ui-select-match placeholder="Select or search a domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" refresh-delay="1"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div><br><br><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.loadAll()" ng-model="vm.charToSearch" ng-disabled="vm.domainAble" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableToExport"><thead><tr><th><span>Licence Code</span></th><th><span>Domain</span></th><th><span>Licence Type</span></th><th><span>Duration</span></th><th><span>Object Unique Code</span></th><th><span>Activation Date</span></th><th><span>Vendor</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="licence in vm.licences track by licence.id"><td>{{licence.licenceCode}}</td><td>{{licence.tabObjects.fleet.domains.domainName}}</td><td>{{licence.licenceType.type}}</td><td>{{licence.duration}}</td><td ng-bind-html="licence.tabObjects.objectUniqueCode | highlight:vm.charToSearch"></td><td ng-if="licence.tabObjects.objectUniqueCode != null && licence.activationDate != null">{{licence.activationDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td ng-if="licence.tabObjects.objectUniqueCode != null && licence.activationDate == null">EXPIRED</td><td ng-if="licence.tabObjects.objectUniqueCode == null && licence.activationDate == null">{{licence.activationDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td>{{licence.vendor.name}}</td><td class="text-center"><div class="btn-group icon-table-queue"><span ng-click="vm.change(licence.id)" ng-if="licence.tabObjects.objectUniqueCode != null && licence.activationDate != null" title="Change Object"><i class="fa fa-cube"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/licences/licences-code.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title" translate="jotApp.licencesCode.home.title">Create New Licences</h1><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.licencesCode.quantity" for="field_quantity">Quantity</label> <input type="number" class="form-control" name="quantity" id="field_quantity" ng-model="vm.licences.quantity" min="1" required><div ng-show="editForm.quantity.$invalid"><div ng-show="editForm.quantity.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.quantity.$error.min"><p class="help-block">The quantity min value is 1</p></div></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.licencesCode.checkType" for="field_checkType">Check Types</label><ui-select id="field_checkType" name="checkType" ng-model="vm.licences.checkType" theme="bootstrap" required><ui-select-match placeholder="Select a type..">{{$select.selected.type}}</ui-select-match><ui-select-choices repeat="item in vm.checkTypes | filter: {type: $select.search}" refresh-delay="1"><div ng-bind-html="item.type | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.checkType.$invalid"><p class="help-block" ng-show="editForm.checkType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.licencesCode.duration" for="field_duration">Duration</label> <input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.licences.duration" min="1" max="36" required><div ng-show="editForm.duration.$invalid"><div ng-show="editForm.duration.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.duration.$error.min"><p class="help-block">The quantity min value is 1</p></div><div ng-show="editForm.duration.$error.max"><p class="help-block">The quantity max value is 36</p></div></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.licencesCode.vendor" for="field_vendor">Vendor</label><ui-select id="field_vendor" name="vendor" ng-model="vm.licences.vendor" theme="bootstrap" required><ui-select-match placeholder="Select a vendor..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.vendor | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.vendor.$invalid"><p class="help-block" ng-show="editForm.vendor.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary" ng-click="vm.save()"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.newVendor()"><span class="glyphicon glyphicon-user"></span>&nbsp;<span translate="jotApp.licencesCode.newVendor">Create new Vendor</span></button> <button type="button" class="btn btn-primary" ui-sref="licences-code-detail" ng-if="vm.viewLicence.length > 0"><span class="glyphicon glyphicon-list"></span>&nbsp;<span translate="jotApp.licencesCode.view">View Licences</span></button> <button type="button" class="btn btn-primary" ui-sref="recap-objects" ng-if="vm.viewActiveLicence.length > 0"><span class="fa fa-cube"></span>&nbsp;<span translate="jotApp.licencesCode.viewActive">View Active Licences</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/licences/new-vendor.html','<form name="vendorForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.licencesCode.vendorModal.title">Insert vendor to create</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-xs-12"><input type="text" class="form-control" ng-model="vm.vendor.name" placeholder="Insert name.." required></div><div class="col-md-8 col-xs-12"><input type="text" class="form-control" ng-model="vm.vendor.vendorLink" placeholder="Insert Link.."></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" ng-disabled="vendorForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/admin/licences/recap-objects.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title"><button type="submit" ui-sref="licences-code" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.licencesCode.recapObjects">Active Licences</span></h1><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Active Licences</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row" has-authority="ROLE_ADMIN"><div class="col-md-3 col-xs-6"><label translate="jotApp.licencesCode.vendor" for="field_vendor">Vendor</label><ui-select id="field_vendor" ng-model="vm.vendor" on-select="vm.reloadLicences()" theme="bootstrap"><ui-select-match placeholder="Select or search a vendor..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.vendors | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><br><br><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.loadAll()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableToExport"><thead><tr><th><span>Licence Code</span></th><th><span>Licence Type</span></th><th><span>Duration</span></th><th><span>Object Unique Code</span></th><th><span>Activation Date</span></th><th><span>Vendor</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="licence in vm.activeLicence track by licence.id"><td>{{licence.licenceCode}}</td><td>{{licence.licenceType.type}}</td><td>{{licence.duration}}</td><td ng-bind-html="licence.tabObjects.objectUniqueCode | highlight:vm.charToSearch"></td><td ng-if="licence.tabObjects.objectUniqueCode != null && licence.activationDate != null">{{licence.activationDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td ng-if="licence.tabObjects.objectUniqueCode != null && licence.activationDate == null">EXPIRED</td><td ng-if="licence.tabObjects.objectUniqueCode == null && licence.activationDate == null">{{licence.activationDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td>{{licence.vendor.name}}</td><td class="text-center"><div class="btn-group icon-table-queue"></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div class="app-content-body"><div class="note note-info" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-dashboard"></i> <span translate="metrics.jvm.title">JVM Metrics</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="metrics.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-6"><h3 translate="metrics.jvm.memory.title">Memory</h3><div><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</div><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><div><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</div><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><div><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</div><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-6"><h3><span translate="metrics.jvm.threads.title">Threads</span> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand btn btn-primary btn-sm btn-circle" ui-sref="jhi-metrics-detail"><i class="fa fa-eye"></i> <span translate="entity.action.view"></span></a></h3><div><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</div><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><div><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</div><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><div><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</div><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><div><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</div><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-6"><h3 translate="metrics.jvm.gc.title">Garbage collections</h3><div class="row"><div class="col-md-5 col-lg-3"><span translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</span>:</div><div class="col-md-3">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-5 col-lg-3"><span translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</span>:</div><div class="col-md-3">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-5 col-lg-3"><span translate="metrics.jvm.gc.scavengecount">Scavenge count</span>:</div><div class="col-md-3">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-5 col-lg-3"><span translate="metrics.jvm.gc.scavengetime">Scavenge time</span>:</div><div class="col-md-3">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-dashboard"></i><span translate="metrics.jvm.http.title">HTTP Request</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="metrics.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-fixed no-footer"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div></div><div class="row"><div class="col-xs-12"><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-dashboard"></i><span translate="metrics.servicesstats.title">Service Statistics</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="metrics.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-dashboard"></i><span translate="metrics.ehcache.title">Ehcache statistics</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="metrics.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div></div></div></div></div></div><div class="row" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="glyphicon glyphicon-dashboard"></i><span translate="metrics.datasource.title">DataSource statistics (time in millisecond)</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> &nbsp;<span translate="metrics.refresh.button">Refresh</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<div class="app-content-body threads-dump-page"><h1 class="page-title" translate="metrics.jvm.threads.dump.title">Threads dump</h1><button type="button" ui-sref="jhi-metrics" class="btn btn-primary btn-sm" ng-click="vm.cancel()"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="entity.action.back">Back</span></button><div class="row five-databoard-stat"><div class="col col-sm-6 col-xs-12"><a href="javascript:;" ng-click="threadDumpFilter = {}" class="dashboard-stat dashboard-stat-v2 blue-steel"><div class="visual"><i class="fa fa-cloud"></i></div><div class="details"><div class="number">{{vm.threadDumpAll}}</div><div class="desc" translate="metrics.jvm.threads.all">All</div></div></a></div><div class="col col-sm-6 col-xs-12"><a href="javascript:;" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}" class="dashboard-stat dashboard-stat-v2 green-jungle"><div class="visual"><i class="fa fa-check"></i></div><div class="details"><div class="number">{{vm.threadDumpRunnable}}</div><div class="desc" translate="metrics.jvm.threads.runnable">Runnable</div></div></a></div><div class="col col-sm-6 col-xs-12"><a href="javascript:;" ng-click="threadDumpFilter = {threadState: \'WAITING\'}" class="dashboard-stat dashboard-stat-v2 yellow-saffron"><div class="visual"><i class="fa fa-exclamation-triangle"></i></div><div class="details"><div class="number">{{vm.threadDumpWaiting}}</div><div class="desc" translate="metrics.jvm.threads.waiting">Waiting</div></div></a></div><div class="col col-sm-6 col-xs-12"><a href="javascript:;" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}" class="dashboard-stat dashboard-stat-v2 green"><div class="visual"><i class="fa fa-clock-o"></i></div><div class="details"><div class="number">{{vm.threadDumpTimedWaiting}}</div><div class="desc" translate="metrics.jvm.threads.timedwaiting">Time Waiting</div></div></a></div><div class="col col-sm-6 col-xs-12"><a href="javascript:;" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}" class="dashboard-stat dashboard-stat-v2 red"><div class="visual"><i class="fa fa-times"></i></div><div class="details"><div class="number">{{vm.threadDumpBlocked}}</div><div class="desc" translate="metrics.jvm.threads.blocked">Time Waiting</div></div></a></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation-triangle"></i> <span translate="metrics.jvm.threads.dump.title"></span></div><div class="actions"></div></div><div class="portlet-body"><div class="row"><div class="col-md-6"><div class="dataTables_filter"><label translate="global.form.filter">Filter</label> <input type="text" ng-model="threadDumpFilter"></div></div></div><div class="row content-wrapper"><div class="col-xs-12"><div ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="badge" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span> &nbsp;{{v.threadName}} (ID {{v.threadId}}) <a class="btn btn-primary btn-sm pull-right" ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-striped table-bordered no-footer"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td class="text-right">{{v.blockedTime}}</td><td class="text-right">{{v.blockedCount}}</td><td class="text-right">{{v.waitedTime}}</td><td class="text-right">{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div></div></div></div></div></div><!--<div class="modal-body pad">--><!--<span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp;--><!--<span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp;--><!--<span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp;--><!--<span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp;--><!--<span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;--><!--<div class="voffset2">&nbsp;</div>--><!--Filter--><!--<input type="text" ng-model="threadDumpFilter" class="form-control">--><!--<div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter">--><!--<h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}})--><!--<a ng-click="show = !show">--><!--<span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span>--><!--<span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span>--><!--</a>--><!--</h5>--><!--<div class="well" ng-show="show">--><!--<div ng-repeat="(stK, stV) in v.stackTrace">--><!--{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}})--><!--<span class="voffset1"></span>--><!--</div>--><!--</div>--><!--<table class="table table-condensed">--><!--<thead>--><!--<tr>--><!--<th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th>--><!--<th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th>--><!--<th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th>--><!--<th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th>--><!--<th translate="metrics.jvm.threads.dump.lockname">Lock Name</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr>--><!--<td>{{v.blockedTime}}</td>--><!--<td>{{v.blockedCount}}</td>--><!--<td>{{v.waitedTime}}</td>--><!--<td>{{v.waitedCount}}</td>--><!--<td>{{v.lockName}}</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-default  pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button>--><!--</div>--></div>');
$templateCache.put('app/admin/team-management/team-management-alert-system.html','<div class="app-content-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title" id="myTabDomainsLabel">User : {{vm.user.login}}</h1></div></div><br><br><div class="row"><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" ng-show="vm.email"><div class="dashboard-stat dashboard-stat-v2 bg-email channel-tile-modal"><br><span class="tile-title">Email</span> <a class="boxclose" ng-click="vm.deleteAlert(vm.email.id)"></a><br><label class="switch"><input type="checkbox" ng-click="vm.emailDisabled = !vm.emailDisabled; vm.toggleStatus(\'email\', vm.emailDisabled)" ng-checked="!vm.emailDisabled"> <span class="alert-toggle round"></span></label><br><span style="display: inherit;">{{vm.userEmail}}</span><div class="visual"><i class="iconAlert icon-envelope-regular"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" ng-show="vm.slack" ng-if="vm.licence.id === 4"><div class="dashboard-stat dashboard-stat-v2 bg-slack Ael-tile-modal"><br><span class="tile-title">Slack</span> <a class="boxclose" ng-click="vm.deleteAlert(vm.slack.id)"></a><br><label class="switch"><input type="checkbox" ng-click="vm.slackDisabled = !vm.slackDisabled; vm.toggleStatus(\'slack\', vm.slackDisabled)" ng-checked="!vm.slackDisabled"> <span class="alert-toggle round"></span></label><br><span style="display: inherit;">{{vm.userSlack}}</span><div class="visual"><i class="iconAlert icon-slack-brands"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" ng-show="vm.telegram" ng-if="vm.licence.id === 4"><div class="dashboard-stat dashboard-stat-v2 bg-telegram channel-tile-modal"><br><span class="tile-title">Telegram</span> <a class="boxclose" ng-click="vm.deleteAlert(vm.telegram.id)"></a><br><label class="switch"><input type="checkbox" ng-click="vm.telegramDisabled = !vm.telegramDisabled; vm.toggleStatus(\'telegram\', vm.telegramDisabled)" ng-checked="!vm.telegramDisabled"> <span class="alert-toggle round"></span></label><br><span style="display: inherit;">{{vm.userTelegram}}</span><div class="visual"><i class="iconAlert icon-telegram"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" ng-show="vm.webhook" ng-if="vm.licence.id === 4"><div class="dashboard-stat dashboard-stat-v2 bg-webhook channel-tile-modal"><br><span class="tile-title">Webhook</span> <a class="boxclose" id="boxclose" ng-click="vm.deleteAlert(vm.webhook.id)"></a><br><label class="switch"><input type="checkbox" ng-click="vm.webhookDisabled = !vm.webhookDisabled; vm.toggleStatus(\'webhook\', vm.webhookDisabled)" ng-checked="!vm.webhookDisabled"> <span class="alert-toggle round"></span></label><br><span style="display: inherit;">{{vm.userWebhok}}</span><div class="visual"><i class="iconAlert icon-webhook"></i></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletSystemTitle">System Rules List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.systemPredicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.alertRules.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.alertRules.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.alertRules.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span></th></tr></thead><tbody><tr ng-repeat="warning in vm.systemWarnings track by warning.id"><td>{{warning.name}}</td><td>{{warning.description}}</td><td>{{warning.userProfile.name}}</td><td>{{warning.tabFleets.fleetName}}</td><td><span class="wrapper-md-right no-outline" ng-class="(vm.enableMail[warning.id]) ? (warning.relatedAlertSystemType.email ? \'color-green\' : \'background-red\') : \'color-gray\' " ng-disabled="{{!vm.enableMail[warning.id]}}"><i ng-class="!vm.emailDisabled && (warning.relatedAlertSystemType.Channelmail == undefined || warning.relatedAlertSystemType.Channelmail) && vm.wac[warning.id].email ? \'iconAlert icon-envelope-regular\' : \'iconAlert icon-envelope-regular-not\'"></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableSlack[warning.id]) ? (warning.relatedAlertSystemType.slack ? \'color-green\' : \'background-red\') : \'color-gray\' " ng-disabled="{{!vm.enableSlack[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.slackDisabled && (warning.relatedAlertSystemType.Channelslack == undefined || warning.relatedAlertSystemType.Channelslack) && vm.wac[warning.id].slack ? \'iconAlert icon-slack-brands\' : \'iconAlert icon-slack-not\' "></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableTelegram[warning.id]) ? (warning.relatedAlertSystemType.telegram ? \'color-green\' : \'background-red\') : \'color-gray\'" ng-disabled="{{!vm.enableTelegram[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.telegramDisabled && (warning.relatedAlertSystemType.Channeltelegram == undefined || warning.relatedAlertSystemType.Channeltelegram) && vm.wac[warning.id].telegram ? \'iconAlert icon-telegram\' : \'iconAlert icon-telegram-not\'"></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableWebhook[warning.id]) ? (warning.relatedAlertSystemType.webhook ? \'color-green\' : \'background-red\') : \'color-gray\'" ng-disabled="{{!vm.enableWebhook[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.webhookDisabled && (warning.relatedAlertSystemType.Channelwebhook == undefined || warning.relatedAlertSystemType.Channelwebhook) && vm.wac[warning.id].webhook ? \'iconAlert icon-webhook\' : \'iconAlert icon-webhook-not\'"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-slack-not" ng-if="vm.licence.id !== 4"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-telegram-not" ng-if="vm.licence.id !== 4"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-webhook-not" ng-if="vm.licence.id !== 4"></i></span></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemPage" total="vm.systemQueryCount" limit="vm.systemWarningItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemWarningItemLimit" total-items="vm.systemTotalItems" ng-model="vm.systemPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletTitle">Rules List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select></label></div></div><div class="col-sm-6"></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.alertRules.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.alertRules.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.alertRules.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span></th></tr></thead><tbody><tr ng-repeat="warning in vm.warnings track by warning.id"><td>{{warning.name}}</td><td>{{warning.description}}</td><td>{{warning.userProfile.name}}</td><td>{{warning.tabFleets.fleetName}}</td><td><span class="wrapper-md-right no-outline" ng-class="(vm.enableMail[warning.id]) ? (warning.relatedAlertSystemType.email ? \'color-green\' : \'background-red\') : \'color-gray\' " ng-disabled="{{!vm.enableMail[warning.id]}}"><i ng-class="!vm.emailDisabled && (warning.relatedAlertSystemType.Channelmail == undefined || warning.relatedAlertSystemType.Channelmail) && vm.wac[warning.id].email ? \'iconAlert icon-envelope-regular\' : \'iconAlert icon-envelope-regular-not\'"></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableSlack[warning.id]) ? (warning.relatedAlertSystemType.slack ? \'color-green\' : \'background-red\') : \'color-gray\' " ng-disabled="{{!vm.enableSlack[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.slackDisabled && (warning.relatedAlertSystemType.Channelslack == undefined || warning.relatedAlertSystemType.Channelslack)  && vm.wac[warning.id].slack ? \'iconAlert icon-slack-brands\' : \'iconAlert icon-slack-not\' "></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableTelegram[warning.id]) ? (warning.relatedAlertSystemType.telegram ? \'color-green\' : \'background-red\') : \'color-gray\'" ng-disabled="{{!vm.enableTelegram[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.telegramDisabled && (warning.relatedAlertSystemType.Channeltelegram == undefined || warning.relatedAlertSystemType.Channeltelegram)  && vm.wac[warning.id].telegram ? \'iconAlert icon-telegram\' : \'iconAlert icon-telegram-not\'"></i> </span><span class="wrapper-md-right no-outline" ng-class="(vm.enableWebhook[warning.id]) ? (warning.relatedAlertSystemType.webhook ? \'color-green\' : \'background-red\') : \'color-gray\'" ng-disabled="{{!vm.enableWebhook[warning.id]}}" ng-if="vm.licence.id === 4"><i ng-class="!vm.webhookDisabled && (warning.relatedAlertSystemType.Channelwebhook == undefined || warning.relatedAlertSystemType.Channelwebhook)  && vm.wac[warning.id].webhook ? \'iconAlert icon-webhook\' : \'iconAlert icon-webhook-not\'"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-slack-not" ng-if="vm.licence.id !== 4"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-telegram-not" ng-if="vm.licence.id !== 4"></i> </span><span class="wrapper-md-right no-outline color-gray" ng-disabled="true"><i class="iconAlert icon-webhook-not" ng-if="vm.licence.id !== 4"></i></span></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/team-management/team-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="teamManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/team-management/team-management-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="teamManagement.detail.title">User</span> {{vm.user.login}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="teamManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="teamManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="teamManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="teamManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="teamManagement.activated">Activated</span></dt><dd><span class="label label-danger" ng-show="!vm.user.activated" style="cursor: pointer;">{{vm.user.activated}}</span> <span class="label label-success" ng-show="vm.user.activated" style="cursor: pointer;">{{vm.user.activated}}</span></dd><dt><span translate="teamManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="teamManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="teamManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="teamManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="teamManagement.userProfile">User Profile</span></dt><dd>{{vm.user.userProfile.name}}</dd><dt><span translate="teamManagement.fleets">Fleet</span></dt><dd><span ng-repeat="fleet in vm.user.fleets"><a ui-sref="tab-fleets-detail({id: {{fleet.id}}})">{{fleet.fleetName}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/admin/team-management/team-management-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="teamManagement.home.createOrEditLabel">Create or edit a Tab Object</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="teamManagement.login">Login</label> <input type="text" id="login" class="form-control" name="login" ng-pattern="/^(([a-z0-9]+)(\\.)?([a-z0-9]+))*$/" ng-model="vm.user.login" ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.login.$error.pattern">Your username can only contain lower-case letters and digits and dots.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="teamManagement.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="teamManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="teamManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="teamManagement.userProfile">Profiles</label> <select class="form-control" name="userProfile" ng-model="vm.user.userProfile" required ng-options="userProfile.name for userProfile in vm.userProfiles track by userProfile.id"></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="teamManagement.fleets" for="fleet">Join Fleets</label> <select class="form-control" chosen multiple="multiple" name="fleets" id="fleet" ng-model="vm.user.fleets" ng-options="fleets.fleetName for fleets in vm.domain.fleets track by fleets.id" data-placeholder-text-multiple="\' \'"><option value=""></option></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === undefined" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="teamManagement.activated">Activated</span></label></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/team-management/team-management.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button class="btn btn-primary" ng-click="vm.newInvitation()"><i class="fa fa-plus"></i> <span translate="invitation.home.inviteLabel">Invite a new User</span></button> <button class="btn btn-primary" ng-click="vm.invitationList()"><i class="fa fa-list"></i> <span translate="invitation.home.invitationListLabel">Invitation List</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-lab ng-scope" for="field_status">Filter By status</label> <select class="form-control" id="field_status" ng-change="vm.showUserByStatus()" ng-model="vm.userStatus" chosen disable-search="true"><option label="all" value="all">all</option><option label="active" value="" selected="selected">active</option><option label="inactive" value="inactive">inactive</option></select></div></div><div class="col-md-3 aside-right"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped"><thead><tr multi-sort="vm.predicates" callback="vm.loadAll()"><th multi-sort-by="login"><span translate="teamManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="email"><span translate="teamManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="activated"><span translate="teamManagement.status">Status</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="createdDate"><span translate="teamManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="lastModifiedBy"><span translate="teamManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="lastModifiedDate"><span translate="teamManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="teamManagement.userProfile">Profile</span></th><th translate="entity.action.actionLabel">Action</th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td ng-bind-html="user.login | highlight:vm.charToSearch"></td><td ng-bind-html="user.email | highlight:vm.charToSearch"></td><td><span class="label label-danger" ng-show="!user.activated" translate="teamManagement.deactivated">Desactivated</span> <span class="label label-success" ng-show="user.activated" translate="teamManagement.activated">Activated</span></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.userProfile.name}}</td><td class="text-right"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions</span> <i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="team-management-detail({login:user.login})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="team-management-edit({login:user.login})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><!--                                                TODO rimuovere tutta la funzionalit\xE0, per ora nascosto solo il link--><!--                                                <li>--><!--                                                    <a href="javascript:;" ui-sref="team-management-alerts({login:user.login})">--><!--                                                        <i class="glyphicon glyphicon-envelope"></i>    <span translate="entity.action.alertSystem"></span>--><!--                                                    </a>--><!--                                                </li>--><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="team-management-delete({login:user.login})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div class="app-content-body"><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer"><thead><tr><th translate="tracker.table.userlogin">User</th><th translate="tracker.table.ipaddress">IP Address</th><th translate="tracker.table.page">Current page</th><th translate="tracker.table.time">Time</th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="app-content-body detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}<span></span></span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.role">Role</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd><dt><span translate="userManagement.profile">Profile</span></dt><dd>{{vm.user.userProfile.name}}</dd><dt><span translate="userManagement.domains">Domains</span></dt><dd><span ng-repeat="domain in vm.user.domains"><a ui-sref="tab-domains-detail({id: {{domain.id}}})">{{domain.domainName}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<div class="app-content-body"><h1 class="page-title" translate="userManagement.home.createOrEditLabel">Create or edit a User</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label> <input type="text" id="login" class="form-control" name="login" ng-pattern="/^(([a-z0-9]+)(\\.)?([a-z0-9]+))*$/" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-disabled="vm.edit" ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.login.$error.pattern">Your username can only contain lower-case letters and digits and dots.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.langKey">Lang Key</label> <select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.role">Role</label> <select class="form-control" name="authority" ng-model="vm.user.authorities" ng-change="vm.loadProfiles()" required ng-options="authority for authority in vm.authorities track by authority"></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="activated"><input ng-disabled="vm.user.id === undefined" type="checkbox" id="activated" ng-model="vm.user.activated"> <span></span><div translate="userManagement.activated">Activated</div></label></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.domains" for="field_domains">Domains</label> <select class="form-control" chosen multiple="multiple" name="domains" id="field_domains" ng-model="vm.user.domains" ng-options="domain.domainName for domain in vm.domains track by domain.id" ng-required="vm.edit" data-placeholder-text-multiple="\' \'"><option value=""></option></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.userProfile">Profiles</label> <select class="form-control" name="userProfile" ng-model="vm.user.userProfile" required ng-options="profile.name for profile in vm.userProfiles track by profile.id" ng-disabled="vm.profilesLoading"></select><p class="help-block text-warning" ng-show="!vm.profilesLoading && (!vm.userProfiles || !vm.userProfiles.length) && vm.user.authorities"><i class="fa fa-exclamation-triangle"></i> No profiles available for the selected role.</p><p class="help-block text-muted" ng-show="vm.profilesLoading"><i class="fa fa-spinner fa-spin"></i> Loading profiles...</p></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving || !vm.user.userProfile || !vm.user.userProfile.id" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button class="btn btn-primary" ng-click="vm.newInvitation()"><i class="fa fa-plus"></i> <span translate="invitation.home.inviteLabel">Invite a new User</span></button> <button class="btn btn-primary" ui-sref="user-management.new"><i class="fa fa-plus"></i> <span translate="userManagement.home.createLabel">Create a new User</span></button> <button class="btn btn-primary" ng-click="vm.invitationList()"><i class="fa fa-list"></i> <span translate="invitation.home.invitationListLabel">Invitation List</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-lab ng-scope" for="field_status">Filter By status</label> <select class="form-control" id="field_status" ng-change="vm.showUserByStatus()" ng-model="vm.userStatus" chosen disable-search="true"><option label="all" value="all">all</option><option label="active" value="" selected="selected">active</option><option label="inactive" value="inactive">inactive</option></select></div></div><div class="col-md-3"><div class="form-group"><label for="field_domains">Domains</label><ui-select id="field_domains" ng-model="vm.filterDomain" theme="bootstrap" ng-change="vm.filterDomains()"><ui-select-match placeholder="Select a domain...">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" percent="90"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-show="vm.filterDomain.id > 0"><div class="form-group"><label for="field_fleets">Fleet</label><ui-select id="field_fleets" name="tabFleets" ng-model="vm.filterFleet" theme="bootstrap" ng-change="vm.loadAll()"><ui-select-match placeholder="Select or search a fleet...">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}" percent="90"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-3 aside-right"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Login or Email..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered no-footer action-column"><thead><tr><th translate="userManagement.login">Login</th><th translate="userManagement.email">Email</th><th translate="userManagement.status">Status</th><th translate="userManagement.langKey">Lang Key</th><th translate="userManagement.role">Role</th><th translate="userManagement.createdDate">Created Date</th><th translate="userManagement.lastModifiedBy">Last Modified By</th><th translate="userManagement.lastModifiedDate">Last Modified Date</th><th translate="entity.action.actionLabel">Action</th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td ng-bind-html="user.login | highlight:vm.charToSearch"></td><td ng-bind-html="user.email | highlight:vm.charToSearch"></td><td><span class="label label-danger" ng-show="!user.activated" translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="user.activated" translate="userManagement.activated">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities">{{ authority }}</div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions</span> <i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li ng-if="user.authorities[0] != \'ROLE_ADMIN\'"><a href="javascript:;" ng-click="vm.impersonate(user)"><i class="fa fa-user-secret"></i><span translate="userManagement.impersonate"></span></a></li><li><a href="javascript:;" ui-sref="user-management-detail({login:user.login})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="user-management-edit({login:user.login})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="user-management.delete({login:user.login})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate"><uib-pagination total-items="vm.totalItems" items-per-page="vm.itemsPerPageChosen" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/context/context.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><div class="context-page foreground" ng-cloak><div class="container filter-container"><div class="row"><div ng-if="vm.viewSearch" class="col-xs-12"><div class="form-group context-filter-wrapper"><input class="form-control" ng-model="vm.searchText" ng-change="vm.loadAll()" placeholder="{{\'entity.action.search\' | translate}}..." autofocus></div></div></div></div><div class="container context-list-container"><div class="row justify-content-center"><div id="{{context.id}}" ng-repeat="context in vm.contexts" class="col-lg-3 col-md-4 col-sm-6 col-xs-10 col-lg-offset-0 col-md-offset-0 col-sm-offset-0 col-xs-offset-1 domain-card-container" ng-init="$last && vm.checkRedirect()"><a class="domain-card" href="/jot/api/context/{{context.id}}"><div class="inner"><div class="card-header"><div class="card-text"><div class="card-title text-capitalize">{{context.licence.name}}</div></div></div><div class="card-body"><div class="nome" ng-bind-html="context.domainName | highlight : vm.searchText"></div></div></div></a></div><a id="oneContext" ng-hide href=""></a></div><!--<div class="container context-list-container">\n                <div class="row">\n                    <div id="{{context.id}}" ng-repeat="context in vm.contexts" class="col-xs-6 col-sm-4 col-sm-3 col-md-3 tiles" ng-init="$last && vm.checkRedirect()">\n                        <a class="context mt-element-ribbon" href="/jot/api/context/{{context.id}}">\n                            <div ng-if="context.licence.id != 1" class="ribbon ribbon-shadow ribbon-clip ribbon-color-primary uppercase">\n                                <div class="ribbon-sub ribbon-clip"></div>{{context.licence.name}}\n                                <div class="custom-ribbon-bookmark"></div>\n                            </div>\n                            &lt;!&ndash;<div class="ribbon ribbon-vertical-left ribbon-shadow ribbon-color-primary uppercase">&ndash;&gt;\n                                &lt;!&ndash;<div class="ribbon-sub ribbon-bookmark"></div>&ndash;&gt;\n                                &lt;!&ndash;<i class="fa fa-star"></i>&ndash;&gt;\n                            &lt;!&ndash;</div>&ndash;&gt;\n                            <div class="inner">\n                                <div class="nome" ng-bind-html="context.domainName | highlight : vm.searchText"></div>\n                                <div class="logo">{{context.logo}}</div>\n                            </div>\n                        </a>\n                    </div>\n                    <a id="oneContext" ng-hide href=""></a>\n                </div>\n            </div>--></div></div></div>');
$templateCache.put('app/components/home/home.html','<div class="app-content-body home-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12 col-md-4"><h4 align="center" translate="home.chart.objectStatus">Objects Status</h4><canvas class="chart chart-horizontal-bar" chart-colors="colorStatus" chart-data="dataStatus" chart-labels="labelStatus" chart-options="options"></canvas></div><div class="col-sm-12 col-md-4"><h4 align="center" translate="home.chart.trend">Last Hour Trend</h4><table class="trend" align="center"><tr><td width="20%"><strong>online</strong></td><td width="70%"><canvas id="line-chart" class="online-graph"></canvas><div><strong>{{vm.onlineTrendPrecentage > 0 ? "+" + vm.trendFormatter(vm.onlineTrendPrecentage) : vm.trendFormatter(vm.onlineTrendPrecentage)}} %</strong></div></td><td width="10%"><i ng-class="vm.onlineTrendPrecentage > 0 ? [\'fa fa-arrow-up fa-2x\', \'trend-arrow-green\'] : vm.onlineTrendPrecentage < 0 ? [\'fa fa-arrow-down fa-2x\', \'trend-arrow-red\'] : \'fa fa-arrows-h fa-2x\' "></i></td></tr><tr><td><strong>warnings</strong></td><td><strong>{{vm.offlineTrendPrecentage > 0 ? "+" + vm.trendFormatter(vm.offlineTrendPrecentage) : vm.trendFormatter(vm.offlineTrendPrecentage)}} %</strong></td><td><i ng-class="vm.offlineTrendPrecentage > 0 ? [\'fa fa-arrow-up fa-2x\', \'trend-arrow-red\'] : vm.offlineTrendPrecentage < 0 ? [\'fa fa-arrow-down fa-2x\', \'trend-arrow-green\'] : \'fa fa-arrows-h fa-2x\' "></i></td></tr><tr><td style="line-height: 1"><strong>objects with warnings</strong></td><td><strong>{{vm.warningsTrendPercentage > 0 ? "+" + vm.trendFormatter(vm.warningsTrendPercentage) : vm.trendFormatter(vm.warningsTrendPercentage)}} %</strong></td><td><i ng-class="vm.warningsTrendPercentage > 0 ? [\'fa fa-arrow-up fa-2x\', \'trend-arrow-red\'] : vm.warningsTrendPercentage < 0 ? [\'fa fa-arrow-down fa-2x\', \'trend-arrow-green\'] : \'fa fa-arrows-h fa-2x\' "></i></td></tr></table></div><div class="co-sm-12 col-md-4"><div class="tiles"><div class="tile tile-motiqa-gray"><a ui-sref="queues"><div class="tile-body"><i class="fa fa-list"></i></div><div class="tile-object"><div class="name" translate="home.tiles.queues">Commands Queue</div></div></a></div><div class="tile tile-motiqa-gray"><a ui-sref="warning-dashboard"><div class="tile-body"><i class="fa fa-exclamation-triangle"></i></div><div class="tile-object"><div class="name" translate="home.tiles.warning">Warnings</div></div></a></div><div class="tile tile-motiqa-gray"><a ui-sref="action-commands"><div class="tile-body"><i class="fa fa-terminal"></i></div><div class="tile-object"><div class="name" translate="home.tiles.commands">Commands</div></div></a></div><div class="tile tile-motiqa-gray" evaluate-authorities="ROLE_DOMAIN_ADMIN && !ROLE_TECH"><a ui-sref="team-management"><div class="tile-body"><i class="fa fa-users"></i></div><div class="tile-object"><div class="name" translate="home.tiles.team">My Team</div></div></a></div><div class="tile tile-motiqa-gray" has-authority="ROLE_TECH"><a ui-sref="tab-objects"><div class="tile-body"><i class="fa fa-cube"></i></div><div class="tile-object"><div class="name" translate="home.tiles.objects">Objects</div></div></a></div></div></div></div></div><div class="row" id="dashboardType"><dashboard name="TickAllObjects" from-date="vm.fromDate" to-date="vm.toDate" frame-height="380px;"></dashboard></div><div id="object-map" ng-style="vm.mapStyle"></div>');
$templateCache.put('app/components/login/login.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><jhi-alert></jhi-alert><div class="login-wrapper-inner"><div class="content"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="logo"><img src="./content/images/jot-logo.png" alt=""><!--<span class="login-page-title">JoT</span>--></div><!--Start forget form--><div class="form" ng-show="vm.view==\'forget\'"><!--TODO da mettere submit per il form di forget--><form class="login-form" name="form" role="form" ng-submit="vm.requestReset()" novalidate show-validation><h3 class="form-title" translate="login.password.forgot">Forgot Password?</h3><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><p translate="login.form.emailLabel">Enter your e-mail address below to reset your password.</p><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><div class="form-group"><label class="control-label visible-ie8 visible-ie9">Email</label> <input class="form-control form-control-solid placeholder-no-fix" id="email" name="email" type="text" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required placeholder="{{\'login.form.email\' | translate}}"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="actions"><button class="btn btn-lg btn-outline uppercase" ng-click="vm.view = \'login\'; vm.resetAccount.email = \'\'" translate="entity.action.back">Back</button> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-lg uppercase" translate="login.form.submit">submit</button></div></form><br></div><!--End forget form--><!--Start login form--><div class="form" ng-if="vm.view==\'login\'"><form class="login-form" role="form" ng-submit="vm.login($event)"><!--<h3 class="form-title" translate="login.title">Sign In</h3>--><div class="alert alert-danger" ng-show="vm.authenticationError"><button type="button" class="close" data-close="alert" ng-click="vm.authenticationError=false"></button> <span translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</span></div><div class="form-group form-group-login"><label class="control-label visible-ie8 visible-ie9">Username</label> <span><i class="glyphicon glyphicon-user"></i></span> <input class="form-control form-control-solid placeholder-no-fix" type="text" placeholder="Username" id="username" placeholder="{{\'global.form.username\' | translate}}" ng-model="vm.username"></div><div class="form-group form-group-login"><label class="control-label visible-ie8 visible-ie9">Password</label> <span><i class="glyphicon glyphicon-lock"></i></span> <input class="form-control form-control-solid placeholder-no-fix" type="password" placeholder="Password" id="password" placeholder="{{\'login.form.password\' | translate}}" ng-model="vm.password"></div><label for="rememberMe" class="rememberme check mt-checkbox mt-checkbox-outline"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"><div translate="login.form.rememberme">Remember me</div><span></span></label><div class="actions"><div><button type="submit" class="btn btn-primary btn-lg uppercase new-account-button" translate="login.form.button">login</button><!--                            <button ui-sref="register-page" class="btn btn-primary btn-lg uppercase new-account-button" translate="login.form.register">Register</button>--></div><div class="login-footer"><div class="forget-link" ng-click="vm.view = \'forget\'" translate="login.password.forgot">Forgot Password?</div><!--                                        <a ui-sref="register-page" translate="login.form.register">Sign up</a>--></div></div></form></div><!--End login form--></div></div></div></div><div class="contact-us"><a ui-sref="contact-us" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/components/otp/contact.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><div class="login-wrapper-inner login-wrapper-contact-inner"><div class="content" ng-if="vm.form"><div class="logo"><img src="./content/images/jot-logo.png" alt=""></div><!--Start Contact-Us form--><div class="form"><form class="login-form" name="editForm" role="form" novalidate ng-submit="vm.contactUs()"><h3 class="form-title" translate="login.contact.contactUs">Contact Us</h3><div class="form-group"><label class="control-label" translate="login.contact.mail">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.contact.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" translate="login.contact.name">Name</label> <input type="text" class="form-control" name="name" required ng-model="vm.contact.name" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="login.contact.message">Message</label> <textarea class="form-control contact-us-textarea" name="message" rows="5" required ng-model="vm.contact.message"></textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="actions"><button type="button" class="btn btn-lg btn-outline uppercase" ui-sref="login"><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-lg uppercase"><span translate="login.contact.sendMail">Contact</span></button></div></form></div><!--End Contact-Us form--></div><div class="help-desk-mail-sent" ng-show="!vm.form"><div class="row"><div class="alert alert-success"><button class="close" data-close="alert"></button> <span translate="login.contact.sent">Mail Sent</span></div></div><div class="row"><button type="button" class="btn btn-default col-xs-12 col-xm-12" ui-sref="login"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="login.contact.back">Login Form</span></button></div></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/components/otp/otp-code.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><div class="login-wrapper-inner"><div class="content otp-content"><div class="logo"><img src="./content/images/jot-logo.png" alt=""></div><!--Start OTP form--><div class="form"><form class="login-form" role="form" ng-submit="vm.checkOtp()"><h3 class="form-title" translate="login.userOtp.verificationCode" ng-if="vm.twoFactorEmail">Verification Code</h3><h3 class="form-title" translate="login.userOtp.verification2FCode" ng-if="!vm.twoFactorEmail">Verification 2F Code</h3><div class="alert alert-danger" ng-show="vm.otpError"><button type="button" class="close" data-close="alert" ng-click="vm.otpError=false"></button> <span translate="login.messages.error.otp"><strong>Invalid Otp!</strong></span></div><div class="form-group"><input class="form-control form-control-solid placeholder-no-fix" type="text" placeholder="Insert verification code..." id="user_otp" ng-model="vm.userOtp"></div><div class="actions"><button type="submit" class="btn btn-primary btn-lg uppercase new-account-button" translate="login.userOtp.otpVerify">Verify</button> <button type="button" class="btn btn-primary btn-lg uppercase new-account-button" translate="login.userOtp.sendOtp" ng-click="vm.sendNew()" ng-if="vm.twoFactorEmail">Send New OTP</button></div><div ng-if="vm.twoFactorEmail" class="otp-tutorial-text"><span>Don\'t want to wait for an email?<br>Use your mobile authenticator app.</span><br><a href="https://youtu.be/u10Jz6oPu68" target="_blank" rel="noopener noreferrer">Here\'s a tutorial.</a></div></form></div><!--End OTP form--></div><div class="contact-us"><a ui-sref="contact-us" ui-sref-opts="{reload: true}" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}}</div></div></div>');
$templateCache.put('app/components/register-page/privacy-terms-modal.html','<div class="modal-body"><p translate="login.registration.modalMsg">To confirm please read the Privacy Policy and accept the Terms & conditions</p><ul><li><button class="btn btn-primary" ng-click="vm.privacyAgree()" translate="login.registration.privacy">Privacy Policy</button></li><br><li><button class="btn btn-primary" ng-click="vm.termsAgree()" translate="login.registration.terms">Terms and Conditions</button></li></ul></div><div class="modal-footer"><button class="btn btn-primary btn-lg uppercase" ng-click="vm.dismissModal()"><span translate="entity.action.ok">OK</span></button></div>');
$templateCache.put('app/components/register-page/register-page.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="login-wrapper-inner-register"><div class="content"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="logo"><img src="./content/images/jot-logo.png" alt=""><!--<span class="login-page-title">JoT</span>--></div><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="form-body"><h3 class="form-title" translate="login.registration.formTitle">Register new Account and Domain</h3><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.login">Username</label> <input type="text" id="login" class="form-control" name="login" ng-pattern="/^(([a-z0-9]+)(\\.)?([a-z0-9]+))*$/" ng-model="vm.user.login" required ng-maxlength="50" ng-minlength="7"><div ng-show="editForm.login.$dirty && editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.login.$error.minlength" translate="entity.validation.minlength" translate-value-min="7">This field is required to be at least 7 characters.</p><p class="help-block" ng-show="editForm.login.$error.pattern" translate="entity.validation.rulesUsername">Your username can only contain lower-case letters and digits and dots.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.login.$dirty && editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" required ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.login.$dirty && editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="userManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" required ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.login.$dirty && editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><label translate="userManagement.domainName">Domains</label> <input type="text" class="form-control" name="domains" required ng-pattern="/^(([a-zA-Z0-9]+)([-_\\s])?([a-zA-Z0-9]+))*$/" ng-model="vm.user.domain" ng-maxlength="50"><div ng-show="editForm.login.$dirty && editForm.domains.$invalid"><p class="help-block" ng-show="editForm.domains.$error.pattern" translate="entity.validation.rules">Your domain name can only contain letters and digits. Minus, underscore and spaces are allowed only within the domain name.</p><p class="help-block" ng-show="editForm.domains.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label for="field_check1" class="check mt-checkbox mt-checkbox-outline"><input type="checkbox" name="check1" id="field_check1" value="true" required ng-model="vm.user.check1" ng-click="vm.openModal()"><div translate="login.registration.confirmation">I confirm to have read the <span class="fake-link-text" ng-click="vm.privacyAgree()">Privacy Policy* </span>and to accept the <span class="fake-link-text" ng-click="vm.termsAgree()">Terms & conditions*</span></div><span></span></label></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label for="field_check2" class="check mt-checkbox mt-checkbox-outline"><input class="col-md-1 col-xs-1" type="checkbox" name="check2" id="field_check2" value="true" ng-model="vm.user.check2"><div translate="login.registration.consentCommercial">I confirm my consent to the processing of my personal data for marketing purposes, consisting in commercial offers sent via email</div><span></span></label></div></div></div><div class="row"><div class="col-xs-12"><div class="form-group"><label for="field_check3" class="check mt-checkbox mt-checkbox-outline"><input class="col-md-1 col-xs-1" type="checkbox" name="check3" id="field_check3" value="true" ng-model="vm.user.check3"><div translate="login.registration.consentProfiling">I confirm my consent to automated processing of my personal data, by means of profiling, in order to receive commercial offers customized on the basic of my browsing and purchasing behavior</div><span></span></label></div></div></div><div class="re-captcha-wrapper"><div vc-recaptcha key="\'6LeUg08cAAAAAAD9O4zgNG5twHJ0UxAcjMFfRZ00\'"></div></div><div class="actions"><button type="button" class="btn btn-lg btn-outline uppercase" ui-sref="login"><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary btn-lg uppercase"><span translate="entity.action.confirm">Save</span></button></div></div></form></div></div></div></div><!--<div class="row">\n                <p><a ui-sref="contact-us-privacy" translate="login.contact.contactUs">Contact Us</a></p>\n            </div>--></div><div class="contact-us"><a ui-sref="contact-us" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/components/register-page/terms-conditions.html','<form name="termsForm"><div class="modal-header"><h4 class="modal-title">Please Check Conditions</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group" uib-tooltip="{{vm.checkDisabled}}" tooltip-placement="top"><input class="col-md-1 col-xs-12" type="checkbox" name="check1" id="field_check1" value="true" required ng-model="vm.updateCheck.check1" ng-disabled="vm.disabled"> <label class="col-md-11 col-xs-12" for="field_check1" style="font-size:12px">I confirm to have read the <span class="fake-link-text" ng-click="vm.privacyAgree()">Privacy Policy* </span>and to accept the <span class="fake-link-text" ng-click="vm.termsAgree()">Terms & conditions*</span></label></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><input class="col-md-1 col-xs-12" type="checkbox" name="check2" id="field_check2" value="true" ng-model="vm.updateCheck.check2"> <label class="col-md-11 col-xs-12" for="field_check2" style="font-size:12px">I confirm my consent to the processing of my personal data for marketing purposes, consisting in commercial offers sent via email</label></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><input class="col-md-1 col-xs-12" type="checkbox" name="check3" id="field_check3" value="true" ng-model="vm.updateCheck.check3"> <label class="col-md-11 col-xs-12" for="field_check3" style="font-size:12px">I confirm my consent to automated processing of my personal data, by means of profiling, in order to receive commercial offers customized on the basic of my browsing and purchasing behavior</label></div></div></div></div><div class="modal-footer"><button ng-click="vm.save()" ng-disabled="termsForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/dashboards/old-home/performances.html','<h1 class="page-title" translate="performances.title"></h1><div class="row" ng-if="vm.domains.length > 1"><div class="col-sm-3 col-md-4" style="padding: 3px"><ui-select on-select="vm.selectOne($item)" ng-model="vm.domain" theme="bootstrap"><ui-select-match ng-click="vm.fleet=null" placeholder="Select a domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><iframe height="{{vm.frameHeight}}" width="100%" style="border: 0" src="{{vm.grafanaTrusted}}"></iframe>');
$templateCache.put('app/dashboards/performance/performance.html','<div class="app-content-body" ng-cloak><jhi-alert></jhi-alert><dashboard-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" show-condition="false" condition="vm.selectedCondition"></dashboard-filter><div class="row" ng-if="vm.selectedFleets.length > 1"><!--{{vm.dashboards[\'performanceFrame\'].url}}--><dashboard name="performanceFrame" fleet="vm.fleet" object-type="vm.objectType" frame-height="1100px"></dashboard></div><div ng-if="vm.selectedFleets.length < 2"><h3>No objects associated, please contact your admin.</h3></div></div>');
$templateCache.put('app/dashboards/tab-objects-dashboard/tab-objects-dashboard-detail.html','<div class="app-content-body object-dashboard-detail-page ng-scope" ng-cloak><h1 class="page-title text-center"><div class="row"><div class="col-xs-12"><button type="submit" ng-click="vm.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></div><div><span translate="jotApp.tabObjects.detail.title"></span>:&nbsp; <span class="bigger">{{vm.tabObjects.objectUniqueCode}}</span></div><div><span>Name</span>:&nbsp; <span class="bigger">{{vm.tabObjects.objectName}}</span></div><div><span translate="jotApp.tabObjects.fleet">Fleet</span>:&nbsp; <span class="bigger">{{vm.tabObjects.fleet.fleetName}}</span></div><div ng-if="vm.warningDetail.warningName === \'\' && vm.licence.id !== 1"><span translate="jotApp.tabObjects.detail.lastEvent">Last Event</span>:&nbsp; <span class="bigger">{{vm.tabObjects.lastTick | date:\'dd/MM/yyyy HH:mm:ss\' }}</span></div><div ng-if="vm.warningDetail.warningName !== \'\'"><span translate="jotApp.tabObjects.detail.warning">Waning</span>:&nbsp; <span class="bigger">{{vm.warningDetail.warningName}}</span></div><div ng-if="vm.warningDetail.warningName !== \'\'"><span translate="jotApp.tabObjects.detail.period">Period</span>:&nbsp; <span class="bigger">{{vm.warningDetail.warningDateFrom | date:\'dd/MM/yyyy HH:mm:ss\' }} - {{vm.warningDetail.warningDateTo | date:\'dd/MM/yyyy HH:mm:ss\' }}</span></div></h1><hr><div class="row" ng-if="vm.warningDetail.warningName === \'\' &&  (vm.licence.id === 4 || vm.licence.id === 3)"><uib-accordion><div uib-accordion-group class="panel-default" is-open="vm.isOpen"><uib-accordion-heading><div class="time-range-acc-heading"><button ng-class="{disabled: vm.prevBtnDisabled}" ng-click="vm.prev($event)" class="btn btn-primary" ng-disabled="vm.prevBtnDisabled"><span class="glyphicon glyphicon-arrow-left"></span></button><div class="text-center heading-text"><i class="fa fa-clock-o"></i> {{vm.dashboardRange}} <button class="btn btn-primary"><span class="glyphicon glyphicon-search"></span></button></div><button ng-class="{disabled: vm.nextBtnDisabled === 0}" ng-click="vm.next($event)" class="btn btn-primary" ng-disabled="vm.nextBtnDisabled === 0"><span class="glyphicon glyphicon-arrow-right"></span></button></div></uib-accordion-heading><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-6"><label class="range">Time range</label><div class="input-group" id="range"><span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span> <input type="text" id="start" class="form-control" name="start" ng-click="vm.picker.start=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.fromCalendarDate" is-open="vm.picker.start" ng-change="vm.onChangeFromDate()" datepicker-options="vm.fromDateOptions" required> <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span> <input type="text" id="end" class="form-control" name="end" ng-click="vm.picker.end=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.toCalendarDate" ng-change="vm.onChangeToDate()" is-open="vm.picker.end" datepicker-options="vm.toDateOptions" required></div><br><br><button type="submit" ng-click="vm.applyFilterDate($event)" class="btn btn-primary"><span>&nbsp;Apply</span></button></div><div class="col-xs-6 portlet light bordered"><label class="range">Quick ranges</label><table><tr ng-repeat="options in vm.rangeOptions"><td class="dl-horizontal"><a ng-click="vm.changeRange(options.column1)">{{options.column1.display}}</a></td><td class="dl-horizontal"><a ng-click="vm.changeRange(options.column2)">{{options.column2.display}}</a></td><td class="dl-horizontal"><a ng-click="vm.changeRange(options.column3)">{{options.column3.display}}</a></td><td class="dl-horizontal"><a ng-click="vm.changeRange(options.column4)">{{options.column4.display}}</a></td></tr></table></div></div></div></form></div></div></div></div></uib-accordion></div><div class="row" ng-if="vm.dashboardType.length > 0" id="dashboardType" has-authority="ROLE_TECH"><dashboard name="{{vm.dashboardType}}" object-type="vm.tabObjects.objectType" object-unique-code="vm.tabObjects.objectUniqueCode" from-date="vm.fromDate" to-date="vm.toDate" frame-height="2710px;"></dashboard></div><div ng-if="vm.dashboardType.length > 0" class="row" evaluate-authorities="!ROLE_TECH || ROLE_ADMIN"><!--{{vm.dashboards[\'performanceFrame\'].url}}--><dashboard name="{{vm.dashboardType}}L" fleet="vm.fleet" object-type="vm.tabObjects.objectType" object-unique-code="vm.tabObjects.objectUniqueCode" from-datel="vm.fromDate" to-datel="vm.toDate" frame-height="2710px;"></dashboard></div></div>');
$templateCache.put('app/dashboards/tab-objects-dashboard/tab-objects-dashboard-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabObjects.dashboard.editLabel" translate-values="{param: \'{{vm.tabObjects.objectUniqueCode}}\'}">Create or edit a Object</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12" ng-show="false"><div class="form-group"><label for="id" translate="global.field.id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.tabObjects.id" readonly="readonly"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectName" for="field_objectName">Object Name</label> <input type="text" class="form-control" name="objectName" id="field_objectName" ng-model="vm.tabObjects.objectName" required ng-maxlength="50"><div ng-show="editForm.objectName.$invalid"><p class="help-block" ng-show="editForm.objectName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.objectName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12" ng-if="vm.licence.id !== 1"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.condition" for="field_condition">Condition</label><ui-select id="field_condition" name="condition" ng-model="vm.tabObjects.condition" theme="bootstrap" search-enabled="false" required><ui-select-match placeholder="Select a condition..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectsConditions"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.condition.$invalid"><p class="help-block" ng-show="vm.editForm.condition.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectDescription" for="field_objectDescription">Object Description</label> <input type="text" class="form-control" name="objectDescription" id="field_objectDescription" ng-model="vm.tabObjects.objectDescription" ng-maxlength="255"><div ng-show="editForm.objectDescription.$invalid"><p class="help-block" ng-show="editForm.objectDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectNotes" for="field_objectNotes">Object Notes</label> <input type="text" class="form-control" name="objectNotes" id="field_objectNotes" ng-model="vm.tabObjects.objectNotes" ng-maxlength="10000"><div ng-show="editForm.objectNotes.$invalid"><p class="help-block" ng-show="editForm.objectNotes.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLatitude" for="field_objectLatitude">Object Latitude</label> <input type="text" class="form-control" name="objectLatitude" id="field_objectLatitude" ng-model="vm.tabObjects.objectLatitude" ng-maxlength="50" ng-change="vm.onChangeCoordsFunction()" ng-pattern="/^([-+]?)([\\d]{1,2})(((\\.)(\\d+)))$/"><div ng-show="editForm.objectLatitude.$invalid"><p class="help-block" ng-show="editForm.objectLatitude.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.objectLatitude.$error.pattern">This field can only contain number in format 12.12345 with optional [-]</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLongitude" for="field_objectLongitude">Object Longitude</label> <input type="text" class="form-control" name="objectLongitude" id="field_objectLongitude" ng-model="vm.tabObjects.objectLongitude" ng-maxlength="50" ng-change="vm.onChangeCoordsFunction()" ng-pattern="/^(([-+]?)([\\d]{1,3})((\\.)(\\d+))?)$/"><div ng-show="editForm.objectLongitude.$invalid"><p class="help-block" ng-show="editForm.objectLongitude.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.objectLongitude.$error.pattern">This field can only contain number in format 123.12345 with optional [-]</p></div></div></div></div><div class="row" ng-if="vm.tabObjects.fieldLongitude != null && vm.tabObjects.fieldLatitude != null"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.fieldLatitude" for="field_latitude">Field Latitude</label> <input ng-readonly="vm.tabObjects.fieldLatitude" type="text" class="form-control" name="fieldLatitude" id="field_latitude" ng-model="vm.tabObjects.fieldLatitude" required ng-maxlength="50"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.fieldLongitude" for="field_longitude">Field Longitude</label> <input ng-readonly="vm.tabObjects.fieldLongitude" type="text" class="form-control" name="fieldLongitude" id="field_longitude" ng-model="vm.tabObjects.fieldLongitude" required ng-maxlength="50"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLocation" for="field_objectLocation">Object Location</label> <input type="text" class="form-control" name="objectLocation" id="field_objectLocation" ng-model="vm.tabObjects.objectLocation" ng-maxlength="250" ng-change="vm.onChangeAddressFunction()" ng-model-options="{debounce:1500}"><div ng-show="editForm.objectLocation.$invalid"><p class="help-block" ng-show="editForm.objectLocation.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer then 250 characters.</p></div></div></div><div class="col-md-6 col-xs-12" ng-if="vm.timeZone.length != 0"><div class="form-group"><label translate="jotApp.tabObjects.zone" for="field_zone">Time Zone</label><ui-select id="field_zone" name="zone" ng-model="vm.tabObjects.timeZone" theme="bootstrap" required><ui-select-match placeholder="Select a time zone..">{{$select.selected.timeZone}}</ui-select-match><ui-select-choices repeat="item in vm.timeZone | filter: {timeZone: $select.search}"><div ng-bind-html="item.timeZone | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.zone.$invalid"><p class="help-block" ng-show="vm.editForm.zone.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-12 col-xs-12"><div id="map_canvas" style="height: 250px"></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/dashboards/tab-objects-dashboard/tab-objects-dashboard-map.html','<div class="row"><div class="col-xs-12"><button type="submit" ng-click="vm.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></div><br><dashboard-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" show-condition="false" condition="vm.selectedCondition"></dashboard-filter><div id="object-map" ng-style="vm.mapStyle"></div><!--<button type="submit" onclick="window.history.back()" class="btn btn-info m-l">--><!--<span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span>--><!--</button>-->');
$templateCache.put('app/dashboards/tab-objects-dashboard/tab-objects-dashboard.html','<div class="ng-scope" ng-cloak><jhi-alert></jhi-alert><dashboard-filter filter="vm.applyFilter(fleet, objectType, condition)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" condition="vm.selectedCondition" remove-option-all="false" show-condition="true" ng-if="$root.licence.id !== 1"></dashboard-filter><dashboard-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" ng-if="$root.licence.id === 1"></dashboard-filter><div class="full-page-loader-container" ng-if="!vm.pageReady"><div class="loader"></div></div><div ng-style=" !vm.pageReady && {\'visibility\':\'hidden\'}"><table id="tableToExport"><thead><tr ng-show="false"><th><span>Status</span></th><th ng-if="vm.licence.id === 4 || vm.licence.id === 3"><span translate="jotApp.tabObjects.warnings">Warnings</span></th><th><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span></th><th><span translate="jotApp.tabObjects.objectName">Object Name</span></th><th><span translate="jotApp.tabObjects.fleet">Fleet</span></th><th><span translate="jotApp.tabObjects.objectType">Type</span></th><th ng-if="vm.licence.id !== 1"><span translate="jotApp.tabObjects.condition">Condition</span></th><th><span translate="jotApp.tabObjects.objectDescription">Object Description</span></th><th><span translate="jotApp.tabObjects.objectNotes">Object Notes</span></th><th ng-if="vm.licence.id !== 1"><span translate="jotApp.tabObjects.dashboard.lastTick">Last Event</span></th><th ng-repeat="metricName in vm.tabObjectsToExport[0].metricList"><span>{{metricName}}</span></th></tr></thead><tbody><tr ng-repeat="tabObjectsToExport in vm.tabObjectsToExport track by tabObjectsToExport.id" ng-show="false"><td ng-class="vm.parseStatusClass(tabObjectsToExport)" ng-bind="vm.parseStatus(tabObjectsToExport)"></td><td ng-if="vm.licence.id === 4 ||  vm.licence.id === 3">{{tabObjectsToExport.warningCount}}</td><td>{{tabObjectsToExport.objectUniqueCode}}</td><td>{{tabObjectsToExport.objectName}}</td><td>{{tabObjectsToExport.fleet.fleetName}}</td><td>{{tabObjectsToExport.objectType.objectTypeName}}</td><td ng-if="vm.licence.id !== 1">{{tabObjectsToExport.condition.name}}</td><td>{{tabObjectsToExport.objectDescription}}</td><td>{{tabObjectsToExport.objectNotes}}</td><td ng-if="vm.licence.id !== 1">{{tabObjectsToExport.lastTick | nullable : \'Never\' : true | date :\'dd MMM yyyy h:mm:ss a\'}}</td><td ng-repeat="metricName in vm.tabObjectsToExport[0].metricList">{{tabObjectsToExport.metric[metricName]}}</td></tr></tbody></table><div class="row" ng-if="vm.licence.id !== 1"><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><a href="javascript:;" ng-click="vm.filterBy(0)" ng-class="vm.listFilter == 0 ? \'\' : \'active\'" class="dashboard-stat dashboard-stat-v2 bg-online"><div class="visual"><i class="fa fa-cloud"></i></div><div class="details"><div class="number">{{vm.objectCounting.online + vm.objectCounting.offlineTracked}}</div><div class="desc">Online</div></div></a></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><a href="javascript:;" ng-click="vm.filterBy(1)" ng-class="vm.listFilter == 1 ? \'\' : \'active\'" class="dashboard-stat dashboard-stat-v2 bg-offline"><div class="visual"><i class="fa fa-times"></i></div><div class="details"><div class="number">{{vm.objectCounting.offline}}</div><div class="desc">Offline</div></div></a></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" ng-if="vm.licence.id === 4 ||  vm.licence.id === 3"><a href="javascript:;" ng-click="vm.filterBy(2)" ng-class="vm.listFilter == 2 ? \'\' : \'active\'" class="dashboard-stat dashboard-stat-v2 bg-warning"><div class="visual"><i class="fa fa-exclamation-triangle"></i></div><div class="details"><div class="number">{{vm.objectCounting.warning}}</div><div class="desc">Warning</div></div></a></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><a ui-sref="tab-objects-map({fleet:vm.selectedFleet.id,objectType:vm.selectedObjectType.id})" ng-class="vm.listFilter == 3 ? \'\' : \'active\'" class="dashboard-stat dashboard-stat-v2 dashboard-stat-no-number bg-map"><div class="visual"><i class="fa fa-map-marker"></i></div><div class="details"><div class="number" evaluate-authorities="ROLE_ADMIN">{{vm.objectCounting.online + vm.objectCounting.offline}} / {{vm.objectCounting.online + vm.objectCounting.offline + vm.objectCounting.offlineTracked}}</div><div class="hidden-number number" evaluate-authorities="!ROLE_ADMIN">0</div><div class="desc">Object Map</div></div></a></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-2" ng-if="vm.licence.id === 4 || vm.licence.id === 3"><div class="dataTables_length"><label><select ng-model="vm.filterStatus" ng-change="vm.loadAll()" class="form-control input-sm input-inline" style="width: 150px;"><option value="-1">All Status</option><option value="0">Muted</option><option value="1">Unmuted</option></select></label></div></div><div ng-if="vm.listFilter == 1" class="col-sm-4"><div class="dataTables_length"><label><select ng-model="vm.filterUntracked" ng-init="vm.filterUntracked=\'-1\'" ng-change="vm.loadAll()" class="form-control input-sm input-inline" style="width: 150px;"><option value="-1">All Status</option><option value="0">Untracked</option><option value="1">Offline</option></select></label></div></div><div ng-if="vm.listFilter == 2" class="col-sm-2"><div class="dataTables_length"><label><select ng-model="vm.filterUntracked" ng-init="vm.filterUntracked=\'-1\'" ng-change="vm.loadAll()" class="form-control input-sm input-inline" style="width: 150px;"><option value="-1">All Status</option><option value="0">Online</option><option value="1">Offline</option></select></label></div></div><div ng-if="vm.listFilter == 2" class="col-sm-3" ng-if="vm.licence.id !== 1"><div class="dataTables_length"><label><select ng-model="vm.filterWip" ng-init="vm.filterWip=\'-1\'" ng-change="vm.loadAll()" class="form-control input-sm input-inline" style="width: 190px;"><option value="-1">All Process Status</option><option value="0">Completely Unprocessed</option><option value="1">Partial Processed</option><option value="2">Completely Processed</option></select></label></div></div><div class="col-sm-4 aside-right"><div class="dataTables_filter"><label><input class="input-large" ng-model-options="{ debounce: 800 }" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Code, Name, Description or Notes"></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView" hide-column="vm.hide"><thead><tr multi-sort="vm.predicates" callback="vm.transition()" column-to-hide="header"><th ng-if="vm.licence.id !== 1"><span>Status</span></th><th multi-sort-by="warningCount" uib-tooltip="Click on badge to show warnings" tooltip-placement="top" tooltip-append-to-body="true" column-to-hide="Warnings" class="warnings-table-header" ng-if="vm.licence.id === 4 || vm.licence.id === 3"><span translate="jotApp.tabObjects.warnings">Warnings</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectUniqueCode" column-to-hide="Code"><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectName" column-to-hide="Name"><span translate="jotApp.tabObjects.objectName">Object Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fleet.fleetName" column-to-hide="Fleet"><span translate="jotApp.tabObjects.fleet">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectType.objectTypeName" column-to-hide="Type"><span translate="jotApp.tabObjects.objectType">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="conditions.name" column-to-hide="Condition" ng-if="vm.licence.id !== 1"><span translate="jotApp.tabObjects.condition">Condition</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectDescription" column-to-hide="Description"><span translate="jotApp.tabObjects.objectDescription">Object Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectNotes" column-to-hide="Notes"><span translate="jotApp.tabObjects.objectNotes">Object Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-if="vm.licence.id !== 1" multi-sort-by="lastTick" column-to-hide="LastEvent"><span translate="jotApp.tabObjects.dashboard.lastTick">Last Event</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-repeat="metricName in vm.tabObjects[0].metricList" column-to-hide="Metrics"><span>{{metricName | capitalize}}</span></th><th class="actions-table-header"><div class="btn-group"><span class="dropdown-toggle glyphicon glyphicon-eye-open object-icon-action no-outline no-bg" data-toggle="dropdown" title="Show/Hide Columns"></span><ul class="dropdown-menu hide-column-wrapper" role="menu" hide-column-menu="dashboardColumn"></ul></div><div class="btn-group"><span class="dropdown-toggle glyphicon glyphicon-save-file object-icon-action no-outline no-bg" data-toggle="dropdown" title="Export" ng-click="vm.loadAllToExport()"></span><ul class="dropdown-menu" role="menu"><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'json\',escape:\'false\'});"><!--<img src="./content/images/json.png" width="24px"> JSON--> <i class="fa fa-file-code-o"></i> JSON</a></li><li class="divider"></li><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'xml\',escape:\'false\'});"><!--<img src="./content/images/xml.png" width="24px"> XML--> <i class="fa fa-file-text-o"></i> XML</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'csv\')"><!--<img src="./content/images/csv.png" width="24px"> CSV (all elements)--> <i class="fa fa-file-zip-o"></i> CSV (all elements)</a></li><li><a href="" ng-click="vm.exportTableView(\'csv\')"><!--<img src="./content/images/csv.png" width="24px"> CSV (only view)--> <i class="fa fa-file-zip-o"></i> CSV (only view)</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><!--<img src="./content/images/excel.png" width="24px"> XLS (all elements)--> <i class="fa fa-file-excel-o"></i> XLS (all elements)</a></li><li><a href="" ng-click="vm.exportTableView(\'excel\')"><!--<img src="./content/images/excel.png" width="24px">XLS (only view)--> <i class="fa fa-file-excel-o"></i> XLS (only view)</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'pdf\')"><!--<img src="./content/images/pdf.png" width="24px"> PDF (all elements)--> <i class="fa fa-file-pdf-o"></i> PDF (all elements)</a></li><li><a href="" ng-click="vm.exportTableView(\'pdf\')"><!--<img src="./content/images/pdf.png" width="24px"> PDF (only view)--> <i class="fa fa-file-pdf-o"></i> PDF (only view)</a></li></ul></div></th></tr></thead><tbody><tr ng-repeat="tabObjects in vm.tabObjects track by tabObjects.id"><!--<i class="fa fa-circle object-online-led" ng-class="{working: tabObjects.working}" ng-style="{color: tabObjects.objectOnline  ? \'#27c24c\' : \'#98a6ad\'}"></i>--><!--                                    <td ng-class="vm.parseStatusClass(tabObjects)" ng-bind="vm.parseStatus(tabObjects)">--><td class="text-center" ng-if="vm.licence.id !== 1"><div class="badge custom-badge no-text-badge" ng-class="((tabObjects.objectOnline && tabObjects.objectTracked)  ? \'bg-online\' : ((tabObjects.objectOnline && !tabObjects.objectTracked) ?  \'bg-untracked\' : \'bg-offline\' ))"></div><span style="display:none;">{{vm.parseStatus(tabObjects)}}</span></td><td ng-mouseenter="vm.tooltip=true" ng-mouseleave="vm.tooltip=false" class="td-link text-center warnings-table-header" column-to-hide="Warnings" ui-sref="warnings-list({search:tabObjects.objectUniqueCode})" ng-if="vm.licence.id === 4 || vm.licence.id === 3"><div class="btn" ng-class="vm.parseWarningLevel(tabObjects.warningLevel)"><i class="fa fa-search"></i> {{tabObjects.warningCount}}</div></td><td column-to-hide="Code"><b>{{tabObjects.objectUniqueCode}}</b></td><td column-to-hide="Name" ng-bind-html="tabObjects.objectName | highlight: vm.charToSearch"></td><td column-to-hide="Fleet">{{tabObjects.fleet.fleetName}}</td><td column-to-hide="Type">{{tabObjects.objectType.objectTypeName}}</td><td column-to-hide="Condition" ng-if="vm.licence.id !== 1">{{tabObjects.condition.name}}</td><td column-to-hide="Description" ng-bind-html="tabObjects.objectDescription | highlight: vm.charToSearch"></td><td column-to-hide="Notes" ng-bind-html="tabObjects.objectNotes | highlight:vm.charToSearch"></td><td column-to-hide="LastEvent" ng-if="vm.licence.id !== 1"><span>{{tabObjects.lastTick | nullable : \'Never\' : true | date :\'dd MMM yyyy h:mm:ss a\'}}</span></td><td ng-repeat="metricName in vm.tabObjects[0].metricList" column-to-hide="Metrics"><span>{{tabObjects.metric[metricName]}}</span></td><td class="text-center"><div class="btn-group flex-btn-group-container"><span class="object-icon-action no-outline" ng-show="(tabObjects.warningCount > 0)" ng-class="(tabObjects.wipStatus == 0) ? \'color-mindscape\' : \'color-gray\' " ng-click="vm.wipStatus(tabObjects, $index)" title="{{vm.showStatusWrench(tabObjects.wipStatus)}}" ng-if="vm.licence.id !== 1"><i ng-class="(tabObjects.wipStatus == 1) ? \'iconAlert icon-wrench\' : \'fa fa-wrench\' "></i> </span><span class="object-icon-action no-outline" ng-class="(!tabObjects.objectMuted) ? \'color-mindscape\' : \'color-gray\' " ng-click="vm.muteStatus(tabObjects)" title="{{vm.showStatus(tabObjects.objectMuted)}}" ng-if="vm.licence.id !== 1"><i ng-class="tabObjects.objectMuted ? \'glyphicon glyphicon-volume-off\' : \'glyphicon glyphicon-volume-up\'"></i> </span><span ui-sref="tab-objects-dashboard-edit({id:tabObjects.id})" class="object-icon-action no-outline" title="Edit"><i class="glyphicon glyphicon-pencil"></i> </span><span ui-sref="tab-objects-dashboard-detail({id:tabObjects.id,uniqueCode:tabObjects.objectUniqueCode , fleet:tabObjects.fleet.id, objType: tabObjects.objectType.id})" class="object-icon-action no-outline" title="Details"><i class="glyphicon glyphicon-zoom-in"></i> </span><span ui-sref="action-commands({id:tabObjects.id})" class="object-icon-action no-outline" title="Commands" ng-if="vm.licence.id !== 1"><i class="glyphicon glyphicon-th"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/dashboards/tab-objects-dashboard/tab-objects-wip-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="vm.object.wipStatus == 0" translate="jotApp.warning.wip.questionAll" translate-values="{objectUniqueCode: \'{{vm.object.objectUniqueCode}}\'}"></p><p ng-show="vm.object.wipStatus > 0" translate="jotApp.warning.wip.questionUnprocessedAll" translate-values="{objectUniqueCode: \'{{vm.object.objectUniqueCode}}\'}"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/dashboards/warning-dashboard/warning-dashboard-detail.html','<div class="app-content-body"><h1 class="page-title"><div class="row"><div class="col-xs-12"><button type="submit" ng-click="vm.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span>{{vm.titlePage}}</span>:&nbsp; <span class="bigger">{{vm.detail}}</span></div></div></h1><div class="row" ng-if="vm.frame.length > 0"><dashboard name="{{vm.frame}}" fleet="vm.fleetId" object-type="vm.objectType" object-unique-code="vm.objectUniqueCode" warning-category="vm.warningCategory" warning-name="vm.warningName" frame-height="800px;"></dashboard></div></div>');
$templateCache.put('app/dashboards/warning-dashboard/warning-dashboard.html','<div class="app-content-body" ng-cloak><jhi-alert></jhi-alert><dashboard-filter filter="vm.applyFilter(fleet,objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" show-condition="false" condition="vm.selectedCondition"></dashboard-filter><div class="row"><div class="col-xs-12 col-sm-6 col-md-3"><div class="dashboard-stat dashboard-stat-v2 bg-online"><div class="visual"><i class="fa fa-cloud"></i></div><div class="details"><div class="number">{{vm.objectCounting.online}}</div><div class="desc" translate="jotApp.warning.dashboard.online">Online</div></div></div><div class="dashboard-stat dashboard-stat-v2 bg-offline"><div class="visual"><i class="fa fa-times"></i></div><div class="details"><div class="number">{{vm.objectCounting.offline}}</div><div class="desc" translate="jotApp.warning.dashboard.offline">Offline</div></div></div><div class="dashboard-stat dashboard-stat-v2 bg-warning"><div class="visual"><i class="fa fa-exclamation-triangle"></i></div><div class="details"><div class="number">{{vm.objectCounting.warning}}</div><div class="desc" translate="jotApp.warning.dashboard.warning">Warning</div></div></div></div><div class="col-xs-12 col-sm-6 col-md-9"><div id="warning-map" class="inline-map"></div></div></div><br><div class="dataTables_wrapper no-footer" ng-if="vm.selectedFleets.length > 1"><h3 translate="jotApp.warning.dashboard.top10">Top Object with warning</h3><div class="kibana-table"><table ng-table="vm.tableTopParams" class="table table-hover order-column dataTable no-footer" id="topTenView"><tr class="tr-link" ng-repeat="topObjects in $data track by topObjects.objectUniqueCode"><td title="\'Object Unique Code\'" sortable="\'name\'">{{topObjects.objectUniqueCode}}</td><td title="\'Object Name\'" sortable="\'name\'">{{topObjects.objectName}}</td><td title="\'Object Type\'" sortable="\'objectType\'">{{topObjects.objectType}}</td><td title="\'Fleet\'" sortable="\'fleetName\'">{{topObjects.fleetName}}</td><td title="\'Count\'" sortable="\'occurrence\'"><span class="td-link" ui-sref="warning-dashboard-detail(\n                                                            {frame: \'objectDetailFrame\',\n                                                            titlePage: \'Object Name\',\n                                                            fleetId: (vm.selectedFleet && vm.selectedFleet.id !== -1) ? vm.selectedFleet.id : undefined,\n                                                            objectType: (vm.selectedObjectType && vm.selectedObjectType.id !== -1) ? vm.selectedObjectType.objectTypeName : undefined,\n                                                            objectUniqueCode: topObjects.objectUniqueCode,\n                                                            detail: topObjects.objectUniqueCode\n                                                            })"><i class="fa fa-search-plus" aria-hidden="true"></i></span> {{topObjects.occurrence}}</td></tr></table></div></div><br><div class="row" ng-if="vm.selectedFleets.length > 1"><dashboard name="warningFrame" fleet="vm.fleet" object-type="vm.objectType" frame-height="1400px;"></dashboard></div><br><div class="dataTables_wrapper no-footer" ng-if="vm.selectedFleets.length > 1"><h3 translate="jotApp.warning.dashboard.topWarningName">Top Warning Name</h3><div class="kibana-table"><table ng-table="vm.tableNameParams" class="table kibana-table table-hover order-column dataTable no-footer" id="warningView"><tr class="tr-link" ng-repeat="topName in $data track by topName.name"><td title="\'Warning Name\'" sortable="\'name\'">{{topName.name}}</td><td title="\'Count\'" sortable="\'occurrence\'"><span class="td-link" ui-sref="warning-dashboard-detail(\n                                                            {frame: \'warningDetailFrame\',\n                                                            titlePage: \'Warning Name\',\n                                                            fleetId: (vm.selectedFleet && vm.selectedFleet.id !== -1) ? vm.selectedFleet.id : undefined,\n                                                            objectType: (vm.selectedObjectType && vm.selectedObjectType.id !== -1) ? vm.selectedObjectType.objectTypeName : undefined,\n                                                            warningCategory: topName.category,\n                                                            warningName: topName.name,\n                                                            detail: topName.name\n                                                            })"><i class="fa fa-search-plus" aria-hidden="true"></i></span> {{topName.occurrence}}</td><td title="\'Average Level\'" sortable="\'level\'">{{topName.level}}</td><td title="\'Category\'" sortable="\'category\'"><span class="td-link" ui-sref="warning-dashboard-detail(\n                                                            {frame: \'categoryFrame\',\n                                                            titlePage: \'Average Level\',\n                                                            fleetId: (vm.selectedFleet && vm.selectedFleet.id !== -1) ? vm.selectedFleet.id : undefined,\n                                                            objectType: (vm.selectedObjectType && vm.selectedObjectType.id !== -1) ? vm.selectedObjectType.objectTypeName : undefined,\n                                                            warningCategory: topName.category,\n                                                            detail: topName.category\n                                                            })"><i class="fa fa-search-plus" aria-hidden="true"></i></span> {{topName.category}}</td></tr></table></div></div><div ng-if="vm.selectedFleets.length < 2"><h3>No objects associated, please contact your admin.</h3></div></div>');
$templateCache.put('app/dashboards/warnings-list/warning-list-wip-dialog.html','<form name="stopForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="!vm.warning.wip" translate="jotApp.warning.wip.question" translate-values="{objectUniqueCode: \'{{vm.warning.objectUniqueCode}}\', warningName: \'{{warning.name}}\'}"></p><p ng-show="vm.warning.wip" translate="jotApp.warning.wip.questionUnprocessed" translate-values="{objectUniqueCode: \'{{vm.warning.objectUniqueCode}}\', warningName: \'{{warning.name}}\'}"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/dashboards/warnings-list/warnings-list-detail.html','<div class="ng-scope"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span class="warnings-detail-font-title">Warning name:</span><span class="warnings-detail-font-title-content">{{vm.filter.warningName}}</span> <span class="warnings-detail-font-title">Unique Code: </span><span class="warnings-detail-font-title-content">{{vm.filter.warningObjectCode}}</span> <span class="warnings-detail-font-title">Fleet: </span><span class="warnings-detail-font-title-content">{{vm.filter.warningFleet}}</span></h1></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable">{{vm.field}}<table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr><th><span translate="jotApp.warning.dashboard.category">Category</span></th><th><span translate="jotApp.warning.name">Name</span></th><th><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span></th><th><span translate="jotApp.warning.objectName">Object Name</span></th><th><span translate="jotApp.tabObjects.fleet">Fleet</span></th><th><span translate="jotApp.warning.level">Level</span></th><th><span translate="jotApp.warning.dashboard.status">Close</span></th><th><span translate="jotApp.warning.description">Description</span></th><th><span translate="jotApp.warning.dashboard.dateOpen">Date Open</span></th><th ng-show="vm.showClose"><span translate="jotApp.warning.dashboard.dateClose">Date Close</span></th><th><span translate="entity.action.actionLabel">Actions</span></th></tr></thead><tbody><tr class="tr-link" ng-repeat="warning in vm.warning"><td>{{warning.category}}</td><td>{{warning.name}}</td><td>{{warning.objectUniqueCode}}</td><td>{{warning.objectName}}</td><td>{{warning.fleetName}}</td><td class="text-center"><div class="badge custom-badge" ng-class="vm.parseWarningLevel(warning.critical)">{{warning.critical}}</div></td><td>{{warning.status}}</td><td>{{warning.description}}</td><td>{{warning.date | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td ng-show="vm.showClose">{{warning.dateClose | nullable | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td class="text-center"><div class="btn-group"><span type="submit" ng-click="vm.showDetail(warning)" class="object-icon-action no-outline color-mindscape" title="Detail"><i class="fa fa-line-chart"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/dashboards/warnings-list/warnings-list.html','<div class="ng-scope"><jhi-alert></jhi-alert><table id="tableToExport"><thead><tr ng-show="false"><th><span translate="jotApp.warning.dashboard.category">Category</span></th><th><span translate="jotApp.warning.name">Name</span></th><th><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span></th><th><span translate="jotApp.tabObjects.objectName">Object Name</span></th><th><span translate="jotApp.tabObjects.fleet">Fleet</span></th><th><span translate="jotApp.warning.level">Level</span></th><th><span translate="jotApp.warning.dashboard.status">Close</span></th><th><span translate="jotApp.warning.description">Description</span></th><th><span translate="jotApp.warning.dashboard.dateOpen">Date Open</span></th><th ng-if="vm.showClose"><span translate="jotApp.warning.dashboard.dateClose">Date Close</span></th></tr></thead><tbody><tr ng-repeat="warning in vm.tabObjectsToExport" ng-show="false"><td>{{warning.category}}</td><td>{{warning.name}}</td><td>{{warning.objectUniqueCode}}</td><td>{{warning.objectName}}</td><td>{{warning.fleetName}}</td><td><span ng-class="vm.parseWarningLevel(warning.critical)">{{warning.critical}}</span></td><td>{{warning.status}}</td><td>{{warning.description}}</td><td>{{warning.date | date:\'yyyy-MM-dd\'}}</td><td ng-show="vm.showClose">{{warning.dateClose | nullable | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table><div class="row"><div class="col-xs-12"><h3 class="page-title">Apply filters to your Warning History</h3></div></div><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form no-action-border"><form ng-submit="vm.applyWarningFilter()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label ng-scope" translate="jotApp.myDomainNotification.tabFleets" for="field_tabFleets">Fleet</label><div ng-dropdown-multiselect="" name="tabFleets" required id="field_tabFleets" options="vm.fleetOptions" selected-model="vm.filter.fleets" extra-settings="vm.fleetListSettings" translation-texts="vm.fleetListSettings" events="vm.fleetListEvent"></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="objectsStatus">Objects Status</label> <select class="form-control" id="objectsStatus" name="objectsStatus" ng-model="vm.filter.objectsStatus" chosen disable-search="true"><option label="ALL" value="all">ALL</option><option label="ONLINE" value="online">ONLINE</option><option label="OFFLINE" value="offline">OFFLINE</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="status">Status</label> <select class="form-control" id="status" name="status" ng-model="vm.filter.status" chosen disable-search="true"><option label="OPEN" value="open">OPEN</option><option label="CLOSE" value="close">CLOSE</option><option label="ALL" value="all">ALL</option></select></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label ng-scope" translate="jotApp.myDomainNotification.warningCategories" for="field_warning_category">Warning Category</label><div ng-dropdown-multiselect="" id="field_warning_category" options="vm.categoryOptions" selected-model="vm.filter.categories" required extra-settings="vm.categoryListSettings" translation-texts="vm.categoryListSettings" events="vm.categoryListEvent" disabled="vm.fleetEmpty == true"></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label ng-scope" translate="jotApp.myDomainNotification.warningNames" for="field_warning_name">Warning Name</label><div ng-dropdown-multiselect="" id="field_warning_name" options="vm.warningNameOptions" selected-model="vm.filter.warningNames" required extra-settings="vm.warningListSettings" translation-texts="vm.warningListSettings" events="vm.warningListEvent" disabled="vm.categoryEmpty == true"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="range">Range</label><div class="input-group" id="range"><span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span> <input type="text" id="start" class="form-control" ng-click="vm.picker.start=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.filter.start" is-open="vm.picker.start"> <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span> <input type="text" id="end" class="form-control" ng-click="vm.picker.end=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.filter.end" is-open="vm.picker.end"></div></div></div></div><!--<script>\n                                //var currentime= new Date();\n                                //var alarmtime = new Date(currentTime);\n                                //alarmtime.setHours(8,0,0);\n                                /*if(alarmtime > currentime){\n                                    console.log(document.getElementById(start).textContent = (new Date(currentime.getFullYear(),currentime.getMonth(),currentime.getDate() + 1)).toLocaleDateString(\'en-GB\'));\n                                    console.log(document.getElementById(start).textContent = (new Date(currentime.getFullYear(),currentime.getMonth(),currentime.getDate() + 1)).toLocaleDateString(\'en-GB\'));\n                                }\n                                else{\n                                    console.log(document.getElementById(start).textContent = (new Date(currentime.getFullYear(),currentime.getMonth(),currentime.getDate() + 1)).toLocaleDateString(\'en-GB\'));\n                                    console.log(document.getElementById(start).textContent = (new Date(currentime.getFullYear(),currentime.getMonth(),currentime.getDate() + 1)).toLocaleDateString(\'en-GB\'));\n                             */   }\n                            </script>--><div class="form-actions right"><button type="submit" class="btn btn-primary"><i class="fa fa-filter"></i> Filter</button></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><div class="btn-group"><button class="btn btn-outline dropdown-toggle" data-toggle="dropdown" ng-click="vm.loadAllToExport()"><i class="fa fa-bars"></i> Export</button><ul class="dropdown-menu" role="menu"><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'json\',escape:\'false\'});"><i class="fa fa-file-code-o"></i> JSON</a></li><li class="divider"></li><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'xml\',escape:\'false\'});"><i class="fa fa-file-text-o"></i> XML</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'csv\')"><i class="fa fa-file-zip-o"></i> CSV (all elements)</a></li><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'csv\',escape:\'false\', ignoreColumn:[9],tableName:\'Warnings\'});"><i class="fa fa-file-zip-o"></i> CSV (only view)</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS (all elements)</a></li><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'excel\',escape:\'false\', ignoreColumn:[9],tableName:\'Warnings\'});"><i class="fa fa-file-excel-o"></i> XLS (only view)</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF (all elements)</a></li><li><a href="" onclick="$(\'#tableView\').tableExport({type:\'pdf\',pdfFontSize:\'7\',escape:\'false\', ignoreColumn:[9],tableName:\'Warnings\',size:{0:50, 1: 105, 2: 90, 3: 90, 4: 100, 5: 35, 6: 50, 8: 92, 9: 105}});"><i class="fa fa-file-pdf-o"></i> PDF (only view)</a></li></ul></div></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-3"><div class="dataTables_length"></div></div><div class="col-sm-9"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchParams" placeholder="Search..." ng-change="vm.applySearch()"></label></div></div></div><div class="table-scrollable">{{vm.field}}<table class="table table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr multi-sort="vm.predicates" callback="vm.transition(true)"><th><span translate="jotApp.warning.dashboard.category">Category</span></th><th><span translate="jotApp.warning.name">Name</span></th><th><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span></th><th><span translate="jotApp.warning.objectName">Object Name</span></th><th><span translate="jotApp.tabObjects.fleet">Fleet</span></th><th><span translate="jotApp.warning.level">Level</span></th><th><span translate="jotApp.warning.dashboard.status">Close</span></th><th><span translate="jotApp.warning.description">Description</span></th><th multi-sort-by="date"><span translate="jotApp.warning.dashboard.dateOpen">Date Open</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.showClose" multi-sort-by="date_close"><span translate="jotApp.warning.dashboard.dateClose">Date Close</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="entity.action.actionLabel">Actions</span></th></tr></thead><tbody><tr class="tr-link" ng-repeat-start="warning in vm.warnings.warningName" ng-class="(vm.saveIndex($index)) ? \'warnings-row-bg-color-odd\' : \'warnings-row-bg-color-even\' "><td>{{warning.category}}</td><td>{{warning.name}}</td><td ng-bind-html="warning.objectUniqueCode | highlightCaseSensitive: vm.searchParams"></td><td ng-bind-html="warning.objectName | highlightCaseSensitive: vm.searchParams"></td><td>{{warning.fleetName}}</td><td class="text-center"><div class="badge custom-badge" ng-class="vm.parseWarningLevel(warning.critical)">{{warning.critical}}</div></td><td>{{warning.status}}</td><td ng-bind-html="warning.description | highlight: vm.searchParams"></td><td>{{warning.date | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td ng-show="vm.showClose">{{warning.dateClose | nullable | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td class="text-center"><div class="btn-group" ng-if="warning.count > 1"><i ng-if="!warning.expanded" class="fa fa-plus-square open-row-col" ng-click="vm.detail(warning)" title="Open Group"></i> <i ng-if="warning.expanded" class="fa fa-minus-square open-row-col" ng-click="vm.detail(warning)" title="Close Group"></i></div><div class="btn-group" ng-if="warning.count <= 1"><span ng-show="warning.status == \'open\'" class="no-outline" ng-class="!warning.wip ? \'color-mindscape\' : \'color-gray\' " ng-click="vm.wipStatus(warning)" title="{{vm.showStatus(warning.wip)}}"><i class="fa fa-wrench"></i> </span><span type="submit" ng-click="vm.showDetail(warning)" class="object-icon-action no-outline color-mindscape" title="Detail"><i class="fa fa-line-chart"></i></span></div></td></tr><tr ng-if="warning.expanded" ng-repeat="warningGroup in vm.warningsGroup" ng-class="(vm.indexColor % 2 == 0) ? \'warnings-row-bg-color-odd\' : \'warnings-row-bg-color-even\' "><td ng-if="$index != vm.seeMore" colspan="5"></td><td ng-if="$index != vm.seeMore" class="text-center"><div class="badge custom-badge" ng-class="vm.parseWarningLevel(warningGroup.critical)">{{warningGroup.critical}}</div></td><td ng-if="$index != vm.seeMore">{{warningGroup.status}}</td><td ng-if="$index != vm.seeMore">{{warningGroup.description}}</td><td ng-if="$index != vm.seeMore">{{warningGroup.date | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td ng-if="$index != vm.seeMore" ng-show="vm.showClose">{{warningGroup.dateClose | nullable | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td ng-if="$index != vm.seeMore"><div class="btn-group"><span ng-show="warning.status == \'open\'" class="no-outline" ng-class="!warning.wip ? \'color-mindscape\' : \'color-gray\' " ng-click="vm.wipStatus(warning)" title="{{vm.showStatus(warning.wip)}}"><i class="fa fa-wrench"></i> </span><span type="submit" ng-click="vm.showDetail(warning)" class="object-icon-action no-outline color-mindscape" title="Detail"><i class="fa fa-line-chart"></i></span></div></td><td ng-if="$index == vm.seeMore" colspan="11" class="text-center"><button type="submit" ng-click="vm.openSeeMore(warning)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">See More</span></button></td></tr><tr ng-if="false" ng-repeat-end=""></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/alert-rules/alert-rules-configuration.html','<div class="app-content-body detail-page warning-detail-page"><div class="modal-body"><h1 class="page-title"><span translate="jotApp.alertRules.configuration">Configuration</span> : {{vm.warning.name}}</h1><jhi-alert></jhi-alert><br><div class="row"><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><div class="dashboard-stat dashboard-stat-v2 alert-card channel-tile-modal"><div class="inner-wrapper"><br><span class="tile-title">Email</span><br><label class="switch"><input type="checkbox" ng-click="vm.toggleStatus(\'email\')" ng-checked="vm.email.active"> <span class="alert-toggle round"></span></label><div class="form-group" ng-show="vm.email.active"><label>Throttle Time</label><br><input style="width: 73px;height: 27px; color: black" name="throttle" ng-model="vm.email.throttle" type="number" min="0" max="59"> <select style="width: 103px;height: 27px; color: black" name="time" ng-model="vm.email.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="form-actions"><input ng-show="vm.email.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'email\', false)" value="Save"> <input ng-show="vm.email.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'email\', true)" value="Save for all"></div></div><div class="visual"><i class="iconAlert icon-envelope-regular"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><div class="dashboard-stat dashboard-stat-v2 alert-card channel-tile-modal"><span class="disable-help" tooltip-placement="left" uib-tooltip="Available only for JoT Carbon" ng-if="vm.licence.id !== 4">?</span><div class="col-xs-12 channel-tile-modal disable-overlay" ng-if="vm.licence.id !== 4"></div><div class="inner-wrapper"><br><span class="tile-title">Slack</span><br><label class="switch"><input type="checkbox" ng-if="vm.licence.id !== 4"> <input type="checkbox" ng-click="vm.toggleStatus(\'slack\')" ng-checked="vm.slack.active" ng-if="vm.licence.id === 4"> <span class="alert-toggle round"></span></label><div class="form-group" ng-show="vm.slack.active" ng-if="vm.licence.id === 4"><label>Throttle Time</label><br><input style="width: 73px;height: 27px; color: black" name="throttle" ng-model="vm.slack.throttle" type="number" min="0" max="59"> <select style="width: 103px;height: 27px; color: black" name="time" ng-model="vm.slack.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="form-actions" ng-if="vm.licence.id === 4"><input ng-show="vm.slack.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'slack\', false)" value="Save"> <input ng-show="vm.slack.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'slack\', true)" value="Save for all"></div></div><div class="visual"><i class="iconAlert icon-slack-brands"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><div class="dashboard-stat dashboard-stat-v2 alert-card channel-tile-modal"><span class="disable-help" tooltip-placement="left" uib-tooltip="Available only for JoT Carbon" ng-if="vm.licence.id !== 4">?</span><div class="col-xs-12 channel-tile-modal disable-overlay" ng-if="vm.licence.id !== 4"></div><div class="inner-wrapper"><br><span class="tile-title">Telegram</span><br><label class="switch"><input type="checkbox" ng-if="vm.licence.id !== 4"> <input type="checkbox" ng-click="vm.toggleStatus(\'telegram\')" ng-checked="vm.telegram.active" ng-if="vm.licence.id === 4"> <span class="alert-toggle round"></span></label><div class="form-group" ng-show="vm.telegram.active" ng-if="vm.licence.id === 4"><label>Throttle Time</label><br><input style="width: 73px;height: 27px; color: black" name="throttle" ng-model="vm.telegram.throttle" type="number" min="0" max="59"> <select style="width: 103px;height: 27px; color: black" name="time" ng-model="vm.telegram.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="form-actions" ng-if="vm.licence.id === 4"><input ng-show="vm.telegram.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'telegram\', false)" value="Save"> <input ng-show="vm.telegram.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'telegram\', true)" value="Save for all"></div></div><div class="visual"><i class="iconAlert icon-telegram"></i></div></div></div><div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"><div class="dashboard-stat dashboard-stat-v2 alert-card channel-tile-modal"><span class="disable-help" tooltip-placement="left" uib-tooltip="Available only for JoT Carbon" ng-if="vm.licence.id !== 4">?</span><div class="col-xs-12 channel-tile-modal disable-overlay" ng-if="vm.licence.id !== 4"></div><div class="inner-wrapper"><br><span class="tile-title">Webhook</span><br><label class="switch"><input type="checkbox" ng-if="vm.licence.id !== 4"> <input type="checkbox" ng-click="vm.toggleStatus(\'webhook\')" ng-checked="vm.webhook.active" ng-if="vm.licence.id === 4"> <span class="alert-toggle round"></span></label><div class="form-group" ng-show="vm.webhook.active" ng-if="vm.licence.id === 4"><label>Throttle Time</label><br><input style="width: 73px;height: 27px; color: black" name="throttle" ng-model="vm.webhook.throttle" type="number" min="0" max="59"> <select style="width: 103px;height: 27px; color: black" name="time" ng-model="vm.webhook.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="form-actions" ng-if="vm.licence.id === 4"><input ng-show="vm.webhook.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'webhook\', false)" value="Save"> <input ng-show="vm.webhook.active" class="btn btn-primary" type="button" ng-click="vm.saveThrottle(\'webhook\', true)" value="Save for all"></div></div><div class="visual"><i class="iconAlert icon-webhook"></i></div></div></div></div></div><div class="row" ng-show="vm.domain.enableAlerting"><div ng-show="!vm.domain.enableAlerting">Enable alerting in general settings page <a href="javascript:;" ng-click="vm.goToSettings()">General Settings</a></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span class="ng-scope">Close</span></button></div></div>');
$templateCache.put('app/entities/alert-rules/alert-rules-level-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Select level</h4><select class="form-control" name="level" ng-model="vm.critical" required ng-options="critical.name for critical in vm.criticals track by critical.id"></select></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.update()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Update</span></button></div></form>');
$templateCache.put('app/entities/alert-rules/alert-rules-turnoff-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="(vm.warning.active === true)" class="modal-title" translate="jotApp.warning.turnOff.title">Confirm stop operation</h4><h4 ng-show="(vm.warning.active === false)" class="modal-title" translate="jotApp.warning.turnOn.title">Confirm start operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="(vm.warning.active === true)" translate="jotApp.warning.turnOff.question" translate-values="{name: \'{{vm.warning.name}}\'}">By setting status \'stopped\' {{ vm.warning.name }} will no longer monitor or send you communications about this warning list. Are you sure?</p><p ng-show="(vm.warning.active === false)" translate="jotApp.warning.turnOn.question" translate-values="{name: \'{{vm.warning.name}}\'}">By setting status \'running\' {{ vm.warning.name }} will restart its monitoring routine. If any notification channel is active you will start receiving communications at set frequency. Are you sure?</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/alert-rules/alert-rules-user-profile-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Select user profile</h4><select class="form-control" name="userProfile" ng-model="vm.profile" required ng-options="userProfile.name for userProfile in vm.userProfiles track by userProfile.id"></select></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.update()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Update</span></button></div></form>');
$templateCache.put('app/entities/alert-rules/alert-rules.html','<div class="ng-scope"><jhi-alert></jhi-alert><dashboard-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" show-condition="false" condition="vm.selectedCondition"></dashboard-filter><div class="row" has-authority="ROLE_TECH"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletSystemTitle">System Rules List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.systemPredicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.alertRules.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.alertRules.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="critical"><span translate="jotApp.alertRules.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.alertRules.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span> <i class="fa fa-question-circle" ng-click="vm.notificationsHelp()" uib-tooltip="Click Here" tooltip-placement="top"></i></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel" has-authority="ROLE_DOMAIN_ADMIN"></th></tr></thead><tbody><tr ng-repeat="warning in vm.systemWarnings track by warning.id"><td>{{warning.name}}</td><td>{{warning.description}}</td><td>{{warning.critical == 1 ? "LOW" : "CRITICAL"}}</td><td>{{warning.userProfile.name}}</td><td>{{warning.tabFleets.fleetName}}</td><td><span class="wrapper-md-right no-outline" ng-class="vm.enableMail[warning.id].config.color"><i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'email\', vm.notifications.warningEmail, vm.enableMail[warning.id])"></i> <i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableMail\', warning.id)" tooltip-is-open="vm.enableMail[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableTelegram[warning.id].config.color"><i ng-class="\'iconAlert icon-telegram\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'telegram\', vm.notifications.warningTelegram, vm.enableTelegram[warning.id])"></i> <i ng-class="\'iconAlert icon-telegram\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableTelegram\',warning.id)" tooltip-is-open="vm.enableTelegram[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableWebhook[warning.id].config.color"><i ng-class="\'iconAlert icon-webhook\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'webhook\', vm.notifications.warningWebhook, vm.enableWebhook[warning.id])"></i> <i ng-class="\'iconAlert icon-webhook\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableWebhook\',warning.id)" tooltip-is-open="vm.enableWebhook[warning.id].tooltip"></i></span></td><td><span class="label label-danger" ng-show="!warning.active" translate="jotApp.alertRules.stopped">Stopped</span> <span class="label label-success" ng-show="warning.active" translate="jotApp.alertRules.running">Running</span></td><td class="text-center" has-authority="ROLE_DOMAIN_ADMIN"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ng-click="vm.tooggleStatus(warning)" has-authority="ROLE_DOMAIN_ADMIN"><i class="fa fa-play" ng-class="warning.active ? \'fa-stop\'  : \'fa-play\'"></i> <span ng-show="!warning.active" translate="entity.action.start"></span> <span ng-show="warning.active" translate="entity.action.stop"></span></a></li><li><a href="javascript:;" ng-click="vm.changeProfile(warning)"><i class="glyphicon glyphicon-wrench"></i><span translate="global.menu.admin.menuProfile"></span></a></li><li><a href="javascript:;" ng-click="vm.changeLevel(warning)" has-authority="ROLE_DOMAIN_ADMIN"><i class="fa fa-sliders"></i> <span translate="jotApp.alertRules.level"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemPage" total="vm.systemQueryCount" limit="vm.systemWarningItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemWarningItemLimit" total-items="vm.systemTotalItems" ng-model="vm.systemPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletTitle">Rule List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-4 aside-right"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Name..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.alertRules.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.alertRules.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="critical"><span translate="jotApp.alertRules.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.alertRules.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-if="vm.licence.id === 4"><span translate="jotApp.warning.autoRepair">Auto Repair</span></th><th multi-sort-by="tabObjectTypes.objectTypeName"><span translate="jotApp.warning.tabObjectTypes">Object Type</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span> <i class="fa fa-question-circle" ng-click="vm.notificationsHelp()" uib-tooltip="Click Here" tooltip-placement="top"></i></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel" has-authority="ROLE_DOMAIN_ADMIN"></th></tr></thead><tbody><tr ng-repeat="warning in vm.warnings track by warning.id"><td ng-bind-html="warning.name | highlight:vm.charToSearch"></td><td>{{warning.description}}</td><td>{{warning.critical == 1 ? "LOW" : "CRITICAL"}}</td><td>{{warning.userProfile.name}}</td><td ng-if="vm.licence.id === 4"><span ng-if="warning.action.actionCommand">{{warning.action.actionCommand}}</span> <span ng-if="warning.macro.alias">(Macro) {{warning.macro.alias}}</span></td><td>{{warning.tabObjectTypes.objectTypeName}}</td><td>{{warning.tabFleets.fleetName}}</td><td><span class="wrapper-md-right no-outline" ng-class="vm.enableMail[warning.id].config.color"><i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'email\', vm.notifications.warningEmail, vm.enableMail[warning.id])"></i> <i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableMail\', warning.id)" tooltip-is-open="vm.enableMail[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableTelegram[warning.id].config.color"><i ng-class="\'iconAlert icon-telegram\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'telegram\', vm.notifications.warningTelegram, vm.enableTelegram[warning.id])"></i> <i ng-class="\'iconAlert icon-telegram\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableTelegram\', warning.id)" tooltip-is-open="vm.enableTelegram[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableWebhook[warning.id].config.color"><i ng-class="\'iconAlert icon-webhook\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'webhook\', vm.notifications.warningWebhook, vm.enableWebhook[warning.id])"></i> <i ng-class="\'iconAlert icon-webhook\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableWebhook\', warning.id)" tooltip-is-open="vm.enableWebhook[warning.id].tooltip"></i></span></td><td><span class="label label-danger" ng-show="!warning.active" ng-click="vm.tooggleStatus(warning)" translate="jotApp.alertRules.stopped">Stopped</span> <span class="label label-success" ng-show="warning.active" ng-click="vm.tooggleStatus(warning)" translate="jotApp.alertRules.running">Running</span></td><td class="text-center" has-authority="ROLE_DOMAIN_ADMIN"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ng-click="vm.changeProfile(warning)"><i class="glyphicon glyphicon-wrench"></i><span translate="global.menu.admin.menuProfile"></span></a></li><li><a href="javascript:;" ng-click="vm.changeLevel(warning)" has-authority="ROLE_DOMAIN_ADMIN"><i class="fa fa-sliders"></i> <span translate="jotApp.alertRules.level"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/alert-rules/notifications-help.html','<form name="notificationsHelp"><div class="modal-header"><h4 class="modal-title" translate="jotApp.warning.notificationsHelp">Notifications Description</h4></div><div class="modal-body"><div class="row"><table class="table table-striped table-hover order-column dataTable no-footer"><thead><tr><th>Icon</th><th>Description</th></tr></thead><tbody><tr ng-repeat="notification in vm.notifications track by $index"><td><span ng-class="notification.iconColor"><i ng-class="notification.icon"></i></span></td><td>{{notification.description}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/dashboard/dashboard-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dashboard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.dashboard.delete.question" translate-values="{id: \'{{vm.dashboard.dashboardName}}\'}">Are you sure you want to delete this Dashboard?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dashboard/dashboard-management-detail.html','<div class="app-content-body detail-page devices-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.dashboard.detail.title">Dashboard</span> {{vm.dashboard.name}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.dashboard.name">Name</span></dt><dd><span>{{vm.dashboard.name}}</span></dd><dt><span translate="jotApp.dashboard.url">Url</span></dt><dd><span>{{vm.dashboard.url}}</span></dd><dt><span translate="jotApp.dashboard.frameReference">Frame Reference</span></dt><dd><span>{{vm.dashboard.frameReference}}</span></dd><dt><span translate="jotApp.dashboard.licence">Licence</span></dt><dd>{{vm.dashboard.licence.name}}</dd><dt><span translate="jotApp.dashboard.description">Description</span></dt><dd>{{vm.dashboard.description}}</dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/dashboard/dashboard-management-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myDashboardLabel" translate="jotApp.dashboard.home.createOrEditLabel">Create or edit a Dashboard</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.dashboard.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dashboard.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.dashboard.url" for="field_url">Url</label> <input type="text" class="form-control" name="url" id="field_url" ng-model="vm.dashboard.url" required ng-maxlength="3000"><div ng-show="editForm.frameReference.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.url.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 3000 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.dashboard.frameReference" for="field_frameReference">Frame Reference</label> <input type="text" class="form-control" name="frameReference" id="field_frameReference" ng-model="vm.dashboard.frameReference" required><div ng-show="editForm.frameReference.$invalid"><p class="help-block" ng-show="editForm.frameReference.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.dashboard.licence" for="field_licence">Licence</label> <select required class="form-control" id="field_licence" name="licence" ng-model="vm.dashboard.licence" ng-options="licences as licences.name for licences in vm.licences track by licences.id"><option value=""></option></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.dashboard.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.dashboard.description" ng-maxlength="1000"><div ng-show="editForm.frameReference.$invalid"><p class="help-block" ng-show="vm.editForm.url.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/dashboard/dashboard-management.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="dashboard-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.dashboard.home.createLabel">Create new Dashboard</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.dashboard.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="url"><span translate="jotApp.dashboard.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="frameReference"><span translate="jotApp.dashboard.frameReference">Frame Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="licence.name"><span translate="jotApp.dashboard.licence">Licence</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.dashboard.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards track by dashboard.id"><td ng-bind-html="dashboard.name | highlight:vm.charToSearch"></td><td>{{dashboard.url | limitTo : 58 }}...</td><td ng-bind-html="dashboard.frameReference | highlight:vm.charToSearch"></td><td>{{dashboard.licence.name}}</td><td>{{dashboard.description}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="dashboard-detail({id:dashboard.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="dashboard-edit({id:dashboard.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="dashboard.delete({id:dashboard.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/kiosks/kiosks-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.kiosks.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.kiosk.delete.question" translate-values="{id: \'{{vm.kiosks.name}}\'}">Are you sure you want to delete this Kiosk?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/kiosks/kiosks-detail.html','<div class="app-content-body detail-page domain-detail-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back">Back</span></button><h1 class="page-title"><span translate="jotApp.kiosk.detail.title">Kiosk</span> {{vm.kiosk.name}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.kiosk.kioskName">Kiosk Name</span></dt><dd><span>{{vm.kiosk.name}}</span></dd><dt><span translate="jotApp.kiosk.kioskDescription">Kiosk Description</span></dt><dd><span>{{vm.kiosk.description}}</span></dd><dt><span translate="jotApp.kiosk.kioskLink">Kiosk Link</span></dt><dd><a class="btn btn-primary" href="kiosk/playlists/play/{{vm.kiosk.playlistId}}?token={{vm.kiosk.token}}" class="font-white" target="_blank">Play <i class="fa fa-play"></i></a> <button class="btn btn-primary" type="button" copy-to-clipboard="kiosk/playlists/play/{{vm.kiosk.playlistId}}?token={{vm.kiosk.token}}"><span>Copy Link</span> <i class="fa fa-copy"></i></button></dd></dl></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-vertical"><dt><span>Dashboard</span></dt><dd><table class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr><th class="text-center">Name</th><th class="text-center">Screenshot</th></tr></thead><tbody><tr ng-repeat="dashboard in vm.kiosk.dashboards"><td class="text-center">{{dashboard.name}}</td><td class="text-center"><img src="api/kiosk-dashboard/screenshot/{{dashboard.name}}" width="400" height="225"></td></tr></tbody></table></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/kiosks/kiosks.html','<div class="app-content-body"><jhi-alert></jhi-alert><!--TODO: aggiungere direttiva per filtrare per nome i kiosks--><!--<fleet-filter filter="vm.applyFilter(objectClazz)" object-clazz-val="vm.objectClazz"></fleet-filter>--><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="kiosks-dashboards"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.kiosk.home.createLabel">Create new Kiosk</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.kiosk.kioskName">Kiosk Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.kiosk.kioskDescription">Kiosk Description</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.kiosk.kioskLink">Kiosk Link</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="kiosk in vm.kiosks | filter:vm.searchText track by kiosk.id"><td ng-bind-html="kiosk.name | highlight:vm.searchText"></td><td>{{kiosk.description}}</td><td><a class="btn btn-primary" href="kiosk/playlists/play/{{kiosk.playlistId}}?kiosk=true&token={{kiosk.token}}" class="font-white" target="_blank">Play <i class="fa fa-play"></i></a> <button class="btn btn-primary" type="button" copy-to-clipboard="path+kiosk/playlists/play/{{kiosk.playlistId}}?kiosk=true&token={{kiosk.token}}"><span>Copy Link</span> <i class="fa fa-copy"></i></button></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="kiosks-detail({id:kiosk.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ng-click="vm.editKiosk(kiosk)"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="kiosks.delete({id:kiosk.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/launch-object-test/launch-object-test-manual.html','<div class="app-content-body commands-management-page"><h1 class="page-title" translate="jotApp.launchObjectTest.home.manual.title">Manual Tests</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="page-subtitle-container"><span class="page-subtitle" translate="jotApp.launchObjectTest.home.manual.subtitle">Set your tests status</span> <button ui-sref="launch-object-test({id:vm.obj.id})" class="btn btn-primary"><span translate="jotApp.launchObjectTest.automaticTestsBtn">Automatic Tests ></span></button></div><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label class="control-label" translate="jotApp.launchObjectTest.home.device">Device</label><ui-select on-select="vm.selectObject($item)" ng-model="vm.obj" theme="bootstrap"><ui-select-match placeholder="Select or search an object..">{{$select.selected.objectName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjects | propsFilter: {objectName: $select.search, objectUniqueCode: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectName | highlight: $select.search"></div><small ng-bind-html="item.objectUniqueCode | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label translate="jotApp.launchObjectTest.selectTag">Select Run Tag</label><div ng-dropdown-multiselect="" name="testsTag" events="vm.tagsListEvent" ng-model="vm.filterTag" required id="field_tabFleets" options="vm.testsTag" extra-settings="vm.tagListSettings" translation-texts="vm.tagListSettings" selected-model="vm.filterTag"></div><!--<ui-select on-select="vm.reloadTest()" ng-model="vm.filterTag"\n                                                   theme="bootstrap">\n                                            <ui-select-match placeholder="Select or search a tag...">\n                                                {{$select.selected.testTag}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="item in vm.testsTag | filter: {testTag: $select.search}" refresh-delay="1">\n                                                <div ng-bind-html="item.testTag | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>--></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="aside-right inline-filter-button"><button type="submit" class="btn btn-primary" ng-click="vm.applyTagsFilter()"><i class="fa fa-filter"></i> Filter</button> <button ui-sref="object-test-result({id:vm.obj.id, fromManualTests:true})" class="btn btn-primary"><span>Results</span></button></div></div></div></div></div></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div ng-class="vm.objectTestResults.length == 0 ? \'table-scrollable\' : \'table-scrollable-vertical\'"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th><span translate="jotApp.launchObjectTest.status">status</span> <i class="fa fa-question-circle" uib-tooltip="Select v or x to save the manual test result" tooltip-placement="right"></i></th><th><span translate="jotApp.launchObjectTest.name">name</span></th><th><span translate="jotApp.launchObjectTest.index">Index</span></th><th><span translate="jotApp.launchObjectTest.checkType">checkType</span></th><th><span translate="jotApp.launchObjectTest.testTag">Tag</span></th><th><span translate="jotApp.launchObjectTest.aggregation">aggregation</span></th><th><span translate="jotApp.launchObjectTest.run">run</span></th><th><span translate="jotApp.launchObjectTest.lastRunner">lastRunner</span></th><th><span translate="jotApp.launchObjectTest.lastExecution">lastExecution</span></th></tr></thead><tbody><tr ng-if="vm.objectTestResults.length == 0"><td ng-if="vm.objNotSelected == true" colspan="9" class="empty-table-placeholder">Select an Object to see test results</td><td ng-if="vm.objNotSelected == false && vm.hasNotResults == true" colspan="9" class="empty-table-placeholder">No available tests for this object</td></tr><tr ng-repeat="objectTestResult in vm.objectTestResults track by objectTestResult.id"><td class="text-center"><button type="button" ng-class="objectTestResult.status == 1 ? \'btn btn-sm btn-primary\' : \'btn btn-sm btn-default\'" ng-click="vm.manualResult(objectTestResult, true)"><i class="fa fa-check"></i></button> <button type="button" ng-class="objectTestResult.status == -1 ? \'btn btn-sm btn-primary\' : \'btn btn-sm btn-default\'" ng-click="vm.manualResult(objectTestResult, false)"><i class="fa fa-times"></i></button></td><td>{{objectTestResult.objectTestSetting.name}}</td><td>{{objectTestResult.objectTestSetting.index}}</td><td>{{objectTestResult.objectTestSetting.checkType}}</td><td>{{objectTestResult.objectTestSetting.testSettingTag.testTag}}</td><td>{{objectTestResult.objectTestSetting.aggregation}}</td><td class="text-center">{{objectTestResult.executionCount}}</td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecutor}}</td><td ng-if="objectTestResult.executionCount == 0"></td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecution | date:\'yyyy-MM-dd HH:mm\'}}</td><td ng-if="objectTestResult.executionCount == 0"></td><td class="text-center" ng-if="!objectTestResult.objectTestSetting.manual"></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/launch-object-test/launch-object-test-view.html','<div class="app-content-body commands-management-page"><h1 class="page-title" translate="jotApp.launchObjectTest.home.runResults.title">Run Results</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div class="col-xs-12"><div class="aside-right"><button ui-sref="launch-object-test({id: vm.objId})" class="btn btn-primary" ng-disabled="vm.running"><span class="fa fa-backward"></span>&nbsp;<span>Back</span></button> <button ng-click="vm.downloadPdf()" class="btn btn-primary" ng-disabled="vm.running"><span class="fa fa-download"></span>&nbsp;<span>Download</span></button> <button ng-click="vm.scheduleTest()" class="btn btn-primary" ng-disabled="vm.running"><span class="fa fa-calendar"></span>&nbsp;<span translate="entity.action.schedule">Schedule</span></button></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th><span translate="jotApp.launchObjectTest.name">name</span></th><th><span translate="jotApp.launchObjectTest.index">Index</span></th><th><span translate="jotApp.launchObjectTest.status">status</span></th><th><span translate="jotApp.launchObjectTest.testResult">testResult</span></th><th><span translate="jotApp.launchObjectTest.expectedValue">expectedValue</span></th><th><span translate="jotApp.launchObjectTest.checkType">checkType</span></th><th><span translate="jotApp.launchObjectTest.aggregation">aggregation</span></th><th><span translate="jotApp.launchObjectTest.run">run</span></th><th><span translate="jotApp.launchObjectTest.lastRunner">lastRunner</span></th><th><span translate="jotApp.launchObjectTest.lastExecution">lastExecution</span></th></tr></thead><tbody><tr ng-repeat="test in vm.objectTestResults track by test.id"><td>{{test.objectTestSetting.name}}</td><td>{{test.objectTestSetting.index}}</td><td class="text-center"><i ng-class="(test.running) ? \'fa fa-spinner\' : (test.status > 0) ? \'fa fa-check color-green\' : (test.status < 0) ? \'fa fa-close background-red\' : \'fa fa-minus color-gray\' "></i></td><td class="text-center">{{test.lastResult}}</td><td class="text-center">{{test.objectTestSetting.expectedValue}}</td><td>{{test.objectTestSetting.checkType}}</td><td ng-if="test.objectTestSetting.aggregation !== \'Count_Values\'">{{test.objectTestSetting.aggregation}}</td><td ng-if="test.objectTestSetting.aggregation === \'Count_Values\'">{{test.objectTestSetting.aggregation}} ({{test.objectTestSetting.valueToCheck}})</td><td class="text-center">{{test.executionCount}}</td><td ng-if="test.executionCount > 0">{{test.lastExecutor}}</td><td ng-if="test.executionCount == 0"></td><td ng-if="test.executionCount > 0">{{test.lastExecution | date:\'yyyy-MM-dd HH:mm\'}}</td><td ng-if="test.executionCount == 0"></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/launch-object-test/launch-object-test.html','<div class="app-content-body commands-management-page"><h1 class="page-title" translate="jotApp.launchObjectTest.home.automatic.title">Automatic Tests</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="page-subtitle-container"><span class="page-subtitle" translate="jotApp.launchObjectTest.home.automatic.subtitle">Launch your test and see result</span> <button ui-sref="launch-object-test.manual({id:vm.obj.id})" class="btn btn-primary"><span translate="jotApp.launchObjectTest.manualTestsBtn">Manual Tests ></span></button></div><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label class="control-label" translate="jotApp.launchObjectTest.home.device">Device</label><ui-select ng-model="vm.obj" theme="bootstrap"><ui-select-match placeholder="Select or search an object..">{{$select.selected.objectName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjects | propsFilter: {objectName: $select.search, objectUniqueCode: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectName | highlight: $select.search"></div><small ng-bind-html="item.objectUniqueCode | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label translate="jotApp.launchObjectTest.selectTag">Select Run Tags</label><div ng-dropdown-multiselect="" name="testsTag" events="vm.tagsListEvent" ng-model="vm.filterTag" required id="field_tabFleets" options="vm.testsTag" extra-settings="vm.tagListSettings" translation-texts="vm.tagListSettings" selected-model="vm.filterTag"></div><!--      <ui-select multiple on-select="vm.reloadTest()" ng-model="vm.filterTag"theme="bootstrap">\n                                            <ui-select-match placeholder="Select or search a tags...">\n                                                {{$select.selected.testTag}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="item in vm.testsTag | filter: {testTag: $select.search}" refresh-delay="1">\n                                                <div ng-bind-html="item.testTag | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>--></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="aside-right inline-filter-button"><button type="submit" class="btn btn-primary" ng-click="vm.applyTagsFilter()"><i class="fa fa-filter"></i> Filter</button> <button ng-click="vm.checkedTestList()" class="btn btn-primary" ng-disabled="vm.objectTestResults.length < 1 || (!(vm.obj.objectStates.objectStateName==\'running\' && vm.obj.objectTracked)) || vm.running || !vm.clickedAtLeastOneTest()"><span class="fa fa-play-circle-o"></span>&nbsp;<span>Launch</span></button></div></div></div></div></div></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div ng-class="vm.objectTestResults.length == 0 ? \'table-scrollable\' : \'table-scrollable-vertical\'"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th ng-if="vm.objectTestResults.length > 0" class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-click="vm.checkAll()" ng-model="vm.areChk"> <span></span></label></th><th><span translate="jotApp.launchObjectTest.name">name</span></th><th><span translate="jotApp.launchObjectTest.index">Index</span></th><th><span translate="jotApp.launchObjectTest.status">status</span></th><th><span translate="jotApp.launchObjectTest.checkType">checkType</span></th><th><span translate="jotApp.launchObjectTest.testTag">Tag</span></th><th><span translate="jotApp.launchObjectTest.aggregation">aggregation</span></th><th><span translate="jotApp.launchObjectTest.run">run</span></th><th><span translate="jotApp.launchObjectTest.lastRunner">lastRunner</span></th><th><span translate="jotApp.launchObjectTest.lastExecution">lastExecution</span></th></tr></thead><tbody><tr ng-if="vm.objectTestResults.length == 0"><td ng-if="vm.objNotSelected == true" colspan="9" class="empty-table-placeholder">Select an object to launch your tests, then press filter</td><td ng-if="vm.objNotSelected == false && vm.hasNotResults == true" colspan="9" class="empty-table-placeholder">No available tests for this object</td></tr><tr ng-repeat="objectTestResult in vm.objectTestResults track by objectTestResult.id"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="objectTestResult.check" ng-click="vm.areAllChecked()"> <span></span></label></td><td>{{objectTestResult.objectTestSetting.name}}</td><td>{{objectTestResult.objectTestSetting.index}}</td><td class="text-center"><i ng-if="objectTestResult.status == 1" class="fa fa-check color-green"></i> <i ng-if="objectTestResult.status == 0" class="fa fa-hourglass-o" title="test not performed yet" aria-hidden="true"></i> <i ng-if="objectTestResult.status == -1" class="fa fa-close background-red"></i> <i ng-if="objectTestResult.status == -2" class="fa fa-chain-broken" title="object offline" aria-hidden="true"></i></td><td>{{objectTestResult.objectTestSetting.checkType}}</td><td>{{objectTestResult.objectTestSetting.testSettingTag.testTag}}</td><td>{{objectTestResult.objectTestSetting.aggregation}}</td><td class="text-center">{{objectTestResult.executionCount}}</td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecutor}}</td><td ng-if="objectTestResult.executionCount == 0"></td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecution | date:\'yyyy-MM-dd HH:mm\'}}</td><td ng-if="objectTestResult.executionCount == 0"></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/licences/licences-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.licences.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.licences.delete.question" translate-values="{id: \'{{vm.licences.name}}\'}">Are you sure you want to delete this Licences?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/licences/licences-detail.html','<div><h2><span translate="jotApp.licences.detail.title">Licences</span> {{vm.licences.id}}</h2><hr><dl class="dl-horizontal"><dt><span translate="jotApp.licences.name">Name</span></dt><dd><span>{{vm.licences.name}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/licences/licences-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLicencesLabel" translate="jotApp.licences.home.createOrEditLabel">Create or edit a Licences</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.licences.id"><label for="id" translate="global.field.id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.licences.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="jotApp.licences.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.licences.name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/licences/licences.html','<div><h2 translate="jotApp.licences.home.title">Licences</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="licences.new"><span class="glyphicon glyphicon-plus"></span> <span translate="jotApp.licences.home.createLabel">Create new Licences</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="jotApp.licences.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="licences in vm.licences track by licences.id"><td><a ui-sref="licences-detail({id:licences.id})">{{licences.id}}</a></td><td>{{licences.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="licences-detail({id:licences.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="licences.edit({id:licences.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="licences.delete({id:licences.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/macro/macro-actions-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.command.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><!-- Traditional macro action --><p ng-if="!vm.command.isGreengrass">Are you sure you want to delete this Command: {{vm.command.tabActions.actionCommand}}?</p><!-- Greengrass command --><p ng-if="vm.command.isGreengrass && !vm.command.isLastCommand">Are you sure you want to delete this Command: <strong>{{vm.command.commandName}}</strong>?</p><p ng-if="vm.command.isGreengrass && vm.command.isLastCommand" class="text-danger"><strong>Warning:</strong> This is the last command in the macro.</p><p ng-if="vm.command.isGreengrass && vm.command.isLastCommand">Deleting the command <strong>{{vm.command.commandName}}</strong> will delete the entire macro. Are you sure?</p></div><div class="modal-footer" style="text-align: right;"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle" style="margin-right: 5px; vertical-align: middle;"></span><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle" style="margin-right: 5px; vertical-align: middle;"></span><span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/macro/macro-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.macro.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete this Macro: {{vm.macro.alias}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/macro/macro-detail.html','<div class="app-content-body commands-management-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="macros" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.macro.detail.title" translate-values="{param: \'{{vm.macro.alias}}\'}">Macro: {{vm.macro.alias}}</span></h1></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>{{vm.macro.alias}}</span></div></div><div class="portlet light filter-portlet bordered"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr><th><span>Commands</span></th><th><span>Arguments</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><!-- Traditional macro actions --><tr ng-repeat="command in vm.macro.macroActions track by command.id" ng-if="vm.macro.macroActions && vm.macro.macroActions.length > 0"><td>{{command.tabActions.actionCommand}}</td><td><span ng-repeat="(key, value) in command.argumentMap"><b>{{key}}</b> : {{value}}<br></span></td><td class="text-center"><div class="btn-group icon-table-queue"><span ng-show="$index > 0" ng-click="vm.moveUp($index)" title="Move Up"><i class="glyphicon glyphicon-arrow-up"></i> </span><span ng-show="$index < vm.macro.macroActions.length -1" ng-click="vm.moveDown($index)" title="Move Down"><i class="glyphicon glyphicon-arrow-down"></i> </span><span ng-click="vm.deleteMacroAction(command.id)" title="Delete Command"><i class="glyphicon glyphicon-remove-sign"></i></span></div></td></tr><!-- Greengrass macro commands --><tr ng-repeat="command in vm.greengrassCommands track by $index" ng-if="vm.isGreengrassMacro"><td>{{command.commandName}}</td><td><span ng-repeat="(key, value) in command.argumentMap"><b>{{key}}</b> : {{value}}<br></span></td><td class="text-center"><div class="btn-group icon-table-queue"><span ng-show="$index > 0" ng-click="vm.moveUpGreengrass($index)" title="Move Up"><i class="glyphicon glyphicon-arrow-up"></i> </span><span ng-show="$index < vm.greengrassCommands.length -1" ng-click="vm.moveDownGreengrass($index)" title="Move Down"><i class="glyphicon glyphicon-arrow-down"></i> </span><span ng-click="vm.deleteGreengrassCommand($index)" title="Delete Command"><i class="glyphicon glyphicon-remove-sign"></i></span></div></td></tr></tbody></table></div><div class="row" ng-if="vm.edit" style="margin: 0; padding: 15px; border-top: 1px solid #ddd; text-align: right;"><div class="col-xs-12"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.save()"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/macro/macro.html','<div class="app-content-body commands-management-page"><jhi-alert></jhi-alert><h1 class="page-title" id="myMacroLabel" translate="jotApp.macro.home.title">Macros</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Macros</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr><th><span>Alias</span></th><th><span>Type</span></th><th><span>Fleet</span></th><th><span>Permission level</span></th><th><span>Commands</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="macro in vm.macro track by macro.id"><td>{{macro.alias}}</td><td>{{macro.tabObjectTypes.objectTypeName}}</td><td>{{macro.tabFleets.fleetName}}</td><td>{{macro.level}}</td><td><span ng-if="macro.macroActions && macro.macroActions.length > 0"><span ng-repeat="command in macro.macroActions">{{command.tabActions.actionCommand}} <span ng-if="command.arguments != \'{}\'">- {{command.argumentMap}}</span><br></span></span><span ng-if="!macro.macroActions || macro.macroActions.length == 0"><span ng-if="!macro.greengrassCommands" style="color: #999; font-style: italic;">Loading...</span><div ng-if="macro.greengrassCommands"><div ng-repeat="cmd in macro.greengrassCommands">{{cmd.commandName}} <span ng-if="cmd.arguments && cmd.arguments != \'{}\'">- {{cmd.arguments}}</span><br></div></div></span></td><td class="text-center"><div class="btn-group icon-table-queue"><span ui-sref="macro-detail({id: macro.id})" title="Edit Macro"><i class="glyphicon glyphicon-edit"></i> </span><span ui-sref="macros.delete({id:macro.id, name:macro.alias})" title="Delete Macro"><i class="glyphicon glyphicon-remove-sign"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/my-domain-notification/my-domain-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.myDomainNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.myDomainNotification.delete.title">Delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.myDomainNotification.delete.question" translate-values="{name: \'{{vm.myDomainNotification.name}}\'}">Are you sure you want to delete this domain notification?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/my-domain-notification/my-domain-notification-detail.html','<div class="app-content-body detail-page myDomainNotification-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.myDomainNotification.detail.title">My Domain Notification : </span>{{vm.myDomainNotification.name}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.myDomainNotification.name">Name</span></dt><dd><span>{{vm.myDomainNotification.name}}</span></dd><dt><span translate="jotApp.myDomainNotification.active">Active</span></dt><dd><span>{{vm.myDomainNotification.active}}</span></dd><dt><span translate="jotApp.myDomainNotification.dashboard.warningStatus">Warning status</span></dt><dd><span>{{vm.myDomainNotification.status}}</span></dd><dt><span translate="jotApp.myDomainNotification.objectsStatus">objectStatus</span></dt><dd><span>{{vm.myDomainNotification.objectsStatus}}</span></dd><dt><span translate="jotApp.myDomainNotification.wipStatus">ProcessStatus</span></dt><dd><span>{{vm.myDomainNotification.wipStatus}}</span></dd><dt><span translate="jotApp.myDomainNotification.userProfile">UserProfile</span></dt><dd><span>{{vm.myDomainNotification.userProfile.name}}</span></dd><dt><span translate="jotApp.myDomainNotification.frequency">Frequency</span></dt><dd><span>{{vm.myDomainNotification.frequency}}</span></dd><dt><span translate="jotApp.myDomainNotification.nextExecutionTime">Next execution time</span></dt><dd><span ng-if="vm.myDomainNotification.active == true">{{vm.myDomainNotification.nextExecutionDatetime | date: \'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span translate="jotApp.myDomainNotification.warningCategory">Warning Category</span></dt><dd><span ng-repeat="category in vm.myDomainNotification.categories">{{category.warningName}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.myDomainNotification.tabFleets">Tab Fleets</span></dt><dd><span ng-repeat="fleet in vm.myDomainNotification.fleets"><a ui-sref="tab-fleets-detail({id:{{fleet.id}}})">{{fleet.fleetName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.myDomainNotification.warningNames">Warnings</span></dt><dd><span ng-repeat="myDomainNotification in vm.myDomainNotification.warningNames">{{myDomainNotification.name}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.myDomainNotification.createdBy">Created By</span></dt><dd><span>{{vm.myDomainNotification.createdBy}}</span></dd><dt><span translate="jotApp.myDomainNotification.createdDate">Created Date</span></dt><dd><span>{{vm.myDomainNotification.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.myDomainNotification.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.myDomainNotification.lastModifiedBy}}</span></dd><dt><span translate="jotApp.myDomainNotification.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.myDomainNotification.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/my-domain-notification/my-domain-notification-dialog.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title" ng-if="vm.nameForTitle != null && vm.myDomainNotification.id != null" translate="jotApp.myDomainNotification.home.editLabel">Edit a domain notification</h1><h1 class="page-title" ng-if="vm.nameForTitle != null && vm.myDomainNotification.id == null" translate="jotApp.myDomainNotification.home.cloneLabel">Clone a domain notification</h1><h1 class="page-title" ng-if="vm.nameForTitle == null && vm.myDomainNotification.id == null" translate="jotApp.myDomainNotification.home.createLabel">Create a new domain notification</h1><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation autocomplete="off"><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.myDomainNotification.name" required ng-maxlength="250"></div></div></div><br><p class="info-line">Choose your fleet and connection status to trigger domain notification</p><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.myDomainNotification.tabFleets" for="field_tabFleets">Tab Fleets</label><div ng-dropdown-multiselect="" name="tabFleets" required id="field_tabFleets" options="vm.fleetOptions" selected-model="vm.myDomainNotification.fleets" extra-settings="vm.fleetListSettings" translation-texts="vm.fleetListSettings" events="vm.fleetListEvent"></div><input style="display: none;" type="number" ng-model="vm.myDomainNotification.fleets.length" ng-required="true" min="1"><!-- this input is hidden, used only to make the multi select required --></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.objectsStatus" for="field_objects_status">Objects Status</label> <select class="form-control" id="field_objects_status" name="status" ng-model="vm.myDomainNotification.objectsStatus" required><option selected="vm.myDomainNotification.objectsStatus"></option><option value="all">ALL</option><option value="online">ONLINE</option><option value="offline">OFFLINE</option></select></div></div></div><br><p class="info-line">Choose Warnings and Status related to the selected User Profile</p><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.userProfile" for="field_user_profile">User Profile</label><ui-select id="field_user_profile" name="userProfile" ng-model="vm.myDomainNotification.userProfile" theme="bootstrap" required><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.userProfiles | filter: {name: $select.search}" percent="90" when-scrolled="vm.loadUserProfilePage(vm.userProfilePage + 1)"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><input style="display:none;" type="number" ng-model="vm.myDomainNotification.userProfile.id" ng-required="true"><!-- this input is hidden, used only to make the multi select required --></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.dashboard.warningStatus" for="field_status">Warning Status</label> <select class="form-control" id="field_status" name="status" ng-model="vm.myDomainNotification.status" required><option selected="vm.myDomainNotification.status"></option><option value="all">ALL</option><option value="open">OPEN</option><option value="close">CLOSE</option></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.myDomainNotification.warningCategories" for="field_warning_category">Warning Category</label><div ng-dropdown-multiselect="" id="field_warning_category" options="vm.categoryOptions" selected-model="vm.myDomainNotification.categories" required extra-settings="vm.categoryListSettings" translation-texts="vm.categoryListSettings" events="vm.categoryListEvent" disabled="vm.fleetEmpty == true"></div><input style="display: none;" type="number" ng-model="vm.myDomainNotification.categories.length" ng-required="true" min="1"><!-- this input is hidden, used only to make the multi select required --></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.myDomainNotification.warningNames" for="field_warning_name">Warning Names</label><div ng-dropdown-multiselect="" id="field_warning_name" options="vm.warningNameOptions" selected-model="vm.myDomainNotification.warningNames" required extra-settings="vm.warningListSettings" translation-texts="vm.warningListSettings" events="vm.warningListEvent" disabled="vm.categoryEmpty == true"></div><input style="display: none;" type="number" ng-model="vm.myDomainNotification.warningNames.length" ng-required="true" min="1"><!-- this input is hidden, used only to make the multi select required --></div></div></div><br><p class="info-line">Choose Frequency and Time</p><div class="row"><div class="col-md-3 col-xs-6"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.frequency">Frequency</label><div id="field_frequency">Repeat every <input class="form-control" type="number" name="frequency" ng-model="vm.myDomainNotification.frequency" min="1" max="30" required style="display: inline; width: 50%"> days</div></div></div><div class="col-md-3 col-xs-6"><div class="form-group"><label class="control-label" translate="jotApp.myDomainNotification.time" for="field_time">Time</label> <input type="text" id="field_time" placeholder="Selected timeslot to receive domain notification..." required timepicker-options="vm.timepickerOptions" enable-date="false" class="form-control" datetime-picker="HH:mm" ng-model="vm.myDomainNotification.nextExecutionDatetime" name="time" ng-click="vm.openTimeCalc()" is-open="vm.repeatStatus"></div></div></div><div class="aside-right"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary" ng-click="vm.save()"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button><br><p ng-if="editForm.$invalid" class="required-fields">All fields are required</p></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/my-domain-notification/my-domain-notification.html','<jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="primary-page-title">Access your domain notification or create new ones</div></div></div><br><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="my-domain-notification-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.myDomainNotification.home.createLabel">Create new Domain Notification</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchParams" placeholder="Search by name..." ng-change="vm.applySearch()"></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.myDomainNotification.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.myDomainNotification.warningsInvolved">Warnings Involved</span> <i class="fa fa-question-circle" uib-tooltip="Number of warning rules associated with this Domain Notification" tooltip-placement="top"></i></th><th multi-sort-by="frequency"><span translate="jotApp.myDomainNotification.frequency">Frequency</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.myDomainNotification.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.myDomainNotification.notifications">Notifications</span> <i class="fa fa-question-circle" ng-click="vm.notificationsHelp()" uib-tooltip="Click Here" tooltip-placement="top"></i></th><th multi-sort-by="active"><span translate="jotApp.myDomainNotification.dashboard.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="myDomainNotification in vm.myDomainNotification | filter: vm.searchParams track by myDomainNotification.id"><td ng-bind-html="myDomainNotification.name | highlight:vm.searchParams"></td><td>{{myDomainNotification.warningNames.length}}<!--<a href="#">--><div class="btn-group" ng-if="myDomainNotification.active"><span ui-sref="warnings-list({id:myDomainNotification.id})" class="object-icon-action no-outline" title="Details"><i class="glyphicon glyphicon-zoom-in"></i></span></div></td><td>every {{myDomainNotification.frequency}} day ({{myDomainNotification.nextExecutionDatetime | date: \'HH:mm\'}})</td><td>{{myDomainNotification.userProfile.name}}</td><td><span class="wrapper-md-right no-outline" ng-class="vm.enableMail[myDomainNotification.id].config.color"><i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="myDomainNotification.active" ng-click="vm.changeStatus(myDomainNotification, \'email\', vm.notification.warningEmail, vm.enableMail[myDomainNotification.id])"></i> <i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="!myDomainNotification.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableMail\', myDomainNotification.id)" tooltip-is-open="vm.enableMail[myDomainNotification.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableTelegram[myDomainNotification.id].config.color"><i ng-class="\'iconAlert icon-telegram\'" ng-if="myDomainNotification.active" ng-click="vm.changeStatus(myDomainNotification, \'telegram\', vm.notification.warningTelegram, vm.enableTelegram[myDomainNotification.id])"></i> <i ng-class="\'iconAlert icon-telegram\'" ng-if="!myDomainNotification.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableTelegram\', myDomainNotification.id)" tooltip-is-open="vm.enableTelegram[myDomainNotification.id].tooltip"></i></span></td><td><span class="label label-danger" ng-show="!myDomainNotification.active" translate="jotApp.myDomainNotification.stopped" ng-click="vm.tooggleStatus(myDomainNotification)">Stopped</span> <span class="label label-success" ng-show="myDomainNotification.active" translate="jotApp.myDomainNotification.running" ng-click="vm.tooggleStatus(myDomainNotification)">Running</span></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions</span> <i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="my-domain-notification-view({id:myDomainNotification.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="my-domain-notification-edit({id:myDomainNotification.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="my-domain-notification-clone({id:myDomainNotification.id})"><i class="fa fa-clone"></i><span translate="entity.action.clone"></span></a></li><li><a href="javascript:;" ng-click="vm.deleteRule(myDomainNotification.id)"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/object-test-result/object-test-result-history-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.objectTestResult.delete.question" translate-values="{name: \'{{vm.name}}\'}">Are you sure you want to delete this Dashboard?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/object-test-result/object-test-result-history.html','<div class="app-content-body commands-management-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title" translate="jotApp.objectTestResult.history.title" translate-values="{name: \'{{vm.obj.objectTypeName}}\'}">History download</h1></div></div><br><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="portlet-body form"><div name="editForm"><div class="form-body"><h3 ng-if="vm.objectTestHistory.length <= 0" style="text-align: center;">No History Found!</h3><div class="table-scrollable-vertical" table-scroll-detection ng-if="vm.objectTestHistory.length > 0"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.objectTestSetting.name">name</span></th><th><span>Date</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="objectTestHistory in vm.objectTestHistory"><td>{{objectTestHistory}}</td><td>{{objectTestHistory.split(\'.\')[0].split(\'_\')[1] | date: \'dd-MM-yyyy - HH:mm\'}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" ng-click="vm.checkFiletype(objectTestHistory)"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a ng-if="!vm.checkestensione" ng-click="vm.downloadFilePdf(objectTestHistory.split(\'.\')[0])" target="_blank"><i class="fa fa-download"></i> <span translate="entity.action.download"></span> </a><a ng-if="vm.checkestensione" ng-click="vm.downloadFilePdf1(objectTestHistory.split(\'.\')[0])" target="_blank"><i class="fa fa-download"></i> <span translate="entity.action.download"></span></a></li><li><a ng-show="!vm.checkestensione" ng-click="vm.openFilePdf(objectTestHistory.split(\'.\')[0])" target="_blank"><i class="fa fa-eye"></i> <span translate="entity.action.open"></span></a></li><li><a ng-if="!vm.checkestensione" href="javascript:;" ui-sref="object-test-result.history-delete({name:objectTestHistory.split(\'.\')[0], type: vm.pdf})"><i class="fa fa-times"></i> <span translate="entity.action.delete"></span> </a><a ng-if="vm.checkestensione" href="javascript:;" ui-sref="object-test-result.history-delete({name:objectTestHistory.split(\'.\')[0], type: vm.csv})"><i class="fa fa-times"></i> <span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/object-test-result/object-test-result.html','<div class="app-content-body commands-management-page"><h1 class="page-title" ng-if="vm.testSchedule == null" translate="jotApp.objectTestResult.home.title">Results</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="page-subtitle-container"><span class="page-subtitle">Filter by Object and see the results of your latest tests</span></div><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label class="control-label" translate="jotApp.objectTestResult.home.device">Device</label><ui-select on-select="vm.selectObject($item)" ng-model="vm.obj" theme="bootstrap"><ui-select-match placeholder="Select or search an object..">{{$select.selected.objectName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjects | propsFilter: {objectName: $select.search, objectUniqueCode: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectName | highlight: $select.search"></div><small ng-bind-html="item.objectUniqueCode | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="form-group"><label translate="jotApp.objectTestResult.testTag">Select Run Tags</label><ui-select on-select="vm.reloadTest()" ng-model="vm.filterTag" theme="bootstrap"><ui-select-match placeholder="Select or search a tag...">{{$select.selected.testTag}}</ui-select-match><ui-select-choices repeat="item in vm.testsTag | filter: {testTag: $select.search}" refresh-delay="1"><div ng-bind-html="item.testTag | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-4 col-lg-4"><div class="aside-right inline-filter-button"><button ui-sref="object-test-result.history({object:vm.obj.objectUniqueCode,id:vm.obj.id})" ng-disabled="!vm.obj" class="btn btn-primary"><span class="fa fa-history"></span>&nbsp;<span translate="jotApp.objectTestResult.historyDownload">History of Downloads</span></button> <button ng-click="vm.downloadPdf()" class="btn btn-primary" ng-disabled="!vm.clickedAtLeastOneTest()"><span class="fa fa-download"></span>&nbsp;<span>Download</span></button></div></div></div></div></div></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div ng-class="vm.objectTestResults.length == 0 ? \'table-scrollable\' : \'table-scrollable-vertical\'"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th ng-if="vm.objectTestResults.length > 0" class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-click="vm.checkAll()" ng-model="vm.areChk"> <span></span></label></th><th><span translate="jotApp.objectTestSetting.name">name</span></th><th><span translate="jotApp.objectTestSetting.index">Index</span></th><th><span translate="jotApp.objectTestResult.status">status</span></th><th><span translate="jotApp.objectTestResult.testResult">testResult</span></th><th><span translate="jotApp.objectTestSetting.expectedValue">expectedValue</span></th><th><span translate="jotApp.objectTestSetting.checkType">checkType</span></th><th><span translate="jotApp.objectTestSetting.testTag">Tag</span></th><th><span translate="jotApp.objectTestSetting.aggregation">aggregation</span></th><th><span translate="jotApp.objectTestResult.run">run</span></th><th><span translate="jotApp.objectTestResult.lastRunner">lastRunner</span></th><th><span translate="jotApp.objectTestResult.lastExecution">lastExecution</span></th></tr></thead><tbody><tr ng-if="vm.objectTestResults.length == 0"><td ng-if="vm.objNotSelected == true" colspan="11" class="empty-table-placeholder">Select an Object to see test results</td><td ng-if="vm.objNotSelected == false && vm.hasNotResults == true" colspan="11" class="empty-table-placeholder">No test results for this object</td></tr><tr ng-repeat="objectTestResult in vm.objectTestResults track by objectTestResult.id"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="objectTestResult.check" ng-click="vm.areAllChecked()"> <span></span></label></td><td>{{objectTestResult.objectTestSetting.name}}<div class="aside-right"><i ng-if="objectTestResult.isUpdatedByOther" class="fa fa-exclamation-triangle" title="Another run or schedules updated this test results"></i></div></td><td>{{objectTestResult.objectTestSetting.index}}</td><td class="text-center"><i ng-if="objectTestResult.status == 1" class="fa fa-check color-green"></i> <i ng-if="objectTestResult.status == 0" class="fa fa-hourglass-o" title="test not performed yet" aria-hidden="true"></i> <i ng-if="objectTestResult.status == -1" class="fa fa-close background-red"></i> <i ng-if="objectTestResult.status == -2" class="fa fa-chain-broken" title="object offline" aria-hidden="true"></i></td><td class="text-center">{{objectTestResult.lastResult}}</td><td class="text-center">{{objectTestResult.objectTestSetting.expectedValue}}</td><td>{{objectTestResult.objectTestSetting.checkType}}</td><td>{{objectTestResult.objectTestSetting.testSettingTag.testTag}}</td><td ng-if="objectTestResult.objectTestSetting.aggregation !== \'Count_Values\'">{{objectTestResult.objectTestSetting.aggregation}}</td><td ng-if="objectTestResult.objectTestSetting.aggregation === \'Count_Values\'">{{objectTestResult.objectTestSetting.aggregation}} ({{objectTestResult.objectTestSetting.valueToCheck}})</td><td class="text-center">{{objectTestResult.executionCount}}</td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecutor}}</td><td ng-if="objectTestResult.executionCount == 0"></td><td ng-if="objectTestResult.executionCount > 0">{{objectTestResult.lastExecution | date:\'yyyy-MM-dd HH:mm\'}}</td><td ng-if="objectTestResult.executionCount == 0"></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/object-test-setting/new-tag.html','<form name="tagForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.objectTestSetting.tagModal.title">Insert tag to create</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 col-xs-12"><input type="text" class="form-control" ng-model="vm.tag.name" placeholder="Insert name.." required></div></div><div class="row" has-authority="ROLE_ADMIN"><div class="col-md-3 col-xs-6"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isCrossDomain"><input type="checkbox" name="isCrossDomain" id="field_isCrossDomain" ng-model="vm.tag.isCrossDomain"> <span></span><div translate="jotApp.objectTestSetting.tagModal.crossDomain"></div></label></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" ng-disabled="tagForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/object-test-setting/object-test-setting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.objectTestSetting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.objectTestSetting.delete.question" translate-values="{name: \'{{vm.objectTestSetting.name}}\'}">This operation will delete your test. Are you sure?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/object-test-setting/object-test-setting-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.objectTestSetting.home.createOrEditLabel">Create or edit a Test</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-xs-12"><div class="form-group"><label class="switch aside-right"><input type="checkbox" ng-click="vm.objectTestSetting.manual = !vm.objectTestSetting.manual" ng-checked="vm.objectTestSetting.manual"> <span class="form-mode-toggle test-toggle round"></span></label></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.name" for="field_name">Name</label> <input type="text" class="form-control" name="testName" id="field_name" ng-model="vm.objectTestSetting.name" required ng-maxlength="100"><div ng-show="editForm.testName.$invalid"><p class="help-block" ng-show="editForm.testName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.testName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.objectTestSetting.description"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.tabFleets" for="field_fleet">Fleets</label><ui-select multiple="multiple" id="field_fleet" name="tabFleets" ng-model="vm.objectTestSetting.tabFleets" theme="bootstrap" required ng-if="vm.objectTestSetting.id === null"><ui-select-match placeholder="Select or search a fleet..">{{$item.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}" refresh-delay="1"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select><ui-select id="field_fleet" name="tabFleets" ng-model="vm.objectTestSetting.tabFleets" theme="bootstrap" disabled="true" ng-if="vm.objectTestSetting.id !== null"><ui-select-match placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}" refresh-delay="1"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.tabFleets.$invalid"><p class="help-block" ng-show="editForm.tabFleets.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.tabObjectTypes" for="field_tabObjectTypes">Tab Object Types</label><ui-select id="field_tabObjectTypes" name="tabObjectTypes" ng-model="vm.objectTestSetting.tabObjectTypes" ng-change="vm.loadMetric()" theme="bootstrap" required ng-disabled="vm.objectTestSetting.id !== null"><ui-select-match placeholder="Select an object type..">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" refresh-delay="1"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.tabObjectTypes.$invalid"><p class="help-block" ng-show="editForm.tabObjectTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row" ng-if="!vm.objectTestSetting.manual"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.checkType" for="field_checkType">Check Types</label> <select class="form-control" id="field_checkType" name="checkType" ng-model="vm.objectTestSetting.checkType" ng-change="vm.checkAggregationAllowed()" ng-options="checkType for checkType in vm.checkTypes" required></select><div ng-show="editForm.checkType.$invalid"><p class="help-block" ng-show="editForm.checkType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12" ng-show="vm.objectTestSetting.checkType && (vm.objectTestSetting.checkType == \'Equals\' || vm.objectTestSetting.checkType == \'Not Equals\')"><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.expectedValue" for="field_expectedValue">Expected Value</label> <input type="text" class="form-control" name="expectedValue" id="field_expectedValue" ng-model="vm.expected"></div></div><div class="col-md-6 col-xs-12" ng-show="vm.objectTestSetting.checkType && vm.objectTestSetting.checkType != \'Exists\' && vm.objectTestSetting.checkType != \'Between\' && vm.objectTestSetting.checkType != \'Equals\' && vm.objectTestSetting.checkType != \'Not Exists\' && vm.objectTestSetting.checkType != \'Not Equals\' "><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.expectedValue" for="field_expectedValue">Expected Value</label> <input type="number" class="form-control" name="expectedValueNumber" id="field_expectedValueNumber" ng-model="vm.expectedNumber"></div></div><div class="col-md-6 col-xs-12" ng-show="vm.objectTestSetting.checkType && vm.objectTestSetting.checkType == \'Between\'"><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.expectedValue" for="field_expectedValueA">Expected Value</label> <input type="number" class="form-control" name="expectedValue" id="field_expectedValueA" ng-model="vm.expectedA" placeholder="excluded min edge"> <input type="number" class="form-control" name="expectedValueB" id="field_expectedValueB" ng-model="vm.expectedB" placeholder="excluded max edge"></div></div></div><div class="row" ng-if="!vm.objectTestSetting.manual"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.metric" for="field_metric">Metric</label><ui-select id="field_metric" name="metric" ng-model="vm.tempMetric" ng-change="vm.updateMetric()" theme="bootstrap" required><ui-select-match placeholder="Select or search a metric..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.metric | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.metric.$invalid"><p class="help-block" ng-show="editForm.metric.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.aggregation" for="field_aggregation">Aggregation</label> <select class="form-control" id="field_aggregation" name="aggregation" ng-model="vm.objectTestSetting.aggregation" ng-disabled="vm.aggregationDisabled" ng-options="aggregation for aggregation in vm.aggregations" required></select><div ng-show="vm.objectTestSetting.aggregation == \'Count_Values\'"><input class="form-control" name="valueToCheck" id="field_valueToCheck" ng-pattern="/^(((=|!)[A-Za-z0-9]+)|((<|>|<=|>=)[0-9]+))$/" ng-model="vm.valueToCheck" placeholder="write operation (!, =, <, >, <=, >=) and value to check"></div><div ng-show="editForm.aggregation.$invalid"><p class="help-block" ng-show="editForm.aggregation.$error.required" translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.valueToCheck.$invalid"><p class="help-block" ng-show="editForm.valueToCheck.$error.pattern">Malformed value to check</p></div></div></div></div><!-- SECONDARY METRIC ROW --><div class="row" ng-if="!vm.objectTestSetting.manual"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.secondaryMetric" for="field_secondaryMetric">Secondary Metric</label><ui-select id="field_secondaryMetric" name="secondaryMetric" ng-model="vm.tempSecondaryMetric" ng-change="vm.updateSecondaryMetric()" theme="bootstrap"><ui-select-match placeholder="Select or search a secondary metric..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.metric | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-6 col-xs-12" ng-show="vm.tempSecondaryMetric"><div class="form-group"><label class="control-label" translate="jotApp.objectTestSetting.secondaryMetricExpectedValue" for="field_secondaryMetricExpectedValue">Secondary Expected Value</label> <input type="text" class="form-control" name="secondaryMetricExpectedValue" id="field_secondaryMetricExpectedValue" ng-model="vm.objectTestSetting.secondaryMetricExpectedValue"></div></div></div><!-- SECONDARY METRIC ROW --><div class="row"><div class="col-md-6 col-xs-12" ng-if="!vm.objectTestSetting.manual"><div class="form-group"><label translate="jotApp.objectTestSetting.timeSpan" for="field_timeSpan">Period</label><div id="field_timeSpan" style="display: -webkit-box;"><input style="width: 200px;" type="number" class="form-control" name="timeSpan" ng-model="vm.timeSpan.period" type="number" min="0" max="200" ng-disabled="vm.timeSpan.time == \'Last value\'"> <select style="width: 200px; height: 34px;" name="time" id="field_time" ng-model="vm.timeSpan.time" ng-options="periodUnit as periodUnit for periodUnit in vm.periodUnit" ng-change="vm.checkTimePeriod()" required></select></div><div ng-show="editForm.time.$invalid"><p class="help-block" ng-show="editForm.time.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.index" for="field_index">Index</label> <select id="field_index" name="index" ng-model="vm.objectTestSetting.index" class="form-control" required><option value="JoT">JoT</option><option value="TheTailKeepalive">TheTail Keepalive</option><option value="TheTailScreenshot">TheTail Screenshot</option></select><div ng-show="editForm.index.$invalid"><p class="help-block" ng-show="editForm.index.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.objectTestSetting.testTag" for="field_testTag">Tag</label><ui-select id="field_testTag" name="testSettingTag" ng-model="vm.objectTestSetting.testSettingTag" theme="bootstrap" required><ui-select-match placeholder="Select or search a tag..">{{$select.selected.testTag}}</ui-select-match><ui-select-choices repeat="item in vm.testsTag | filter: {testTag: $select.search}" refresh-delay="1"><div ng-bind-html="item.testTag| highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.testSettingTag.$invalid"><p class="help-block" ng-show="editForm.testSettingTag.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" for="field_level">User Profile</label><ui-select id="field_level" name="userProfile" ng-model="vm.objectTestSetting.userProfile" theme="bootstrap" required><ui-select-match placeholder="Select a user profile...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.testsTag2 track by $index"><div>{{item.name}}</div></ui-select-choices></ui-select><div ng-show="editForm.userProfile.$invalid"><p class="help-block" ng-show="editForm.userProfile.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="form-actions"><button type="button" class="btn btn-primary" ng-click="vm.newTag()"><span class="fa fa-tag"></span>&nbsp;<span translate="entity.action.createTag">Create new Tag</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/object-test-setting/object-test-setting-edit-tag.html','<div class="app-content-body"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><h1 class="page-title"><button type="submit" ui-sref="object-test-setting" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.objectTestSetting.home.edit">Edit Tag</span></h1><div class="row" ng-if="vm.tags.length > 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Tags</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.newTag()"><span class="fa fa-tag"></span>&nbsp; <span translate="entity.action.createTag">Create new Tag</span></button></div></div><div class="portlet light filter-portlet bordered"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th><span>Tag</span></th><th has-authority="ROLE_ADMIN"><span>Domain Tag</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tag in vm.tags track by tag.id"><td ng-click="tag.id != 1 ? vm.enableEditor($index, 0) : false"><div ng-hide="vm.editorEnabled[$index]">{{tag.testTag || \'empty\'}}</div><div ng-show="vm.editorEnabled[$index]" class="col-md-12 col-xs-12"><input type="text" class="col-md-12 col-xs-12 input-group" value="{{tag.testTag}}" ng-model="vm.updateDescription[$index]"></div></td><td has-authority="ROLE_ADMIN"><span ng-class="tag.domain ? \'label label-success\' : \'label label-danger\'">{{tag.domain != null}}</span></td><td class="text-center"><button class="btn btn-primary btn-sm" ng-if="!vm.editorEnabled[$index]" ng-click="vm.enableEditor($index, 1)" ng-disabled="tag.id == 1"><i class="fa fa-pencil"></i> <span translate="entity.action.edit">Edit</span></button> <button type="submit" ng-if="vm.editorEnabled[$index]" class="btn btn-sm btn-primary" ng-click="vm.saveUpdate($index)"><i class="fa fa-check"></i></button> <button type="button" ng-if="vm.editorEnabled[$index]" class="btn btn-sm btn-default" ng-click="vm.enableEditor($index, 2)"><i class="fa fa-times"></i></button> <button class="btn btn-primary btn-sm" ui-sref="object-test-setting-edit-tag.delete({id:tag.id})" ng-disabled="tag.id == 1"><i class="glyphicon glyphicon-remove-sign"></i> <span translate="entity.action.delete">Delete</span></button></td></tr></tbody></table></div></div></div></div></div><div class="row" ng-if="vm.tags.length === 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>No editable tags.</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.newTag()"><span class="fa fa-tag"></span>&nbsp; <span translate="entity.action.createTag">Create new Tag</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/object-test-setting/object-test-setting-tag-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tag.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.objectTestSetting.deleteTag.question" translate-values="{name: \'{{vm.tag.testTag}}\'}">This operation will delete your tag. Are you sure?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/object-test-setting/object-test-setting.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="object-test-setting-edit-tag"><i class="fa fa-tag"></i> &nbsp; <span translate="jotApp.objectTestSetting.home.edit">Create new Test</span></button> <button type="button" class="btn btn-primary" ui-sref="object-test-setting-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.objectTestSetting.home.createLabel">Create new Test</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><form class="horizontal-form"><div class="row"><div class="col-md-3 col-xs-6"><div class="form-group"><label>Fleets</label><ui-select on-select="vm.loadObjectType()" ng-model="vm.filterFleet" theme="bootstrap"><ui-select-match placeholder="Select or search a fleet...">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}" refresh-delay="1"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-3 col-xs-6"><div class="form-group"><label>Object Type</label><ui-select ng-model="vm.filterType" theme="bootstrap"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}" refresh-delay="1"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-3 col-xs-6"><div class="form-group"><label class="control-label ng-scope" translate="jotApp.objectTestSetting.testTag" for="field_tabFleets">Tag</label><div ng-dropdown-multiselect="" name="testsTag" events="vm.tagsListEvent" ng-model="vm.filterTag" required id="field_tabFleets" options="vm.testsTag" extra-settings="vm.tagListSettings" translation-texts="vm.tagListSettings" selected-model="vm.filterTagSelected" ng-change="vm.applyTagsFilter()"></div></div></div><div class="col-md-3 col-xs-6 inline-filter-button"><div class="form-actions right"><button type="submit" class="btn btn-primary" ng-click="vm.applyTagsFilter()"><i class="fa fa-filter"></i> Filter</button></div></div><div class="col-md-3 col-xs-6 inline-filter-button"><div class="dataTables_filter"><label><input ng-change="vm.search()" ng-model-options="{ debounce: 800 }" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div></form><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="index"><span translate="jotApp.objectTestSetting.index">Index</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="name"><span translate="jotApp.objectTestSetting.name">Test Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="metric"><span translate="jotApp.objectTestSetting.metric">Metric</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="checkType"><span translate="jotApp.objectTestSetting.checkType">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="expectedValue"><span translate="jotApp.objectTestSetting.expectedValue">Expected Value</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="timeSpan"><span translate="jotApp.objectTestSetting.timeSpan">Period</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="aggregation"><span translate="jotApp.objectTestSetting.aggregation">Aggregation</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="secondaryMetric"><span translate="jotApp.objectTestSetting.secondaryMetric">Secondary Metric</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="secondaryMetricExpectedValue"><span translate="jotApp.objectTestSetting.secondaryMetricExpectedValue">Secondary Metric Expected Value</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.objectTestSetting.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.objectTestSetting.tabFleets">Tab Fleets</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabObjectTypes.objectTypeName"><span translate="jotApp.objectTestSetting.tabObjectTypes">Tab Object Types</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="testSettingTag.testTag"><span translate="jotApp.objectTestSetting.testTag">Tag</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Associated User Profile</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="objectTestSetting in vm.objectTestSettings track by objectTestSetting.id"><td>{{objectTestSetting.index}}</td><td ng-bind-html="objectTestSetting.name | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.metric | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.manual? \'Manual\' : objectTestSetting.checkType | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.expectedValue | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.timeSpan | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.aggregation + (objectTestSetting.valueToCheck !== null ? \' (\' + objectTestSetting.valueToCheck + \')\' : \'\') | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.secondaryMetric | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.secondaryMetricExpectedValue | highlight:vm.charToSearch"></td><td ng-bind-html="objectTestSetting.description | highlight:vm.charToSearch"></td><td><a ui-sref="tab-fleets-detail({id: {{objectTestSetting.tabFleets.id}}})">{{objectTestSetting.tabFleets.fleetName}}</a></td><td><a ui-sref="tab-object-types-detail({id:objectTestSetting.tabObjectTypes.id})" ng-bind-html="objectTestSetting.tabObjectTypes.objectTypeName | highlight:vm.charToSearch"></a></td><td ng-bind-html="objectTestSetting.testSettingTag.testTag | highlight:vm.charToSearch"></td><td>{{objectTestSetting.userProfile.name}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="object-test-setting-edit({id:objectTestSetting.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="object-test-setting-clone({id:objectTestSetting.id})"><i class="fa fa-clone"></i><span translate="entity.action.clone"></span></a></li><li><a href="javascript:;" ui-sref="object-test-setting.delete({id:objectTestSetting.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/publishMessage/publishMessage.html','<div class="app-content-body queue-page"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="form-group"><label class="control-label" translate="jotApp.publishMessage.topic" for="field_topic">Topic</label> <input type="text" class="form-control" name="topic" id="field_topic" ng-model="vm.topic" required placeholder="Insert Topic"><div ng-show="editForm.topic.$invalid"><p class="help-block" ng-show="editForm.topic.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="jotApp.publishMessage.message" for="field_message">Topic</label> <input type="text" class="form-control" name="message" id="field_message" ng-model="vm.message" required placeholder="Insert Message"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.send">Send</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/queue/queues-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.queues.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete this Queue: {{vm.queues.alias}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/queue/queues-detail.html','<div class="app-content-body commands-management-page queues-detail"><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="queues" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.Queue.detail.title" translate-values="{param: \'{{vm.queue.alias}}\'}">Queue: {{vm.queue.alias}}</span></h1><h3>Object Unique Code: <b>{{vm.queue.queueCommands[0].objects.objectUniqueCode}}</b><br>Object Name: <b>{{vm.queue.queueCommands[0].objects.objectName}}</b></h3></div></div><div class="row" ng-repeat="timeline in vm.timelines track by $index"><div id="timeline"><div class="dot" ng-repeat="command in timeline" style="left: {{vm.findIndexCommand(command, timeline)}}%" ng-class="((command.queueCommandStatus.status == \'ok\') ? \'bg-online\' : ((command.queueCommandStatus.status == \'warning\') ?  \'bg-warning\' : ((command.queueCommandStatus.status == \'ko\') ?  \'bg-offline\' : ((command.queueCommandStatus.status == \'unknown\') ?  \'bg-unknown\' : \'bg-untracked\' ))))" ng-click="vm.printCommand(command, $parent.$index)" title="{{command.queueCommandStatus.status}}"><span class="text-center"><i class="glyphicon glyphicon-ok" ng-if="command.queueCommandStatus.status == \'ok\'"></i> <i class="glyphicon glyphicon-remove" ng-if="command.queueCommandStatus.status == \'ko\'"></i> <i class="glyphicon glyphicon-share" ng-if="command.queueCommandStatus.status == \'working\'"></i> <i class="glyphicon glyphicon-pause" ng-if="command.queueCommandStatus.status == \'waiting\'"></i> <i class="glyphicon glyphicon-alert" ng-if="command.queueCommandStatus.status == \'warning\'"></i> <i class="glyphicon glyphicon-flag" ng-if="command.queueCommandStatus.status == \'unknown\'"></i></span><date ng-class="{\'even\': !$even, \'odd\': $even}">{{vm.getActionDisplayName(command)}}</date></div></div><div ng-if="vm.showCommand[$index]"><p ng-if="vm.command.executionDatetime != null && !vm.queue.stopped">Execution Date: {{vm.command.executionDatetime | date: \'dd-MM-yyyy HH:mm\'}}</p><p ng-if="vm.command.executionDatetime != null && vm.queue.stopped">Execution Date: Queue Stopped</p><p ng-if="vm.isEmpty(vm.command.argumentMap)">Arguments:<br><span ng-repeat="(key, value) in vm.command.argumentMap"><b>{{key}}</b> : {{value}}<br></span></p><p ng-if="vm.command.response != null">Response: {{vm.command.response}}</p></div></div></div>');
$templateCache.put('app/entities/queue/queues-forced-dialog.html','<form name="deleteForm" ng-submit="vm.confirmForced(vm.queue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.forced.title">Confirm forced operation</h4></div><div class="modal-body"><p>Are you sure to complete this Queue: {{vm.queue.alias}}?</p><p>All commands will be forced.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.forced">Complete</span></button></div></form>');
$templateCache.put('app/entities/queue/queues-stop-dialog.html','<form name="deleteForm" ng-submit="vm.confirmStop(vm.queue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.stop.title">Confirm Stop operation</h4></div><div class="modal-body"><p>Are you sure to stop this Queue: {{vm.queue.alias}}?</p><p>When you restart it all commands will be sent again.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.stop">Stop</span></button></div></form>');
$templateCache.put('app/entities/queue/queues.html','<div class="app-content-body queue-page"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form no-action-border"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" for="status">Status</label> <select class="form-control" id="status" name="status" ng-model="vm.filter.status" chosen disable-search="true"><option label="ALL" value="all">ALL</option><option label="OK" value="ok">OK</option><option label="KO" value="ko">KO</option><option label="WORKING" value="working">WORKING</option><option label="WAITING" value="waiting">WAITING</option><option label="WARNING" value="warning">WARNING</option><option label="UNKNOWN" value="unknown">UNKNOWN</option></select></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="object_field">Object Unique Code</label><ui-select on-select="vm.selectObject($item)" ng-model="vm.obj" ng-keyup="vm.searchObj($select.search, false)" ng-paste="vm.searchObj($event.originalEvent, true)" id="object_field" theme="bootstrap"><ui-select-match placeholder="Select an Object Unique Code...">{{$select.selected.objectUniqueCode}}</ui-select-match><ui-select-choices repeat="item in vm.objects | propsFilter: {objectUniqueCode: $select.search, objectName: $select.search}" percent="90" when-scrolled="vm.loadPageObject(vm.objectPage + 1)"><div ng-bind-html="item.objectUniqueCode | highlight: $select.search"></div><small ng-bind-html="item.objectName | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group"><label for="range">Range</label><div class="input-group" id="range"><span class="input-group-addon" ng-click="vm.picker.start=true">FROM</span> <input type="text" id="start" class="form-control" ng-click="vm.picker.start=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.filter.start" is-open="vm.picker.start"> <span class="input-group-addon" ng-click="vm.picker.end=true">TO</span> <input type="text" id="end" class="form-control" ng-click="vm.picker.end=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.filter.stop" is-open="vm.picker.end"></div></div></div></div><div class="form-actions right"><button class="btn btn-primary" ng-click="vm.applyFilter()"><i class="fa fa-search"></i> Apply</button> <button class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model-options="{debounce: 1000}" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Name/CreatedBy..."><!-- ng-keyup="($event.keyCode == 13) ? vm.search() : \'\'"  placeholder="Press Enter To Search by Name/CreatedBy..." OR\n                    ng-model-options="{debounce: 1000}" ng-change="vm.search()" OR\n                    we could add an apply search button--></label></div></div></div></div></div><div class="row" ng-if="vm.checkQueueEmpty"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>No commands sent for this domain.</span></div></div></div></div></div><div class="row" ng-if="vm.now.length != 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Now</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.Queue.aliasGroup">Queue Name</span></th><th><span translate="jotApp.Queue.object">Object</span></th><th><span translate="jotApp.Queue.aliasProgress">Progress</span></th><th><span translate="jotApp.Queue.createdBy">Created by</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="now in vm.now"><!--  | filter:vm.searchText track by now.alias  --><td class="table-queue-name" ng-bind-html="now.alias | highlight: vm.charToSearch"></td><td class="table-queue-name">{{now.queueCommands[0].objects.objectUniqueCode}}</td><td><div class="progress" style="width: 375px"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width:{{now.execCount*100/now.size}}%" ng-class="((now.queueCommandStatus.status == \'ok\') ? \'bg-online\' : ((now.queueCommandStatus.status == \'warning\') ?  \'bg-warning\' : (now.queueCommandStatus.status == \'ko\') ?  \'bg-offline\' : \'bg-untracked\' ))"><span ng-if="now.execCount != 0">{{now.execCount}}\\{{now.size}}</span></div></div></td><td ng-bind-html="now.created | highlight: vm.charToSearch"></td><td class="text-center"><div class="btn-group icon-table-queue"><span ui-sref="queues.delete({id:now.id, name:now.alias})" title="Delete Queue" ng-if="now.queueCommandStatus.status == \'waiting\'"><i class="glyphicon glyphicon-remove-sign"></i> </span><span ng-click="vm.forceCompletion(now)" title="Complete queue" ng-if="now.queueCommandStatus.status == \'working\'"><i class="glyphicon glyphicon-flag"></i> </span><span ui-sref="queues-detail({id: now.id})" title="Queue Detail"><i class="glyphicon glyphicon-eye-open"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemNowPage" total="vm.systemNowQueryCount" limit="vm.systemItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemItemLimit" total-items="vm.systemNowTotalItems" ng-model="vm.systemNowPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row" ng-if="vm.once.length != 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Once</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.Queue.aliasGroup">Queue Name</span></th><th><span translate="jotApp.Queue.object">Object</span></th><th><span translate="jotApp.Queue.aliasProgress">Progress</span></th><th><span translate="jotApp.Queue.aliasOnceExecution">Execution Date</span></th><th><span translate="jotApp.Queue.createdBy">Created by</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="once in vm.once"><td class="table-queue-name" ng-bind-html="once.alias | highlight: vm.charToSearch"></td><td class="table-queue-name">{{once.queueCommands[0].objects.objectUniqueCode}}</td><td class="table-queue-progress"><div class="progress" style="width: 375px"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width:{{once.execCount*100/once.size}}%" ng-class="((once.queueCommandStatus.status == \'ok\') ? \'bg-online\' : ((once.queueCommandStatus.status == \'warning\') ?  \'bg-warning\' : (once.queueCommandStatus.status == \'ko\') ?  \'bg-offline\' : \'bg-untracked\' ))"><span ng-if="once.execCount != 0">{{once.execCount}}\\{{once.size}}</span></div></div></td><td>{{once.queueCommands[vm.findIndexDate(once.queueCommands)].executionDatetime | date: \'dd-MM-yyyy HH:mm\'}}</td><td ng-bind-html="once.created | highlight: vm.charToSearch"></td><td class="text-center"><div class="btn-group icon-table-queue"><span ui-sref="queues.delete({id:once.id, name:once.alias})" title="Delete Queue" ng-if="(once.queueCommandStatus.status == \'waiting\' || once.queueCommandStatus.status == \'working\')"><i class="glyphicon glyphicon-remove-sign"></i> </span><span ng-click="vm.forceCompletion(once)" title="Complete queue" ng-if="once.queueCommandStatus.status == \'waiting\' || once.queueCommandStatus.status == \'working\'"><i class="glyphicon glyphicon-flag"></i> </span><span ui-sref="queues-detail({id: once.id})" title="Queue Detail"><i class="glyphicon glyphicon-eye-open"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemOncePage" total="vm.systemOnceQueryCount" limit="vm.systemItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemItemLimit" total-items="vm.systemOnceTotalItems" ng-model="vm.systemOncePage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row" ng-if="vm.scheduled.length != 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Scheduled</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.Queue.aliasGroup">Queue Name</span></th><th><span translate="jotApp.Queue.object">Object</span></th><th><span translate="jotApp.Queue.aliasProgress">Progress</span></th><th><span translate="jotApp.Queue.aliasCondition">Condition</span></th><th><span translate="jotApp.Queue.aliasExecution">Next Execution</span></th><th><span translate="jotApp.Queue.createdBy">Created by</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="scheduled in vm.scheduled"><td class="table-queue-name" ng-bind-html="scheduled.alias | highlight:vm.charToSearch"></td><td class="table-queue-name">{{scheduled.queueCommands[0].objects.objectUniqueCode}}</td><td class="table-queue-progress"><div class="progress" style="width: 375px"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width:{{scheduled.execCount*100/scheduled.size}}%" ng-class="((scheduled.queueCommandStatus.status == \'ok\') ? \'bg-online\' : ((scheduled.queueCommandStatus.status == \'warning\') ?  \'bg-warning\' : (scheduled.queueCommandStatus.status == \'ko\') ?  \'bg-offline\' : \'bg-untracked\' ))"><span ng-if="scheduled.execCount != 0">{{scheduled.execCount}}\\{{scheduled.size}}</span></div></div></td><td class="table-queue-condition"><span ng-if="!scheduled.stopped && scheduled.repeat.split(\' at \')[1] != undefined">{{scheduled.repeat.split(" at ")[0]}} at {{scheduled.repeat.split(" at ")[1] | utcToLocal: \'HH:mm\'}}</span> <span ng-if="!scheduled.stopped && scheduled.repeat.split(\' at \')[1] == undefined">{{scheduled.repeat}}</span></td><td><span ng-if="!scheduled.stopped">{{scheduled.queueCommands[vm.findIndexDate(scheduled.queueCommands)].executionDatetime | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td ng-bind-html="scheduled.created | highlight:vm.charToSearch"></td><td class="text-center"><div class="btn-group icon-table-queue"><span ui-sref="queues.delete({id:scheduled.id, name:scheduled.alias})" title="Delete Queue" ng-if="(scheduled.queueCommandStatus.status == \'waiting\' || scheduled.queueCommandStatus.status == \'working\')"><i class="glyphicon glyphicon-remove-sign"></i> </span><span title="{{vm.showCron(scheduled.stopped)}}" ng-click="vm.muteCron(scheduled)"><i class="glyphicon glyphicon-play" ng-if="scheduled.stopped"></i> <i class="glyphicon glyphicon-stop" ng-if="!scheduled.stopped"></i> </span>&nbsp; <span ng-click="vm.forceCompletion(scheduled)" title="Complete queue" ng-if="scheduled.queueCommandStatus.status == \'waiting\' || scheduled.queueCommandStatus.status == \'working\'"><i class="glyphicon glyphicon-flag"></i> </span><span ui-sref="queues-detail({id: scheduled.id})" title="Queue Detail"><i class="glyphicon glyphicon-eye-open"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemScheduledPage" total="vm.systemScheduledQueryCount" limit="vm.systemItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemItemLimit" total-items="vm.systemScheduledTotalItems" ng-model="vm.systemScheduledPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row" ng-if="vm.completed.length != 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Completed</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.Queue.aliasGroup">Queue Name</span></th><th><span translate="jotApp.Queue.object">Object</span></th><th><span translate="jotApp.Queue.aliasProgress">Progress</span></th><th><span translate="jotApp.Queue.aliasLDate">Last Date</span></th><th><span translate="jotApp.Queue.aliasStatus">Status</span></th><th><span translate="jotApp.Queue.createdBy">Created by</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="completed in vm.completed"><td class="table-queue-name" ng-bind-html="completed.alias | highlight:vm.charToSearch"></td><td class="table-queue-name">{{completed.queueCommands[0].objects.objectUniqueCode}}</td><td class="table-queue-progress"><div class="progress" style="width: 375px"><div class="progress-bar progress-bar-striped progress-bar-animated" style="width:{{completed.execCount*100/completed.size}}%" ng-class="((completed.queueCommandStatus.status == \'ok\') ? \'bg-online\' : ((completed.queueCommandStatus.status == \'warning\') ?  \'bg-warning\' : ((completed.queueCommandStatus.status == \'ko\') ?  \'bg-offline\' : ((completed.queueCommandStatus.status == \'unknown\') ?  \'bg-unknown\' : \'bg-untracked\' ))))"><span ng-if="completed.execCount != 0">{{completed.execCount}}\\{{completed.size}}</span></div></div></td><td class="table-queue-condition">{{completed.lastDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td>{{completed.queueCommandStatus.status}}</td><td ng-bind-html="completed.created | highlight:vm.charToSearch"></td><td class="text-center"><div class="btn-group icon-table-queue"><span has-authority="ROLE_ADMIN" ui-sref="queues.delete({id:completed.id, name:completed.alias})" title="Delete Queue"><i class="glyphicon glyphicon-remove-sign"></i> </span><span ui-sref="queues-detail({id: completed.id})" title="Queue Detail"><i class="glyphicon glyphicon-eye-open"></i></span></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemCompletedPage" total="vm.systemCompletedQueryCount" limit="vm.systemItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemItemLimit" total-items="vm.systemCompletedTotalItems" ng-model="vm.systemCompletedPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-releases/scripts-releases-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scriptsReleases.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.scriptsReleases.delete.question" translate-values="{id: \'{{vm.scriptsReleases.id}}\'}">Are you sure you want to delete this Tab Device Releases?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/scripts-releases/scripts-releases-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.scriptsReleases.detail.title">Tab Device Release</span> {{vm.scriptsReleases.scriptsReleaseName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.scriptsReleases.scriptsReleaseName">Device Release Name</span></dt><dd><span>{{vm.scriptsReleases.scriptsReleaseName}}</span></dd><dt><span translate="jotApp.scriptsReleases.scriptsReleaseDescription">Device Release Description</span></dt><dd><span>{{vm.scriptsReleases.scriptsReleaseDescription}}</span></dd><dt><span translate="jotApp.scriptsReleases.isActive">Is Active</span></dt><dd><span>{{vm.scriptsReleases.isActive}}</span></dd><dt><span translate="jotApp.scriptsReleases.scriptsReleaseVersion">Device Release Version</span></dt><dd><span>{{vm.scriptsReleases.scriptsReleaseVersion}}</span></dd><dt><span translate="jotApp.scriptsReleases.scriptsType">Device</span></dt><dd><a ui-sref="scripts-types-detail({id:vm.scriptsReleases.scriptsTypes.id})">{{vm.scriptsReleases.scriptsTypes.scriptsTypeName}}</a></dd><dt><span translate="jotApp.scriptsReleases.createdBy">Created By</span></dt><dd><span>{{vm.scriptsReleases.createdBy}}</span></dd><dt><span translate="jotApp.scriptsReleases.createdDate">Created Date</span></dt><dd><span>{{vm.scriptsReleases.createdDate | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.scriptsReleases.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.scriptsReleases.lastModifiedBy}}</span></dd><dt><span translate="jotApp.scriptsReleases.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.scriptsReleases.lastModifiedDate | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-releases/scripts-releases-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.scriptsReleases.home.createOrEditLabel">Create or edit a Device Releases</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.scriptsReleaseName" for="field_scriptsReleaseName">Device Release Name</label> <input type="text" class="form-control" name="scriptsReleaseName" id="field_scriptsReleaseName" ng-model="vm.scriptsReleases.scriptsReleaseName" required ng-disabled="vm.scriptsReleases.id!=null" ng-maxlength="50"><div ng-show="editForm.scriptsReleaseName.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsReleaseName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.scriptsReleaseDescription" for="field_scriptsReleaseDescription">Device Release Description</label> <input type="text" class="form-control" name="scriptsReleaseDescription" id="field_scriptsReleaseDescription" ng-model="vm.scriptsReleases.scriptsReleaseDescription" ng-maxlength="255"><div ng-show="editForm.scriptsReleaseDescription.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.scriptsReleases.scriptsType" for="field_scriptsTypes">Scripts type</label><ui-select id="field_scriptsTypes" name="scriptsTypes" ng-model="vm.scriptsReleases.scriptsTypes" theme="bootstrap" search-enabled="false" required><ui-select-match placeholder="Select a scriptsTypes...">{{$select.selected.scriptsTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.scriptsTypes track by item.id" percent="90" when-scrolled="vm.loadPage(vm.page + 1)"><div ng-bind-html="item.scriptsTypeName"></div></ui-select-choices></ui-select><div ng-show="editForm.scriptsTypes.$invalid"><p class="help-block" ng-show="editForm.scriptsTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.scriptsReleaseVersion" for="field_scriptsReleaseVersion">Device Release Version</label> <input type="text" class="form-control" name="scriptsReleaseVersion" id="field_scriptsReleaseVersion" ng-model="vm.scriptsReleases.scriptsReleaseVersion" required ng-disabled="vm.scriptsReleases.id!=null" ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.scriptsReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p><p class="help-block" ng-show="editForm.scriptsReleaseName.$error.pattern">This field must match the git versioning pattern major.minor.patch</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.scriptsReleases.isActive"> <span></span><div translate="jotApp.scriptsReleases.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.inlineEditor" for="field_fileContentRaw">Inline Editor</label><div class="form-control" id="field_fileContentRaw" ui-ace="{rendererOptions: { fontSize: 14 }}" ng-model="vm.fileContentRaw" ng-change="vm.setFileFromEditor()" style="height: 400px"></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-releases/scripts-releases-enable-dialog.html','<form name="enableForm" ng-submit="vm.confirmEnable()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.enable.title">Confirm enable operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.scriptsReleases.enable.question" translate-values="{version: \'{{vm.scriptsReleases.scriptsReleaseVersion}}\', name: \'{{vm.scriptsReleases.scriptsReleaseName}}\'}">Are you sure you want to enable this Device Release Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="enableForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-check"></span>&nbsp;<span translate="entity.action.enable">Enable</span></button></div></form>');
$templateCache.put('app/entities/scripts-releases/scripts-releases-upgrade.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.scriptsReleases.home.upgradeVersion">Upgrade Device Releases Version</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.scriptsReleaseName" for="field_scriptsReleaseName">scripts Release Name</label> <input type="text" class="form-control" name="scriptsReleaseName" id="field_scriptsReleaseName" ng-model="vm.scriptsReleases.scriptsReleaseName" required ng-maxlength="50" ng-disabled="true"><div ng-show="editForm.scriptsReleaseName.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsReleaseName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.scriptsReleaseDescription" for="field_scriptsReleaseDescription">Device Release Description</label> <input type="text" class="form-control" name="scriptsReleaseDescription" id="field_scriptsReleaseDescription" ng-model="vm.scriptsReleases.scriptsReleaseDescription" ng-maxlength="255"><div ng-show="editForm.scriptsReleaseDescription.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.currentVersion" for="field_currentVersion">Current Version</label> <input type="text" class="form-control" name="scriptsReleaseVersion" id="field_currentVersion" value="{{::vm.scriptsReleases.scriptsReleaseVersion}}" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.newVersion" for="field_scriptsReleaseVersion">New Version</label> <input type="text" class="form-control" name="scriptsReleaseVersion" id="field_scriptsReleaseVersion" ng-model="vm.scriptsReleases.scriptsReleaseVersion" required ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.scriptsReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.scriptsReleases.scriptsType" for="field_scriptsTypes">Device</label> <select class="form-control" id="field_scriptsTypes" name="scriptsTypes" ng-model="vm.scriptsReleases.scriptsTypes" ng-options="scriptsTypes as scriptsTypes.scriptsTypeName for scriptsTypes in vm.scriptsTypes | orderBy:\'id\' track by scriptsTypes.id" ng-disabled="true"><option value=""></option></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.scriptsReleases.isActive"> <span></span><div translate="jotApp.scriptsReleases.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsReleases.inlineEditor" for="field_fileContentRaw">Inline Editor</label><div class="form-control" id="field_fileContentRaw" ui-ace="{rendererOptions: { fontSize: 14 }}" ng-model="vm.fileContentRaw" ng-change="vm.setFileFromEditor()" style="height: 400px"></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-releases/scripts-releases.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.scriptsReleases.home.title">Scripts Releases</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.search()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="objectType_field">Object Type</label><ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="scripts_field">ScriptsTypes</label><ui-select ng-model="vm.scriptTypes" id="scripts_field" theme="bootstrap"><ui-select-match placeholder="Select or search a scripts...">{{$select.selected.scriptsTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.scriptsTypes | filter: {scriptsTypeName: $select.search}"><div ng-bind-html="item.scriptsTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-2 inline-filter-button"><div class="form-group"><label class="control-label ng-scope" for="submit_field"></label> <button type="submit" id="submit_field" class="btn btn-primary"><span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span></button></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-upload"></i> <span translate="jotApp.scriptsReleases.home.portletTitle">Scripts Releases List</span></div><div class="actions"><button type="button" class="btn btn-primary" ui-sref="scripts-releases-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.scriptsReleases.home.createLabel">Create new Scripts Releases</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column" data-detail-view="true"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th class="open-row-col"></th><th multi-sort-by="scriptsReleaseName"><span translate="jotApp.scriptsReleases.scriptsReleaseName">Scripts Release Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scriptsReleaseDescription"><span translate="jotApp.scriptsReleases.scriptsReleaseDescription">Scripts Release Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="isActive"><span translate="jotApp.scriptsReleases.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scriptsReleaseVersion"><span translate="jotApp.scriptsReleases.scriptsReleaseVersion">Scripts Release Version</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scriptsType.scriptsName"><span translate="jotApp.scriptsReleases.scriptsType">Scripts Types</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat-start="scriptsReleases in vm.scriptsReleases | filter:vm.searchText track by scriptsReleases.id"><td class="open-row-col" ng-click="scriptsReleases.expanded = !scriptsReleases.expanded"><div ng-if="vm.scriptsReleasesInactive[scriptsReleases.scriptsReleaseName].length > 0"><i ng-if="!scriptsReleases.expanded" class="fa fa-plus-square"></i> <i ng-if="scriptsReleases.expanded" class="fa fa-minus-square" aria-hidden="true"></i></div></td><td ng-click="scriptsReleases.expanded = !scriptsReleases.expanded">{{scriptsReleases.scriptsReleaseName}}</td><td ng-click="scriptsReleases.expanded = !scriptsReleases.expanded">{{scriptsReleases.scriptsReleaseDescription}}</td><td ng-click="scriptsReleases.expanded = !scriptsReleases.expanded"><span class="label label-danger" ng-show="!scriptsReleases.isActive">{{scriptsReleases.isActive}}</span> <span class="label label-success" ng-show="scriptsReleases.isActive">{{scriptsReleases.isActive}}</span></td><td>{{scriptsReleases.scriptsReleaseVersion}}</td><td ng-click="scriptsReleases.expanded = !scriptsReleases.expanded"><a ui-sref="scripts-types-detail({id:scriptsReleases.scriptsTypes.id})">{{scriptsReleases.scriptsTypes.scriptsTypeName}}</a></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="scripts-releases-detail({id:scriptsReleases.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="scripts-releases-edit({id:scriptsReleases.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li ng-if="!scriptsReleases.isActive"><a href="javascript:;" ui-sref="scripts-releases.enable({id:scriptsReleasesInactive.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="scripts-releases-upgrade({id:scriptsReleases.id})"><i class="fa fa-plus"></i><span translate="entity.action.upgrade"></span></a></li><li ng-if="!scriptsReleases.isActive"><a href="javascript:;" ui-sref="scripts-releases.delete({id:scriptsReleases.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="scriptsReleases.expanded" ng-repeat="scriptsReleasesInactive in vm.scriptsReleasesInactive[scriptsReleases.scriptsReleaseName]"><td class="open-row-col"></td><td><i class="fa fa-circle" aria-hidden="true"></i></td><td>{{scriptsReleasesInactive.scriptsReleaseDescription}}</td><td><span class="label label-danger" ng-show="!scriptsReleasesInactive.isActive">{{scriptsReleasesInactive.isActive}}</span> <span class="label label-success" ng-show="scriptsReleasesInactive.isActive">{{scriptsReleasesInactive.isActive}}</span></td><td>{{scriptsReleasesInactive.scriptsReleaseVersion}}</td><td><a ui-sref="scripts-types-detail({id:scriptsReleasesInactive.scriptsType.id})">{{scriptsReleasesInactive.scriptsType.scriptsTypeName}}</a></td><td><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="scripts-releases-detail({id:scriptsReleasesInactive.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="scripts-releases-edit({id:scriptsReleasesInactive.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="scripts-releases.enable({id:scriptsReleasesInactive.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="scripts-releases.delete({id:scriptsReleasesInactive.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="false" ng-repeat-end=""></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-types/scripts-types-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scriptsTypes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.scriptsTypes.delete.question" translate-values="{id: \'{{vm.scriptsTypes.deviceTypeName}}\'}">Are you sure you want to delete this Tab Devices Types?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/scripts-types/scripts-types-detail.html','<div class="app-content-body detail-page scriptss-types-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.scriptsTypes.detail.title">Tab Devices Types</span> {{vm.scriptsTypes.scriptsTypeName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.scriptsTypes.scriptsTypeName">Device Type Name</span></dt><dd><span>{{vm.scriptsTypes.scriptsTypeName}}</span></dd><dt><span translate="jotApp.scriptsTypes.scriptsTypeDescription">Device Type Description</span></dt><dd><span>{{vm.scriptsTypes.scriptsTypeDescription}}</span></dd><dt><span translate="jotApp.scriptsTypes.createdBy">Created By</span></dt><dd><span>{{vm.scriptsTypes.createdBy}}</span></dd><dt><span translate="jotApp.scriptsTypes.createdDate">Created Date</span></dt><dd><span>{{vm.scriptsTypes.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.scriptsTypes.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.scriptsTypes.lastModifiedBy}}</span></dd><dt><span translate="jotApp.scriptsTypes.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.scriptsTypes.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-types/scripts-types-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.scriptsTypes.home.createOrEditLabel">Create or edit a Device Type</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsTypes.scriptsTypeName" for="field_scriptsTypeName">Device Type Name</label> <input type="text" class="form-control" name="scriptsTypeName" id="field_scriptsTypeName" ng-model="vm.scriptsTypes.scriptsTypeName" required ng-maxlength="50"><div ng-show="editForm.scriptsTypeName.$invalid"><p class="help-block" ng-show="editForm.scriptsTypeName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsTypeName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.scriptsTypes.scriptsTypeDescription" for="field_scriptsTypeDescription">Device Type Description</label> <input type="text" class="form-control" name="scriptsTypeDescription" id="field_scriptsTypeDescription" ng-model="vm.scriptsTypes.scriptsTypeDescription" ng-maxlength="255"><div ng-show="editForm.scriptsTypeDescription.$invalid"><p class="help-block" ng-show="editForm.scriptsTypeDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/scripts-types/scripts-types.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.scriptsTypes.home.title">Tab Devices Types</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-desktop"></i> <span translate="jotApp.scriptsTypes.home.portletTitle">Domains List</span></div><div class="actions"><button type="button" class="btn btn-primary" ui-sref="scripts-types-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.scriptsTypes.home.createLabel">Create new Tab Devices Types</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="scriptsTypeName"><span translate="jotApp.scriptsTypes.scriptsTypeName">Device Type Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scriptsTypeDescription"><span translate="jotApp.scriptsTypes.scriptsTypeDescription">Device Type Description</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="scriptsTypes in vm.scriptsTypes | filter:vm.searchText track by scriptsTypes.id"><td>{{scriptsTypes.scriptsTypeName}}</td><td>{{scriptsTypes.scriptsTypeDescription}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="scripts-types-detail({id:scriptsTypes.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="scripts-types-edit({id:scriptsTypes.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="scripts-types.delete({id:scriptsTypes.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-actions/tab-actions-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabActions.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabActions.delete.question" translate-values="{id: \'{{vm.tabActions.actionCommand}}\'}">Are you sure you want to delete this Tab Actions?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-actions/tab-actions-detail.html','<div class="app-content-body detail-page action-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabActions.detail.title">Tab Actions</span> {{vm.tabActions.actionCommand}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabActions.actionTarget">Action Command</span></dt><dd><span>{{vm.tabActions.deviceReleases.deviceReleaseName}}</span></dd><dt><span translate="jotApp.tabActions.actionCommand">Action Descrtiption</span></dt><dd><span>{{vm.tabActions.actionCommand}}</span></dd><dt><span translate="jotApp.tabActions.permissionLevel">Permission</span></dt><dd><span>{{vm.tabActions.permissionLevel}}</span></dd><div ng-repeat="(key, arg) in vm.arguments"><dt><span><b>{{key}}</b></span></dt><dd><div ng-repeat="(name, prop) in arg"><span>{{name}}</span> : {{prop}}</div></dd></div></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-actions/tab-actions.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.tabActions.home.title">Tab Actions</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-list"></i> <span translate="jotApp.tabActions.home.portletTitle">Actions List</span></div><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-fixed table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="actionCommand"><span translate="jotApp.tabActions.actionCommand">Command</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceReleases.deviceReleaseName"><span translate="jotApp.tabActions.actionTarget">Target</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceReleases.deviceReleaseVersion"><span translate="jotApp.tabDeviceReleases.deviceReleaseVersion">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="permissionLevel"><span translate="jotApp.tabActions.permissionLevel">Permission Level</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="tabActions in vm.tabActions | filter:vm.searchText track by tabActions.id"><td>{{tabActions.actionCommand}}</td><td><a ui-sref="tab-device-releases({id:tabActions.deviceRelease.id})">{{tabActions.deviceReleases.deviceReleaseName}}</a></td><td><a ui-sref="tab-device-releases({id:tabActions.deviceRelease.id})">{{tabActions.deviceReleases.deviceReleaseVersion}}</a></td><td>{{tabActions.permissionLevel}}</td><td class="text-center"><button class="hand btn btn-primary btn-sm" ui-sref="tab-actions-detail({id:tabActions.id})"><i class="fa fa-eye"></i> <span translate="entity.action.view">View</span></button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-actions-queue/tab-actions-queue-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabActionsQueue.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-if="!vm.tabActionsQueue.cron" translate="jotApp.tabActionsQueue.delete.question" translate-values="{id: \'{{vm.tabActionsQueue.actionCommand}}\'}">Are you sure you want to delete this Tab Actions Queue?</p><p ng-if="vm.tabActionsQueue.cron" translate="jotApp.tabActionsQueue.delete.cronQuestion" translate-values="{id: \'{{vm.tabActionsQueue.actionCommand}}\'}">Are you sure you want to delete this Tab Actions Queue?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-actions-queue/tab-actions-queue-detail.html','<div class="app-content-body detail-page action-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" ui-sref="tab-actions-queue({group: vm.group})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabActionsQueue.detail.title">Tab Actions Queue</span> {{vm.tabActionsQueue.action.actionCommand}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabActionsQueue.aliasGroup">Queue</span></dt><dd><span>{{vm.tabActionsQueue.aliasGroup}}</span></dd><dt><span translate="jotApp.tabActionsQueue.insertDateTime">Insert Date Time</span></dt><dd><span>{{vm.tabActionsQueue.insertDateTime | date:\'medium\'}}</span></dd><dt><span translate="jotApp.tabActionsQueue.executionCommand"></span></dt><dd><a ui-sref="tab-device-releases({id:vm.tabActionsQueue.action.deviceReleases.id})">{{vm.tabActionsQueue.action.deviceReleases.deviceReleaseName}}</a></dd><dt><span translate="jotApp.tabDeviceReleases.deviceReleaseVersion"></span></dt><dd><a ui-sref="tab-device-releases({id:vm.tabActionsQueue.action.deviceReleases.id})">{{vm.tabActionsQueue.action.deviceReleases.deviceReleaseVersion}}</a></dd><dt><span translate="jotApp.tabActionsQueue.object">Object</span></dt><dd><a ui-sref="tab-objects-detail({id:vm.tabActionsQueue.object.id})">{{vm.tabActionsQueue.object.objectName}}</a></dd><div ng-repeat="(key, value) in vm.tabActionsQueue.argumentMap"><dt><span>{{key}}</span></dt><dd><span>{{value}}</span></dd></div></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-actions-queue/tab-actions-queues.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6 col-lg-4"><div class="form-group"><label class="control-label" translate="jotApp.tabActionsQueue.home.search">Search</label><ui-select on-select="vm.selectObject($item)" ng-model="vm.obj" theme="bootstrap"><ui-select-match placeholder="Select or search an object..">{{$select.selected}}</ui-select-match><ui-select-choices repeat="item in vm.tabActionQueueGroups | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-6 col-lg-4" ng-if="vm.licence.id === 4"><div class="form-group"><label class="control-label" for="repeatable">Repeatable Type</label> <select class="form-control" id="repeatable" name="repeatable" ng-model="vm.repeatable" ng-change="vm.reset()"><option label="ALL" value="-1">ALL</option><option label="TRUE" value="1">TRUE</option><option label="FALSE" value="0">FALSE</option></select></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.selectObject(vm.obj)"><th multi-sort-by="executionCommand"><span translate="jotApp.tabActionsQueue.executionCommand">Execution Command</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="insertDateTime"><span translate="jotApp.tabActionsQueue.insertDateTime">Insert Date Time</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scheduleDateTime"><span translate="jotApp.tabActionsQueue.scheduleDateTime">Schedule Date Time</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="executionDateTime"><span translate="jotApp.tabActionsQueue.executionDateTime">Execution Date Time</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="action.actionCommand"><span translate="jotApp.tabActionsQueue.action">Action</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="aliasGroup"><span translate="jotApp.tabActionsQueue.aliasGroup">Group</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-if="vm.licence.id === 4"><span translate="jotApp.tabActionsQueue.repeatable">Repeatable</span></th><th multi-sort-by="actionState.actionStateName"><span translate="jotApp.tabActionsQueue.actionState">Action State</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="executedMessage"><span translate="jotApp.tabActionsQueue.executedMessage">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="object.objectName"><span translate="jotApp.tabActionsQueue.object">Object</span> <span class="glyphicon glyphicon-sort"></span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabActionsQueue in vm.tabActionsQueues"><td>{{tabActionsQueue.executionCommand}}</td><td>{{tabActionsQueue.insertDateTime | date:\'dd/MM/yy HH:mm\'}}</td><td>{{tabActionsQueue.scheduleDateTime | date:\'dd/MM/yy HH:mm\'}}</td><td>{{tabActionsQueue.executionDateTime | date:\'dd/MM/yy HH:mm\'}}</td><td>{{tabActionsQueue.action.actionCommand}}</td><td>{{tabActionsQueue.aliasGroup}}</td><td ng-if="vm.licence.id === 4"><span ng-show="!tabActionsQueue.cron">False</span> <span ng-show="tabActionsQueue.cron">True</span></td><td><span ng-class="tabActionsQueue.actionState.actionStateName == \'Executed\' ? [\'label\', \'label-success\'] : tabActionsQueue.actionState.actionStateName == \'Error\' ? [\'label\', \'label-danger\'] : \'\'">{{tabActionsQueue.actionState.actionStateName}}</span></td><td>{{tabActionsQueue.executedMessage}}</td><td><a ui-sref="tab-objects-detail({id:tabActionsQueue.object.id})">{{tabActionsQueue.object.objectName}}</a></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ng-show="tabActionsQueue.arguments != null" ui-sref="tab-actions-queue-detail({id:tabActionsQueue.id, group:vm.obj })"><i class="fa fa-eye"></i><span translate="entity.action.arguments"></span></a></li><li><a href="javascript:;" ng-if="tabActionsQueue.actionState.actionStateName==\'Error\'" ng-click="vm.retry(tabActionsQueue)"><i class="fa fa-repeat"></i><span translate="entity.action.retry"></span></a></li><li has-authority="ROLE_DOMAIN_ADMIN"><a href="javascript:;" ui-sref="tab-actions-queue.delete({id:tabActionsQueue.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabDeviceReleases.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabDeviceReleases.delete.question" translate-values="{id: \'{{vm.tabDeviceReleases.deviceReleaseName}}\'}">Are you sure you want to delete this Tab Device Releases?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabDeviceReleases.detail.title">Tab Device Release</span> {{vm.tabDeviceReleases.id}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabDeviceReleases.deviceReleaseName">Device Release Name</span></dt><dd><span>{{vm.tabDeviceReleases.deviceReleaseName}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.deviceReleaseDescription">Device Release Description</span></dt><dd><span>{{vm.tabDeviceReleases.deviceReleaseDescription}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.isActive">Is Active</span></dt><dd><span>{{vm.tabDeviceReleases.isActive}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.deviceReleaseVersion">Device Release Version</span></dt><dd><span>{{vm.tabDeviceReleases.deviceReleaseVersion}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.device">Device</span></dt><dd><a ui-sref="tab-devices-detail({id:vm.tabDeviceReleases.device.id})">{{vm.tabDeviceReleases.device.deviceName}}</a></dd><dt><span translate="jotApp.tabDeviceReleases.createdBy">Created By</span></dt><dd><span>{{vm.tabDeviceReleases.createdBy}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.createdDate">Created Date</span></dt><dd><span>{{vm.tabDeviceReleases.createdDate | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabDeviceReleases.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabDeviceReleases.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabDeviceReleases.lastModifiedDate | date: \'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabDeviceReleases.home.createOrEditLabel">Create or edit a Device Releases</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.deviceReleaseName" for="field_deviceReleaseName">Device Release Name</label> <input type="text" class="form-control" name="deviceReleaseName" id="field_deviceReleaseName" ng-model="vm.tabDeviceReleases.deviceReleaseName" required ng-disabled="vm.tabDeviceReleases.id!=null" ng-maxlength="50" ng-pattern="\'^(([a-z,A-Z,0-9]+(?=\\\\.)\\\\.)+)([a-z,A-Z,0-9,\\\\-,_]+)$\'"><div ng-show="editForm.deviceReleaseName.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceReleaseName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.deviceReleaseName.$error.pattern">This field must match an an artifactory pattern (es: org.mycompany.myapp.my-bundle)</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.deviceReleaseDescription" for="field_deviceReleaseDescription">Device Release Description</label> <input type="text" class="form-control" name="deviceReleaseDescription" id="field_deviceReleaseDescription" ng-model="vm.tabDeviceReleases.deviceReleaseDescription" ng-maxlength="255"><div ng-show="editForm.deviceReleaseDescription.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabDeviceReleases.device" for="field_device">Device</label><ui-select id="field_device" name="device" ng-model="vm.tabDeviceReleases.device" theme="bootstrap" search-enabled="false" required><ui-select-match placeholder="Select a device...">{{$select.selected.deviceName}}</ui-select-match><ui-select-choices repeat="item in vm.devices track by item.id" percent="90" when-scrolled="vm.loadPage(vm.page + 1)"><div ng-bind-html="item.deviceName"></div></ui-select-choices></ui-select><div ng-show="editForm.device.$invalid"><p class="help-block" ng-show="editForm.device.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.deviceReleaseVersion" for="field_deviceReleaseVersion">Device Release Version</label> <input type="text" class="form-control" name="deviceReleaseVersion" id="field_deviceReleaseVersion" ng-model="vm.tabDeviceReleases.deviceReleaseVersion" required ng-disabled="vm.tabDeviceReleases.id!=null" ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.deviceReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p><p class="help-block" ng-show="editForm.deviceReleaseName.$error.pattern">This field must match the git versioning pattern major.minor.patch</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabDeviceReleases.isActive"> <span></span><div translate="jotApp.tabDeviceReleases.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases-enable-dialog.html','<form name="enableForm" ng-submit="vm.confirmEnable()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.enable.title">Confirm enable operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabDeviceReleases.enable.question" translate-values="{version: \'{{vm.tabDeviceReleases.deviceReleaseVersion}}\', name: \'{{vm.tabDeviceReleases.deviceReleaseName}}\'}">Are you sure you want to enable this Device Release Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="enableForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-check"></span>&nbsp;<span translate="entity.action.enable">Enable</span></button></div></form>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases-upgrade.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabDeviceReleases.home.upgradeVersion">Upgrade Device Releases Version</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.deviceReleaseName" for="field_deviceReleaseName">Device Release Name</label> <input type="text" class="form-control" name="deviceReleaseName" id="field_deviceReleaseName" ng-model="vm.tabDeviceReleases.deviceReleaseName" required ng-maxlength="50" ng-disabled="true"><div ng-show="editForm.deviceReleaseName.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceReleaseName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.deviceReleaseDescription" for="field_deviceReleaseDescription">Device Release Description</label> <input type="text" class="form-control" name="deviceReleaseDescription" id="field_deviceReleaseDescription" ng-model="vm.tabDeviceReleases.deviceReleaseDescription" ng-maxlength="255"><div ng-show="editForm.deviceReleaseDescription.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.currentVersion" for="field_currentVersion">Current Version</label> <input type="text" class="form-control" name="deviceReleaseVersion" id="field_currentVersion" value="{{::vm.tabDeviceReleases.deviceReleaseVersion}}" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDeviceReleases.newVersion" for="field_deviceReleaseVersion">New Version</label> <input type="text" class="form-control" name="deviceReleaseVersion" id="field_deviceReleaseVersion" ng-model="vm.tabDeviceReleases.deviceReleaseVersion" required ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.deviceReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.deviceReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabDeviceReleases.device" for="field_device">Device</label> <select class="form-control" id="field_device" name="device" ng-model="vm.tabDeviceReleases.device" ng-options="tabDevices as tabDevices.deviceName for tabDevices in vm.devices | orderBy:\'id\' track by tabDevices.id" ng-disabled="true"><option value=""></option></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabDeviceReleases.isActive"> <span></span><div translate="jotApp.tabDeviceReleases.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-device-releases/tab-device-releases.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.search()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="objectType_field">Object Type</label><ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="device_field">Device</label><ui-select ng-model="vm.device" id="device_field" theme="bootstrap"><ui-select-match placeholder="Select or search a device...">{{$select.selected.deviceName}}</ui-select-match><ui-select-choices repeat="item in vm.devices | filter: {deviceName: $select.search}"><div ng-bind-html="item.deviceName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-2 inline-filter-button"><div class="form-group"><label class="control-label ng-scope" for="submit_field"></label> <button type="submit" id="submit_field" class="btn btn-primary"><span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span></button></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-device-releases-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabDeviceReleases.home.createLabel">Create new Tab Device Releases</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column" data-detail-view="true"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th class="open-row-col"></th><th multi-sort-by="deviceReleaseName"><span translate="jotApp.tabDeviceReleases.deviceReleaseName">Device Release Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceReleaseDescription"><span translate="jotApp.tabDeviceReleases.deviceReleaseDescription">Device Release Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="isActive"><span translate="jotApp.tabDeviceReleases.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceReleaseVersion"><span translate="jotApp.tabDeviceReleases.deviceReleaseVersion">Device Release Version</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="device.deviceName"><span translate="jotApp.tabDeviceReleases.device">Device</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat-start="tabDeviceReleases in vm.tabDeviceReleases track by tabDeviceReleases.id"><td class="open-row-col" ng-click="tabDeviceReleases.expanded = !tabDeviceReleases.expanded"><div ng-if="vm.tabDeviceReleasesInactive[tabDeviceReleases.deviceReleaseName].length > 0"><i ng-if="!tabDeviceReleases.expanded" class="fa fa-plus-square"></i> <i ng-if="tabDeviceReleases.expanded" class="fa fa-minus-square" aria-hidden="true"></i></div></td><td ng-click="tabDeviceReleases.expanded = !tabDeviceReleases.expanded" ng-bind-html="tabDeviceReleases.deviceReleaseName | highlight:vm.charToSearch"></td><td ng-click="tabDeviceReleases.expanded = !tabDeviceReleases.expanded" ng-bind-html="tabDeviceReleases.deviceReleaseDescription | highlight:vm.charToSearch"></td><td><span class="label label-danger" ng-show="!tabDeviceReleases.isActive">{{tabDeviceReleases.isActive}}</span> <span class="label label-success" ng-show="tabDeviceReleases.isActive">{{tabDeviceReleases.isActive}}</span></td><td>{{tabDeviceReleases.deviceReleaseVersion}}</td><td ng-click="tabDeviceReleases.expanded = !tabDeviceReleases.expanded"><a ui-sref="tab-devices-detail({id:tabDeviceReleases.device.id})" ng-bind-html="tabDeviceReleases.device.deviceName | highlight:vm.charToSearch"></a></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-device-releases-detail({id:tabDeviceReleases.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-device-releases-edit({id:tabDeviceReleases.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li ng-if="!tabDeviceReleases.isActive"><a href="javascript:;" ui-sref="tab-device-releases.enable({id:tabDeviceReleases.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-device-releases-upgrade({id:tabDeviceReleases.id})"><i class="fa fa-plus"></i><span translate="entity.action.upgrade"></span></a></li><li ng-if="!tabDeviceReleases.isActive"><a href="javascript:;" ui-sref="tab-device-releases.delete({id:tabDeviceReleases.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="tabDeviceReleases.expanded" ng-repeat="tabDeviceReleasesInactive in vm.tabDeviceReleasesInactive[tabDeviceReleases.deviceReleaseName]"><td class="open-row-col"></td><td></td><td>{{tabDeviceReleasesInactive.deviceReleaseDescription}}</td><td><span class="label label-danger" ng-show="!tabDeviceReleasesInactive.isActive">{{tabDeviceReleasesInactive.isActive}}</span> <span class="label label-success" ng-show="tabDeviceReleasesInactive.isActive">{{tabDeviceReleasesInactive.isActive}}</span></td><td>{{tabDeviceReleasesInactive.deviceReleaseVersion}}</td><td><a ui-sref="tab-devices-detail({id:tabDeviceReleasesInactive.device.id})">{{tabDeviceReleasesInactive.device.deviceName}}</a></td><td><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-device-releases-detail({id:tabDeviceReleasesInactive.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-device-releases-edit({id:tabDeviceReleasesInactive.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-device-releases.enable({id:tabDeviceReleasesInactive.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-device-releases.delete({id:tabDeviceReleasesInactive.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="false" ng-repeat-end=""></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices/tab-devices-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabDevices.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabDevices.delete.question" translate-values="{id: \'{{vm.tabDevices.deviceName}}\'}">Are you sure you want to delete this Tab Devices?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-devices/tab-devices-detail.html','<div class="app-content-body detail-page devices-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabDevices.detail.title">Tab Devices</span> {{vm.tabDevices.deviceName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabDevices.deviceName">Device Name</span></dt><dd><span>{{vm.tabDevices.deviceName}}</span></dd><dt><span translate="jotApp.tabDevices.deviceDescription">Device Description</span></dt><dd><span>{{vm.tabDevices.deviceDescription}}</span></dd><dt><span translate="jotApp.tabDevices.deviceType">Device Type</span></dt><dd><a ui-sref="tab-devices-types-detail({id:vm.tabDevices.deviceType.id})">{{vm.tabDevices.deviceType.deviceTypeName}}</a></dd><dt><span translate="jotApp.tabDevices.createdBy">Created By</span></dt><dd><span>{{vm.tabDevices.createdBy}}</span></dd><dt><span translate="jotApp.tabDevices.createdDate">Created Date</span></dt><dd><span>{{vm.tabDevices.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabDevices.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabDevices.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabDevices.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabDevices.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices/tab-devices-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabDevices.home.createOrEditLabel">Create or edit a Device</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDevices.deviceName" for="field_deviceName">Device Name</label> <input type="text" class="form-control" name="deviceName" id="field_deviceName" ng-model="vm.tabDevices.deviceName" required ng-maxlength="50"><div ng-show="editForm.deviceName.$invalid"><p class="help-block" ng-show="editForm.deviceName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDevices.deviceDescription" for="field_deviceDescription">Device Description</label> <input type="text" class="form-control" name="deviceDescription" id="field_deviceDescription" ng-model="vm.tabDevices.deviceDescription" ng-maxlength="255"><div ng-show="editForm.deviceDescription.$invalid"><p class="help-block" ng-show="editForm.deviceDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDevices.deviceType" for="field_deviceType">Device Type</label> <select class="form-control" id="field_deviceType" name="deviceTypes" ng-model="vm.tabDevices.deviceType" required ng-options="tabDevicesTypes as tabDevicesTypes.deviceTypeName for tabDevicesTypes in vm.tabdevicestypes track by tabDevicesTypes.id"><option value="" disabled="disabled" selected="selected" style="display: none">Select the type of the device...</option></select><div ng-show="editForm.deviceTypes.$invalid"><p class="help-block" ng-show="editForm.deviceTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><!--<div class="row">--><!--<div class="col-md-6 col-xs-12">--><!--<div class="form-group">--><!--<div class="mt-checkbox-inline form-field-no-label">--><!--<label class="mt-checkbox mt-checkbox-outline" for="field_isActive">--><!--<input type="checkbox" class="form-control" name="isActive" id="field_isActive"--><!--ng-model="vm.tabDevices.isActive"--><!--/>--><!--<span></span>--><!--<div translate="jotApp.tabDevices.isActive"></div>--><!--<div ng-show="editForm.isActive.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.isActive.$error.required" translate="entity.validation.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</label>--><!--<label class="mt-checkbox mt-checkbox-outline" for="field_isVisibile">--><!--<input type="checkbox" class="form-control" name="isVisibile" id="field_isVisibile"--><!--ng-model="vm.tabDevices.isVisibile"--><!--/>--><!--<span></span>--><!--<div translate="jotApp.tabDevices.isVisibile"></div>--><!--<div ng-show="editForm.isVisibile.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.isVisibile.$error.required" translate="entity.validation.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</label>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices/tab-devices.html','<div class="app-content-body"><jhi-alert></jhi-alert><device-filter filter="vm.applyFilter(deviceType)" device-type-val="vm.deviceType"></device-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-devices-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabDevices.home.createLabel">Create new Tab Devices</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="deviceName"><span translate="jotApp.tabDevices.deviceName">Device Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceDescription"><span translate="jotApp.tabDevices.deviceDescription">Device Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="isActive"><span translate="jotApp.tabDevices.deviceType">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabDevices in vm.tabDevices track by tabDevices.id"><td ng-bind-html="tabDevices.deviceName | highlight:vm.searchText"></td><td ng-bind-html="tabDevices.deviceDescription | highlight:vm.searchText"></td><td><a ui-sref="tab-devices-types-detail({id:tabDevices.deviceType.id})" ng-bind-html="tabDevices.deviceType.deviceTypeName | highlight:vm.searchText"></a></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-devices-detail({id:tabDevices.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-devices-edit({id:tabDevices.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-devices.delete({id:tabDevices.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices-types/tab-devices-types-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabDevicesTypes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabDevicesTypes.delete.question" translate-values="{id: \'{{vm.tabDevicesTypes.deviceTypeName}}\'}">Are you sure you want to delete this Tab Devices Types?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-devices-types/tab-devices-types-detail.html','<div class="app-content-body detail-page devices-types-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabDevicesTypes.detail.title">Tab Devices Types</span> {{vm.tabDevicesTypes.deviceTypeName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabDevicesTypes.deviceTypeName">Device Type Name</span></dt><dd><span>{{vm.tabDevicesTypes.deviceTypeName}}</span></dd><dt><span translate="jotApp.tabDevicesTypes.deviceTypeDescription">Device Type Description</span></dt><dd><span>{{vm.tabDevicesTypes.deviceTypeDescription}}</span></dd><dt><span translate="jotApp.tabDevicesTypes.createdBy">Created By</span></dt><dd><span>{{vm.tabDevicesTypes.createdBy}}</span></dd><dt><span translate="jotApp.tabDevicesTypes.createdDate">Created Date</span></dt><dd><span>{{vm.tabDevicesTypes.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabDevicesTypes.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabDevicesTypes.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabDevicesTypes.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabDevicesTypes.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices-types/tab-devices-types-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabDevicesTypes.home.createOrEditLabel">Create or edit a Device Type</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDevicesTypes.deviceTypeName" for="field_deviceTypeName">Device Type Name</label> <input type="text" class="form-control" name="deviceTypeName" id="field_deviceTypeName" ng-model="vm.tabDevicesTypes.deviceTypeName" required ng-maxlength="50"><div ng-show="editForm.deviceTypeName.$invalid"><p class="help-block" ng-show="editForm.deviceTypeName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deviceTypeName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDevicesTypes.deviceTypeDescription" for="field_deviceTypeDescription">Device Type Description</label> <input type="text" class="form-control" name="deviceTypeDescription" id="field_deviceTypeDescription" ng-model="vm.tabDevicesTypes.deviceTypeDescription" ng-maxlength="255"><div ng-show="editForm.deviceTypeDescription.$invalid"><p class="help-block" ng-show="editForm.deviceTypeDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-devices-types/tab-devices-types.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-devices-types-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabDevicesTypes.home.createLabel">Create new Tab Devices Types</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="deviceTypeName"><span translate="jotApp.tabDevicesTypes.deviceTypeName">Device Type Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="deviceTypeDescription"><span translate="jotApp.tabDevicesTypes.deviceTypeDescription">Device Type Description</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabDevicesTypes in vm.tabDevicesTypes track by tabDevicesTypes.id"><td>{{tabDevicesTypes.deviceTypeName}}</td><td>{{tabDevicesTypes.deviceTypeDescription}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-devices-types-detail({id:tabDevicesTypes.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-devices-types-edit({id:tabDevicesTypes.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-devices-types.delete({id:tabDevicesTypes.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-domains/tab-domains-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabDomains.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabDomains.delete.note">By deleting this domain all user (associated with no other domain) will be deactivated.</p><p translate="jotApp.tabDomains.delete.question" translate-values="{id: \'{{vm.tabDomains.domainName}}\'}">Are you sure you want to delete this Tab Domains?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-domains/tab-domains-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabDomains.detail.title">Tab Domains</span> {{vm.tabDomains.domainName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabDomains.domainName">Domain Name</span></dt><dd><span>{{vm.tabDomains.domainName}}</span></dd><dt><span translate="jotApp.tabDomains.domainDescription">Domain Description</span></dt><dd><span>{{vm.tabDomains.domainDescription}}</span></dd><dt><span translate="jotApp.tabDomains.isActive">Is Active</span></dt><dd><span>{{vm.tabDomains.isActive}}</span></dd><dt><span translate="jotApp.tabDomains.licence">Licence</span></dt><dd><span>{{vm.tabDomains.licence.name | uppercase}}</span></dd><dt><span translate="jotApp.tabDomains.trialEnd">Created Date</span></dt><dd><span>{{vm.tabDomains.licenseExpirationDate | date:\'dd/MM/yyyy\'}}</span></dd><dt><span translate="jotApp.tabDomains.user">User</span></dt><dd><span ng-repeat="user in vm.tabDomains.users">{{user.login}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabDomains.fleet">Fleet</span></dt><dd><span ng-repeat="fleet in vm.tabDomains.fleets"><a ui-sref="tab-fleets-detail({id: {{fleet.id}}})">{{fleet.fleetName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabDomains.createdBy">Created By</span></dt><dd><span>{{vm.tabDomains.createdBy}}</span></dd><dt><span translate="jotApp.tabDomains.createdDate">Created Date</span></dt><dd><span>{{vm.tabDomains.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabDomains.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabDomains.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabDomains.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabDomains.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-domains/tab-domains-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabDomains.home.createOrEditLabel">Create or edit a Tab Domains</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDomains.domainName" for="field_domainName">Domain Name</label> <input type="text" class="form-control" name="domainName" id="field_domainName" ng-model="vm.tabDomains.domainName" required ng-maxlength="50" ng-disabled="vm.tabDomains.id!=null" ng-pattern="/^(([a-zA-Z0-9]+)([-_\\s])?([a-zA-Z0-9]+))*$/"><div ng-show="editForm.domainName.$invalid"><p class="help-block" ng-show="editForm.domainName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.domainName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.domainName.$error.pattern">Domain Name can only contain letters, digits, score, underscore and space.</p></div></div></div><div class="col-md-6 col-xs-12 schedule-btn-wrapper"><label class="control-label" translate="jotApp.tabDomains.trialEnd" for="field_trialEnd">Domain Name</label><div class="input-group"><input id="field_trialEnd" type="text" class="form-control" datepicker-options="vm.datepickerOptions" enable-time="false" datetime-picker="dd MMM yyyy" ng-model="vm.tabDomains.licenseExpirationDate" name="trialEnd" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen"> <span class="input-group-btn" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen" role="button" tabindex="0"><button type="button" class="btn btn-default"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabDomains.domainDescription" for="field_domainDescription">Domain Description</label> <input type="text" class="form-control" name="domainDescription" id="field_domainDescription" ng-model="vm.tabDomains.domainDescription" ng-maxlength="255"><div ng-show="editForm.domainDescription.$invalid"><p class="help-block" ng-show="editForm.domainDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="col-md-3 col-xs-6"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" name="isActive" id="field_isActive" ng-model="vm.tabDomains.isActive"> <span></span><div translate="jotApp.tabDomains.isActive"></div></label></div></div></div><div class="col-md-3 col-xs-6"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isTestDomain"><input type="checkbox" name="isTestDomain" id="field_isTestDomain" ng-model="vm.tabDomains.testDomain"> <span></span><div translate="jotApp.tabDomains.testDomain"></div></label></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabDomains.user" for="field_user">User</label> <select class="form-control" id="field_user" chosen multiple="multiple" name="user" ng-model="vm.tabDomains.users" ng-options="user as user.login for user in vm.users track by user.id" data-placeholder-text-multiple="\' \'"></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabDomains.licence" for="field_licence">Licence</label> <select class="form-control" id="field_licence" required name="licence" ng-model="vm.tabDomains.licence" ng-options="licence  as (licence.name | uppercase) for licence in vm.licences track by licence.id"></select><div ng-show="editForm.licence.$invalid"><p class="help-block" ng-show="editForm.licence.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-domains/tab-domains.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-domains-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabDomains.home.createLabel">Create new Tab Domains</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchText" ng-change="vm.search()" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="domainName"><span translate="jotApp.tabDomains.domainName">Domain Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="domainDescription"><span translate="jotApp.tabDomains.domainDescription">Domain Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="isActive"><span translate="jotApp.tabDomains.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="licence.name"><span translate="jotApp.tabDomains.licence">Licence</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="licenseExpirationDate"><span translate="jotApp.tabDomains.trialEnd">Trial End</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.tabDomains.domainUsed">Domain Used</span></th><th><span translate="jotApp.tabDomains.lastLogin">Last Login</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabDomains in vm.tabDomains | filter:vm.searchText track by tabDomains.id"><td ng-bind-html="tabDomains.domainName | highlight:vm.searchText"></td><td>{{tabDomains.domainDescription}}</td><td><span class="label label-danger" ng-show="!tabDomains.isActive" translate="jotApp.tabDomains.deactivated">Desactivated</span> <span class="label label-success" ng-show="tabDomains.isActive" translate="jotApp.tabDomains.activated">Activated</span></td><td>{{tabDomains.licence.name | uppercase}}</td><td>{{tabDomains.licenseExpirationDate | date:\'dd/MM/yyyy\'}}</td><td><span class="label label-success" ng-show="vm.checkLastLog(tabDomains.auditEventDate) && !tabDomains.testDomain" translate="jotApp.tabDomains.domainUsTrue">True</span> <span class="label label-warning" ng-show="tabDomains.testDomain" translate="jotApp.tabDomains.testDomain">Test Domain</span> <span class="label label-danger" ng-show="!vm.checkLastLog(tabDomains.auditEventDate) && !tabDomains.testDomain" translate="jotApp.tabDomains.domainUsFalse">False</span></td><td><div ng-show="!vm.checkLastLog(tabDomains.auditEventDate) && !tabDomains.testDomain">{{tabDomains.principal}} - {{tabDomains.auditEventDate | date:\'dd/MM/yyyy\'}}</div></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-domains-detail({id:tabDomains.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-domains-edit({id:tabDomains.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-domains.delete({id:tabDomains.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-file-types/tab-file-types-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabFileTypes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFileTypes.delete.question" translate-values="{id: \'{{vm.tabFileTypes.fileTypeName}}\'}">Are you sure you want to delete this Tab Devices Types?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-file-types/tab-file-types-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFileTypes.home.createOrEditLabel">Create or edit a Device Type</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFileTypes.tabFileTypeName" for="field_fileTypeName">Device Type Name</label> <input type="text" class="form-control" name="fileTypeName" id="field_fileTypeName" ng-model="vm.tabFileTypes.fileTypeName" required ng-maxlength="50"><div ng-show="editForm.fileTypeName.$invalid"><p class="help-block" ng-show="editForm.fileTypeName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileTypeName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFileTypes.tabFileTypeDescription" for="field_fileTypeDescription">Device Type Description</label> <input type="text" class="form-control" name="fileTypeDescription" id="field_fileTypeDescription" ng-model="vm.tabFileTypes.fileTypeDescription" ng-maxlength="255"><div ng-show="editForm.fileTypeDescription.$invalid"><p class="help-block" ng-show="editForm.fileTypeDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-file-types/tab-file-types.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-file-types-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabFileTypes.home.createLabel">Create new Tab Devices Types</span></button></div></div><!-- new search field for filtering the table tab-file-types --><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="fileTypeName"><span translate="jotApp.tabFileTypes.tabFileTypeName">Device Type Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fileTypeDescription"><span translate="jotApp.tabFileTypes.tabFileTypeDescription">Device Type Description</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabFileTypes in vm.tabFileTypes track by tabFileTypes.id"><td ng-bind-html="tabFileTypes.fileTypeName | highlight:vm.charToSearch"></td><td ng-bind-html="tabFileTypes.fileTypeDescription | highlight:vm.charToSearch"></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-file-types-edit({id:tabFileTypes.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-file-types.delete({id:tabFileTypes.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-files/tab-files-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabFiles.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFiles.delete.question" translate-values="{id: \'{{vm.tabFiles.fileName}}\'}">Are you sure you want to delete this Tab Device Releases?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-files/tab-files-detail.html','<div class="app-content-body detail-page files-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabFiles.detail.title"></span> {{vm.tabFiles.fileAlias}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabFiles.fileAlias"></span></dt><dd><span>{{vm.tabFiles.fileAlias}}</span></dd><dt><span translate="jotApp.tabFiles.fileDescription"></span></dt><dd><span>{{vm.tabFiles.fileDescription}}</span></dd><dt><span translate="jotApp.tabFiles.fileName"></span></dt><dd><span>{{vm.tabFiles.fileName}}</span></dd><dt><span translate="jotApp.tabFiles.fileContent"></span></dt><dd><span class="download-label">{{vm.byteSize(vm.tabFiles.fileContent)}}</span> <a class="btn btn-primary btn-sm btn-circle" ng-click="vm.openFile = true" ng-if="vm.tabFiles.fileContent" target="_blank" ng-disabled="vm.openFile" translate="entity.action.open">open </a><a class="btn btn-primary btn-sm btn-circle" ng-click="vm.openFile = false" ng-if="vm.openFile" target="_blank" translate="entity.action.close">close</a></dd><dt ng-show="vm.openFile"><span></span></dt><dd ng-show="vm.openFile"><pre>{{vm.fileContent}}</pre></dd><dt><span translate="jotApp.tabFiles.tabFileTypes">File Type</span></dt><dd><span>{{vm.tabFiles.tabFileTypes.fileTypeName}}</span></dd><dt><span translate="jotApp.tabFiles.createdBy">Created By</span></dt><dd><span>{{vm.tabFiles.createdBy}}</span></dd><dt><span translate="jotApp.tabFiles.createdDate">Created Date</span></dt><dd><span>{{vm.tabFiles.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabFiles.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabFiles.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabFiles.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabFiles.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-files/tab-files-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFiles.home.createOrEditLabel">Create or edit a File</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileAlias" for="field_fileAlias">Alias</label> <input type="text" class="form-control" name="fileAlias" id="field_fileAlias" ng-model="vm.tabFiles.fileAlias" required ng-maxlength="50" placeholder="Names needs extensions." ng-pattern="/^[a-zA-Z0-9_.+-,_]+[a-zA-Z0-9-,_]+\\.[a-zA-Z0-9-.]+$/"><div ng-show="editForm.fileAlias.$invalid"><p class="help-block" ng-show="editForm.fileAlias.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileAlias.$error.pattern">This field can only contain letters digits and -,_ .extension</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileDescription" for="field_fileDescription">Description</label> <input type="text" class="form-control" name="fileDescription" id="field_fileDescription" ng-model="vm.tabFiles.fileDescription" ng-maxlength="255"><div ng-show="editForm.fileDescription.$invalid"><p class="help-block" ng-show="editForm.fileDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileName" for="field_fileName">Name</label> <input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.tabFiles.fileName" ng-maxlength="255"><div ng-show="editForm.fileName.$invalid"><p class="help-block" ng-show="editForm.fileName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.tabFileTypes" for="field_tabFileTypes">File Type</label> <select class="form-control" id="field_tabFileTypes" name="tabFileTypes" ng-model="vm.tabFiles.tabFileTypes" required ng-options="tabFileTypes as (tabFileTypes.fileTypeName | capitalize) for tabFileTypes in vm.tabfiletypes track by tabFileTypes.id"><option value="" disabled="disabled" selected="selected" style="display: none">Select the type of the file...</option></select><div ng-show="vm.editForm.tabFileTypes.$invalid"><p class="help-block" ng-show="vm.editForm.tabFileTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileReleaseVersion" for="field_tabFilesReleaseVersion">File Release Version</label> <input type="text" class="form-control" name="tabFilesReleaseVersion" id="field_tabFilesReleaseVersion" ng-model="vm.tabFiles.fileReleaseVersion" required ng-disabled="vm.tabFiles.id!=null" ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.tabFilesReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.tabFilesReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tabFilesReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p><p class="help-block" ng-show="editForm.tabFilesReleaseVersion.$error.pattern">This field must match the git versioning pattern major.minor.patch</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabFiles.isActive"> <span></span><div translate="jotApp.tabFiles.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="col-md-6 col-xs-12 form-group no-padding-left" ngf-drop ngf-change="vm.setFileContent($file, vm.tabFiles)"><label class="control-label" translate="jotApp.tabFiles.fileContent" for="field_fileContent">File Content</label><div class=""><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileContent($file, vm.tabFiles)" translate="entity.action.addblob">Select File</button><div class="help-block clearfix"><a class="btn btn-primary btn-circle btn-sm" ng-click="vm.toggleInlineEditor()" ng-if="vm.tabFiles.fileContent" target="_blank" translate="entity.action.open">Open</a> <span ng-if="vm.tabFiles.fileContent"><span translate="jotApp.tabFiles.fileContentExt"></span>: {{vm.tabFiles.fileContentType}} {{byteSize(vm.tabFiles.fileContent)}}</span></div></div><input type="hidden" class="form-control" name="fileContent" id="field_fileContent" ng-model="vm.tabFiles.fileContent" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.tabFiles.fileContentType"><div ng-show="editForm.fileContent.$invalid"><p class="help-block" ng-show="editForm.fileContent.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6 col-xs-12 form-group no-padding-right"><label class="control-label invisible" translate="jotApp.tabFiles.fileContent" for="field_fileContent">.</label> <button type="button" class="btn btn-default btn-block" ng-click="vm.toggleInlineEditor()" translate="jotApp.tabFiles.inlineEditor">Inline Editor</button></div></div></div><div class="row" ng-if="vm.showInlineEditor"><div class="col-md-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.inlineEditor" for="field_fileContentRaw">Inline Editor</label><div class="form-control" id="field_fileContentRaw" ui-ace="{rendererOptions: { fontSize: 14 }}" ng-model="vm.fileContentRaw" ng-change="vm.setFileFromEditor()" style="height: 200px"></div></div></div></div><div class="row"><div class="col-md-2 col-xs-4"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isCustom"><input type="checkbox" class="form-control" id="field_isCustom" ng-model="vm.isCustomPermission" ng-click="vm.clearPermission()"> <span></span><div>Customize permissions</div></label></div></div></div><div ng-if="!vm.isCustomPermission"><div class="col-md-5 col-xs-10"><div class="form-group"><label class="control-label" for="field_permissions">Permissions</label> <select class="form-control" id="field_permissions" ng-model="vm.permissions.permission" ng-init="vm.permissions.permission=\'-1\'"><option value="-1">No permission</option><option value="0">Read</option><option value="1">Write</option><option value="2">Execute</option><option value="3">All</option></select></div></div><div class="col-md-5 col-xs-10" ng-if="vm.permissions.permission != -1"><div class="form-group"><label class="control-label" for="field_group">Categories</label> <select class="form-control" id="field_group" ng-model="vm.permissions.category" ng-init="vm.permissions.category=\'-1\'"><option value="-1">All</option><option value="0">User</option><option value="1">Group</option><option value="2">Others</option></select></div></div></div></div><div ng-if="vm.isCustomPermission"><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>User:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readUser"><input type="checkbox" class="form-control" id="field_readUser" ng-model="vm.permissions.user.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeUser"><input type="checkbox" class="form-control" id="field_writeUser" ng-model="vm.permissions.user.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeUser"><input type="checkbox" class="form-control" id="field_executeUser" ng-model="vm.permissions.user.permis.x"> <span></span><div>x</div></label></div></div></div></div><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>Group:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readGroup"><input type="checkbox" class="form-control" id="field_readGroup" ng-model="vm.permissions.group.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeGroup"><input type="checkbox" class="form-control" id="field_writeGroup" ng-model="vm.permissions.group.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeGroup"><input type="checkbox" class="form-control" id="field_executeGroup" ng-model="vm.permissions.group.permis.x"> <span></span><div>x</div></label></div></div></div></div><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>Others:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readOthers"><input type="checkbox" class="form-control" id="field_readOthers" ng-model="vm.permissions.other.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeOthers"><input type="checkbox" class="form-control" id="field_writeOthers" ng-model="vm.permissions.other.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeOthers"><input type="checkbox" class="form-control" id="field_executeOthers" ng-model="vm.permissions.other.permis.x"> <span></span><div>x</div></label></div></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-files/tab-files-enable-dialog.html','<form name="enableForm" ng-submit="vm.confirmEnable()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.enable.title">Confirm enable operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFiles.enable.question" translate-values="{version: \'{{vm.tabFile.fileReleaseVersion}}\', name: \'{{vm.tabFile.fileAlias}}\'}">Are you sure you want to enable this Device Release Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="enableForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-check"></span>&nbsp;<span translate="entity.action.enable">Enable</span></button></div></form>');
$templateCache.put('app/entities/tab-files/tab-files-upgrade.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFiles.home.upgradeVersion">Upgrade Device Releases Version</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileAlias" for="field_tabFileReleaseName">tabFile Release Name</label> <input type="text" class="form-control" name="fileAlias" id="field_tabFileReleaseName" ng-model="vm.tabFiles.fileAlias" required ng-maxlength="50" ng-disabled="true"><div ng-show="editForm.fileAlias.$invalid"><p class="help-block" ng-show="editForm.fileAlias.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileAlias.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.fileDescription" for="field_tabFilesReleaseDescription">Device Release Description</label> <input type="text" class="form-control" name="fileDescription" id="field_tabFilesReleaseDescription" ng-model="vm.tabFiles.fileDescription" ng-maxlength="255"><div ng-show="editForm.fileDescription.$invalid"><p class="help-block" ng-show="editForm.fileDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.currentVersion" for="field_currentVersion">Current Version</label> <input type="text" class="form-control" name="fileReleaseVersion" id="field_currentVersion" value="{{::vm.tabFiles.fileReleaseVersion}}" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.newVersion" for="field_scriptsReleaseVersion">New Version</label> <input type="text" class="form-control" name="scriptsReleaseVersion" id="field_scriptsReleaseVersion" ng-model="vm.tabFiles.fileReleaseVersion" required ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\.(\\\\d+)\'"><div ng-show="editForm.scriptsReleaseVersion.$invalid"><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.scriptsReleaseVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.tabFileTypes" for="field_scriptsTypes">File Type</label> <select class="form-control" id="field_scriptsTypes" name="scriptsTypes" ng-model="vm.tabFiles.tabFileTypes" ng-options="tabFileTypes as tabFileTypes.fileTypeName for tabFileTypes in vm.tabFileTypes | orderBy:\'id\' track by tabFileTypes.id" ng-disabled="true"><option value=""></option></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabFiles.isActive"> <span></span><div translate="jotApp.tabFiles.isActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="col-md-6 col-xs-12 form-group no-padding-left" ngf-drop ngf-change="vm.setFileContent($file, vm.tabFiles)"><label class="control-label" translate="jotApp.tabFiles.fileContent" for="field_fileContent">File Content</label><div class=""><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileContent($file, vm.tabFiles)" translate="entity.action.addblob">Select File</button><div class="help-block clearfix"><a class="btn btn-primary btn-circle btn-sm" ng-click="vm.toggleInlineEditor()" ng-if="vm.tabFiles.fileContent" target="_blank" translate="entity.action.open">Open</a> <span ng-if="vm.tabFiles.fileContent"><span translate="jotApp.tabFiles.fileContentExt"></span>: {{vm.tabFiles.fileContentType}} {{byteSize(vm.tabFiles.fileContent)}}</span></div></div><input type="hidden" class="form-control" name="fileContent" id="field_fileContent" ng-model="vm.tabFiles.fileContent" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.tabFiles.fileContentType"><div ng-show="editForm.fileContent.$invalid"><p class="help-block" ng-show="editForm.fileContent.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6 col-xs-12 form-group no-padding-right"><label class="control-label invisible" translate="jotApp.tabFiles.fileContent" for="field_fileContent">.</label> <button type="button" class="btn btn-default btn-block" ng-click="vm.toggleInlineEditor()" translate="jotApp.tabFiles.inlineEditor">Inline Editor</button></div></div></div><div class="row" ng-if="vm.showInlineEditor"><div class="col-md-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFiles.inlineEditor" for="field_fileContentRaw">Inline Editor</label><div class="form-control" id="field_fileContentRaw" ui-ace="{rendererOptions: { fontSize: 14 }}" ng-model="vm.fileContentRaw" ng-change="vm.setFileFromEditor()" style="height: 200px"></div></div></div></div><div class="row"><div class="col-md-2 col-xs-4"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isCustom"><input type="checkbox" class="form-control" id="field_isCustom" ng-model="vm.isCustomPermission" ng-click="vm.clearPermission()"> <span></span><div>Customize permissions</div></label></div></div></div><div ng-if="!vm.isCustomPermission"><div class="col-md-5 col-xs-10"><div class="form-group"><label class="control-label" for="field_permissions">Permissions</label> <select class="form-control" id="field_permissions" ng-model="vm.permissions.permission" ng-init="vm.permissions.permission=\'-1\'"><option value="-1">No permission</option><option value="0">Read</option><option value="1">Write</option><option value="2">Execute</option><option value="3">All</option></select></div></div><div class="col-md-5 col-xs-10" ng-if="vm.permissions.permission != -1"><div class="form-group"><label class="control-label" for="field_group">Categories</label> <select class="form-control" id="field_group" ng-model="vm.permissions.category" ng-init="vm.permissions.category=\'-1\'"><option value="-1">All</option><option value="0">User</option><option value="1">Group</option><option value="2">Others</option></select></div></div></div></div><div ng-if="vm.isCustomPermission"><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>User:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readUser"><input type="checkbox" class="form-control" id="field_readUser" ng-model="vm.permissions.user.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeUser"><input type="checkbox" class="form-control" id="field_writeUser" ng-model="vm.permissions.user.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeUser"><input type="checkbox" class="form-control" id="field_executeUser" ng-model="vm.permissions.user.permis.x"> <span></span><div>x</div></label></div></div></div></div><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>Group:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readGroup"><input type="checkbox" class="form-control" id="field_readGroup" ng-model="vm.permissions.group.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeGroup"><input type="checkbox" class="form-control" id="field_writeGroup" ng-model="vm.permissions.group.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeGroup"><input type="checkbox" class="form-control" id="field_executeGroup" ng-model="vm.permissions.group.permis.x"> <span></span><div>x</div></label></div></div></div></div><div class="row"><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class=""><div>Others:</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_readOthers"><input type="checkbox" class="form-control" id="field_readOthers" ng-model="vm.permissions.other.permis.r"> <span></span><div>r</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_writeOthers"><input type="checkbox" class="form-control" id="field_writeOthers" ng-model="vm.permissions.other.permis.w"> <span></span><div>w</div></label></div></div></div><div class="col-md-1 col-xs-2"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_executeOthers"><input type="checkbox" class="form-control" id="field_executeOthers" ng-model="vm.permissions.other.permis.x"> <span></span><div>x</div></label></div></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-files/tab-files.html','<div class="app-content-body"><jhi-alert></jhi-alert><file-types-filter filter="vm.applyFilter(tabFileType, tabObjectType)" tab-file-type-val="vm.tabFileType" tab-object-type-val="vm.tabObjectType"></file-types-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-files-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabFiles.home.createLabel">Create new File</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Name, Description or Target..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th class="open-row-col"></th><th multi-sort-by="fileAlias"><span translate="jotApp.tabFiles.fileAlias">Device Release Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fileDescription"><span translate="jotApp.tabFiles.fileDescription">Device Release Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fileName"><span translate="jotApp.tabFiles.fileName">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="isActive"><span translate="jotApp.tabFiles.isActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fileReleaseVersion"><span translate="jotApp.tabFiles.fileReleaseVersion">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.tabFiles.tabFileTypes">File Type</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat-start="tabFiles in vm.tabFiles track by tabFiles.id"><td class="open-row-col" ng-click="tabFiles.expanded = !tabFiles.expanded"><div ng-if="vm.tabFilesInactive[tabFiles.fileAlias].length > 0"><i ng-if="!tabFiles.expanded" class="fa fa-plus-square"></i> <i ng-if="tabFiles.expanded" class="fa fa-minus-square" aria-hidden="true"></i></div></td><td ng-click="tabFiles.expanded = !tabFiles.expanded" ng-bind-html="tabFiles.fileAlias | highlight: vm.charToSearch"></td><td ng-click="tabFiles.expanded = !tabFiles.expanded" ng-bind-html="tabFiles.fileDescription | highlight: vm.charToSearch"></td><td ng-bind-html="tabFiles.fileName | highlight: vm.charToSearch"></td><td ng-click="tabFiles.expanded = !tabFiles.expanded"><span class="label label-danger" ng-show="!tabFiles.isActive">{{tabFiles.isActive}}</span> <span class="label label-success" ng-show="tabFiles.isActive">{{tabFiles.isActive}}</span></td><td ng-click="tabFiles.expanded = !tabFiles.expanded">{{tabFiles.fileReleaseVersion}}</td><td ng-click="tabFiles.expanded = !tabFiles.expanded">{{tabFiles.tabFileTypes.fileTypeName}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-files-detail({id:tabFiles.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-files-edit({id:tabFiles.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li ng-if="!tabFiles.isActive"><a href="javascript:;" ui-sref="tab-files.enable({id:tabFiles.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-files-upgrade({id:tabFiles.id})"><i class="fa fa-plus"></i><span translate="entity.action.upgrade"></span></a></li><li><a href="javascript:;" ui-sref="tab-files.delete({id:tabFiles.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="tabFiles.expanded" ng-repeat="tabFilesInactive in vm.tabFilesInactive[tabFiles.fileAlias]"><td class="open-row-col"></td><td></td><td>{{tabFilesInactive.fileDescription}}</td><td>{{tabFilesInactive.fileName}}</td><td><span class="label label-danger" ng-show="!tabFilesInactive.isActive">{{tabFilesInactive.isActive}}</span> <span class="label label-success" ng-show="tabFilesInactive.isActive">{{tabFilesInactive.isActive}}</span></td><td>{{tabFilesInactive.fileReleaseVersion}}</td><td>{{tabFilesInactive.tabFileTypes.fileTypeName}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-files-detail({id:tabFilesInactive.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-files-edit({id:tabFilesInactive.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-files.enable({id:tabFilesInactive.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-files.delete({id:tabFilesInactive.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="false" ng-repeat-end=""></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-firmware/tab-firmware-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabFirmware.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFirmware.delete.question" translate-values="{id: \'{{vm.tabFirmware.address}}\'}">Are you sure you want to delete this Firmware?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-firmware/tab-firmware-detail.html','<div class="app-content-body detail-page firmware-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabFirmware.detail.title"></span> {{vm.tabFirmware.address}}_{{vm.tabFirmware.version}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabFirmware.fileAddress"></span></dt><dd><span>{{vm.tabFirmware.address}}</span></dd><dt><span translate="jotApp.tabFirmware.fileVersion"></span></dt><dd><span>{{vm.tabFirmware.version}}</span></dd><dt><span translate="jotApp.tabFirmware.fileDescription"></span></dt><dd><span>{{vm.tabFirmware.description}}</span></dd><dt><span translate="jotApp.tabFirmware.fileActive"></span></dt><dd><span>{{vm.tabFirmware.isActive}}</span></dd><dt><span translate="jotApp.tabFirmware.fileContent"></span></dt><dd><span class="download-label">{{vm.byteSize(vm.tabFirmware.firmwareBody)}}</span> <a class="btn btn-primary btn-sm btn-circle" ng-click="vm.openFile = true" ng-if="vm.tabFirmware.firmwareBody" target="_blank" ng-disabled="vm.openFile" translate="entity.action.open">open </a><a class="btn btn-primary btn-sm btn-circle" ng-click="vm.openFile = false" ng-if="vm.openFile" target="_blank" translate="entity.action.close">close</a></dd><dt ng-show="vm.openFile"><span></span></dt><dd ng-show="vm.openFile"><pre>{{vm.firmwareBody}}</pre></dd><dt><span translate="jotApp.tabFirmware.boardReference"></span></dt><dd><span>{{vm.tabFirmware.boardReference}}</span></dd><dt><span translate="jotApp.tabFirmware.tabObjectType"></span></dt><dd><span><a ui-sref="tab-object-types-detail({id: vm.tabFirmware.objectType.id})">{{vm.tabFirmware.objectType.objectTypeName}}</a></span></dd><dt><span translate="jotApp.tabFirmware.createdBy"></span></dt><dd><span>{{vm.tabFirmware.createdBy}}</span></dd><dt><span translate="jotApp.tabFirmware.createdDate"></span></dt><dd><span>{{vm.tabFirmware.createdDate | date: \'medium\'}}</span></dd><dt><span translate="jotApp.tabFirmware.lastModifiedBy"></span></dt><dd><span>{{vm.tabFirmware.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabFirmware.lastModifiedDate"></span></dt><dd><span>{{vm.tabFirmware.lastModifiedDate | date: \'medium\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-firmware/tab-firmware-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFirmware.home.createOrEditLabel">Create or edit a File</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.fileAddress" for="field_fileAddress">fileAddress</label> <input type="text" class="form-control" name="fileAddress" id="field_fileAddress" ng-model="vm.tabFirmware.address" required ng-maxlength="100" ng-pattern="\'([A-Z]{2}\\\\d{3})(J(\\\\d{2}))+\'" ng-disabled="vm.tabFirmware.id!=null"><div ng-show="editForm.fileAddress.$invalid"><p class="help-block" ng-show="editForm.fileAddress.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.fileAddress.$error.pattern">Invalid format: the address has to be like AB123J03</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.fileVersion" for="field_fileVersion">fileVersion</label> <input type="text" class="form-control" name="fileVersion" id="field_fileVersion" ng-model="vm.tabFirmware.version" required ng-maxlength="15" ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\\\.(\\\\d+)\'" ng-disabled="vm.tabFirmware.id!=null"><div ng-show="editForm.fileVersion.$invalid"><p class="help-block" ng-show="editForm.fileVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block" ng-show="editForm.fileVersion.$error.pattern">This field must match the git versioning pattern major.minor.patch</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.boardReference" for="field_boardReference">boardReference</label> <input type="text" class="form-control" name="boardReference" id="field_boardReference" ng-model="vm.tabFirmware.boardReference" required ng-maxlength="100" ng-disabled="vm.tabFirmware.id!=null"><div ng-show="editForm.boardReference.$invalid"><p class="help-block" ng-show="editForm.boardReference.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boardReference.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.fileDescription" for="field_fileDescription">Description</label> <input type="text" class="form-control" name="fileDescription" id="field_fileDescription" ng-model="vm.tabFirmware.description" ng-maxlength="255"><div ng-show="editForm.fileDescription.$invalid"><p class="help-block" ng-show="editForm.fileDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group" ngf-drop ngf-change="vm.setFileContent($file, vm.tabFirmware)"><label class="control-label" translate="jotApp.tabFirmware.fileContent" for="field_fileContent">File Content</label><div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileContent($file, vm.tabFirmware)" translate="entity.action.addblob">Add blob</button><div class="help-block clearfix"><button ng-click="vm.tabFirmware.firmwareBody=null;vm.tabFirmware.fileContentType=null;" ng-if="vm.tabFirmware.firmwareBody" class="btn btn-primary btn-circle btn-sm">Remove</button> <a class="btn btn-primary btn-circle btn-sm" ng-click="vm.openFile(vm.tabFirmware.fileContentType, vm.tabFirmware.firmwareBody)" ng-if="vm.tabFirmware.firmwareBody" target="_blank" translate="entity.action.open">open</a> <span ng-if="vm.tabFirmware.firmwareBody"><span translate="jotApp.tabFirmware.fileContentExt"></span>: {{vm.tabFirmware.fileContentType}} {{byteSize(vm.tabFirmware.firmwareBody)}}</span></div></div><input type="hidden" class="form-control" name="fileContent" id="field_fileContent" ng-model="vm.tabFirmware.firmwareBody" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.tabFirmware.fileContentType"><div ng-show="editForm.fileContent.$invalid"><p class="help-block" ng-show="editForm.fileContent.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabFirmware.isActive"> <span></span><div translate="jotApp.tabFirmware.fileActive"></div></label></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.tabObjectType" for="field_tabObjectTypes">Object Type</label><ui-select id="field_tabObjectTypes" name="tabObjectTypes" ng-model="vm.tabFirmware.objectType" theme="bootstrap" search-enabled="false" required ng-disabled="vm.tabFirmware.id!=null"><ui-select-match placeholder="Select an object type..">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes track by item.id" percent="90" when-scrolled="vm.loadPage(vm.page + 1)"><div ng-bind-html="item.objectTypeName"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.tabObjectTypes.$invalid"><p class="help-block" ng-show="vm.editForm.tabObjectTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-firmware/tab-firmware-enable-dialog.html','<form name="enableForm" ng-submit="vm.confirmEnable()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.enable.title">Confirm enable operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFirmware.enable.question" translate-values="{version: \'{{vm.tabFirmware.version}}\', name: \'{{vm.tabFirmware.address}}\'}">Are you sure you want to enable this Firmware Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="enableForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-check"></span>&nbsp;<span translate="entity.action.enable">Enable</span></button></div></form>');
$templateCache.put('app/entities/tab-firmware/tab-firmware-upgrade.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFirmware.home.upgradeVersion">Upgrade Firmware Version</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.fileAddress" for="field_fileAddress">Address</label> <input type="text" class="form-control" name="fileAddress" id="field_fileAddress" ng-model="vm.tabFirmware.address" required ng-maxlength="100" ng-disabled="true"><div ng-show="editForm.fileAddress.$invalid"><p class="help-block" ng-show="editForm.fileAddress.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.tabObjectType" for="field_tabObjectTypes">Object Type</label> <select required class="form-control" id="field_tabObjectTypes" name="tabObjectTypes" ng-model="vm.tabFirmware.objectType" ng-options="tabObjectTypes as (tabObjectTypes.objectTypeName | capitalize) for tabObjectTypes in vm.tabObjectTypes track by tabObjectTypes.id" ng-disabled="true"></select><div ng-show="vm.editForm.tabObjectTypes.$invalid"><p class="help-block" ng-show="vm.editForm.tabObjectTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.currentVersion" for="field_currentVersion">Current Version</label> <input type="text" class="form-control" name="deviceReleaseVersion" id="field_currentVersion" value="{{::vm.tabFirmware.version}}" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.newVersion" for="field_fileVersion">New Version</label> <input type="text" class="form-control" name="fileVersion" id="field_fileVersion" ng-model="vm.tabFirmware.version" ng-maxlength="15" ng-change="vm.isSameVersion()" required ng-pattern="\'(\\\\d+)\\\\.(\\\\d+)\\\\.(\\\\d+)\'"><div ng-show="editForm.fileVersion.$invalid || vm.isSameVersion()"><p class="help-block" ng-show="editForm.fileVersion.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileVersion.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="help-block" ng-show="editForm.fileVersion.$error.pattern">This field must match the git versioning pattern major.minor.patch</p><p class="help-block" ng-show="vm.isSameVersion()">Change version of firmware</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.boardReference" for="field_boardReference">boardReference</label> <input type="text" class="form-control" name="boardReference" id="field_boardReference" ng-model="vm.tabFirmware.boardReference" required ng-maxlength="100" ng-disabled="true"><div ng-show="editForm.boardReference.$invalid"><p class="help-block" ng-show="editForm.boardReference.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boardReference.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFirmware.fileDescription" for="field_fileDescription">Description</label> <input type="text" class="form-control" name="fileDescription" id="field_fileDescription" ng-model="vm.tabFirmware.description" ng-maxlength="255"><div ng-show="editForm.fileDescription.$invalid"><p class="help-block" ng-show="editForm.fileDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group" ngf-drop ngf-change="vm.setFileContent($file, vm.tabFirmware)"><label class="control-label" translate="jotApp.tabFirmware.fileContent" for="field_fileContent">File Content</label><div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileContent($file, vm.tabFirmware)" translate="entity.action.addblob">Add blob</button><div class="help-block clearfix"><button ng-click="vm.tabFirmware.fileContent=null;vm.tabFirmware.fileContentType=null;" ng-if="vm.tabFirmware.firmwareBody" class="btn btn-primary btn-circle btn-sm">Remove</button> <a class="btn btn-primary btn-circle btn-sm" ng-click="vm.openFile(vm.tabFirmware.fileContentType, vm.tabFirmware.firmwareBody)" ng-if="vm.tabFirmware.fileContent" target="_blank" translate="entity.action.open">open</a> <span ng-if="vm.tabFirmware.fileContent"><span translate="jotApp.tabFirmware.fileContentExt"></span>: {{vm.tabFirmware.fileContentType}} {{byteSize(vm.tabFirmware.fileContent)}}</span></div></div><input type="hidden" class="form-control" name="fileContent" id="field_fileContent" ng-model="vm.tabFirmware.firmwareBody" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.tabFirmware.fileContentType"><div ng-show="editForm.fileContent.$invalid"><p class="help-block" ng-show="editForm.fileContent.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" class="form-control" name="isActive" id="field_isActive" ng-model="vm.tabFirmware.isActive"> <span></span><div translate="jotApp.tabFirmware.fileActive"></div><div ng-show="editForm.isActive.$invalid"><p class="help-block" ng-show="editForm.isActive.$error.required" translate="entity.validation.required">This field is required.</p></div></label></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving || vm.isSameVersion()" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-firmware/tab-firmware.html','<div class="app-content-body"><jhi-alert></jhi-alert><firmware-filter filter="vm.applyFilter(objectType)" object-type-val="vm.objectType"></firmware-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-firmware-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabFirmware.home.createLabel">Create new File</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Address or Board Reference..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th class="open-row-col"></th><th multi-sort-by="address"><span translate="jotApp.tabFirmware.fileAddress">Device Release Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="boardReference"><span translate="jotApp.tabFirmware.boardReference">boardReference</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="active"><span translate="jotApp.tabFirmware.fileActive">Is Active</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="version"><span translate="jotApp.tabFirmware.fileVersion">fileVersion</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="extension"><span translate="jotApp.tabFirmware.extension">Extension</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.tabFirmware.tabObjectType">Object Type</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat-start="tabFirmware in vm.tabFirmware track by tabFirmware.id"><td class="open-row-col" ng-click="tabFirmware.expanded = !tabFirmware.expanded"><div ng-if="vm.tabFirmwareInactive[tabFirmware.address + tabFirmware.objectType.objectTypeName].length > 0"><i ng-if="!tabFirmware.expanded" class="fa fa-plus-square"></i> <i ng-if="tabFirmware.expanded" class="fa fa-minus-square" aria-hidden="true"></i></div></td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded" ng-bind-html="tabFirmware.address | highlight:vm.charToSearch"></td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded" ng-bind-html="tabFirmware.boardReference | highlight:vm.charToSearch"></td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded"><span class="label label-danger" ng-show="!tabFirmware.isActive">{{tabFirmware.isActive}}</span> <span class="label label-success" ng-show="tabFirmware.isActive">{{tabFirmware.isActive}}</span></td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded">{{tabFirmware.version}}</td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded">{{tabFirmware.extension}}</td><td ng-click="tabFirmware.expanded = !tabFirmware.expanded">{{tabFirmware.objectType.objectTypeName}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-firmware-detail({id:tabFirmware.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware-edit({id:tabFirmware.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li ng-if="!tabFirmware.isActive"><a href="javascript:;" ui-sref="tab-firmware.enable({id:tabFirmware.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware-upgrade({id:tabFirmware.id})"><i class="fa fa-plus"></i><span translate="entity.action.upgrade"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware.delete({id:tabFirmware.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="tabFirmware.expanded" ng-repeat="tabFirmwareInactive in vm.tabFirmwareInactive[tabFirmware.address + tabFirmware.objectType.objectTypeName]"><td class="open-row-col"></td><td><i class="fa fa-circle" aria-hidden="true"></i></td><td>{{tabFirmwareInactive.boardReference}}</td><td><span class="label label-danger" ng-show="!tabFirmwareInactive.isActive">{{tabFirmwareInactive.isActive}}</span> <span class="label label-success" ng-show="tabFirmwareInactive.isActive">{{tabFirmwareInactive.isActive}}</span></td><td>{{tabFirmwareInactive.version}}</td><td>{{tabFirmwareInactive.extension}}</td><td>{{tabFirmware.objectType.objectTypeName}}</td><td><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-firmware-detail({id:tabFirmwareInactive.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware-edit({id:tabFirmwareInactive.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware.enable({id:tabFirmwareInactive.id})"><i class="fa fa-check"></i><span translate="entity.action.enable"></span></a></li><li><a href="javascript:;" ui-sref="tab-firmware.delete({id:tabFirmwareInactive.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr><tr ng-if="false" ng-repeat-end=""></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-fleets/tab-fleets-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabFleets.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabFleets.delete.question" translate-values="{id: \'{{vm.tabFleets.fleetName}}\'}">Are you sure you want to delete this Tab Fleets?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-fleets/tab-fleets-detail.html','<div class="app-content-body detail-page fleet-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabFleets.detail.title">Tab Fleets</span> {{vm.tabFleets.fleetName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabFleets.fleetName">Fleet Name</span></dt><dd><span>{{vm.tabFleets.fleetName}}</span></dd><dt><span translate="jotApp.tabFleets.fleetDescription">Fleet Description</span></dt><dd><span>{{vm.tabFleets.fleetDescription}}</span></dd><dt><span translate="jotApp.tabFleets.user">User</span></dt><dd><span ng-repeat="user in vm.tabFleets.users">{{user.login}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabFleets.file">File</span></dt><dd><span ng-repeat="file in vm.tabFleets.files"><a ui-sref="tab-files-detail({id: {{file.id}}})">{{file.fileAlias}}</a>{{$last ? \'\' : \', \'}}</span></dd><dd><dt><span translate="jotApp.tabFleets.otherMetrics">Other Metrics</span></dt></dd><dd><span>{{vm.tabFleets.otherMetrics}}</span></dd><dt><span translate="jotApp.tabFleets.createdBy">Created By</span></dt><dd><span>{{vm.tabFleets.createdBy}}</span></dd><dt><span translate="jotApp.tabFleets.createdDate">Created Date</span></dt><dd><span>{{vm.tabFleets.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabFleets.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabFleets.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabFleets.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabFleets.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-fleets/tab-fleets-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabFleets.home.createOrEditLabel">Create or edit a Fleet</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFleets.fleetName" for="field_fleetName">Fleet Name</label> <input type="text" class="form-control" name="fleetName" id="field_fleetName" ng-model="vm.tabFleets.fleetName" required ng-maxlength="50" ng-pattern="/^(?:[a-zA-Z0-9]+(?:[-_][a-zA-Z0-9]+)*)$/"><div ng-show="editForm.fleetName.$invalid"><p class="help-block" ng-show="editForm.fleetName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fleetName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.fleetName.$error.pattern">Fleet Name can only contain letters, digits, score and underscore.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFleets.fleetDescription" for="field_fleetDescription">Fleet Description</label> <input type="text" class="form-control" name="fleetDescription" id="field_fleetDescription" ng-model="vm.tabFleets.fleetDescription" ng-maxlength="255"><div ng-show="editForm.fleetDescription.$invalid"><p class="help-block" ng-show="editForm.fleetDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabFleets.user" for="field_user">User</label> <select class="form-control" id="field_user" chosen multiple="multiple" name="user" ng-model="vm.tabFleets.users" ng-options="user as user.login for user in vm.domain.users track by user.id" data-placeholder-text-multiple="\' \'"></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group" ng-show="vm.tabFleets.domains" has-authority="ROLE_ADMIN"><label translate="jotApp.tabFleets.domain" for="field_domain">Domain</label> <select class="form-control" id="field_domain" ng-change="vm.reloadUsers()" name="domain" ng-model="vm.tabFleets.domains" ng-options="domain as domain.domainName for domain in vm.domains track by domain.id"></select></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabFleets.otherMetrics" for="field_otherMetrics">Other Metrics</label> <input type="text" class="form-control" name="otherMetrics" id="field_otherMetrics" ng-model="vm.tabFleets.otherMetrics" placeholder="Every property must finish with \' ; \' character. Dot notation is allowed" ng-maxlength="1000" ng-pattern="/^(?:(?:[\\w-$&]+(?:\\.[\\w-$&]+)*);\\s*){0,3}$/"><div ng-show="editForm.otherMetrics.$invalid"><p class="help-block" ng-show="editForm.otherMetrics.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p><p class="help-block" ng-show="editForm.otherMetrics.$error.pattern">Every property must finish with \' ; \' character</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group" has-authority="ROLE_ADMIN"><label translate="jotApp.tabFleets.file" for="field_file">File</label> <select class="form-control" id="field_file" chosen multiple="multiple" name="device" ng-model="vm.tabFleets.files" ng-options="tabFiles as tabFiles.fileAlias for tabFiles in vm.tabfiles track by tabFiles.id" data-placeholder-text-multiple="\' \'"></select></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-fleets/tab-fleets-manage-object.html','<div class="app-content-body fleet-manage-object-page"><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="tab-fleets" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span translate="jotApp.tabFleets.object.title">Manage Objects</span></h1></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-md-6"><div class="row"><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.fleet" for="field_fleet1">Fleet</label><ui-select id="field_fleet1" name="fleet1" ng-model="vm.fleet1" ng-change="vm.change(vm.fleet1, vm.type1)" theme="bootstrap" required><ui-select-match placeholder="Select a Fleet...">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search" ng-if="!item.selected"></div></ui-select-choices></ui-select></div><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.search" for="field_code1">Search</label> <input type="text" class="form-control" name="code1" id="field_code1" ng-model="vm.fleetFilters.objectUniqueCode" placeholder="Unique Code or Name..." ng-maxlength="100"></div><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.type" for="field_type1">Object Type</label> <select class="form-control" ng-model="vm.fleetFilters.type" name="type" id="field_type1" style="cursor: pointer"><option ng-repeat="type in vm.type1">{{type}}</option></select></div></div><div class="list-wrapper left"><div ng-repeat="obj in vm.fleets[vm.getIndex(vm.fleet1)].fleetList | fleetFilter: vm.fleetFilters as filtered track by $index" ng-click="vm.moveObj(obj,  vm.fleets[vm.getIndex(vm.fleet1)], vm.fleets[vm.getIndex(vm.fleet2)])" class="list-element"><div class="list-elem-txt"><h4>{{obj.objectUniqueCode}}</h4><h5>{{obj.objectName}}</h5><span class="glyphicon glyphicon-arrow-right arrow"></span></div></div><div class="no-content-element list-element" ng-if="filtered.length < 1">No object</div></div></div><div class="col-xs-12 col-md-6"><div class="row"><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.fleet" for="field_fleet2">Fleet</label><ui-select id="field_fleet2" name="fleet2" ng-model="vm.fleet2" ng-change="vm.change(vm.fleet2, vm.type2)" theme="bootstrap" required><ui-select-match placeholder="Select a Fleet...">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search" ng-if="!item.selected"></div></ui-select-choices></ui-select></div><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.search" for="field_code2">Search</label> <input type="text" class="form-control" name="code2" id="field_code2" ng-model="vm.fleet2Filters.objectUniqueCode" placeholder="Unique Code or Name..." ng-maxlength="100"></div><div class="form-group col-lg-4 col-xs-12"><label translate="jotApp.tabFleets.object.type" for="field_type2">Object Type</label> <select class="form-control" ng-model="vm.fleet2Filters.type" name="type" id="field_type2" style="cursor: pointer"><option ng-repeat="type in vm.type2">{{type}}</option></select></div></div><div class="list-wrapper right"><div ng-repeat="obj in vm.fleets[vm.getIndex(vm.fleet2)].fleetList | fleetFilter: vm.fleet2Filters as filtered2 track by $index" ng-click="vm.moveObj(obj,  vm.fleets[vm.getIndex(vm.fleet2)], vm.fleets[vm.getIndex(vm.fleet1)])" class="list-element"><div class="list-elem-txt"><h4>{{obj.objectUniqueCode}}</h4><h5>{{obj.objectName}}</h5><span class="glyphicon glyphicon-arrow-left arrow"></span></div></div><div class="no-content-element list-element" ng-if="filtered2.length < 1">No object</div></div></div></div></div>');
$templateCache.put('app/entities/tab-fleets/tab-fleets.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-fleets-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabFleets.home.createLabel">Create new Tab Fleets</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="fleetName"><span translate="jotApp.tabFleets.fleetName">Fleet Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fleetDescription"><span translate="jotApp.tabFleets.fleetDescription">Fleet Description</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabFleets in vm.tabFleets  | filter:vm.searchText track by tabFleets.id"><td ng-bind-html="tabFleets.fleetName | highlight: vm.searchText"></td><td ng-bind-html="tabFleets.fleetDescription | highlight: vm.searchText"></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-fleets-detail({id:tabFleets.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-fleets-edit({id:tabFleets.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-fleets-object({id:tabFleets.id})"><i class="fa fa-cubes"></i><span translate="entity.action.object"></span></a></li><li><a href="javascript:;" ui-sref="tab-fleets.delete({id:tabFleets.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/insert-object.html','<form name="vendorForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Insert new metric in Object</h4></div><div class="row"><div class="col-md-6 col-xs-12" style="margin-left: 5px; margin-right:-5px"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyName" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.property.name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><types-mapping id="field_type" type="vm.property.type"></types-mapping><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" ng-disabled="vendorForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/tab-object-types/object-types-device-releases.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.tabObjectTypes.home.createOrEditLabel">Create or edit a Object Type</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.objectTypeName" for="field_objectTypeName">Object Type Name</label> <input type="text" class="form-control" name="objectTypeName" id="field_objectTypeName" ng-model="vm.tabObjectTypes.objectTypeName" ng-disabled="true"></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" data-detail-view="true"><thead><tr><th translate="jotApp.tabObjectTypes.device">Device</th><th translate="jotApp.tabObjectTypes.deviceReleases">Device Release</th><th>Default Version</th><th>Choose Version</th></tr></thead><tbody ng-repeat="(deviceIndex, device) in vm.tabDevices"><tr ng-repeat="(releaseIndex, deviceRelease) in vm.tabDeviceReleases[deviceIndex] | filter: {isActive : true}"><td>{{device.deviceName}}</td><td>{{deviceRelease.deviceReleaseName}}</td><td>{{deviceRelease.deviceReleaseVersion}}</td><td><div class="input-group"><select class="form-control" name="deviceReleases" id="field_deviceReleases" ng-model="vm.deviceReleasesForced[deviceRelease.deviceReleaseName]" ng-options="tabDeviceReleases as tabDeviceReleases.deviceReleaseVersion for tabDeviceReleases in vm.tabDeviceReleases[deviceIndex] | filter: {deviceReleaseName: deviceRelease.deviceReleaseName} track by tabDeviceReleases.id"><option value="" disabled="disabled">Select Version</option></select><div class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="vm.clearDependency(deviceRelease.deviceReleaseName)"><span>Clear</span></button></div></div></td></tr></tbody></table></div></div><div class="form-actions"><button type="submit" ng-disabled="isSaving || editForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/recursive-row.html','<tr ng-show="visibility"><td style="padding-left: {{model.level}}">{{model.name}}</td><td>{{model.type}}</td><td class="text-center"><i class="fa" ng-class="model.folderClass" ng-click="toggleChildren(model)"></i> <i class="fa" ng-class="model.addMetric" ng-click="clickHere(model.subProperties)"></i></td></tr><tr recursive-row ng-repeat="child in model.subProperties" model="child" visibility="model.childrenVisible"></tr>');
$templateCache.put('app/entities/tab-object-types/tab-object-types-delete-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error ng-if="!vm.hasIndices"></jhi-alert-error><p translate="jotApp.tabObjectTypes.delete.question" translate-values="{id: \'{{vm.tabObjectTypes.objectTypeName}}\'}" ng-if="!vm.hasIndices">Are you sure you want to delete this Tab Object Types?</p><p translate="jotApp.tabObjectTypes.delete.questionIndices" translate-values="{id: \'{{vm.tabObjectTypes.objectTypeName}}\'}" ng-if="vm.hasIndices">Tab Object Types has indices do you want to delete also his indices?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger" ng-if="vm.hasIndices" ng-click="vm.confirmDelete(vm.tabObjectTypes.id,1)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="jotApp.tabObjectTypes.action.deleteTabObject">Delete Only TabObject</span></button> <button type="submit" class="btn btn-danger" ng-if="vm.hasIndices" ng-click="vm.confirmDelete(vm.tabObjectTypes.id,2)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="jotApp.tabObjectTypes.action.deleteBoth">Delete Both</span></button> <button type="submit" class="btn btn-danger" ng-if="!vm.hasIndices" ng-click="vm.confirmDelete(vm.tabObjectTypes.id,0)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div>');
$templateCache.put('app/entities/tab-object-types/tab-object-types-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabObjectTypes.detail.title">Tab Object Types</span> {{vm.tabObjectTypes.objectTypeName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabObjectTypes.objectTypeName">Object Type Name</span></dt><dd><span>{{vm.tabObjectTypes.objectTypeName}}</span></dd><dt><span translate="jotApp.tabObjectTypes.objectTypeDescription">Object Type Description</span></dt><dd><span>{{vm.tabObjectTypes.objectTypeDescription}}</span></dd><dt><span translate="jotApp.tabObjectTypes.objectTypeNotes">Object Type Notes</span></dt><dd><span>{{vm.tabObjectTypes.objectTypeNotes}}</span></dd><dt><span translate="jotApp.tabObjectTypes.device">Device</span></dt><dd><span ng-repeat="device in vm.tabObjectTypes.devices"><a ui-sref="tab-devices-detail({id: {{device.id}}})">{{device.deviceName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabObjectTypes.tabFileTypes">File</span></dt><dd><span ng-repeat="file in vm.tabObjectTypes.fileTypes">{{file.fileTypeName}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabObjectTypes.script">Scripts</span></dt><dd><span ng-repeat="script in vm.tabObjectTypes.scripts"><a ui-sref="tab-update-scripts-detail({id: {{script.id}}})">{{script.scriptName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabObjectTypes.deviceReleases">Device Release</span></dt><dd><span ng-repeat="deviceRelease in vm.tabObjectTypes.deviceReleases"><a ui-sref="tab-device-releases-detail({id: {{deviceRelease.id}}})">{{deviceRelease.deviceReleaseName}}_{{deviceRelease.deviceReleaseVersion}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.tabObjectTypes.firmware">Firmwares</span></dt><dd><span ng-repeat="firmwares in vm.tabObjectTypes.firmwares"><span ng-if="firmwares.isActive == true"><a ui-sref="tab-firmware-detail({id: {{firmwares.id}}})">{{firmwares.address}}_{{firmwares.version}}</a>{{$last ? \'\' : \', \'}}</span></span></dd><dt><span translate="jotApp.tabObjectTypes.createdBy">Created By</span></dt><dd><span>{{vm.tabObjectTypes.createdBy}}</span></dd><dt><span translate="jotApp.tabObjectTypes.createdDate">Created Date</span></dt><dd><span>{{vm.tabObjectTypes.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabObjectTypes.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabObjectTypes.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabObjectTypes.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabObjectTypes.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span>Is Greengrass</span></dt><dd><span>{{vm.tabObjectTypes.greengrassType}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/tab-object-types-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabObjectTypes.home.createOrEditLabel">Create or edit a Object Type</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation ng-submit="vm.save()"><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.objectTypeName" for="field_objectTypeName">Object Type Name</label> <input type="text" class="form-control" name="objectTypeName" id="field_objectTypeName" ng-model="vm.tabObjectTypes.objectTypeName" required ng-maxlength="50" ng-disabled="vm.tabObjectTypes.id !== null"><div ng-show="editForm.objectTypeName.$invalid"><p class="help-block" ng-show="editForm.objectTypeName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.objectTypeName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.objectTypeDescription" for="field_objectTypeDescription">Object Type Description</label> <input type="text" class="form-control" name="objectTypeDescription" id="field_objectTypeDescription" ng-model="vm.tabObjectTypes.objectTypeDescription" ng-maxlength="255"><div ng-show="editForm.objectTypeDescription.$invalid"><p class="help-block" ng-show="editForm.objectTypeDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.objectTypeNotes" for="field_objectTypeNotes">Object Type Notes</label> <input type="text" class="form-control" name="objectTypeNotes" id="field_objectTypeNotes" ng-model="vm.tabObjectTypes.objectTypeNotes" ng-maxlength="10000"><div ng-show="editForm.objectTypeNotes.$invalid"><p class="help-block" ng-show="editForm.objectTypeNotes.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div></div></div><div class="row" ng-if="!vm.tabObjectTypes.skipBurnin"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabObjectTypes.device" for="field_device">Device</label> <select required class="form-control" id="field_device" chosen multiple="multiple" name="device" ng-model="vm.tabObjectTypes.devices" ng-options="tabDevices as tabDevices.deviceName for tabDevices in vm.tabdevices track by tabDevices.id" data-placeholder-text-multiple="\' \'"></select><div ng-show="vm.editForm.device.$invalid"><p class="help-block" ng-show="vm.editForm.device.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabObjectTypes.tabFileTypes" for="field_tabFileTypes">Device</label> <select required class="form-control" id="field_tabFileTypes" chosen multiple="multiple" name="tabFileTypes" ng-model="vm.tabObjectTypes.fileTypes" ng-options="tabFileTypes as tabFileTypes.fileTypeName for tabFileTypes in vm.tabFileTypes track by tabFileTypes.id" data-placeholder-text-multiple="\' \'"></select><div ng-show="vm.editForm.tabFileTypes.$invalid"><p class="help-block" ng-show="vm.editForm.tabFileTypes.$error.required" translate="entity.validation.required">This field is required</p></div></div></div></div><div class="row"><div class="col-md-3 col-xs-6"><div class="form-group"><div class="mt-checkbox-inline"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.tabObjectTypes.skipBurnin"><span></span> Skip Burnin</label></div></div></div><div class="col-md-3 col-xs-6" style="margin-top: -20px"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isMultipleDocs"><input type="checkbox" name="isMultipleDocs" id="field_isMultipleDocs" ng-model="vm.tabObjectTypes.multipleDocs"> <span></span><div translate="jotApp.tabObjectTypes.multipleDocs"></div></label></div></div></div><div class="col-md-3 col-xs-6" style="margin-top: -20px"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_greengrassType"><input type="checkbox" id="field_greengrassType" name="greengrassType" ng-model="vm.tabObjectTypes.greengrassType"> <span></span><div>Is Greengrass</div></label></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-if="!vm.tabObjectTypes.id" class="btn btn-primary" ng-disabled="!vm.tabObjectTypes.devices || !vm.tabObjectTypes.objectTypeName" ng-click="vm.saveAndContinue()"><span class="fa fa-step-forward">&nbsp;</span>Save & Continue</button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/tab-object-types-mapping-dialog.html','<div class="app-content-body detail-page domain-detail-page"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabObjectTypes.mapping.createLabel">Create a Property</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation ng-submit="vm.save()"><div class="form-body"><div class="col-xs-12"><div class="form-group"><label class="switch aside-right"><input type="checkbox" ng-click="vm.createObj = !vm.createObj" ng-checked="vm.createObj"> <span class="form-mode-toggle add-mode-toggle round"></span></label></div></div><div ng-if="!vm.createObj"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyName" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.property.name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><types-mapping id="field_type" type="vm.property.type"></types-mapping><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div></div><div ng-if="vm.createObj"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.quantity" for="field_quantity">Quantity</label> <input type="number" class="form-control" name="quantity" id="field_quantity" ng-model="vm.quantity" min="1" max="100" required><div ng-show="vm.editForm.quantity.$invalid"><div ng-show="vm.editForm.quantity.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><div ng-show="vm.editForm.quantity.$error.min"><p class="help-block">The quantity min value is 1</p></div><div ng-show="vm.editForm.quantity.$error.max"><p class="help-block">The quantity max value is 100</p></div></div></div></div></div><div class="row" ng-if="vm.quantity > 0"><div class="row" ng-class="vm.properties[$index].type.toLowerCase() === \'object\' ? \'types-mapping-object-json\' : false" ng-repeat="quantity in [].constructor(vm.quantity) track by $index"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyName" for="field_name_obj">Name</label> <input type="text" class="form-control" name="name" id="field_name_obj" ng-model="vm.properties[$index].name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><!--                                                <label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyType" for="field_type_obj">Type</label>--><!--                                                <input type="text" class="form-control" name="type" id="field_type_obj"--><!--                                                       ng-model="vm.properties[$index].type"--><!--                                                       required ng-maxlength="50"/>--><types-mapping id="field_type_obj" type="vm.properties[$index].type"></types-mapping><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-12 col-xs-12" ng-if="vm.properties[$index].type.toLowerCase() === \'object\'"><div class="form-group"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.objectJson" for="field_json">Object JSON</label> <textarea rows="5" class="form-control" name="objectJson" id="field_json" ng-model="vm.properties[$index].objectJson" style="resize: none" required ng-maxlength="10000"></textarea><div ng-show="editForm.objectJson.$invalid"><p class="help-block" ng-show="editForm.objectJson.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.objectJson.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving || (vm.property.type === \'\' && !vm.createObj)" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/tab-object-types-mapping.html','<div class="app-content-body detail-page domain-detail-page"><jhi-alert></jhi-alert><div ng-if="vm.templateMetric.length > 0"><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="tab-object-types" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span translate="jotApp.tabObjectTypes.detail.title">Tab Object Types</span> {{vm.tabObjectTypes.objectTypeName}}</h1></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Properties</span></div><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-object-types-mapping-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabObjectTypes.mapping.newProperty">Create new Property</span></button> <button type="button" ng-click="vm.updateNewObject()" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.searchText" placeholder="Search property..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr><th><span>Property</span></th><th><span>Type</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr recursive-row ng-repeat="model in vm.templateMetric" model="model" visibility="model.visibility"></tr></tbody></table></div></div></div></div></div></div></div><div ng-if="vm.templateMetric.length == 0"><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="tab-object-types" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span translate="jotApp.tabObjectTypes.mapping.createTemplate">Create new Template: </span>{{vm.tabObjectTypes.objectTypeName}}</h1></div></div><div class="row"><div class="col-md-12 col-xs-12"><label class="control-label" translate="jotApp.tabObjectTypes.mapping.insertJSON" for="field_json">Insert JSON</label> <textarea ng-change="vm.updateJsonObject()" ng-model="vm.script" rows="20" class="form-control" style="width: 100%; resize: none" id="field_json"></textarea><!--                <b ng-if="vm.isValid">Valid Json</b>--> <b ng-if="!vm.isValid">{{vm.errorJson}}</b><br><br><button type="button" ng-click="vm.save()" ng-disabled="!vm.isValid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></div></div>');
$templateCache.put('app/entities/tab-object-types/tab-object-types.html','<div class="app-content-body"><jhi-alert></jhi-alert><object-type-filter filter="vm.applyFilter(device)" device-val="vm.device"></object-type-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-object-types-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabObjectTypes.home.createLabel">Create new Tab Object Types</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="objectTypeName"><span translate="jotApp.tabObjectTypes.objectTypeName">Object Type Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectTypeDescription"><span translate="jotApp.tabObjectTypes.objectTypeDescription">Object Type Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="skipBurnin"><span translate="jotApp.tabObjectTypes.skipBurnin">Burnin to skip</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectTypeNotes"><span translate="jotApp.tabObjectTypes.objectTypeNotes">Object Type Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="greengrassType"><span>Is greengrass</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabObjectTypes in vm.tabObjectTypes track by tabObjectTypes.id"><td ng-bind-html="tabObjectTypes.objectTypeName | highlight: vm.charToSearch"></td><td ng-bind-html="tabObjectTypes.objectTypeDescription | highlight: vm.charToSearch"></td><td><span ng-class="tabObjectTypes.skipBurnin ? [\'label\', \'label-success\'] : [\'label\', \'label-danger\']">{{tabObjectTypes.skipBurnin}}</span></td><td>{{tabObjectTypes.objectTypeNotes}}</td><td><span ng-class="tabObjectTypes.greengrassType ? [\'label\', \'label-success\'] : [\'label\', \'label-danger\']">{{tabObjectTypes.greengrassType}}</span></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-object-types-detail({id:tabObjectTypes.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-object-types-mapping({id:tabObjectTypes.id})"><i class="fa fa-eye"></i><span>Mapping</span></a></li><li><a href="javascript:;" ui-sref="tab-object-types-edit({id:tabObjectTypes.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="object-types-device-releases({id:tabObjectTypes.id})"><i class="fa fa-pencil"></i><span>Edit Dependencies</span></a></li><li><a href="javascript:;" ui-sref="tab-object-types.delete({id:tabObjectTypes.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/massive-properties-update.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.tabProperties.massive.title">Update objects properties</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form no-action-border"><div class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" translate="jotApp.tabProperties.massive.fleetLabel">Fleet</label><ui-select on-select="vm.selectedFleet($item)" ng-model="vm.fleet" theme="bootstrap"><ui-select-match ng-click="vm.fleet=null" placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-6" ng-if="vm.fleet"><div class="form-group"><label class="control-label" translate="jotApp.tabProperties.massive.objectLabel">Object Type</label><ui-select on-select="vm.selectObjectType($item)" ng-model="vm.objType" theme="bootstrap"><ui-select-match ng-click="vm.deselectObjTy($item)" placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div></div></div><div class="row" ng-if="vm.tabObjects.length>0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-object-group"></i> <span translate="jotApp.tabProperties.massive.portletTitle">Object Properties List</span></div><div class="actions"><button class="btn btn-primary" ng-disabled="vm.selectionValue.length <= 0" ng-click="vm.checkOverwrittenProperties()"><span class="fa fa-check"></span> <span translate="jotApp.tabObjects.home.massiveUpdateProperties">Update Properties</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose"></select></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr><th class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input ng-click="vm.chkUnChkAll()" ng-checked="vm.allChecked" type="checkbox"><i></i> <span></span></label></th><th style="width:3%" translate="jotApp.tabProperties.massive.edited"></th><th>Object code</th><th>Object Name</th><th>Object Description</th></tr></thead><tbody><tr ng-repeat="obj in vm.tabObjects | limitTo: vm.itemsPerPageChosen:(vm.currentPage - 1) * vm.itemsPerPageChosen track by $index"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" id="chekObj-{{obj.id}}" name="chekObj-{{obj.id}}" ng-checked="vm.objectChecked[$index+(vm.itemsPerPageChosen * (vm.currentPage - 1))]" ng-click="vm.toggleSelection(obj,$index+(vm.itemsPerPageChosen * (vm.currentPage - 1)))"> <span></span></label></td><td class="text-center"><span class="fa fa-pencil" ng-if="obj.hasOverrideProperties" uib-tooltip="Contains overwritten properties" tooltip-placement="auto top"></span></td><td><span class="text-ellipsis">{{obj.objectUniqueCode}}</span></td><td><span class="text-ellipsis">{{obj.objectName}}</span></td><td><span class="text-ellipsis">{{obj.objectDescription}}</span></td></tr></tbody></table></div><div class="row"><div class="col-sm-12"><div class="text-center"><ul uib-pagination boundary-links="true" items-per-page="vm.itemsPerPageChosen" total-items="vm.tabObjects.length" ng-model="vm.currentPage" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabObjects.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabObjects.delete.question" translate-values="{id: \'{{vm.tabObjects.objectUniqueCode}}\'}">Are you sure you want to delete this Tab Objects?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-detail.html','<div class="app-content-body detail-page object-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabObjects.detail.title"></span> {{vm.tabObjects.objectUniqueCode}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabObjects.objectName">Object Name</span></dt><dd><span>{{vm.tabObjects.objectName}}</span></dd><dt><span translate="jotApp.tabObjects.objectDescription">Object Description</span></dt><dd><span>{{vm.tabObjects.objectDescription}}</span></dd><dt><span translate="jotApp.tabObjects.objectNotes">Object Notes</span></dt><dd><span>{{vm.tabObjects.objectNotes}}</span></dd><dt><span translate="jotApp.tabObjects.objectLocation">Location</span></dt><dd><span>{{vm.tabObjects.objectLocation}}</span></dd><dt><span translate="jotApp.tabObjects.objectLongitude">Object Longitude</span></dt><dd><span>{{vm.tabObjects.objectLongitude}}</span></dd><dt><span translate="jotApp.tabObjects.objectLatitude">Object Latitude</span></dt><dd><span>{{vm.tabObjects.objectLatitude}}</span></dd><dt><span translate="jotApp.tabObjects.fieldLongitude">Field Longitude</span></dt><dd><span>{{vm.tabObjects.fieldLongitude}}</span></dd><dt><span translate="jotApp.tabObjects.fieldLatitude">Field Latitude</span></dt><dd><span>{{vm.tabObjects.fieldLatitude}}</span></dd><dt><span translate="jotApp.tabObjects.objectTimezone">Timezone</span></dt><dd><span>{{vm.tabObjects.objectTimeZone}}</span></dd><dt><span translate="jotApp.tabObjects.fleet">Fleet</span></dt><dd><span><a ui-sref="tab-fleets-detail({id: vm.tabObjects.fleet.id})">{{vm.tabObjects.fleet.fleetName}}</a></span></dd><dt><span translate="jotApp.tabObjects.objectType">Object Type</span></dt><dd><span has-authority="ROLE_ADMIN"><a ui-sref="tab-object-types-detail({id: vm.tabObjects.objectType.id})">{{vm.tabObjects.objectType.objectTypeName}}</a> </span><span evaluate-authorities="!ROLE_ADMIN">{{vm.tabObjects.objectType.objectTypeName}}</span></dd><dt><span translate="jotApp.tabObjects.objectStates">Object States</span></dt><dd><span>{{vm.tabObjects.objectStates.objectStateName}}</span></dd><dt><span translate="jotApp.tabObjects.dashboard.lastTick">Object States</span></dt><dd><span>{{vm.tabObjects.lastTick | date:\'dd/MM/yyyy HH:mm:ss\' }}</span></dd><dt><span translate="jotApp.tabObjects.ipAddress">IP Addr</span></dt><dd><span>{{vm.tabObjects.objectIp}}</span></dd><!--<dt><span translate="jotApp.tabObjects.deviceRelease">Device Release</span></dt>--><!--<dd>--><!--<span ng-repeat="deviceRelease in vm.tabObjects.deviceReleases">--><!--<a ui-sref="tab-device-releases-detail({id: {{deviceRelease.id}}})">{{deviceRelease.deviceReleaseName}}_{{deviceRelease.deviceReleaseVersion}}</a>{{$last ? \'\' : \', \'}}--><!--</span>--><!--</dd>--><!--<dt><span translate="jotApp.tabObjects.lastUpdate">Last Modify</span></dt>--><!--<dd>--><!--<a>{{vm.tabObjects.objectLastUpdate | date:\'dd/MM/yyyy HH:mm:ss\' }}</a>--><!--</dd>--><dt ng-repeat-start="(key,value) in vm.tabObjects.objectAddata"><span>{{key}}</span></dt><dd><span>{{value}}</span></dd><span ng-repeat-end=""></span><dt><span translate="jotApp.tabObjects.createdBy">Created By</span></dt><dd><span>{{vm.tabObjects.createdBy}}</span></dd><dt><span translate="jotApp.tabObjects.createdDate">Created Date</span></dt><dd><span>{{vm.tabObjects.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabObjects.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabObjects.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabObjects.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabObjects.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-vertical"><dt><span>Deployment</span></dt><dd><table class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr><th class="text-center">Device Release</th><th class="text-center">Version</th></tr></thead><tbody><tr ng-repeat="deviceRelease in vm.tabObjects.deviceReleases"><td class="text-center" ui-sref="tab-device-releases-detail({id: {{deviceRelease.id}}})">{{deviceRelease.deviceReleaseName}}</td><td class="text-center" ui-sref="tab-device-releases-detail({id: {{deviceRelease.id}}})">{{deviceRelease.deviceReleaseVersion}}</td></tr></tbody></table></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.tabObjects.home.createOrEditLabel">Create or edit a Tab Object</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row" ng-if="!vm.tabObjects.id"><div class="col-xs-12"><div class="form-group"><label class="switch aside-right"><input type="checkbox" ng-click="vm.tabObjects.multipleCreation = !vm.tabObjects.multipleCreation" ng-checked="vm.tabObjects.multipleCreation"> <span class="form-mode-toggle add-mode-toggle round"></span></label></div></div></div><div ng-if="!vm.tabObjects.multipleCreation"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectUniqueCode" for="field_objectUniqueCode">Object Unique Code</label> <input ng-readonly="vm.tabObjects.id" type="text" class="form-control" name="objectUniqueCode" id="field_objectUniqueCode" ng-model="vm.tabObjects.objectUniqueCode" ng-pattern="/^(?:[a-zA-Z0-9]+(?:[-][a-zA-Z0-9]+)*)$/" required ng-maxlength="100"><div ng-show="vm.editForm.objectUniqueCode.$invalid"><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.pattern">This field can only contain letters digits and -</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectName" for="field_objectName">Object Name</label> <input type="text" class="form-control" name="objectName" id="field_objectName" ng-model="vm.tabObjects.objectName" required ng-maxlength="50"><div ng-show="vm.editForm.objectName.$invalid"><p class="help-block" ng-show="vm.editForm.objectName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.objectName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectDescription" for="field_objectDescription">Object Description</label> <input type="text" class="form-control" name="objectDescription" id="field_objectDescription" ng-model="vm.tabObjects.objectDescription" ng-maxlength="255"><div ng-show="vm.editForm.objectDescription.$invalid"><p class="help-block" ng-show="vm.editForm.objectDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectNotes" for="field_objectNotes">Object Notes</label> <input type="text" class="form-control" name="objectNotes" id="field_objectNotes" ng-model="vm.tabObjects.objectNotes" ng-maxlength="10000"><div ng-show="vm.editForm.objectNotes.$invalid"><p class="help-block" ng-show="vm.editForm.objectNotes.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div></div></div><div class="row" ng-if="vm.tabObjects.fieldLongitude != null && vm.tabObjects.fieldLatitude != null"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.fieldLatitude" for="field_latitude">Field Latitude</label> <input ng-readonly="vm.tabObjects.fieldLatitude" type="text" class="form-control" name="fieldLatitude" id="field_latitude" ng-model="vm.tabObjects.fieldLatitude" required ng-maxlength="50"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.fieldLongitude" for="field_longitude">Field Longitude</label> <input ng-readonly="vm.tabObjects.fieldLongitude" type="text" class="form-control" name="fieldLongitude" id="field_longitude" ng-model="vm.tabObjects.fieldLongitude" required ng-maxlength="50"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLatitude" for="field_objectLatitude">Object Latitude</label> <input type="text" class="form-control" name="objectLatitude" id="field_objectLatitude" ng-model="vm.tabObjects.objectLatitude" ng-maxlength="50" ng-change="vm.onChangeCoordsFunction()" ng-pattern="/^([-+]?)([\\d]{1,2})(((\\.)(\\d+)))$/"><div ng-show="vm.editForm.objectLatitude.$invalid"><p class="help-block" ng-show="vm.editForm.objectLatitude.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="vm.editForm.objectLatitude.$error.pattern">This field can only contain number in format 12.12345 with optional [-]</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLongitude" for="field_objectLongitude">Object Longitude</label> <input type="text" class="form-control" name="objectLongitude" id="field_objectLongitude" ng-model="vm.tabObjects.objectLongitude" ng-maxlength="50" ng-change="vm.onChangeCoordsFunction()" ng-pattern="/^(([-+]?)([\\d]{1,3})((\\.)(\\d+))?)$/"><div ng-show="vm.editForm.objectLongitude.$invalid"><p class="help-block" ng-show="vm.editForm.objectLongitude.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="vm.editForm.objectLongitude.$error.pattern">This field can only contain number in format 123.12345 with optional [-]</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectLocation" for="field_objectLocation">Location</label> <input type="text" class="form-control" name="objectLocation" id="field_objectLocation" ng-model="vm.tabObjects.objectLocation" ng-maxlength="255" ng-change="vm.onChangeAddressFunction()" ng-model-options="{debounce:1500}"><div ng-show="vm.editForm.objectLocation.$invalid"><p class="help-block" ng-show="vm.editForm.objectLocation.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 255 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabObjects.objectType" for="field_objectType">Object Type</label><ui-select id="field_objectType" name="objectType" ng-model="vm.tabObjects.objectType" ng-click="vm.serachObjectType($select.search)" theme="bootstrap" required on-select="vm.filterFleets();vm.isOriginalValue()" ng-keyup="vm.serachObjectType($select.search)"><ui-select-match placeholder="Select or search an object type..">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" percent="90" when-scrolled="vm.loadPageObjectType(vm.objectTypePage + 1)"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.objectType.$invalid"><p class="help-block" ng-show="vm.editForm.objectType.$error.required" translate="entity.validation.required">This field is required.</p></div><div ng-show="vm.tabObjects.objectType && vm.editForm.objectType.$dirty"><p class="help-block" translate="jotApp.tabObjects.objtype.warning">Changing ObjectType could lead to deletion of overwritten properties for this Object</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group" ng-show="vm.tabObjects.objectType"><label translate="jotApp.tabObjects.fleet" for="field_fleet">Fleet</label><!--                                        <select required class="form-control" id="field_fleet" name="fleet" ng-model="vm.tabObjects.fleet" ng-options="tabFleets as tabFleets.fleetName for tabFleets in vm.tabfleets track by tabFleets.id"></select>--><ui-select id="field_fleet" name="fleet" ng-model="vm.tabObjects.fleet" ng-click="vm.searchFieldFleet($select.search)" theme="bootstrap" required ng-keyup="vm.searchFieldFleet($select.search)"><ui-select-match placeholder="Select a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets" percent="90" when-scrolled="vm.loadPageFleet(vm.fleetPage + 1)"><div ng-bind-html="item.fleetName"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.fleet.$invalid"><p class="help-block" ng-show="vm.editForm.fleet.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12" ng-if="vm.timeZone.length != 0"><div class="form-group" ng-show="vm.tabObjects.objectType"><label translate="jotApp.tabObjects.zone" for="field_zone">Time Zone</label><ui-select id="field_zone" name="zone" ng-model="vm.tabObjects.timeZone" theme="bootstrap" required><ui-select-match placeholder="Select a time zone..">{{$select.selected.timeZone}}</ui-select-match><ui-select-choices repeat="item in vm.timeZone | filter: {timeZone: $select.search}"><div ng-bind-html="item.timeZone | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.zone.$invalid"><p class="help-block" ng-show="vm.editForm.zone.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><!--                                <div class="row" ng-if="vm.tabObjects.objectType.skipBurnin">--><!--                                    <div class="col-md-6 col-xs-12">--><!--                                        <div class="form-group">--><!--                                            <label class="control-label" translate="jotApp.tabObjects.msisdn" for="field_msisdn">msisdn</label>--><!--                                            <input type="text" class="form-control" name="msisdn" id="field_msisdn"--><!--                                                   ng-model="vm.tabObjects.msisdn" placeholder="insert the sim msisdn if any"--><!--                                                   ng-maxlength="50"/>--><!--                                        </div>--><!--                                    </div>--><!--                                    <div class="col-md-6 col-xs-12">--><!--                                        <div class="form-group">--><!--                                            <label class="control-label" translate="jotApp.tabObjects.simBarCode" for="field_simBarCode">simBarCode</label>--><!--                                            <input type="text" class="form-control" name="simBarCode" id="field_simBarCode"--><!--                                                   ng-model="vm.tabObjects.simBarCode" placeholder="insert the sim bar code if any"--><!--                                                   ng-maxlength="50"/>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><div class="row"><div class="col-md-6 col-xs-12" ng-if="vm.tabObjects.id"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.condition" for="field_condition">Condition</label><ui-select id="field_condition" name="condition" ng-model="vm.tabObjects.condition" theme="bootstrap" search-enabled="false" required><ui-select-match placeholder="Select a condition..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectsConditions"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.condition.$invalid"><p class="help-block" ng-show="vm.editForm.condition.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div id="map_canvas" style="height: 250px"></div></div></div><!--                                <div class="row" ng-show="vm.tabObjects.id">--><!--                                    <div class="col-md-6 col-xs-12">--><!--                                        <div class="form-group">--><!--                                            <label class="control-label" translate="jotApp.tabObjects.condition" for="field_condition">Condition</label>--><!--                                            <ui-select id="field_condition" name="condition" ng-model="vm.tabObjects.condition"--><!--                                                       theme="bootstrap" search-enabled="false" required >--><!--                                                <ui-select-match placeholder="Select a condition..">--><!--                                                    {{$select.selected.name}}--><!--                                                </ui-select-match>--><!--                                                <ui-select-choices repeat="item in vm.tabObjectsConditions">--><!--                                                    <div ng-bind-html="item.name"></div>--><!--                                                </ui-select-choices>--><!--                                            </ui-select>--><!--                                            <div ng-show="vm.editForm.condition.$invalid">--><!--                                                <p class="help-block"--><!--                                                   ng-show="vm.editForm.condition.$error.required" translate="entity.validation.required">--><!--                                                    This field is required.--><!--                                                </p>--><!--                                            </div>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--></div><div ng-if="vm.tabObjects.multipleCreation"><div ng-if="vm.tabObjects.multipleCreation"><div class="row" ng-if="vm.tabObjects.multipleCreation"><div class="col-md-6 col-xs-12"><div class="col-md-6 col-xs-12 no-padding-left"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.mode" for="field_mode">Mode</label> <select name="mmode" class="form-control" ng-model="vm.mode" id="field_mode" required ng-change="vm.convertToBoolean()"><option value="" disabled="disabled" style="display: none">Select your option</option><option ng-value="0" selected="selected">Random</option><option ng-value="1">Sequence</option></select></div></div><div class="col-md-6 col-xs-12 no-padding-right"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_pair"><input name="pair" type="checkbox" class="form-control" ng-model="vm.tabObjects.pair" id="field_pair"> <span></span><div translate="jotApp.tabObjects.pair" class="ng-scope">Pair (A,B)</div></label></div></div></div></div><div class="col-md-6 col-xs-12"><div class="col-md-6 col-xs-12 no-padding-left" ng-if="vm.tabObjects.sequence"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.from" for="field_objectFrom">Sequence start</label> <input type="number" class="form-control" name="from" id="field_objectFrom" ng-model="vm.tabObjects.from" min="0" required><div ng-show="vm.editForm.from.$invalid"><div ng-show="vm.editForm.from.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><p class="help-block" ng-show="vm.editForm.from.$error.min">The minimum sequence start point could be 0</p></div></div></div><div class="col-md-6 col-xs-12 no-padding-right" ng-if="vm.tabObjects.sequence"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.to" for="field_objectTo">Sequence end</label> <input type="number" class="form-control" name="to" id="field_objectTo" ng-model="vm.tabObjects.to" min="1" required><div ng-show="vm.editForm.to.$invalid"><div ng-show="vm.editForm.to.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><p class="help-block" ng-show="vm.editForm.to.$error.min">The minimum sequence end point could be 1</p></div></div></div><div class="col-md-6 col-xs-12 no-padding-left" ng-if="!vm.tabObjects.sequence"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.quantity" for="field_objectQuantity">Quantity</label> <input type="number" class="form-control" name="quantity" id="field_objectQuantity" ng-model="vm.tabObjects.quantity" min="1" max="100" required><div ng-show="vm.editForm.quantity.$invalid"><div ng-show="vm.editForm.quantity.$error.required"><p class="help-block" translate="entity.validation.required">This field is required.</p></div><div ng-show="vm.editForm.quantity.$error.min"><p class="help-block">The quantity min value is 1</p></div><div ng-show="vm.editForm.quantity.$error.max"><p class="help-block">The quantity max value is 100</p></div></div></div></div></div></div><hr><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectUniqueCodePrefix" for="field_objectUniqueCodePrefix">Object Unique Code prefix</label> <input type="text" class="form-control" name="objectUniqueCode" id="field_objectUniqueCodePrefix" ng-model="vm.tabObjects.objectUniqueCode" ng-pattern="/^(?:[a-zA-Z0-9]+(?:[-][a-zA-Z0-9]+)*[-]{0,1})$/" required ng-maxlength="93" ng-change="vm.populateName()"><div ng-show="vm.editForm.objectUniqueCode.$invalid"><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 95 characters.</p><p class="help-block" ng-show="vm.editForm.objectUniqueCode.$error.pattern">This field can only contain letters digits and -</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectDescription" for="field_objectDescription">Object Description</label> <input type="text" class="form-control" name="objectDescription" id="field_objectDescription" ng-model="vm.tabObjects.objectDescription" ng-maxlength="255"><div ng-show="vm.editForm.objectDescription.$invalid"><p class="help-block" ng-show="vm.editForm.objectDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.objectNotes" for="field_objectNotes">Object Notes</label> <input type="text" class="form-control" name="objectNotes" id="field_objectNotes" ng-model="vm.tabObjects.objectNotes" ng-maxlength="10000"><div ng-show="vm.editForm.objectNotes.$invalid"><p class="help-block" ng-show="vm.editForm.objectNotes.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.tabObjects.objectType" for="field_objectType">Object Type</label><ui-select id="field_objectType" name="objectType" ng-model="vm.tabObjects.objectType" ng-click="vm.serachObjectType($select.search)" theme="bootstrap" required on-select="vm.filterFleets(); vm.isOriginalValue()" ng-keyup="vm.serachObjectType($select.search)"><ui-select-match placeholder="Select an object type..">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes track by item.id" percent="90" when-scrolled="vm.loadPageObjectType(vm.objectTypePage + 1)"><div ng-bind-html="item.objectTypeName "></div></ui-select-choices></ui-select><div ng-show="vm.editForm.objectType.$invalid "><p class="help-block" ng-show="vm.editForm.objectType.$error.required" translate="entity.validation.required">This field is required.</p></div><div ng-show="vm.tabObjects.objectType && vm.editForm.objectType.$dirty"><p class="help-block" translate="jotApp.tabObjects.objtype.warning">Changing ObjectType could lead to deletion of overwritten properties for this Object</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group" ng-show="vm.tabObjects.objectType"><label translate="jotApp.tabObjects.fleet" for="field_fleet">Fleet</label><!--                                        <select required class="form-control" id="field_fleet" name="fleet" ng-model="vm.tabObjects.fleet" ng-options="tabFleets as tabFleets.fleetName for tabFleets in vm.tabfleets track by tabFleets.id"></select>--><ui-select id="field_fleet" name="fleet" ng-model="vm.tabObjects.fleet" ng-click="vm.searchFieldFleet($select.search)" theme="bootstrap" required ng-keyup="vm.searchFieldFleet($select.search)"><ui-select-match placeholder="Select a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets track by item.id" percent="90" when-scrolled="vm.loadPageFleet(vm.fleetPage + 1)"><div ng-bind-html="item.fleetName"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.fleet.$invalid"><p class="help-block" ng-show="vm.editForm.fleet.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12" ng-if="vm.timeZone.length != 0"><div class="form-group" ng-show="vm.tabObjects.objectType"><label translate="jotApp.tabObjects.zone" for="field_zone">Time Zone</label><ui-select id="field_zone" name="zone" ng-model="vm.tabObjects.timeZone" theme="bootstrap" required><ui-select-match placeholder="Select a time zone..">{{$select.selected.timeZone}}</ui-select-match><ui-select-choices repeat="item in vm.timeZone | filter: {timeZone: $select.search}"><div ng-bind-html="item.timeZone | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.editForm.zone.$invalid"><p class="help-block" ng-show="vm.editForm.zone.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row" ng-if="vm.tabObjects.objectType.skipBurnin"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.msisdn" for="field_msisdn">msisdn</label> <input type="text" class="form-control" name="msisdn" id="field_msisdn" ng-model="vm.tabObjects.msisdn" placeholder="insert the sim msisdn if any" ng-maxlength="50"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabObjects.simBarCode" for="field_simBarCode">simBarCode</label> <input type="text" class="form-control" name="simBarCode" id="field_simBarCode" ng-model="vm.tabObjects.simBarCode" placeholder="insert the sim bar code if any" ng-maxlength="50"></div></div></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-elastic-properties.html','<div class="app-content-body detail-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title">{{vm.tabObject.objectUniqueCode}} properties</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-object-group"></i> <span translate="jotApp.tabDevicesReleasesProperties.detail.portletTitle">Object Properties List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.searchText" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table id="object-properties-table" class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr><th><span translate="jotApp.tabDevicesReleasesProperties.propertyName"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.value"></span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="(key, value) in vm.app"><td><span class="text-ellipsis">{{key}}</span></td><td><div class="input-group"><span e-form="rowform_key" editable-text="value" e-name="defaultValue{{$index}}" onbeforesave="vm.checkValueBeforeSave($data)" onaftersave="vm.saveReference(key, value)" class="ng-scope ng-binding editable text-ellipsis" style="padding-right: 10px;">{{ value === false ? false : (value|| \'empty\') }}</span></div></td><td class="action-column-xeditable text-center"><button class="btn btn-primary btn-sm" ng-click="rowform_key.$show()" ng-hide="rowform_key.$visible"><i class="fa fa-pencil"></i> <span translate="entity.action.edit">Edit</span></button><form editable-form name="rowform_key" ng-show="rowform_key.$visible" class="form-buttons form-inline"><button type="submit" ng-disabled="rowform_key.$waiting" class="btn btn-sm btn-primary"><i class="fa fa-check"></i></button> <button type="button" ng-disabled="rowform_key.$waiting" ng-click="rowform_key.$cancel()" class="btn btn-sm btn-default"><i class="fa fa-times"></i></button></form></td></tr><tr ng-if="vm.properties.length == 0"><td colspan="4">No Properties</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-maint-dialog.html','<form name="maintenanceForm" ng-submit="vm.setMaintenance(vm.tabObjects)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.tabObjects.maint.title">Confirm maintenance operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabObjects.maint.question" translate-values="{id: \'{{vm.tabObjects.objectUniqueCode}}\'}">Are you sure you want to set in maintenance this Object</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary ng-scope"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.maintenance">Maint</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-manage-domain.html','<form name="manageForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.manageDomain.title" translate-values="{obj: \'{{vm.tabObjects.objectUniqueCode}}\'}">Change domain for object:</h4></div><div class="modal-body"><div class="row"><div ng-class="vm.styleDomain"><ui-select ng-model="vm.domain" on-select="vm.selectDomain()" theme="bootstrap" required><ui-select-match placeholder="Select a domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" refresh-delay="1"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 col-xs-12" ng-if="vm.domain != null"><ui-select ng-model="vm.fleet" ng-disabled="vm.disabledFleet" theme="bootstrap" required><ui-select-match placeholder="{{vm.disabledFleet ? \'No fleet for this domain\' : \'Select a fleet..\'}}">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}" refresh-delay="1"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.manangeDomain()" ng-disabled="manageForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-properties-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTabObjectsLabel" translate="jotApp.tabDevicesReleasesProperties.dialog.title">Pending modify</h4></div><div class="modal-body"><p translate="jotApp.tabDevicesReleasesProperties.dialog.body">There are some pending modify, continue?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.continue">Continue</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-properties-history.html','<div class="app-content-body detail-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title">{{vm.property.propertyName}} history on {{vm.tabObject.objectUniqueCode}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-object-group"></i> <span translate="jotApp.tabDevicesReleasesProperties.detail.history">Object Properties List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.search" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table id="object-properties-table" class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr><th><span translate="jotApp.tabDevicesReleasesProperties.override.oldValue"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.override.newValue"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.override.executedBy"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.override.executionDate"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.override.status"></span></th></tr></thead><tbody><tr ng-repeat="obj in vm.updates | filter : vm.search track by $index"><td><span class="text-ellipsis">{{obj.oldValue}}</span></td><td><span class="text-ellipsis">{{obj.newValue}}</span></td><td>{{obj.executedBy}}</td><td>{{obj.executionDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{obj.status}}</td></tr><tr ng-if="vm.updates.length == 0"><td colspan="4">No Updates</td></tr></tbody></table></div><div class="row"><div class="col-sm-5"><jhi-item-count page="vm.currentPage" total="vm.queryCount" limit="20"></jhi-item-count></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-properties.html','<div class="app-content-body detail-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title">{{vm.tabObject.objectUniqueCode}} properties</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-object-group"></i> <span translate="jotApp.tabDevicesReleasesProperties.detail.portletTitle">Object Properties List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.search" placeholder="Search..." ng-change="vm.currentPage=1"></label></div></div></div><div class="table-scrollable"><table id="object-properties-table" class="table table-striped table-bordered table-hover order-column dataTable no-footer"><thead><tr multi-sort="vm.predicates" callback="vm.reloadPage()"><th multi-sort-by="tabDeviceReleases.deviceReleaseName"><span translate="jotApp.tabDevicesReleasesProperties.tabDeviceReleases"></span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="propertyName"><span translate="jotApp.tabDevicesReleasesProperties.propertyName"></span><span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.defVal"></span></th><th><span translate="jotApp.tabDevicesReleasesProperties.value"></span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="obj in vm.properties | filter : vm.search | limitTo: vm.numPerPage:(vm.currentPage - 1) * vm.numPerPage track by $index"><td><span class="text-ellipsis">{{obj.tabDeviceReleases.deviceReleaseName}} - {{obj.tabDeviceReleases.deviceReleaseVersion}}</span></td><td><span class="text-ellipsis">{{obj.propertyName}}</span></td><td>{{obj.defaultValue}}</td><td><div class="input-group"><span e-form="rowform_key" ng-style="{color:obj.currentValue!=obj.defaultValue?\'#428bca\':\'#58666e\'}" editable-text="obj.currentValue" e-name="defaultValue{{$index}}" onbeforesave="vm.checkValueBeforeSave($data)" onaftersave="vm.saveReference(obj)" class="ng-scope ng-binding editable text-ellipsis" style="padding-right: 10px;">{{ obj.currentValue || \'empty\' }}</span></div></td><td class="action-column-xeditable text-center"><button class="btn btn-primary btn-sm" ng-click="rowform_key.$show()" ng-hide="rowform_key.$visible"><i class="fa fa-pencil"></i> <span translate="entity.action.edit">Edit</span></button><form editable-form name="rowform_key" ng-show="rowform_key.$visible" class="form-buttons form-inline"><button type="submit" ng-disabled="rowform_key.$waiting" class="btn btn-sm btn-primary"><i class="fa fa-check"></i></button> <button type="button" ng-disabled="rowform_key.$waiting" ng-click="rowform_key.$cancel()" class="btn btn-sm btn-default"><i class="fa fa-times"></i></button></form><button class="btn btn-primary btn-sm bg-green" ng-style="{\'margin-top\': rowform_key.$visible ? \'10px\' : \'\'}" ui-sref="tab-objects-properties-history({id:vm.tabObject.id, property: obj.id})"><i class="fa fa-history"></i> <span translate="entity.action.history">History</span></button></td><!--<td>--><!--<p class="input-group" uib-tooltip="Default: {{obj.defaultValue}}" tooltip-placement="auto right">--><!--<span ng-style="{color:obj.currentValue!=obj.defaultValue?\'#428bca\':\'#58666e\'}" editable-text="obj.currentValue" e-name="defaultValue{{$index}}" onbeforesave="vm.checkValueBeforeSave($data)" onaftersave="vm.saveReference(obj)" class="ng-scope ng-binding editable text-ellipsis" style="padding-right: 10px;"> {{ obj.currentValue || \'empty\' }} </span>--><!--</p>--><!--</td>--></tr><tr ng-if="vm.properties.length == 0"><td colspan="4">No Properties</td></tr></tbody></table></div><div class="row"><div class="col-sm-5"><jhi-item-count page="vm.currentPage" total="vm.properties.length" limit="vm.numPerPage"></jhi-item-count></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><ul uib-pagination boundary-links="true" items-per-page="vm.numPerPage" total-items="vm.properties.length" ng-model="vm.currentPage" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects-provision-dialog.html','<style>.material-switch>input[type=checkbox]{display:none}.material-switch>label{cursor:pointer;height:0;position:relative;width:40px}.material-switch>label::after,.material-switch>label::before{content:\'\';margin-top:-8px;position:absolute}.material-switch>label::before{background:#000;box-shadow:inset 0 0 10px rgba(0,0,0,.5);border-radius:8px;height:16px;opacity:.3;transition:all .4s ease-in-out;width:40px}.material-switch>label::after{background:#fff;border-radius:16px;box-shadow:0 0 5px rgba(0,0,0,.3);height:24px;left:-4px;top:-4px;transition:all .3s ease-in-out;width:24px}.material-switch>input[type=checkbox]:checked+label::before{background:inherit;opacity:.5}.material-switch>input[type=checkbox]:checked+label::after{background:inherit;left:20px}.panel{border-top:0px}.panel-default .panel-heading{background-color:#fff4e3!important; border-top:1px solid #e9e9e9;}</style><!--************************************--><!-- Single TabObject Redeployment Form --><!--************************************--><form ng-if="vm.entityId" name="redeploymentForm" ng-submit="vm.confirmRedeployment(vm.entityId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.tabObjects.provision.title">Confirm redeployment operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabObjects.provision.question" translate-values="{id: \'{{vm.entityId}}\'}">Are you sure you want to redeploy this Object?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="" ng-disabled="deleteForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.provision">Force provision</span></button></div></form><!--***********************************--><!-- Mass TabObjects Redeployment Form --><!--***********************************--><form ng-if="!vm.entityId" name="redeploymentForm_" ng-submit="vm.confirmRedeploymentAll()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.tabObjects.redeployAll.title">Confirm Redeploy All Operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="panel panel-default"><div translate="jotApp.tabObjects.redeployAll.selectionMsg" class="panel-heading">Please specify if you also want to restore files:</div><ul class="list-group"><li class="list-group-item"><span translate="jotApp.tabObjects.redeployAll.restore">Restore files</span><div class="material-switch pull-right"><input type="checkbox" id="opRestore" name="operations" ng-model="vm.formData.operations.restore"> <label for="opRestore" class="label-warning"></label></div></li><li class="list-group-item"><span translate="jotApp.tabObjects.redeployAll.restart">Restart</span><div class="material-switch pull-right"><input type="checkbox" id="opRestart" name="operations" ng-model="vm.formData.operations.restart" disabled="disabled"> <label for="opRestart" class="label-warning"></label></div></li><li class="list-group-item"><div style="font-size: 12px;" class="text-center">There {{ vm.redeployObjCounter.getNumObjs() == 1 ? \'is\' : \'are\' }} <b>{{ vm.redeployObjCounter.getNumObjs() }}</b> Objects to be deployed.</div></li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.formData.operations.restore && !vm.formData.operations.restart" class="btn btn-warning"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.redeployAll">Redeploy All</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-redeploy-dialog.html','<style>.material-switch>input[type=checkbox]{display:none}.material-switch>label{cursor:pointer;height:0;position:relative;width:40px}.material-switch>label::after,.material-switch>label::before{content:\'\';margin-top:-8px;position:absolute}.material-switch>label::before{background:#000;box-shadow:inset 0 0 10px rgba(0,0,0,.5);border-radius:8px;height:16px;opacity:.3;transition:all .4s ease-in-out;width:40px}.material-switch>label::after{background:#fff;border-radius:16px;box-shadow:0 0 5px rgba(0,0,0,.3);height:24px;left:-4px;top:-4px;transition:all .3s ease-in-out;width:24px}.material-switch>input[type=checkbox]:checked+label::before{background:inherit;opacity:.5}.material-switch>input[type=checkbox]:checked+label::after{background:inherit;left:20px}.panel{border-top:0px}.panel-default .panel-heading{background-color:#fff4e3!important; border-top:1px solid #e9e9e9;}</style><!--************************************--><!-- Single TabObject Redeployment Form --><!--************************************--><form ng-if="vm.entityId" name="redeploymentForm" ng-submit="vm.confirmRedeployment(vm.entityId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.tabObjects.redeploy.title">Confirm redeployment operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabObjects.redeploy.question" translate-values="{id: \'{{vm.entityId}}\'}">Are you sure you want to redeploy this Object?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="" ng-disabled="deleteForm.$invalid" class="btn btn-warning"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.redeploy">Redeploy</span></button></div></form><!--***********************************--><!-- Mass TabObjects Redeployment Form --><!--***********************************--><form ng-if="!vm.entityId" name="redeploymentForm_" ng-submit="vm.confirmRedeploymentAll()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.tabObjects.redeployAll.title">Confirm Redeploy All Operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="panel panel-default"><div translate="jotApp.tabObjects.redeployAll.selectionMsg" class="panel-heading">Please specify if you also want to restore files:</div><ul class="list-group"><li class="list-group-item"><span translate="jotApp.tabObjects.redeployAll.restore">Restore files</span><div class="material-switch pull-right"><input type="checkbox" id="opRestore" name="operations" ng-model="vm.formData.operations.restore"> <label for="opRestore" class="label-warning"></label></div></li><li class="list-group-item"><span translate="jotApp.tabObjects.redeployAll.restart">Restart</span><div class="material-switch pull-right"><input type="checkbox" id="opRestart" name="operations" ng-model="vm.formData.operations.restart" disabled="disabled"> <label for="opRestart" class="label-warning"></label></div></li><li class="list-group-item"><div style="font-size: 12px;" class="text-center">There {{ vm.redeployObjCounter.getNumObjs() == 1 ? \'is\' : \'are\' }} <b>{{ vm.redeployObjCounter.getNumObjs() }}</b> Objects to be deployed.</div></li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.formData.operations.restore && !vm.formData.operations.restart" class="btn btn-warning"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.redeployAll">Redeploy All</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-register-dialog.html','<form name="refgisterForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.register.title" ng-if="!vm.showCode">Insert object to register</h4><h4 class="modal-title" ng-if="vm.showCode">Insert your licence code</h4></div><div class="modal-body"><div class="row" ng-if="!vm.showCode"><div class="col-md-4 col-xs-12"><input type="text" class="form-control" ng-model="vm.objectUniqueCode" required></div><div class="col-md-8 col-xs-12"><ui-select ng-model="vm.fleet" theme="bootstrap" required><ui-select-match placeholder="Select a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.fleets | filter: {fleetName: $select.search}" refresh-delay="1"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row" ng-if="vm.showCode"><div class="col-md-4 col-xs-12"><input type="text" class="form-control" ng-model="vm.registrationCode" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-if="!vm.showCode" ng-click="vm.showCode = true" ng-disabled="refgisterForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button> <button ng-if="vm.showCode" ng-click="vm.register()" ng-disabled="refgisterForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-rerunning-dialog.html','<form name="rerunningForm" ng-submit="vm.confirmRerunning(vm.tabObjects)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.rerunning.title">Confirm running operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabObjects.rerunning.question" translate-values="{id: \'{{vm.tabObjects.objectUniqueCode}}\'}">Are you sure you want set this Tab Objects as running?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="rerunningForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.rerunning">Set Running</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objects-view-last-data.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabObjects.detail.title"></span> {{vm.objectUniqueCode}}</h1></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover order-column dataTable no-footer action-column"><thead><tr><th class="decrease-width"><span translate="jotApp.tabObjects.metricKey">Metric Key</span></th><th><span translate="jotApp.tabObjects.metricValue">Metric Value</span></th></tr></thead><tbody><tr ng-repeat="(key, value) in vm.tabObjectMetrics | Find: vm.charToSearch || \'\'"><td ng-bind-html="key | highlight:vm.charToSearch"></td><td ng-bind-html="value"></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objects.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="full-page-loader-container" ng-if="!vm.pageReady"><div class="loader"></div></div><div ng-if="vm.pageReady"><object-filter filter="vm.applyFilter(fleet,objectType,state,update,online,tracked)" fleet-val="vm.fleet" object-type-val="vm.objectType" object-state-val="vm.objectState" monitor-val="vm.tracked" network-val="vm.online" release-val="vm.toUpdate"></object-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><!--                            <button type="button" has-authority="ROLE_DOMAIN_ADMIN" class="btn btn-primary" ui-sref="tab-objects.register()">--><!--                                <i class="fa fa-plus"></i> &nbsp;--><!--                                <span translate="jotApp.tabObjects.home.registerLabel">--><!--                                Register Objects--><!--                            </span>--><!--                            </button>--> <button type="button" has-authority="ROLE_TECH" class="btn btn-primary" ui-sref="tab-objects-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabObjects.home.createLabel">Create new Tab Objects</span></button> <button has-authority="ROLE_ADMIN" type="button" class="btn btn-primary" ui-sref="tab-objects.redeployment()" ng-disabled="vm.redeployObjCounter.getNumObjs() == 0"><i class="fa fa-refresh"></i> <span translate="jotApp.tabObjects.home.redeployAll">Redeploy All</span></button> <button has-authority="ROLE_TECH" class="btn btn-primary" ui-sref="massive-properties"><i class="fa fa-pencil"></i> <span translate="jotApp.tabObjects.home.massiveUpdateProperties">Update Properties</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model-options="{ debounce: 800 }" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="objectOnline"><span translate="jotApp.tabObjects.objectOnline">Online</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectUniqueCode"><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectName"><span translate="jotApp.tabObjects.objectName">Object Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectDescription"><span translate="jotApp.tabObjects.objectDescription">Object Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectNotes"><span translate="jotApp.tabObjects.objectNotes">Object Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="fleet.fleetName"><span translate="jotApp.tabObjects.fleet">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectType.objectTypeName"><span translate="jotApp.tabObjects.objectType">Object Type</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectIp"><span translate="jotApp.tabObjects.ipAddress">IP Addr</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="condition.name"><span translate="jotApp.tabObjects.condition">Condition</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="toUpdate"><span translate="jotApp.tabObjects.toUpdate">To Update</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectStates.objectStateName"><span translate="jotApp.tabObjects.objectStates">Object States</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabObjects in vm.tabObjects track by tabObjects.id"><td class="text-center"><div class="badge custom-badge no-text-badge object-online-led" ng-class="{working: tabObjects.working}" ng-style="{\'background-color\': tabObjects.objectOnline  ? \'#26c281\' : \'#98a6ad\'}"></div></td><td><a has-authority="ROLE_ADMIN" href="shell/{{tabObjects.objectUniqueCode}}" target="_blank"><span><i class="fa fa-terminal"></i></span> {{tabObjects.objectUniqueCode}}</a> <span evaluate-authorities="!ROLE_ADMIN">{{tabObjects.objectUniqueCode}}</span></td><td ng-bind-html="tabObjects.objectName | highlight:vm.charToSearch"></td><td ng-bind-html="tabObjects.objectDescription | highlight:vm.charToSearch"></td><td ng-bind-html="tabObjects.objectNotes | highlight:vm.charToSearch"></td><td><a ui-sref="tab-fleets-detail({id:tabObjects.fleet.id})">{{tabObjects.fleet.fleetName}}</a></td><td><a ui-sref="tab-object-types-detail({id:tabObjects.objectType.id})">{{tabObjects.objectType.objectTypeName}}</a></td><td><span ng-if="tabObjects.objectOnline">{{tabObjects.objectIp}} <i class="fa fa-copy" copy-to-clipboard="{{tabObjects.objectIp}}"></i></span></td><td><span>{{tabObjects.condition.name}}</span></td><td><span>{{tabObjects.toUpdate}}</span></td><td><span ng-style="{color: tabObjects.objectTracked  ? \'#27c24c\' : \'#98a6ad\'}">{{tabObjects.objectStates.objectStateName}}</span></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-objects-detail({id:tabObjects.id})"><i class="fa fa-eye"></i> <span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-objects-edit({id:tabObjects.id})" has-authority="ROLE_TECH"><i class="fa fa-pencil"></i> <span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="action-commands({id:tabObjects.id})"><i class="fa fa-terminal"></i> <span translate="entity.action.commands"></span></a></li><li ng-if="!tabObjects.objectType.skipBurnin" has-authority="ROLE_TECH"><a href="javascript:;" ui-sref="tab-objects-properties({id:tabObjects.id})" ng-if="tabObjects.objectStates.objectStateName==\'running\'&& tabObjects.objectTracked"><i class="fa fa-pencil"></i> <span translate="entity.action.edit-properties"></span></a></li><li ng-if="tabObjects.objectType.skipBurnin"><a href="javascript:;" ui-sref="tab-objects-elastic-properties({id:tabObjects.id})" has-authority="ROLE_TECH" ng-if="tabObjects.objectStates.objectStateName==\'running\'&& tabObjects.objectTracked"><i class="fa fa-pencil"></i> <span translate="entity.action.edit-properties"></span></a></li><li ng-if="tabObjects.objectType.skipBurnin"><a href="javascript:;" ng-click="vm.changeSimStatus(tabObjects, true)" ng-if="!tabObjects.simActive" has-authority="ROLE_ADMIN"><i class="fa fa-check"></i> <span>Activate Sim</span> </a><a href="javascript:;" ng-click="vm.changeSimStatus(tabObjects, false)" ng-if="tabObjects.simActive"><i class="fa fa-times"></i> <span>Block Sim</span></a></li><li ng-if="tabObjects.objectType.skipBurnin"><a href="javascript:;" ui-sref="tab-objects.provision({id:tabObjects.id})" has-authority="ROLE_TECH" ng-if="tabObjects.objectOnline && !tabObjects.objectTracked"><i class="fa fa-refresh"></i> <span translate="entity.action.redeploy"></span></a></li><li ng-if="!tabObjects.objectType.skipBurnin"><a href="javascript:;" ui-sref="tab-objects.redeployment({id:tabObjects.id})" has-authority="ROLE_TECH" ng-if="tabObjects.objectOnline && !tabObjects.objectTracked"><i class="fa fa-refresh"></i> <span translate="entity.action.redeploy"></span></a></li><li><a href="javascript:;" ui-sref="object-test-result({id:tabObjects.id})" has-authority="ROLE_TECH"><i class="fa fa-list-alt"></i> <span translate="entity.action.test"></span></a></li><li><a href="javascript:;" ng-disabled="tabObjects.objectStates.objectStateName==\'burnIn\'" ui-sref="tab-objects.maintenance({id:tabObjects.id})" ng-click="vm.setMaintenance(tabObjects)" has-authority="ROLE_TECH"><i class="fa fa-cog"></i> <span translate="entity.action.maintenance"></span></a></li><li></li><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="tab-objects.rerunning({id:tabObjects.id})" ng-if="tabObjects.objectOnline && tabObjects.objectStates.objectStateName !=\'running\'"><i class="fa fa-refresh"></i> <span translate="entity.action.rerunning"></span></a></li><li><a href="javascript:;" ui-sref="tab-objects.delete({id:tabObjects.id})"><i class="fa fa-times"></i> <span translate="entity.action.delete"></span></a></li><li><a href="javascript:;" ui-sref="tab-objects-manage-domain({id:tabObjects.id})" has-authority="ROLE_ADMIN"><i class="fa fa-tags"></i> <span translate="entity.action.domain"></span></a></li><li><a href="javascript:;" ui-sref="tab-objects-view-last-data({id:tabObjects.id, name: tabObjects.objectUniqueCode})" has-authority="ROLE_TECH"><i class="fa fa-table"></i> <span translate="entity.action.viewLastTick"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-objects/tab-objectstype-properties-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.go()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Warning</h4></div><div class="modal-body"><p>These objects could lose their existing overwritten properties</p><ul><li style="display: inline-block; width: 50%" ng-repeat="warning in vm.warnings">{{warning}}</li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary"><span translate="entity.action.continue">Continue</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objectstype-properties-old-value-dialog.html','<form name="editForm" role="form" novalidate show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Existing value for: <strong>{{propertyName}}</strong></h4></div><div class="modal-body"><h5>Legend: ObjectUniqueCode : PropertyValue</h5><ul><li style="display: inline-block; width: 50%" ng-repeat="val in values">{{val}}</li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span>Close</span></button></div></form>');
$templateCache.put('app/entities/tab-objects/tab-objectstype-properties.html','<div class="bg-light lter b-b wrapper-md ng-scope"><h1 class="m-n font-thin h3"><span translate="jotApp.tabDevicesReleasesProperties.detail.title"></span></h1></div><div class="wrapper-md" style="padding-bottom: 60px; margin-left:  10px"><div class="panel panel-default"><table id="object-properties-table" class="table table-striped b-t b-light"><thead><tr><th style="width:25%;"><span translate="jotApp.tabDevicesReleasesProperties.tabDeviceReleases"></span></th><th style="width:25%;"><span translate="jotApp.tabDevicesReleasesProperties.propertyName"></span></th><th style="width:25%;"><span translate="jotApp.tabDevicesReleasesProperties.value"></span></th><th style="width:25%;"></th></tr></thead><tbody><tr ng-repeat="obj in vm.properties | limitTo: vm.numPerPage:(vm.currentPage - 1) * vm.numPerPage track by $index"><td><span class="text-ellipsis">{{obj.tabDeviceReleases.deviceReleaseName}} - {{obj.tabDeviceReleases.deviceReleaseVersion}}</span></td><td><span class="text-ellipsis">{{obj.propertyName}}</span></td><td><p class="input-group" uib-tooltip="Default: {{obj.defaultValue}}" tooltip-placement="auto right"><span ng-style="{color:vm.showOldValue(obj.propertyName)?\'#428bca\':\'#58666e\'}" editable-text="obj.currentValue" e-name="defaultValue{{$index}}" onbeforesave="vm.checkValueBeforeSave($data)" onaftersave="vm.saveReference(obj)" class="ng-scope ng-binding editable text-ellipsis" style="padding-right: 10px;">{{ obj.currentValue || \'empty\' }}</span></p></td><td><button ng-show="vm.showOldValue(obj.propertyName)" type="submit" ng-click="vm.openModal(obj.propertyName)" class="btn btn-info"><span>Current value</span></button></td></tr><tr ng-if="vm.properties.length == 0"><td colspan="3">No Properties</td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><div class="text-center"><jhi-item-count page="vm.currentPage" total="vm.properties.length" limit="vm.numPerPage"></jhi-item-count><ul uib-pagination boundary-links="true" items-per-page="vm.numPerPage" total-items="vm.properties.length" ng-model="vm.currentPage" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul></div></div>');
$templateCache.put('app/entities/tab-onEvent-scripts/tab-onEvent-scripts-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.getFileName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabOnEventScripts.delete.question" translate-values="{name: \'{{vm.getFileName}}\'}">Are you sure you want to delete this OnEvent Scripts?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-onEvent-scripts/tab-onEvent-scripts.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div class="form-body"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="onEventScript_field">Filter By Name</label> <select class="form-control" id="onEventScript_field" name="onEventScript_field" ng-model="filter" chosen disable-search="true"><option label="ALL" value="">ALL</option><option label="burnin" value="burnin">burnin</option><option label="update" value="update">update</option><option label="vpn" value="vpn">vpn</option></select></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.charToSearch" placeholder="Search by File Name or Size..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr callback="vm.reset()"><th><span translate="jotApp.tabOnEventScripts.scriptName">Name</span></th><th><span translate="jotApp.tabOnEventScripts.scriptCreationDate">Creation Date</span></th><th><span translate="jotApp.tabOnEventScripts.scriptSize">Size</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="line in vm.tabOnEventScripts  |  filter: filter  |  filter: vm.charToSearch "><td ng-bind-html="line.fileName | highlight: vm.charToSearch"></td><td>{{line.creationDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td ng-bind-html="line.fileSize | highlight: vm.charToSearch"></td><td class="text-center"><button class="hand btn btn-primary" ng-click="vm.openDeleteDialog(line.fileName)"><i class="fa fa-times"></i> <span translate="entity.action.delete">Delete</span></button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-properties/tab-properties-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabProperties.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabProperties.delete.question" translate-values="{id: \'{{vm.tabProperties.propertyDescription}}\'}">Are you sure you want to delete this Tab Properties?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-properties/tab-properties-detail.html','<div class="bg-light lter b-b wrapper-md ng-scope"><h1 class="m-n font-thin h3"><span translate="jotApp.tabProperties.detail.title">Tab Properties</span> {{vm.tabProperties.id}}</h1></div><div class="wrapper-md" style="padding-bottom: 60px; margin-left:  10px"><dl class="dl-horizontal"><dt><span translate="jotApp.tabProperties.propertyDescription">Property Description</span></dt><dd><span>{{vm.tabProperties.propertyDescription}}</span></dd><hr><dt><span translate="jotApp.tabProperties.properyValue">Propery Value</span></dt><dd><span>{{vm.tabProperties.properyValue}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/tab-properties/tab-properties-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTabPropertiesLabel" translate="jotApp.tabProperties.home.createOrEditLabel">Create or edit a Tab Properties</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tabProperties.id"><label for="id" translate="global.field.id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.tabProperties.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="jotApp.tabProperties.propertyDescription" for="field_propertyDescription">Property Description</label> <input type="text" class="form-control" name="propertyDescription" id="field_propertyDescription" ng-model="vm.tabProperties.propertyDescription" required ng-maxlength="255"><div ng-show="editForm.propertyDescription.$invalid"><p class="help-block" ng-show="editForm.propertyDescription.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.propertyDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" translate="jotApp.tabProperties.properyValue" for="field_properyValue">Propery Value</label> <input type="text" class="form-control" name="properyValue" id="field_properyValue" ng-model="vm.tabProperties.properyValue" ng-maxlength="1000"><div ng-show="editForm.properyValue.$invalid"><p class="help-block" ng-show="editForm.properyValue.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tab-properties/tab-properties.html','<div><div class="bg-light lter b-b wrapper-md ng-scope"><h1 class="m-n font-thin h3" translate="jotApp.tabProperties.home.title">Tab Properties</h1></div><jhi-alert></jhi-alert><div class="wrapper-md ng-scope"><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tab-properties.new"><span class="glyphicon glyphicon-plus"></span> <span translate="jotApp.tabProperties.home.createLabel">Create new Tab Properties</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="propertyDescription"><span translate="jotApp.tabProperties.propertyDescription">Property Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="properyValue"><span translate="jotApp.tabProperties.properyValue">Propery Value</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tabProperties in vm.tabProperties track by tabProperties.id"><td>{{tabProperties.propertyDescription}}</td><td>{{tabProperties.properyValue}}</td><td class="text-right btnCol"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tab-properties-detail({id:tabProperties.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="tab-properties.edit({id:tabProperties.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tab-properties.delete({id:tabProperties.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/tab-schedule/tab-schedule-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabSchedule.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabSchedule.delete.question" translate-values="{id: \'\'}">Are you sure you want to delete this Tab Schedule?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-schedule/tab-schedule-detail.html','<div class="app-content-body detail-page schedule-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.tabSchedule.detail.title">Tab Schedule</span></h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabSchedule.scheduleDatetime">Schedule Datetime</span></dt><dd><span>{{vm.tabSchedule.scheduleDatetime | date:\'yyyy-MM-dd HH:mm\'}}</span></dd><dt><span translate="jotApp.tabSchedule.scheduleStatus">Schedule Status</span></dt><dd>{{vm.tabSchedule.scheduleStatus.scheduleStatusName}}</dd><dt><span translate="jotApp.tabSchedule.scheduleNote">Note</span></dt><dd><span>{{vm.tabSchedule.scheduleNote}}</span></dd><dt><span translate="jotApp.tabSchedule.object">Object</span></dt><dd><a ui-sref="tab-objects-detail({id:vm.tabSchedule.object.id})">{{vm.tabSchedule.object.objectName}}</a></dd><dt><span translate="jotApp.tabSchedule.commands">Commands</span></dt><dd><span>{{vm.tabSchedule.commands}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-schedule/tab-schedules.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-sm-12 col-md-4" ng-show="vm.emptyData.length > 0"><canvas id="schedulesCanvas" class="chart chart-doughnut" chart-data="dataSchedules" chart-labels="labelsSchedules" chart-colors="colorsSchedules" chart-options="options"></canvas></div><div ng-class="vm.emptyData.length > 0 ? [\'col-xs-12\', \'col-sm-12\', \'col-md-8\'] : [\'col-xs-12\', \'col-sm-12\', \'col-md-12\']"><schedule-filter filter="vm.applyFilter(fleet, objectType, from, to, status, tag)" fleet-val="vm.fleet" object-type-val="vm.objectType" from-val="vm.from" to-val="vm.to" status-val="vm.status" tag-val="vm.tag"></schedule-filter></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-model="vm.searchText" placeholder="Search..." ng-change="vm.loadAll()"></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="scheduleDatetime"><span translate="jotApp.tabSchedule.scheduleDatetime">Schedule Datetime</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scheduleStatus.scheduleStatusName"><span translate="jotApp.tabSchedule.scheduleStatus">Schedule Status</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tag"><span translate="jotApp.tabSchedule.tag">Tag</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scheduleNote"><span translate="jotApp.tabSchedule.scheduleNote">Note</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="updateFirmware"><span translate="jotApp.tabSchedule.firmwareToUpdate">firmwareToUpdate</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="object.objectName"><span translate="jotApp.tabSchedule.object">Object</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="commands"><span translate="jotApp.tabSchedule.commands">Commands</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="createdBy"><span translate="jotApp.tabSchedule.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="tabSchedule in vm.tabSchedules | filter:vm.searchText track by tabSchedule.id"><td>{{tabSchedule.scheduleDatetime | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{tabSchedule.scheduleStatus.scheduleStatusName}}</td><td>{{tabSchedule.tag}}</td><td>{{tabSchedule.scheduleNote}}</td><td><span ng-class="tabSchedule.updateFirmware ? [\'label\', \'label-success\'] : [\'label\', \'label-danger\']">{{tabSchedule.updateFirmware}}</span></td><td ng-bind-html="tabSchedule.object.objectUniqueCode | highlight:vm.searchText"></td><td style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;max-width: 300px;">{{tabSchedule.commands | limitTo:50}}</td><td style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;max-width: 300px;">{{tabSchedule.created | limitTo:50}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-schedule-detail({id:tabSchedule.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-schedule.delete({id:tabSchedule.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tab-update-scripts/tab-update-scripts-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tabUpdateScripts.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.tabUpdateScripts.delete.question" translate-values="{id: \'{{vm.tabUpdateScripts.scriptName}}\'}">Are you sure you want to delete this Tab Update Script?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tab-update-scripts/tab-update-scripts-detail.html','<div class="app-content-body detail-page files-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"></span></button><h1 class="page-title"><span translate="jotApp.tabUpdateScripts.detail.title"></span> {{vm.tabUpdateScripts.scriptName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.tabUpdateScripts.scriptName"></span></dt><dd><span>{{vm.tabUpdateScripts.scriptName}}</span></dd><dt><span translate="jotApp.tabUpdateScripts.scriptDescription"></span></dt><dd><span>{{vm.tabUpdateScripts.scriptDescription}}</span></dd><!--<dt><span translate="jotApp.tabUpdateScripts.scriptContent"></span> </dt>--><!--<dd>--><!--<span class="download-label">{{vm.byteSize(vm.tabUpdateScripts.scriptContent)}}</span>--><!--<a class="btn btn-primary btn-sm btn-circle"--><!--ng-click="vm.openScript = true"--><!--ng-if="vm.tabUpdateScripts.scriptContent" target="_blank"--><!--translate="entity.action.open">open</a>--><!--<a class="btn btn-primary btn-sm btn-circle"--><!--ng-click="vm.openScript = false"--><!--ng-if="vm.openScript" target="_blank"--><!--translate="entity.action.close">close</a>--><!--</dd>--><!--<dt ng-show="vm.openScript"><span></span></dt>--><!--<dd ng-show="vm.openScript">--><!--<pre>{{vm.scriptContent}}</pre>--><!--</dd>--><dt><span translate="jotApp.tabUpdateScripts.objectType">Object Type</span></dt><dd><a ui-sref="tab-object-types-detail({id: vm.tabUpdateScripts.objectType.id})">{{vm.tabUpdateScripts.objectType.objectTypeName}}</a></dd><dt><span translate="jotApp.tabUpdateScripts.createdBy">Created By</span></dt><dd><span>{{vm.tabUpdateScripts.createdBy}}</span></dd><dt><span translate="jotApp.tabUpdateScripts.createdDate">Created Date</span></dt><dd><span>{{vm.tabUpdateScripts.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd><dt><span translate="jotApp.tabUpdateScripts.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.tabUpdateScripts.lastModifiedBy}}</span></dd><dt><span translate="jotApp.tabUpdateScripts.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.tabUpdateScripts.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/tab-update-scripts/tab-update-scripts-dialog.html','<div class="app-content-body"><h1 class="page-title" translate="jotApp.tabUpdateScripts.home.createOrEditLabel">Create or Edit a script</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabUpdateScripts.scriptName" for="field_scriptName">Name</label> <input type="text" class="form-control" name="scriptName" id="field_scriptName" ng-model="vm.tabUpdateScripts.scriptName" required ng-maxlength="50" ng-disabled="vm.tabUpdateScripts.id !== null"><div ng-show="editForm.scriptName.$invalid"><p class="help-block" ng-show="editForm.scriptName.$error.required" translate="entity.validation.required">Field required</p><p class="help-block" ng-show="editForm.scriptName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabUpdateScripts.scriptDescription" for="field_scriptDescription">Description</label> <input type="text" class="form-control" name="scriptDescription" id="field_scriptDescription" ng-model="vm.tabUpdateScripts.scriptDescription" ng-maxlength="255"><div ng-show="editForm.scriptDescription.$invalid"><p class="help-block" ng-show="editForm.scriptDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">Field cannot be longer than 255 characters</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.tabUpdateScripts.objectType" for="field_objectType">Object Type</label><ui-select multiple="multiple" ng-model="vm.tabUpdateScripts.objectTypes" theme="bootstrap" id="field_objectTypes" name="objectType" required ng-if="vm.tabUpdateScripts.id === null"><ui-select-match placeholder="Select an Object Type..."><!--{{$select.selected.objectTypeName}}--> {{$item.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><ui-select ng-model="vm.tabUpdateScripts.objectType" theme="bootstrap" id="field_objectType" name="objectType" required ng-if="vm.tabUpdateScripts.id !== null"><ui-select-match placeholder="Select an Object Type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.objectType.$invalid"><p class="help-block" ng-show="editForm.objectType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><!--<div class="col-md-6 col-xs-12">--><!--<div class="form-group" ngf-drop ngf-change="vm.setScriptContent($file, vm.tabUpdateScripts)">--><!--<label class="control-label" translate="jotApp.tabUpdateScripts.scriptContent" for="field_scriptContent">File Content</label>--><!--<div>--><!--<button type="file" ngf-select class="btn btn-default btn-block"--><!--ngf-change="vm.setScriptContent($file, vm.tabUpdateScripts)" translate="entity.action.addblob">--><!--Add blob--><!--</button>--><!--<div class="help-block clearfix">--><!--<button ng-click="vm.tabUpdateScripts.scriptContent=null;"--><!--ng-if="vm.tabUpdateScripts.scriptContent"--><!--class="btn btn-primary btn-circle btn-sm">--><!--Remove--><!--</button>--><!--<a class="btn btn-primary btn-circle btn-sm" ng-click="vm.openFile(vm.tabUpdateScripts.scriptContent)"--><!--ng-if="vm.tabUpdateScripts.scriptContent" target="_blank" translate="entity.action.open">open</a>--><!--<span ng-if="vm.tabUpdateScripts.scriptContent"><span></span> {{byteSize(vm.tabUpdateScripts.scriptContent)}}</span>--><!--</div>--><!--</div>--><!--<input type="hidden" class="form-control" name="scriptContent" id="field_scriptContent"--><!--ng-model="vm.tabUpdateScripts.scriptContent"--><!--required/>--><!--<div ng-show="editForm.scriptContent.$invalid">--><!--<p class="help-block"--><!--ng-show="editForm.scriptContent.$error.required" translate="entity.validation.required">--><!--This field is required.--><!--</p>--><!--</div>--><!--</div>--><!--</div>--></div><div class="row"><div class="col-xs-12"><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/tab-update-scripts/tab-update-scripts.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.loadAll()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label ng-scope" for="objectType_field">Object Type</label><ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-2 inline-filter-button"><div class="form-group"><label class="control-label ng-scope" for="submit_field"></label> <button type="submit" id="submit_field" class="btn btn-primary"><span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span></button></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="tab-update-scripts-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.tabUpdateScripts.home.createLabel">Create new Script</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Name or Description..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.reset()"><th multi-sort-by="scriptName"><span translate="jotApp.tabUpdateScripts.scriptName">Name</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="scriptDescription"><span translate="jotApp.tabUpdateScripts.scriptDescription">Description</span><span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="objectType"><span translate="jotApp.tabUpdateScripts.objectType">Object Type</span><span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="scripts in vm.tabUpdateScripts track by scripts.id"><td ng-bind-html="scripts.scriptName | highlight:vm.charToSearch"></td><td ng-bind-html="scripts.scriptDescription | highlight:vm.charToSearch"></td><td>{{scripts.objectType.objectTypeName}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="tab-update-scripts-detail({id:scripts.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="tab-update-scripts-edit({id:scripts.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="tab-update-scripts.delete({id:scripts.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/test-schedule/schedule-object-test.html','<form name="scheduleForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times</button><h4 class="modal-title" ng-if="vm.afterLaunch" translate="jotApp.testSchedule.scheduleCommand.title">Schedule Test</h4><h4 class="modal-title" ng-if="!vm.afterLaunch">Schedule Test - {{vm.testScheduleName}}</h4></div><div class="modal-body"><div ng-if="vm.afterLaunch" class="nav nav-tabs nav-tabs-cards"><label translate="jotApp.testSchedule.scheduleCommand.testName" for="field_name">Schedule Name</label> <input type="text" class="form-control" name="testName" id="field_name" ng-model="vm.testName" required ng-maxlength="100"></div><ul class="nav nav-tabs nav-tabs-cards" role="tablist"><li ng-class="vm.scheduleDate.single ? \'nav-item\' : \'nav-item active\'"><a class="nav-link" data-toggle="tab" data-target="#card-tab1" role="tab" aria-controls="card-tab1" aria-selected="true" ng-click="vm.check(false)" translate="jotApp.testSchedule.scheduleCommand.weekly">Weekly</a></li><li ng-class="vm.scheduleDate.single ? \'nav-item active\' : \'nav-item\'"><a class="nav-link" data-toggle="tab" data-target="#card-tab2" role="tab" aria-controls="card-tab2" aria-selected="false" ng-click="vm.check(true)" translate="jotApp.testSchedule.scheduleCommand.repeat">Repeat</a></li></ul><div class="tab-content"><div ng-class="vm.scheduleDate.single ? \'tab-pane p-4 fade\' : \'tab-pane p-4 fade active in\'" ng-show="!vm.scheduleDate.single" id="card-tab1" role="tabpanel"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableToExport"><thead><tr><th translate="jotApp.testSchedule.scheduleCommand.repeat">Repeat</th><th translate="jotApp.testSchedule.scheduleCommand.days">Days</th><th translate="jotApp.testSchedule.scheduleCommand.hours">Hour</th></tr></thead><tbody><tr ng-repeat="day in vm.multipleSchedule track by $index"><td><i ng-class="day.selectedTime ? \'fa fa-check color-green\' : \'fa fa-close background-red\'"></i></td><td>{{day.day}}</td><td><input type="text" placeholder="HH:mm" timepicker-options="vm.timepickerOptions" datepicker-options="vm.datepickerOptions" enable-date="false" class="form-control" datetime-picker="HH:mm" ng-model="day.selectedTime" ng-required="vm.checkEmptyWeeklyForm()" name="scheduleTime" ng-click="vm.openTimeCal($index)" is-open="vm.repeatStatus[$index]" autocomplete="off"></td></tr></tbody></table></div><div ng-class="vm.scheduleDate.single ? \'tab-pane p-4 fade active in\' : \'tab-pane p-4 fade\'" ng-show="vm.scheduleDate.single" id="card-tab2" role="tabpanel"><div class="row"><div class="col-md-12 col-xs-12 schedule-btn-wrapper top-action-buttons-wrapper"><div class="input-group"><input id="scheduleUp" type="text" placeholder="Set schedule time if any" timepicker-options="vm.timepickerOptions" datepicker-options="vm.datepickerOptions" class="form-control" datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.scheduleDate.scheduleDateTime" ng-required="vm.scheduleDate.single" name="scheduleDatetime" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen" autocomplete="off"> <span class="input-group-btn" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen" role="button" tabindex="0"><button type="button" class="btn btn-default"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row"><div class="col-md-12 col-xs-12 mt-checkbox-inline form-field-no-label" ng-if="vm.scheduleDate.scheduleDateTime" style="margin-left: 17px"><div><label>Repeat every <input style="width: 73px;height: 27px;" type="number" ng-model="vm.scheduleDate.repeatNumber" ng-required="vm.scheduleDate.scheduleDateTime" min="1" max="30"> days</label></div></div></div></div></div></div><div class="modal-footer"><button ng-click="vm.save()" ng-disabled="scheduleForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/test-schedule/test-schedule-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.testSchedule.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.testSchedule.question.delete" translate-values="{name: \'{{vm.testSchedule.name}}\'}">Are you sure you want to delete this Schedule test?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/test-schedule/test-schedule-detail.html','<div class="app-content-body detail-page domain-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span>Schedule: "{{vm.testSchedule.name}}"</span></h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.testSchedule.name">Name</span></dt><dd><span>{{vm.testSchedule.name}}</span></dd><dt><span translate="jotApp.testSchedule.lastExecution">Last Execution</span></dt><dd><span>{{vm.testSchedule.lastExecution | date:\'yyyy/MM/dd HH:mm\'}}</span></dd><dt><span translate="jotApp.testSchedule.nextExecution">Next Execution</span></dt><dd><span ng-bind-html="!vm.testSchedule.stopped ? (vm.testSchedule.nextExecution | date:\'yyyy/MM/dd HH:mm\') : \'STOPPED\'"></span></dd><dt><span translate="jotApp.testSchedule.executionCriteria">Execution Criteria</span></dt><dd><span ng-if="!vm.testSchedule.stopped && vm.testSchedule.repeat.split(\' at \')[1] != undefined">{{vm.testSchedule.repeat.split(" at ")[0]}} at {{vm.testSchedule.repeat.split(" at ")[1] | utcToLocal: \'HH:mm\'}}</span> <span ng-if="!vm.testSchedule.stopped && vm.testSchedule.repeat.split(\' at \')[1] == undefined">{{vm.testSchedule.repeat}}</span></dd><dt><span translate="jotApp.testSchedule.tests">Tests</span></dt><dd><span ng-repeat="test in vm.testSchedule.tests">{{test.name}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.testSchedule.objects">Objects</span></dt><dd><span ng-repeat="object in vm.testSchedule.objects">{{object.objectName}}{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="jotApp.testSchedule.createdBy">Created By</span></dt><dd><span>{{vm.testSchedule.createdBy}}</span></dd><dt><span translate="jotApp.testSchedule.createdDate">Created Date</span></dt><dd><span>{{vm.testSchedule.createdDate | date:\'yyyy/MM/dd HH:mm\'}}</span></dd><dt><span translate="jotApp.testSchedule.lastModifiedBy">Last Modified By</span></dt><dd><span>{{vm.testSchedule.lastModifiedBy}}</span></dd><dt><span translate="jotApp.testSchedule.lastModifiedDate">Last Modified Date</span></dt><dd><span>{{vm.testSchedule.lastModifiedDate | date:\'yyyy/MM/dd HH:mm\'}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/test-schedule/test-schedule-dialog-next.html','<div class="app-content-body commands-management-page"><h1 class="page-title" ng-if="vm.testSchedule == null" translate="jotApp.testSchedule.home.createLabel">Create a Schedule</h1><h1 class="page-title" ng-if="vm.testSchedule != null" translate="jotApp.testSchedule.home.editLabel" translate-values="{name: \'{{vm.testSchedule.name}}\'}">Edit Schedule</h1><h3>Select objects for your schedule</h3><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div><span>Fleet: {{vm.fleet.fleetName}}, Object Type: {{vm.objType.objectTypeName}}, include: {{vm.isActive}}</span></div><div><span>Test: </span><span ng-repeat="test in vm.tests">{{test.name}}{{$last ? \'\' : \', \'}}</span></div><div class="table-scrollable-vertical"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-click="vm.checkAll()" ng-model="vm.areChk"> <span></span></label></th><th><span translate="jotApp.tabObjects.objectName">Object Name</span></th><th><span translate="jotApp.tabObjects.objectUniqueCode">Object Unique Code</span></th><th><span translate="jotApp.tabObjects.objectDescription">Object Description</span></th><th><span translate="jotApp.tabObjects.objectNotes">Object Notes</span></th></tr></thead><tbody><tr ng-repeat="object in vm.tabObjects track by object.id"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="object.check" ng-click="vm.areAllChecked()"> <span></span></label></td><td>{{object.objectName}}</td><td>{{object.objectUniqueCode}}</td><td>{{object.objectDescription}}</td><td>{{object.objectNotes}}</td></tr></tbody></table></div></div><div class="aside-right"><button ng-click="vm.back()" class="btn btn-primary"><span class="fa fa-backward"></span>&nbsp;<span>Back</span></button> <button ng-if="vm.testSchedule == null" ng-click="vm.scheduleTest()" class="btn btn-primary" ng-disabled="vm.tabObjects.length < 1 || !vm.clickedAtLeastOneObject()"><span class="fa fa-calendar"></span>&nbsp;<span translate="entity.action.schedule">Schedule</span></button> <button ng-if="vm.testSchedule != null" ng-click="vm.update()" class="btn btn-primary" ng-disabled="vm.tabObjects.length < 1 || !vm.clickedAtLeastOneObject()"><span class="fa fa-save"></span>&nbsp;<span>Update</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/test-schedule/test-schedule-dialog.html','<div class="app-content-body commands-management-page"><h1 class="page-title" ng-if="vm.testSchedule == null" translate="jotApp.testSchedule.home.createLabel">Create a Schedule</h1><h1 class="page-title" ng-if="vm.testSchedule != null" translate="jotApp.testSchedule.home.editLabel" translate-values="{name: \'{{vm.testSchedule.name}}\'}">Edit Schedule</h1><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-md-8 col-lg-4 py20"><label translate="jotApp.testSchedule.scheduleCommand.testName" for="field_name">Schedule Name</label> <input type="text" class="form-control" name="scheduleName" id="field_name" ng-model="vm.scheduleName" required ng-maxlength="100"></div><div class="col-md-6 col-xs-4 col-lg-2 py20"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="field_isActive"><input type="checkbox" id="field_isActive" ng-model="vm.isActive" checked="vm.isActive">Include offline objects <span></span></label></div></div></div><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label for="field_fleet">Fleet</label><ui-select ng-if="vm.testSchedule == null" id="field_fleet" on-select="vm.selectedFleet($item)" ng-model="vm.fleet" theme="bootstrap"><ui-select-match placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" ng-if="vm.testSchedule != null" class="form-control" ng-model="vm.fleet.fleetName" title="These fields cannot be modified" disabled="disabled"></div></div><div class="col-md-4"><div class="form-group"><label for="field_objectType">Object Type</label><ui-select ng-if="vm.testSchedule == null" id="field_objectType" on-select="vm.selectedObjectType($item, 1,true)" ng-model="vm.objType" theme="bootstrap" ng-disabled="vm.fleet == null"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" ng-if="vm.testSchedule != null" class="form-control" ng-model="vm.objType.objectTypeName" title="These fields cannot be modified" disabled="disabled"></div></div></div><div class="table-scrollable-vertical"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th ng-if="vm.tests.length > 0" class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-click="vm.checkAll()" ng-model="vm.areChk"> <span></span></label></th><th><span translate="jotApp.objectTestSetting.name">name</span></th><th><span translate="jotApp.objectTestSetting.index">Index</span></th><th><span translate="jotApp.objectTestSetting.expectedValue">expectedValue</span></th><th><span translate="jotApp.objectTestSetting.checkType">checkType</span></th><th><span translate="jotApp.objectTestSetting.aggregation">aggregation</span></th></tr></thead><tbody><tr ng-repeat="test in vm.tests track by test.id"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="test.check" ng-click="vm.areAllChecked()"> <span></span></label></td><td>{{test.name}}</td><td>{{test.index}}</td><td class="text-center">{{test.expectedValue}}</td><td>{{test.checkType}}</td><td>{{test.aggregation}}</td></tr></tbody></table></div></div><div class="aside-right"><button ui-sref="test-schedule" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.next()" class="btn btn-primary" ng-disabled="vm.tests.length < 1 || !vm.clickedAtLeastOneTest() || vm.scheduleName == null"><span class="fa fa-arrow-circle-o-right"></span>&nbsp;<span>Next</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/test-schedule/test-schedule-failed-tests.html','<div class="app-content-body commands-management-page"><h1 class="page-title" id="title">{{vm.testSchedule.name}}</h1><jhi-alert></jhi-alert><div class="page-subtitle-container"><span class="page-subtitle" translate="jotApp.testSchedule.failedTestsDetail.subtitle"></span></div><div class="row"><div class="col-xs-12"><div class="portlet-body"><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><div class="btn-group"><button ui-sref="object-test-result.history({object:vm.testSchedule.name,id:-1})" type="button" class="btn btn-primary" style="margin-right: 5px;"><i class="fa fa-history"></i> <span>History of Downloads</span></button> <button class="btn btn-outline dropdown-toggle" data-toggle="dropdown" ng-click="vm.loadAllToExport()"><i class="fa fa-bars"></i><span> Export</span></button><ul class="dropdown-menu" role="menu"><li class="divider"></li><li><a href="" ng-click="vm.downloadCsv(1)"><i class="fa fa-file-zip-o"></i> CSV (all elements)</a></li><li><a href="" ng-click="vm.downloadCsv(0)"><i class="fa fa-file-zip-o"></i> CSV (only view)</a></li><li class="divider"></li><li><a href="" ng-click="vm.downloadPdf(0)"><i class="fa fa-file-pdf-o"></i> PDF (only view)</a></li><li><a href="" ng-click="vm.downloadPdf(1)"><i class="fa fa-file-pdf-o"></i> PDF (all elements)</a></li></ul></div></div></div></div></div></div><div class="table-scrollable-vertical"><table id="tableToExport" class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th class="text-center" style="width:5%;"></th><th><span translate="jotApp.testSchedule.failedTestsDetail.objectName">Object Name</span></th><th><span translate="jotApp.testSchedule.failedTestsDetail.performedTests">Performed tests in this schedule</span></th><th><span translate="jotApp.testSchedule.failedTestsDetail.lastFailedTests">Last failed tests update</span></th><th style="visibility:collapse;" class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="test in vm.scheduleResults"><td><div class="text-center"><i ng-if="test[4] > 0" class="fa fa-exclamation-triangle" title="Another run or schedules updated {{test[4]}} test result(s) of this object"></i></div></td><td>{{test[1]}}</td><td>{{test[2]}}</td><td>{{test[3]}}</td><td class="text-center"><div class="btn-group icon-table-queue"><span ui-sref="object-test-result({id:test[0], scheduleId: vm.testSchedule.id})" title="View tests"><i class="glyphicon glyphicon-zoom-in"></i></span></div></td></tr></tbody></table></div></div></div></div><div class="aside-right"><button ui-sref="test-schedule" class="btn btn-primary"><span class="fa fa-backward"></span>&nbsp;<span>Back</span></button></div></div>');
$templateCache.put('app/entities/test-schedule/test-schedule-resume-dialog.html','<form name="resumeForm" ng-submit="vm.confirmResume(vm.testSchedule.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm resume operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.testSchedule.question.resume" translate-values="{date: \'{{vm.testSchedule.nextExecution | date:\'yyyy-MM-dd HH:mm\'}}\'}"></p></div><div class="modal-footer"><button type="submit" ng-disabled="resumeForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/test-schedule/test-schedule.html','<div class="app-content-body custom-updates-page"><h1 class="page-title" translate="jotApp.testSchedule.home.title">Schedule</h1><jhi-alert></jhi-alert><div class="page-subtitle-container"><span class="page-subtitle" translate="jotApp.testSchedule.home.subtitle"></span></div><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.loadTestSchedule()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-xs-12 col-md-6 col-lg-3"><div class="form-group"><label for="field_fleet">Fleet</label><ui-select id="field_fleet" on-select="vm.selectedFleet($item)" ng-model="vm.fleet" theme="bootstrap"><ui-select-match placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-6 col-lg-3"><div class="form-group"><label for="field_objectType">Object Type</label><ui-select id="field_objectType" on-select="vm.selectedObjectType($item, 1,true)" ng-model="vm.objType" theme="bootstrap" ng-disabled="vm.fleet.id == -1"><ui-select-match placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-6 col-lg-3"><div class="form-group"><label>Objects</label><ui-select multiple="multiple" on-select="vm.selectObject($item)" ng-model="vm.objects" theme="bootstrap" ng-disabled="vm.fleet.id == -1"><ui-select-match placeholder="All">{{$item.objectName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjects | propsFilter: {objectName: $select.search, objectUniqueCode: $select.search}" percent="90" when-scrolled="vm.loadObjSelect(vm.objPage + 1)" refresh="vm.selectSearch($select.search)" refresh-delay="1"><div ng-bind-html="item.objectName | highlight: $select.search"></div><small ng-bind-html="item.objectUniqueCode | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-md-6 col-lg-3"><div class="aside-right inline-filter-button-mr"><button type="submit" class="btn btn-primary"><span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span></button></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="test-schedule.new"><i class="fa fa-plus"></i> <span translate="jotApp.testSchedule.home.createLabel">Create a new Schedule</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Name..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition(true)"><th multi-sort-by="name"><span translate="jotApp.testSchedule.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.testSchedule.run">N\xB0 run</span></th><th multi-sort-by="lastExecution"><span translate="jotApp.testSchedule.lastExecution">Last exec</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="nextExecution"><span translate="jotApp.testSchedule.nextExecution">Next exec</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.testSchedule.executionCriteria">Execution Criteria</span></th><th><span translate="jotApp.testSchedule.createdBy">Created By</span></th><th>Offline Objects <i class="fa fa-question-circle" uib-tooltip="User choice whether to include offline objects during the tests time interval" tooltip-placement="top"></i></th><th><span>Calculated User Profile</span></th><th multi-sort-by="lastScheduleFailedTestCount"><span translate="jotApp.testSchedule.failedTest">N\xB0 failed tests</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="test in vm.testSchedule"><td ng-bind-html="test.name | highlight:vm.charToSearch"></td><td>{{test.executionCount}}</td><td id="lastExecution">{{test.lastExecution | date:\'yyyy-MM-dd HH:mm\'}}</td><td ng-bind-html="!test.stopped ? (test.nextExecution | date:\'yyyy-MM-dd HH:mm\') : \'STOPPED\'"></td><td><span ng-if="!test.stopped && test.repeat.split(\' at \')[1] != undefined">{{test.repeat.split(" at ")[0]}} at {{test.repeat.split(" at ")[1] | utcToLocal: \'HH:mm\'}}</span> <span ng-if="!test.stopped && test.repeat.split(\' at \')[1] == undefined">{{test.repeat}}</span></td><td>{{test.created}}</td><td><!--{{test.includeOffline}}--> <span ng-if="test.includeOffline">Offline object are included </span><span ng-if="!test.includeOffline">Offline object are not included</span></td><td>{{test.userProfile.name}}</td><td class="text-center"><div ng-if="test.lastScheduleFailedTestCount != null" class="btn" ui-sref="test-schedule.failed-tests({id:test.id})" ng-class="\'warning-level \' + (test.lastScheduleFailedTestCount === 0 ? \'btn-lv-ok\' : \'btn-lv-high\')"><i class="fa fa-search"></i> {{test.lastScheduleFailedTestCount}}</div><i ng-if="test.lastScheduleFailedTestCount == null" class="fa fa-hourglass-o" aria-hidden="true" title="Tests not performed yet"></i></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" ng-click="vm.changevisibilty(test)" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="test-schedule.detail({id:test.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><!--<li ng-if="Math.ceil(Math.abs(now().getDate() - new Date({{test.lastExecution}}).getDate())/(1000*60*60))">--><li><a href="javascript:;" ng-show="vm.datelastexcution" ng-click="vm.runSchedule(test)"><i class="glyphicon glyphicon-flash"></i>Run now<span></span></a></li><li><a href="javascript:;" ui-sref="test-schedule.edit({id:test.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li ng-if="test.stopped"><a href="javascript:;" ui-sref="test-schedule.resume({id:test.id})"><i class="glyphicon glyphicon-play"></i><span translate="jotApp.testSchedule.resume"></span></a></li><li ng-if="!test.stopped"><a href="javascript:;" ng-click="vm.manageSchedule(test)"><i class="glyphicon glyphicon-stop"></i><span translate="entity.action.stop"></span></a></li><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="test-schedule.delete({id:test.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition(true)"></uib-pagination></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/user-profile/user-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.userProfile.delete.question" translate-values="{id: \'{{vm.userProfile.name}}\'}">Are you sure you want to delete this User Profile?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/user-profile/user-profile-detail.html','<div class="bg-light lter b-b wrapper-md ng-scope"><h1 class="m-n font-thin h3"><span translate="jotApp.userProfile.detail.title">User Profile</span></h1></div><div class="wrapper-md" style="padding-bottom: 60px; margin-left:  10px"><dl class="dl-horizontal" style="padding-left: 9px;"><dt><span translate="jotApp.userProfile.name">Name</span></dt><dd><span>{{vm.userProfile.name}}</span></dd><hr><dt><span translate="jotApp.userProfile.description">Description</span></dt><dd><span>{{vm.userProfile.description}}</span></dd><hr><dt><span translate="jotApp.userProfile.warningLevel">Warning Level</span></dt><dd><span>{{vm.userProfile.warningLevel}}</span></dd><hr><dt><span translate="jotApp.userProfile.commandLevel">Command Level</span></dt><dd><span>{{vm.userProfile.commandLevel}}</span></dd><hr><dt><span translate="jotApp.userProfile.authority">Role</span></dt><dd><span>{{vm.userProfile.authority.name}}</span></dd><hr></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/user-profile/user-profile-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.userProfile.home.createOrEditLabel">Create or edit a User Profile</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.userProfile.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.userProfile.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.userProfile.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.userProfile.description"></div></div></div><div class="row"><div class="form-group"><label class="control-label" translate="jotApp.userProfile.warningLevel" for="field_warningLevel">Warning Level</label><rzslider id="field_warningLevel" rz-slider-options="vm.slider.options" rz-slider-model="vm.userProfile.warningLevel"></rzslider><div ng-show="editForm.warningLevel.$invalid"><p class="help-block" ng-show="editForm.warningLevel.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.warningLevel.$error.min" translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.warningLevel.$error.max" translate="entity.validation.max" translate-value-max="10">This field cannot be more than 10.</p><p class="help-block" ng-show="editForm.warningLevel.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><br></div><div class="row"><div class="form-group"><label class="control-label" translate="jotApp.userProfile.commandLevel" for="field_commandLevel">Command Level</label><rzslider id="field_commandLevel" rz-slider-options="vm.slider.options" rz-slider-model="vm.userProfile.commandLevel"></rzslider><div ng-show="editForm.commandLevel.$invalid"><p class="help-block" ng-show="editForm.commandLevel.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.commandLevel.$error.min" translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.commandLevel.$error.max" translate="entity.validation.max" translate-value-max="10">This field cannot be more than 10.</p><p class="help-block" ng-show="editForm.commandLevel.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><br></div><div has-authority="ROLE_ADMIN" class="row"><div class="col-md-6 col-xs-12" ng-if="vm.customizable"><div class="form-group"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="customProfile"><input type="checkbox" id="customProfile" ng-click="vm.loadDomains()" ng-model="vm.userProfile.customProfile"> <span></span><div translate="jotApp.userProfile.custom">Custom</div></label></div></div></div></div><div class="col-md-6 col-xs-12" ng-if="vm.customizable"><div class="form-group" ng-if="vm.userProfile.customProfile"><label translate="jotApp.userProfile.domains" for="field_domains">Domains</label> <select class="form-control" id="field_domains" chosen multiple="multiple" name="domains" ng-model="vm.userProfile.domains" ng-options="domain.domainName for domain in vm.domains track by domain.id" data-placeholder-text-multiple="\' \'" required></select></div></div></div><div class="form-actions"><button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/user-profile/user-profiles.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button class="btn btn-primary" ui-sref="user-profile.new"><i class="fa fa-plus"></i> <span translate="jotApp.userProfile.home.createLabel">Create a new User</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.userProfile.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.userProfile.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="warningLevel"><span translate="jotApp.userProfile.warningLevel">Warning Level</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" multi-sort-by="commandLevel"><span translate="jotApp.userProfile.commandLevel">Command Level</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" multi-sort-by="customProfile"><span translate="jotApp.userProfile.customProfile">Custom Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="authority"><span translate="jotApp.userProfile.authority">Role</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel">Action</th></tr></thead><tbody><tr ng-repeat="userProfile in vm.userProfiles track by userProfile.id"><td>{{userProfile.name}}</td><td>{{userProfile.description}}</td><td>{{userProfile.warningLevel}}</td><td has-authority="ROLE_ADMIN">{{userProfile.commandLevel}}</td><td has-authority="ROLE_ADMIN"><span ng-class="userProfile.customProfile ? \'label label-success\' : \'label label-danger\'">{{userProfile.customProfile}}</span></td><td>{{userProfile.authority.name}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions</span> <i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="user-profile-edit({id:userProfile.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="user-profile-delete({id:userProfile.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-xs-12"><div class="dataTables_paginate"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/warning/check-save-edit.html','<form name="checkSaveEdit"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.warning.checkQuery">Check Query Before Save</h4></div><div class="modal-body col-md-12 col-xs-12"><div class="row col-md-12 col-xs-12" style="padding-bottom: 15px;"><label for="last">Last Query</label> <textarea id="last" class="form-control" ng-model="vm.lastQuery" readonly="readonly" style="resize: none"></textarea></div><div class="row col-md-12 col-xs-12" style="padding-bottom: 15px;"><label for="new_q">Query To Save</label> <textarea id="new_q" class="form-control" ng-model="vm.newQuery" readonly="readonly" style="resize: none"></textarea></div></div><div class="modal-footer"><button ng-click="vm.save()" ng-disabled="checkSaveEdit.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">save</span></button></div></form>');
$templateCache.put('app/entities/warning/notifications-help.html','<form name="notificationsHelp"><div class="modal-header"><h4 class="modal-title" translate="jotApp.warning.notificationsHelp">Notifications Description</h4></div><div class="modal-body"><div class="row"><table class="table table-striped table-hover order-column dataTable no-footer"><thead><tr><th>Icon</th><th>Description</th></tr></thead><tbody><tr ng-repeat="notification in vm.notifications track by $index"><td><span ng-class="notification.iconColor"><i ng-class="notification.icon"></i></span></td><td>{{notification.description}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/warning/warning-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.warning.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="jotApp.alertRules.delete.question" translate-values="{id: \'{{vm.warning.name}}\'}">Are you sure you want to delete this Rule?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/warning/warning-detail.html','<div class="app-content-body detail-page warning-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.alertRules.detail.title">Rule</span> {{vm.warning.name}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.warning.name">Name</span></dt><dd><span>{{vm.warning.name}}</span></dd><dt><span translate="jotApp.warning.query">Query</span></dt><dd><span>{{vm.warning.query}}</span></dd><dt><span translate="jotApp.warning.description">Description</span></dt><dd><span>{{vm.warning.description}}</span></dd><dt><span translate="jotApp.warning.active">Active</span></dt><dd><span>{{vm.warning.active}}</span></dd><dt><span translate="jotApp.warning.message">Message</span></dt><dd><span>{{vm.warning.message}}</span></dd><dt><span translate="jotApp.warning.userProfile">UserProfile</span></dt><dd><span>{{vm.warning.userProfile.name}}</span></dd><dt><span translate="jotApp.warning.frequency">Frequency</span></dt><dd><span>{{vm.warning.frequency}}</span></dd><dt><span translate="jotApp.warning.occurrence">occurrence</span></dt><dd><span>{{vm.warning.occurrence}}</span></dd><dt><span translate="jotApp.warning.warningCategory">Warning Category</span></dt><dd>{{vm.warning.warningCategory.warningName}}</dd><dt><span translate="jotApp.warning.tabObjectTypes">Tab Object Types</span></dt><dd><a ui-sref="tab-object-types-detail({id:vm.warning.tabObjectTypes.id})">{{vm.warning.tabObjectTypes.objectTypeName}}</a></dd><dt><span translate="jotApp.warning.tabFleets">Tab Fleets</span></dt><dd><a ui-sref="tab-fleets-detail({id:vm.warning.tabFleets.id})">{{vm.warning.tabFleets.fleetName}}</a></dd><dt><span>Response Type</span></dt><dd><span ng-if="vm.hasAutoRepairResponse()">{{vm.getResponseType()}}</span> <span ng-if="!vm.hasAutoRepairResponse()" class="text-muted">\u2014</span></dd><dt><span>Auto repair</span></dt><dd><div ng-if="vm.hasAutoRepairResponse()" style="border-left: 4px solid #B9E726;\n                                 padding-left: 12px;\n                                 max-width: 460px;"><!-- Greengrass Command --><div ng-if="vm.warning.greengrassCommandName"><!-- Badge + Command Name --><div style="margin-bottom: 10px;"><span style="display: inline-block;\n                                                     background-color: #B9E726;\n                                                     color: #444C50;\n                                                     padding: 2px 7px;\n                                                     font-size: 11px;\n                                                     font-weight: 700;\n                                                     line-height: 16px;\n                                                     border-radius: 0;\n                                                     margin-right: 8px;">{{vm.getResponseBadgeLabel()}} </span><span style="font-weight: 600; color: #222;">{{vm.prettyLabel(vm.warning.greengrassCommandName)}}</span></div><!-- Target --><div ng-if="vm.warning.greengrassTarget" style="display: grid;\n                                                    grid-template-columns: 140px 1fr;\n                                                    column-gap: 12px;\n                                                    margin-bottom: 10px;"><span style="font-weight: 700;">Target</span> <span>{{vm.warning.greengrassTarget}}</span></div><!-- Arguments --><div ng-if="vm.hasKeys(vm.warning.greengrassArguments)" style="margin-top: 6px;"><div style="font-weight: 700; margin-bottom: 6px;">Arguments</div><div ng-repeat="(key, value) in vm.warning.greengrassArguments" style="display: grid;\n                                                    grid-template-columns: 140px 1fr;\n                                                    column-gap: 12px;\n                                                    padding: 2px 0;\n                                                    align-items: start;"><span style="font-weight: 500;">{{vm.prettyLabel(key)}}</span> <span style="overflow-wrap: anywhere;">{{value}}</span></div></div></div><!-- Macro (Greengrass o Kura) --><div ng-if="vm.warning.macro"><div style="margin-top: 6px;"><span style="display: inline-block;\n                                                     background-color: #B9E726;\n                                                     color: #444C50;\n                                                     padding: 2px 7px;\n                                                     font-size: 11px;\n                                                     font-weight: 700;\n                                                     line-height: 16px;\n                                                     border-radius: 0;\n                                                     margin-right: 8px;">{{vm.getResponseBadgeLabel()}} </span><span style="font-weight: 600; color: #222;">{{vm.warning.macro.alias}}</span></div></div><!-- Action --><div ng-if="vm.warning.action.actionCommand"><div style="margin-bottom: 10px;"><span style="display: inline-block;\n                                                     background-color: #B9E726;\n                                                     color: #444C50;\n                                                     padding: 2px 7px;\n                                                     font-size: 11px;\n                                                     font-weight: 700;\n                                                     line-height: 16px;\n                                                     border-radius: 0;\n                                                     margin-right: 8px;">{{vm.getResponseBadgeLabel()}} </span><span style="font-weight: 600; color: #222;">{{vm.prettyLabel(vm.warning.action.actionCommand)}}</span></div><!-- Target --><div ng-if="vm.warning.action.deviceReleases.deviceReleaseName" style="display: grid;\n                                                    grid-template-columns: 140px 1fr;\n                                                    column-gap: 12px;\n                                                    margin-bottom: 10px;"><span style="font-weight: 700;">Target</span> <span>{{vm.warning.action.deviceReleases.deviceReleaseName}}</span></div><!-- Arguments --><div ng-if="vm.hasKeys(vm.warning.actionArguments)" style="margin-top: 6px;"><div style="font-weight: 700; margin-bottom: 6px;">Arguments</div><div ng-repeat="(key, value) in vm.warning.actionArguments" style="display: grid;\n                                                    grid-template-columns: 140px 1fr;\n                                                    column-gap: 12px;\n                                                    padding: 2px 0;\n                                                    align-items: start;"><span style="font-weight: 500;">{{vm.prettyLabel(key)}}</span> <span style="overflow-wrap: anywhere;">{{value}}</span></div></div></div></div><!-- No response --><div ng-if="!vm.hasAutoRepairResponse()" class="text-muted">No response configured</div></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/warning/warning-dialog-query.html','<div class="app-content-body"><jhi-alert></jhi-alert><h1 class="page-title"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <span translate="jotApp.warning.editQuery">Edit Query</span></h1><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row warning-show-query-edit"><h4><span>Query</span>&nbsp; <button type="button" class="btn btn-primary" ng-disabled="!(vm.memory.length > 1 && vm.viewIndex > 0)" ng-click="vm.useMemory(true)"><span class="fa fa-undo"></span></button> <button type="button" class="btn btn-primary" ng-disabled="!(vm.memory.length > 1 && vm.viewIndex < vm.memory.length-1)" ng-click="vm.useMemory(false)"><span class="fa fa-repeat"></span></button></h4><textarea id="field_query" rows="3" ng-model="vm.showQuery"></textarea></div><div class="row content-row"><div class="col-xs-12" style="margin-bottom: 20px;"><div class="col-xs-12" style="margin-bottom: 20px; text-align: center;"><button type="button" class="btn btn-primary" style="background-color: #f4d03f; font-weight: bold; display: block; margin: 0 auto;"><span class="fa fa-exclamation-triangle" ; style="color: white;"></span> <span style="color: #4f4e4e; font-weight: bold;">Initial Query:{{vm.originalQuery}}</span> <span class="fa fa-exclamation-triangle" style="color: white;"></span></button></div><input type="button" class="btn btn-primary" style="margin-left: 4px; margin-bottom: 10px;" ng-repeat="query in vm.query track by $index" value="{{query.value}}" ng-click="vm.moveInside($index)" ng-disabled="vm.notQuery"><!--<input type="button" class="btn btn-primary" value="!(Query)" ng-click="vm.negQuery()" ng-disabled="vm.hasTotalNegation" style="margin-top: -10px;">--> <input type="button" class="btn btn-primary" value="!(Query)" ng-click="vm.addNegQuery()" style="margin-top: -10px;"></div></div><div class="form-actions"><button type="button" class="btn btn-primary" ng-click="vm.save()"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.clear">Clear</span></button></div></div>');
$templateCache.put('app/entities/warning/warning-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.alertRules.home.createOrEditLabel">Create or edit a Rule</h1><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.warning.name" required ng-maxlength="250"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.message" for="field_message">Message</label> <input type="text" class="form-control" name="message" id="field_message" ng-model="vm.warning.message" ng-maxlength="1000"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.warning.description" ng-maxlength="1000"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.userProfile" for="field_level">User Profile</label><ui-select id="field_level" name="userProfile" ng-model="vm.warning.userProfile" theme="bootstrap" required><ui-select-match placeholder="Select a user profile...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.userProfiles | filter: {name: $select.search}" percent="90" when-scrolled="vm.loadUserProfilePage(vm.userProfilePage + 1)"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.userProfile.$invalid"><p class="help-block" ng-show="editForm.userProfile.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.frequency" for="field_frequency">Frequency</label> <input type="text" class="form-control" name="frequency" id="field_frequency" ng-model="vm.warning.frequency" required><div ng-show="editForm.frequency.$invalid"><p class="help-block" ng-show="editForm.frequency.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.occurrence" for="field_occurrence">occurrence</label> <input type="number" class="form-control" name="occurrence" id="field_occurrence" ng-model="vm.warning.occurrence" min="1" required><div ng-show="editForm.occurrence.$invalid"><p class="help-block" ng-show="editForm.occurrence.$error.min" translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.occurrence.$error.number" translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.occurrence.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.warning.warningCategory" for="field_warningCategory">Warning Category</label><ui-select id="field_warningCategory" name="warningCategory" ng-model="vm.warning.warningCategory" theme="bootstrap" required><ui-select-match placeholder="Select a warning category...">{{$select.selected.warningName}}</ui-select-match><ui-select-choices repeat="item in vm.warningCategories | filter: {warningName: $select.search}" percent="90" when-scrolled="vm.loadWarningCategoryPage(vm.warningCategoryPage + 1)"><div ng-bind-html="item.warningName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.warningCategory.$invalid"><p class="help-block" ng-show="editForm.warningCategory.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.warning.tabObjectTypes" for="field_tabObjectTypes">Tab Object Types</label><ui-select id="field_tabObjectTypes" name="tabObjectTypes" ng-model="vm.warning.tabObjectTypes" ng-change="vm.onObjectTypeChange()" theme="bootstrap" required><ui-select-match placeholder="Select an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" percent="90" when-scrolled="vm.loadObjectTypePage(vm.objectTypePage + 1)" refresh="vm.search($select.search)" refresh-delay="1"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.tabObjectTypes.$invalid"><p class="help-block" ng-show="editForm.tabObjectTypes.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group" ng-if="vm.warning.id == null && vm.warning.cloned !== true"><label translate="jotApp.warning.tabFleets" for="field_tabFleets">Tab Fleets</label><ui-select id="field_tabFleets" name="tabFleets" multiple="multiple" ng-model="vm.warning.tabFleets" theme="bootstrap" required ng-change="vm.onFleetChange()" close-on-select="false"><ui-select-match placeholder="Select or search a fleet...">{{$item.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}" percent="90" when-scrolled="vm.loadFleetPage(vm.fleetPage + 1)"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.tabFleets.$invalid"><p class="help-block" ng-show="editForm.tabFleets.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.warning.id != null || vm.warning.cloned === true"><label translate="jotApp.warning.tabFleets" for="field_tabFleets_edit">Tab Fleets</label><ui-select id="field_tabFleets_edit" name="tabFleets" ng-model="vm.warning.tabFleets" theme="bootstrap" search-enabled="false" required ng-change="vm.onFleetChange()"><ui-select-match placeholder="Select a fleet...">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets track by item.id" percent="90" when-scrolled="vm.loadFleetPage(vm.fleetPage + 1)"><div ng-bind-html="item.fleetName"></div></ui-select-choices></ui-select><div ng-show="editForm.tabFleets.$invalid"><p class="help-block" ng-show="editForm.tabFleets.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group" ng-if="vm.warning.tabObjectTypes != null"><label translate="jotApp.warning.index" for="field_index">Tab Object Types</label> <select id="field_index" name="index" ng-model="vm.warning.index" class="form-control" required ng-change="vm.loadMetric()"><option value="JoT">JoT</option><option value="TheTailKeepalive">TheTail Keepalive</option><option value="TheTailScreenshot">TheTail Screenshot</option></select><div ng-show="editForm.index.$invalid"><p class="help-block" ng-show="editForm.index.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row" ng-if="vm.canLoadRuleResponses()"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.warning.responseMacro" for="field_macro">Response macro</label><ui-select id="field_macro" name="macro" ng-model="vm.warning.macro" theme="bootstrap" search-enabled="true" ng-change="vm.onMacroChange()"><ui-select-match placeholder="Select a response macro...">{{$select.selected.alias}}</ui-select-match><ui-select-choices repeat="item in vm.macro track by item.id"><div ng-bind-html="item.alias"></div></ui-select-choices></ui-select></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.warning.command" for="field_command">Response command</label><ui-select id="field_command" name="command" ng-model="vm.warning.action" theme="bootstrap" search-enabled="true" ng-change="vm.onCommandChange();" ng-disabled="vm.warning.macro != null && vm.warning.macro.id != -1"><ui-select-match placeholder="Select or search a response command...">{{$select.selected.actionCommand}}</ui-select-match><ui-select-choices repeat="item in vm.commandList | filter: vm.filterResponseCommand($select.search) track by item.id"><div><span ng-bind-html="item.actionCommand | highlight: $select.search"></span> <small ng-if="item.componentName" class="text-muted">\u2014 {{item.componentName}}</small></div></ui-select-choices></ui-select></div></div></div><div class="row" ng-if="vm.warning.index != null"><div class="col-xs-12"><div class="form-group"><label class="switch aside-right"><input type="checkbox" ng-click="vm.compose = !vm.compose" ng-checked="vm.compose"> <span class="form-mode-toggle add-mode-toggle-query round"></span></label></div></div></div><div class="row" ng-if="vm.warning.index != null && !vm.compose"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warning.query" for="field_query">Query</label> <input type="text" class="form-control" name="query" id="field_query" ng-model="vm.warning.query" required><div ng-show="editForm.query.$invalid"><p class="help-block" ng-show="editForm.query.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row" ng-if="vm.warning.index != null && vm.compose" ng-repeat="quantity in [].constructor(vm.quantity) track by $index"><div ng-class="vm.tempMetric.length > 1 ? \'col-md-5 col-xs-12\' : \'col-md-6 col-xs-12\'"><div class="form-group"><label translate="jotApp.warning.metric" for="field_metric">Metric</label><ui-select id="field_metric" name="metric" ng-model="vm.tempMetric[$index]" ng-change="vm.clearOperator($index)" theme="bootstrap" required><ui-select-match placeholder="Select or search a metric..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.metric | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.metric.$invalid"><p class="help-block" ng-show="editForm.metric.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-1 col-xs-12" ng-if="vm.tempMetric.length > 1"><button id="field_deleteMetric" type="button" class="btn btn-primary form-rules-metric-delete-button" ng-click="vm.deleteMetric($index)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div><div class="col-md-6 col-xs-12 form-rules-metric-type" ng-if="vm.tempMetric[$index] != null"><div class="col-lg-4 col-xs-12 form-rules-metric-type"><label translate="jotApp.warning.typeMetric" for="field_types">Metric Type</label><div ng-if="vm.checkMetricType($index)"><select class="form-control form-rules-metric-type" id="field_types" name="checkType" ng-model="vm.checkType[$index]" ng-options="checkType for checkType in vm.checkTypes"></select></div><div ng-if="!vm.checkMetricType($index)"><select class="form-control form-rules-metric-type" name="checkType" ng-model="vm.checkType[$index]" ng-options="checkType for checkType in vm.checkTypesNumeric"></select></div></div><div class="col-lg-4 col-xs-12" ng-show="vm.checkType[$index] && (vm.checkType[$index] == \'Equals\' || vm.checkType[$index] == \'Not Equals\')"><label translate="jotApp.warning.expectedValues" for="field_expected_text">Expected Values</label> <input type="text" class="form-control" name="expectedValue" id="field_expected_text" ng-if="vm.checkMetricType($index) && !vm.checkMetricDate($index)" ng-model="vm.expected[$index]"> <input type="number" class="form-control" name="expectedValue" min="0" ng-if="!vm.checkMetricType($index) && !vm.checkMetricDate($index)" ng-model="vm.expectedNumber[$index]"><div ng-if="vm.checkMetricDate($index)"><input type="text" class="form-control" name="expectedValue" ng-if="vm.checkMetricDate($index)" ng-model="vm.expectedDate[$index]" enable-time="false" placeholder="Set date" datepicker-options="vm.datePickerOptions" datetime-picker="dd MMM yyyy" ng-click="vm.openCalendar($event, $index)" is-open="vm.metricDate[$index].isOpen"></div></div><div class="col-lg-4 col-xs-12" ng-show="vm.checkType[$index]&& vm.checkType[$index] != \'Exists\' && vm.checkType[$index] != \'Between\' && vm.checkType[$index] != \'Equals\' && vm.checkType[$index] != \'Not Exists\' && vm.checkType[$index] != \'Not Equals\'"><label translate="jotApp.warning.typeDate" for="field_expected" ng-if="vm.formDate[$index]">Type Date</label> <label translate="jotApp.warning.expectedValues" for="field_expected" ng-if="!vm.formDate[$index]">Expected Values</label> <input type="number" class="form-control" name="expectedValue" id="field_expected" ng-model="vm.expectedNumber[$index]" ng-if="!vm.checkMetricDate($index)"> <select ng-if="vm.formDate[$index]" ng-model="vm.typeDateForm[$index]" ng-change="vm.changeDate($index)" class="form-control"><option value="absolute">Absolute</option><option value="relative">Relative</option></select><div ng-if="!vm.formDate[$index] && vm.typeDateForm[$index] === \'absolute\'"><input type="text" class="form-control" name="expectedValue" ng-if="vm.checkMetricDate($index)" ng-model="vm.expectedDate[$index]" enable-time="false" placeholder="Set date" datepicker-options="vm.datePickerOptions" datetime-picker="dd MMM yyyy" ng-click="vm.openCalendar($event, $index)" is-open="vm.metricDate[$index].isOpen"></div><div ng-if="!vm.formDate[$index] && vm.typeDateForm[$index] === \'relative\'"><div class="col-lg-12 col-xs-12" style="padding: 0px"><div class="col-md-3 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDateSimbol[$index]" class="form-control"><option value="+">+</option><option value="-">-</option></select></div><div class="col-md-4 col-xs-12" style="padding: 0px"><input type="number" class="form-control" min="0" ng-model="vm.relativeDateNumber[$index]"></div><div class="col-md-5 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDate[$index]" ng-change="vm.changeDateRelative($index)" class="form-control"><option value="h">Hours</option><option value="d">Days</option><option value="m">Months</option><option value="y">Years</option></select></div></div></div></div><div class="col-lg-4 col-xs-12" ng-show="vm.checkType[$index] && vm.checkType[$index] == \'Between\'"><label translate="jotApp.warning.typeDate" for="field_expected" ng-if="vm.formDate[$index]">Type Date</label> <label translate="jotApp.warning.expectedValues" for="field_expected" ng-if="!vm.formDate[$index]">Expected Values</label> <input type="number" class="form-control" name="expectedValue" id="field_expected_between" ng-model="vm.expectedA[$index]" placeholder="excluded min edge" ng-if="!vm.checkMetricDate($index)"> <input type="number" class="form-control" name="expectedValueB" ng-model="vm.expectedB[$index]" placeholder="excluded max edge" ng-if="!vm.checkMetricDate($index)"> <select ng-if="vm.formDate[$index]" ng-model="vm.typeDateForm[$index]" ng-change="vm.changeDate($index)" class="form-control"><option value="absolute">Absolute</option><option value="relative">Relative</option></select><div ng-if="!vm.formDate[$index] && vm.typeDateForm[$index] === \'absolute\'"><input type="text" class="form-control" name="expectedValue" ng-if="vm.checkMetricDate($index)" ng-model="vm.expectedDateA[$index]" placeholder="Set date" datepicker-options="vm.datePickerOptions" datetime-picker="dd MMM yyyy" enable-time="false" ng-click="vm.openCalendar($event, $index)" is-open="vm.metricDate[$index].isOpen"> <input type="text" class="form-control" name="expectedValue" ng-if="vm.checkMetricDate($index)" ng-model="vm.expectedDateB[$index]" placeholder="Set date" datepicker-options="vm.datePickerOptions" datetime-picker="dd MMM yyyy" enable-time="false" ng-click="vm.openDownCalendar($event, $index)" is-open="vm.metricDateDown[$index].isOpen"></div><div ng-if="!vm.formDate[$index] && vm.typeDateForm[$index] === \'relative\'"><div class="col-lg-12 col-xs-12" style="padding: 0px"><div class="col-md-3 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDateSimbol[$index]" class="form-control"><option value="+">+</option><option value="-">-</option></select></div><div class="col-md-4 col-xs-12" style="padding: 0px"><input type="number" class="form-control" min="0" ng-model="vm.relativeDateNumber[$index]"></div><div class="col-md-5 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDate[$index]" ng-change="vm.changeDateRelative($index)" class="form-control"><option value="h">Hours</option><option value="d">Days</option><option value="m">Months</option><option value="y">Years</option></select></div></div><div class="col-lg-12 col-xs-12" style="padding: 0px"><div class="col-md-3 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDateSimbolB[$index]" class="form-control"><option value="+">+</option><option value="-">-</option></select></div><div class="col-md-4 col-xs-12" style="padding: 0px"><input type="number" class="form-control" min="0" ng-model="vm.relativeDateNumberB[$index]"></div><div class="col-md-5 col-xs-12" style="padding: 0px"><select ng-model="vm.relativeDateB[$index]" ng-change="vm.changeDateRelativeB($index)" class="form-control"><option value="h">Hours</option><option value="d">Days</option><option value="m">Months</option><option value="y">Years</option></select></div></div></div></div><div class="col-lg-4 col-xs-12"><div class="form-group"><label translate="jotApp.warning.addMetric" for="field_add_metric">Add Metric</label><ui-select id="field_add_metric" name="addMetric" ng-model="vm.operator[$index]" ng-change="vm.addQuantity($index)" theme="bootstrap"><ui-select-match placeholder="Operator..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.addMetric | filter: {name: $select.search}" refresh-delay="1"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-if="vm.warning.action != null && vm.warning.action.argumentsSchema != null"><div class="col-xs-12 col-md-6 col-lg-4 form-component-wrapper" ng-class="{\'col-md-12 col-lg-8 two-col\': vm.warning.action.weight == 2, \'col-md-12 col-lg-12 three-col\': vm.warning.action.weight == 3}"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption">{{vm.formSchemas.command | beautifyCommand }}</div></div><div class="portlet-body"><div class="form-group schema-form-submit"><form class="command-form" name="{{vm.formSchemas.command}}"><div sf-model="vm.formSchemas" sf-schema="vm.formSchemas.schema" sf-form="vm.formSchemas.form"></div></form></div><div class="clearfix"></div></div></div></div></div><div class="col-xs-12" ng-if="vm.originalQuery && vm.compose" style="margin-bottom: 20px;"><div style="background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);\n                                            border: 1px solid #f4c430;\n                                            border-left: 4px solid #f39c12;\n                                            border-radius: 4px;\n                                            padding: 12px 16px;\n                                            display: flex;\n                                            align-items: center;\n                                            gap: 12px;\n                                            box-shadow: 0 1px 3px rgba(0,0,0,0.06);"><span class="fa fa-exclamation-triangle" style="color: #f39c12; font-size: 18px; flex-shrink: 0;"></span><div style="flex: 1; min-width: 0;"><div style="font-size: 11px;\n                                                    font-weight: 700;\n                                                    color: #7a5c00;\n                                                    letter-spacing: 0.8px;\n                                                    text-transform: uppercase;\n                                                    margin-bottom: 4px;">Initial Query</div><code style="display: block;\n                                                     background: rgba(255,255,255,0.7);\n                                                     border: 1px solid rgba(0,0,0,0.08);\n                                                     border-radius: 3px;\n                                                     padding: 6px 10px;\n                                                     font-family: \'Consolas\', \'Monaco\', \'Courier New\', monospace;\n                                                     font-size: 13px;\n                                                     color: #2c3e50;\n                                                     white-space: pre-wrap;\n                                                     word-break: break-word;">{{vm.originalQuery}}</code></div></div></div><div class="form-actions"><button type="button" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary" ng-click="vm.checkSaveEdit()"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-disabled="vm.tempMetric == null || vm.tempMetric.length < 3" class="btn btn-primary" ng-click="vm.editQuery()" ng-if="vm.compose"><span class="fa fa-pencil"></span>&nbsp;<span translate="jotApp.warning.editQuery">Edit Query</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/warning/warning-turnoff-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="(vm.warning.active === true)" class="modal-title" translate="jotApp.warning.turnOff.title">Confirm stop operation</h4><h4 ng-show="(vm.warning.active === false)" class="modal-title" translate="jotApp.warning.turnOn.title">Confirm start operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="(vm.warning.active === true)" translate="jotApp.warning.turnOff.question" translate-values="{name: \'{{vm.warning.name}}\'}">By setting status \'stopped\' {{ vm.warning.name }} will no longer monitor or send you communications about this warning list. Are you sure?</p><p ng-show="(vm.warning.active === false)" translate="jotApp.warning.turnOn.question" translate-values="{name: \'{{vm.warning.name}}\'}">By setting status \'running\' {{ vm.warning.name }} will restart its monitoring routine. If any notification channel is active you will start receiving communications at set frequency. Are you sure?</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/warning/warnings.html','<div class="ng-scope"><jhi-alert></jhi-alert><dashboard-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="false" show-condition="false" condition="vm.selectedCondition"></dashboard-filter><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletSystemTitle">System Rules List</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.systemPredicates" callback="vm.transition()"><th multi-sort-by="name"><span translate="jotApp.alertRules.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="description"><span translate="jotApp.alertRules.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="critical"><span translate="jotApp.alertRules.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.alertRules.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span> <i class="fa fa-question-circle" ng-click="vm.notificationsHelp()" uib-tooltip="Click Here" tooltip-placement="top"></i></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.alertRules.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="warning in vm.systemWarnings track by warning.id"><td>{{warning.name}}</td><td>{{warning.description}}</td><td>{{warning.critical == 1 ? "LOW" : "CRITICAL"}}</td><td>{{warning.userProfile.name}}</td><td>{{warning.tabFleets.fleetName}}</td><td><span class="wrapper-md-right no-outline" ng-class="vm.enableMail[warning.id].config.color"><i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'email\', vm.notifications.warningEmail, vm.enableMail[warning.id])"></i> <i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableMail\', warning.id)" tooltip-is-open="vm.enableMail[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableTelegram[warning.id].config.color"><i ng-class="\'iconAlert icon-telegram\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'telegram\', vm.notifications.warningTelegram, vm.enableTelegram[warning.id])"></i> <i ng-class="\'iconAlert icon-telegram\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableTelegram\',warning.id)" tooltip-is-open="vm.enableTelegram[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableWebhook[warning.id].config.color"><i ng-class="\'iconAlert icon-webhook\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'webhook\', vm.notifications.warningWebhook, vm.enableWebhook[warning.id])"></i> <i ng-class="\'iconAlert icon-webhook\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableWebhook\',warning.id)" tooltip-is-open="vm.enableWebhook[warning.id].tooltip"></i></span></td><td><span class="label label-danger" ng-show="!warning.active" translate="jotApp.alertRules.stopped" ng-click="vm.toggleStatus(warning)">Stopped</span> <span class="label label-success" ng-show="warning.active" translate="jotApp.alertRules.running" ng-click="vm.toggleStatus(warning)">Running</span></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ng-click="vm.changeProfile(warning)"><i class="glyphicon glyphicon-wrench"></i><span translate="global.menu.admin.menuProfile"></span></a></li><li><a href="javascript:;" ng-click="vm.changeLevel(warning)"><i class="fa fa-sliders"></i> <span translate="jotApp.alertRules.level"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.systemPage" total="vm.systemQueryCount" limit="vm.systemWarningItemLimit"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemWarningItemLimit" total-items="vm.systemTotalItems" ng-model="vm.systemPage" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-exclamation"></i> <span translate="jotApp.alertRules.home.portletTitle">Rules List</span></div><div class="actions"><button type="button" class="btn btn-primary" ng-click="vm.sendRuleEmail()"><i class="fa fa-share-square-o">&nbsp;</i> <span translate="jotApp.warning.home.email.sendEmail">Send Rule email</span></button> <button type="button" class="btn btn-primary" ui-sref="warning-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.warning.home.createLabel">Create new Warning</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-4 aside-right"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search by Index, Warning Category, Name or Query..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="index"><span translate="jotApp.warning.index">Index</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="warningCategory.warningName"><span translate="jotApp.warning.warningCategory">Warning Category</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="name"><span translate="jotApp.warning.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="frequency"><span translate="jotApp.warning.frequency">Frequency</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="occurrence"><span translate="jotApp.warning.occurrence">Occurrence</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="critical"><span translate="jotApp.alertRules.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="userProfile.name"><span translate="jotApp.warning.userProfile">User Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="query"><span translate="jotApp.warning.query">Query</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.warning.autoRepair">Auto repair</span></th><th><span translate="jotApp.warning.deletedFlag">Deleted</span></th><th multi-sort-by="tabObjectTypes.objectTypeName"><span translate="jotApp.warning.tabObjectTypes">Object Type</span> <span class="glyphicon glyphicon-sort"></span></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.warning.tabFleets">Fleet</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="jotApp.alertRules.notifications">Notifications</span> <i class="fa fa-question-circle" ng-click="vm.notificationsHelp()" uib-tooltip="Click Here" tooltip-placement="top"></i></th><th multi-sort-by="tabFleets.fleetName"><span translate="jotApp.warning.dashboard.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="warning in vm.warnings track by warning.id"><td ng-bind-html="warning.index | highlight:vm.charToSearch"></td><td ng-bind-html="warning.warningCategory.warningName | highlight:vm.charToSearch"></td><td ng-bind-html="warning.name | highlight:vm.charToSearch"></td><td>{{warning.frequency}}</td><td>{{warning.occurrence}}</td><td>{{warning.critical == 1 ? "LOW" : "CRITICAL"}}</td><td>{{warning.userProfile.name}}</td><td ng-bind-html="warning.query | highlight:vm.charToSearch"></td><td><span ng-if="warning.action.actionCommand">(Single Command) {{warning.action.actionCommand}}</span> <span ng-if="warning.macro.alias">(Macro) {{warning.macro.alias}}</span> <span ng-if="warning.greengrassCommandName">(Single Command) {{warning.greengrassCommandName}}</span></td><td>{{warning.deleted == true ? "Yes" : "No"}}</td><td><a ui-sref="tab-object-types-detail({id:warning.tabObjectTypes.id})">{{warning.tabObjectTypes.objectTypeName}}</a></td><td><a ui-sref="tab-fleets-detail({id:warning.tabFleets.id})">{{warning.tabFleets.fleetName}}</a></td><td><span class="wrapper-md-right no-outline" ng-class="vm.enableMail[warning.id].config.color"><i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'email\', vm.notifications.warningEmail, vm.enableMail[warning.id])"></i> <i ng-class="\'iconAlert icon-envelope-regular\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableMail\', warning.id)" tooltip-is-open="vm.enableMail[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableTelegram[warning.id].config.color"><i ng-class="\'iconAlert icon-telegram\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'telegram\', vm.notifications.warningTelegram, vm.enableTelegram[warning.id])"></i> <i ng-class="\'iconAlert icon-telegram\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableTelegram\', warning.id)" tooltip-is-open="vm.enableTelegram[warning.id].tooltip"></i> </span><span class="wrapper-md-right no-outline" ng-class="vm.enableWebhook[warning.id].config.color"><i ng-class="\'iconAlert icon-webhook\'" ng-if="warning.active" ng-click="vm.changeStatus(warning, \'webhook\', vm.notifications.warningWebhook, vm.enableWebhook[warning.id])"></i> <i ng-class="\'iconAlert icon-webhook\'" ng-if="!warning.active" uib-tooltip="You can\'t change this because status is stopped." tooltip-placement="top" tooltip-trigger="click" ng-click="vm.enableTooltip(\'enableWebhook\', warning.id)" tooltip-is-open="vm.enableWebhook[warning.id].tooltip"></i></span></td><td><span class="label label-danger" ng-show="!warning.active" translate="jotApp.warning.stopped" ng-click="!warning.deleted && vm.toggleStatus(warning)">Stopped</span> <span class="label label-success" ng-show="warning.active" translate="jotApp.warning.running" ng-click="!warning.deleted && vm.toggleStatus(warning)">Running</span></td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="warning-detail({id:warning.id})"><i class="fa fa-eye"></i><span translate="entity.action.view"></span></a></li><li><a href="javascript:;" ui-sref="warning-edit({id:warning.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit"></span></a></li><li><a href="javascript:;" ui-sref="warning-clone({id:warning.id})"><i class="fa fa-clone"></i><span translate="entity.action.clone"></span></a></li><li><a href="javascript:;" ng-click="vm.changeLevel(warning)"><i class="fa fa-sliders"></i> <span translate="jotApp.alertRules.level"></span></a></li><li ng-if="!warning.deleted"><a href="javascript:;" ui-sref="warning.delete({id:warning.id})"><i class="fa fa-times"></i><span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/warning-category/warning-categories.html','<div class="app-content-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button type="button" class="btn btn-primary" ui-sref="warning-category-new"><i class="fa fa-plus"></i> &nbsp; <span translate="jotApp.warningCategory.home.createLabel">Create new Warning Category</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr multi-sort="vm.predicates" callback="vm.transition()"><th multi-sort-by="warningName"><span translate="jotApp.warningCategory.warningName">Warning Name</span> <span class="glyphicon glyphicon-sort"></span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="warningCategory in vm.warningCategories track by warningCategory.id"><td>{{warningCategory.warningName}}</td><td class="text-center"><button class="hand btn btn-primary" ui-sref="warning-category.delete({id:warningCategory.id})"><i class="fa fa-times"></i> <span translate="entity.action.delete">Delete</span></button></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/warning-category/warning-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.warningCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.warningCategory.delete.question" translate-values="{id: \'{{vm.warningCategory.warningName}}\'}">Are you sure you want to delete this Warning Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/warning-category/warning-category-detail.html','<div class="app-content-body detail-page warning-category-detail-page"><div class="row"><div class="col-xs-12"><button type="submit" onclick="window.history.back()" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><h1 class="page-title"><span translate="jotApp.warningCategory.detail.title">Warning Category</span> {{vm.warningCategory.warningName}}</h1></div></div><div class="row content-row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body"><dl class="dl-horizontal"><dt><span translate="jotApp.warningCategory.warningName">Warning Name</span></dt><dd><span>{{vm.warningCategory.warningName}}</span></dd></dl></div></div></div></div></div>');
$templateCache.put('app/entities/warning-category/warning-category-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.warningCategory.home.createOrEditLabel">Create or edit a Warning Category</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12" ng-show="vm.warningCategory.id"><div class="form-group"><label for="id" translate="global.field.id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.warningCategory.id" readonly="readonly"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.warningCategory.warningName" for="field_warningName">Warning Name</label> <input type="text" class="form-control" name="warningName" id="field_warningName" ng-model="vm.warningCategory.warningName"></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/layouts/aside/aside.html','<div class="page-sidebar navbar-collapse collapse"><!-- nav --><ul content-heigth-sync class="page-sidebar-menu page-header-fixed page-sidebar-menu-light" data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200"><li class="sidebar-toggler-wrapper hide"><div class="sidebar-toggler"><span></span></div></li><li ng-include="vm.homeTemplate" class="nav-item start" ui-sref-active="active" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id >= 2"></li><li ng-include="vm.monitoringTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'dashboard\')}" has-authority="ROLE_DOMAIN_USER"></li><li ng-include="vm.controlTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'management\')}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id >= 2"></li><li ng-include="vm.systemTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'entity\')}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"></li><li ng-include="vm.systemTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'entity\')}" has-authority="ROLE_TECH" ng-if="$root.licence.id === 3"></li><li ng-include="vm.alertingTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'alerting\')}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"></li><li ng-include="vm.alertingTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'alerting\')}" ng-if="$root.licence.id === 3"></li><li ng-include="vm.updatesTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'update_management\')}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"></li><li ng-include="vm.updatesTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'update_management\')}" has-authority="ROLE_TECH" ng-if="$root.licence.id === 3"></li><li ng-include="vm.kioskTemplate" class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_USER && !ROLE_ADMIN" ng-if="$root.licence.id === 4"></li><li ng-include="vm.kioskTemplateAdmin" class="nav-item" ng-class="{active: vm.$state.includes(\'kiosk\')}" has-authority="ROLE_ADMIN"></li><li ng-include="vm.testingTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'testing\')}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"></li><li ng-include="vm.administrationTemplate" class="nav-item" ng-class="{active: vm.$state.includes(\'admin\')}" has-authority="ROLE_DOMAIN_ADMIN" ng-if="$root.licence.id >= 2"></li><!--<li class="heading">--><!--<h3 class="uppercase">Navigation</h3>--><!--</li>--><!--HOME--><!--<li class="nav-item start" ui-sref-active="active" has-authority="ROLE_DOMAIN_ADMIN" ng-if="vm.licence.id >= 2">\n            <a href="javascript:;" ui-sref="home" class="nav-link">\n                <i class="glyphicon glyphicon-home"></i>\n                <span class="title">Home</span>\n            </a>\n        </li>--><!--MONITORING--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'dashboard\')}" has-authority="ROLE_DOMAIN_USER">\n            <a href="javascript:;" data-target="#dashboard-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="fa fa-bar-chart"></i>\n                <span class="title">Monitoring</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse in" id="dashboard-submenu" aria-expanded="true">\n                <li class="nav-item start" ui-sref-active="active">\n                    <a ui-sref="tab-objects-dashboard" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-object-group"></i>\n                        <span translate="global.menu.dashboard.objects">Objects</span>\n                    </a>\n                </li>\n                <li class="nav-item start" ui-sref-active="active" ng-if="vm.licence.id >= 3">\n                    <a ui-sref="warning-dashboard" ng-click="vm.collapseNavbar()" class="nav-link">\n                        <i class="fa fa-exclamation-triangle"></i>\n                        <span class="title" translate="global.menu.dashboard.warning-dashboard">Warnings</span>\n                    </a>\n                </li>\n                <li class="nav-item start" ui-sref-active="active" ng-if="vm.licence.id >= 3">\n                    <a ui-sref="warnings-list" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-exclamation-triangle"></i>\n                        <span translate="global.menu.dashboard.warning-list">Warnings History</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--><!--CONTROL--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'management\')}" has-authority="ROLE_DOMAIN_USER" ng-if="vm.licence.id >= 2">\n            <a href="javascript:;" data-target="#command-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="glyphicon glyphicon-globe"></i>\n                <span class="title" translate="global.menu.objectManagement.remoteControl">Control</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" id="command-submenu">\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="action-commands" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-terminal"></i>\n                        <span translate="global.menu.objectManagement.commands">Single Object</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" ng-if="vm.showMacro">\n                    <a class="nav-link" ui-sref="macros" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cube" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.macros">Macros</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="multiple-commands" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-reply-all"></i>\n                        <span translate="global.menu.objectManagement.multipleCommands">Multiple Objects</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="queues" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-list"></i>\n                        <span translate="global.menu.objectManagement.queue">Commands Queue</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="publish-message" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-commenting-o"></i>\n                        <span translate="global.menu.entities.publisMessage">Publish Message</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="view-all-command-value" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-list"></i>\n                        <span translate="global.menu.entities.viewAllCommandsValue">View All Commands Value</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--><!--SYSTEM--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'entity\')}" has-authority="ROLE_DOMAIN_USER" ng-if="vm.licence.id >= 3">\n            <a href="javascript:;" data-target="#entities-submenu" class="nav-link nav-toggle collapsed" data-toggle="collapse">\n                <i class="glyphicon glyphicon-cog"></i>\n                <span class="title" translate="global.menu.entities.main">System</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" id="entities-submenu">\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-domains" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-tags" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabDomains">Domains</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="tab-fleets" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-ship" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabFleets">Fleets</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_TECH && !ROLE_ADMIN" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="object-class" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cubes" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.objectClass">Object Class</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="object-class" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cubes" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.objectClass">Object Class</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_TECH && !ROLE_ADMIN" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="tab-object-types" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cubes" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabObjectTypes">Object Types</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-object-types" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cubes" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabObjectTypes">Object Types</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="tab-objects" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cube" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabObjects">Objects</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="object-test-setting" ng-click="vm.collapseNavbar()">\n                        <i class="glyphicon glyphicon-cog" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.objectTestSetting">Test Setting</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="object-test-result" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-list-alt" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.objectTestResult">Test Workbench</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-devices-types" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-desktop"></i>\n                        <span translate="global.menu.entities.tabDevicesTypes">Devices Types</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-devices" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-desktop"></i>\n                        <span translate="global.menu.entities.tabDevices">Devices</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-file-types" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-file-text"></i>\n                        <span translate="global.menu.entities.fileTypes">File Types</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-firmware" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-file"></i>\n                        <span translate="global.menu.entities.tabFirmware">Firmwares</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="dashboard-management" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-line-chart"></i>\n                        <span translate="global.menu.entities.dashboard-management">Dashboard</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--><!--ALERTING--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'alerting\')}" has-authority="ROLE_DOMAIN_USER" ng-if="vm.licence.id >= 3">\n            <a href="javascript:;" data-target="#alerting-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="fa fa-bullhorn"></i>\n                <span class="title">Alerting</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" id="alerting-submenu">\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="warning-category" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.warningCategory">Categories</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH">\n                    <a class="nav-link" ui-sref="warning" ng-click="vm.collapseNavbar()">\n                        <i class="glyphicon glyphicon-cog" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.alertRules">Rules</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="!ROLE_TECH">\n                    <a class="nav-link" ui-sref="alert-rules" ng-click="vm.collapseNavbar()">\n                        <i class="glyphicon glyphicon-cog" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.alertRules">Rules</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="my-channel" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-envelope-o" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.myChannel">Channels</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--><!--UPDATES--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'update_management\')}" has-authority="ROLE_DOMAIN_USER" ng-if="vm.licence.id >= 3">\n            <a href="javascript:;" data-target="#management-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="glyphicon glyphicon-open"></i>\n                <span class="title" translate="global.menu.entities.tabUpdateManagement">Updates</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" id="management-submenu">\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="custom-update" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-cloud-upload" aria-hidden="true"></i>\n                        <span translate="global.menu.objectManagement.updates">Update</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="tab-schedule" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-calendar"></i>\n                        <span translate="global.menu.entities.tabSchedule">History</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-device-releases" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-upload" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabDeviceReleases">Bundles</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-files" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-file"></i>\n                        <span translate="global.menu.entities.tabFiles">Files</span>\n                    </a>\n                </li>\n\n                &lt;!&ndash;                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">&ndash;&gt;\n                &lt;!&ndash;                    <a class="nav-link" ui-sref="scripts-releases" ng-click="vm.collapseNavbar()">&ndash;&gt;\n                &lt;!&ndash;                        <i class="fa fa-file"></i>&ndash;&gt;\n                &lt;!&ndash;                        <span translate="global.menu.entities.tabFiles">Script Releases</span>&ndash;&gt;\n                &lt;!&ndash;                    </a>&ndash;&gt;\n                &lt;!&ndash;                </li>&ndash;&gt;\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-update-scripts" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-list-alt" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabUpdateScripts">Update Scripts</span>\n                    </a>\n                </li>\n\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="tab-onEvent-scripts" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-file" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.tabOnEventScripts">OnEvent Scripts</span>\n                    </a>\n                </li>\n\n            </ul>\n        </li>--><!--KIOSK--><!--<li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_USER && !ROLE_ADMIN " ng-if="vm.licence.id === 4">\n            <a href="javascript:;" ui-sref="kiosks" class="nav-link">\n                <i class="fa fa-tachometer"></i>\n                <span translate="global.menu.entities.kiosks">Kiosks</span>\n            </a>\n        </li>--><!--KIOSK ADMIN--><!--<li class="nav-item" ng-class="{active: vm.$state.includes(\'kiosk\')}" has-authority="ROLE_ADMIN">\n            <a href="javascript:;" data-target="#kiosk-sub-menu" id="kiosk-menu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="fa fa-tachometer"></i>\n                <span class="title" translate="global.menu.entities.kiosks">Kiosks</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" aria-expanded="false" id="kiosk-sub-menu">\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="kiosks" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-tachometer" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.kiosks">Kiosks</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active">\n                    <a class="nav-link" ui-sref="kiosks-dashboard({showCreation:false})" ng-click="vm.collapseNavbar()">\n                        <i class="fa fa-line-chart" aria-hidden="true"></i>\n                        <span translate="global.menu.entities.dashboard-management">Dashboard</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--><!--ADMINISTRATION--><!-- <li class="nav-item" ng-class="{active: vm.$state.includes(\'admin\')}" has-authority="ROLE_DOMAIN_ADMIN" ng-if="vm.licence.id >= 2">\n            <a href="javascript:;" data-target="#admin-sub-menu" id="admin-menu" data-toggle="collapse" class="nav-link nav-toggle collapsed">\n                <i class="glyphicon glyphicon-user"></i>\n                <span class="title" translate="global.menu.admin.main">Administration</span>\n                <span class="arrow"></span>\n            </a>\n            <ul class="sub-menu collapse" aria-expanded="false" id="admin-sub-menu">\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="user-management" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-user"></span>&nbsp;\n                        <span translate="global.menu.admin.userManagement">User Admin</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_ADMIN && !ROLE_TECH || ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="team-management" ng-click="vm.collapseNavbar()">\n                        <span class="fa fa-users"></span>&nbsp;\n                        <span translate="global.menu.admin.teamManagement">My Team</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="licences-code" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-list"></span>&nbsp;\n                        <span translate="global.menu.admin.licences">Licences</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_ADMIN && !ROLE_ADMIN" ng-if="vm.showLicences" ng-if="vm.licence.id === 4">\n                    <a class="nav-link" ui-sref="recap-objects" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-list"></span>&nbsp;\n                        <span translate="global.menu.admin.licences">Licences</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_ADMIN && !ROLE_TECH || ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="user-profile" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-wrench"></span>&nbsp;\n                        <span translate="global.menu.admin.menuProfile">User Profile</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-eye-open"></span>&nbsp;\n                        <span translate="global.menu.admin.tracker">User tracker</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                        <span translate="global.menu.admin.metrics">Metrics</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                        <span translate="global.menu.admin.health">Health</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                        <span translate="global.menu.admin.configuration">Configuration</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="audits" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                        <span translate="global.menu.admin.audits">Audits</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="audit-log" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-folder-open"></span>&nbsp;\n                        <span translate="global.menu.admin.auditLog">Journal CRUD Log</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="logs" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                        <span translate="global.menu.admin.logs">Logs</span>\n                    </a>\n                </li>\n                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">\n                    <a class="nav-link" ui-sref="docs" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-book"></span>&nbsp;\n                        <span translate="global.menu.admin.apidocs">API</span>\n                    </a>\n                </li>\n            </ul>\n        </li>--></ul><!-- nav --></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<!-- navbar right --><ul class="nav navbar-nav pull-right"><li><a ng-if="vm.expirationDate" ng-click="vm.expirationDateCheck=!vm.expirationDateCheck" ng-class="{\'nav-active\' : !vm.expirationDateCheck}"><span class="fa fa-clock-o hithere"></span></a></li><li><a ng-if="vm.isMaintenance && vm.maintUserCheck" ng-click="vm.togglePopup()" ng-class="{\'nav-active\' : vm.popupToggled}"><span class="fa fa-warning"></span></a></li><li><a ui-sref="context" ng-if="vm.domains.length > 1"><span class="fa fa-refresh"></span>&nbsp; <span class="navtext-mobile">{{vm.domainName}}</span> </a><a ng-if="vm.domains.length < 2">{{vm.domainName}}</a></li><li ng-switch="vm.isAuthenticated()" ng-class="{active: vm.$state.includes(\'account\')}" class="dropdown dropdown-user" uib-dropdown><a href="#" class="dropdown-toggle clear" uib-dropdown-toggle aria-haspopup="true" aria-expanded="false"><i ng-class="vm.impersonated != null ? \'fa fa-user-secret\' : \'fa fa-user\'"></i> <span class="navtext-mobile username">{{vm.username}} </span><i class="fa fa-angle-down"></i></a><ul class="dropdown-menu animated customFadeInDown w"><li ng-if="vm.impersonated != null" ng-switch-when="true"><a ng-click="vm.restoreUser(); vm.collapseNavbar()"><span class="fa fa-user"></span>&nbsp; <span translate="global.menu.account.restore">Restore</span></a></li><li ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cog"></span>&nbsp; <span translate="global.menu.account.settings">Settings</span></a></li><li ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span> <span translate="global.menu.account.password">Password</span></a></li><li ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span translate="global.menu.account.sessions">Sessions</span></a></li><li ng-switch-when="true"><a ui-sref="general-settings({id:vm.domainId})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-envelope"></span>&nbsp; <span translate="global.menu.account.generalSettings">General Settings</span></a></li><li ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li><li ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></li></ul></li></ul><div class="maintenance-popup"><div ng-if="vm.isMaintenance && !vm.maintUserCheck || vm.popupToggled" role="alert" class="alert ng-scope ng-isolate-scope alert-warning alert-dismissible"><button type="button" class="close close-alert-btn" data-dismiss="alert" aria-label="Close" ng-click="vm.closeMaintenanceMessage()"><span aria-hidden="true">&times;</span></button><div><h4><span class="fa fa-warning"></span> Scheduled Maintenance</h4><h5><span class="fa fa-calendar"></span> {{vm.maintenance.releaseDate | date : \'dd MMM yyyy hh:mm a\'}}</h5><div class="maintenance-message"><pre>{{vm.maintenance.description}}</pre></div></div></div><div ng-if="vm.expirationDate && !vm.expirationDateCheck" role="alert" class="alert ng-scope ng-isolate-scope alert-warning alert-dismissible"><button type="button" class="close close-alert-btn" data-dismiss="alert" aria-label="Close" ng-click="vm.expirationDateCheck=!vm.expirationDateCheck"><span aria-hidden="true">&times;</span></button><div><h4><span class="fa fa-clock-o"></span> License Expiration Date</h4><h5><span class="fa fa-calendar"></span> {{vm.expirationDate | date : \'dd MMM yyyy\'}}</h5><div class="maintenance-message">Your {{vm.licence.name}} license will expire {{vm.expireDays}}</div></div></div></div><!-- / navbar right -->');
$templateCache.put('app/management/action-commands/action-commands.html','<div class="app-content-body commands-management-page" ng-init="vm.init()"><jhi-alert></jhi-alert><div class="full-page-loader-container" ng-if="!vm.pageReady"><div class="loader"></div></div><div ng-if="vm.pageReady"><div class="command-sidebar-content"></div><div class="command-sidebar-aside-wrapper"><!--Commands--><div class="command-sidebar-content" ng-class="{\'open\': vm.commAside && vm.commandStash.length != 0}"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><!--Open Aside button--> <span ng-show="vm.commandStash.length > 0 && !vm.commAside"><button class="btn btn-primary aside-open-button" ng-click="vm.toggleCommAside()" ng-disabled="!vm.commandToSend || !vm.isQueue"><span class="glyphicon glyphicon-chevron-left"></span></button> </span><!--/ Open Aside button--><div class="row top-buttons"><!--Select for objects--><div class="col-xs-9 col-sm-5 col-md-4"><div class="form-group"><label class="control-label" translate="jotApp.actionCommands.home.device">Device</label><ui-select on-select="vm.selectObject($item)" ng-model="vm.obj" theme="bootstrap"><ui-select-match placeholder="Select or search an object.."><i ng-if="$select.selected.objectType" class="fa fa-circle" style="font-size: 10px; margin-right: 8px; vertical-align: middle;" ng-style="{\'color\': $select.selected.objectOnline ? \'#5cb85c\' : \'#d9534f\'}"></i> <span style="vertical-align: middle;">{{$select.selected.objectName}} ({{$select.selected.objectUniqueCode}})</span></ui-select-match><ui-select-choices repeat="item in vm.tabObjects | propsFilter: {objectName: $select.search, objectUniqueCode: $select.search}" percent="90" when-scrolled="vm.loadPage(vm.page + 1)" refresh="vm.search($select.search)" refresh-delay="800"><i ng-if="item.objectType" class="fa fa-circle" style="font-size: 10px; margin-right: 8px; vertical-align: middle;" ng-style="{\'color\': item.objectOnline ? \'#5cb85c\' : \'#d9534f\'}"></i><div ng-bind-html="item.objectName | highlight: $select.search" style="display: inline; vertical-align: middle;"></div><small ng-bind-html="item.objectUniqueCode | highlight: $select.search" style="vertical-align: middle;"></small></ui-select-choices></ui-select></div></div><!--/ Select for objects--><!-- Button opens modal commands-view (hidden for Greengrass) --> <button class="btn btn-primary yours-commands-button top-action-buttons-wrapper" ng-click="vm.commandsView()" ng-if="vm.obj != undefined && vm.licence.id === 4 && !vm.isGreengrassObject"><span translate="jotApp.actionCommands.home.viewValues">View Commands Values</span></button><!-- / Button opens modal commands-view--></div><!-- Commands content --><div><!--Macros--> <label class="control-label" ng-if="vm.macro.length > 0">Macros</label><div class="row"><div class="col-xs-12"><div class="command-button-wrapper"><div class="command-button" ng-repeat="macro in vm.macro" ng-if="vm.obj != undefined"><div class="form-group schema-form-submit"><input type="button" class="btn btn-primary" value="{{macro.alias}}" ng-click="storeChangesMacro(macro)" ng-disabled="!vm.isQueue"></div></div></div></div></div><!--/Macros--></div><!--Button Commands--> <label class="control-label" ng-if="vm.formSchemas.buttons.length > 0 || vm.formSchemas.forms.length > 0">Commands</label><div class="row"><div class="col-xs-12"><div class="command-button-wrapper"><div class="command-button" ng-repeat="buttonCommand in vm.formSchemas.buttons"><div class="form-group schema-form-submit"><input type="button" class="btn btn-primary" value="{{buttonCommand.command}}" ng-click="storeChanges(buttonCommand.command)" ng-disabled="!vm.isQueue"></div></div></div></div></div><!--/ Button Commands--><!--Form Commands--><div class="row"><div ng-repeat="formCommand in vm.formSchemas.forms" class="col-xs-12 col-md-6 col-lg-4 form-component-wrapper" ng-class="{\'single-col\': formCommand.weight == 1, \'col-md-12 col-lg-8 two-col\': formCommand.weight == 2, \'col-md-12 col-lg-12 three-col\': formCommand.weight == 3}"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption">{{formCommand.command | beautifyCommand }}</div><div class="actions"><span title="{{formCommand.schema.scheduleTime | date:\'dd/MM/yy HH:mm\'}}" class="icon pull-right" ng-if="formCommand.schema.isScheduled"><i class="fa fa-clock-o"></i> </span><span ng-if="formCommand.schema.sending" title="pending value" class="icon" ng-click="formCommand.showPending = !formCommand.showPending"><i class="fa fa-paper-plane"></i></span></div></div><div class="portlet-body"><div class="form-group schema-form-submit" ng-if="!formCommand.showPending"><form class="command-form" ng-submit="storeChanges(formCommand)" name="{{formCommand.command}}"><div sf-model="formCommand" sf-schema="formCommand.schema" sf-form="formCommand.form"></div><div class="action-buttons"><input id="{{formCommand.command}}" type="submit" class="btn btn-primary pull-right" value="Add To Queue" ng-disabled="!vm.isQueue"> <button type="button" class="btn btn-default pull-right" ng-click="vm.removeChanges(formCommand)" ng-disabled="!vm.isQueue" translate="jotApp.actionCommands.cancel">Cancel</button></div></form></div><span ng-if="formCommand.showPending" class="command-form"><span ng-repeat-start="arg in formCommand.schema.properties" ng-if="formCommand.schema.sending"></span><div class="form-group" ng-if="arg.type !== \'array\'"><div class="pending-label">{{arg.title}}:</div><div class="pending-value">{{arg.format == \'time\'? (arg.pending | date:\'HH:mm\') : (arg.format == \'date\'? (arg.pending | date:\'dd/MM/yy\') : arg.pending) }}</div></div><div ng-if="arg.type === \'array\'"><div ng-repeat="pendObj in arg.pending" class="pending-array-components-wrapper" ng-class="{\'first\': $first}"><div class="form-group" ng-repeat="(key, value) in pendObj"><div class="pending-label">{{key}}:</div><div class="pending-value">{{value}}</div></div></div></div><span ng-repeat-end></span><div class="action-buttons"><button type="button" class="btn btn-danger pull-right" ng-if="formCommand.schema.sending" ng-click="vm.deleteCommand(formCommand.schema.idCommand)" translate="jotApp.actionCommands.delete">Delete</button> <button type="button" class="btn btn-default pull-right" ng-if="formCommand.schema.sending" ng-click="formCommand.showPending = !formCommand.showPending" translate="jotApp.actionCommands.back">Back</button></div></span></div><div class="clearfix"></div></div></div></div><!--/ Form Commands--><!-- / Commands content --></div></div></div></div></div></div></div><!--/ Commands--><!--Aside--><div class="command-sidebar-aside thin-scroll" ng-class="{\'open\': vm.commAside && vm.commandStash.length != 0}"><!--Close Aside button--> <span ng-if="vm.commandStash.length > 0 && vm.commAside"><button class="btn btn-primary aside-close-button" ng-click="vm.toggleCommAside()" ng-disabled="!vm.commandToSend || !vm.isQueue"><span class="glyphicon glyphicon-chevron-right"></span></button> </span><!--/ Close Aside button--><div class="form"><div name="editForm"><form name="editForm" role="form" novalidate ng-submit="" show-validation><div class="form-body"><div class="row"><br><div class="col-xs-12"><!--Name input for macro or queue--><div class="form-group" ng-show="vm.isQueue"><label class="control-label" translate="jotApp.actionCommands.name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.tabActionsQueue.alias" required ng-maxlength="250"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><!--/ Name input for macro or queue--><!--Commands Queue--><div class="card-wrapper commands-queue-wrapper thin-scroll" ng-show="vm.isQueue"><div class="card-element" ng-repeat="commands in vm.commandStash track by $index"><div class="command-sidebar-aside-icons"><button ng-click="vm.remove($index)" class="btn btn-primary" title="Delete Command"><i class="remove-icon fa fa-times"></i></button> <button ng-show="vm.commandStash.length > 1" ng-click="vm.moveUp($index)" class="btn btn-primary" title="Move Command Up" ng-disabled="$index == 0"><i class="glyphicon glyphicon-arrow-up"></i></button> <button ng-show="vm.commandStash.length > 1" ng-click="vm.moveDown($index)" class="btn btn-primary" title="Move Command Down" ng-disabled="$index == vm.commandStash.length - 1"><i class="glyphicon glyphicon-arrow-down"></i></button></div><div class="label-wrapper"><label translate="jotApp.actionCommands.commandQueue.actionCommand">Action Command</label></div><div class="elem-body">{{commands.actionCommand}}</div><div class="argument-wrapper" ng-if="commands.arguments != undefined && (commands.arguments | json) != ({} | json)"><div class="label-wrapper"><label translate="jotApp.actionCommands.commandQueue.argumentsCommand">Arguments Command</label></div><div class="argument-body" ng-repeat="(key, value) in commands.arguments"><label>{{key}}</label>: {{value}}</div></div></div></div><!--/ Commands Queue--><!--Message if object is offline--><div ng-if="vm.obj != undefined && !vm.obj.objectOnline && vm.isQueue" style="background-color: #fcf8e3; border: 1px solid #f0ad4e; padding: 10px 12px; border-radius: 4px; margin-top: 15px; margin-bottom: 15px; font-size: 13px; line-height: 1.4;"><i class="fa fa-exclamation-triangle" style="color: #f0ad4e; margin-right: 6px;"></i> <strong style="font-size: 13px;">WARNING - Object is offline</strong><div style="margin: 4px 0 0 0;">As the object is currently offline, commands and macros will run as soon as this object comes back online.</div></div><!--/ Message if object is offline--><!--buttons for step 1/commands queue --><div class="form-actions command-sidebar-aside-buttons" ng-show="vm.isQueue"><button type="button" class="btn btn-primary" ng-click="vm.toggleQueue()" ng-disabled="editForm.$invalid || isSaving"><span class="glyphicon glyphicon-arrow-right"></span> <span translate="jotApp.actionCommands.next">Next</span></button> <button ng-click="vm.saveQueueOrMacro(\'saveMacro\')" type="submit" ng-disabled="editForm.$invalid || isSaving || (vm.isGreengrassObject && vm.clickMacro)" class="btn btn-primary" title="{{vm.isGreengrassObject && vm.clickMacro ? \'Cannot save a macro that contains another macro\' : \'\'}}"><span translate="jotApp.actionCommands.saveMacro">Save As Macro</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span translate="entity.action.reset">Reset</span></button></div><!--/ buttons for step 1/commands queue --><!--step 2 triggered by "next" button--><div ng-hide="vm.isQueue"><div class="schedule-wrapper" ng-class="vm.showSchedule == undefined ? \'centered\' : \'\'"><!--Message if there are no commands scheduled--><div ng-if="vm.showSchedule == undefined" class="alert-msg"><span translate="jotApp.actionCommands.commandQueue.qNotScheduled">Queue not scheduled, if executed it will be launched immediately</span></div><!--/ Message if there are no commands scheduled--><!--Schedule--><div ng-if="vm.showSchedule != undefined"><div class="schedule-list">{{vm.showSchedule}}</div></div><!--/ Schedule--><!--Edit schedule button--> <button type="button" class="btn btn-primary edit-btn btn-sm" ng-click="vm.scheduleCommands()" ng-if="vm.showSchedule != undefined" title="Edit Schedule "><span>Edit</span></button><!--/ Edit schedule button--></div><!--Buttons for step 2--><div class="form-actions command-sidebar-aside-buttons"><button type="button" class="btn btn-primary" ng-click="vm.toggleQueue()"><span class="glyphicon glyphicon-arrow-left"></span> <span translate="jotApp.actionCommands.back">Back</span></button><!--button opens schedule modal (only for non-Greengrass)--> <button type="button" class="btn btn-primary" ng-click="vm.scheduleCommands()" ng-if="vm.showSchedule == undefined"><span translate="jotApp.actionCommands.commandQueue.scheduleQueue">Schedule</span></button><!--button opens schedule modal--> <button ng-click="vm.saveQueueOrMacro(\'saveQueue\')" type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span translate="jotApp.actionCommands.commandQueue.execute">Execute</span></button></div><!--/ Buttons for step 2--></div><!--/ step 2 triggered by "next" button --></div></div></div></form></div></div></div><!--/ Aside--></div></div></div>');
$templateCache.put('app/management/action-commands/commands-detail.html','<div class="app-content-body commands-management-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><h1 class="page-title"><button type="submit" ui-sref="action-commands" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="jotApp.actionCommands.commandsDetail.title">Commands Detail</span></h1></div></div><table id="tableToExport"><thead><tr ng-show="false"><th><span>Commands</span></th><th><span>Description</span></th></tr></thead><tbody><tr ng-repeat="command in vm.commands track by $index" ng-show="false"><td>{{command.actionCommand}}</td><td>{{command.description || \'empty\'}}</td></tr></tbody></table><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>{{vm.objectUniqueCode}} - Commands</span></div><div class="actions"><div class="btn-group"><div class="dropdown-toggle object-icon-action no-outline no-bg btn btn-primary" data-toggle="dropdown"><i class="glyphicon glyphicon-save-file">&nbsp;</i> <span translate="jotApp.actionCommands.commandsDetail.export">Export Table</span></div><ul class="dropdown-menu" role="menu"><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS</a></li></ul></div></div></div><div class="portlet light filter-portlet bordered"><div class="row"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableView"><thead><tr><th><span>Commands</span></th><th><span>Description</span></th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="command in vm.commands track by $index"><td>{{command.actionCommand}}</td><td ng-click="vm.enableEditor($index, 0)"><div ng-hide="vm.editorEnabled[$index]">{{command.description || \'empty\'}}</div><div ng-show="vm.editorEnabled[$index]" class="col-md-12 col-xs-12"><input type="text" class="col-md-12 col-xs-12 input-group" value="{{command.description}}" ng-model="vm.updateDescription[$index]"></div></td><td class="text-center"><button class="btn btn-primary btn-sm" ng-if="!vm.editorEnabled[$index]" ng-click="vm.enableEditor($index, 1)"><i class="fa fa-pencil"></i> <span translate="entity.action.edit">Edit</span></button> <button type="submit" ng-if="vm.editorEnabled[$index]" class="btn btn-sm btn-primary" ng-click="vm.saveUpdate($index)"><i class="fa fa-check"></i></button> <button type="button" ng-if="vm.editorEnabled[$index]" class="btn btn-sm btn-default" ng-click="vm.enableEditor($index, 2)"><i class="fa fa-times"></i></button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/management/action-commands/commands-view.html','<form name="scheduleForm" ng-init="vm.init()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.actionCommands.commandsDetail.title">Commands View</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><div class="btn-group"><div class="dropdown-toggle object-icon-action no-outline no-bg btn btn-primary" data-toggle="dropdown"><i class="glyphicon glyphicon-save-file">&nbsp;</i> <span translate="jotApp.actionCommands.commandsDetail.export">Export Table</span></div><ul class="dropdown-menu" role="menu"><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'csv\')"><i class="fa fa-file-zip-o"></i> CSV</a></li></ul></div></div></div><div class="portlet-body"><div class="table-scrollable commands-view-table thin-scroll"><table class="table table-striped table-bordered table-hover order-column dataTable no-footer action-column"><thead><tr><th><span translate="jotApp.actionCommands.detail.command">Command</span></th><th><span translate="jotApp.actionCommands.detail.metricName">Metrics Name</span></th><th><span translate="jotApp.actionCommands.detail.metricValue">Metrics Value</span></th><th><span translate="">{{ "jotApp.actionCommands.detail.description" | translate }}</span></th><th has-authority="ROLE_ADMIN"><span translate="jotApp.actionCommands.detail.actions">Actions</span></th></tr></thead><tbody><tr ng-repeat="command in vm.table"><td>{{command.command.name}}</td><td>{{command.metricName}}</td><td>{{command.metricValue}}</td><td><div ng-if="command.isEdit !== true">{{command.description}}</div><div ng-if="command.isEdit"><input type="text" class="input-group" ng-model="command.description"></div></td><td class="text-center" has-authority="ROLE_ADMIN"><span ng-if="command.isEdit && command.command.name"><button type="submit" class="btn btn-sm btn-primary" ng-click="vm.saveUpdate(command)"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-sm btn-default" ng-click="vm.disableEditor(command)"><i class="fa fa-times"></i></button> </span><span ng-if="!command.isEdit && command.command.name"><button class="btn btn-primary btn-sm" ng-click="vm.enableEditor(command)" title="Edit Description"><i class="fa fa-pencil"></i></button></span></td></tr></tbody></table><table class="table table-striped table-bordered table-hover order-column dataTable no-footer action-column" id="tableToExport"><thead><tr ng-show="false"><th><span translate="jotApp.actionCommands.detail.command">Command</span></th><th><span translate="jotApp.actionCommands.detail.metricName">Metrics Name</span></th><th><span translate="jotApp.actionCommands.detail.metricValue">Metrics Value</span></th></tr></thead><tbody><tr ng-repeat="command in vm.tableToExport" ng-show="false"><td>{{command.command.name}}</td><td>{{command.metricName}}</td><td>{{command.metricValue}}</td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/management/action-commands/schedule-commands.html','<form name="scheduleForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.actionCommands.scheduleCommand.title">Schedule Command</h4></div><div class="modal-body"><ul class="nav nav-tabs nav-tabs-cards" role="tablist"><li ng-class="vm.scheduleDate.single ? \'nav-item\' : \'nav-item active\'"><a class="nav-link" data-toggle="tab" data-target="#card-tab1" role="tab" aria-controls="card-tab1" aria-selected="true" ng-click="vm.check(false)" translate="jotApp.actionCommands.scheduleCommand.weekly">Weekly</a></li><li ng-class="vm.scheduleDate.single ? \'nav-item active\' : \'nav-item\'"><a class="nav-link" data-toggle="tab" data-target="#card-tab2" role="tab" aria-controls="card-tab2" aria-selected="false" ng-click="vm.check(true)" translate="jotApp.actionCommands.scheduleCommand.repeat">Repeat</a></li></ul><div class="tab-content"><div ng-class="vm.scheduleDate.single ? \'tab-pane p-4 fade\' : \'tab-pane p-4 fade active in\'" ng-show="!vm.scheduleDate.single" id="card-tab1" role="tabpanel"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer" id="tableToExport"><thead><tr><th translate="jotApp.actionCommands.scheduleCommand.repeat">Repeat</th><th translate="jotApp.actionCommands.scheduleCommand.days">Days</th><th translate="jotApp.actionCommands.scheduleCommand.hours">Hour</th></tr></thead><tbody><tr ng-repeat="day in vm.multipleSchedule track by $index"><td><input type="checkbox" ng-model="day.includeDay"></td><td>{{day.day}}</td><td><input type="text" placeholder="HH:mm" timepicker-options="vm.timepickerOptions" datepicker-options="vm.datepickerOptions" enable-date="false" class="form-control" datetime-picker="HH:mm" ng-model="day.selectedTime" name="scheduleTime" ng-click="vm.openTimeCal($index)" is-open="vm.repeatStatus[$index]" autocomplete="off"></td></tr></tbody></table></div><div ng-class="vm.scheduleDate.single ? \'tab-pane p-4 fade active in\' : \'tab-pane p-4 fade\'" ng-show="vm.scheduleDate.single" id="card-tab2" role="tabpanel"><div class="row"><div class="col-md-12 col-xs-12 schedule-btn-wrapper top-action-buttons-wrapper"><div class="input-group"><input id="scheduleUp" type="text" placeholder="Set schedule time if any" timepicker-options="vm.timepickerOptions" datepicker-options="vm.datepickerOptions" class="form-control" datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.scheduleDate.scheduleDateTime" name="scheduleDatetime" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen" autocomplete="off"> <span class="input-group-btn" ng-click="vm.openUpCalendar($event)" is-open="vm.scheduleUpDatetime.isOpen" role="button" tabindex="0"><button type="button" class="btn btn-default"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row"><div class="col-md-12 col-xs-12 mt-checkbox-inline form-field-no-label" ng-if="vm.scheduleDate.scheduleDateTime" style="margin-left: 17px"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.scheduleDate.cron"> <span></span><div>Repeat <span ng-if="vm.scheduleDate.cron === true">every <input style="width: 73px;height: 27px;" type="number" ng-model="vm.scheduleDate.repeatNumber" min="1" max="30"> <select style="width: 103px;height: 27px;" ng-model="vm.scheduleDate.repeatTime"><option label="HOURS" value="HOURS">HOURS</option><option label="DAYS" value="DAYS">DAYS</option></select></span></div></label></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" ng-disabled="scheduleForm.$invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/management/commands/selected-email.html','<form name="selectedEmailForm"><jhi-alert-error></jhi-alert-error><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.actionCommands.modalEmail.title">Set email for report</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 col-xs-12"><label class="control-label" translate="jotApp.actionCommands.modalEmail.infoPrincipal">infoPrincipal</label> <input type="text" class="form-control" ng-model="vm.email.principal" placeholder="Insert name.." required></div></div><div class="row"><div class="col-md-12 col-xs-12"><br><label class="control-label" translate="jotApp.actionCommands.modalEmail.infoSecond">infoSecond</label><br><label class="control-label" translate="jotApp.actionCommands.modalEmail.infoPoint">infoPoint</label> <textarea rows="3" cols="100" ng-model="vm.email.cc" style="resize: none; width: 100%;" placeholder="Insert CC emails | test@test.com; test@abc.it"></textarea></div></div></div><div class="modal-footer"><button ng-click="vm.save()" ng-disabled="selectedEmailForm.$invalid" class="btn btn-primary"><span class="fa fa-envelope-o"></span>&nbsp;<span translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/management/commands/showPdf.html','<form name="selectedEmailForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="container-pdf"><embed class="center-pdf" ng-src="{{vm.content}}"></div></form>');
$templateCache.put('app/management/commands/view-all-commands-value.html','<div class="app-content-body custom-updates-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.applyFilter()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'disabled\': vm.tableIsLoading === true}"><label for="field_fleet">Fleet</label><ui-select id="field_fleet" on-select="vm.selectedFleet($item)" ng-model="vm.fleet" theme="bootstrap"><ui-select-match ng-click="vm.resetFilter()" placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-4" ng-if="vm.tabObjectType.length == 0"><label for="field_objectTypeError">Object Type</label><div id="field_objectTypeError"><span>No associated Object Type</span></div></div><div class="col-md-4" ng-if="vm.tabObjectType.length > 0"><div class="form-group" ng-if="vm.fleet" ng-class="{\'disabled\': vm.tableIsLoading === true}"><label for="field_objectType">Object Type</label><ui-select id="field_objectType" on-select="vm.selectObjectType($item, 1,true)" ng-model="vm.objType" theme="bootstrap"><ui-select-match ng-click="vm.deselectObjTy($item)" placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectType | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-3"><div class="form-group margin-fix"><div class="dropdown-toggle btn btn-primary" data-toggle="dropdown" ng-disabled="vm.tableIsLoading === true || !vm.fleet || !vm.objType" ng-class="{\'disabled\': vm.tableIsLoading === true || !vm.fleet || !vm.objType}"><i class="fa fa-share-square-o">&nbsp;</i> <span translate="jotApp.actionCommands.sendReport">Send Report</span> <i class="fa fa-angle-down">&nbsp;</i></div><ul class="dropdown-menu" role="menu"><li><a href="" ng-click="vm.exportTable(\'pdf\')"><i class="fa fa-file-pdf-o"></i> PDF</a></li><li class="divider"></li><li><a href="" ng-click="vm.exportTable(\'excel\')"><i class="fa fa-file-excel-o"></i> XLS</a></li></ul><i class="fa fa-question-circle" uib-tooltip="Create PDF or CSV reports and send them via mail" tooltip-placement="bottom"></i></div></div></div></div></form></div></div></div></div><div class="row" ng-if="vm.message.show"><div class="col-xs-12"><b><span>{{vm.message.text}}</span></b></div></div><div class="row" ng-if="!vm.message.show"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Reports Download History</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div></div><div class="table-scrollable" ng-class="{\'is-loading\': vm.tableIsLoading === true}"><div class="loader-background-mask" ng-show="vm.tableIsLoading === true"><div class="loader"></div><div class="loader-message"><h4 translate="entity.detail.loading"></h4></div></div><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th>File Name</th><th>Fleet Name</th><th>Type Name</th><th>Request By</th><th>Request Date</th><th>Elapsed Time (hh:mm:ss)</th><th translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="row in vm.allDownloadReport track by $index"><td>{{row.fileName}}</td><td>{{row.fleetName}}</td><td>{{row.typeName}}</td><td>{{row.requestBy}}</td><td>{{row.requestDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{row.elapsedTime}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><span class="object-icon-action no-outline" title="Download" ng-click="vm.downloadCommandsReport(row)"><i class="fa fa-download"></i> </span><span class="object-icon-action no-outline" title="View" ng-click="vm.openFilePdf(row)" ng-if="row.fileName.substr(id.length - 4) === \'.pdf\'"><i class="fa fa-eye"></i></span></div></td></tr></tbody></table><div class="row" style="margin-top: 10px"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.currentPage" ng-change="vm.transition(true)"></uib-pagination></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/management/custom-update/custom-update-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.action.addCommand">Add commands</h4></div><div class="modal-body"><div class="row" style="margin-left: 0px"><div class="col-md-6 col-xs-12" style="padding: 0; margin: 11px;"><div class="form-group"><label for="field_script">Scripts</label><ui-select id="field_script" ng-model="vm.script" theme="bootstrap" ng-change="vm.writeCommandInTextbox()"><ui-select-match allow-clear="true" placeholder="Select or search a script">{{$select.selected.scriptName}}</ui-select-match><ui-select-choices repeat="item in vm.scripts | filter: {scriptName: $select.search}"><div ng-bind-html="item.scriptName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><label for="field_customCommand" style="margin: 11px" has-authority="ROLE_ADMIN">Custom Commands</label><div ui-ace="{mode: \'sh\', rendererOptions: { fontSize: 14 }}" ng-model="vm.newCommand" id="field_customCommand" style="width: 846px;    height: 280px;    resize: none;    padding: 8px;    margin: 11px;" has-authority="ROLE_ADMIN" ng-change="vm.resetScriptBox()"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/management/custom-update/custom-update-tags-dialog.html','<jhi-alert-error></jhi-alert-error><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.action.addTag">Add Tag</h4></div><div class="modal-body"><div class="alert alert-info"><strong>Info:</strong> Updating {{vm.numObjects + (vm.numObjects > 1 ? " objects" : " object")}}</div><div class="col-xs-12"><label class="mt-checkbox mt-checkbox-outline aside-right" has-authority="ROLE_ADMIN"><input type="checkbox" ng-model="vm.forced"><span></span>Forced</label> <label class="mt-checkbox mt-checkbox-outline aside-right"><input type="checkbox" ng-model="vm.firmware"><span></span>Update Firmware</label> <label class="mt-checkbox mt-checkbox-outline aside-right"><input type="checkbox" ng-model="vm.schedule"><span></span>Schedule</label></div><div class="form-group"><div class="input-group" ng-if="vm.schedule"><label for="field_date" style="margin-bottom: 11px" has-authority="ROLE_ADMIN">Schedule Time</label> <input type="text" id="start" class="form-control" ng-click="vm.picker=true" datetime-picker="dd/MM/yyyy HH:mm" ng-model="vm.date" is-open="vm.picker" name="date" id="field_date" required><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" translate="entity.validation.required">This field is required.</p></div></div><label for="field_tag" style="margin-bottom: 11px" has-authority="ROLE_ADMIN">Description Tag</label> <input type="text" class="form-control" name="tag" id="field_tag" ng-model="vm.tag" required ng-maxlength="50"><div ng-show="editForm.tag.$invalid"><p class="help-block" ng-show="editForm.tag.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tag.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/management/custom-update/custom-update.html','<div class="app-content-body custom-updates-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form ng-submit="vm.applyFilter()" class="horizontal-form"><div class="form-body"><div class="row"><div class="col-md-4"><div class="form-group"><label for="field_fleet">Fleet</label><ui-select id="field_fleet" on-select="vm.selectedFleet($item, 1,true)" ng-model="vm.fleet" theme="bootstrap"><ui-select-match ng-click="vm.fleet=null;vm.charToSearch = \'\';vm.onlyToUpdate = false;vm.onlyOnline = false;" placeholder="Select or search a fleet..">{{$select.selected.fleetName}}</ui-select-match><ui-select-choices repeat="item in vm.tabFleets | filter: {fleetName: $select.search}"><div ng-bind-html="item.fleetName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group" ng-if="vm.fleet"><label for="field_objectType">Object Type</label><ui-select id="field_objectType" on-select="vm.selectObjectType($item, 1,true)" ng-model="vm.objType" theme="bootstrap"><ui-select-match ng-click="vm.deselectObjTy($item)" placeholder="Select or search an object type...">{{$select.selected.objectTypeName}}</ui-select-match><ui-select-choices repeat="item in vm.tabObjectType | filter: {objectTypeName: $select.search}"><div ng-bind-html="item.objectTypeName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group" ng-if="vm.fleet"><div class="mt-checkbox-inline"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.onlyToUpdate" ng-change="vm.search()"><span></span> Only To Update</label> <label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.onlyOnline" ng-change="vm.search()"><span></span>Only OnLine</label></div></div></div></div></div></form></div></div></div></div><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions"><button class="btn btn-primary" ng-click="vm.openModalCommand()" ng-if="vm.tabObjectsRow.length>0"><i class="fa fa-plus"></i> <span translate="entity.action.addCommand">Add Command</span></button> <button class="btn btn-primary" ng-click="vm.openModalForTag()" ng-disabled="vm.objectToUdp.length < 1" ng-if="vm.tabObjectsRow.length>0"><i class="fa fa-save"></i> <span translate="entity.action.save">Save</span></button></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div></div><div class="table-scrollable"><table class="table table-striped table-bordered no-footer action-column action-column-xeditable"><thead><tr><th class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input ng-click="vm.chkUnChkAll()" ng-checked="vm.areChk" type="checkbox"> <span></span></label></th><th><span translate="jotApp.customUpdate.objectCode">Object code</span></th><th><span translate="jotApp.customUpdate.objectName">Object Name</span></th><th><span translate="jotApp.customUpdate.description">Object Description</span></th><th><span translate="jotApp.customUpdate.note">Note</span></th></tr></thead><tbody><tr ng-repeat="obj in vm.tabObjectsRow track by obj.objectUniqueCode"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input id="chekObj{{obj.id}}" ng-checked="vm.checkChecked(obj)" ng-click="vm.toggleSelection(obj)" type="checkbox"> <span></span></label></td><td><span class="text-ellipsis" ng-bind-html="obj.objectUniqueCode | highlight:vm.charToSearch"></span></td><td><span class="text-ellipsis" ng-bind-html="obj.objectName | highlight:vm.charToSearch"></span></td><td><span class="text-ellipsis">{{obj.objectDescription}}</span></td><td><span class="text-ellipsis">{{obj.objectNotes}}</span></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.currentPage" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.currentPage" ng-change="vm.transition(true)"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/schema-form-component/angular-schema-form-array/angular-schema-form-array.html','<div sf-array="form" class="schema-form-array {{form.htmlClass}}" ng-model="$$value$$" ng-model-options="form.ngModelOptions"><label class="control-label" ng-show="showTitle()">{{ form.title }}</label><ol class="list-group" ng-model="modelArray" ui-sortable=""><li class="list-group-item {{form.fieldHtmlClass}}" ng-repeat="item in modelArray track by $index"><button ng-hide="form.readonly || form.remove === null" ng-click="deleteFromArray($index)" type="button" class="close"><!--<span aria-hidden="true">&times;</span>--><!--<span class="sr-only">Close</span>--> <i class="fa fa-times"></i></button><sf-decorator ng-init="arrayIndex = $index" form="copyWithIndex($index)"></sf-decorator></li></ol><div class="clearfix"><button ng-hide="form.readonly || form.add === null" ng-click="appendToArray()" type="button" class="btn {{ form.style.add || \'btn-default\' }} pull-right"><i class="glyphicon glyphicon-plus"></i> {{ form.add || \'Add\'}}</button></div><div class="help-block" ng-show="(hasError() && errorMessage(schemaError())) || form.description" ng-bind-html="(hasError() && errorMessage(schemaError())) || form.description"></div></div>');
$templateCache.put('app/management/multiple-commands/check-save.html','<form name="checkform" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.confirmSaveMultiple.title">Confirm Save operation</h4></div><div class="modal-body"><div class="row" ng-if="vm.now.length != 0"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span>Save this new queue for the following objects?</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer action-column"><thead><tr><th><span>Objects</span></th></tr></thead><tbody><tr ng-repeat="obj in vm.objects track by $index"><td>{{obj}}</td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.page" total="vm.systemQueryCount" limit="vm.systemItemLimit"></jhi-item-count></div></div></div><div class="row" style="display: flex; justify-content: flex-end;"><div class="col-sm-9"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.systemItemLimit" total-items="vm.systemNowTotalItems" ng-model="vm.page" ng-change="vm.changePage()"></uib-pagination></div></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="checkform.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/management/multiple-commands/multiple-commands-arguments.html','<div class="app-content-body commands-management-page commands-multiple-arguments"><h1 class="page-title" translate="jotApp.actionCommands.multiple.title">Commands Management</h1><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><div name="editForm"><div class="form-body"><div class="row"><div ng-repeat="buttonCommand in vm.formSchemas.buttons"><div class="form-group schema-form-submit"><input type="button" class="btn btn-primary" value="{{buttonCommand.command}}{{vm.isGreengrassObject ? \'\' : \' \' + buttonCommand.deviceReleases.deviceReleaseVersion}}"></div></div></div><div class="row"><div ng-repeat="macro in vm.macro"><div class="form-group schema-form-submit"><input type="button" class="btn btn-primary" value="{{macro.alias}}"></div></div></div><div class="row"><div ng-repeat="formCommand in vm.formSchemas.forms" class="col-xs-12 col-md-6 col-lg-4 form-component-wrapper" ng-class="{\'col-md-12 col-lg-8 two-col\': formCommand.weight == 2, \'col-md-12 col-lg-12 three-col\': formCommand.weight == 3}"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption">{{formCommand.command | beautifyCommand }}{{vm.isGreengrassObject ? \'\' : \' \' + formCommand.deviceReleases.deviceReleaseVersion}}</div><div class="actions"><span title="{{formCommand.schema.scheduleTime | date:\'dd/MM/yy HH:mm\'}}" class="icon pull-right" ng-if="formCommand.schema.isScheduled"><i class="fa fa-clock-o"></i> </span><span ng-if="formCommand.schema.sending" class="icon" ng-click="formCommand.showPending = !formCommand.showPending"><i class="fa fa-paper-plane"></i></span></div></div><div class="portlet-body"><div class="form-group schema-form-submit"><form class="command-form" ng-submit="storeChanges(formCommand)" name="{{formCommand.command}}"><div sf-model="formCommand" sf-schema="formCommand.schema" sf-form="formCommand.form"></div></form></div><div class="clearfix"></div></div></div></div></div></div><div class="form-actions"><div class="col-sm-6 col-md-4 col-lg-3 schedule-btn-wrapper"><div class="input-group"><input id="schedule" type="text" placeholder="Set schedule time if any" timepicker-options="vm.timepickerOptions" datepicker-options="vm.datepickerOptions" class="form-control" datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.scheduleDateTime" name="scheduleDatetime" ng-click="vm.openCalendar($event)" is-open="vm.scheduleDatetime.isOpen"> <span class="input-group-btn" ng-click="vm.openCalendar($event)" is-open="vm.scheduleDatetime.isOpen" role="button" tabindex="0"><button type="button" class="btn btn-default"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-xs-4" ng-if="vm.scheduleDateTime && vm.licence.id === 4"><div class="form-group"><div class="mt-checkbox-inline"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.cron"> <span></span><div>Repeat <span ng-if="vm.cron === true">every <input style="width: 73px;height: 27px;" type="number" ng-model="vm.repeatNumber" min="1" max="30"> <select style="width: 103px;height: 27px;" ng-model="vm.repeatTime"><option label="HOURS" value="HOURS">HOURS</option><option label="DAYS" value="DAYS">DAYS</option></select></span></div></label></div></div></div><button ng-click="vm.checkSave()" type="button" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span translate="entity.action.send">Send</span></button> <button type="button" class="btn btn-default" onclick="history.back()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back">Back</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/management/multiple-commands/multiple-commands.html','<div class="app-content-body"><jhi-alert></jhi-alert><multiple-com-filter filter="vm.applyFilter(fleet, objectType)" fleets="vm.selectedFleets" fleet="vm.selectedFleet" object-type="vm.selectedObjectType" remove-option-all="true" show-condition="false" condition="vm.selectedCondition" show-warn="vm.showWarning"></multiple-com-filter><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="form-body"><div class="row"><div class="form-group"><div class="col-md-4 col-xs-12"><label class="control-label" translate="jotApp.actionCommands.home.command">Select commands</label> <select class="form-control" id="field_action" chosen multiple="multiple" name="action" ng-model="vm.tabCommands" ng-options="action as action.actionCommand for action in vm.tabActions track by action.id" ng-change="vm.clearObjectList()" ng-disabled="vm.isGreengrassObjectType && !vm.filterApplied" data-placeholder-text-multiple="\' \'"></select><!-- Warning message for Greengrass when filter not applied\n                                <div ng-if="vm.isGreengrassObjectType && !vm.filterApplied" style="margin-top: 5px;">\n                                    <small class="text-warning">\n                                        <i class="fa fa-exclamation-triangle"></i>\n                                        Please apply the filter above before selecting commands for Greengrass ObjectType.\n                                    </small>\n                                </div>--></div><div class="col-md-4 col-xs-12"><label class="control-label" translate="jotApp.actionCommands.home.macro">Select macro</label> <select class="col-md-2 form-control" id="field_action_macro" chosen multiple="multiple" name="action_macro" ng-model="vm.tabMacro" ng-options="macro as macro.alias for macro in vm.macro track by macro.id" ng-change="vm.clearObjectList()" ng-disabled="vm.isGreengrassObjectType && !vm.filterApplied" data-placeholder-text-multiple="\' \'"></select></div><div class="col-md-4 col-xs-12"><div class="mt-checkbox-inline" style="margin-top: 25px;"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ng-model="vm.onlyOnline"><span></span>Only OnLine</label></div></div><div class="col-md-12 col-xs-12"><button ng-click="vm.fetchObjects(1)" class="btn btn-primary" style="margin-top: 10px" ng-disabled="(vm.tabCommands.length < 1 && vm.tabMacro.length < 1) || (vm.isGreengrassObjectType && !vm.filterApplied)"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="jotApp.actionCommands.multiple.check">Check available objects</span></button><!-- Additional warning for Greengrass\n                                <div ng-if="vm.isGreengrassObjectType && !vm.filterApplied" style="margin-top: 10px;">\n                                    <div class="alert alert-info">\n                                        <i class="fa fa-info-circle"></i>\n                                        <strong>Greengrass ObjectType:</strong> You must apply the filter above before you can select commands and check objects.\n                                    </div>\n                                </div>--></div></div></div></div></div></div></div><div class="row" ng-if="vm.showTable"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><i class="fa fa-calendar"></i> <span translate="jotApp.actionCommands.home.title">Updates Schedules List</span></div><div class="actions"></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="col-sm-6"></div><div class="col-sm-6"><div class="dataTables_filter"><label><input class="input-large" ng-change="vm.search()" ng-model="vm.charToSearch" placeholder="Search..."></label></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th class="text-center" style="width:5%;"><label class="mt-checkbox mt-checkbox-outline"><input ng-click="vm.chkUnChkAll()" ng-checked="vm.areChk" type="checkbox"> <span></span></label></th><th><span translate="jotApp.actionCommands.multiple.objectCode">Object code</span></th><th><span translate="jotApp.actionCommands.multiple.objectName">Object Name</span></th></tr></thead><tbody><tr ng-repeat="obj in vm.objectList track by $index"><td class="text-center"><label class="mt-checkbox mt-checkbox-outline"><input id="chekObj{{obj.id}}" ng-checked="vm.selectionValue.indexOf(obj.objectUniqueCode) > -1" ng-click="vm.toggleSelection(obj)" type="checkbox"> <span></span></label></td><td>{{obj.objectUniqueCode}}</td><td>{{obj.objectName}}</td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><jhi-item-count page="vm.currentPage" total="vm.queryCount" limit="20"></jhi-item-count></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination total-items="vm.totalItems" ng-model="vm.currentPage" ng-change="vm.fetchObjects(vm.currentPage)"></uib-pagination></div></div></div><div class="row"><button ui-sref="multiple-commands-arguments({objects:vm.objectToUdp, commands: vm.tabCommands, macros: vm.tabMacro})" class="btn btn-primary" ng-disabled="vm.objectToUdp.length < 1" style="margin-left: 15px;"><span class="fa fa-step-forward"></span>&nbsp;<span translate="jotApp.actionCommands.multiple.next">Next</span></button><!--\n                            <div class="alert alert-info" ng-if="vm.isGreengrassObjectType && vm.objectToUdp.length > 0" style="margin: 10px 15px 0;">\n                                <i class="fa fa-info-circle"></i>\n                                <strong>Note:</strong> Greengrass objects do not support scheduled commands. You can proceed to the next page, but scheduling options will be disabled.\n                            </div>\n\n\n                            <div class="alert alert-warning" ng-if="vm.hasGreengrassSelected && !vm.isGreengrassObjectType" style="margin: 10px 15px 0;">\n                                <i class="fa fa-exclamation-circle"></i>\n                                You have selected one or more Greengrass objects that do not support scheduled commands. Scheduling will be disabled for these objects on the next page.\n                            </div>\n                            --></div></div></div></div></div></div></div>');
$templateCache.put('app/schema-form-component/angular-schema-form-checkbox/angular-schema-form-checkbox.html','<div class="form-group schema-form-checkbox mt-checkbox-inline {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" sf-changed="form" ng-disabled="form.readonly" ng-model="$$value$$" ng-model-options="form.ngModelOptions" schema-validate="form" class="{{form.fieldHtmlClass}}" name="{{form.key.slice(-1)[0]}}"> <span></span><div ng-bind-html="form.title"></div></label><div class="help-block" sf-message="form.description"></div></div>');
$templateCache.put('app/schema-form-component/angular-schema-form-checkboxes/angular-schema-form-checkboxes.html','<div sf-array="form" ng-model="$$value$$" class="form-group schema-form-checkboxes {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}"><label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label><div class="form-field mt-checkbox-inline"><label class="mt-checkbox mt-checkbox-outline" ng-repeat="val in titleMapValues track by $index"><input type="checkbox" ng-disabled="form.readonly" sf-changed="form" class="{{form.fieldHtmlClass}}" ng-model="titleMapValues[$index]" name="{{form.key.slice(-1)[0]}}"> <span></span><div ng-bind-html="form.titleMap[$index].name"></div></label></div><div class="help-block" sf-message="form.description"></div></div>');
$templateCache.put('app/schema-form-component/angular-schema-form-spinner/angular-schema-form-spinner.html','<div class="form-group" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }"><!-- The showTitle function is implemented by ASF, returns true if the title should be shown --> <label class="control-label" {{form.labelhtmlclass}} ng-show="showTitle()">{{form.title}}</label><div ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddongRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span><div touch-spin ng-model="$$value$$" ng-model-options="form.ngModelOptions" options="form.options" schema-validate="form"></div></div><span ng-if="form.feedback !== false" ng-class="evalInScope(form.feedback)" id="{{form.key.slice(-1)[0] + \'Status\'}}" class="form-control-feedback"></span> <span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>');
$templateCache.put('app/schema-form-component/angular-schema-form-timepicker/angular-schema-form-timepicker.html','<div class="form-group" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }"><label class="control-label" {{form.labelhtmlclass}} ng-show="showTitle()">{{form.title}}</label><div ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddongRight)}"><span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span> <input type="time" name="timepicker" ng-model="$$value$$" ng-model-options="form.ngModelOptions" min="{{form.schema.minimum}}" max="{{form.schema.maximum}}"></div><span class="help-block">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>');
$templateCache.put('app/account/general-settings/modals/channel-disabled.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.stop()">&times;</button><h4 class="modal-title">Channel disabled!</h4></div><div class="modal-body user-config-modal-body">This channel has been disabled by your domain admin!</div><div class="modal-footer"><button type="button" class="btn btn-primary btn-inline-big" ng-click="vm.stop()"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.confirm">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/delete-dialog.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="entity.delete.deleteUserAlert"></p></div><div class="modal-footer"><button type="submit" class="btn btn-primary btn-inline-big"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.confirm">Stop</span></button></div></form>');
$templateCache.put('app/account/general-settings/modals/domain-emails-setup.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Trusted email domains configuration</h4></div><div class="modal-body user-config-modal-body" ng-show="vm.showWarningResult === false"><div class="form-group"><span ng-show="vm.trusted.email.length > 0">Delete Active trusted email domains</span><div class="chosen-container chosen-container-multi chosen-with-drop chosen-container-active tile-content" id="mail_domain_chosen"><ul class="chosen-choices transparent alerting-chosen"><li class="search-choice transparent" ng-class="{\'red\': trusted.toBeDeleted === true, \'grey\': trusted.greyout === true}" ng-repeat="trusted in vm.trusted.email"><span>{{trusted.trustedDomain}}</span> <a class="search-choice-close" ng-click="vm.checkAndPrepareToDelete(trusted, \'email\')"></a></li></ul></div></div><div class="form-group" ng-if="vm.isConfirmOperation === true">Deleting this email domain will stop the users using it to recieve notifications.</div><div class="form-group"><label ng-show="vm.trusted.email.length == 0">Trusted email domain to add:</label> <input class="form-control switch-input" ng-model="vm.domain.email" placeholder="add your domain: \'mail.com\' here..."> <button type="button" ng-disabled="vm.domain.email == undefined || vm.domain.email.length < 1" class="btn btn-primary" ng-click="vm.addDomainGeneral(\'email\')"><span class="fa fa-plus"></span>&nbsp;<span>Add</span></button></div></div><div class="modal-body user-config-modal-body" ng-show="vm.showWarningResult === true">RESTRICTING ALREADY EXISTING USERS</div><div class="modal-footer"><button type="button" ng-disabled="vm.newtrusted.email.length < 1 && vm.domainToDelete.length < 1" ng-show="vm.showWarningResult === false" class="btn btn-primary btn-inline-big" ng-click="vm.saveSettingsGeneral(\'email\')"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-show="vm.showWarningResult === true" class="btn btn-primary btn-inline-big" ng-click="vm.confirmSaveEvent(\'email\')"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/domain-webhook-setup.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Trusted webhook domains configuration</h4></div><div class="modal-body user-config-modal-body" ng-show="vm.showWarningResult === false"><div class="form-group"><span ng-show="vm.trusted.webhook.length > 0">Delete active trusted webhook domains</span><div class="chosen-container chosen-container-multi chosen-with-drop chosen-container-active tile-content" id="mail_domain_chosen"><ul class="chosen-choices transparent alerting-chosen"><li class="search-choice transparent" ng-class="{\'red\': trusted.toBeDeleted === true}" ng-repeat="trusted in vm.trusted.webhook"><span>{{trusted.trustedDomain}}</span> <a class="search-choice-close" data-option-array-index="$index" ng-click="vm.checkAndPrepareToDelete(trusted, \'webhook\')"></a></li></ul></div></div><div class="form-group"><label ng-show="vm.trusted.webhook.length == 0">Trusted webhook domain to add:</label> <input class="form-control switch-input" ng-model="vm.domain.webhook" placeholder="add your domain: \'mail.com\' here..."> <button type="button" ng-disabled="vm.domain.webhook == undefined || vm.domain.webhook.length < 1" class="btn btn-primary" ng-click="vm.addDomainGeneral(\'webhook\')"><span class="fa fa-plus"></span>&nbsp;<span>Add</span></button></div></div><div class="modal-body user-config-modal-body" ng-show="vm.showWarningResult === true">RESTRICTING ALREADY EXISTING USERS</div><div class="modal-footer"><button type="button" ng-disabled="vm.newtrusted.webhook.length < 1 && vm.domainToDelete.length < 1" ng-show="vm.showWarningResult === false" class="btn btn-primary btn-inline-big" ng-click="vm.saveSettingsGeneral(\'webhook\')"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-show="vm.showWarningResult === true" class="btn btn-primary btn-inline-big" ng-click="vm.confirmSaveEvent(\'webhook\')"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/email-setup.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Email configuration</h4></div><div class="modal-body user-config-modal-body"><div class="form-group"><ol><li>Insert your email and press "Send code".</li><li>Check your email and copy the code in the "Verification code" field.</li><li>Save!</li></ol></div><div class="form-group"><label class="label-text-large">Email:</label> <input class="form-control switch-input" name="actionIdentifier" ng-model="vm.email.actionIdentifier" type="email" required> <button type="button" class="btn-primary btn" ng-click="vm.testAlert(\'email\')" translate="entity.action.sendCode" ng-disabled="vm.isSaving !== true && !vm.email.actionIdentifier">send code</button><div class="verification-message" ng-show="vm.testEmail === true">A verification code has been sent to your email.</div></div><div class="form-group"><label class="label-text-large">Verification code:</label> <input class="form-control switch-input" ng-disabled="!vm.email.actionIdentifier" ng-model="vm.emailCode"></div></div><div class="modal-footer"><button type="button" ng-disabled="!vm.emailCode || !vm.email.actionIdentifier" class="btn btn-primary btn-inline-big" ng-click="vm.save(\'Email\', vm.emailCode)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/telegram-setup.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Telegram configuration</h4></div><div class="modal-body user-config-modal-body"><div class="form-group"><ol><li>Open Telegram and search JoT Alert or click <a href="https://telegram.me/jotalertbot" target="_blank">here</a>.</li><li>Say "Hello" to JoT Alert.</li><li>Copy here the code.</li><li>Save!</li></ol></div><div class="form-group"><label class="label-text-large">Code:</label> <input class="form-control switch-input" name="telegramCode" ng-model="vm.telegramCode" type="text" required></div></div><div class="modal-footer"><button type="button" ng-disabled="!vm.telegramCode" class="btn btn-primary btn-inline-big" ng-click="vm.save(\'Telegram\', vm.telegramCode)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/throttle-configuration.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Email configuration</h4></div><div class="modal-body user-config-modal-body" ng-if="vm.type === \'telegram\'"><div class="section-infos" translate="entity.infos.throttleTimeInfos"></div><label class="control-label">Throttle time</label> <input class="switch-input throttle" name="throttle" ng-model="vm.telegram.throttle" type="number" min="0" max="59"> <select class="switch-input throttle" name="time" ng-model="vm.telegram.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="modal-body user-config-modal-body" ng-if="vm.type === \'email\'"><div class="section-infos" translate="entity.infos.throttleTimeInfos"></div><label class="control-label">Throttle time</label> <input class="switch-input throttle" name="throttle" ng-model="vm.email.throttle" type="number" min="0" max="59"> <select class="switch-input throttle" name="time" ng-model="vm.email.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="modal-body user-config-modal-body" ng-if="vm.type === \'webhook\'"><div class="section-infos" translate="entity.infos.throttleTimeInfos"></div><label class="control-label">Throttle time</label> <input class="switch-input throttle" name="throttle" ng-model="vm.webhook.throttle" type="number" min="0" max="59"> <select class="switch-input throttle" name="time" ng-model="vm.webhook.time" ng-options="throttleUnit as throttleUnit for throttleUnit in vm.throttleUnit"></select></div><div class="modal-footer"><button type="button" ng-disabled="!vm.email.throttle && !vm.email.time" class="btn btn-primary btn-inline-big" ng-if="vm.type === \'email\'" ng-click="vm.save(vm.type, vm.email)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-disabled="!vm.telegram.throttle && !vm.telegram.time" class="btn btn-primary btn-inline-big" ng-if="vm.type === \'telegram\'" ng-click="vm.save(vm.type, vm.telegram)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-disabled="!vm.webhook.throttle && !vm.webhook.time" class="btn btn-primary btn-inline-big" ng-if="vm.type === \'webhook\'" ng-click="vm.save(vm.type, vm.webhook)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/general-settings/modals/toggle-domain-notifications.html','<form name="stopForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.enable.toggle">Confirm channel toggle</h4></div><div class="modal-body"><div ng-if="vm.channelSettings !== \'enableAlerting\'"><span ng-if="vm.notificationStatus === false" translate="entity.infos.toggleOff"></span> <span ng-if="vm.notificationStatus === true" translate="entity.infos.toggleOn"></span></div><div ng-if="vm.channelSettings === \'enableAlerting\'"><span ng-if="vm.notificationStatus === true" translate="entity.infos.enableDomainNotifications"></span> <span ng-if="vm.notificationStatus === false" translate="entity.infos.disableDomainNotifications"></span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-inline-big" ng-click="vm.stop();"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.confirm"></span></button></div></form>');
$templateCache.put('app/account/general-settings/modals/webhook-setup.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Webhook configurations</h4></div><div class="modal-body user-config-modal-body"><span ng-show="vm.webhook.id == null"><div class="form-group"><label class="label-text-large">Url:</label> <input class="form-control switch-input" name="actionIdentifier" ng-model="vm.webhook.url" required></div><div class="form-group"><label class="label-text-large">Authentication</label> <select required ng-disabled="vm.webhook.id != null" name="auth" class="form-control switch-input" ng-model="vm.webhook.authType" ng-change="vm.logValue()" ng-options="authentications as authentications for authentications in vm.authentications"></select></div></span><span ng-show="vm.webhook.authType == \'oauth\' && vm.webhook.id == null"><div class="form-group"><span>head</span> <label class="switch round" ng-show="vm.webhook.authType == \'oauth\' && vm.webhook.id == null"><input type="checkbox" ng-click="vm.oauth = !vm.oauth" ng-checked="vm.oauth"> <span class="form-mode-toggle-user-settings user-settings-toggle round"></span></label> <span>form</span></div><div class="form-group"><label>Client Id:</label> <input class="form-control switch-input" ng-model="vm.webhook.clientId"></div><div class="form-group"><label>Client Secret:</label> <input class="form-control switch-input" ng-model="vm.webhook.clientSecret"></div><div class="form-group"><label>Token Url:</label> <input class="form-control switch-input" ng-model="vm.webhook.tokenUrl"></div></span><span ng-show="vm.webhook.authType == \'basic\' && vm.webhook.id == null"><div class="form-group"><label>Username:</label> <input class="form-control switch-input" ng-model="vm.webhook.username"></div><div class="form-group"><label>Password:</label> <input class="form-control switch-input" ng-model="vm.webhook.password"></div></span><div class="form-group"><button type="button" class="btn-primary btn" ng-click="vm.testAlert(\'Webhook\')" translate="entity.action.test" ng-disabled="vm.isSaving === true || !vm.webhook.url">test</button></div></div><div class="modal-footer"><button type="button" ng-disabled="!vm.testWebhook" class="btn btn-primary btn-inline-big" ng-click="vm.save(\'Webhook\', vm.webhook)"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="login custom-login-page"><bg-canvas></bg-canvas><div class="login-wrapper-inner"><div class="content"><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet"><div class="logo"><img src="./content/images/jot-logo.png" alt=""></div><div class="form"><div ng-hide="vm.keyMissing"><form name="form" role="form" ng-submit="vm.finishReset()" show-validation><h3 translate="reset.finish.title">Reset password</h3><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-hide="vm.success || !vm.error" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group" ng-show="!vm.success"><label class="control-label visible-ie8 visible-ie9" for="password" translate="global.form.newpassword">New password</label> <input type="password" class="form-control form-control-solid placeholder-no-fix" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">The password and its confirmation do not match!</p><p class="help-block" ng-show="form.password.$error.minlength">The password and its confirmation do not match!</p><p class="help-block" ng-show="form.password.$error.maxlength">The password and its confirmation do not match!</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group" ng-show="!vm.success"><label class="control-label visible-ie8 visible-ie9" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label> <input ng-hover="vm.passwordmatch()" ng-change="vm.passwordmatch()" ng-click="vm.passwordmatch()" type="password" class="form-control form-control-solid placeholder-no-fix" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="8" ng-maxlength="50" required><p class="help-block" style="color: red">{{vm.passwordnotmatch}}</p><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required"></p><p class="help-block" ng-show="form.confirmPassword.$error.minlength"></p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength"></p></div></div><div class="actions" ng-show="!vm.success" ng-mouseover="vm.checkUserLng()"><button type="submit" ng-disabled="vm.checkMinLngUser" class="btn btn-primary btn-lg uppercase login-button" translate="reset.request.form.button">Reset</button></div></form></div></div></div></div></div></div><div class="contact-us"><a ui-sref="contact-us" class="contact-us-text" translate="login.contact.contactUs">Contact Us</a></div><div class="copyright">JoT v{{VERSION}} - Powered By motIQa</div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="app-content-body container"><div class="wrapped-md"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div></div>');
$templateCache.put('app/account/settings/integration/active-integration.html','<div class="app-content-body"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><h1 class="page-title"><button type="submit" ui-sref="integration" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="settings.integration.active">Active Integration</span></h1><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="caption"><span translate="settings.integration.active">Active Integration</span></div></div><div class="portlet-body"><div class="dataTables_wrapper no-footer"><div class="row"><div class="col-md-6 col-xs-12"><label translate="settings.integration.domain" for="field_domain">Domain</label><ui-select id="field_domain" ng-model="vm.selectedDomain" on-select="vm.reloadIntegration()" theme="bootstrap"><ui-select-match placeholder="Select or search a domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" refresh-delay="1"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 col-xs-12"><label translate="settings.integration.scopes" for="field_scopes">Scopes</label><ui-select id="field_scopes" ng-model="vm.selectedScope" on-select="vm.reloadIntegration()" theme="bootstrap"><ui-select-match placeholder="Select or search a scopes..">{{$select.selected.scope}}</ui-select-match><ui-select-choices repeat="item in vm.scopes | filter: {scope: $select.search}" refresh-delay="1"><div ng-bind-html="item.scope | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th><span translate="settings.integration.client.id">Client ID</span></th><th><span translate="settings.integration.client.resourceIds">Resource ids</span></th><th><span translate="settings.integration.client.scope">Scope</span></th><th><span translate="settings.integration.client.grantTypes">Authorized Grant Types</span></th><th><span translate="settings.integration.client.redirectUri">Web Server Redirect Uri</span></th><th><span translate="settings.integration.client.authorities">Authorities</span></th><th><span translate="settings.integration.client.accessToken">Access Token Validity</span></th><th><span translate="settings.integration.client.refreshToken">Refresh Token Validity</span></th><th><span translate="settings.integration.client.information">Additional Information</span></th><th><span translate="settings.integration.client.autoapprove">Autoapprove</span></th><th><span translate="settings.integration.client.domain">Domain</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="integration in vm.integrations track by integration.clientId"><td>{{integration.clientId}}</td><td>{{integration.resourceIds}}</td><td>{{integration.scope}}</td><td>{{integration.authorizedGrantTypes}}</td><td>{{integration.webServerRedirectUri}}</td><td>{{integration.authorities}}</td><td>{{integration.accessTokenValidity}}</td><td>{{integration.refreshTokenValidity}}</td><td>{{integration.additionalInformation}}</td><td>{{integration.autoapprove}}</td><td>{{integration.domain.domainName}}</td><td class="text-center"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="integration-edit({id:integration.clientId})"><i class="fa fa-pencil"></i> <span translate="entity.action.edit"></span></a></li><li has-authority="ROLE_ADMIN"><a href="javascript:;" ui-sref="delete-integration({id:integration.clientId})"><i class="fa fa-times"></i> <span translate="entity.action.delete"></span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/account/settings/integration/edit-integration.html','<div class="app-content-body"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><h1 class="page-title"><button type="submit" ui-sref="active-integration" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="settings.integration.edit">Edit Integration</span></h1><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" ng-submit="vm.save()" novalidate show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.id" for="field_client_id">Client ID</label> <input type="text" class="form-control" name="client_id" id="field_client_id" ng-model="vm.client.clientId" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.grantTypes" for="field_grantTypes">Grant Types</label> <input type="text" class="form-control" name="client_grantTypes" id="field_grantTypes" ng-model="vm.client.authorizedGrantTypes" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.scope" for="field_scope">Scope</label> <input type="text" class="form-control" name="client_scope" id="field_scope" ng-model="vm.client.scope" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.domain" for="field_domain">Domain</label> <input type="text" class="form-control" name="client_domain" id="field_domain" ng-model="vm.client.domain.domainName" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.resourceIds" for="field_resourceIds">Resource Ids</label> <input type="text" class="form-control" name="client_resourceIds" id="field_resourceIds" ng-model="vm.client.resourceIds"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.redirectUri" for="field_webServerRedirectUri">Web Server Redirect Uri</label> <input type="text" class="form-control" name="client_webServerRedirectUri" id="field_webServerRedirectUri" ng-model="vm.client.webServerRedirectUri"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.accessToken" for="field_accessToken">Access Token Validity</label> <input type="number" class="form-control" name="client_accessToken" id="field_accessToken" ng-model="vm.client.accessTokenValidity"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.refreshToken" for="field_refreshToken">Refresh Token Validity</label> <input type="number" class="form-control" name="client_refreshToken" id="field_refreshToken" ng-model="vm.client.refreshTokenValidity"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.information" for="field_information">Additional Information</label> <input type="text" class="form-control" name="client_information" id="field_information" ng-model="vm.client.additionalInformation" ng-disabled="true"></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.autoapprove" for="field_autoapprove">Autoapprove</label> <input type="text" class="form-control" name="client_autoapprove" id="field_autoapprove" ng-model="vm.client.autoapprove"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.authorities" for="field_authorities">Authorities</label> <input type="text" class="form-control" name="client_authorities" id="field_authorities" ng-model="vm.client.authorities"></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/account/settings/integration/integration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.client.clientId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="settings.integration.delete.question" translate-values="{id: \'{{vm.client.clientId}}\'}">Are you sure you want to delete this Integration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/account/settings/integration/integration.html','<div class="app-content-body"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><h1 class="page-title"><button type="submit" ui-sref="settings" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button>&nbsp; <span translate="settings.integration.title">Edit Integration</span></h1><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation><div class="row"><div class="col-md-6 col-xs-12"><label translate="settings.integration.domain" for="field_domain">Domain</label><ui-select id="field_domain" ng-model="vm.selectedDomain" on-select="vm.refreshRequired()" theme="bootstrap" ng-disabled="vm.generated"><ui-select-match placeholder="Select or search a domain..">{{$select.selected.domainName}}</ui-select-match><ui-select-choices repeat="item in vm.domains | filter: {domainName: $select.search}" refresh-delay="1"><div ng-bind-html="item.domainName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 col-xs-12"><label translate="settings.integration.scopes" for="field_scopes">Scopes</label><ui-select id="field_scopes" multiple="multiple" ng-model="vm.selectedScopes" theme="bootstrap" ng-change="vm.refreshRequired()" close-on-select="false" ng-disabled="vm.generated"><ui-select-match placeholder="Select or search scopes..">{{$item.scope}}</ui-select-match><ui-select-choices repeat="item in vm.scopes | filter: {scope: $select.search}" percent="90" when-scrolled="vm.loadFleetPage(vm.fleetPage + 1)"><div ng-bind-html="item.scope | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.id" for="field_client_id">Client ID</label> <input type="text" class="form-control" name="client_id" id="field_client_id" ng-model="vm.client.id" ng-disabled="vm.disabled"></div><div ng-show="vm.generated"><p class="help-block">Please copy this value, it will be deleted</p></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="settings.integration.client.secret" for="field_client_secret">Client Secret</label> <input type="text" class="form-control" name="client_secret" id="field_client_secret" ng-model="vm.client.secret" ng-disabled="vm.disabled"></div><div ng-show="vm.generated"><p class="help-block">Please copy this value, it will be deleted</p></div></div></div></div><div class="form-actions"><button type="button" class="btn btn-primary" ng-click="vm.generateClient()" ng-disabled="vm.checkRequireFields || vm.generated"><span class="glyphicon glyphicon-random"></span>&nbsp; <span translate="settings.integration.client.generate">Generate Client ID/Secret</span></button> <button type="button" class="btn btn-primary" ui-sref="active-integration"><span class="fa fa-list"></span>&nbsp; <span translate="settings.integration.active">Active</span></button> <button type="button" class="btn btn-primary" ui-sref="scope-dialog"><span class="glyphicon glyphicon-th"></span>&nbsp; <span translate="settings.integration.scope.active">Scope</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.clear">Clear</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/account/settings/integration/scope-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scope.scope)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="settings.integration.scope.delete.question" translate-values="{scope: \'{{vm.scope.scope}}\'}">Are you sure you want to delete this Scope?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/account/settings/integration/scope-dialog.html','<form name="deleteForm" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="settings.integration.scope.active">Active Scope</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="table-scrollable"><table class="table table-striped table-bordered table-hover table-checkable order-column dataTable no-footer"><thead><tr><th><span translate="settings.integration.scopes">Scopes</span></th><th class="action-column" translate="entity.action.actionLabel"></th></tr></thead><tbody><tr ng-repeat="scope in vm.scopes track by $index"><td ng-click="vm.enableEditor($index, 0)"><div ng-hide="vm.editorEnabled[$index]">{{scope.scope || \'\'}}</div><div ng-show="vm.editorEnabled[$index]" class="col-md-12 col-xs-12"><input type="text" class="col-md-12 col-xs-12 input-group" value="{{scope.scope}}" ng-model="vm.updateScope[$index]"></div></td><td class="text-center"><div class="btn-group table-action-btn-group"><button type="button" class="btn btn-primary btn-sm" ng-if="!vm.editorEnabled[$index]" ng-click="vm.enableEditor($index, 1)"><i class="fa fa-pencil"></i> <span translate="entity.action.edit">Edit</span></button> <button type="button" ng-if="vm.editorEnabled[$index] && !vm.saveNew" class="btn btn-sm btn-primary" ng-click="vm.saveUpdate($index)"><i class="fa fa-check"></i></button> <button type="button" ng-if="vm.editorEnabled[$index]" class="btn btn-sm btn-default" ng-click="vm.enableEditor($index, 2)"><i class="fa fa-times"></i></button> <span type="button" title="Delete Scope" class="btn btn-primary btn-sm" ng-click="vm.deleteScope(scope)" ng-if="!vm.saveNew"><i class="glyphicon glyphicon-remove"></i></span></div></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="vm.editForm.$invalid || isSaving" class="btn btn-primary" ng-if="vm.saveNew"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.addNewScope()" ng-if="!vm.saveNew"><span class="glyphicon glyphicon-plus"></span>&nbsp; <span translate="settings.integration.scope.addNew">Add New Item</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/account/settings/integration/show-integration.html','<form name="integrationForm"><div class="modal-header"><h4 class="modal-title">Generated Values</h4></div><div class="modal-body"><div class="row"><div class="col-md-10 col-xs-10"><label class="control-label" translate="settings.integration.client.id" for="field_client_id">Client ID</label> <input type="text" class="form-control" name="client_id" id="field_client_id" ng-model="vm.client.id" ng-disabled="true" style="text-overflow: ellipsis;"></div><div class="col-md-2 col-xs-2"><i class="fa fa-copy" copy-to-clipboard="{{vm.client.id}}" uib-tooltip="Copy ID" tooltip-placement="top"></i></div></div><div class="row"><div class="col-md-10 col-xs-10"><label class="control-label" translate="settings.integration.client.secret" for="field_client_secret">Client Secret</label> <input type="text" class="form-control" name="client_secret" id="field_client_secret" ng-model="vm.client.secret" ng-disabled="true" style="text-overflow: ellipsis;"></div><div class="col-md-2 col-xs-2"><i class="fa fa-copy" copy-to-clipboard="{{vm.client.secret}}" uib-tooltip="Copy Secret" tooltip-placement="top"></i></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/entities/kiosks/kiosks-dashboard/kiosk-dashboard-kiosk-delete.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dashboard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete this Dashboard: {{vm.dashboard.name}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dashboard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.kiosksDashboard.delete.question" translate-values="{id: \'{{vm.dashboard.name}}\'}">Are you sure you want to delete this Dashboard?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-dialog.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.kiosksDashboard.home.createOrEditLabel">Create a Dashboard</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.kiosksDashboard.grafanaId" for="field_gafanaId">id grafana</label> <input type="text" class="form-control" name="gafanaId" id="field_gafanaId" ng-model="vm.kiosksDashboard.grafanaId" disabled="disabled" required></div></div><div class="col-md-6 col-xs-12"><div ng-show="vm.enableSelect" class="form-group"><label class="control-label" translate="jotApp.kiosksDashboard.dashboardName" for="field_dashboardName">dashboardName</label> <select class="form-control" id="field_dashboardName" chosen name="dashboardName" ng-model="vm.dashboard" required ng-options="dashboard.title for dashboard in vm.grafanaDashboard track by dashboard.id" ng-change="vm.setGrafanaId()" data-placeholder="\' \'"></select></div><div ng-show="!vm.enableSelect" class="form-group"><label class="control-label" translate="jotApp.kiosksDashboard.dashboardName" for="field_dashboardView">dashboardName</label> <input type="text" class="form-control" name="dashboardView" id="field_dashboardView" ng-model="vm.kiosksDashboard.name" disabled="disabled"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label translate="jotApp.kiosksDashboard.domain" for="field_domain">Domain</label> <select class="form-control" id="field_domain" chosen multiple="multiple" name="domain" ng-model="vm.kiosksDashboard.domains" ng-options="domain as domain.domainName for domain in vm.domains track by domain.id" data-placeholder-text-multiple="\' \'" required></select></div></div></div></div><div class="form-actions"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-kiosk.html','<div class="app-content-body"><h1 class="page-title" id="myTabDomainsLabel" translate="jotApp.kiosk.home.createLabel">Kiosk Configuration</h1><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12"><div class="portlet light filter-portlet bordered"><div class="portlet-body form"><form name="editForm" role="form" novalidate show-validation><div class="form-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.kiosk.kioskName" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.kiosksDashboardkiosk.name" required></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.kiosk.kioskDescription" for="field_description">description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.kiosksDashboardkiosk.description" ng-maxlength="255"><div ng-show="editForm.fleetDescription.$invalid"><p class="help-block" ng-show="editForm.fleetDescription.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group"><label class="control-label" translate="jotApp.kiosk.kioskInterval" for="field_interval">Interval</label> <input type="text" class="form-control" name="interval" id="field_interval" ng-model="vm.dashboardInterval" ng-disabled="vm.singleInterval" placeholder="Insert number and time unit (s,m or h)" ng-pattern="/^[0-9]+[smh]$/"><div ng-show="editForm.interval.$invalid"><p class="help-block" ng-show="editForm.interval.$error.pattern">Interval can only contain number and s (seconds),m (minutes) or h (hours).</p></div></div></div><div class="col-md-6 col-xs-12"><div class="form-group"><div class="mt-checkbox-inline form-field-no-label"><label class="mt-checkbox mt-checkbox-outline" for="singleInterval"><input type="checkbox" id="singleInterval" ng-click="vm.singleInterval = !vm.singleInterval" ng-checked="vm.singleInterval"> <span></span><div translate="jotApp.kiosk.singleInterval">Single Interval</div></label></div></div></div></div><div class="portlet-body portlet-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer action-column action-column-xeditable"><thead><tr><th class="text-center" style="width:5%;">Order</th><th class="text-center" style="width:15%;"><span translate="jotApp.kiosksDashboard.dashboardName">Dashboard name</span></th><th><span translate="jotApp.kiosksDashboard.preview">Preview</span></th><th translate="entity.action.actionLabel"></th><th ng-if="vm.dashboardList.length > 1"><span translate="jotApp.kiosksDashboard.deleteIt">Delete Dashboards</span></th><th ng-show="vm.singleInterval">Interval</th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboardList track by dashboard.id"><td class="text-center">{{$index + 1}}</td><td><span>{{dashboard.name}}</span></td><td><img ng-show="vm.showPreview[dashboard.id]" src="api/kiosk-dashboard/screenshot/{{dashboard.name}}" width="600" height="300"> <button type="button" ng-click="vm.showPreview[dashboard.id] = ! vm.showPreview[dashboard.id]" class="btn btn-primary"><span class="fa fa-eye"></span>&nbsp; <span ng-show="!vm.showPreview[dashboard.id]">Show preview</span> <span ng-show="vm.showPreview[dashboard.id]">Hide preview</span></button></td><td><button type="button" ng-show="$index > 0" class="btn btn-primary" ng-click="vm.moveUp($index)"><span class="glyphicon glyphicon-arrow-up"></span></button> <button type="button" ng-show="$index < vm.dashboardList.length -1" class="btn btn-primary" ng-click="vm.moveDown($index)"><span class="glyphicon glyphicon-arrow-down"></span></button></td><td ng-if="vm.dashboardList.length > 1"><span type="button" title="Delete Dashboards" class="btn btn-primary" ng-click="vm.deleteDashboard(dashboard.id)"><i class="glyphicon glyphicon-remove"></i></span></td><td ng-show="vm.singleInterval"><div class="form-group"><input type="text" ng-model="vm.time[dashboard.name]" name="{{\'interval\' + $index}}" ng-pattern="/^[0-9]+[smh]$/" placeholder="Insert number and time unit (s,m or h)"><div ng-show="{{\'editForm.interval\' + $index + \'.$invalid\'}}"><p class="help-block" ng-show="editForm.interval.$error.pattern">Interval can only contain number and s (seconds),m (minutes) or h (hours).</p></div></div></td></tr></tbody></table></div></div></form></div></div><div class="form-actions"><button type="button" ng-click="vm.addDashboard()" class="btn btn-primary"><span class="fa fa-line-chart"></span>&nbsp;<span translate="jotApp.kiosksDashboard.addDashboard">Add dashboard</span></button> <button type="button" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/kiosks/kiosks-dashboard/kiosks-dashboard.html','<div class="app-content-body custom-updates-page"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12"><div class="portlet box mindscape-blue"><div class="portlet-title"><div class="actions" has-authority="ROLE_ADMIN"><button class="btn btn-primary" ui-sref="kiosks-dashboard-new"><i class="fa fa-plus"></i> <span>Add Dashboard</span></button></div></div><div class="portlet-body portlet-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="dataTables_wrapper no-footer"><div class="table-scrollable"><table class="table table-striped table-bordered no-footer action-column action-column-xeditable"><thead><tr><th class="text-center" style="width:5%;" ng-show="vm.showCreation"><span></span></th><th><span translate="jotApp.kiosksDashboard.preview">Preview</span></th><th class="text-center" style="width:15%;"><span translate="jotApp.kiosksDashboard.dashboardName">Dashboard name</span></th><th has-authority="ROLE_ADMIN"><span translate="entity.action.actionLabel">Actions</span></th></tr></thead><tbody id="table_sortable"><tr ng-repeat="dashboard in vm.dashboards track by dashboard.id"><td class="text-center" ng-show="vm.showCreation"><label class="mt-checkbox mt-checkbox-outline"><input id="checkDashboard{{dashboard.id}}" ng-checked="dashboard.selected" ng-disabled="dashboard.disabledCheck" ng-click="vm.toggleSelection(dashboard)" type="checkbox"> <span></span></label></td><td><img ng-src="api/kiosk-dashboard/screenshot/{{dashboard.name}}" width="400" height="225"></td><td><span>{{dashboard.name}}</span></td><td class="text-center" has-authority="ROLE_ADMIN"><div class="btn-group table-action-btn-group"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span translate="entity.action.actionLabel">Actions </span><i class="fa fa-angle-down"></i></button><ul class="dropdown-menu" role="menu"><li><a href="javascript:;" ui-sref="kiosks-dashboard-edit({id:dashboard.id})"><i class="fa fa-pencil"></i><span translate="entity.action.edit">Edit</span></a></li><li><a href="javascript:;" ui-sref="kiosks-dashboard.delete({id:dashboard.id})"><i class="fa fa-times"></i><span translate="entity.action.delete">Delete</span></a></li></ul></div></td></tr></tbody></table></div><div class="row"><div class="col-md-5 col-sm-5"><div class="dataTables_info"><div class="col-sm-3"><div class="dataTables_length"><label><span translate="entity.pagination.size">Size </span><select ng-model="vm.itemsPerPageChosen" ng-options="items as items for items in vm.itemsPerPageChoose" ng-change="vm.changePageSize()"></select><jhi-item-count page="vm.page" total="vm.queryCount" limit="vm.itemsPerPageChosen"></jhi-item-count></label></div></div></div></div><div class="col-sm-7"><div class="dataTables_paginate paging_bootstrap_number"><uib-pagination items-per-page="vm.itemsPerPageChosen" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div><div class="form-actions" ng-show="vm.showCreation"><button type="submit" ng-disabled="isSaving || vm.selectedDashboards.length < 1" class="btn btn-primary"><span class="fa fa-step-forward"></span>&nbsp;<span>Save And Continue</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/my-domain-notification/modals/change-my-domain-notification-status.html','<form name="stopForm" ng-submit="vm.stop()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="(vm.myDomainNotification.active === true)" class="modal-title" translate="jotApp.myDomainNotification.turnOff.title">Confirm stop operation</h4><h4 ng-show="(vm.myDomainNotification.active === false)" class="modal-title" translate="jotApp.myDomainNotification.turnOn.title">Confirm start operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="(vm.myDomainNotification.active === true)" translate="jotApp.myDomainNotification.turnOff.question" translate-values="{name: \'{{vm.myDomainNotification.name}}\'}">By setting status \'stopped\' {{ vm.myDomainNotification.name }} will no longer monitor or send you communications about this warning list.</p><p ng-show="(vm.myDomainNotification.active === false)" translate="jotApp.myDomainNotification.turnOn.question" translate-values="{name: \'{{vm.myDomainNotification.name}}\'}">By setting status \'running\' {{ vm.myDomainNotification.name }} will restart its monitoring routine. If any notification channel is active you will start receiving communications at set frequency.</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/my-domain-notification/modals/change-notification-channel.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.myDomainNotification.changeNotificationStatus">Changing my domain notification setting</h4></div><div class="modal-body"><p ng-show="vm.myDomainNotification.relatedAlertSystemType[vm.type] === true">By disabling this channel for this domain notification no further notificaiton about it will be sent. <b></b>Regardless rule will continue to be monitored if the status is set to "running"</p><p ng-show="vm.myDomainNotification.relatedAlertSystemType[vm.type] === false">By enabling notifications, alerts will be sent on this channel starting now.</p></div><div class="modal-footer"><button type="button" ng-click="vm.stop()" class="btn btn-primary btn-inline-big"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div>');
$templateCache.put('app/entities/my-domain-notification/modals/my-domain-notification-duplicate-name.html','<form name="stopForm" ng-submit="vm.clear()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.myDomainNotification.duplicate">Warning: Duplicate Name</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="jotApp.myDomainNotification.duplicateMessage">my domain notifications can\'t have the same name</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/my-domain-notification/modals/reroute-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Warning!</h4></div><div class="modal-body"><p ng-show="(vm.notification === false && vm.myDomainNotificationCondition === true) || (vm.typeToCheck.status === false && !(vm.notification === false && vm.myDomainNotificationCondition === false))">The user of this account has disabled the channel or it has never been configured. <b></b> Click "confirm" to move to the notifications setting page.</p><p ng-show="vm.notification === false && vm.myDomainNotificationCondition === false">The notification channel has been disabled by a domain admin.</p></div><div class="modal-footer"><button type="button" ng-click="vm.stop()" class="btn btn-primary btn-inline-big" ng-show="!(vm.notification === false && vm.myDomainNotificationCondition === false)"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm">Confirm</span></button></div>');
$templateCache.put('app/entities/warning/email/selected-rules-email.html','<form name="selectedRulesEmailForm"><jhi-alert-error></jhi-alert-error><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="jotApp.warning.home.email.title">Set email to send new rule alert creation</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 col-xs-12"><label class="control-label" translate="jotApp.warning.home.email.infoPrincipal">infoPrincipal</label><ui-select theme="bootstrap" ng-model="vm.selectedAut"><ui-select-match placeholder="Select or search an authority..">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.authorities | propsFilter: {name: $select.search}"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button ng-click="vm.save()" ng-disabled="selectedEmailForm.$invalid" class="btn btn-primary"><span class="fa fa-envelope-o"></span>&nbsp;<span translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/warning/modals/change-notification-channel.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.detail.changeRules">Confirm set operation</h4></div><div class="modal-body"><p ng-show="vm.warning.relatedAlertSystemType[vm.type] === true">By disabling this channel, no further notification will be sent for this rule. This will not prevent data collection: warnings, if any, are still available in the warning history page</p><p ng-show="vm.warning.relatedAlertSystemType[vm.type] === false">By enabling notifications, alerts will be sent on this channel starting now.</p></div><div class="modal-footer"><button type="button" ng-click="vm.stop()" class="btn btn-primary btn-inline-big"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.confirm">Stop</span></button></div>');
$templateCache.put('app/entities/warning/modals/reroute-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Warning!</h4></div><div class="modal-body"><p ng-show="((vm.notification === false && vm.warningCondition === true) || (vm.typeToCheck.status === false && !(vm.notification === false && vm.warningCondition === false))) && vm.warningCondition !== false">The user of this account has disabled the channel or it has never been configured. <b></b> Click "confirm" to move to the notifications setting page.</p><p ng-show="vm.warningCondition === false">The notification channel has been disabled by a domain admin.</p></div><div class="modal-footer"><button type="button" ng-click="vm.stop()" class="btn btn-primary btn-inline-big" ng-show="vm.warningCondition === true"><span class="fa fa-check"></span>&nbsp;<span translate="entity.action.confirm">Stop</span></button></div>');
$templateCache.put('app/layouts/aside/templates/administration.html','<a href="javascript:;" data-target="#admin-sub-menu" id="admin-menu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="glyphicon glyphicon-user"></i> <span class="title" translate="global.menu.admin.main">Administration</span> <span class="arrow"></span></a><ul class="sub-menu collapse" aria-expanded="false" id="admin-sub-menu"><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="user-management" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User Admin</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_DOMAIN_ADMIN"><a class="nav-link" ui-sref="team-management" ng-click="vm.toggleAside()"><span class="fa fa-users"></span>&nbsp; <span translate="global.menu.admin.teamManagement">My Team</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="licences-code" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-list"></span>&nbsp; <span translate="global.menu.admin.licences">Licences</span></a></li><li class="nav-item" ui-sref-active="active" evaluate-authorities="ROLE_DOMAIN_ADMIN && !ROLE_ADMIN" ng-if="vm.showLicences" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="recap-objects" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-list"></span>&nbsp; <span translate="global.menu.admin.licences">Licences</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="user-profile" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span translate="global.menu.admin.menuProfile">User Profile</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="jhi-tracker" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span translate="global.menu.admin.tracker">User tracker</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="jhi-metrics" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="jhi-health" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span translate="global.menu.admin.health">Health</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="jhi-configuration" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="audits" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="audit-log" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-folder-open"></span>&nbsp; <span translate="global.menu.admin.auditLog">Journal CRUD Log</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="logs" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="docs" ng-click="vm.toggleAside()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/alerting.html','<a href="javascript:;" data-target="#alerting-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="fa fa-bullhorn"></i> <span class="title" translate="global.menu.alerting.main">Alerting</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="alerting-submenu"><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="warning-category" ng-click="vm.toggleAside()"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span translate="global.menu.entities.warningCategory">Categories</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH"><a class="nav-link" ui-sref="warning" ng-click="vm.toggleAside()"><i class="glyphicon glyphicon-cog" aria-hidden="true"></i> <span translate="global.menu.entities.alertRules">Rules</span></a></li><li class="nav-item" ui-sref-active="active" evaluate-authorities="!ROLE_TECH"><a class="nav-link" ui-sref="alert-rules" ng-click="vm.toggleAside()"><i class="glyphicon glyphicon-cog" aria-hidden="true"></i> <span translate="global.menu.entities.alertRules">Rules</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="my-domain-notification" ng-click="vm.toggleAside()"><i class="fa fa-bell" aria-hidden="true"></i> <span translate="global.menu.entities.myDomainNotification">My Domain Notification</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/control.html','<a href="javascript:;" data-target="#command-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="glyphicon glyphicon-globe"></i> <span class="title" translate="global.menu.objectManagement.remoteControl">Control</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="command-submenu"><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="action-commands" ng-click="vm.toggleAside()"><i class="fa fa-terminal"></i> <span translate="global.menu.objectManagement.commands">Single Object</span></a></li><li class="nav-item" ui-sref-active="active" ng-if="vm.showMacro"><a class="nav-link" ui-sref="macros" ng-click="vm.toggleAside()"><i class="fa fa-cube" aria-hidden="true"></i> <span translate="global.menu.entities.macros">Macros</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="multiple-commands" ng-click="vm.toggleAside()"><i class="fa fa-reply-all"></i> <span translate="global.menu.objectManagement.multipleCommands">Multiple Objects</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="queues" ng-click="vm.toggleAside()"><i class="fa fa-list"></i> <span translate="global.menu.objectManagement.queue">Commands Queue</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="publish-message" ng-click="vm.toggleAside()"><i class="fa fa-commenting-o"></i> <span translate="global.menu.entities.publisMessage">Publish Message</span></a></li><li class="nav-item" ui-sref-active="active" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="view-all-command-value" ng-click="vm.toggleAside()"><i class="fa fa-list"></i> <span translate="global.menu.entities.viewAllCommandsValue">View All Commands Value</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/home.html','<a href="javascript:;" ui-sref="home" class="nav-link"><i class="glyphicon glyphicon-home"></i> <span class="title" translate="global.menu.home">Home</span></a>');
$templateCache.put('app/layouts/aside/templates/kiosk.html','<a href="javascript:;" ui-sref="kiosks" class="nav-link"><i class="fa fa-tachometer"></i> <span translate="global.menu.entities.kiosks">Kiosks</span></a>');
$templateCache.put('app/layouts/aside/templates/kioskAdmin.html','<a href="javascript:;" data-target="#kiosk-sub-menu" id="kiosk-menu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="fa fa-tachometer"></i> <span class="title" translate="global.menu.entities.kiosks">Kiosks</span> <span class="arrow"></span></a><ul class="sub-menu collapse" aria-expanded="false" id="kiosk-sub-menu"><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="kiosks" ng-click="vm.toggleAside()"><i class="fa fa-tachometer" aria-hidden="true"></i> <span translate="global.menu.entities.kiosks">Kiosks</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="kiosks-dashboard({showCreation:false})" ng-click="vm.toggleAside()"><i class="fa fa-line-chart" aria-hidden="true"></i> <span translate="global.menu.entities.dashboard-management">Dashboard</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/monitoring.html','<a href="javascript:;" data-target="#dashboard-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="fa fa-bar-chart"></i> <span class="title" translate="global.menu.dashboard.main">Monitoring</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="dashboard-submenu" aria-expanded="true"><li class="nav-item start" ui-sref-active="active"><a ui-sref="tab-objects-dashboard" ng-click="vm.toggleAside()"><i class="fa fa-object-group"></i> <span translate="global.menu.dashboard.objects">Objects</span></a></li><li class="nav-item start" ui-sref-active="active" ng-if="$root.licence.id >= 3"><a ui-sref="warning-dashboard" ng-click="vm.toggleAside()" class="nav-link"><i class="fa fa-exclamation-triangle"></i> <span class="title" translate="global.menu.dashboard.warning-dashboard">Warnings</span></a></li><li class="nav-item start" ui-sref-active="active" ng-if="$root.licence.id >= 3"><a ui-sref="warnings-list" ng-click="vm.toggleAside()"><i class="fa fa-exclamation-triangle"></i> <span translate="global.menu.dashboard.warning-list">Warnings History</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/system.html','<a href="javascript:;" data-target="#entities-submenu" class="nav-link nav-toggle collapsed" data-toggle="collapse"><i class="glyphicon glyphicon-cog"></i> <span class="title" translate="global.menu.entities.main">System</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="entities-submenu"><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-domains" ng-click="vm.toggleAside()"><i class="fa fa-tags" aria-hidden="true"></i> <span translate="global.menu.entities.tabDomains">Domains</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="tab-fleets" ng-click="vm.toggleAside()"><i class="fa fa-ship" aria-hidden="true"></i> <span translate="global.menu.entities.tabFleets">Fleets</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-object-types" ng-click="vm.toggleAside()"><i class="fa fa-cubes" aria-hidden="true"></i> <span translate="global.menu.entities.tabObjectTypes">Object Types</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="tab-objects" ng-click="vm.toggleAside()"><i class="fa fa-cube" aria-hidden="true"></i> <span translate="global.menu.entities.tabObjects">Objects</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-devices-types" ng-click="vm.toggleAside()"><i class="fa fa-desktop"></i> <span translate="global.menu.entities.tabDevicesTypes">Devices Types</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-devices" ng-click="vm.toggleAside()"><i class="fa fa-desktop"></i> <span translate="global.menu.entities.tabDevices">Devices</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-file-types" ng-click="vm.toggleAside()"><i class="fa fa-file-text"></i> <span translate="global.menu.entities.fileTypes">File Types</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-firmware" ng-click="vm.toggleAside()"><i class="fa fa-file"></i> <span translate="global.menu.entities.tabFirmware">Firmwares</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="dashboard-management" ng-click="vm.toggleAside()"><i class="fa fa-line-chart"></i> <span translate="global.menu.entities.dashboard-management">Dashboard</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/testing.html','<a href="javascript:;" data-target="#testing-submenu" class="nav-link nav-toggle collapsed" data-toggle="collapse"><i class="fa fa-pencil-square-o"></i> <span class="title" translate="global.menu.testing.main">Testing</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="testing-submenu"><li class="nav-item" ui-sref-active="active" has-authority="ROLE_TECH" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="object-test-setting" ng-click="vm.toggleAside()"><i class="glyphicon glyphicon-cog" aria-hidden="true"></i> <span translate="global.menu.testing.createOrEdit">Create/Edit</span></a></li><li class="nav-item" ui-sref-active="{\'active\': \'launch-object-test.*\'}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="launch-object-test" ng-click="vm.toggleAside()"><i class="fa fa-rocket" aria-hidden="true"></i> <span translate="global.menu.testing.launch">Launch</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="test-schedule" ng-click="vm.toggleAside()"><i class="fa fa-calendar-o" aria-hidden="true"></i> <span translate="global.menu.testing.schedule">Schedule</span></a></li><li class="nav-item" ui-sref-active="{\'active\': \'object-test-result.*\'}" has-authority="ROLE_DOMAIN_USER" ng-if="$root.licence.id === 4"><a class="nav-link" ui-sref="object-test-result" ng-click="vm.toggleAside()"><i class="fa fa-folder-open" aria-hidden="true"></i> <span translate="global.menu.testing.results">Results</span></a></li></ul>');
$templateCache.put('app/layouts/aside/templates/updates.html','<a href="javascript:;" data-target="#management-submenu" data-toggle="collapse" class="nav-link nav-toggle collapsed"><i class="glyphicon glyphicon-open"></i> <span class="title" translate="global.menu.entities.tabUpdateManagement">Updates</span> <span class="arrow"></span></a><ul class="sub-menu collapse" id="management-submenu"><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="custom-update" ng-click="vm.toggleAside()"><i class="fa fa-cloud-upload" aria-hidden="true"></i> <span translate="global.menu.objectManagement.updates">Update</span></a></li><li class="nav-item" ui-sref-active="active"><a class="nav-link" ui-sref="tab-schedule" ng-click="vm.toggleAside()"><i class="fa fa-calendar"></i> <span translate="global.menu.entities.tabSchedule">History</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-device-releases" ng-click="vm.toggleAside()"><i class="fa fa-upload" aria-hidden="true"></i> <span translate="global.menu.entities.tabDeviceReleases">Bundles</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-files" ng-click="vm.toggleAside()"><i class="fa fa-file"></i> <span translate="global.menu.entities.tabFiles">Files</span></a></li><!--                <li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN">--><!--                    <a class="nav-link" ui-sref="scripts-releases" ng-click="vm.toggleAside()">--><!--                        <i class="fa fa-file"></i>--><!--                        <span translate="global.menu.entities.tabFiles">Script Releases</span>--><!--                    </a>--><!--                </li>--><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-update-scripts" ng-click="vm.toggleAside()"><i class="fa fa-list-alt" aria-hidden="true"></i> <span translate="global.menu.entities.tabUpdateScripts">Update Scripts</span></a></li><li class="nav-item" ui-sref-active="active" has-authority="ROLE_ADMIN"><a class="nav-link" ui-sref="tab-onEvent-scripts" ng-click="vm.toggleAside()"><i class="fa fa-file" aria-hidden="true"></i> <span translate="global.menu.entities.tabOnEventScripts">OnEvent Scripts</span></a></li></ul>');}]);})();